
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4tTm9", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $kbVzJ = parcelRequire("kbVzJ");


var $aUTn5 = parcelRequire("aUTn5");


var $cZa7r = parcelRequire("cZa7r");


var $24amZ = parcelRequire("24amZ");

var $l2hqi = parcelRequire("l2hqi");


var $3jwuS = parcelRequire("3jwuS");


var $afGoD = parcelRequire("afGoD");


var $bQm3c = parcelRequire("bQm3c");


var $8Mzkb = parcelRequire("8Mzkb");

const $1d207411f43b18d4$export$a9a76753cd947d5c = ({ pageId: pageId, onCreate: onCreate, onClose: onClose, dom: selectionElement, textSelection: textSelection, inlineNodeTypes: inlineNodeTypes, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar = false, closeObjectSidebar: closeObjectSidebar, isOffline: isOffline })=>{
    const { editorCreateProps: editorCreateProps } = (0, $cZa7r.useAnnotations)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const editorNode = (0, $42omo.useRef)(null);
    const indexFound = (0, $42omo.useRef)(0);
    const textMatches = (0, $42omo.useRef)(0);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    // Required to close the sidebar once we create a new standalone comment
    (0, $42omo.useEffect)(()=>{
        closeObjectSidebar && editorCreateProps && closeObjectSidebar();
    }, [
        closeObjectSidebar,
        editorCreateProps
    ]);
    (0, $42omo.useEffect)(()=>{
        (0, $8Ss4E.startEditorExperiences)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            attributes: {
                mode: isLivePage ? (0, $l2hqi.InlineCommentMode).LIVE : (0, $l2hqi.InlineCommentMode).EDIT,
                framework: (0, $24amZ.InlineCommentFramework).ANNOTATION_PROVIDER,
                edition: edition
            }
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        }, {
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE)
        });
        // both editor and inline comment sidebar share the same class, target the element that isn't the sidebar
        const editorNodes = Array.from(document.querySelectorAll('.ak-editor-content-area > .ProseMirror'));
        if (editorNodes.length) {
            const foundEditorNode = editorNodes.find((element)=>!element.closest('#editor-create-sidebar'));
            if (foundEditorNode) editorNode.current = foundEditorNode;
        }
        if (selectionElement && editorNode.current && textSelection) {
            const ignoredNodes = Array.from(editorNode.current.querySelectorAll((0, $aUTn5.IGNORE_SELECTORS)));
            const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(editorNode.current, ignoredNodes);
            const { index: index, numMatches: numMatches } = (0, $kbVzJ.findMatches)(text, textSelection, // we prefer the TextNode rather than <p> or headings
            selectionElement.parentNode ? selectionElement.parentNode : selectionElement, // default to 0 since the Editor wraps the selection in a <span> now
            0, nodesStartPos, nodes);
            indexFound.current = index;
            textMatches.current = numMatches;
        }
    }, [
        edition,
        selectionElement,
        textSelection,
        isLivePage,
        pageId,
        closeObjectSidebar,
        createAnalyticsEvent,
        editorCreateProps
    ]);
    const selectionOptions = (0, $42omo.useMemo)(()=>({
            originalSelection: textSelection,
            numMatches: textMatches.current,
            matchIndex: indexFound.current,
            inlineNodeTypes: inlineNodeTypes,
            createdFrom: isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : (0, $afGoD.CommentCreationLocation).EDITOR
        }), [
        textSelection,
        textMatches,
        indexFound,
        isLivePage,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Mzkb.CreateComment), {
        pageId: pageId,
        annotationElement: selectionElement,
        selectionOptions: selectionOptions,
        onClose: onClose,
        onCreate: onCreate,
        isEditor: true,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        isOffline: isOffline
    });
};
module.exports["CreateComponent"] = $1d207411f43b18d4$export$a9a76753cd947d5c;

});

parcelRegister("kbVzJ", function(module, exports) {
// eslint-disable-next-line import/no-cycle

var $2zMIV = parcelRequire("2zMIV");

const $567297790b62d2d4$var$TEXT_NODE_TYPE = 3;
function $567297790b62d2d4$export$2a4369abc54086f5(list, search, from) {
    const startPosInRange = Math.min(from, list.length - 1);
    let l = startPosInRange;
    let r = list.length;
    while(l < r){
        // This is a LEGACY disable statement after rule addition. Use `Math.floor((l+r)/2)` next time
        // eslint-disable-next-line no-bitwise
        const mid = l + r >> 1;
        if (list[mid] <= search) l = mid + 1;
        else r = mid;
    }
    return Math.max(l - 1, startPosInRange);
}
function $567297790b62d2d4$export$2605a3f2b4d7f885(root, ignoredNodes) {
    let textNode;
    let text = '';
    const nodesStartPos = [];
    const nodes = [];
    const nodeFilter = (textNode)=>{
        /**
     * If the text node is a descendent of one of the ignored node.
     * It means the text was rendered by maybe a macro.
     * Ignore these text nodes.
     */ return ignoredNodes.some((node)=>node === textNode || node.contains(textNode)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    };
    // createNodeIterator accepts an object with acceptNode field as node filter.
    // However IE 11 is expecting a function directly.
    nodeFilter.acceptNode = nodeFilter;
    const iter = document.createNodeIterator(root, NodeFilter.SHOW_TEXT, nodeFilter, false);
    while(textNode = iter.nextNode()){
        const normalizedText = (0, $2zMIV.textNormalize)(textNode.nodeValue);
        // WS-2885 - \u0020 represents the spacebar character so this regex handles any number of space only characters
        //           that may exist as their own nodes. We don't need to worry about only commenting on a space here
        //           because the popup has logic to only show itself if more than just a space is selected.
        if (/^\u0020+$/.test(normalizedText) || normalizedText.trim()) {
            // If it is not completely empty
            nodesStartPos.push(text.length);
            nodes.push(textNode);
            text += normalizedText;
        }
    }
    return {
        text: text,
        nodesStartPos: nodesStartPos,
        nodes: nodes
    };
}
function $567297790b62d2d4$var$getNodeTextLength(node) {
    return node && node.nodeValue ? node.nodeValue.length : 0;
}
function $567297790b62d2d4$export$f4585c00f32d9257(text, rawSelectedText, startContainer, startOffset, nodesStartPos, nodes, includeTraceForMatches) {
    const matchTraceList = [];
    if (!startContainer) return {
        numMatches: 0,
        index: -1,
        matchTraceList: null
    };
    let start = 0;
    let nodeStart = 0;
    let found = 0;
    let index = -1;
    let numMatches = 0;
    // loop through the provided text body string, starting from the beginning,
    // and update the index to search from until the rawSelectedtext can
    // no longer be found
    while((found = text.indexOf(rawSelectedText, start)) !== -1){
        // nodesStartPos is built by slowly concatenanting each non-empty text node value
        // together into a single string, and storing the index number at which the next string starts
        // with the matched index, find the nearest index value but return that index-1.
        // For example, if our match index is 10 and nodesStartPos = [0, 5, 11, 13],
        // we return index 1 (11 is the nearest but we want the index-1, 5).
        const pos = $567297790b62d2d4$export$2a4369abc54086f5(nodesStartPos, found, nodeStart);
        const textNode = nodes[pos];
        // In Firefox there is a case that startOffset is the end of a text node.
        // In this case it means the selection is actually starting from the next sibling node.
        let startNode = startContainer;
        if (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && startOffset >= $567297790b62d2d4$var$getNodeTextLength(startNode)) {
            startOffset -= $567297790b62d2d4$var$getNodeTextLength(startNode);
            startNode = startContainer.nextSibling;
        }
        if (startNode && (startNode.nodeType === $567297790b62d2d4$var$TEXT_NODE_TYPE && textNode === startNode || // Text node in IE 11 doesn't have contains method
        startNode.nodeType !== $567297790b62d2d4$var$TEXT_NODE_TYPE && startNode.contains(textNode))) {
            // The current text node might be the one we are selecting.
            // However a single text may have more than one match of the selected text.
            // We need to double check if the offset is correct.
            const offsetForCurrentFoundText = found - nodesStartPos[pos];
            if (offsetForCurrentFoundText <= startOffset) index = numMatches;
        }
        // Trace the text node back to the root if the flag is true
        if (includeTraceForMatches) {
            let element = textNode.parentElement;
            const parentElements = [];
            // We want to loop and record all the elements up to the div#content node
            while(element && element.getAttribute('id') !== 'content'){
                let classes = '';
                let attributes = '';
                const { tagName: tagName } = element;
                const classList = element.classList ? element.classList.value : '';
                const dataAttributes = element.getAttributeNames().filter((attribute)=>attribute.indexOf('data-') !== -1);
                // Handle classes
                if (classList.length) classes = `.${classList.split(' ').join('.')}`;
                // Handle data attributes
                if (dataAttributes.length) dataAttributes.forEach((attribute)=>{
                    // We don't want to get the value of the data-macro-body and data-title attributes
                    // because they can contain user information and we don't want to record it
                    if (attribute !== 'data-macro-body' && attribute !== 'data-title') {
                        // While it's "possible", we'll never actually get here if element is null
                        const value = element?.getAttribute(attribute);
                        attributes += `[${attribute}="${value}"]`;
                    } else attributes += `[${attribute}]`;
                });
                parentElements.unshift(`${tagName}${classes}${attributes}`);
                element = element.parentElement;
            }
            matchTraceList.push(parentElements.join(' > '));
        }
        numMatches++;
        start = found + 1;
        nodeStart = pos;
    }
    return {
        numMatches: numMatches,
        index: index,
        matchTraceList: matchTraceList.length ? matchTraceList : null
    };
}
module.exports["indexTextNodes"] = $567297790b62d2d4$export$2605a3f2b4d7f885;
module.exports["findMatches"] = $567297790b62d2d4$export$f4585c00f32d9257;

});

parcelRegister("2zMIV", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $aUTn5 = parcelRequire("aUTn5");

const $15cdccae323ae129$var$logger = (0, $7W8i8.getLogger)('highlight-action');
const $15cdccae323ae129$export$4042f14350dc38e1 = (container, contentId)=>{
    const selection = window.getSelection();
    // getSelection() only returns null for iframes in firefox; in all other cases the type field is set to "None"
    if (!selection || selection?.type === 'None') return false;
    let legacyHighlight;
    try {
        legacyHighlight = (0, $aUTn5.convertSelectionToLegacyFormat)(container, selection.getRangeAt(0), contentId);
    } catch (err) {
        $15cdccae323ae129$var$logger.error`An error occurred while highlighting content - ${err}`;
    }
    if (!legacyHighlight || !legacyHighlight.searchText) return false;
    const { searchText: { selectedText: selectedText, index: index, numMatches: numMatches } } = legacyHighlight;
    /*
   * A valid highlight contains:
   *
   *   A selection that has a length (non-empty)
   *   A matched index (-1 means not found)
   *   A positive non-zero number of matches
   *   A match index that is less than the number of matches
   *
   */ return selectedText.replace(/\n/g, '').length > 0 && index !== -1 && numMatches > 0 && index < numMatches;
};
const $15cdccae323ae129$export$6c73cedfcc8a18f2 = ()=>{
    const selection = window.getSelection();
    if (!selection || selection?.type === 'None') return false;
    const range = $15cdccae323ae129$export$fef151b94550e9f5();
    if (!range) return false;
    const parentElement = $15cdccae323ae129$export$ab738b211369230e(range);
    return parentElement instanceof HTMLElement && Boolean(parentElement.closest('table'));
};
const $15cdccae323ae129$export$42b4db950c80743f = (s)=>{
    /*
    CONF-36789: on IE, selectionRange.toString() always convert all &nbsp; to normal space
    on other browsers, it does not. So we must convert manually to made consistency across all browsers
    */ return s.replace(/\u00a0/g, '\u0020');
};
const $15cdccae323ae129$export$fef151b94550e9f5 = ()=>{
    const selection = window.getSelection();
    // no selection made webkit
    if (!selection || selection.isCollapsed) return null;
    const selectionRange = selection.getRangeAt(0);
    // Don't show popup if selection is white space
    if (!String(selectionRange).trim()) return null;
    return selectionRange;
};
const $15cdccae323ae129$export$cfa2225e87938781 = (node)=>{
    const TEXT_NODE_TYPE = 3;
    if (!node) return null;
    if (node.nodeType !== TEXT_NODE_TYPE && node.scrollWidth > node.clientWidth) return node;
    else return $15cdccae323ae129$export$cfa2225e87938781(node.parentNode);
};
const $15cdccae323ae129$export$6fc0706fcfa876ec = (node)=>{
    const ELEMENT_NODE_TYPE = 1;
    if (!node) return null;
    if (node.nodeType === ELEMENT_NODE_TYPE) {
        if (node.classList.contains('pm-table-sticky-wrapper')) return node;
    }
    if (node.parentElement) return $15cdccae323ae129$export$6fc0706fcfa876ec(node.parentElement);
    return null;
};
const $15cdccae323ae129$export$ab738b211369230e = (selectionRange)=>{
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
    return null;
};
module.exports["isHighlightValidForInlineComment"] = $15cdccae323ae129$export$4042f14350dc38e1;
module.exports["isHighlightValidForBulkCreateJiraIssues"] = $15cdccae323ae129$export$6c73cedfcc8a18f2;
module.exports["getRange"] = $15cdccae323ae129$export$fef151b94550e9f5;
module.exports["textNormalize"] = $15cdccae323ae129$export$42b4db950c80743f;
module.exports["findStickyHeader"] = $15cdccae323ae129$export$6fc0706fcfa876ec;

});

parcelRegister("aUTn5", function(module, exports) {
/* eslint-disable no-restricted-globals */ 
var $9wGTI = parcelRequire("9wGTI");


var $2zMIV = parcelRequire("2zMIV");


var $kbVzJ = parcelRequire("kbVzJ");

const $92069b7b1bcb2285$export$c5bc138cfa79c2b2 = [
    // Legacy mention
    '.user-mention',
    // Fabric mention
    '[data-mention-id]',
    // Connect macro
    '.ap-container',
    // Links
    'a[href^="/"]',
    // Macros that doesn't have body
    '.conf-macro[data-hasbody="false"]',
    // Normal status
    '.status-lozenge-span',
    // Date will get rendered as "Today" in fabric
    '.date-lozenger-container',
    // Inline Smart Card/Jira issue link
    '[data-inline-card="true"]',
    '.inlineCardView-content-wrap',
    '.smart-link-title-wrapper',
    // Actual jira issue macro
    '.jira-issue',
    // Title for expand
    '.ak-renderer-extension-overflow-container button',
    '[data-node-type="expand"] > button',
    '[data-node-type="nestedExpand"] > button',
    // JIRA Macro
    '.jira-issues',
    // datasource table for new JIM macro
    '.datasource-table',
    // Inline file attachments
    "[data-type='file']",
    // Fabric code snippets
    '.code-block',
    // Legacy code snippets
    '.conf-macro[data-macro-name="code"]',
    // Sticky table headers (WS-2345 - Sticky header comment flow is strange for now, restrict until we can find a better solution)
    '.pm-table-sticky-wrapper',
    // Block cards
    '.blockCardView-content-wrap',
    // Excerpt Includes (WS-2563)
    '.ak-excerpt-include',
    // View All Container
    '#view-all-inline-comments-container',
    // Strikethrough
    's',
    // Emoji
    '[data-emoji-id]',
    // Charts
    "[data-mark-type='dataConsumer']",
    // Reattach Dialog
    '#reattach-container',
    // BEGIN EDITOR EXCLUSIONS
    //
    // Gadget?
    "[extensionkey='gadget']",
    // placeholder content
    'span[data-placeholder]',
    // covers most macros, would this be too encompassing?
    "[contenteditable='false']",
    // page include macro
    "[data-node-type='include']",
    // page properties report adf macro
    '.page-properties-report'
].join(',');
function $92069b7b1bcb2285$var$getSelectionHTML(selectionRange) {
    if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
        const div = document.createElement('div');
        div.appendChild(selectionRange.cloneContents());
        return div.innerHTML;
    } else return $('<div>').append(selectionRange.cloneContents()).html();
}
function $92069b7b1bcb2285$var$getContainingElement(selectionRange) {
    if (selectionRange.commonAncestorContainer) {
        const selectRangeElement = selectionRange.commonAncestorContainer;
        if (selectRangeElement.nodeType === 3) //Is TextNode
        return selectRangeElement.parentNode;
        return selectRangeElement;
    }
}
function $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects) {
    // In Chrome triple clicking text will cause all the text in an element to be selected. When calling
    // getClientRects after a triple click, the array will contain rects for each line of highlighted text
    // in the highlighted element and also a clientRects for the adjacent sibling element even though no text
    // is highlighted inside it. If the endOffset is zero, we ignore this final clientRect because no text
    // is highlighted inside of it.
    //
    // Also, in Chrome, Safari and Firefox, get client rects return a clientRects representing each inline element
    // including rectangles for all nested elements. IE8 return many less rects, maybe just one for the ancestor
    // element containing the highlight or a clientRects for each line of highlight without individual rects for each
    // inline element
    const rects = {
        first: clientRects[0],
        last: clientRects[clientRects.length - 1]
    };
    if (selectionRange.endOffset !== 'undefined') //In IE, if we highlight on resolved inline comment, we will length of clientRects is 1
    {
        if (selectionRange.endOffset === 0 && clientRects.length > 1) rects.last = clientRects[clientRects.length - 2];
    }
    return rects;
}
function $92069b7b1bcb2285$var$getSelectionRects(selectionRange) {
    // if using documentation theme, get scrolltop of documentation theme content which is fixed size
    // certain browsers give the scrollTop on html element, some give it on the body element. this works in both.
    const scrollTop = window.scrollY;
    const scrollLeft = window.scrollX;
    let clientRects = selectionRange.getClientRects();
    // IE fails to provide client rects when highlighting a paragraph containing only an image or triple clicking to
    // highlight any paragraph containing content other than plain text. In this case, it is safe to assume parent
    // element dimensions will represent the highlighted area
    if (!clientRects.length && selectionRange.parentElement && selectionRange.parentElement()) {
        if ((0, $9wGTI.fg)('confluence-remove-jquery-from-selection-conversion')) {
            const parentElement = selectionRange.parentElement();
            const rect = parentElement.getBoundingClientRect();
            clientRects = [
                {
                    top: rect.top,
                    left: rect.left,
                    bottom: rect.top + scrollTop + rect.height,
                    right: rect.left + scrollLeft + rect.width
                }
            ];
        } else {
            const $parentElement = $(selectionRange.parentElement());
            const parentOffset = $parentElement.offset();
            if (parentOffset) clientRects = [
                {
                    top: parentOffset.top - scrollTop,
                    left: parentOffset.left - scrollLeft,
                    bottom: parentOffset.top + ($parentElement.height() || 0),
                    right: parentOffset.left + ($parentElement.width() || 0)
                }
            ];
        }
    }
    const rects = $92069b7b1bcb2285$var$getFirstAndLastSelectionRect(selectionRange, clientRects);
    /*
   * Calculates Create Issue dialog target area
   */ const getOverlap = function(firstRect, lastRect) {
        const overlap = {};
        overlap.top = firstRect.top;
        overlap.left = (firstRect.left || 0) + scrollLeft;
        overlap.bottom = lastRect.bottom;
        if (firstRect.left !== undefined && firstRect.right !== undefined && lastRect.left !== undefined && lastRect.right !== undefined) {
            if (firstRect.left >= lastRect.right) overlap.right = firstRect.right;
            else overlap.right = lastRect.right;
        }
        overlap.right = (overlap.right || 0) + scrollLeft;
        // adjust top for doc theme
        overlap.top = (overlap.top || 0) + scrollTop;
        overlap.bottom = (overlap.bottom || 0) + scrollTop;
        // set width and height
        overlap.width = overlap.right - overlap.left;
        overlap.height = overlap.bottom - overlap.top;
        return overlap;
    };
    /*
   * Calculates the action panel target area
   */ const getHighlightStart = function(rect) {
        const highlight = {};
        if (!rect) return highlight;
        highlight.width = rect.right - rect.left;
        highlight.height = rect.bottom - rect.top;
        highlight.left = rect.left + scrollLeft;
        highlight.right = rect.right + scrollLeft;
        highlight.top = rect.top + scrollTop;
        highlight.bottom = rect.bottom + scrollTop;
        return highlight;
    };
    return {
        first: getHighlightStart(rects.first),
        average: getOverlap(rects.first, rects.last)
    };
}
function $92069b7b1bcb2285$var$getSelectionText(selectionRange) {
    return (0, $2zMIV.textNormalize)(String(selectionRange));
}
/**
 * Generates javascript object containing the context of the selected text to help locate in storage format
 *
 * @param root container of content which can be selected
 * @param selectedText text that currently highlighted
 * @param selected range object representing the current selection
 * @param pageId the page id we're currently on
 * @param includeTraceForMatches a boolean stating whether or not to include a tree trace for each match
 * @return object containing metadata about the location of the selected text
 */ function $92069b7b1bcb2285$var$computeSearchTextObject(root, selectedText, selected, pageId, includeTraceForMatches) {
    // WS-2345 - Sticky header create comment flow is strange for now, disabling it until a better solution is found
    // https://product-fabric.atlassian.net/browse/CEMS-1100
    //
    // sticky headers create duplicate tables to work, which causes duplicate
    // text content to end up in the inline comment text string. ignore sticky
    // table content when not visible, and vice versa.
    // const inSticky = findStickyHeader(selected.startContainer);
    // const ignoreTable: HTMLElement[] = Array.from(
    //   inSticky
    //     ? root.querySelectorAll(
    //         ".pm-table-container .pm-table-wrapper tr:first-of-type"
    //       )
    //     : root.querySelectorAll(".pm-table-sticky-wrapper")
    // );
    const ignoreTable = Array.from(root.querySelectorAll('.pm-table-sticky-wrapper'));
    const ignoredNodes = Array.from(root.querySelectorAll($92069b7b1bcb2285$export$c5bc138cfa79c2b2));
    const { text: text, nodesStartPos: nodesStartPos, nodes: nodes } = (0, $kbVzJ.indexTextNodes)(root, [
        ...ignoredNodes,
        ...ignoreTable
    ]);
    const { index: index, numMatches: numMatches, matchTraceList: matchTraceList } = (0, $kbVzJ.findMatches)(text, selectedText, selected.startContainer, selected.startOffset, nodesStartPos, nodes, includeTraceForMatches);
    const searchTextObj = {
        pageId: pageId,
        selectedText: selectedText,
        index: index,
        numMatches: numMatches
    };
    if (matchTraceList) searchTextObj.matchTraceList = matchTraceList;
    return searchTextObj;
}
function $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, lastModified, getTraceForMatches) {
    const rawText = $92069b7b1bcb2285$var$getSelectionText(selectionRange);
    const text = rawText.trim();
    let searchText;
    // It finds all the occurrences of selected text.
    // Since if I select word "is" there maybe a lot occurrences on the page.
    // searchText.index tells the backend which one is really the one I selected.
    // That is among, for example 20 matches, the 5th match is my selection.
    if (text) searchText = $92069b7b1bcb2285$var$computeSearchTextObject(contentContainer, // It is important to pass raw text here
    rawText, selectionRange, pageId, getTraceForMatches);
    return getTraceForMatches ? searchText.matchTraceList : {
        text: text,
        searchText: searchText,
        area: $92069b7b1bcb2285$var$getSelectionRects(selectionRange),
        html: $92069b7b1bcb2285$var$getSelectionHTML(selectionRange),
        containingElement: $92069b7b1bcb2285$var$getContainingElement(selectionRange),
        range: selectionRange,
        lastModified: lastModified
    };
}
function $92069b7b1bcb2285$export$b297c7070f7a854(contentContainer, selectionRange, pageId) {
    const matchTraceList = $92069b7b1bcb2285$export$4ba66d628a1e5980(contentContainer, selectionRange, pageId, null, true);
    return matchTraceList || [];
}
module.exports["IGNORE_SELECTORS"] = $92069b7b1bcb2285$export$c5bc138cfa79c2b2;
module.exports["convertSelectionToLegacyFormat"] = $92069b7b1bcb2285$export$4ba66d628a1e5980;
module.exports["getMatchTraces"] = $92069b7b1bcb2285$export$b297c7070f7a854;

});

parcelRegister("24amZ", function(module, exports) {
var $0096831e5a63492d$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $0096831e5a63492d$export$b21a3980a7aad169;

});

parcelRegister("l2hqi", function(module, exports) {
var $d6376875f96c1896$export$2df6d049e5bad28e = /*#__PURE__*/ function(InlineCommentMode) {
    InlineCommentMode["EDIT"] = "edit";
    InlineCommentMode["VIEW"] = "view";
    InlineCommentMode["LIVE"] = "live";
    return InlineCommentMode;
}({});
module.exports["InlineCommentMode"] = $d6376875f96c1896$export$2df6d049e5bad28e;

});

parcelRegister("8Mzkb", function(module, exports) {
/* CreateComment.tsx generated by @compiled/babel-plugin v0.36.1 */ /** @graphql cc */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $1KmJq = parcelRequire("1KmJq");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");


var $inPa6 = parcelRequire("inPa6");


var $7EEGh = parcelRequire("7EEGh");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $3YBks = parcelRequire("3YBks");


var $8Ss4E = parcelRequire("8Ss4E");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $aGjYc = parcelRequire("aGjYc");


var $hXzKU = parcelRequire("hXzKU");


var $bQm3c = parcelRequire("bQm3c");


var $7Sm4c = parcelRequire("7Sm4c");


var $bSvtO = parcelRequire("bSvtO");


var $aSsfA = parcelRequire("aSsfA");


var $cD1qu = parcelRequire("cD1qu");


var $cAdj8 = parcelRequire("cAdj8");


var $kmHPt = parcelRequire("kmHPt");


var $daq5m = parcelRequire("daq5m");


var $dLr6w = parcelRequire("dLr6w");


var $isdzP = parcelRequire("isdzP");


var $6cWI7 = parcelRequire("6cWI7");


var $a8ZQ3 = parcelRequire("a8ZQ3");


var $9CnRS = parcelRequire("9CnRS");


var $aMfLn = parcelRequire("aMfLn");


var $9QIM2 = parcelRequire("9QIM2");


var $3Xfi8 = parcelRequire("3Xfi8");


var $eA7s6 = parcelRequire("eA7s6");


var $k8e76 = parcelRequire("k8e76");


var $56QzY = parcelRequire("56QzY");


var $8i27m = parcelRequire("8i27m");


var $9wGTI = parcelRequire("9wGTI");


var $hl0fg = parcelRequire("hl0fg");


var $7aRa9 = parcelRequire("7aRa9");


var $5pQ1Y = parcelRequire("5pQ1Y");


var $en1dX = parcelRequire("en1dX");


var $9FoVw = parcelRequire("9FoVw");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $6mKj3 = parcelRequire("6mKj3");


var $b0EGa = parcelRequire("b0EGa");


var $a3q17 = parcelRequire("a3q17");


var $B3Avz = parcelRequire("B3Avz");

const $f4c77c6e390a7914$export$d26c1daa0321174b = (0, $aJPUt.ExperienceTimeout).CREATE_COMMENT_PUBLISH;
const $f4c77c6e390a7914$var$relativeFilePath = 'annotation-provider-inline-comments/CreateComment';
const $f4c77c6e390a7914$var$i18n = (0, $cgtv4.defineMessages)({
    unableToApplyTitle: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.title",
        defaultMessage: "Something went wrong"
    },
    unableToApplyDescription: {
        id: "annotation-provider-inline-comments.create.error.unable.to.apply.description",
        defaultMessage: "We failed to display your comment. To view it, refresh now."
    },
    refreshContentLink: {
        id: "annotation-provider-inline-comments.refresh.content.link",
        defaultMessage: "Refresh content"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f4c77c6e390a7914$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt49l6b",
            __cmplp.className
        ])
    });
});
const $f4c77c6e390a7914$var$styles = {
    commentEditorContainer: "_ca0qutpp"
};
const $f4c77c6e390a7914$var$getNodeType = (element, annotationId)=>{
    const nodeWithAnnotationWrapper = element.querySelector(`[id="${annotationId}"]`);
    if (nodeWithAnnotationWrapper) {
        const firsChildren = nodeWithAnnotationWrapper.firstChild;
        if (firsChildren?.nodeType === Node.TEXT_NODE) return 'text';
        const targetNode = nodeWithAnnotationWrapper.querySelector('[data-node-type]');
        if (targetNode) return targetNode.dataset.nodeType;
    }
    return 'unknown';
}; // Exporting for testing cases
const $f4c77c6e390a7914$export$d4044f5b8f4bc73a = (setWasDraftAnnotationRemoved)=>(mutationList, observer)=>{
        for (const mutation of mutationList){
            if (mutation.type === 'childList') {
                if (mutation.removedNodes.length > 0) mutation.removedNodes.forEach((node)=>{
                    const nodeClassList = Array.from(node.classList ?? []); // COMMENTS-4308 - If any part of the draft annotation was removed, check if the entirity of the draft
                    // 				   was removed, if so, we need to disable the editor buttons as the comment will fail
                    if (nodeClassList.includes('ak-editor-annotation-draft')) {
                        if (document.querySelector('.ak-editor-annotation-draft') === null) {
                            // Tell the editor that the draft annotation was removed
                            setWasDraftAnnotationRemoved(true);
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog - draft annotation removed`); // Disconnect the observer since we no longer need it
                            observer.disconnect();
                        }
                    }
                });
            }
        }
    };
const $f4c77c6e390a7914$var$CommentEditorContainer = ({ children: children })=>(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $f4c77c6e390a7914$var$styles.commentEditorContainer
    }, children) : children;
const $f4c77c6e390a7914$var$CreateCommentComponent = ({ pageId: pageId, annotationElement: annotationElement, selectionOptions: selectionOptions, onClose: onClose, onCreate: onCreate, isEditor: isEditor, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, flags: flags, isOffline: isOffline })=>{
    const started = (0, $42omo.useRef)(false);
    const pageClass = (0, $9QIM2.usePageClass)();
    const { edition: edition, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    if (started.current === false) {
        // Just in case `edition` is not set on `createInlineCommentCompoundExperience.start()`,
        // which can occur if the experience was started from within the editor platform code.
        (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            edition: edition ?? ''
        });
        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.start();
        started.current = true;
    }
    const initialisedSelection = (0, $42omo.useRef)(false);
    if (selectionOptions && selectionOptions?.createdFrom === 'EDITOR' && initialisedSelection.current === false) {
        initialisedSelection.current = true;
        if (selectionOptions.inlineNodeTypes) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            inlineNodeTypes: selectionOptions.inlineNodeTypes
        });
    }
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const lastContentFetchTime = (0, $42omo.useRef)(1);
    const requestTimeoutHandle = (0, $42omo.useRef)();
    const sidebarEl = (0, $42omo.useRef)(null);
    const draftAnnotationMutationObserverRef = (0, $42omo.useRef)();
    const commentContainerElementRef = (0, $42omo.useRef)(null);
    const { documentUpdated: documentUpdated, publishedDocumentVersion: publishedDocumentVersion, currentDocumentVersion: currentDocumentVersion } = (0, $a8ZQ3.useDocumentUpdateStatus)();
    const { setRefetchContent: setRefetchContent } = (0, $5pQ1Y.useContentRefetchDispatch)();
    const createdAnnotationId = (0, $42omo.useRef)(null);
    const createdCommentId = (0, $42omo.useRef)(null);
    const [shouldRefetch, setShouldRefetch] = (0, $42omo.useState)(false);
    const [wasDraftAnnotationRemoved, setWasDraftAnnotationRemoved] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { onChange: onChange, resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { addUnresolvedInlineComment: addUnresolvedInlineComment } = (0, $k8e76.useInlineCommentsActions)(); // Check if avatar data is ready - this hook runs independently and checks cache/loading state
    const isAuthorReady = (0, $dLr6w.useCurrentUserAvatarReady)();
    const { addNewCommentThreads: addNewCommentThreads } = (0, $8i27m.useCommentsDataActions)();
    const { width: windowWidth } = (0, $hl0fg.useWindowSize)();
    const { isCommentsPanelShown: isCommentsPanelShown, showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const { isSticky: isSticky } = (0, $3Xfi8.useShouldCommentSidebarBeSticky)({
        annotationElement: annotationElement,
        isEditor: !!isEditor
    });
    const sidebarOffset = (0, $eA7s6.useCommentSidebarOffset)({
        isEditor: Boolean(isEditor),
        annotationElement: annotationElement,
        windowWidth: windowWidth,
        isSticky: isSticky
    }); // Hide OmniBar while this component is mounted (viewing inline comment)
    const { requestHideOmniBar: requestHideOmniBar, releaseHideOmniBar: releaseHideOmniBar } = (0, $b0EGa.useOmniBarVisibilityActions)();
    (0, $42omo.useLayoutEffect)(()=>{
        if ((0, $9wGTI.fg)('cc-engagement-omnibar-hide-inline-comments')) {
            requestHideOmniBar();
            return ()=>releaseHideOmniBar();
        }
    }, [
        requestHideOmniBar,
        releaseHideOmniBar
    ]); // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const [createCommentFn] = (0, $1KmJq.useMutation)((0, $eSUdr.default)`mutation CreateCommentInlineCommentMutation($input:CreateInlineCommentInput!$pageId:ID!$includeReactionsAndReplies:Boolean!){createInlineComment(input:$input){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{isDangling resolvedTime resolvedFriendlyDate resolvedUser resolved}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}reactionsSummary(pageId:$pageId contentType:"page" childType:"comment")@include(if:$includeReactionsAndReplies){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}replies@include(if:$includeReactionsAndReplies){id body(representation:ATLAS_DOC_FORMAT){value}contentStatus createdAt{value}createdAtNonLocalized links{webui editui}location{type ...on InlineComment{inlineMarkerRef inlineText inlineResolveProperties{resolved isDangling resolvedFriendlyDate resolvedTime resolvedUser}}...on FooterComment{commentResolveProperties{resolved resolvedFriendlyDate resolvedTime resolvedUser}}}parentId permissions{isEditable isRemovable isResolvable}version{by{displayName}when number}author{displayName profilePicture{path}permissionType ...on KnownUser{accountId}}createdAt{value}createdAtNonLocalized reactionsSummary(pageId:$pageId contentType:"page" childType:"comment"){ari containerAri reactionsCount reactionsSummaryForEmoji{id emojiId count reacted}}}}}`);
    const { createInlineCommentInterop: createInlineCommentInterop } = (0, $6cWI7.useCreateInlineCommentMutation)({
        contentId: pageId
    });
    const { pageInfo: pageInfo, loading: loading, error: error, refetch: refetch } = (0, $cAdj8.usePageInfo)({
        fetchPolicy: 'cache-first',
        onError: (err)=>{
            experienceTracker.stopOnError({
                name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                error: err
            });
        }
    });
    (0, $42omo.useEffect)(()=>{
        // should only refresh on the Content Out of date `Refresh` CTA is clicked
        if (documentUpdated && shouldRefetch && refetch) {
            refetch();
            setShouldRefetch(false);
            onClose && onClose();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        documentUpdated,
        shouldRefetch
    ]);
    (0, $42omo.useEffect)(()=>{
        const metadata = document.querySelector('meta[name=confluence-request-time]');
        if (metadata) {
            const fetchTime = Number(metadata.getAttribute('content'));
            lastContentFetchTime.current = isNaN(fetchTime) ? 1 : fetchTime;
        }
        if (pageMode !== (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
            const editorTextArea = document.getElementById('ak-editor-textarea');
            draftAnnotationMutationObserverRef.current = new MutationObserver($f4c77c6e390a7914$export$d4044f5b8f4bc73a(setWasDraftAnnotationRemoved)); // We need to watch the whole editorTextArea because highlights could
            if (editorTextArea) draftAnnotationMutationObserverRef.current.observe(editorTextArea, {
                childList: true,
                subtree: true
            });
        }
        return ()=>{
            if (pageMode !== (0, $cD1qu.PageMode).VIEW && draftAnnotationMutationObserverRef.current && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) draftAnnotationMutationObserverRef.current.disconnect();
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Check for highlight element on mount - fail experience if createComment renders without a highlight
    // This tracks the scenario where createComment re-renders on close of the comment box without a highlight
    (0, $42omo.useEffect)(()=>{
        if (!(0, $6mKj3.expValEquals)('confluence_comment_enable_exp_create_rerenderer', 'isEnabled', true)) return;
         // Use a small delay to allow the DOM to settle after any state changes
        const timeoutId = setTimeout(()=>{
            const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191(); // Fail experience if createComment renders without a highlight
            if (!draftAnnotationElement && !wasDraftAnnotationRemoved) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('CreateComment renders without highlight'));
        }, 100);
        return ()=>clearTimeout(timeoutId); // Only run on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const saveAttemptedTracker = (0, $42omo.useRef)({
        lastMutationSucceeded: false,
        totalSaves: 0,
        failedSaves: 0
    });
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            const savesWithoutError = // hit, the experience will already have completed in the `handleSaveComment`.
            saveAttemptedTracker.current.totalSaves - saveAttemptedTracker.current.failedSaves;
            if (saveAttemptedTracker.current.failedSaves > 0) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                // eslint-disable-next-line react-hooks/exhaustive-deps
                failedSaves: saveAttemptedTracker.current.failedSaves
            });
            if (savesWithoutError > 1) {
                // At the point this is dismounting -- we don't know for certain if the user intended for this to be discarded or not
                // so we hard fail the full experience (it's possible the dismount is because the second save has worked and
                // the UI is about to load the new comment)
                (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                    savesWithoutError: savesWithoutError
                });
                const msg = 'User clicked save, but UI did not update following successful save'; // we log a debug point and continue with the flow, since creation is not necessarily failing
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debugPoint(msg);
            }
            if (saveAttemptedTracker.current.lastPublishFailure) {
                if (saveAttemptedTracker.current.lastMutationSucceeded) {
                    // in the case there was a publish failure, but the last mutation succeeded -- we assume the dismount is
                    // because the ui is about to load the new comment - in this case we only mark the experience as a soft
                    // failure (we'll capture more details and fail in the final experience step)
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.softFail(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                } else {
                    // In this scenario -- the user attempted to save at least once, got a network error, and gave up on
                    // trying to create the comment
                    // For a subset of errors -- the user is presented with a human readable error message describing that
                    // the comment creation failure is due to the content changing (e.g. the user has edited the page) and
                    // that they need to refresh the page to apply the comment.  In this scenario we don't treat the comment
                    // creation as a failure, but rather we want to mark the experience as aborted.
                    const contentChangedErrorSubstrings = [
                        'Invalid arguments provided for matchIndex and/or numMatches',
                        'Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex',
                        'Selection was made against a stale version of the content',
                        'Published Version out of date. Please provide correct published version.'
                    ];
                    const isContentChangedError = contentChangedErrorSubstrings.some((substring)=>// eslint-disable-next-line react-hooks/exhaustive-deps
                        saveAttemptedTracker.current.lastPublishFailure?.message.includes(substring));
                    if (isContentChangedError) {
                        (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                            abortReason: 'Unable to apply annotation to document'
                        });
                        return;
                    } // This is handled in the UI appropriately, and we should abort not fail
                    const permissionErrorSubstring = 'Could not create content with type comment';
                    const isPermissionError = saveAttemptedTracker.current.lastPublishFailure?.message.includes(permissionErrorSubstring);
                    if (isPermissionError) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                        abortReason: 'User does not have space permission to create comments'
                    });
                    (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.stopOnError(// eslint-disable-next-line react-hooks/exhaustive-deps -- This is intentionally using a ref value due to the indirect flow of comment updates
                    saveAttemptedTracker.current.lastPublishFailure);
                    return;
                }
            }
            if (saveAttemptedTracker.current.lastMutationSucceeded) {
                (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.complete();
                return;
            } // In this case the user did not attempt to save the comment, and so we assume this was
            // an intentional discard of the comment.
            // So we abort the draftToPublishExperience here, along with any unfinished initExperience.
            const abortReason = 'Create Comment UI dismissed';
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                abortReason: abortReason
            });
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                abortReason: abortReason
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
        };
    }, []);
    const saveAttemptedCounts = (0, $42omo.useRef)({
        total: 0,
        failedSaves: 0
    });
    const failPublishExperience = (0, $42omo.useCallback)((commentPublishError, translatedErrorMsg)=>{
        // COMMENTS-1879 - Only log unexpected errors or annotation application error as failures
        if ((0, $isdzP.isUnexpectedError)(translatedErrorMsg)) experienceTracker.stopOnError({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            error: commentPublishError
        });
        else (0, $7Sm4c.markErrorAsHandled)(commentPublishError);
    }, [
        experienceTracker
    ]);
    const onCacheUpdateError = (0, $42omo.useCallback)((cacheError)=>{
        const { message: message } = (0, $isdzP.parseError)(cacheError);
        failPublishExperience(cacheError, (0, $isdzP.getTranslatedError)(message));
    }, [
        failPublishExperience
    ]);
    const handleSaveCommentWithTimeout = (timeoutInMs, saveMutation)=>{
        const timeout = new Promise((_resolve, reject)=>{
            requestTimeoutHandle.current = setTimeout(()=>{
                experienceTracker.stopOnError({
                    name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
                    error: new Error(`Request took longer than ${timeoutInMs}ms`)
                });
                return reject({
                    error: (0, $9CnRS.i18n).createTimeout
                });
            }, timeoutInMs);
        });
        return Promise.race([
            timeout,
            saveMutation
        ]).finally(()=>{
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
        });
    };
    const handleSaveComment = (adf, onSuccess)=>{
        saveAttemptedTracker.current.totalSaves = saveAttemptedTracker.current.totalSaves + 1;
        saveAttemptedTracker.current.lastMutationSucceeded = false;
        saveAttemptedCounts.current.total = saveAttemptedCounts.current.total + 1;
        createdAnnotationId.current = null;
        createdCommentId.current = null;
        if (!selectionOptions) // We likely will never get here, but just in case
        return Promise.reject({
            error: (0, $9CnRS.i18n).unableToGenerateStep
        });
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
            attributes: {
                pageId: pageId,
                pageMode: pageMode,
                isEditor: isEditor
            }
        });
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).start();
        (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationStart');
        (0, $8Ss4E.startEditorSubExperience)({
            name: (0, $irVI7.ADD_INLINE_COMMENT_PUBLISH_EXPERIENCE),
            attributes: {
                timeout: $f4c77c6e390a7914$export$d26c1daa0321174b
            }
        });
        if (pageMode === (0, $cD1qu.PageMode).VIEW && (0, $9wGTI.fg)('confluence_frontend_view_inline_comment_debug_v2')) (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
            currentDocumentVersion: currentDocumentVersion,
            publishedDocumentVersion: publishedDocumentVersion,
            isPageOutdated: currentDocumentVersion !== publishedDocumentVersion
        });
        const { numMatches: numMatches, matchIndex: matchIndex, originalSelection: originalSelection, createdFrom: createdFrom, step: step, targetNodeType: targetNodeType } = selectionOptions; // eslint-disable-next-line confluence-feature-gating/inline-usage
        const variables = {
            input: {
                containerId: pageId,
                commentBody: {
                    value: JSON.stringify(adf),
                    representationFormat: 'ATLAS_DOC_FORMAT'
                },
                numMatches: numMatches,
                matchIndex: matchIndex,
                originalSelection: originalSelection,
                createdFrom: createdFrom,
                lastFetchTimeMillis: lastContentFetchTime.current,
                // In VIEW mode, we send the currentDocumentVersion so that the backend can
                // correctly identify where the inline annotation should be applied on the Page.
                // p.s. currentDocumentVersion is not set in EDIT/LIVE mode.
                publishedVersion: pageMode === (0, $cD1qu.PageMode).VIEW && currentDocumentVersion && (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? currentDocumentVersion : publishedDocumentVersion,
                ...!!step && {
                    step: (0, $aMfLn.constructStepForGql)(step)
                }
            },
            pageId: pageId,
            includeReactionsAndReplies: false
        }; // Note -- this mixes data saving logic and UI application logic.
        // And when the UI logic fails, the result is that the user is left with
        // the ui looking like the comment failed to save.
        // This should be refactored to separate the two concerns, and on a UI application
        // failure, we should encourage users to refresh (and mark the experience as failed).
        let succeededPublish = false;
        const onCreateSuccess = (retVal)=>{
            saveAttemptedTracker.current.lastMutationSucceeded = true;
            const { data: data } = retVal;
            if (requestTimeoutHandle.current) clearTimeout(requestTimeoutHandle.current);
            succeededPublish = true;
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.publishSucceeded(); // Mark comment creation end for both cohorts
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentCreationEnd');
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).mark('commentDataLoadStart');
            const annotationId = data?.createInlineComment?.location?.inlineMarkerRef;
            const commentId = data?.createInlineComment?.id;
            if (!annotationId || !commentId) throw new Error(`Comment was not saved correctly - either annotationId '${annotationId}' or commentId '${commentId}' were undefined`);
            createdAnnotationId.current = annotationId;
            createdCommentId.current = commentId; // Reset the content changing flag
            resetContentChanged(); // Grab the marker ref id returned and update the editor/renderer
            try {
                onCreate(annotationId, data?.createInlineComment);
            } catch (e) {
                // We generate errors in renderer, but this will also handle the editor case
                throw new Error(`Unable to apply annotation to document - ${e.message}`);
            } // Update the unresolved inline comments count
            addUnresolvedInlineComment(annotationId, pageMode); // For experiment cohort, we pass the mutation data to onCreate
            // The experiment success and data load completion will be handled in AnnotationsContext
            // after the view component renders the new data
            const newComment = {
                // (Need to coerce the data from the new Comments Data Manager's mutation because it is
                // defined using the new Relay-generated types that define option fields as "| null | undefined"
                // but the original Apollo-generated types define them as just "| null".  These aren't compatible
                // without the coercion even though the "if (value)" or "value?." expressions would work the same.)
                ...data?.createInlineComment,
                isOpen: true,
                type: (0, $8i27m.CommentType).INLINE,
                wasRemovedByAnotherUser: false,
                replies: [],
                reactionsSummary: null
            };
            if (!(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) addNewCommentThreads({
                general: {},
                inline: {
                    [annotationId]: newComment
                }
            });
             // Create inline comment track event
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'comment',
                    actionSubjectId: commentId,
                    objectType: 'page',
                    objectId: pageId,
                    source: isEditor ? 'editPageScreen' : 'viewPageScreen',
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        source: (0, $en1dX.AnalyticsSource).STANDALONE,
                        commentType: (0, $8i27m.CommentType).INLINE,
                        parentCommentId: null,
                        isReply: false,
                        pageMode: pageMode,
                        isLivePage: createdFrom === 'LIVE',
                        navdexPointType: (0, $56QzY.END),
                        inlineNodeTypes: selectionOptions.inlineNodeTypes,
                        ...annotationElement && !isEditor && {
                            nodeType: $f4c77c6e390a7914$var$getNodeType(annotationElement, annotationId)
                        },
                        ...!isEditor && {
                            targetNodeType: targetNodeType
                        }
                    }
                }
            }).fire(); // Reset the editor
            onSuccess();
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                commentType: 'inline',
                entryPoint: 'create-comment',
                annotationId: annotationId
            }); /*
           * On editor pages, the view-inline-comment experience is started by the editor when the
           * created annotation is automatically selected after successful comment creation. For
           * editor pages, we update the attributes here to ensure that the experience is tracked
           * with the correct entry point.
           */ 
            if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_create')) {
                const attributes = {
                    annotationId: annotationId,
                    entryPoint: $f4c77c6e390a7914$var$relativeFilePath,
                    pageClass: pageClass
                };
                if (pageClass === 'renderer') experienceTracker.start({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                    attributes: {
                        ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                        ...attributes
                    }
                });
                else if (pageClass === 'editor') experienceTracker.updateAttributes({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    attributes: attributes
                });
                if (isCommentsPanelShown) experienceTracker.fail({
                    name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                    error: new Error('Comments panel is visible when it should not be'),
                    attributes: {
                        stopPoint: $f4c77c6e390a7914$var$relativeFilePath
                    }
                });
            }
        };
        const onCreateFailure = (err)=>{
            saveAttemptedTracker.current.failedSaves = saveAttemptedTracker.current.failedSaves + 1;
            saveAttemptedCounts.current.failedSaves = saveAttemptedCounts.current.failedSaves + 1;
            experienceTracker.fail({
                name: (0, $irVI7.VIEW_PAGE_DIRECT_COMMENT_DATA_FLOW_EXPERIENCE),
                error: err,
                attributes: {
                    pageId: pageId,
                    pageMode: pageMode,
                    isEditor: isEditor,
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            (0, $a3q17.DIRECT_COMMENT_DATA_FLOW_METRIC).cancel();
            (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.debug({
                error: err,
                createAnalyticsEvent: createAnalyticsEvent,
                extraAttributes: {
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui'
                }
            });
            if (!succeededPublish) saveAttemptedTracker.current.lastPublishFailure = err;
            let contentOutOfDate = false; // Get a truncated graphql error message
            const { errorId: errorId, message: message } = (0, $isdzP.parseError)(err);
            const translatedError = (0, $isdzP.getTranslatedError)(message); // COMMENTS-1879 - The backend will fall back to the old method of trying to make string matches if the content
            // is out of date. If the BE fails to apply a comment when using the old fallback method we should log it
            if ((0, $isdzP.isHighlightError)(translatedError)) {
                // Send the analytics event
                const analyticsObject = {
                    source: 'viewPage',
                    objectType: 'page',
                    objectId: pageId,
                    action: 'invalid',
                    actionSubject: 'highlight',
                    actionSubjectId: 'inlineComment',
                    attributes: {
                        errorMessage: message,
                        editor: 'FABRIC',
                        framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                        errorId: errorId,
                        highlightOrigin: 'userHighlight' // TODO: Do we need to programmatically track this?
                    }
                };
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: analyticsObject
                }).fire();
                contentOutOfDate = true;
            }
            failPublishExperience(err, translatedError); // Use the existing value if it's already set or is an out of date error
            contentOutOfDate = contentOutOfDate || (0, $isdzP.isOutOfDateError)(translatedError); // In the case of an annotation error, we should show a flag to the user to let them know
            // their comment has been saved and they need to refresh the content (view mode only)
            if ((0, $isdzP.isAnnotationError)(translatedError)) {
                const CREATE_ERROR_FLAG_ID = `create-error-${Date.now()}`;
                const getAnnotationErrorFlagActions = ()=>{
                    if (pageMode === (0, $cD1qu.PageMode).VIEW) // Only show the refetch content action on view mode as it's not applicable in editor/live
                    return [
                        {
                            content: formatMessage($f4c77c6e390a7914$var$i18n.refreshContentLink),
                            onClick: ()=>{
                                setRefetchContent(true);
                                handleOnClose();
                                flags.hideFlag(CREATE_ERROR_FLAG_ID);
                            }
                        }
                    ];
                    else {
                        // pageMode === PageMode.EDITOR || PageMode.LIVE
                        if (createdAnnotationId.current && createdCommentId.current && translatedError === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation && (0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) return [
                            {
                                content: formatMessage((0, $9CnRS.i18n).goToCommentCTA),
                                onClick: ()=>{
                                    if (!isCommentsPanelShown) showCommentsPanel({
                                        openWithView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    else setCurrentView((0, $3mVfX.ViewValues).DELETED_CONTENT);
                                    setCurrentlySelectedThreadKey(createdAnnotationId.current);
                                    (0, $9FoVw.handleCommentsPanelNavigationWithViewChange)({
                                        scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                                        context: (0, $9FoVw.NavigationContext).PANEL,
                                        block: 'center',
                                        annotationId: createdAnnotationId.current,
                                        commentId: createdCommentId.current,
                                        commentType: 'INLINE',
                                        annotationClicked: true,
                                        expectedView: (0, $3mVfX.ViewValues).DELETED_CONTENT
                                    });
                                    flags.hideFlag(CREATE_ERROR_FLAG_ID);
                                }
                            }
                        ];
                         // TODO: Add more actions for editor/live if needed
                    }
                    return [];
                };
                flags.showWarningFlag({
                    id: CREATE_ERROR_FLAG_ID,
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $f4c77c6e390a7914$var$i18n.unableToApplyTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), translatedError === (0, $9CnRS.i18n).unableToApplyAnnotation ? $f4c77c6e390a7914$var$i18n.unableToApplyDescription : translatedError),
                    actions: getAnnotationErrorFlagActions()
                }); // Log the occurance through analytics so we can still track it
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        source: pageMode === (0, $cD1qu.PageMode).VIEW ? 'viewPageScreen' : 'editPageScreen',
                        objectType: 'page',
                        objectId: pageId,
                        action: 'failed',
                        actionSubject: 'applyAnnotation',
                        actionSubjectId: 'inlineComment',
                        attributes: {
                            errorMessage: message,
                            editor: 'FABRIC',
                            framework: (0, $kmHPt.InlineCommentFramework).ANNOTATION_PROVIDER,
                            isLivePage: pageMode === (0, $cD1qu.PageMode).LIVE,
                            tenantId: cloudId,
                            userId: userId,
                            pageId: pageId
                        }
                    }
                }).fire(); // Some code duplication.
                // Not extracting common code since `else` will be deleted after experiment is shipped.
                if ((0, $6mKj3.expValEquals)('confluence_fe_show_created_dangling_comment_flag', 'isEnabled', true)) (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.abort({
                    abortReason: 'Unable to apply annotation to document',
                    attributes: {
                        detailedMessage: message,
                        ...errorId ? {
                            errorId: errorId
                        } : {},
                        pageMode: pageMode,
                        context: isEditor ? 'editor' : 'renderer',
                        pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                        pageId: pageId
                    }
                });
                else (0, $3YBks.createInlineCommentCompoundExperience).draftToPublishExperience.fail(new Error('Unable to apply annotation to document'), {
                    detailedMessage: message,
                    ...errorId ? {
                        errorId: errorId
                    } : {},
                    pageMode: pageMode,
                    context: isEditor ? 'editor' : 'renderer',
                    pointOfFailure: !succeededPublish ? 'running-mutation' : 'applying-comment-to-ui',
                    pageId: pageId
                });
                onClose && onClose();
                return;
            }
            // CommentEditor expects a translated error message otherwise it fails
            // TODO: CommentEditor should likely just receive the translated message
            // rather than expect the object needed for FormattedMessage
            return Promise.reject({
                error: contentOutOfDate ? (0, $9CnRS.i18n).contentOutOfDate : translatedError,
                contentOutOfDate: contentOutOfDate
            });
        };
        // Wrap the createCommentFn mutation with the interop logic that handles both the direct Apollo
        // mutation path and the new hook-based for the Comments Data Manager
        const commentCreationInteropWrapper = (options)=>createInlineCommentInterop({
                originalMutationFn: createCommentFn,
                options: options,
                onCacheUpdateError: onCacheUpdateError
            });
        if ((0, $9wGTI.fg)('confluence_frontend_add_inline_comment_timeout')) return handleSaveCommentWithTimeout($f4c77c6e390a7914$export$d26c1daa0321174b, commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure));
        else return commentCreationInteropWrapper({
            variables: variables
        }).then(onCreateSuccess).catch(onCreateFailure);
    };
    const handleOnClose = (0, $42omo.useCallback)((hasContentChanged)=>{
        const reason = hasContentChanged ? 'comment discarded by user' : 'empty comment discarded by user';
        experienceTracker.abort({
            name: (0, $irVI7.ADD_INLINE_COMMENT_EXPERIENCE),
            reason: reason
        }); // Clearing reply draft is handled in the comment editor
        (0, $aGjYc.clearCommentDraft)(isEditor ? 'edit-inline' : 'inline', 'create');
        onClose && onClose();
    }, [
        experienceTracker,
        isEditor,
        onClose
    ]);
    const onEditorLoad = ()=>{
        experienceTracker.succeed({
            name: (0, $irVI7.ADD_INLINE_COMMENT_LOAD_EXPERIENCE)
        });
        const draftAnnotationElement = $f4c77c6e390a7914$export$292a5d148db8f191();
        if (!draftAnnotationElement && !wasDraftAnnotationRemoved) {
            // We have handling to show a message when we detect the draft annotation was removed, indicated by
            // `wasDraftAnnotationRemoved=true`. So we only need to fail the experience if we unexpectedly cannot find
            // the draftAnnotationElement, indicated by `wasDraftAnnotationRemoved=false`
            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('No annotation element'));
            return;
        }
        setTimeout(()=>{
            // There are multiple useEffects involved in positioning the comment UI.
            // This works around this by only marking the experience as complete after
            // a short timeout + animation frame.
            requestAnimationFrame(()=>{
                // In the Editor and Renderer, the comment UI is positioned relative to slightly different
                // elements.
                if (!draftAnnotationElement) {
                    (0, $3YBks.createInlineCommentCompoundExperience).initExperience.abort({
                        abortReason: 'Draft annotation removed from document'
                    });
                    return;
                } else if (!sidebarEl.current) (0, $3YBks.createInlineCommentCompoundExperience).initExperience.fail(new Error('Missing create comment ui'));
                else {
                    const commentUIVerticalDistanceFromAnnotation = Math.abs(draftAnnotationElement.getBoundingClientRect().top - sidebarEl.current.getBoundingClientRect?.().top); // The 40 pixel allowance has been arbitrarily chosen to allow for some wiggle room
                    if (commentUIVerticalDistanceFromAnnotation > 40) {
                        const isVisible = sidebarEl.current.checkVisibility();
                        if (isVisible) {
                            // if it's fully visible, but misaligned, we don't treat this as a failure
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debug({
                                error: new Error('View Created Comment UI too far from annotation'),
                                createAnalyticsEvent: createAnalyticsEvent,
                                extraAttributes: {
                                    misalignedBy: commentUIVerticalDistanceFromAnnotation
                                }
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                        } else {
                            (0, $3YBks.createInlineCommentCompoundExperience).addCommonAttributes({
                                misalignedBy: commentUIVerticalDistanceFromAnnotation
                            });
                            (0, $3YBks.createInlineCommentCompoundExperience).initExperience.softFail(new Error('Draft Comment UI is setup too far from annotation'));
                        }
                    } else (0, $3YBks.createInlineCommentCompoundExperience).initExperience.complete();
                }
            });
        }, 1000);
    };
    if (loading || error) {
        (0, $3YBks.createInlineCommentCompoundExperience).initExperience.debugPoint(`CreateComment dialog ${loading ? 'loading' : 'error'}`, {
            error: error?.message ?? '',
            loading: loading
        });
        return null;
    }
    const spaceId = pageInfo?.space?.id ?? '';
    const pageType = pageInfo?.type ?? ''; // User page permissions
    const operations = pageInfo?.operations || [];
    const spaceOperations = (0, $9wGTI.fg)('confluence_comments_space_operations_permissions') ? pageInfo?.space?.operations || [] : [];
    const canAddComment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'comment');
    const canAddAttachment = operations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment') || spaceOperations.some((op)=>op?.operation === 'create' && op?.targetType === 'attachment'); // The user can upload media only if they have update permissions for the page if confluence_comment_use_comment_media_endpoint FG is off
    const hasMediaUploadPermissions = (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? canAddComment && canAddAttachment : operations.some((op)=>op?.operation === 'update' && op?.targetType === pageType); // Don't render CreateComment at all until author data is ready (only when experiment is enabled)
    // This ensures both CommentAuthor and CommentEditor render together with data ready
    if (!isAuthorReady && (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $B3Avz.CommentSidebar), {
        pageId: pageId,
        onClose: handleOnClose,
        isEditor: isEditor,
        annotationElement: annotationElement,
        sidebarOffset: sidebarOffset,
        isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar,
        sidebarEl: sidebarEl,
        isSticky: isSticky,
        isFabricPage: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$Container, {
        ref: commentContainerElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $daq5m.CommentAuthor), {
        size: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? 'small' : 'medium',
        commentMode: "create",
        userId: userId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f4c77c6e390a7914$var$CommentEditorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXzKU.LazyCommentEditor // @ts-ignore FIXME: `pageId` can be `undefined` here, and needs proper handling
    ), {
        pageId: pageId,
        pageType: pageType,
        spaceId: spaceId,
        appearance: "chromeless",
        EditorComponent: (0, $7EEGh.ChromelessEditor),
        onSaveComment: handleSaveComment,
        onContentChange: onChange,
        commentMode: "create",
        commentType: isEditor ? 'edit-inline' : 'inline',
        onEditorReady: onEditorLoad,
        hideWatchCheckbox: true,
        pageMode: isEditor ? 'edit' : 'view',
        shouldWarnOnInternalNavigation: true,
        useNewWarningModal: true,
        setShouldRefetch: ()=>setShouldRefetch(true),
        hasMediaUploadPermissions: hasMediaUploadPermissions,
        commentContainerElementRef: commentContainerElementRef,
        wasDraftAnnotationRemoved: wasDraftAnnotationRemoved,
        isStandaloneComment: true,
        isOffline: isOffline,
        allowDefaultMouseDownOnSave: (0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)
    }))));
};
const $f4c77c6e390a7914$export$b217475cf0d7b767 = (0, $7aRa9.withFlags)($f4c77c6e390a7914$var$CreateCommentComponent); /**
                                                                 *
                                                                 * Exported for testing purposes only
                                                                 *
                                                                 * This function is used to find the draft annotation element in the DOM.
                                                                 * It checks both the renderer and editor for the draft annotation element.
                                                                 *
                                                                 * In some scenarios, there are duplicate draft annotations in the DOM such
                                                                 * as in the renderer where the dom for table headers is repeated.
                                                                 *
                                                                 * To mitigate this, we get all possible draft annotation elements and
                                                                 * and return the first one that has a height greater than 0.
                                                                 *
                                                                 * If no draft annotation element is found, it returns null.
                                                                 */ 
function $f4c77c6e390a7914$export$292a5d148db8f191() {
    const possibleAnnotations = document.querySelectorAll((0, $9wGTI.fg)('confluence_fe_create_inline_comment_exp_coverage_2') ? '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft, .ak-editor-block-annotation-draft' : '[data-annotation-draft-mark="true"], .ak-editor-annotation-draft');
    if (possibleAnnotations.length === 1) // In cases where there is only one draft annotation, we can return it directly
    // and avoid the performance hit where reflow is triggered by checking if the
    // annotation has a height greater than 0.
    return possibleAnnotations[0];
    for(let i = 0; i < possibleAnnotations.length; i++){
        if (possibleAnnotations[i].getBoundingClientRect().height > 0) return possibleAnnotations[i];
    }
    return null;
}
module.exports["CreateComment"] = $f4c77c6e390a7914$export$b217475cf0d7b767;

});

parcelRegister("aGjYc", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $7W8i8 = parcelRequire("7W8i8");

const $9a76668fa978df44$export$6af3d18059afaa9e = 'outOfDate';
const $9a76668fa978df44$var$logger = (0, $7W8i8.getLogger)('comment-draft-utils');
const $9a76668fa978df44$var$getKey = (type, mode)=>{
    switch(type){
        case 'edit-inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_EDITOR_INLINE_REPLY;
        case 'inline':
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_INLINE_REPLY;
        case 'page':
        default:
            if (mode === 'create') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_CREATE;
            else if (mode === 'edit') return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_EDIT;
            else return (0, $1UApO.keys).COMMENT_DRAFTS_PAGE_REPLY;
    }
};
const $9a76668fa978df44$export$a4f0a5ceed96eae8 = (adf, pageId, type, mode)=>{
    let b64EncodedDraftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const draftObj = JSON.stringify({
        pageId: pageId,
        adf: adf
    });
    try {
        b64EncodedDraftObj = btoa(draftObj);
    } catch (e) {
        $9a76668fa978df44$var$logger.error`Unable to save draft object for ${pageId}; ${e}`;
    }
    if (b64EncodedDraftObj === null) return false;
    // Store the draft with a 72 hour expiration
    (0, $17wUi.confluenceLocalStorageInstance).setItem(key, b64EncodedDraftObj, 259200);
    return true;
};
const $9a76668fa978df44$export$e7cfba777a0d590e = (type, mode)=>{
    const key = $9a76668fa978df44$var$getKey(type, mode);
    (0, $17wUi.confluenceLocalStorageInstance).removeItem(key);
};
const $9a76668fa978df44$export$5fff31d3d3e1ad8b = (pageId, type, mode)=>Boolean($9a76668fa978df44$export$7c0604f3bd51258a(pageId, type, mode));
const $9a76668fa978df44$export$7c0604f3bd51258a = (pageId, type, mode)=>{
    let draftObj = null;
    const key = $9a76668fa978df44$var$getKey(type, mode);
    const b64EncodedDraftObj = (0, $17wUi.confluenceLocalStorageInstance).getItem(key);
    if (b64EncodedDraftObj !== null) {
        try {
            draftObj = JSON.parse(atob(b64EncodedDraftObj));
        } catch (e) {
            $9a76668fa978df44$var$logger.error`Unable to get draft object for ${pageId}; ${e}`;
        }
        if (draftObj) {
            const { pageId: draftPageId, adf: adf } = draftObj;
            // If the pageId matches, return the ADF, otherwise return null
            if (draftPageId === pageId) return adf;
        }
    }
    return null;
};
module.exports["OUT_OF_DATE_KEY"] = $9a76668fa978df44$export$6af3d18059afaa9e;
module.exports["saveCommentDraft"] = $9a76668fa978df44$export$a4f0a5ceed96eae8;
module.exports["clearCommentDraft"] = $9a76668fa978df44$export$e7cfba777a0d590e;
module.exports["hasCommentDraft"] = $9a76668fa978df44$export$5fff31d3d3e1ad8b;
module.exports["getCommentDraft"] = $9a76668fa978df44$export$7c0604f3bd51258a;

});

parcelRegister("cAdj8", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $j1Ss3 = parcelRequire("j1Ss3");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $1uFM6 = parcelRequire("1uFM6");


var $flE5X = parcelRequire("flE5X");

const $a1394411ec7881e4$var$usePageInfoPageInfoQuery = (0, $eSUdr.default)`query usePageInfoPageInfoQuery($pageId:ID){content(id:$pageId status:["current" "archived" "draft"]){nodes{id type status space{id operations{operation targetType}}operations{operation targetType}version{number}}}}`;
const $a1394411ec7881e4$export$e1b9843c9a40eb2 = {
    id: '',
    type: '',
    status: '',
    space: {
        id: '',
        operations: []
    },
    operations: [],
    version: {
        number: -1
    }
};
const $a1394411ec7881e4$export$7b2dac1793a2824 = ({ fetchPolicy: fetchPolicy = 'cache-and-network', onCompleted: onCompleted, onError: onError } = {})=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $j1Ss3.useQuery)($a1394411ec7881e4$var$usePageInfoPageInfoQuery, {
        variables: {
            pageId: contentId
        },
        fetchPolicy: fetchPolicy,
        onCompleted: onCompleted
    });
    return (0, $42omo.useMemo)(()=>{
        // Handle error case first
        if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error) || error instanceof (0, $flE5X.NoNetworkError)) (0, $7Sm4c.markErrorAsHandled)(error);
            onError?.(error);
            return {
                pageInfo: null,
                loading: false,
                error: error,
                refetch: null
            };
        }
        // If we have data, use it even during loading
        if (data) {
            const pageInfoNode = data.content?.nodes?.[0] ?? null;
            if (pageInfoNode) return {
                pageInfo: pageInfoNode,
                loading: loading,
                error: undefined,
                refetch: refetch
            };
            return {
                pageInfo: {
                    ...$a1394411ec7881e4$export$e1b9843c9a40eb2
                },
                loading: loading,
                error: undefined,
                refetch: refetch
            };
        }
        // Only return null pageInfo if we have no data at all
        return {
            pageInfo: null,
            loading: loading,
            error: undefined,
            refetch: null
        };
    }, [
        data,
        loading,
        error,
        onError,
        refetch
    ]);
};
module.exports["usePageInfo"] = $a1394411ec7881e4$export$7b2dac1793a2824;

});

parcelRegister("kmHPt", function(module, exports) {
var $b271ebdedd90282b$export$b21a3980a7aad169 = /*#__PURE__*/ function(InlineCommentFramework) {
    InlineCommentFramework["BACKBONE"] = "backbone";
    InlineCommentFramework["REACT"] = "react";
    InlineCommentFramework["ANNOTATION_PROVIDER"] = "annotation-provider";
    return InlineCommentFramework;
}({});
module.exports["InlineCommentFramework"] = $b271ebdedd90282b$export$b21a3980a7aad169;

});

parcelRegister("daq5m", function(module, exports) {
/* CommentAuthor.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @graphql cc
 */ 
var $77XlC = parcelRequire("77XlC");


var $aFLCH = parcelRequire("aFLCH");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cUiCf = parcelRequire("cUiCf");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $3gadb = parcelRequire("3gadb");


var $8jHAi = parcelRequire("8jHAi");


var $jJK3p = parcelRequire("jJK3p");


var $fs6LW = parcelRequire("fs6LW");


var $1YXTQ = parcelRequire("1YXTQ");


var $gvWVt = parcelRequire("gvWVt");


var $6faGq = parcelRequire("6faGq");


var $7tI6B = parcelRequire("7tI6B");


var $9wGTI = parcelRequire("9wGTI");


var $3ejfs = parcelRequire("3ejfs");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $6b5EI = parcelRequire("6b5EI");


var $cWhxr = parcelRequire("cWhxr");


var $lRNq8 = parcelRequire("lRNq8");


var $jMyy4 = parcelRequire("jMyy4");

'use no memo';
const $005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery = (0, $aFLCH.default);
const $005e7fbdd3b99ea0$var$CommentAuthorUserQuery = (0, $77XlC.default);
const $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply, isStandaloneComment: isStandaloneComment, isFooterComment: isFooterComment })=>{
    if (isFixedEditStyles) {
        const negativeMarginForEditMode = (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? '-16px' : '-24px';
        return commentMode === 'edit' ? isReply || isStandaloneComment || isFooterComment ? '0' : negativeMarginForEditMode : undefined;
    }
    return commentMode === 'reply' ? '-2px' : 'inherit';
};
const $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom = ({ isFixedEditStyles: isFixedEditStyles, commentMode: commentMode, isReply: isReply })=>{
    if (isFixedEditStyles) return commentMode === 'edit' ? isReply ? '8px' : '12px' : undefined;
    return commentMode === 'view' ? undefined : '8px';
};
const $005e7fbdd3b99ea0$var$authorContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$AuthorContainer = (props)=>{
    const { commentMode: _commentMode, isReply: _isReply, isStandaloneComment: _isStandaloneComment, isFooterComment: _isFooterComment, isFixedEditStyles: _isFixedEditStyles, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        style: {
            marginLeft: $005e7fbdd3b99ea0$var$getAuthorContainerMarginLeft(props),
            paddingBottom: $005e7fbdd3b99ea0$var$getAuthorContainerPaddingBottom(props)
        },
        ...rest,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1ul9idpf _jva41snc _uvzw1snc _wkreagmp _12rjagmp _gcmzvv82 _1vjrvv82 _5xy14viv _1dtc4viv _1msj4viv"
        ])
    });
};
const $005e7fbdd3b99ea0$var$avatarWrapperBaseStyles = null;
const $005e7fbdd3b99ea0$var$avatarSmallPaddingStyles = null;
const $005e7fbdd3b99ea0$var$avatarLargePaddingStyles = null;
const $005e7fbdd3b99ea0$var$AvatarWrapper = ({ isCommentsTuneupActive: isCommentsTuneupActive, isCommentsPanel: isCommentsPanel, isFooterComment: isFooterComment, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_1e0c1txw",
            !isCommentsTuneupActive && (isCommentsPanel || isFooterComment || isFixedEditStyles) ? "_u5f312x7" : "_u5f3u2gc"
        ])
    });
};
const $005e7fbdd3b99ea0$var$containerStyles = null;
const $005e7fbdd3b99ea0$var$Container = ({ useProfileLinkStyle: useProfileLinkStyle, useColumnStyle: useColumnStyle, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _1ul9idpf _14yyfhey _hwn17g83 _1msj4viv _5xy14viv _1dtc4viv _17rpwadc _cpznidpf _1s79idpf _amufidpf _x966idpf _387xglyw _14l5azsu _1ptk1j28 _19gdazsu _1gidazsu _1e6pazsu",
            useProfileLinkStyle && "_zulpu2gc _1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _4cvr1q9y _1ul9idpf",
            useColumnStyle && "_zulpidpf _2lx21bp4 _4cvr1y6m"
        ])
    });
};
const $005e7fbdd3b99ea0$var$newPageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative'
}); // TODO: remove the following 3 styles when cleaning up `confluence_frontend_content_wrapper` flag
const $005e7fbdd3b99ea0$var$resolvedPropertiesStyle = (0, $ecnYn.xcss)({
    paddingLeft: 'space.050'
});
const $005e7fbdd3b99ea0$var$pageIconStyle = (0, $ecnYn.xcss)({
    position: 'relative',
    top: 'space.negative.025'
});
const $005e7fbdd3b99ea0$var$generalCommentFooterStyle = (0, $ecnYn.xcss)({
    top: 'space.negative.050'
});
const $005e7fbdd3b99ea0$var$profileLinkContainerStyle = null;
const $005e7fbdd3b99ea0$var$profileLinkContainerColumnStyle = null;
const $005e7fbdd3b99ea0$var$truncateTextStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
    flex: '1 1 0%',
    wordBreak: 'unset'
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$ProfileLinkContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = $005e7fbdd3b99ea0$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $005e7fbdd3b99ea0$var$LozengeWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19bvu2gc _s7n4jp4b",
            __cmplp.className
        ])
    });
});
const $005e7fbdd3b99ea0$var$dateContainerBaseStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerStandaloneStyles = null;
const $005e7fbdd3b99ea0$var$dateContainerSubtlestStyles = null;
const $005e7fbdd3b99ea0$var$DateContainer = ({ isStandaloneComment: isStandaloneComment, isCommentsPanel: isCommentsPanel, isFixedEditStyles: isFixedEditStyles, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...props,
        className: (0, $gMc0m.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _2lx2n7od _4cvrn7od _102ewadc _1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _7wy0glyw _1plv1j28 _zmp8azsu _1blwazsu _9b8iazsu _1kcs1y54",
            isStandaloneComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && "_2lx21bp4 _4cvr1y6m",
            (isStandaloneComment || isCommentsPanel && isFixedEditStyles) && "_syaz1rpy"
        ])
    });
}; // confluence_comments_cohiti_date_tooltips exp evaluations will use this component-level i18n object instead of commentsI18n
const $005e7fbdd3b99ea0$var$i18n = (0, $cgtv4.defineMessages)({
    defaultTooltip: {
        id: "inline-comments-common.date-tooltip.default",
        defaultMessage: "Added on {date} at {timestamp}"
    },
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    },
    resolvedTooltip: {
        id: "inline-comments-common.date-tooltip.resolved",
        defaultMessage: "Resolved by {username} on {date} at {timeStamp}"
    },
    reopenedTooltip: {
        id: "inline-comments-common.date-tooltip.reopened",
        defaultMessage: "Reopened by {username} on {date} at {timeStamp}"
    },
    reopenedDateInfoText: {
        id: "inline-comments-common.reopened.date.info.text",
        defaultMessage: "Reopened {timeAgo}{timeStamp, select,\n\t\t\tundefined {}\n\t\t\tother { at {timeStamp}}\n\t\t}"
    },
    resolvedDateInfoText: {
        id: "inline-comments-common.resolved.date.info.text",
        defaultMessage: "Resolved {timeAgo}"
    }
});
const $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7 = ({ commentMode: commentMode, userId: userId, date: date, createdAtNonLocalized: createdAtNonLocalized, size: size, displayName: displayName, avatarUrl: avatarUrl, commentDateUrl: commentDateUrl, commentId: commentId, permissionType: permissionType, isInactiveComment: isInactiveComment, showCopyLink: showCopyLink = false, resolveProperties: resolveProperties, isCommentsPanel: isCommentsPanel = false, isGeneralComments: isGeneralComments = false, isReply: isReply = false, isFooterComment: isFooterComment = false, isStandaloneComment: isStandaloneComment = false })=>{
    const skipUserIdPath = Boolean(avatarUrl && displayName || !userId || commentId);
    const { data: authorData } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorInlineCommentAuthorQuery, {
        variables: {
            commentId: commentId
        },
        fetchPolicy: 'cache-and-network',
        skip: Boolean(userId || !commentId)
    });
    const { data: userDataFromOld } = (0, $jMyy4.useQueryInterop)($005e7fbdd3b99ea0$var$CommentAuthorUserQuery, {
        variables: {
            id: userId
        },
        fetchPolicy: 'cache-and-network',
        skip: skipUserIdPath || (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true)
    });
    const { data: userDataFromNew } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, {
        skip: skipUserIdPath || !(0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true),
        fetchPolicy: 'cache-and-network'
    });
    const userData = (0, $6mKj3.expValEquals)('confluence_comment_improve_author_paint', 'isEnabled', true) ? userDataFromNew : userDataFromOld;
    const author = (authorData?.content?.nodes || [])[0]?.history?.createdBy;
    const userAvatar = author ? author.profilePicture?.path : (userData?.user?.photos || [])[0]?.value;
    const userDisplayName = author ? author.displayName : userData?.user?.displayName;
    const userAccountId = author?.accountId;
    const linkToComment = `${window.location.origin}/wiki${commentDateUrl}`;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    const getTooltipContent = ()=>{
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            // resolveProperties.resolved = true -> comment is in resolved state
            // resolveProperties.resolved = false -> comment is in re-opened state
            const i18nMessage = resolveProperties?.resolved ? $005e7fbdd3b99ea0$var$i18n.resolvedTooltip : $005e7fbdd3b99ea0$var$i18n.reopenedTooltip;
            const resolvedTimeBase = new Date(resolveProperties.resolvedTime);
            return formatMessage(i18nMessage, {
                username: resolveProperties?.resolvedUser,
                date: intl.formatDate(resolvedTimeBase, {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime(resolvedTimeBase, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            });
        }
        if (resolveProperties?.resolved) return formatMessage((0, $3ejfs.commentsi18n).resolvedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser
        });
        return formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
            username: resolveProperties?.resolvedUser,
            createdAtNonLocalized: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
                date: (0, $6faGq.getValidDate)(createdAtNonLocalized),
                usePrepositions: true
            })
        });
    };
    const oldStandloneExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: resolveProperties?.resolvedFriendlyDate
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                username: resolveProperties?.resolvedUser,
                friendlyDate: resolveProperties?.resolvedFriendlyDate
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
            username: resolveProperties?.resolvedUser,
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        }))));
    };
    const getResolvedDateInfoText = ()=>{
        // resolveProperties.resolved = true -> comment is in resolved state
        // resolveProperties.resolved = false -> comment is in re-opened state
        const i18nKey = resolveProperties?.resolved ? 'resolvedDateInfoText' : 'reopenedDateInfoText';
        if (resolveProperties?.resolvedTime && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true)) {
            const resolvedTimeBase_0 = new Date(resolveProperties.resolvedTime);
            const twentyFourHourThreshold = 86400; // in seconds
            const secondsSinceReopen = (Date.now() - resolvedTimeBase_0.getTime()) / 1000; // Don't include a timestamp if the comment was re-opened less than 24 hours ago
            const shouldIncludeTimeStamp = secondsSinceReopen >= twentyFourHourThreshold;
            return formatMessage($005e7fbdd3b99ea0$var$i18n[i18nKey], {
                // use formatTimeAgo directly so that this string can be injected into aria-label,
                timeAgo: (0, $1YXTQ.formatTimeAgo)(intl, resolvedTimeBase_0, true, {}, userTimeZone, tenantTimeZone),
                timeStamp: shouldIncludeTimeStamp && !(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? intl.formatTime(resolvedTimeBase_0, {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                }) : undefined
            });
        } else return formatMessage((0, $3ejfs.commentsi18n)[i18nKey], {
            friendlyDate: resolveProperties?.resolvedFriendlyDate
        });
    };
    const newExperienceResolveInfo = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "top",
            content: getTooltipContent()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "aria-label": getResolvedDateInfoText()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtlest",
            size: "small",
            maxLines: 2
        }, getResolvedDateInfoText())));
    };
    const renderResolveInfo = ()=>{
        const standAloneExperience = !isFooterComment && !isCommentsPanel;
        if (standAloneExperience && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isFooterComment && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isCommentsPanel) return newExperienceResolveInfo();
        return oldStandloneExperienceResolveInfo();
    };
    const hasPageCommentIconEnabled = (0, $42omo.useCallback)(()=>{
        if (!isGeneralComments) return false;
        return !isFooterComment;
    }, [
        isGeneralComments,
        isFooterComment
    ]); // TODO: remove renderDateInfoOldExperience() when cleaning up `confluence_frontend_content_wrapper` flag
    const renderDateInfoOldExperience = (resolvedInfo)=>{
        return resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, resolvedInfo, hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $005e7fbdd3b99ea0$var$pageIconStyle,
                $005e7fbdd3b99ea0$var$resolvedPropertiesStyle,
                isFooterComment && $005e7fbdd3b99ea0$var$generalCommentFooterStyle
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date)
        }), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$pageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        })))));
    };
    const renderCopyButton = ()=>{
        const resolvedInfo_0 = renderResolveInfo();
        const renderCopyLinkButton = commentDateUrl && !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && !isCommentsPanel;
        const timeAgoDate = (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? createdAtNonLocalized : date;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$DateContainer, {
            isStandaloneComment: isStandaloneComment,
            isCommentsPanel: isCommentsPanel,
            isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }, (0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050"
        }, resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate ? resolvedInfo_0 : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: (0, $6mKj3.expValEquals)('confluence_comments_cohiti_date_tooltips', 'isEnabled', true) ? formatMessage($005e7fbdd3b99ea0$var$i18n.defaultTooltip, {
                date: intl.formatDate((0, $6faGq.getValidDate)(timeAgoDate), {
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                    timeZone: timeZone
                }),
                timestamp: intl.formatTime((0, $6faGq.getValidDate)(timeAgoDate), {
                    hour: 'numeric',
                    minute: 'numeric',
                    timeZone: timeZone
                })
            }) : undefined
        }, (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cWhxr.RelativeTimestamp), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1YXTQ.TimeAgo), {
            date: (0, $6faGq.getValidDate)(timeAgoDate)
        })), hasPageCommentIconEnabled() && !isReply && (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $005e7fbdd3b99ea0$var$newPageIconStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))), {
            color: "var(--ds-icon-subtlest, #6B6E76)",
            testId: "general-comment-page-icon",
            label: formatMessage((0, $3ejfs.commentsi18n).generalCommentTooltip)
        }))))) : renderDateInfoOldExperience(resolvedInfo_0), renderCopyLinkButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6b5EI.CopyLinkButton), {
            visible: showCopyLink,
            textToCopy: linkToComment
        }));
    };
    const isDateShown = (commentMode === 'view' || (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) && date;
    const name = displayName || userDisplayName || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AuthorContainer, {
        commentMode: commentMode,
        isReply: isReply,
        isStandaloneComment: isStandaloneComment,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        "data-testid": "comment-author"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$AvatarWrapper, {
        isCommentsPanel: isCommentsPanel,
        isFooterComment: isFooterComment,
        isFixedEditStyles: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
        isCommentsTuneupActive: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fs6LW.ProfileAvatar), {
        isBlockLevel: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        userId: userId,
        src: avatarUrl || userAvatar,
        trigger: "click",
        size: size,
        name: name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lRNq8.MaybeTooltip), {
        date: date,
        name: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$Container, {
        useProfileLinkStyle: (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true),
        useColumnStyle: !!(resolveProperties?.resolved || resolveProperties?.resolvedFriendlyDate) && (0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$ProfileLinkContainer, null, isInactiveComment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
        "data-testid": "dummy-profile-link"
    }, displayName || userDisplayName) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jJK3p.ProfileLink), {
        fullName: displayName || userDisplayName,
        userId: userId || userAccountId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            wordBreak: 'break-word',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            color: "var(--ds-text, #292A2E)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            fontWeight: "var(--ds-font-weight-medium, 500)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...(0, $6mKj3.expValEquals)('confluence_comments_tuneup', 'isEnabled', true) && $005e7fbdd3b99ea0$var$truncateTextStyle
        },
        isUnderlinedByDefault: false
    }), permissionType === (0, $7tI6B.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($005e7fbdd3b99ea0$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null)) : null), isDateShown && renderCopyButton())));
};
module.exports["CommentAuthor"] = $005e7fbdd3b99ea0$export$d05a2f5fbf67a6d7;

});

parcelRegister("77XlC", function(module, exports) {
/**
 * @generated SignedSource<<f3a4b4ed7601aace35c2653bcb912fb4>>
 * @relayHash 7603ffb5cdb0040c872fb1a866b28175
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0
const $a4999a70afb18ca0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorUserQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7603ffb5cdb0040c872fb1a866b28175",
            "id": "0b1e2510061c030d99b8f44e327d161323fb6339bea4e158cd11ff183a6440a0",
            "metadata": {},
            "name": "CommentAuthorUserQuery",
            "operationKind": "query",
            "text": "query CommentAuthorUserQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a4999a70afb18ca0$var$node.hash = "b941cc393296a840051106bc2b577a66";
var $a4999a70afb18ca0$export$2e2bcd8739ae039 = $a4999a70afb18ca0$var$node;
module.exports["default"] = $a4999a70afb18ca0$export$2e2bcd8739ae039;

});

parcelRegister("aFLCH", function(module, exports) {
/**
 * @generated SignedSource<<ea6bac65cbc1f11b4d15bcbc69caa479>>
 * @relayHash 3fce16c4b50c6a412fa8487092b88148
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641
const $05493535de3a048c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "commentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "commentId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v5 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "createdBy",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fce16c4b50c6a412fa8487092b88148",
            "id": "e22018d4069a45e8f6db8aee4f779ec3d1167f9f1b3abb3096b28120a93d6641",
            "metadata": {},
            "name": "CommentAuthorInlineCommentAuthorQuery",
            "operationKind": "query",
            "text": "query CommentAuthorInlineCommentAuthorQuery($commentId:ID!){content(id:$commentId){nodes{id,history{createdBy{__typename,displayName,profilePicture{path},...on KnownUser{accountId}}}}}}"
        }
    };
}();
$05493535de3a048c$var$node.hash = "7be748651ddc7f6e555a6f8193a7649c";
var $05493535de3a048c$export$2e2bcd8739ae039 = $05493535de3a048c$var$node;
module.exports["default"] = $05493535de3a048c$export$2e2bcd8739ae039;

});

parcelRegister("cUiCf", function(module, exports) {

var $kVisP = parcelRequire("kVisP");


var $jMyy4 = parcelRequire("jMyy4");

const $e7d88eb3577c40b3$export$81e6931b5465b2c6 = (0, $kVisP.default);
const $e7d88eb3577c40b3$export$15a9d6bfd715c3fb = (userId, options = {})=>{
    const { skip: skip = !userId, fetchPolicy: fetchPolicy = 'cache-and-network' } = options;
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($e7d88eb3577c40b3$export$81e6931b5465b2c6, {
        variables: {
            id: userId
        },
        fetchPolicy: fetchPolicy,
        skip: skip || !userId
    });
    const isReady = skip || !!data || !loading;
    return {
        data: data,
        loading: loading,
        isReady: isReady
    };
};
module.exports["useCommentAuthorQuery"] = $e7d88eb3577c40b3$export$15a9d6bfd715c3fb;

});

parcelRegister("kVisP", function(module, exports) {
/**
 * @generated SignedSource<<bc24953310fa78820eb739edf69525c0>>
 * @relayHash d7dd18272a64084411071f3794bede2a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d
const $a036ea87d0b71d0a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "concreteType": "AtlassianUserPhoto",
                    "kind": "LinkedField",
                    "name": "photos",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommentAuthorQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "d7dd18272a64084411071f3794bede2a",
            "id": "034bbfdcc82ad8b892c7f2334d1da72b0bff1c2b16820174371933b530761c1d",
            "metadata": {},
            "name": "useCommentAuthorQuery",
            "operationKind": "query",
            "text": "query useCommentAuthorQuery($id:ID!){user:confluence_atlassianUser(id:$id){id,displayName,photos{value}}}"
        }
    };
}();
$a036ea87d0b71d0a$var$node.hash = "5a28bff8b85798e31c8498c8ffd13edb";
var $a036ea87d0b71d0a$export$2e2bcd8739ae039 = $a036ea87d0b71d0a$var$node;
module.exports["default"] = $a036ea87d0b71d0a$export$2e2bcd8739ae039;

});

parcelRegister("jJK3p", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jyPfN = parcelRequire("jyPfN");


var $cPER9 = parcelRequire("cPER9");


var $4qzKl = parcelRequire("4qzKl");


var $a6t12 = parcelRequire("a6t12");


var $5XsiK = parcelRequire("5XsiK");


var $dD7ks = parcelRequire("dD7ks");

const $5c1fbd48d7d200d4$var$linkStyles = (0, $ecnYn.xcss)({
    textDecoration: 'underline',
    display: 'inline-block',
    cursor: 'pointer'
});
const $5c1fbd48d7d200d4$var$i18n = (0, $cgtv4.defineMessages)({
    profileLinkName: {
        id: "profile.link.name",
        defaultMessage: "{fullName} profile"
    }
});
const $5c1fbd48d7d200d4$export$a2a4245643e0242b = (t0)=>{
    const $ = (0, $frIzR.c)(23);
    const { userId: userId, fullName: fullName, isAnonymous: t1, onUserLinkClick: onUserLinkClick, referralSource: referralSource, className: className, style: style, behavior: t2, position: t3, offset: offset, ariaLabel: ariaLabel, isUnderlinedByDefault: t4 } = t0;
    const isAnonymous = t1 === undefined ? false : t1;
    const behavior = t2 === undefined ? "link" : t2;
    const position = t3 === undefined ? "bottom-start" : t3;
    const isUnderlinedByDefault = t4 === undefined ? true : t4;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const intl = (0, $8C5kA.default)();
    const t5 = userId ?? "";
    let t6;
    if ($[0] !== t5) {
        t6 = {
            type: "USER",
            payload: {
                userId: t5
            }
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const { href: teamsAppPersonProfileUrl } = (0, $dD7ks.useNavigateToTeamsApp)(t6);
    let t7;
    if ($[2] !== ariaLabel || $[3] !== behavior || $[4] !== className || $[5] !== fullName || $[6] !== intl || $[7] !== isAnonymous || $[8] !== isUnderlinedByDefault || $[9] !== offset || $[10] !== onUserLinkClick || $[11] !== position || $[12] !== referralSource || $[13] !== style || $[14] !== teamsAppPersonProfileUrl || $[15] !== userId) {
        t7 = ()=>{
            if (behavior === "card") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
                isAnonymous: isAnonymous,
                userId: userId,
                position: position,
                offset: offset,
                ariaLabel: ariaLabel
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                style: style,
                xcss: $5c1fbd48d7d200d4$var$linkStyles
            }, fullName));
            else {
                const linkStyle = {
                    ...style,
                    ...isUnderlinedByDefault ? {
                        textDecoration: "underline"
                    } : {}
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cPER9.PeopleLink), {
                    target: "_blank",
                    onClick: onUserLinkClick,
                    href: (0, $5XsiK.isTeamsAppEnabled)() ? teamsAppPersonProfileUrl : (0, $4qzKl.getAtlassianPeopleProfileUrl)(userId, referralSource),
                    className: className,
                    style: linkStyle,
                    "data-testid": "profile-link",
                    "aria-label": ariaLabel || intl.formatMessage($5c1fbd48d7d200d4$var$i18n.profileLinkName, {
                        fullName: fullName
                    })
                }, fullName);
            }
        };
        $[2] = ariaLabel;
        $[3] = behavior;
        $[4] = className;
        $[5] = fullName;
        $[6] = intl;
        $[7] = isAnonymous;
        $[8] = isUnderlinedByDefault;
        $[9] = offset;
        $[10] = onUserLinkClick;
        $[11] = position;
        $[12] = referralSource;
        $[13] = style;
        $[14] = teamsAppPersonProfileUrl;
        $[15] = userId;
        $[16] = t7;
    } else t7 = $[16];
    const renderNameComponent = t7;
    let t8;
    if ($[17] !== fullName || $[18] !== hasViewUserProfilePermission || $[19] !== isAnonymous || $[20] !== renderNameComponent || $[21] !== userId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isAnonymous || !userId || userId === "" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            id: "profile.anonymous.name",
            defaultMessage: "Anonymous"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasViewUserProfilePermission ? renderNameComponent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, fullName)));
        $[17] = fullName;
        $[18] = hasViewUserProfilePermission;
        $[19] = isAnonymous;
        $[20] = renderNameComponent;
        $[21] = userId;
        $[22] = t8;
    } else t8 = $[22];
    return t8;
};
module.exports["ProfileLink"] = $5c1fbd48d7d200d4$export$a2a4245643e0242b;

});

parcelRegister("cPER9", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $8lYIw = parcelRequire("8lYIw");


var $jlIaF = parcelRequire("jlIaF");


var $5XsiK = parcelRequire("5XsiK");

const $6a5a2957e3d32f84$export$43aa0d4f5c176033 = (props)=>{
    const $ = (0, $frIzR.c)(8);
    let href;
    let otherProps;
    let to;
    if ($[0] !== props) {
        ({ href: href, to: to, ...otherProps } = props);
        $[0] = props;
        $[1] = href;
        $[2] = otherProps;
        $[3] = to;
    } else {
        href = $[1];
        otherProps = $[2];
        to = $[3];
    }
    const url = to || href;
    const path = url && url.indexOf("/") !== 0 ? `/${url}` : url;
    const destination = !path.startsWith((0, $jlIaF.CONTEXT_PATH)) ? `${0, $jlIaF.CONTEXT_PATH}${path}` : path;
    const t0 = (0, $5XsiK.isTeamsAppEnabled)() ? url : destination;
    let t1;
    if ($[4] !== otherProps || $[5] !== props || $[6] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8lYIw.Link), {
            ...props,
            href: t0,
            ...otherProps
        });
        $[4] = otherProps;
        $[5] = props;
        $[6] = t0;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
$6a5a2957e3d32f84$export$43aa0d4f5c176033.propTypes = {
    href: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string
};
module.exports["PeopleLink"] = $6a5a2957e3d32f84$export$43aa0d4f5c176033;

});

parcelRegister("fs6LW", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $esRft = parcelRequire("esRft");


var $jyPfN = parcelRequire("jyPfN");


var $9wGTI = parcelRequire("9wGTI");


var $a6t12 = parcelRequire("a6t12");

const $98dff64af54e38f8$var$avatarWrapperStyles = {
    base: (0, $ecnYn.xcss)({
        display: 'inline-flex',
        backgroundColor: 'color.background.neutral.subtle',
        borderWidth: '0',
        padding: 'space.0',
        borderRadius: 'radius.full',
        outlineOffset: 'space.0',
        ':focus-within': {
            outlineStyle: 'solid',
            outlineWidth: 'border.width.focused',
            outlineColor: 'color.border.focused'
        }
    }),
    blockBase: (0, $ecnYn.xcss)({
        display: 'flex'
    }),
    cursor: (0, $ecnYn.xcss)({
        cursor: 'pointer'
    })
};
const $98dff64af54e38f8$var$i18n = (0, $cgtv4.defineMessages)({
    label: {
        id: "profile.avatar.image",
        defaultMessage: "profile image of a user"
    },
    ariaLabel: {
        id: "profile.avatar.ariaLabel",
        defaultMessage: "More information about {name}"
    }
});
const $98dff64af54e38f8$export$3778be82376b06d7 = (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { userId: userId, canViewProfile: t1, isAnonymous: t2, size: t3, src: src, onClick: onClick, trigger: trigger, name: name, stackIndex: stackIndex, testId: testId, position: position, borderColor: borderColor, offset: offset, isBlockLevel: t4 } = t0;
    const canViewProfile = t1 === undefined ? true : t1;
    const isAnonymous = t2 === undefined ? false : t2;
    const size = t3 === undefined ? "medium" : t3;
    const isBlockLevel = t4 === undefined ? false : t4;
    const intl = (0, $8C5kA.default)();
    const avatarSrc = isAnonymous || !canViewProfile || !src ? undefined : src;
    const { canViewUserProfile: hasViewUserProfilePermission } = (0, $jyPfN.useViewUserProfile)();
    const willRenderProfileCardTrigger = !isAnonymous && canViewProfile && !!userId && hasViewUserProfilePermission;
    const avatarRef = (0, $42omo.useRef)(null);
    const [isVisible, setIsVisible] = (0, $42omo.useState)(false);
    const [shouldReturnFocus, setShouldReturnFocus] = (0, $42omo.useState)(false);
    const [wasKeyboardAction, setWasKeyboardAction] = (0, $42omo.useState)(false);
    let t5;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (isVisible_0)=>{
            setIsVisible(isVisible_0);
        };
        $[0] = t5;
    } else t5 = $[0];
    const handleVisibilityChange = t5;
    let t6;
    let t7;
    if ($[1] !== isVisible || $[2] !== shouldReturnFocus) {
        t6 = ()=>{
            if (shouldReturnFocus && !isVisible && avatarRef.current) {
                avatarRef.current.focus();
                setShouldReturnFocus(false);
            }
        };
        t7 = [
            isVisible,
            shouldReturnFocus
        ];
        $[1] = isVisible;
        $[2] = shouldReturnFocus;
        $[3] = t6;
        $[4] = t7;
    } else {
        t6 = $[3];
        t7 = $[4];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[5] !== isVisible || $[6] !== wasKeyboardAction) {
        t8 = (e)=>{
            e.stopPropagation();
            if (e.key === "Enter") {
                setWasKeyboardAction(true);
                setIsVisible($98dff64af54e38f8$var$_temp);
                setShouldReturnFocus(true);
            } else if (e.key === "Escape" && isVisible && wasKeyboardAction) {
                setIsVisible(false);
                setWasKeyboardAction(false);
                setShouldReturnFocus(true);
            }
        };
        $[5] = isVisible;
        $[6] = wasKeyboardAction;
        $[7] = t8;
    } else t8 = $[7];
    const handleKeyDown = t8;
    const t9 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? "" : name || "";
    let t10;
    if ($[8] !== intl) {
        t10 = (0, $9wGTI.fg)("a11y_whiteboards_changes") ? {} : {
            label: intl.formatMessage($98dff64af54e38f8$var$i18n.label)
        };
        $[8] = intl;
        $[9] = t10;
    } else t10 = $[9];
    let t11;
    if ($[10] !== avatarSrc || $[11] !== borderColor || $[12] !== onClick || $[13] !== size || $[14] !== stackIndex || $[15] !== t10 || $[16] !== t9 || $[17] !== testId) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            src: avatarSrc,
            size: size,
            target: "_blank",
            name: t9,
            ...t10,
            stackIndex: stackIndex,
            testId: testId,
            borderColor: borderColor,
            onClick: onClick
        });
        $[10] = avatarSrc;
        $[11] = borderColor;
        $[12] = onClick;
        $[13] = size;
        $[14] = stackIndex;
        $[15] = t10;
        $[16] = t9;
        $[17] = testId;
        $[18] = t11;
    } else t11 = $[18];
    const Icon = t11;
    let t12;
    if ($[19] !== intl || $[20] !== isVisible || $[21] !== name || $[22] !== willRenderProfileCardTrigger) {
        t12 = ()=>{
            if ((0, $9wGTI.fg)("a11y_whiteboards_changes")) return {};
            if (willRenderProfileCardTrigger) return {
                tabIndex: -1
            };
            return {
                "aria-haspopup": "true",
                "aria-expanded": isVisible,
                "aria-label": intl.formatMessage($98dff64af54e38f8$var$i18n.ariaLabel, {
                    name: name || ""
                }),
                role: "button",
                tabIndex: 0
            };
        };
        $[19] = intl;
        $[20] = isVisible;
        $[21] = name;
        $[22] = willRenderProfileCardTrigger;
        $[23] = t12;
    } else t12 = $[23];
    const getAriaProps = t12;
    const t13 = name || "";
    let t14;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (0, $9wGTI.fg)("a11y_whiteboards_changes");
        $[24] = t14;
    } else t14 = $[24];
    const t15 = isBlockLevel && $98dff64af54e38f8$var$avatarWrapperStyles.blockBase;
    const t16 = canViewProfile && hasViewUserProfilePermission && $98dff64af54e38f8$var$avatarWrapperStyles.cursor;
    let t17;
    if ($[25] !== t15 || $[26] !== t16) {
        t17 = [
            $98dff64af54e38f8$var$avatarWrapperStyles.base,
            t15,
            t16
        ];
        $[25] = t15;
        $[26] = t16;
        $[27] = t17;
    } else t17 = $[27];
    let t18;
    if ($[28] !== getAriaProps) {
        t18 = getAriaProps();
        $[28] = getAriaProps;
        $[29] = t18;
    } else t18 = $[29];
    let t19;
    if ($[30] !== Icon || $[31] !== handleKeyDown || $[32] !== t17 || $[33] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: t17,
            testId: "avatarWrapperTestId",
            ref: avatarRef,
            onKeyDown: handleKeyDown,
            ...t18
        }, Icon);
        $[30] = Icon;
        $[31] = handleKeyDown;
        $[32] = t17;
        $[33] = t18;
        $[34] = t19;
    } else t19 = $[34];
    let t20;
    if ($[35] !== canViewProfile || $[36] !== isAnonymous || $[37] !== offset || $[38] !== position || $[39] !== t13 || $[40] !== t19 || $[41] !== trigger || $[42] !== userId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a6t12.ProfileCardWrapper), {
            userId: userId,
            canViewProfile: canViewProfile,
            isAnonymous: isAnonymous,
            trigger: trigger,
            fullName: t13,
            disabledAriaAttributes: t14,
            onVisibilityChange: handleVisibilityChange,
            position: position,
            offset: offset
        }, t19);
        $[35] = canViewProfile;
        $[36] = isAnonymous;
        $[37] = offset;
        $[38] = position;
        $[39] = t13;
        $[40] = t19;
        $[41] = trigger;
        $[42] = userId;
        $[43] = t20;
    } else t20 = $[43];
    return t20;
};
function $98dff64af54e38f8$var$_temp(prev) {
    return !prev;
}
module.exports["ProfileAvatar"] = $98dff64af54e38f8$export$3778be82376b06d7;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await (parcelRequire("lWBRe"))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("lWBRe", function(module, exports) {

let $ff9c617ad0e949e6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff9c617ad0e949e6$var$load("h4Nf7").then(()=>parcelRequire('9fywD'));

});

parcelRegister("6faGq", function(module, exports) {

var $3ejfs = parcelRequire("3ejfs");


var $3iaSn = parcelRequire("3iaSn");

const $fd14f0f09d6b2a27$export$48c62524de3612b3 = (dateString)=>{
    if (!dateString) return new Date(0); // Return earliest possible date if missing
    // Ensure UTC timezone. Some createdAt values are missing the UTC timezone identifier, and some have it
    const normalizedDate = dateString.endsWith('Z') ? dateString : `${dateString}Z`;
    // Try to parse the date, return earliest date if invalid
    const parsed = new Date(normalizedDate);
    return isNaN(parsed.getTime()) ? new Date(0) : parsed;
};

const $fd14f0f09d6b2a27$export$63880caa66d80fb9 = ({ intl: intl, dateString: dateString, commentStatus: commentStatus = (0, $3iaSn.CommentStatus).OPEN, resolveProperties: resolveProperties, isReply: isReply = false })=>{
    if (!dateString) return '';
    // Get formatted timestamp
    let timestamp;
    try {
        const { formatTimeAgo: formatTimeAgo } = (parcelRequire("1JmNR"));
        timestamp = formatTimeAgo(intl, $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString));
    } catch (error) {
        // Fallback to a simple date format if formatTimeAgo is not available
        const date = $fd14f0f09d6b2a27$export$48c62524de3612b3(dateString);
        timestamp = date.toLocaleDateString(intl.locale);
    }
    // For replies, just return the timestamp without comment status
    if (isReply) return timestamp;
    // Format based on comment status
    switch(commentStatus){
        case (0, $3iaSn.CommentStatus).RESOLVED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).resolvedByInfoText, {
                friendlyDate: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).REOPENED:
            return intl.formatMessage((0, $3ejfs.commentsi18n).reopenedByTooltipTextCommentsPanel, {
                createdAtNonLocalized: timestamp,
                username: resolveProperties?.resolvedUser
            });
        case (0, $3iaSn.CommentStatus).OPEN:
        default:
            return intl.formatMessage((0, $3ejfs.commentsi18n).createdTimestamp, {
                timestamp: timestamp
            });
    }
};
module.exports["getValidDate"] = $fd14f0f09d6b2a27$export$48c62524de3612b3;
module.exports["formatTimestampForAriaLabel"] = $fd14f0f09d6b2a27$export$63880caa66d80fb9;

});

parcelRegister("3ejfs", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $d1e9edb9f1563526$export$454b2229580969d0 = (0, $cgtv4.defineMessages)({
    resolvedByInfoText: {
        id: "comments-util.resolved.by.info.text",
        defaultMessage: "Resolved by {username} {friendlyDate}"
    },
    reopenedByTooltipTextCommentsPanel: {
        id: "comments-util.reopened.by.tooltip.text.comments.panel",
        defaultMessage: "Added {createdAtNonLocalized}, reopened by {username}"
    },
    createdTimestamp: {
        id: "comments-util.timestamp.created",
        defaultMessage: "created {timestamp}"
    },
    resolvedDateInfoText: {
        id: "comments-util.resolved.date.info.text",
        defaultMessage: "Resolved {friendlyDate}"
    },
    reopenedDateInfoText: {
        id: "comments-util.reopened.date.info.text",
        defaultMessage: "Reopened {friendlyDate}"
    },
    generalCommentTooltip: {
        id: "comments-util.view.tooltip.general.comment",
        defaultMessage: "General comment"
    },
    anonymous: {
        id: "comments-util.display.name.anonymous",
        defaultMessage: "Anonymous"
    },
    editedBy: {
        id: "comments-util.edited.by",
        defaultMessage: "Edited by {username} {at}"
    },
    edited: {
        id: "comments-util.edited",
        defaultMessage: "Edited"
    },
    resolvedByTooltipTextCommentsPanel: {
        id: "comments-util.resolved.by.tooltip.text.comments.panel",
        defaultMessage: "By {username}"
    }
});
module.exports["commentsi18n"] = $d1e9edb9f1563526$export$454b2229580969d0;

});

parcelRegister("3iaSn", function(module, exports) {

var $42omo = parcelRequire("42omo");

var $c6395b80aeb36ecd$export$4f1057b172870e9c = /*#__PURE__*/ function(CommentStatus) {
    CommentStatus["OPEN"] = "OPEN";
    CommentStatus["RESOLVED"] = "RESOLVED";
    CommentStatus["REOPENED"] = "REOPENED";
    return CommentStatus;
}({});
const $c6395b80aeb36ecd$export$eac30d30628b994a = ({ resolveProperties: resolveProperties })=>{
    return (0, $42omo.useMemo)(()=>{
        // If no resolve properties, the comment is open
        if (!resolveProperties) return "OPEN";
        // If resolved is false, the comment is reopened
        if (!resolveProperties.resolved) return "REOPENED";
        return "RESOLVED";
    }, [
        resolveProperties
    ]);
};
module.exports["CommentStatus"] = $c6395b80aeb36ecd$export$4f1057b172870e9c;
module.exports["useGetCommentStatus"] = $c6395b80aeb36ecd$export$eac30d30628b994a;

});

parcelRegister("1JmNR", function(module, exports) {
$parcel$export(module.exports, "formatTimeAgo", () => (parcelRequire("1YXTQ")).formatTimeAgo);
$parcel$export(module.exports, "TimeAgo", () => (parcelRequire("1YXTQ")).TimeAgo);
$parcel$export(module.exports, "StaticTimeAgo", () => (parcelRequire("1YXTQ")).StaticTimeAgo);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $1YXTQ = parcelRequire("1YXTQ");


});

parcelRegister("7tI6B", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ /**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */ var $89d6a09a4f827a20$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $89d6a09a4f827a20$export$8995abb8169b2cb8;

});

parcelRegister("6b5EI", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $3gadb = parcelRequire("3gadb");


var $1bY7o = parcelRequire("1bY7o");


var $3sFtD = parcelRequire("3sFtD");


var $6F6hl = parcelRequire("6F6hl");


var $aHcFH = parcelRequire("aHcFH");


var $afGoD = parcelRequire("afGoD");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $9CnRS = parcelRequire("9CnRS");

const $0220545780b126ac$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { visible: visible, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_v5641n2p _1e0c116y _4cvr1h6o _1bah1h6o _18u014y2 _tzy4idpf _t9ec1jvs _1mygkb7n _66dk1xty",
            __cmplp.visible && "_tzy4kb7n _t9ec1ygq",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomTooltipWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c116y _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0220545780b126ac$var$CustomizedTooltipTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((t0, ref)=>{
    const $ = (0, $frIzR.c)(7);
    let children;
    let rest;
    if ($[0] !== t0) {
        ({ children: children, ...rest } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = rest;
    } else {
        children = $[1];
        rest = $[2];
    }
    const t1 = ref;
    let t2;
    if ($[3] !== children || $[4] !== rest || $[5] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$CustomTooltipWrapper, {
            ...rest,
            ref: t1
        }, children);
        $[3] = children;
        $[4] = rest;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
});
const $0220545780b126ac$export$da91d1846689786c = 'link-icon';
const $0220545780b126ac$export$9c785f85e6437122 = 'check-icon';
const $0220545780b126ac$export$266980ac2cfa7919 = 'legacy-clipboard-support';
const $0220545780b126ac$var$RESET_TIMEOUT = 5000;
const $0220545780b126ac$export$534d10f1c5b9c7b3 = (t0)=>{
    const $ = (0, $frIzR.c)(30);
    const { visible: visible, textToCopy: textToCopy, children: children } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isCopied, setCopied] = (0, $42omo.useState)(false);
    const copyWrapperRef = (0, $42omo.useRef)(null);
    const cleanupTimer = (0, $42omo.useRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isEditor = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = !(0, $aHcFH.isClipboardApiSupported)() && !(0, $aHcFH.isIEClipboardApiSupported)();
        $[0] = t1;
    } else t1 = $[0];
    const needRenderCopyArea = t1;
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (needRenderCopyArea) copyWrapperRef.current = document.getElementById("copyWrapperRef");
        };
        t3 = [
            needRenderCopyArea
        ];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCopied) {
        t4 = ()=>{
            if (isCopied) cleanupTimer.current = setTimeout(()=>setCopied(false), $0220545780b126ac$var$RESET_TIMEOUT);
            return ()=>clearTimeout(cleanupTimer.current);
        };
        t5 = [
            isCopied
        ];
        $[3] = isCopied;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== createAnalyticsEvent || $[7] !== isCopied || $[8] !== isEditor || $[9] !== isLivePage || $[10] !== textToCopy) {
        t6 = async (event)=>{
            event.stopPropagation();
            if (isCopied) return;
            if ((0, $aHcFH.isClipboardApiSupported)()) await (0, $aHcFH.copyToClipboard)(textToCopy);
            else if ((0, $aHcFH.isIEClipboardApiSupported)()) await (0, $aHcFH.copyToClipboardIE)(textToCopy);
            else await (0, $aHcFH.legacyCopyToClipboard)(textToCopy, copyWrapperRef.current);
            const pageMode = (isLivePage ? (0, $afGoD.CommentCreationLocation).LIVE : isEditor ? (0, $afGoD.CommentCreationLocation).EDITOR : (0, $afGoD.CommentCreationLocation).RENDERER).toLowerCase();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: isEditor ? "editPageScreen" : "viewPageScreen",
                    action: "clicked",
                    actionSubject: "copyCommentLink",
                    attributes: {
                        pageMode: pageMode
                    }
                }
            }).fire();
            setCopied(true);
        };
        $[6] = createAnalyticsEvent;
        $[7] = isCopied;
        $[8] = isEditor;
        $[9] = isLivePage;
        $[10] = textToCopy;
        $[11] = t6;
    } else t6 = $[11];
    const handleButtonClick = t6;
    let t7;
    if ($[12] !== formatMessage || $[13] !== isCopied) {
        t7 = isCopied ? formatMessage((0, $9CnRS.i18n).linkCopiedTooltip) : formatMessage((0, $9CnRS.i18n).copyLinkTooltip);
        $[12] = formatMessage;
        $[13] = isCopied;
        $[14] = t7;
    } else t7 = $[14];
    const tooltipContent = t7;
    let t8;
    if ($[15] !== formatMessage || $[16] !== isCopied) {
        t8 = !isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: formatMessage((0, $9CnRS.i18n).copyLinkTooltip),
            testId: $0220545780b126ac$export$da91d1846689786c,
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
            label: formatMessage((0, $9CnRS.i18n).linkCopiedTooltip),
            color: "var(--ds-icon-success, #6A9A23)",
            testId: $0220545780b126ac$export$9c785f85e6437122,
            spacing: "spacious"
        });
        $[15] = formatMessage;
        $[16] = isCopied;
        $[17] = t8;
    } else t8 = $[17];
    let t9;
    if ($[18] !== handleButtonClick || $[19] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: "subtle-link",
            "data-cy": "inline-comment-time-link",
            iconBefore: t8,
            onClick: handleButtonClick,
            spacing: "none"
        });
        $[18] = handleButtonClick;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    let t10;
    if ($[21] !== t9 || $[22] !== tooltipContent) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: tooltipContent,
            position: "top",
            tag: $0220545780b126ac$var$CustomizedTooltipTag,
            hideTooltipOnClick: true
        }, t9);
        $[21] = t9;
        $[22] = tooltipContent;
        $[23] = t10;
    } else t10 = $[23];
    let t11;
    if ($[24] !== children) {
        t11 = needRenderCopyArea && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            testId: $0220545780b126ac$export$266980ac2cfa7919,
            id: "copyWrapperRef"
        }, children);
        $[24] = children;
        $[25] = t11;
    } else t11 = $[25];
    let t12;
    if ($[26] !== t10 || $[27] !== t11 || $[28] !== visible) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0220545780b126ac$var$Wrapper, {
            visible: visible
        }, t10, t11);
        $[26] = t10;
        $[27] = t11;
        $[28] = visible;
        $[29] = t12;
    } else t12 = $[29];
    return t12;
};
module.exports["CopyLinkButton"] = $0220545780b126ac$export$534d10f1c5b9c7b3;

});

parcelRegister("aHcFH", function(module, exports) {

var $1d2ww = parcelRequire("1d2ww");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $cD1qu = parcelRequire("cD1qu");


var $i49vP = parcelRequire("i49vP");

const $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7 = 'inline-create-comment-selection';
const $a78c261c3211f7d6$export$b803c692fbaaa5a4 = 'inline-highlight';
const $a78c261c3211f7d6$export$fb3d0eebfe85522a = 'active-highlight';
const $a78c261c3211f7d6$export$b899b07e3f725968 = ()=>{
    const commentData = {
        commentIndex: undefined,
        totalComments: undefined
    };
    if (window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__ && window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']) {
        commentData['commentIndex'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['position']);
        commentData['totalComments'] = Number(window.__SSR_INLINE_COMMENTS_EVENTS_CAPTURE__['focusedComment']['totalComments']);
    }
    return commentData;
};
const $a78c261c3211f7d6$export$1f7acceb752add79 = (pageMode)=>{
    const marks = Array.from(document.querySelectorAll($a78c261c3211f7d6$export$8c7b048437c01388(pageMode))).map((node)=>{
        if (pageMode === 'edit') return node.id;
        else return $a78c261c3211f7d6$export$8f4213b45c05ab5d(node);
    });
    /* In case of overlapping comments there will be multiple tags with the same markerRefs. We need to remove
  duplicates in that case so we can navigate between comments correctly */ return new Set(marks);
};
const $a78c261c3211f7d6$export$9b48c18cc387f791 = (markerRefList, pageMode = 'view')=>{
    const distinctMarks = [
        ...$a78c261c3211f7d6$export$1f7acceb752add79(pageMode)
    ];
    return distinctMarks.filter((mark)=>mark && markerRefList.includes(mark));
};
const $a78c261c3211f7d6$export$8c7b048437c01388 = (pageMode = 'view')=>{
    if (pageMode === 'edit') return "[annotationtype='inlineComment']";
    else return '[data-mark-annotation-type="inlineComment"], .inline-comment-marker';
};
const $a78c261c3211f7d6$export$f7ceeb7ba8156450 = ()=>{
    const activeHighlights = document.querySelectorAll(`.${$a78c261c3211f7d6$export$fb3d0eebfe85522a}`);
    activeHighlights.forEach((activeHighlight)=>{
        activeHighlight.classList.remove($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    });
};
const $a78c261c3211f7d6$var$getNextTextNodeOld = (node, boundingParentNode)=>{
    let currentNode = node;
    let nextTextNode = currentNode?.nextSibling;
    // If the node has no next sibling, grab it's parent's next sibling until we find a node
    while(!nextTextNode){
        nextTextNode = currentNode?.parentElement?.nextSibling;
        if (nextTextNode) {
            // WS-2551 - If the bounding parent exists and we're out of bounds of it, we're done looking
            if (boundingParentNode && !boundingParentNode.contains(nextTextNode)) {
                nextTextNode = null;
                break;
            }
            // If we've landed on a text node, then break out
            if (nextTextNode.nodeType === Node.TEXT_NODE) break;
            // If the node exists and it's a hard break (<br />), we do one of two things:
            //   1. If it has a bounding parent, break out because the <br /> signifies the end of the selection
            //   2. If not, then move to the next sibling because we don't count hard breaks in selections
            if (nextTextNode?.tagName === 'BR') {
                if (boundingParentNode) break;
                else nextTextNode = nextTextNode.nextSibling;
            }
        } else // If the text node we tried to access is null, we need to jump up a generation
        currentNode = currentNode?.parentNode;
    }
    // Search for the first text node in the next node
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE)nextTextNode = nextTextNode.firstChild;
    return nextTextNode;
};
const $a78c261c3211f7d6$export$3e98291f1f032a77 = (currentNode, boundingNode, isInlineMark)=>{
    let nextTextNode = isInlineMark ? currentNode : currentNode?.nextSibling;
    while(nextTextNode && nextTextNode.nodeType !== Node.TEXT_NODE){
        // If the text node is the bounding node, return that node
        if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return nextTextNode;
        // Check if the node is a hard break (<br />) or an element with role="presentation" we do one of two things:
        if (nextTextNode?.tagName === 'BR') {
            // If it has a bounding parent, break out because the <br /> signifies the end of the selection
            if (boundingNode) return nextTextNode;
            // If not, then move to the next sibling because we don't count hard breaks in selections
            nextTextNode = nextTextNode.nextSibling;
        } else if (nextTextNode?.attributes?.getNamedItem('role')?.value === 'presentation') // If the element has role="presentation", move to the parent element's sibling because this current node does not contain a text node
        nextTextNode = nextTextNode.parentNode?.nextSibling;
        else if ($a78c261c3211f7d6$var$isEmojiNode(nextTextNode)) {
            // If we encounter an emoji and it's also the bounding node, return nothing
            if (boundingNode && nextTextNode?.isSameNode(boundingNode)) return null;
            // Otherwise, just return the node after it and keep going
            nextTextNode = nextTextNode.nextSibling;
        } else // Otherwise, search for the first text node in the next node
        nextTextNode = nextTextNode.firstChild;
    }
    // If we've found the text node, return that node
    if (nextTextNode?.nodeType === Node.TEXT_NODE) return nextTextNode;
    // If the text node we tried to access is null, we need to jump up a generation
    if (!nextTextNode) return $a78c261c3211f7d6$export$3e98291f1f032a77(currentNode?.parentNode, boundingNode);
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // WS-2551 - Triple clicks are the only thing that can cause the endContainer to be a non-text node
    const isTripleClick = endContainer.nodeType !== Node.TEXT_NODE;
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    if (!startContainer.isSameNode(endContainer)) {
        let boundingParentNode;
        // Push the starting node into a range
        const startingRange = new Range();
        startingRange.setStart(startContainer, startOffset);
        startingRange.setEnd(startContainer, startContainer.length);
        rangesToHighlight.push(startingRange);
        // WS-2551 - In the case of a triple click, we only want to contain our selection to the
        // first non-comment parent wrapping the starting container to ensure we don't over select
        if (isTripleClick) {
            boundingParentNode = startContainer.parentNode;
            while(!boundingParentNode || boundingParentNode.nodeType === Node.TEXT_NODE || $a78c261c3211f7d6$export$8f4213b45c05ab5d(boundingParentNode) !== null)boundingParentNode = boundingParentNode?.parentNode;
        } else {
            // Push the ending node into a range only if it's not a triple click
            const endingRange = new Range();
            endingRange.setStart(endContainer, 0);
            endingRange.setEnd(endContainer, endOffset);
            rangesToHighlight.push(endingRange);
        }
        // Iterate through all the inner nodes and extract the text ranges
        let node = $a78c261c3211f7d6$var$getNextTextNodeOld(startContainer, boundingParentNode);
        while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
            if (node.length) {
                const range = new Range();
                range.selectNodeContents(node);
                rangesToHighlight.push(range);
            }
            node = $a78c261c3211f7d6$var$getNextTextNodeOld(node, boundingParentNode);
        }
    } else // If they are the same container it's much simpler and we can just use the range
    rangesToHighlight.push(selectedRange);
    return rangesToHighlight;
};
const $a78c261c3211f7d6$var$isEmojiNode = (node)=>{
    if (!node) return false;
    const attributes = node?.attributes;
    const classList = node?.classList;
    return attributes && attributes.getNamedItem('data-emoji-id') || classList && classList.contains('emoji-common-node');
};
const $a78c261c3211f7d6$var$extractTextNodesIntoRanges = (selectedRange)=>{
    const rangesToHighlight = [];
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = selectedRange;
    // NOTE: It's not possible for us to get here with anything other than "#text" nodes
    //       for the start container due to our highlighting restrictions, so we only
    //       need to check the type for endContainer when we get a selected range
    // The endContainer is a non-text node when the user either:
    // 1. Triple clicks a node
    // 2. Highlights a header
    // 3. The highlight goes to the next node but does not actually highlight anything (offset === 0)
    const isNonTextNodeEndContainer = endContainer.nodeType !== Node.TEXT_NODE;
    // If highlight is just one node (i.e. same containers), it's much simpler and we can just use the range
    if (startContainer.isSameNode(endContainer)) {
        rangesToHighlight.push(selectedRange);
        return rangesToHighlight;
    }
    // If the start and end containers don't match, we need to loop through and extract
    // the text nodes out all common elements and create ranges to represent each of them
    let boundingNode;
    // Push the starting node into a range
    const startingRange = new Range();
    startingRange.setStart(startContainer, startOffset);
    startingRange.setEnd(startContainer, startContainer.length);
    rangesToHighlight.push(startingRange);
    // In the case of a non-text node endContainer, we want to set a bounding node to the endContainer so we know
    // to stop traversing the DOM when hidding that bounding node
    if (isNonTextNodeEndContainer) {
        // If the end container is non-text and an emoji, we need to jump up a level or else it is
        // going to be bound to a node that we will never be able to check and thus never exit
        if ($a78c261c3211f7d6$var$isEmojiNode(endContainer)) boundingNode = endContainer.parentNode;
        else boundingNode = endContainer;
    } else {
        // Push the ending node into a range
        const endingRange = new Range();
        endingRange.setStart(endContainer, 0);
        endingRange.setEnd(endContainer, endOffset);
        rangesToHighlight.push(endingRange);
    }
    // Get the first "inner" node between the start and end containers
    let node = $a78c261c3211f7d6$export$3e98291f1f032a77(startContainer, boundingNode);
    // Iterate through all the inner nodes and extract the text ranges
    while(node && !node.isSameNode(endContainer) && node.nodeType === Node.TEXT_NODE){
        if (node.length) {
            const range = new Range();
            range.selectNodeContents(node);
            rangesToHighlight.push(range);
        }
        node = $a78c261c3211f7d6$export$3e98291f1f032a77(node, boundingNode);
    }
    return rangesToHighlight;
};
const $a78c261c3211f7d6$export$739c145b6a07c076 = (isFabricPage, isCreateDialogOpen = false, markerRef = '')=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    let markOffsetTop = 0;
    // Measure the offset of the highlight from the renderer wrapper
    // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    if (markerRef) {
        const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(highlight);
    } else {
        const selection = window.getSelection();
        // If there is a user selection, we need to create a new temp "highlight" for this
        // new selection as it is removed when the temp "highlight" is created
        const isNewSelection = selection && selection.type == 'Range' && !isCreateDialogOpen;
        if (isNewSelection) {
            // Reset any existing DOM selections
            $a78c261c3211f7d6$export$743373b19993e2b0();
            // Mark the selection in the DOM temporarily
            $a78c261c3211f7d6$export$4147ba71ff179432(false);
        }
        const createCommentHighlight = document.querySelector(`.${highlightClass}`);
        markOffsetTop = $a78c261c3211f7d6$export$331805bfbe18b1c0(createCommentHighlight);
    }
    // On a fabric page, the highlight is positioned relative to the renderer
    // wrapper. To correctly position the sidebar we need to measure the offset
    // of the renderer wrapper and the offset of the highlight from the wrapper
    if (isFabricPage) {
        const rendererWrapper = document.querySelector('#content .ak-renderer-wrapper');
        if (rendererWrapper) markOffsetTop += rendererWrapper.offsetTop;
    } else {
        // In tiny, we need to remove the title and author info offset to position it correctly
        const pageMetadata = document.querySelector('#content-body .page-metadata-modification-info');
        if (pageMetadata) markOffsetTop -= pageMetadata.offsetTop - pageMetadata.offsetHeight;
    }
    return markOffsetTop;
};
const $a78c261c3211f7d6$export$4147ba71ff179432 = (useNewHighlightLogic)=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    const selection = window.getSelection();
    if (!selection || selection.type !== 'Range') // Throw error?
    return;
    // Extract the range
    const selectedRange = selection.getRangeAt(0);
    // Get an array of the ranges to make highlights
    const rangesToHighlight = useNewHighlightLogic ? $a78c261c3211f7d6$var$extractTextNodesIntoRanges(selectedRange) : $a78c261c3211f7d6$var$extractTextNodesIntoRangesOld(selectedRange);
    rangesToHighlight.forEach((range)=>{
        // Create a new wrapper element with the correct class
        const highlightWrapper = document.createElement('span');
        highlightWrapper.classList.add(highlightClass);
        // Extract the contents of the range and add it to the new wrapper
        highlightWrapper.appendChild(range.extractContents());
        // Re-insert the wrapper back into the range
        range.insertNode(highlightWrapper);
    });
    // Clear the selection
    selection.removeAllRanges();
};
const $a78c261c3211f7d6$var$unwrapTextNodes = (wrappedNodes)=>{
    while(wrappedNodes.length){
        const node = wrappedNodes.shift();
        if (!node) return;
        const { parentNode: parentNode } = node;
        // Extract the text contents of the selection node out of the temp wrapper
        while(node.firstChild)parentNode?.insertBefore(node.firstChild, node);
        // After the text has been extracted, delete the wrapper
        parentNode?.removeChild(node);
        // Normalize the parent to fix any text node fragmentation
        parentNode?.normalize();
    }
};
const $a78c261c3211f7d6$export$743373b19993e2b0 = ()=>{
    const highlightClass = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
    // Grab all the newly created selection nodes
    const tempSelectionNodes = Array.from(document.querySelectorAll(`.${highlightClass}`));
    $a78c261c3211f7d6$var$unwrapTextNodes(tempSelectionNodes);
};
const $a78c261c3211f7d6$export$a160a5110cbadcb8 = (isFabricPage, markerRef, isActive = true)=>{
    const createCommentSelectionNodes = document.querySelectorAll(`.${$a78c261c3211f7d6$export$d2bdbdaa2c26e7f7}`);
    const ref = markerRef || '';
    // If we find selection nodes in the DOM, we need to add some attributes to them,
    // based on the page type, so they behave correctly when the user clicks a highlight
    if (createCommentSelectionNodes.length) createCommentSelectionNodes.forEach((selectionNode)=>{
        if (isFabricPage) {
            selectionNode.setAttribute($a78c261c3211f7d6$export$98471574bfa5228e, ref);
            selectionNode.setAttribute('data-mark-annotation-type', 'inlineComment');
        } else {
            selectionNode.setAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832, ref);
            selectionNode.classList.add('inline-comment-marker');
        }
        const classesToAdd = [
            $a78c261c3211f7d6$export$b803c692fbaaa5a4
        ];
        if (isActive) classesToAdd.push($a78c261c3211f7d6$export$fb3d0eebfe85522a);
        // Add the classes needed
        selectionNode.classList.add(...classesToAdd);
        // Finally, remove the selection class to make it a full mark
        selectionNode.classList.remove($a78c261c3211f7d6$export$d2bdbdaa2c26e7f7);
    });
};
const $a78c261c3211f7d6$var$setHighlightsAsActive = (highlightElement, skipClassCheck = false)=>{
    if (skipClassCheck || highlightElement.classList.contains($a78c261c3211f7d6$export$b803c692fbaaa5a4)) highlightElement.classList.add($a78c261c3211f7d6$export$fb3d0eebfe85522a);
    // We need to set all the children of this highlight to active as well
    const { children: children } = highlightElement;
    for(let i = 0; i < children.length; ++i)$a78c261c3211f7d6$var$setHighlightsAsActive(children[i], skipClassCheck);
};
const $a78c261c3211f7d6$export$fd55463aeed84830 = (markerRef, skipClassCheck = false)=>{
    const highlightMarks = $a78c261c3211f7d6$export$6dfccc77fe608546(markerRef) || [];
    highlightMarks.forEach((highlight)=>$a78c261c3211f7d6$var$setHighlightsAsActive(highlight, skipClassCheck));
};
const $a78c261c3211f7d6$export$280edc47a64130be = (markerRef)=>{
    const highlight = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef || '');
    return Boolean(highlight && highlight.classList.contains($a78c261c3211f7d6$export$fb3d0eebfe85522a));
};
const $a78c261c3211f7d6$export$a26c4eafef12029f = (markerRef)=>{
    const highlightMarksToRemove = Array.from($a78c261c3211f7d6$export$6dfccc77fe608546(markerRef));
    $a78c261c3211f7d6$var$unwrapTextNodes(highlightMarksToRemove);
    $a78c261c3211f7d6$export$f7ceeb7ba8156450();
};
const $a78c261c3211f7d6$export$a0939f064b367798 = ()=>{
    const highlightedAnnotations = Array.from(document.querySelectorAll('.ak-editor-annotation-blur, .ak-editor-annotation-focus'));
    const highlightedAnnotationIds = highlightedAnnotations.map((annotation)=>annotation?.closest('.annotationView-content-wrap')?.id).filter((id)=>Boolean(id));
    return new Set(highlightedAnnotationIds);
};
const $a78c261c3211f7d6$export$98471574bfa5228e = 'data-id';
const $a78c261c3211f7d6$export$90ee95b6cd79c832 = 'data-ref';
const $a78c261c3211f7d6$var$hasAdfContent = (input)=>{
    const content = input && input.content;
    return content && content.some($a78c261c3211f7d6$var$validateContent);
};
// Check to make sure if we have item.type as paragraph content is not empty (user did not type anything)
// or user has put in blank spaces(empty string) and clicked save
// Any type other than paragraph is valid (e.g:- when user inserts divider, status etc without content)
const $a78c261c3211f7d6$var$validateContent = (item)=>item.type !== 'paragraph' || $a78c261c3211f7d6$var$validateParagraph(item);
const $a78c261c3211f7d6$var$validateParagraph = (item)=>{
    if (item.content) return item.content.some($a78c261c3211f7d6$var$isParagraphNotEmpty);
    return false;
};
const $a78c261c3211f7d6$var$isParagraphNotEmpty = (item)=>item.type !== 'text' || item.text.trim() !== '';
const $a78c261c3211f7d6$export$915f03d46d87bfd4 = (adf)=>!adf || !$a78c261c3211f7d6$var$hasAdfContent(adf);
const $a78c261c3211f7d6$export$d204c0ea9b3f0d7d = (isFabricPage)=>isFabricPage ? $a78c261c3211f7d6$export$98471574bfa5228e : $a78c261c3211f7d6$export$90ee95b6cd79c832;
const $a78c261c3211f7d6$export$8f4213b45c05ab5d = (element)=>{
    let markerRef = null;
    if (element) {
        markerRef = element.getAttribute($a78c261c3211f7d6$export$98471574bfa5228e);
        if (!markerRef) markerRef = element.getAttribute($a78c261c3211f7d6$export$90ee95b6cd79c832);
    }
    return markerRef;
};
const $a78c261c3211f7d6$export$21445ab787d3b446 = (markerRef, additionalQueryScope = '')=>{
    if (!markerRef) return null;
    // We need to allow for additional query scope to be added to specify particular markerRef comments
    return document.querySelector(`${additionalQueryScope} [${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], ${additionalQueryScope} [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6dfccc77fe608546 = (markerRef)=>{
    return document.querySelectorAll(`[${$a78c261c3211f7d6$export$98471574bfa5228e}="${markerRef}"], [${$a78c261c3211f7d6$export$90ee95b6cd79c832}="${markerRef}"]`);
};
const $a78c261c3211f7d6$export$6d23af9d8c2844b1 = [
    'enter',
    'escape'
];
const $a78c261c3211f7d6$var$getDimensions = ()=>{
    try {
        const nav4ScrollParent = document.getElementById('AkMainContent');
        const currentPageOffset = !!nav4ScrollParent ? nav4ScrollParent.scrollTop : window.scrollY || (window.top?.scrollY ?? 0);
        return {
            currentWindowHeight: window.innerHeight || (window.top?.innerHeight ?? 0),
            currentPageOffset: currentPageOffset
        };
    } catch  {
        // Catch cross origin iframe error https://hello.atlassian.net/browse/CBT-907
        return {
            currentWindowHeight: 0,
            currentPageOffset: 0
        };
    }
};
const $a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET = 350;
const $a78c261c3211f7d6$export$858fd2398afb28e4 = (commentElement, useInstantScroll = false, isAbove = false)=>{
    if (!commentElement) return;
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = $a78c261c3211f7d6$var$getDimensions();
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    // If the position of the comment box is more than halfway down the screen, reposition it to the center
    if (offset <= currentPageOffset || offset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = currentWindowHeight / 5;
        window.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$b451b837f5309ae9 = ({ commentId: commentId, targetCommentId: targetCommentId, isEditor: isEditor, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (commentId !== targetCommentId) return;
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (isEditor && commentElement) (0, $i49vP.scrollToElementInEditor)({
        targetElement: commentElement,
        viewingRoomOffset: viewingRoomOffset
    });
    else $a78c261c3211f7d6$export$fc9b5eebad60b835({
        element: commentElement,
        viewingRoomOffset: viewingRoomOffset,
        useInstantScroll: useInstantScroll
    });
};
const $a78c261c3211f7d6$export$e5d4e097ce63febc = ({ commentElement: commentElement, scrollRootElement: scrollRootElement, currentPageOffset: currentPageOffset, currentWindowHeight: currentWindowHeight, isAbove: isAbove, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll })=>{
    if (!commentElement) return;
    // We may be in an iframe so use window.top
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
    const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
    // If the position of the highlight is more than halfway down the screen, reposition it to the center
    if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
        const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
        scrollRootElement.scrollTo({
            top: offset - windowOffset,
            behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
        });
    }
};
const $a78c261c3211f7d6$export$82eb6662255613e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadContainerId: commentThreadContainerId, isCommentsPanel: isCommentsPanel })=>{
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    const behavior = useInstantScroll ? 'instant' : 'smooth';
    if (isCommentsPanel) {
        const element = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
        const commentThreadParentElement = element.getBoundingClientRect().top;
        const commentThreadSelector = document.querySelector(`[data-testid='comments-panel-list-container']`);
        const inlineCommentPosition = element?.getBoundingClientRect();
        const documentContent = document.getElementById('content');
        const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
        const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && Math.floor(inlineCommentPosition.top) < Math.floor(documentContentTopPosition);
        const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        /**
     * Determine which panel or section needs to be scrolled:
     * the content area or the comments panel.
     * We need to find out if the highlight or panel is above or below the viewport.
     * This will help us decide which one to scroll.
     */ if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) // if the comment highlight is above or below viewport use content area to scroll;
        scrollRootElement.scrollBy({
            top: window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top),
            behavior: behavior
        });
        else if (commentThreadSelector && (commentAboveViewport || commentBelowViewport || window.innerHeight - commentThreadParentElement - (window.innerHeight - targetCommentHighlight.top) < 0)) // if the comment thread is above or below viewport or
        // there is difference in top of comment thread and highlight if completely visible in the viewport
        //  use commentThreadSelector as an element to scroll ;
        commentThreadSelector.scrollBy({
            top: window.innerHeight - targetCommentHighlight.top - (window.innerHeight - commentThreadParentElement),
            behavior: behavior
        });
        else scrollRootElement.scrollBy({
            top: targetCommentHighlight.top - commentThreadParentElement,
            behavior: behavior
        });
    } else {
        // We may be in an iframe so use window.top
        const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement) + commentElement.offsetHeight + (isAbove ? -$a78c261c3211f7d6$var$COMMENT_CONTAINER_OFFSET : 0);
        const rendererOffset = document.querySelector('#content .ak-renderer-wrapper')?.offsetTop || 0;
        // If the position of the highlight is more than halfway down the screen, reposition it to the center
        if (offset + rendererOffset <= currentPageOffset || offset + rendererOffset > currentPageOffset + currentWindowHeight * (2 / 3)) {
            const windowOffset = isFabricPage ? currentWindowHeight / 5 : currentWindowHeight / 3;
            scrollRootElement.scrollTo({
                top: offset - windowOffset,
                behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
            });
        }
    //If comment is in expand, open respective expand
    }
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$c7436bd0a15f3e7e = ({ commentElement: commentElement, isFabricPage: isFabricPage, useInstantScroll: useInstantScroll = false, isAbove: isAbove = false, commentThreadAnnotationId: commentThreadAnnotationId, isCommentsPanel: isCommentsPanel })=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        const commentThreadContainerId = `comment-thread-${commentThreadAnnotationId}-container`;
        $a78c261c3211f7d6$export$82eb6662255613e({
            commentElement: commentElement,
            isFabricPage: isFabricPage,
            useInstantScroll: useInstantScroll,
            isAbove: isAbove,
            commentThreadContainerId: commentThreadContainerId,
            isCommentsPanel: isCommentsPanel
        });
        return;
    }
    if (!commentElement) return;
    const nodeToConsider = $a78c261c3211f7d6$export$ee0755cb593feed6(commentElement) || commentElement;
    const targetCommentHighlight = nodeToConsider.getBoundingClientRect();
    const { scrollRootElement: scrollRootElement, getDimensions: getDimensionsFromScrollRootContext } = $a78c261c3211f7d6$var$getScrollRootContext();
    const { currentWindowHeight: currentWindowHeight, currentPageOffset: currentPageOffset } = getDimensionsFromScrollRootContext();
    if (isCommentsPanel) {
        const commentHighlightAboveViewPort = Math.floor(targetCommentHighlight.bottom) < currentPageOffset;
        const commentHighlightBelowViewPort = targetCommentHighlight.top + 200 > window.innerHeight;
        // Scroll the highlight into view in the main content body
        if (commentHighlightAboveViewPort || commentHighlightBelowViewPort) $a78c261c3211f7d6$export$e5d4e097ce63febc({
            commentElement: commentElement,
            scrollRootElement: scrollRootElement,
            currentPageOffset: currentPageOffset,
            currentWindowHeight: currentWindowHeight,
            isAbove: isAbove,
            isFabricPage: !!isFabricPage,
            useInstantScroll: useInstantScroll
        });
    } else $a78c261c3211f7d6$export$e5d4e097ce63febc({
        commentElement: commentElement,
        scrollRootElement: scrollRootElement,
        currentPageOffset: currentPageOffset,
        currentWindowHeight: currentWindowHeight,
        isAbove: isAbove,
        isFabricPage: !!isFabricPage,
        useInstantScroll: useInstantScroll
    });
    //If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$export$66b4d1e3b6633573 = (target, scrollContainer)=>{
    const rect = target.getBoundingClientRect();
    const parentRect = scrollContainer.getBoundingClientRect();
    let moveY = 0;
    // The distance (in pixels) between the target and the end of the visible viewport at which point,
    // when scrolling the target into view, scrolling takes place.
    const SCROLL_THRESHOLD = 60;
    // The extra space (in pixels) that is left above or below the target when it is scrolled into view.
    const SCROLL_MARGIN = 120;
    // Note: visible area of the container refers to parentRect.top/bottom +/- SCROLL_THRESHOLD
    if (rect.top < parentRect.top + SCROLL_THRESHOLD) // If the target is above the top of the visible area of the container, moveY should be negative to bring target down into view
    moveY = -(parentRect.top - rect.top + SCROLL_MARGIN);
    else if (rect.bottom > parentRect.bottom - SCROLL_THRESHOLD) // If the target's bottom is below the bottom of the visible area of the container, move Y should be positive to bring target up into view
    moveY = rect.bottom - parentRect.bottom + SCROLL_MARGIN;
    if (moveY) scrollContainer.scrollTop += moveY;
};
const $a78c261c3211f7d6$export$fb40c5e75b82df8 = (isEditor, isViewCommentMode)=>{
    if (isEditor && isViewCommentMode) return 'editor-comments-sidebar';
    else if (isEditor && !isViewCommentMode) return 'editor-create-sidebar';
    else if (!isEditor && isViewCommentMode) return 'renderer-comments-sidebar';
    else return 'renderer-create-sidebar';
};
const $a78c261c3211f7d6$export$cfa8eefe354167cd = (element)=>{
    element.setAttribute('tabIndex', '-1');
    element.focus();
};
const $a78c261c3211f7d6$export$db9eae89818590a4 = (commentElement, previousCommentElement, isFabricPage, isEditor)=>{
    if (!commentElement) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    // if current open comment is out of viewport, we need to scroll so that the next comment is in viewport
    const sidebarId = $a78c261c3211f7d6$export$fb40c5e75b82df8(isEditor, true); // Hard-coding isViewCommentMode to true because navigation only exists in the view scenario
    const inlineCommentSidebar = document.getElementById(sidebarId);
    const inlineCommentPosition = inlineCommentSidebar?.getBoundingClientRect();
    const documentContent = document.getElementById('content');
    const documentContentTopPosition = documentContent?.getBoundingClientRect().top;
    const commentAboveViewport = inlineCommentPosition && documentContentTopPosition && inlineCommentPosition.top < documentContentTopPosition + scrollRootOffset;
    const commentBelowViewport = inlineCommentPosition && inlineCommentPosition.top + 200 > window.innerHeight;
    if (commentAboveViewport || commentBelowViewport) {
        $a78c261c3211f7d6$export$c7436bd0a15f3e7e({
            commentElement: commentElement,
            isFabricPage: isFabricPage
        });
        return;
    }
    const previousOffset = previousCommentElement ? $a78c261c3211f7d6$export$331805bfbe18b1c0(previousCommentElement) : 0;
    const offset = $a78c261c3211f7d6$export$331805bfbe18b1c0(commentElement);
    const differenceOffset = offset - previousOffset;
    scrollRootElement.scrollBy({
        top: differenceOffset,
        behavior: 'smooth' // navigation uses a smooth scroll
    });
    // If comment is in expand, open respective expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(commentElement, isFabricPage);
};
const $a78c261c3211f7d6$var$adjustNodeForStickyHeader = (stickyHeaderElement)=>{
    let adjustedElement = stickyHeaderElement;
    const markerRef = $a78c261c3211f7d6$export$8f4213b45c05ab5d(adjustedElement);
    // If this is exists it's a commited comment, look for its counterpart in the real table
    // TODO: Support new highlights when we allow it
    if (markerRef) // WS-2618 We have old macros that render tiny inline comments so we need to look for both fabric and tiny marker refs
    adjustedElement = $a78c261c3211f7d6$export$21445ab787d3b446(markerRef, '.pm-table-wrapper');
    return adjustedElement;
};
const $a78c261c3211f7d6$export$ee0755cb593feed6 = (element)=>{
    let nodeToReturn = element;
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToReturn && nodeToReturn.closest && nodeToReturn.closest('.pm-table-sticky-wrapper')) nodeToReturn = $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToReturn);
    if (nodeToReturn) {
        // WS-2718 - If a comment is in an extension macro
        const extensionParent = nodeToReturn.closest('.ak-renderer-extension');
        if (extensionParent) nodeToReturn = extensionParent;
    }
    return nodeToReturn;
};
const $a78c261c3211f7d6$export$331805bfbe18b1c0 = (element, relativeToElement, isRendererAnnotationProviderEnabled)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    // new sticky header implementation
    if ((0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false)) {
        if (relativeToElement && nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('tr.pm-table-row-native-sticky-active')) {
            const elementRect = nodeToMeasure.getBoundingClientRect();
            const containerRect = relativeToElement.getBoundingClientRect();
            return elementRect.top - containerRect.top;
        }
    }
    // Sticky table headers duplicate the elements in the DOM so we need to check if this is the real one or not
    // If the highlight has a parent with the class .pm-table-sticky-wrapper it is the fake one
    if (nodeToMeasure && nodeToMeasure.closest && nodeToMeasure.closest('.pm-table-sticky-wrapper')) // The RAP annotation draft mark is applied to the both pm-table-sticky-wrapper as well as the pm-table-wrapper.
    // Need to check only pm-table-wrapper annotation draft mark for the RAP enabled
    nodeToMeasure = isRendererAnnotationProviderEnabled ? document.querySelector(`.pm-table-wrapper [data-annotation-draft-mark="true"]`) : $a78c261c3211f7d6$var$adjustNodeForStickyHeader(nodeToMeasure);
    // Iterate through the offset parents until we are back to the ak-renderer-wrapper to get the
    // proper offset Fabric Pages wrap the content in a .ak-renderer-wrapper element, but Tiny
    // pages do not have anything like that, but will return null when we get to <body>
    while(nodeToMeasure && !nodeToMeasure.classList.contains('ak-renderer-wrapper') && nodeToMeasure !== relativeToElement){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    // WS-2718 - If a comment is in an extension macro, we need to add its container offset as well
    if (nodeToMeasure) {
        const extensionParent = nodeToMeasure.closest('.ak-renderer-extension');
        if (extensionParent) elementOffsetTop += extensionParent.offsetTop;
    }
    return elementOffsetTop;
};
const $a78c261c3211f7d6$export$d0d02dc9adb82d62 = (element, isFabricPage)=>{
    //get the child of element passed in
    const expandElement = element?.hasChildNodes() ? element?.firstChild : element;
    //check if element is expand button and return element if so
    if (isFabricPage) {
        if (expandElement?.tagName?.toLowerCase() === 'button') return expandElement;
    } else if (expandElement?.classList?.contains('expand-control')) return expandElement?.firstChild; //it's one child down for tiny pages
    return null;
};
const $a78c261c3211f7d6$export$1a2319f5c2109ee1 = (element, options)=>{
    const { expandSelectors: expandSelectors, getExpandButton: getExpandButton, isExpanded: isExpanded, onExpand: onExpand } = options;
    const nodeToCheck = element;
    // Check if comment is in any expand
    const isInExpand = expandSelectors.some((selector)=>nodeToCheck?.closest?.(selector));
    if (!isInExpand) return;
    // Find all expand buttons that need to be opened, starting from the innermost
    const expandButtonsToOpen = [];
    let currentNode = nodeToCheck;
    while(currentNode){
        // Check if current node has an expand button
        const expandButton = getExpandButton(currentNode);
        if (expandButton) // Check if this expand is already opened
        {
            if (!isExpanded(expandButton)) expandButtonsToOpen.push(expandButton);
        }
        currentNode = currentNode?.parentElement;
    }
    // Open all expand buttons from innermost to outermost
    const buttonsToClick = [
        ...expandButtonsToOpen
    ].reverse();
    buttonsToClick.forEach((expandButton)=>{
        if (onExpand) onExpand(expandButton);
        expandButton.click();
    });
};
const $a78c261c3211f7d6$export$d2685a53bf6957f4 = (element, isFabricPage)=>{
    const expandElementClassname = isFabricPage ? '.expand-content-wrapper' : '.expand-content';
    const nestedExpandElementClassname = '.nestedExpand-content-wrapper';
    const expandSelectors = [
        expandElementClassname,
        nestedExpandElementClassname
    ];
    const getExpandButton = (node)=>$a78c261c3211f7d6$export$d0d02dc9adb82d62(node, isFabricPage);
    const isExpanded = (button)=>{
        return isFabricPage ? button.getAttribute('aria-expanded') === 'true' : button.className.includes('expanded');
    };
    $a78c261c3211f7d6$export$1a2319f5c2109ee1(element, {
        isFabricPage: isFabricPage,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded
    });
};
const $a78c261c3211f7d6$export$876171b9c9b54aab = (element, isFabricPage)=>{
    $a78c261c3211f7d6$export$d2685a53bf6957f4(element, isFabricPage);
};
const $a78c261c3211f7d6$export$187f977414e8342c = (action, index, markerRefList)=>{
    if (markerRefList.length === 0 || index === undefined || index === -1) return;
    let commentIndex = -1;
    //Navigate to first inline comment if we're on the last comment and the user clicks next,
    // or to the last comment if we're on the first comment and the user clicks previous
    if (action === 'next') commentIndex = index === markerRefList.length - 1 ? 0 : index + 1;
    else if (action === 'previous') commentIndex = index === 0 ? markerRefList.length - 1 : index - 1;
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$883ebc059dd86e88 = (index, markerRefList, unreadMarkerRefList)=>{
    if (index === undefined || markerRefList.length === 0 || index === -1 || !unreadMarkerRefList || unreadMarkerRefList.length === 0) return;
    let commentIndex = index % markerRefList.length; // Handle case where index is beyond array length
    const refListLength = markerRefList.length;
    let iterations = 0;
    while(markerRefList[commentIndex] !== undefined && !unreadMarkerRefList.includes(markerRefList[commentIndex]) && iterations < refListLength){
        commentIndex = (commentIndex + 1) % markerRefList.length;
        iterations++;
    }
    return markerRefList[commentIndex];
};
const $a78c261c3211f7d6$export$b401b3c3a0774fd7 = ()=>navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $a78c261c3211f7d6$export$bec1a1359bf081c5 = ()=>window.clipboardData && typeof window.clipboardData.setData === 'function';
const $a78c261c3211f7d6$export$dcc703cd1f894b4c = (textToCopy)=>new Promise((resolve, reject)=>{
        if ($a78c261c3211f7d6$export$bec1a1359bf081c5()) {
            window.clipboardData.setData('text', textToCopy);
            resolve();
        } else reject('IE clipboard api is not supported');
    });
const $a78c261c3211f7d6$export$2cdf1b96a9f86d16 = async (text)=>{
    if ($a78c261c3211f7d6$export$b401b3c3a0774fd7()) await navigator.clipboard.writeText(text);
};
const $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9 = (text, ref)=>new Promise((res, rej)=>{
        if (!ref) {
            rej();
            return;
        }
        const textarea = document.createElement('textarea');
        textarea.readOnly = true;
        textarea.defaultValue = text;
        ref.appendChild(textarea);
        textarea.select();
        const wasCopied = document.execCommand('copy');
        ref.removeChild(textarea);
        wasCopied ? res() : rej();
    });
const $a78c261c3211f7d6$export$ab567600730c0b3b = (annotationElement, scrollParentSelector)=>{
    const scrollParent = document.querySelector(scrollParentSelector);
    return $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement, scrollParent);
};
const $a78c261c3211f7d6$export$3cdeee3ea1732782 = (annotationElement, scrollParentSelector, isView)=>{
    let offset = 0;
    if (annotationElement) {
        // If the annotation is the wrapperDOM, we actually need #content to be the scrollParent
        const scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
        if (scrollParent) {
            let annotationOffset;
            if (isView) annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(annotationElement);
            else {
                // If the annotation is the wrapperDOM, we need to find the actual highlight instead
                const actualHiglightElement = scrollParent.querySelector(scrollParentSelector);
                annotationOffset = $a78c261c3211f7d6$export$331805bfbe18b1c0(actualHiglightElement, undefined, true);
            }
            offset = annotationOffset + scrollParent.offsetTop;
        }
    }
    return offset;
};
const $a78c261c3211f7d6$export$9f8164812b21bc7a = (entries)=>{
    const windowHeight = window.innerHeight;
    if ((0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true) || (0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
        if (!(0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_space_ld')) {
            // When fg is ON, we would have verified that there's no
            // endOfPageRecommendations before adding this ResizeObserver.
            // So no need to check it here.
            const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
            if (endOfPageRecommendations) return 0;
        }
        const editorTextArea = document.getElementById('ak-editor-textarea');
        const editorBottom = editorTextArea?.getBoundingClientRect().bottom;
        if (editorBottom && windowHeight) {
            // The minimum spacing between bottom of editor content and top of footer is 120px
            const minimumSpacing = 120;
            // - There's an existing fixed 24px margin below editor content.
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px to make it visually distinct
            //   when a short LiveDoc has some vs zero existing footer comment.
            const editorBottomMargin = 24;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            const editorScrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
            const currentScroll = editorScrollParent?.scrollTop ?? 0;
            const editorBottomUnscrolled = editorBottom + currentScroll;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - editorBottomUnscrolled;
            return Math.max(verticalDistanceFromWindowBottomUnscrolled - editorBottomMargin - addFooterCommentHeight - extraFooterCommentHeightToShow, minimumSpacing);
        }
    } else {
        // The calculation is
        // 15px of marginTop on the comment container
        // 2px full-page-editor-style bottom which above the viewport
        // 1px border which is cumulates to 120px
        const thresholdTop = 102;
        const editorEntry = entries.find((entry)=>entry.target.id === 'ak-editor-textarea');
        const editorBottom = editorEntry?.target.getBoundingClientRect().bottom;
        const editorContentHeight = document.querySelector(`.ak-editor-content-area .ProseMirror`)?.getBoundingClientRect().height;
        const documentContentBottom = document.querySelector(`[data-testid='full-page-editor-style']`)?.getBoundingClientRect().bottom;
        if (editorContentHeight) {
            // If the document content is larger than the window height, just set it to a static 120 to keep the proper spacing
            if (editorContentHeight > windowHeight) return 120;
            if (documentContentBottom && editorBottom) {
                const verticalDistance = documentContentBottom - editorBottom;
                if (verticalDistance >= thresholdTop && editorContentHeight <= windowHeight) return verticalDistance - thresholdTop;
                else if (verticalDistance <= thresholdTop) return thresholdTop;
            }
        }
    }
};
const $a78c261c3211f7d6$export$e3a17b46d43aa5f6 = ()=>{
    // This is deprecated, and will be replaced by a new approach that works in SSR.
    let newTop = 0;
    const endOfPageRecommendations = document.querySelector('.end-of-page-rec-wrapper');
    const legacyLabels = document.querySelector('[data-vc="view-page-labels-container"]');
    // no extra spacing if the page shows end-of-page recommendations or legacy labels
    if (!endOfPageRecommendations && !legacyLabels) {
        const rendererContent = document.getElementById('main-content');
        const rendererContentBottom = rendererContent?.getBoundingClientRect()?.bottom ?? 0;
        if (rendererContentBottom) {
            // - There's an existing fixed 80px margin below Page content (See
            //   next/packages/view-page-common/src/ViewPageContent.tsx).
            // - ObjectAddCommentContainer.tsx has a 64px height.
            // - We lift footer comment top by 14px (matching Editor version ^)
            //   to make it visually distinct when a short Page has some vs zero
            //   existing footer comment.
            const contentBottomMargin = 80;
            const addFooterCommentHeight = 64;
            const extraFooterCommentHeightToShow = 14;
            // Find the current scroll offset on the Page.
            // This is similar to implementation in getDimensionsForNav4(),
            // but when the window is very narrow, nav4ScrollParent.scrollTop
            // can be 0 (nav4ScrollParent element itself exists on page) while
            // window.scrollY is positive.
            // So this is a more robust implementation. Will explore whether
            // getDimensionsForNav4() can be updated to use this implementation
            // in a separate PR.
            const nav4ScrollParent = document.getElementById('AkMainContent');
            const currentPageOffset = (nav4ScrollParent?.scrollTop ?? 0) + (window.scrollY ?? window.top?.scrollY ?? 0);
            const rendererContentBottomUnscrolled = rendererContentBottom + currentPageOffset;
            const windowHeight = window.innerHeight;
            const verticalDistanceFromWindowBottomUnscrolled = windowHeight - rendererContentBottomUnscrolled - contentBottomMargin;
            newTop = Math.max(verticalDistanceFromWindowBottomUnscrolled - addFooterCommentHeight - extraFooterCommentHeightToShow, 0);
        }
    }
    return newTop;
};
const $a78c261c3211f7d6$export$fc9b5eebad60b835 = ({ element: element, viewingRoomOffset: viewingRoomOffset = -150, useInstantScroll: useInstantScroll = false })=>{
    if (!element) return;
    const { scrollRootElement: scrollRootElement, scrollRootOffset: scrollRootOffset } = $a78c261c3211f7d6$var$getScrollRootContext();
    const elementRect = element.getBoundingClientRect();
    const elementTopViewport = elementRect.top;
    const scrollRootTopViewport = scrollRootElement instanceof Window ? 0 // Window doesn't have a bounding rect; its top is always 0
     : scrollRootElement.getBoundingClientRect().top;
    const elementTopFromScrollRoot = elementTopViewport - scrollRootTopViewport;
    const targetScrollPosition = elementTopFromScrollRoot + scrollRootOffset + viewingRoomOffset;
    scrollRootElement.scrollTo({
        top: targetScrollPosition,
        behavior: useInstantScroll ? 'instant' : 'smooth' // focused comments use an instant scroll
    });
    // open expand if the element is inside an expand
    $a78c261c3211f7d6$export$876171b9c9b54aab(element, true);
};
const $a78c261c3211f7d6$export$b3ba907d5759e257 = (commentId)=>{
    let isDisconnected = false;
    let commentFound = false;
    // Find the most specific container to observe
    const commentsPanelListContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const targetContainer = commentsPanelListContainer || document.body;
    const observer = new MutationObserver(()=>{
        if (isDisconnected || commentFound) return;
        // Look for the comment element directly
        const commentElement = targetContainer.querySelector(`[data-comment-id="${commentId}"]`);
        if (commentElement) {
            commentFound = true;
            commentElement.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
            isDisconnected = true;
            observer.disconnect();
        }
    });
    // Start observing only the specific container
    observer.observe(targetContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: [
            'data-comment-id'
        ]
    });
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
        }
    };
};
const $a78c261c3211f7d6$export$b1b7c9bcc75c855d = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId })=>{
    if ((0, $6mKj3.expValEquals)('confluence_comments_use_new_observer', 'isEnabled', true)) return $a78c261c3211f7d6$export$4d09fb2a10e54800({
        targetCommentId: targetCommentId,
        onScrollReady: onScrollReady,
        onFallback: onFallback,
        timeoutMs: timeoutMs,
        markElement: markElement,
        containerId: containerId
    });
    let commentFound = false;
    let isDisconnected = false;
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                for (const addedNode of Array.from(mutation.addedNodes))if (addedNode.nodeType === Node.ELEMENT_NODE) {
                    const element = addedNode;
                    // Check if this element or any of its descendants has the specific data-comment-id
                    const containerElement = containerId ? document.getElementById(containerId) : null;
                    const commentElement = containerElement || element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
                    if (commentElement) {
                        commentFound = true;
                        // Early return if the comment is in the container element
                        if (containerElement) {
                            onScrollReady(containerElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        }
                        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                        // Check the initial state of the show more button
                        const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
                        if (!showMoreButton) {
                            onScrollReady(commentElement);
                            isDisconnected = true;
                            observer.disconnect();
                            return;
                        } else // Trigger click on the show more button to expand all replies
                        showMoreButton.click();
                        break;
                    }
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
            const showMoreButton = document.querySelector('[data-testid="show-hidden-replies"]');
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = document.querySelector(`[data-comment-id="${targetCommentId}"]`);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Find the comment element by ID or data-comment-id attribute
 */ const $a78c261c3211f7d6$var$findCommentElement = (targetCommentId, containerId, isFooterCommentInPanel)=>{
    // If isFooterCommentInPanel is true, use comment-thread-${targetCommentId}-container
    if (isFooterCommentInPanel) {
        const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
        if (panelContainer) return panelContainer;
    }
    // Try container element first if containerId is provided
    if (containerId) {
        const container = document.getElementById(containerId);
        if (container) return container;
    }
    // Fall back to finding by data-comment-id
    return document.querySelector(`[data-comment-id="${targetCommentId}"]`);
};
const $a78c261c3211f7d6$export$5eaef9e6a0975768 = (commentElement, targetCommentId)=>{
    if (!commentElement) return null;
    // 1. Check within commentElement (descendants)
    const buttonInComment = commentElement.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInComment) return buttonInComment;
    // 2. Check in parent element (siblings)
    const parentElement = commentElement.parentElement;
    const buttonInParent = parentElement?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInParent) return buttonInParent;
    // 3. Check in replies container (specific to this comment thread)
    const repliesContainer = document.querySelector(`[data-testid="comment-thread-${targetCommentId}-replies"]`);
    const buttonInReplies = repliesContainer?.querySelector('[data-testid="show-hidden-replies"]');
    if (buttonInReplies) return buttonInReplies;
    return null;
};
/**
 * Handle the comment element being found
 * Checks for show more button and either scrolls immediately or clicks to expand
 */ const $a78c261c3211f7d6$var$handleCommentFound = (commentElement, targetCommentId, containerId, markElement, onScrollReady)=>{
    // If container element exists and we're using it, scroll immediately
    if (containerId && commentElement.id === containerId) {
        markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    }
    // Expand mark element if needed
    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
    // Check for show more button
    const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
    if (!showMoreButton) {
        // No show more button, scroll immediately
        onScrollReady(commentElement);
        return true; // Indicates we should disconnect
    } else {
        // Show more button exists, click it to expand replies
        showMoreButton.click();
        return false; // Keep watching for button to disappear
    }
};
/**
 * Check if comment element exists in newly added nodes
 */ const $a78c261c3211f7d6$var$checkAddedNodes = (addedNodes, targetCommentId, containerId, isFooterCommentInPanel, onCommentFound)=>{
    for (const addedNode of Array.from(addedNodes)){
        if (addedNode.nodeType !== Node.ELEMENT_NODE) continue;
        const element = addedNode;
        // Check if this element or its descendants contains the comment
        let commentElement = null;
        // First check for container element
        if (containerId) {
            const container = document.getElementById(containerId);
            if (container) commentElement = container;
        }
        // If not found, check for comment by data-comment-id
        if (!commentElement) commentElement = element.querySelector?.(`[data-comment-id="${targetCommentId}"]`) || (element.matches?.(`[data-comment-id="${targetCommentId}"]`) ? element : null);
        // If isFooterCommentInPanel, also check for panel container
        if (!commentElement && isFooterCommentInPanel) {
            const panelContainer = document.getElementById(`comment-thread-${targetCommentId}-container`);
            if (panelContainer) commentElement = panelContainer;
        }
        if (commentElement) {
            const shouldDisconnect = onCommentFound(commentElement);
            if (shouldDisconnect) return true; // Indicates we should stop processing
        }
    }
    return false;
};
const $a78c261c3211f7d6$export$4d09fb2a10e54800 = ({ targetCommentId: targetCommentId, onScrollReady: onScrollReady, onFallback: onFallback, timeoutMs: timeoutMs = 10000, markElement: markElement, containerId: containerId, isFooterCommentInPanel: isFooterCommentInPanel = false })=>{
    let commentFound = false;
    let isDisconnected = false;
    const handleCommentFoundWrapper = (commentElement)=>{
        commentFound = true;
        return $a78c261c3211f7d6$var$handleCommentFound(commentElement, targetCommentId, containerId, markElement, onScrollReady);
    };
    const observer = new MutationObserver((mutations)=>{
        if (isDisconnected) return;
        // First, look for the comment element if we haven't found it yet
        if (!commentFound) {
            for (const mutation of mutations)if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                const shouldStop = $a78c261c3211f7d6$var$checkAddedNodes(mutation.addedNodes, targetCommentId, containerId, isFooterCommentInPanel, handleCommentFoundWrapper);
                if (shouldStop) {
                    isDisconnected = true;
                    observer.disconnect();
                    return;
                }
            }
        }
        // If comment is found, watch for the show more button to disappear
        if (commentFound) {
            const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
            const showMoreButton = $a78c261c3211f7d6$export$5eaef9e6a0975768(commentElement, targetCommentId);
            // If comment exists and show more button is gone, we're ready to scroll
            if (commentElement && !showMoreButton) {
                markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                onScrollReady(commentElement);
                isDisconnected = true;
                observer.disconnect();
                return;
            }
        }
    });
    // Start observing
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    // Clean up observer after specified timeout to prevent memory leaks
    const timeoutId = setTimeout(()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            // Fallback behavior if comment was found but button never disappeared
            if (commentFound) {
                const commentElement = $a78c261c3211f7d6$var$findCommentElement(targetCommentId, containerId, isFooterCommentInPanel);
                if (commentElement) {
                    // Check and open expand sections if needed before scrolling
                    markElement && $a78c261c3211f7d6$export$876171b9c9b54aab(markElement, true);
                    onScrollReady(commentElement);
                }
            } else if (onFallback) onFallback();
        }
    }, timeoutMs);
    // Return cleanup function
    return ()=>{
        if (!isDisconnected) {
            observer.disconnect();
            isDisconnected = true;
            clearTimeout(timeoutId);
        }
    };
};
/**
 * Returns the HTMLElement or window that should be used as the scroll root. By default,
 *  this is the div with id=AkMainContent, if the id exists in the DOM
 */ function $a78c261c3211f7d6$var$getScrollRootContext() {
    const nav4ScrollRootElement = document.getElementById('AkMainContent');
    const scrollRootElement = nav4ScrollRootElement || window;
    const scrollRootOffset = nav4ScrollRootElement ? nav4ScrollRootElement.scrollTop : window.scrollY;
    return {
        scrollRootElement: scrollRootElement,
        scrollRootOffset: scrollRootOffset,
        getDimensions: $a78c261c3211f7d6$var$getDimensions
    };
}
// Constants for comment thread visibility
const $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS = 8;
const $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW = 60;
const $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads = (generalCommentsHeaderHeight)=>{
    let objectSidebarPanelHeader = document.querySelector("[data-testid='object-sidebar-panel-header']");
    let additionalOffset = 0;
    if (!objectSidebarPanelHeader) {
        objectSidebarPanelHeader = document.querySelector("[data-testid='scrolled-object-sidebar-panel-header']");
        additionalOffset = $a78c261c3211f7d6$var$SCROLLED_COMMENTS_HEADER_GAP_SIZE_IN_PIXELS;
    }
    const objectSidebarPanelHeaderHeight = objectSidebarPanelHeader?.getBoundingClientRect().height ?? 0;
    const objectHeaderHeight = document.querySelector("[data-testid='object-header-container']")?.getBoundingClientRect().height ?? 0;
    const topNavContainerHeight = document.querySelector("[data-testid='grid-topNav']")?.getBoundingClientRect().height ?? 0;
    const bannerContainerHeight = document.querySelector("[data-testid='banner-container']")?.getBoundingClientRect().height ?? 0;
    const editorControlsOnboardingBannerHeight = document.querySelector("[data-testid='editor-controls-onboarding-banner']")?.getBoundingClientRect().height ?? 0;
    const announcementBannerHeight = document.querySelector("[id='AkBanner']")?.getBoundingClientRect().height ?? 0;
    return objectSidebarPanelHeaderHeight + objectHeaderHeight + topNavContainerHeight + bannerContainerHeight + additionalOffset + generalCommentsHeaderHeight + editorControlsOnboardingBannerHeight + announcementBannerHeight;
};
const $a78c261c3211f7d6$export$4d211f4974dcf196 = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const totalPaddingAboveCommentThreadView = $a78c261c3211f7d6$var$getTotalOffsetAboveCommentsPanelThreads(generalCommentsHeaderHeight);
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    const viewportTop = totalPaddingAboveCommentThreadView;
    const viewportBottom = window.innerHeight - objectSidebarPanelFooterHeight;
    const commentTopInView = commentThreadRect.top >= viewportTop;
    const commentBottomInView = commentThreadRect.bottom <= viewportBottom;
    if (commentTopInView && commentBottomInView) // Comment is 100% in view
    return false;
    else if (!commentTopInView && commentBottomInView) // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
    else if (commentTopInView && !commentBottomInView) {
        // Comment is <100% in view and the hidden part is the bottom of the comment
        const hiddenBottomHeight = commentThreadRect.bottom - viewportBottom;
        if (hiddenBottomHeight <= $a78c261c3211f7d6$var$NUM_HIDDEN_PIXELS_TO_BE_CONSIDERED_OUT_OF_VIEW) // The hidden part is <= 60 pixels
        return false;
        else // The hidden part is > 60 pixels
        return true;
    } else // Comment is <100% in view and the hidden part is the top part of the comment
    return true;
};
const $a78c261c3211f7d6$export$9c5b7a3c864ae31b = (commentThreadElement, commentType)=>{
    const commentThreadRect = commentThreadElement.getBoundingClientRect();
    const generalCommentsHeaderHeight = commentType === 'general' ? document.querySelector("[data-testid='comment-section-separator']")?.getBoundingClientRect().height ?? 0 : 0;
    const objectSidebarPanelFooter = document.querySelector("[data-testid='object-sidebar-panel-footer']");
    const objectSidebarPanelFooterHeight = objectSidebarPanelFooter?.getBoundingClientRect().height ?? 0;
    return(// Element is partially out of view below the comments panel viewport
    commentThreadRect.bottom + generalCommentsHeaderHeight > window.innerHeight - objectSidebarPanelFooterHeight);
};
const $a78c261c3211f7d6$export$e3c287b6d80b16ce = ({ pageMode: pageMode, pageWidthType: pageWidthType, hasEndOfPageRecommendations: hasEndOfPageRecommendations })=>{
    const endOfPageRecommendationsMaxWidth = '1000px';
    if (pageMode === (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) {
        // pageWidthType is a string like '"default"' / '"full-width"' in renderer mode, and is undefined in live doc mode
        const isDefaultWidth = pageWidthType && JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT;
        if (hasEndOfPageRecommendations) // when end-of-page recommendations is present, always match its width (see EndOfPageRecContainer.tsx)
        return {
            width: isDefaultWidth ? '87.5%' : '100%',
            maxWidth: endOfPageRecommendationsMaxWidth
        };
        else return {
            width: '100%',
            maxWidth: isDefaultWidth ? '760px' : '1800px' // if not defaultWidth, use full page width
        };
    }
    if (pageMode !== (0, $cD1qu.PageMode).VIEW && ((0, $9wGTI.fg)('confluence_frontend_unify_footer_comment_width_ld') || (0, $6mKj3.expValEquals)('confluence_unify_footer_comments_space_width', 'isEnabled', true))) return {
        width: '100%',
        maxWidth: hasEndOfPageRecommendations && (0, $6mKj3.expValEquals)('confluence_ai_related_content_for_live_pages', 'isEnabled', true) ? endOfPageRecommendationsMaxWidth : '100%'
    };
    // Base case: when the fg for the current pageMode isn't ON, i.e. either of:
    // - pageMode === PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // - pageMode !== PageMode.VIEW && !fg('confluence_frontend_unify_footer_comment_width_ld') && !expValEquals('confluence_unify_footer_comments_space_width', 'isEnabled', true)
    // This block can be removed entirely once both fgs are rolled out.
    let maxWidth = '100%';
    if (pageWidthType) maxWidth = JSON.parse(pageWidthType) === (0, $1d2ww.ContentAppearanceType).DEFAULT ? '1000px' : 'unset';
    return {
        width: '100%',
        maxWidth: maxWidth
    };
};
module.exports["CREATE_COMMENT_SELECTION_CLASS"] = $a78c261c3211f7d6$export$d2bdbdaa2c26e7f7;
module.exports["HIGHLIGHT_CLASS"] = $a78c261c3211f7d6$export$b803c692fbaaa5a4;
module.exports["ACTIVE_CLASS"] = $a78c261c3211f7d6$export$fb3d0eebfe85522a;
module.exports["getCommentIndexAndCount"] = $a78c261c3211f7d6$export$b899b07e3f725968;
module.exports["getInlineMarkSelector"] = $a78c261c3211f7d6$export$8c7b048437c01388;
module.exports["getMarkerRef"] = $a78c261c3211f7d6$export$8f4213b45c05ab5d;
module.exports["getSortedMarkerRefs"] = $a78c261c3211f7d6$export$9b48c18cc387f791;
module.exports["clearActiveHighlight"] = $a78c261c3211f7d6$export$f7ceeb7ba8156450;
module.exports["getNextTextNode"] = $a78c261c3211f7d6$export$3e98291f1f032a77;
module.exports["getHighlightOffset"] = $a78c261c3211f7d6$export$739c145b6a07c076;
module.exports["getHighlightFromMarkerRef"] = $a78c261c3211f7d6$export$21445ab787d3b446;
module.exports["calculateElementOffset"] = $a78c261c3211f7d6$export$331805bfbe18b1c0;
module.exports["resetTemporaryDOMHighlight"] = $a78c261c3211f7d6$export$743373b19993e2b0;
module.exports["convertDOMHighlightToMark"] = $a78c261c3211f7d6$export$a160a5110cbadcb8;
module.exports["setCommentAsActive"] = $a78c261c3211f7d6$export$fd55463aeed84830;
module.exports["removeMarkInDOM"] = $a78c261c3211f7d6$export$a26c4eafef12029f;
module.exports["isEmptyAdf"] = $a78c261c3211f7d6$export$915f03d46d87bfd4;
module.exports["keyPropagationList"] = $a78c261c3211f7d6$export$6d23af9d8c2844b1;
module.exports["scrollPageCommentIntoView"] = $a78c261c3211f7d6$export$858fd2398afb28e4;
module.exports["handleScrollToElement"] = $a78c261c3211f7d6$export$b451b837f5309ae9;
module.exports["scrollToElementWithViewingRoom"] = $a78c261c3211f7d6$export$fc9b5eebad60b835;
module.exports["getNodeForTableORMacro"] = $a78c261c3211f7d6$export$ee0755cb593feed6;
module.exports["checkElementExpand"] = $a78c261c3211f7d6$export$876171b9c9b54aab;
module.exports["scrollCommentIntoView"] = $a78c261c3211f7d6$export$c7436bd0a15f3e7e;
module.exports["getSidebarId"] = $a78c261c3211f7d6$export$fb40c5e75b82df8;
module.exports["focusElementAndUpdateTabIndex"] = $a78c261c3211f7d6$export$cfa8eefe354167cd;
module.exports["scrollToComment"] = $a78c261c3211f7d6$export$db9eae89818590a4;
module.exports["checkElementExpandMultiLevelCommon"] = $a78c261c3211f7d6$export$1a2319f5c2109ee1;
module.exports["getNextMarkerRef"] = $a78c261c3211f7d6$export$187f977414e8342c;
module.exports["getNextUnreadThreadKey"] = $a78c261c3211f7d6$export$883ebc059dd86e88;
module.exports["isClipboardApiSupported"] = $a78c261c3211f7d6$export$b401b3c3a0774fd7;
module.exports["isIEClipboardApiSupported"] = $a78c261c3211f7d6$export$bec1a1359bf081c5;
module.exports["copyToClipboardIE"] = $a78c261c3211f7d6$export$dcc703cd1f894b4c;
module.exports["copyToClipboard"] = $a78c261c3211f7d6$export$2cdf1b96a9f86d16;
module.exports["legacyCopyToClipboard"] = $a78c261c3211f7d6$export$d26ca9d0d4cbdbe9;
module.exports["calculateEditorOffsetFromParent"] = $a78c261c3211f7d6$export$ab567600730c0b3b;
module.exports["calculateRendererOffsetFromParent"] = $a78c261c3211f7d6$export$3cdeee3ea1732782;
module.exports["getCommentPositionTopOfSectionEditor"] = $a78c261c3211f7d6$export$9f8164812b21bc7a;
module.exports["getCommentPositionTopOfSectionRenderer"] = $a78c261c3211f7d6$export$e3a17b46d43aa5f6;
module.exports["watchForCommentContainerAndScroll"] = $a78c261c3211f7d6$export$b3ba907d5759e257;
module.exports["watchForCommentRepliesAndScroll"] = $a78c261c3211f7d6$export$b1b7c9bcc75c855d;
module.exports["shouldScrollCommentThreadToTop"] = $a78c261c3211f7d6$export$4d211f4974dcf196;
module.exports["isCommentThreadReplyOutOfView"] = $a78c261c3211f7d6$export$9c5b7a3c864ae31b;
module.exports["getWidthAndMaxWidth"] = $a78c261c3211f7d6$export$e3c287b6d80b16ce;

});

parcelRegister("i49vP", function(module, exports) {

var $gfqXk = parcelRequire("gfqXk");


var $4EKKB = parcelRequire("4EKKB");


var $aHcFH = parcelRequire("aHcFH");

const $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage = (element)=>{
    let elementOffsetTop = 0;
    let nodeToMeasure = element;
    while(nodeToMeasure && !nodeToMeasure.classList.contains('fabric-editor-popup-scroll-parent')){
        elementOffsetTop += nodeToMeasure.offsetTop;
        nodeToMeasure = nodeToMeasure.offsetParent;
    }
    return elementOffsetTop;
};
const $36cd0189b09a46b6$export$cc3d34287540b287 = (element)=>{
    const expandSelectors = [
        '.ak-editor-expand'
    ];
    const getExpandButton = (node)=>{
        if (node.classList.contains('ak-editor-expand')) {
            const button = node.querySelector('.ak-editor-expand__icon-container');
            return button;
        }
        return null;
    };
    const isExpanded = (button)=>{
        const expandContainer = button.closest('.ak-editor-expand');
        return expandContainer?.classList.contains('ak-editor-expand__expanded') || false;
    };
    const onExpand = ()=>{
        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
            isInExpand: true
        });
    };
    (0, $aHcFH.checkElementExpandMultiLevelCommon)(element, {
        isEditor: true,
        expandSelectors: expandSelectors,
        getExpandButton: getExpandButton,
        isExpanded: isExpanded,
        onExpand: onExpand
    });
};
const $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8 = (element)=>{
    $36cd0189b09a46b6$export$cc3d34287540b287(element);
};
const $36cd0189b09a46b6$export$2163ce5a75e4a465 = ({ targetElement: targetElement, targetElementID: targetElementID, shouldScroll: shouldScroll = true })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8(targetElement);
    emitter.emit('setselectedannotation', targetElementID);
    window.getSelection()?.setPosition(targetElement);
    shouldScroll && $36cd0189b09a46b6$export$4ee22c4fac4681d8({
        targetElement: targetElement,
        viewingRoomOffset: -100
    });
};
const $36cd0189b09a46b6$export$4ee22c4fac4681d8 = ({ targetElement: targetElement, viewingRoomOffset: viewingRoomOffset = 0 })=>{
    const editorScrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
    if (editorScrollableContainer) editorScrollableContainer.scrollTo(0, $36cd0189b09a46b6$var$getElementOffsetFromTopOfPage(targetElement) + viewingRoomOffset // add viewing room
    );
};
const $36cd0189b09a46b6$export$443ba0c8d1b21569 = ({ data: data, previousAnnotations: previousAnnotations })=>{
    const emitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const topLevelCommentMarkerRefs = data?.comments?.nodes?.map((node)=>(node?.location).inlineMarkerRef);
    if (topLevelCommentMarkerRefs && topLevelCommentMarkerRefs.length > 0) {
        const newAnnotationsSet = new Set(topLevelCommentMarkerRefs);
        const removedMarkerRefs = [];
        previousAnnotations.forEach((item)=>{
            if (!newAnnotationsSet.has(item)) removedMarkerRefs.push(item);
        });
        let updatedAnnotations = [
            ...previousAnnotations
        ];
        const addedMarkerRefs = [];
        newAnnotationsSet.forEach((item)=>{
            if (!previousAnnotations.includes(item)) addedMarkerRefs.push(item);
        });
        for (const markerRef of addedMarkerRefs){
            emitter.emit('create', markerRef);
            updatedAnnotations.push(markerRef);
        }
        for (const markerRef of removedMarkerRefs){
            emitter.emit('resolve', markerRef);
            updatedAnnotations = updatedAnnotations.filter((annotation)=>annotation !== markerRef);
        }
        return updatedAnnotations;
    }
    return [];
};
module.exports["checkElementExpandInEditor"] = $36cd0189b09a46b6$export$a1bb3d68e0c3dbb8;
module.exports["openInlineCommentInEditor"] = $36cd0189b09a46b6$export$2163ce5a75e4a465;
module.exports["scrollToElementInEditor"] = $36cd0189b09a46b6$export$4ee22c4fac4681d8;

});

parcelRegister("9CnRS", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90dae8a726ff859c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    addNew: {
        id: "inline-comments-common.reactions.add.new",
        defaultMessage: "Add new"
    },
    invalidHighlight: {
        id: "inline-comments-common.error.invalid.highlight",
        defaultMessage: "We\u2019re having trouble adding your comment. Try highlighting more or less text."
    },
    replyCommentPlaceholder: {
        id: "inline-comments-common.reply-comment-placeholder",
        defaultMessage: "Reply"
    },
    staleContent: {
        id: "inline-comments-common.error.stale.content",
        defaultMessage: "Refresh to view the latest updates, and try adding your comment again."
    },
    viewNotPermitted: {
        id: "inline-comments-common.error.view.not.permitted",
        defaultMessage: "Your permission settings don\u2019t allow you to view this comment. Check with your administrator if you need this ability."
    },
    createNotPermitted: {
        id: "inline-comments-common.error.create.not.permitted",
        defaultMessage: "You can\u2019t create comments in this space. A space admin can modify your permissions."
    },
    unableToApplyAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.annotation",
        defaultMessage: "Something went wrong when adding this comment to the document. Refresh to see your comment."
    },
    unableToApplyDanglingCommentAnnotation: {
        id: "inline-comments-common.error.unable.to.apply.dangling.comment.annotation",
        defaultMessage: "Your comment was created but could not be added to the document because the text has been changed or removed."
    },
    contentHasBeenRemoved: {
        id: "inline-comments-common.error.create.content.removed",
        defaultMessage: "The text you highlighted has already been deleted by someone else. Refresh to view the latest updates."
    },
    cannotHighlightContent: {
        id: "inline-comments-common.error.cannot.highlight.content",
        defaultMessage: "An error occurred when commenting on the highlighted content. The page may be outdated. Refresh to view the latest updates."
    },
    viewOrModifyNotPermitted: {
        id: "inline-comments-common.error.view.or.modify.not.permitted",
        defaultMessage: "You can\u2019t view or modify comments in this space. A space admin can modify your permissions."
    },
    deleteWithRepliesNotAllowed: {
        id: "inline-comments-common.error.delete.with.replies",
        defaultMessage: "You can\u2019t delete this comment anymore because someone else replied to it. Refresh to see all replies."
    },
    commentAlreadyDeleted: {
        id: "inline-comments-common.error.comment.already.deleted",
        defaultMessage: "This comment has been deleted by someone else. Refresh to view the latest updates."
    },
    commentAlreadyDeletedTitle: {
        id: "inline-comments-common.error.comment.already.deleted.title",
        defaultMessage: "Unable to delete comment"
    },
    noCommentsFoundForGivenMarkerRef: {
        id: "inline-comments-common.error.no.comments.found.for.given.marker.ref",
        defaultMessage: "This comment couldn\u2019t be found. Refresh to view the latest updates."
    },
    resolveNotPermitted: {
        id: "inline-comments-common.error.resolve.not.permitted",
        defaultMessage: "You can\u2019t resolve comments in this space. A space admin can modify your permissions."
    },
    resolveError: {
        id: "inline-comments-common.error.resolve.error",
        defaultMessage: "We failed to resolve your comment due to an error. Try resolving the comment again."
    },
    resolveErrorTitle: {
        id: "inline-comments-common.error.resolve.error.title",
        defaultMessage: "Failed to resolve comment"
    },
    deleteError: {
        id: "inline-comments-common.error.delete.error",
        defaultMessage: "We failed to delete your comment due to an error. Try deleting the comment again."
    },
    deleteErrorTitle: {
        id: "inline-comments-common.error.delete.error.title",
        defaultMessage: "Failed to delete comment"
    },
    editNotPermitted: {
        id: "inline-comments-common.error.edit.not.permitted",
        defaultMessage: "You can\u2019t edit comments in this space. A space admin can modify your permissions."
    },
    replyNotPermitted: {
        id: "inline-comments-common.error.reply.not.permitted",
        defaultMessage: "You can\u2019t reply to comments in this space. A space admin can modify your permissions."
    },
    replyNotAllowedParentDeleted: {
        id: "inline-comments-common.error.reply.not.allowed.parent.deleted",
        defaultMessage: "You can\u2019t reply to this comment because it was just deleted by someone else. Refresh to view the latest updates."
    },
    unableToMarkDOM: {
        id: "inline-comments-common.error.unable.to.mark.dom",
        defaultMessage: "Your comment has been successfully created. Refresh to view it."
    },
    networkError: {
        id: "inline-comments-common.error.network",
        defaultMessage: "Your comment wasn't added due to a network error. Check your connection and try again."
    },
    unexpectedError: {
        id: "inline-comments-common.error.unexpected",
        defaultMessage: "Something went wrong when saving this comment. Close the comment or refresh, and try adding your comment again."
    },
    actionNotPermittedTitle: {
        id: "inline-comments-common.error.action.not.permitted.title",
        defaultMessage: "Unauthorized action"
    },
    actionNotPermitted: {
        id: "inline-comments-common.error.action.not.permitted",
        defaultMessage: "You can\u2019t perform that action on inline comments in this space. A space admin can modify your permissions."
    },
    cannotReplyToResolvedComment: {
        id: "inline-comments-common.error.cannot.reply.to.resolved",
        defaultMessage: "You can\u2019t reply to this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    cannotUpdateResolvedComment: {
        id: "inline-comments-common.error.cannot.update.resolved",
        defaultMessage: "You can\u2019t edit this comment because it was recently resolved by another user. Refresh to view the latest updates."
    },
    unableToGenerateStep: {
        id: "inline-comments-common.error.unable.to.generate.step",
        defaultMessage: "You can\u2019t create a comment because something went wrong with your highlight. Close this window and create a new highlight."
    },
    contentOutOfDate: {
        id: "inline-comments-common.error.content.out.of.date",
        defaultMessage: "You can\u2019t create a comment here because the text has been changed or removed."
    },
    createTimeout: {
        id: "inline-comments-common.error.create.timeout",
        defaultMessage: "Your request to create a comment timed out. Wait a few moments and save the comment again."
    },
    /**
   * The message below is duplicated in the next files:
   * next/packages/resolved-inline-comments-dialog/src/ResolvedInlineCommentsDialogComponent.tsx
   * packages/confluence-frontend-server/src/components/Comment/PageCommentRenderer.js
   *
   * If you are going to change the message please make sure that the same changes are made in the mentioned above files
   */ a11yCommentLabel: {
        id: "inline-comments-common.a11y.comment.wrapper.label",
        defaultMessage: "Comment by {username}"
    },
    commentActionsMenuLabel: {
        id: "inline-comments-common.comment.actions.menu.label",
        defaultMessage: "More actions"
    },
    copyLinkTooltip: {
        id: "inline-comments-common.tooltip.copy.link",
        defaultMessage: "Copy link to comment"
    },
    linkCopiedTooltip: {
        id: "inline-comments-common.tooltip.link.has.been.copied",
        defaultMessage: "Copied!"
    },
    resolve: {
        id: "inline-comments-common.view.action.resolve",
        defaultMessage: "Resolve"
    },
    resolved: {
        id: "inline-comments-common.view.action.resolved",
        defaultMessage: "Resolved"
    },
    edit: {
        id: "inline-comments-common.view.action.edit",
        defaultMessage: "Edit"
    },
    delete: {
        id: "inline-comments-common.view.action.delete",
        defaultMessage: "Delete"
    },
    reopen: {
        id: "inline-comments-common.action.reopen",
        defaultMessage: "Reopen"
    },
    replyPlaceholder: {
        id: "inline-comments-common.reply.placeholder",
        defaultMessage: "Reply"
    },
    replyPlaceholderWithName: {
        id: "inline-comments-common.reply.placeholder.with-name",
        defaultMessage: "Reply to {name}"
    },
    reactionAriaLabelWithName: {
        id: "inline-comments-common.reaction.aria-label.with-name",
        defaultMessage: "React to {name}\u2019s comment"
    },
    resolveThread: {
        id: "inline-comments-common.resolve-thread",
        defaultMessage: "Resolve comment thread"
    },
    /**
   * Collaborator Onboarding sample comment
   */ sampleAuthor: {
        id: "inline-comments-common.sample.comment.author",
        defaultMessage: "Confluence"
    },
    sampleBody: {
        id: "inline-comments-common.sample.comment.body",
        defaultMessage: "Highlight content to add an inline comment. All viewers can see these, so it\u2019s great for targeted discussion on a specific word or phrase"
    },
    sampleReply: {
        id: "inline-comments-common.sample.reply.input",
        defaultMessage: "disabled reply input"
    },
    sampleReplyPlaceholder: {
        id: "inline-comments-common.sample.reply.placeholder",
        defaultMessage: "Reply"
    },
    sampleReplyTooltip: {
        id: "inline-comments-common.sample.reply.tooltip",
        defaultMessage: "Reply is unavailable for sample comments"
    },
    sampleDeleteHeader: {
        id: "inline-comments-common.sample.comment.delete.header",
        defaultMessage: "Only you can see this."
    },
    sampleDeleteIcon: {
        id: "inline-comments-common.sample.comment.delete.icon",
        defaultMessage: "Delete icon"
    },
    sampleDeleteTooltip: {
        id: "inline-comments-common.sample.comment.delete.tooltip",
        defaultMessage: "Delete sample comment"
    },
    sampleCloseIconLabel: {
        id: "inline-comments-common.sample.comment.delete.icon.label",
        defaultMessage: "Close sample comment"
    },
    collapsedRepliesMore: {
        id: "inline-comments-common.collapsed.replies.more",
        defaultMessage: "{numCollapsedReplies} more replies"
    },
    unreadInlineComment: {
        id: "inline-comments-common.unread.inline.comment",
        defaultMessage: "This is an unread inline comment"
    },
    deletedCommentActionLabel: {
        id: "inline-comments-common.deleted.comment.action.label",
        defaultMessage: "This comment has been deleted"
    },
    resolvedText: {
        id: "inline-comments-common.resolved",
        defaultMessage: "[Resolved]"
    },
    resolvedFlagText: {
        id: "inline-comments-common.resolved.flag.text",
        defaultMessage: "Comment resolved"
    },
    deletedText: {
        id: "inline-comments-common.deleted",
        defaultMessage: "[Deleted]"
    },
    copyLink: {
        id: "inline-comments-common.copy.link",
        defaultMessage: "Copy link"
    },
    goToCommentCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.gotocomment",
        defaultMessage: "Go to comment"
    },
    undoCTA: {
        id: "inline-comments-common.comment.reopened.flag.cta.undo",
        defaultMessage: "Undo"
    },
    contentDeleted: {
        id: "inline-comments-common.content.deleted",
        defaultMessage: "Content deleted"
    },
    originalContentDeleted: {
        id: "inline-comments-common.original.content.deleted",
        defaultMessage: "Original content deleted"
    },
    thisContentWasDeleted: {
        id: "inline-comments-common.dangling.comments.this.content.was.deleted",
        defaultMessage: "This content was deleted."
    },
    viewDeletedContent: {
        id: "inline-comments-common.dangling.comments.view.deleted.content",
        defaultMessage: "View deleted content"
    },
    collapseDeletedContent: {
        id: "inline-comments-common.dangling.comments.collapse.deleted.content",
        defaultMessage: "Collapse deleted content"
    }
});
module.exports["i18n"] = $90dae8a726ff859c$export$a7357cdd1f0b0168;

});

parcelRegister("cWhxr", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $917iu = parcelRequire("917iu");

var $8uR5k = parcelRequire("8uR5k");

var $d6omw = parcelRequire("d6omw");

var $lvvx5 = parcelRequire("lvvx5");

const $677d422179b5c9e8$var$messages = (0, $cgtv4.defineMessages)({
    now: {
        id: "inline-comments-common.relative-timestamp.now",
        defaultMessage: "Now"
    }
});
const $677d422179b5c9e8$export$705da3a6fb3571ab = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { date: date } = t0;
    const intl = (0, $8C5kA.default)();
    const now = new Date();
    const diffInMinutes = (0, $d6omw.default)(now, date);
    const diffInHours = (0, $8uR5k.default)(now, date);
    const diffInDays = (0, $917iu.default)(now, date);
    const diffInWeeks = (0, $lvvx5.default)(now, date);
    if (diffInMinutes < 2) {
        let t1;
        if ($[0] !== intl) {
            t1 = intl.formatMessage($677d422179b5c9e8$var$messages.now);
            $[0] = intl;
            $[1] = t1;
        } else t1 = $[1];
        let t2;
        if ($[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (diffInMinutes < 60) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInMinutes,
        style: "unit",
        unit: "minute",
        unitDisplay: "narrow"
    });
    if (diffInHours < 24) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInHours,
        style: "unit",
        unit: "hour",
        unitDisplay: "narrow"
    });
    if (diffInWeeks < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cgtv4.FormattedNumber), {
        value: diffInDays,
        style: "unit",
        unit: "day",
        unitDisplay: "narrow"
    });
    const currentYear = now.getFullYear();
    const dateYear = date.getFullYear();
    if (currentYear === dateYear) {
        let t1;
        if ($[4] !== date || $[5] !== intl) {
            t1 = intl.formatDate(date, {
                month: "short",
                day: "numeric"
            });
            $[4] = date;
            $[5] = intl;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
            $[7] = t1;
            $[8] = t2;
        } else t2 = $[8];
        return t2;
    }
    let t1;
    if ($[9] !== date || $[10] !== intl) {
        t1 = intl.formatDate(date, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
        $[9] = date;
        $[10] = intl;
        $[11] = t1;
    } else t1 = $[11];
    let t2;
    if ($[12] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1);
        $[12] = t1;
        $[13] = t2;
    } else t2 = $[13];
    return t2;
};
module.exports["RelativeTimestamp"] = $677d422179b5c9e8$export$705da3a6fb3571ab;

});

parcelRegister("8uR5k", function(module, exports) {
$parcel$export(module.exports, "default", () => $62fa4da7b1bddd96$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $62fa4da7b1bddd96$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInHour);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("d6omw", function(module, exports) {
$parcel$export(module.exports, "default", () => $989ebbba3827b0fa$export$2e2bcd8739ae039);

var $jx0NF = parcelRequire("jx0NF");


var $62guz = parcelRequire("62guz");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $989ebbba3827b0fa$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $62guz.default)(dateLeft, dateRight) / (0, $jx0NF.millisecondsInMinute);
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lvvx5", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa84f3f15ff2b5dc$export$2e2bcd8739ae039);

var $917iu = parcelRequire("917iu");


var $b5utg = parcelRequire("b5utg");


var $fls5L = parcelRequire("fls5L");

function $fa84f3f15ff2b5dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $b5utg.default)(2, arguments);
    var diff = (0, $917iu.default)(dateLeft, dateRight) / 7;
    return (0, $fls5L.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});

parcelRegister("lRNq8", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $3gadb = parcelRequire("3gadb");


var $gdv5Z = parcelRequire("gdv5Z");


var $6faGq = parcelRequire("6faGq");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");

const $82d0090970c55653$var$styles = {
    tooltipWrapper: "_1ul9idpf"
};
const $82d0090970c55653$var$i18n = (0, $cgtv4.defineMessages)({
    addedTooltip: {
        id: "inline-comments-common.date-tooltip.added",
        defaultMessage: "Added by {username} on {date} at {timeStamp}"
    }
});
const $82d0090970c55653$export$8d25ba73a810c5c5 = (t0)=>{
    const $ = (0, $frIzR.c)(7);
    const { children: children, date: date, name: name } = t0;
    const intl = (0, $8C5kA.default)();
    const { formatMessage: formatMessage } = intl;
    const { timeZone: userTimeZone, tenantTimeZone: tenantTimeZone } = (0, $bQm3c.useSessionData)();
    const timeZone = userTimeZone || tenantTimeZone || undefined;
    let t1;
    if ($[0] !== children || $[1] !== date || $[2] !== formatMessage || $[3] !== intl || $[4] !== name || $[5] !== timeZone) {
        t1 = date && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $82d0090970c55653$var$styles.tooltipWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage($82d0090970c55653$var$i18n.addedTooltip, {
                username: name,
                date: intl.formatDate((0, $6faGq.getValidDate)(date), {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                    timeZone: timeZone
                }),
                timeStamp: intl.formatTime((0, $6faGq.getValidDate)(date), {
                    hour: "numeric",
                    minute: "numeric",
                    timeZone: timeZone
                })
            })
        }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[0] = children;
        $[1] = date;
        $[2] = formatMessage;
        $[3] = intl;
        $[4] = name;
        $[5] = timeZone;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
module.exports["MaybeTooltip"] = $82d0090970c55653$export$8d25ba73a810c5c5;

});

parcelRegister("dLr6w", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");


var $cUiCf = parcelRequire("cUiCf");

const $4baccafa846af1c4$export$fba4d5c7ef076998 = ()=>{
    const $ = (0, $frIzR.c)(4);
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== userId) {
        t0 = !userId || !(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true);
        $[0] = userId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = {
            skip: t0,
            fetchPolicy: "cache-first"
        };
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const { isReady: isReady } = (0, $cUiCf.useCommentAuthorQuery)(userId ?? undefined, t1);
    if (!(0, $6mKj3.expValEquals)("confluence_comment_improve_author_paint", "isEnabled", true)) return true;
    if (!userId) return true;
    return isReady;
};
module.exports["useCurrentUserAvatarReady"] = $4baccafa846af1c4$export$fba4d5c7ef076998;

});

parcelRegister("isdzP", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $fJlJm = parcelRequire("fJlJm");


var $hL41C = parcelRequire("hL41C");


var $9CnRS = parcelRequire("9CnRS");

const $e5083fb3da68bf8e$export$e80a9284539c1797 = (error)=>{
    const { message: message } = error;
    let errorMessage = '';
    const parsedError = {
        message: errorMessage,
        isAuthorized: false
    };
    /* If this is a GraphQL error we need to extract the data out of it
   * GraphQL errors that are returned from mutations always have the same format:
   * GraphQL error: <GUID>: <EXCEPTION>: <REASON>
   * The GUID correlates to the microsId so it unfortunately doesn't do much for us
   * With this in mind, we want to extract the REASON as the message for translation
   */ if (message.indexOf('GraphQL error:') !== -1) {
        const reasonStartIdx = message.lastIndexOf(':') + 1;
        errorMessage = message.substr(reasonStartIdx, message.length - reasonStartIdx).trim();
        // Extract the traceId for highlight errors
        parsedError.errorId = (0, $fJlJm.getLogSafeErrorAttributes)(error).traceId;
    } else errorMessage = message;
    parsedError.message = errorMessage;
    // If we have an ApolloErrorInterop, extract the status code and the authorization status
    const { graphQLErrors: graphQLErrors } = error;
    if (graphQLErrors && graphQLErrors.length) {
        parsedError.statusCode = graphQLErrors?.[0]?.extensions?.statusCode;
        parsedError.isAuthorized = graphQLErrors?.[0]?.extensions?.data?.authorized || false;
    }
    return parsedError;
};
const $e5083fb3da68bf8e$export$a67f8c1198066537 = (message, id = '')=>{
    let i18nError;
    // COMMENTS-4199 - This is our own handling of the error thrown by the editor/renderer that we wrap
    //				   in our own message, so to preserve the original error we just check for our message
    if (message.includes('Unable to apply annotation to document')) {
        if (message.includes('Failed to create annotation')) i18nError = (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation;
        else i18nError = (0, $9CnRS.i18n).unableToApplyAnnotation;
    } else if (message.startsWith('Network error: ')) i18nError = (0, $9CnRS.i18n).networkError;
    else switch(message){
        case (0, $hL41C.InlineCommentError).INVALID_SELECTION:
        case (0, $hL41C.InlineCommentError).FAILED_TO_INSERT_MARK:
            i18nError = (0, $9CnRS.i18n).invalidHighlight;
            break;
        case (0, $hL41C.InlineCommentError).STALE_SELECTION:
            i18nError = (0, $9CnRS.i18n).staleContent;
            break;
        case (0, $hL41C.InlineCommentError).NO_ANONYMOUS_ACCESS:
            i18nError = (0, $9CnRS.i18n).actionNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF:
        case (0, $hL41C.InlineCommentError).NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST:
            i18nError = (0, $9CnRS.i18n).noCommentsFoundForGivenMarkerRef;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_PERMS:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED:
        case (0, $hL41C.InlineCommentError).NOT_AUTHORIZED_COMMENTS:
            i18nError = (0, $9CnRS.i18n).viewNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_UPDATE_PERMS.replace('%d', id ? id : ''):
            i18nError = (0, $9CnRS.i18n).editNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_VIEW_OR_MODIFY_PERMS:
        case (0, $hL41C.InlineCommentError).NO_SPACE_PERMS:
            i18nError = (0, $9CnRS.i18n).viewOrModifyNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).NO_DELETE_WITH_CHILDREN:
            i18nError = (0, $9CnRS.i18n).deleteWithRepliesNotAllowed;
            break;
        case (0, $hL41C.InlineCommentError).NO_CREATE_PERMS:
            i18nError = (0, $9CnRS.i18n).createNotPermitted;
            break;
        case (0, $hL41C.InlineCommentError).UPDATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).COMMENT_ALREADY_DELETED.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).CANNOT_RESOLVE_DELETED_COMMENT.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).ERROR_404:
            i18nError = (0, $9CnRS.i18n).commentAlreadyDeleted;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_DELETED_PARENT:
            i18nError = (0, $9CnRS.i18n).replyNotAllowedParentDeleted;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_MATCHES:
            i18nError = (0, $6mKj3.expValEquals)('confluence_fe_create_inline_use_curr_doc_version', 'isEnabled', true) ? (0, $9CnRS.i18n).cannotHighlightContent : (0, $9CnRS.i18n).contentHasBeenRemoved;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_REPLY_TO_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotReplyToResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CANNOT_UPDATE_RESOLVED_COMMENT:
            i18nError = (0, $9CnRS.i18n).cannotUpdateResolvedComment;
            break;
        case (0, $hL41C.InlineCommentError).CONTENT_OUT_OF_DATE:
            i18nError = (0, $9CnRS.i18n).contentOutOfDate;
            break;
        case (0, $hL41C.InlineCommentError).INVALID_ARGUMENT_CREATED_FROM:
        case (0, $hL41C.InlineCommentError).CREATE_COMMENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).PARENT_NOT_FOUND.replace('%d', id ? id : ''):
        case (0, $hL41C.InlineCommentError).INCOMPATIBLE_PARENT_TYPE:
        case (0, $hL41C.InlineCommentError).DELETE_ERROR:
        default:
            i18nError = (0, $9CnRS.i18n).unexpectedError;
            break;
    }
    return i18nError;
};
const $e5083fb3da68bf8e$export$336db91bab9fb3ba = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).invalidHighlight.id;
const $e5083fb3da68bf8e$export$68de2e41a5e9d0c3 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unexpectedError.id;
const $e5083fb3da68bf8e$export$fb2e61e668e6b1d2 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).unableToApplyAnnotation.id || translatedMessage.id === (0, $9CnRS.i18n).unableToApplyDanglingCommentAnnotation.id;
const $e5083fb3da68bf8e$export$81795bac145b8560 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).contentOutOfDate.id || translatedMessage.id === (0, $9CnRS.i18n).staleContent.id;
const $e5083fb3da68bf8e$export$b2e3f629cad072ef = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).commentAlreadyDeleted.id;
const $e5083fb3da68bf8e$export$476aa014e2fd89d5 = (translatedMessage)=>translatedMessage.id === (0, $9CnRS.i18n).networkError.id;
module.exports["parseError"] = $e5083fb3da68bf8e$export$e80a9284539c1797;
module.exports["getTranslatedError"] = $e5083fb3da68bf8e$export$a67f8c1198066537;
module.exports["isHighlightError"] = $e5083fb3da68bf8e$export$336db91bab9fb3ba;
module.exports["isUnexpectedError"] = $e5083fb3da68bf8e$export$68de2e41a5e9d0c3;
module.exports["isAnnotationError"] = $e5083fb3da68bf8e$export$fb2e61e668e6b1d2;
module.exports["isOutOfDateError"] = $e5083fb3da68bf8e$export$81795bac145b8560;
module.exports["isAlreadyDeletedError"] = $e5083fb3da68bf8e$export$b2e3f629cad072ef;
module.exports["isNetworkError"] = $e5083fb3da68bf8e$export$476aa014e2fd89d5;

});

parcelRegister("hL41C", function(module, exports) {
var $4bdefc881ecc3bb8$export$317614131ad59950 = /*#__PURE__*/ function(InlineCommentError) {
    InlineCommentError["INVALID_SELECTION"] = "Invalid text selection. Cannot create inline comments on macros (mentions, images, emojis, etc.)";
    InlineCommentError["FAILED_TO_INSERT_MARK"] = "Failed to insert highlight, invalid originalSelection, numMatches, or matchIndex";
    InlineCommentError["INVALID_ARGUMENT_CREATED_FROM"] = "Invalid createdFrom, please specify if created from editor or renderer";
    InlineCommentError["STALE_SELECTION"] = "Selection was made against a stale version of the content";
    InlineCommentError["NO_ANONYMOUS_ACCESS"] = "Anonymous access is not permitted";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF"] = "No comments found for the given markerRef";
    InlineCommentError["NO_COMMENTS_FOUND_FOR_GIVEN_MARKER_REF_LIST"] = "No comments found for the given markerRefList";
    InlineCommentError["NO_VIEW_PERMS"] = "User doesn't have VIEW permission for this comment";
    InlineCommentError["NOT_AUTHORIZED"] = "403 Forbidden, current user not permitted to use Confluence.";
    InlineCommentError["NOT_AUTHORIZED_COMMENTS"] = "User does not have permission to access the comment(s)";
    // Create Reply
    InlineCommentError["CREATE_COMMENT_NOT_FOUND"] = "Content with id %d for comment container is not found. Please provide correct container id.";
    InlineCommentError["PARENT_NOT_FOUND"] = "Parent comment with id %d is not found. Please provide correct parent comment id.";
    InlineCommentError["INCOMPATIBLE_PARENT_TYPE"] = "Incompatible parent type. Please provide comment id.";
    InlineCommentError["CANNOT_REPLY_TO_DELETED_PARENT"] = "Cannot add reply to a deleted comment";
    InlineCommentError["CANNOT_REPLY_TO_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be replied";
    // Delete
    // This is the error message for a NotFoundException only
    InlineCommentError["DELETE_ERROR"] = "Exception occurred while deleting comment with id";
    InlineCommentError["NO_VIEW_OR_MODIFY_PERMS"] = "Parent page view is restricted";
    InlineCommentError["NO_SPACE_PERMS"] = "Space is restricted";
    InlineCommentError["NO_DELETE_WITH_CHILDREN"] = "Inline comment with child cannot be deleted.";
    InlineCommentError["COMMENT_ALREADY_DELETED"] = "Exception occurred while deleting comment with id %d";
    InlineCommentError["ERROR_404"] = "Received status 404";
    // Edit
    InlineCommentError["NO_UPDATE_PERMS"] = "Could not update Content of type  = class com.atlassian.confluence.pages.Comment with id %d";
    InlineCommentError["UPDATE_COMMENT_NOT_FOUND"] = "Could not find Comment for update with id CommentId{id=%d}";
    InlineCommentError["CANNOT_UPDATE_RESOLVED_COMMENT"] = "Inline comment in RESOLVED status cannot be updated";
    // Create
    InlineCommentError["NO_CREATE_PERMS"] = "Could not create content with type comment";
    InlineCommentError["INVALID_ARGUMENT_MATCHES"] = "Invalid arguments provided for matchIndex and/or numMatches";
    InlineCommentError["CONTENT_OUT_OF_DATE"] = "Published Version out of date. Please provide correct published version.";
    InlineCommentError["UNABLE_TO_APPLY_ANNOTATION"] = "Unable to apply annotation to document";
    // Resolve
    InlineCommentError["CANNOT_RESOLVE_DELETED_COMMENT"] = "%d must be existing and be an inline comment";
    return InlineCommentError;
}({});
module.exports["InlineCommentError"] = $4bdefc881ecc3bb8$export$317614131ad59950;

});

parcelRegister("6cWI7", function(module, exports) {

var $l4jQJ = parcelRequire("l4jQJ");


var $42omo = parcelRequire("42omo");


var $308Wd = parcelRequire("308Wd");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");

// This hook returns a mutation function to create a new inline comment. Because the new Comments
// Data Manager caches all the data for comments in Relay, we need to define the mutation here so
// that the cache can be updated fully when a new comment is created - and that means the mutation
// needs to return the full comment data structure that we are using in the returned query part of
// the mutation.  Since that returned query is quite large, we define it here in its own hook to
// avoid having it in many places in the codebase - which makes the code harder to read and could
// lead to the multiple copies getting out of sync.
// Data Mutation Definition:
// Unfortunately our Relay-friendly type generation tools don't support using GQL fragments yet -
// but in order to keep the definition of the comment fields in sync (so the cache update fragment
// is always in sync with the full query) we will need to manually make any changes to one
// definition in any others as well, until our tooling supports fragments and then we move to a
// more fragmented-based approach.  Note there are also comment queries or fragments in the
// following files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data/src/hooks/useCommentById.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// (Note that there is another exported GraphQL mutation variable named "CreateInlineCommentMutation"
// that is exported from @confluence/inline-comments-queries. It's okay that these are the same
// variable name because the other one does not seem to be imported anywhere in the codebase at
// present, this variable is only used internally in this file, and the actual muation's name -
// useCreateInlineCommentMutation - is unique so GQL won't complain.)
const $03f1ee89907a0c1d$var$CreateInlineCommentMutation = (0, $l4jQJ.default);
const $03f1ee89907a0c1d$export$10606ca3587bb707 = ({ contentId: contentId })=>{
    const { addCommentInCache: addCommentInCache } = (0, $NYiei.useAllCommentsData)({
        contentId: contentId,
        options: {
            skip: true // Only using write operations, no need to fetch data
        }
    });
    const [createInlineCommentFn] = (0, $308Wd.useMutationInterop)($03f1ee89907a0c1d$var$CreateInlineCommentMutation);
    const addEmptyInlineRepliesAndReactions = (0, $42omo.useCallback)((commentData)=>{
        return commentData ? {
            ...commentData,
            replies: [],
            reactionsSummary: (0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true) ? null : commentData.reactionsSummary ?? null
        } : undefined;
    }, []);
    // This is the interop mutation function that will be used by components that need to create
    // inline comments. It will either call the new Comments Data Manager path or the old Apollo
    // mutation path depending on whether the relevant experiment is enabled.
    const createInlineCommentInterop = (0, $42omo.useCallback)(({ originalMutationFn: originalMutationFn, options: options, onCacheUpdateError: onCacheUpdateError })=>{
        if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
            // Strip out the old update function and other options, and adjust variables as needed
            // The includeReactionsAndReplies variable is needed by some of the legacy mutations but is
            // not needed by the new Comments Data Manager. So remove it if we're using the new path -
            // otherwise Typescript will complain and GQL may error as well.
            const { variables: variables } = options;
            const { includeReactionsAndReplies: _includeReactionsAndReplies, ...newVariables } = variables ?? {
                includeReactionsAndReplies: undefined
            };
            const updateNewCommentInCache = (_dataProxy, mutationResult)=>{
                addCommentInCache({
                    newComment: addEmptyInlineRepliesAndReactions(mutationResult.data.createInlineComment),
                    onError: onCacheUpdateError
                });
            };
            return createInlineCommentFn({
                variables: {
                    ...newVariables,
                    includeReactionsSummary: !(0, $6mKj3.expValEquals)('confluence_fe_use_create_comment_exclude_reactions', 'isEnabled', true)
                },
                update: updateNewCommentInCache
            });
        } else return originalMutationFn(options);
    }, [
        addCommentInCache,
        addEmptyInlineRepliesAndReactions,
        createInlineCommentFn
    ]);
    return {
        createInlineCommentInterop: createInlineCommentInterop
    };
};
module.exports["useCreateInlineCommentMutation"] = $03f1ee89907a0c1d$export$10606ca3587bb707;

});

parcelRegister("l4jQJ", function(module, exports) {
/**
 * @generated SignedSource<<2ae02ff23c56f2a9e7dd47b4282e497b>>
 * @relayHash 44102a25791a45664a7cee556a06b417
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446
const $3dcbd79e6f23278f$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "includeReactionsSummary"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "input"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v6 = {
        "kind": "ScalarField",
        "name": "type"
    }, v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v9 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v10 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v11 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v12 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v13 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "Comment",
            "kind": "LinkedField",
            "name": "createInlineComment",
            "plural": false,
            "selections": [
                v3 /*: any*/ ,
                {
                    "kind": "LinkedField",
                    "name": "author",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "permissionType"
                        },
                        {
                            "concreteType": "Icon",
                            "kind": "LinkedField",
                            "name": "profilePicture",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "path"
                                }
                            ]
                        },
                        v6 /*: any*/ ,
                        v7 /*: any*/ 
                    ]
                },
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "representation",
                            "value": "ATLAS_DOC_FORMAT"
                        }
                    ],
                    "concreteType": "DocumentBody",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": v8 /*: any*/ ,
                    "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
                },
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "container",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ 
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "contentStatus"
                },
                {
                    "concreteType": "ConfluenceDate",
                    "kind": "LinkedField",
                    "name": "createdAt",
                    "plural": false,
                    "selections": v8 /*: any*/ 
                },
                {
                    "kind": "ScalarField",
                    "name": "createdAtNonLocalized"
                },
                {
                    "concreteType": "Map_LinkType_String",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "editui"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "name": "location",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        v6 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "commentResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                }
                            ],
                            "type": "FooterComment"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineMarkerRef"
                                },
                                {
                                    "concreteType": "InlineCommentResolveProperties",
                                    "kind": "LinkedField",
                                    "name": "inlineResolveProperties",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "isDangling"
                                        },
                                        v9 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v12 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "inlineText"
                                }
                            ],
                            "type": "InlineComment"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "parentId"
                },
                {
                    "concreteType": "CommentPermissions",
                    "kind": "LinkedField",
                    "name": "permissions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isEditable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isRemovable"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "isResolvable"
                        }
                    ]
                },
                {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "name": "by",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                v6 /*: any*/ ,
                                v5 /*: any*/ ,
                                v7 /*: any*/ 
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "friendlyWhen"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "number"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "when"
                        }
                    ]
                },
                {
                    "condition": "includeReactionsSummary",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Literal",
                                    "name": "childType",
                                    "value": "comment"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "contentType",
                                    "value": "page"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "pageId",
                                    "variableName": "pageId"
                                }
                            ],
                            "concreteType": "ReactionsSummaryResponse",
                            "kind": "LinkedField",
                            "name": "reactionsSummary",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ari"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "containerAri"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "reactionsCount"
                                },
                                {
                                    "concreteType": "ReactionsSummaryForEmoji",
                                    "kind": "LinkedField",
                                    "name": "reactionsSummaryForEmoji",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "ScalarField",
                                            "name": "count"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "emojiId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "reacted"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v2 /*: any*/ ,
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCreateInlineCommentMutation",
            "selections": v13 /*: any*/ 
        },
        "params": {
            "cacheID": "44102a25791a45664a7cee556a06b417",
            "id": "c986ca4c90a941ccb373a83d557efa12425e0ed56bc3f91ac8ce141534051446",
            "metadata": {},
            "name": "useCreateInlineCommentMutation",
            "operationKind": "mutation",
            "text": "mutation useCreateInlineCommentMutation($pageId:ID!,$input:CreateInlineCommentInput!,$includeReactionsSummary:Boolean!){createInlineComment(input:$input){id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactionsSummary){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}"
        }
    };
}();
$3dcbd79e6f23278f$var$node.hash = "1024b1212d3a391069987015908aee0c";
var $3dcbd79e6f23278f$export$2e2bcd8739ae039 = $3dcbd79e6f23278f$var$node;
module.exports["default"] = $3dcbd79e6f23278f$export$2e2bcd8739ae039;

});

parcelRegister("a8ZQ3", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $0e1f4810033038ec$export$82f0a2c62bb8fbf = /*#__PURE__*/ (0, $42omo.createContext)({
    documentUpdated: false,
    documentNeedsUpdate: false,
    publishedDocumentVersion: 0,
    currentDocumentVersion: 0
});
$0e1f4810033038ec$export$82f0a2c62bb8fbf.displayName = 'DocumentUpdateStatusContext';
const $0e1f4810033038ec$export$d35f8c93092bdd5a = /*#__PURE__*/ (0, $42omo.createContext)({
    setDocumentUpdated: ()=>{},
    setDocumentNeedsUpdate: ()=>{},
    setPublishedDocumentVersion: ()=>{},
    setCurrentDocumentVersion: ()=>{}
});
$0e1f4810033038ec$export$d35f8c93092bdd5a.displayName = 'DocumentUpdateStatusDispatchContext';
const $0e1f4810033038ec$export$e1e6df7f9af5d046 = ({ children: children })=>{
    const [documentUpdated, setDocumentUpdated] = (0, $42omo.useState)(false);
    const [documentNeedsUpdate, setDocumentNeedsUpdate] = (0, $42omo.useState)(false);
    const [publishedDocumentVersion, setPublishedDocumentVersion] = (0, $42omo.useState)(0);
    const [currentDocumentVersion, setCurrentDocumentVersion] = (0, $42omo.useState)(0);
    const providerValue = (0, $42omo.useMemo)(()=>({
            documentUpdated: documentUpdated,
            documentNeedsUpdate: documentNeedsUpdate,
            publishedDocumentVersion: publishedDocumentVersion,
            currentDocumentVersion: currentDocumentVersion
        }), [
        documentUpdated,
        documentNeedsUpdate,
        publishedDocumentVersion,
        currentDocumentVersion
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setDocumentUpdated: setDocumentUpdated,
            setDocumentNeedsUpdate: setDocumentNeedsUpdate,
            setPublishedDocumentVersion: setPublishedDocumentVersion,
            setCurrentDocumentVersion: setCurrentDocumentVersion
        }), [
        setDocumentUpdated,
        setDocumentNeedsUpdate,
        setPublishedDocumentVersion,
        setCurrentDocumentVersion
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$82f0a2c62bb8fbf.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0e1f4810033038ec$export$d35f8c93092bdd5a.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $0e1f4810033038ec$export$ff9e1d20f8dc4075 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$82f0a2c62bb8fbf);
};
const $0e1f4810033038ec$export$317fac591d89e2e3 = ()=>{
    return (0, $42omo.useContext)($0e1f4810033038ec$export$d35f8c93092bdd5a);
};
module.exports["DocumentUpdateStatusProvider"] = $0e1f4810033038ec$export$e1e6df7f9af5d046;
module.exports["useDocumentUpdateStatus"] = $0e1f4810033038ec$export$ff9e1d20f8dc4075;
module.exports["useDocumentUpdateStatusDispatch"] = $0e1f4810033038ec$export$317fac591d89e2e3;

});

parcelRegister("aMfLn", function(module, exports) {

var $aXG5V = parcelRequire("aXG5V");


var $kDIns = parcelRequire("kDIns");

const $194c389c7ab5ab2c$export$bbbd7ccaedea9691 = async ({ rendererActions: rendererActions, contentId: contentId, triggerAnalyticsEvent: triggerAnalyticsEvent, updateUnresolvedInlineComment: updateUnresolvedInlineComment })=>{
    const allAnnotationMarks = rendererActions?.getAnnotationMarks();
    const allAnnotationIds = allAnnotationMarks?.map((mark)=>mark.attrs.id) || [];
    (0, $kDIns.getRendererAnnotationStates)({
        annotations: allAnnotationIds,
        pageId: contentId,
        triggerAnalyticsEvent: triggerAnalyticsEvent,
        validAnnotationsCallback: updateUnresolvedInlineComment,
        isNestedRender: false
    }).catch(()=>{
    //intentional no-op
    });
};
const $194c389c7ab5ab2c$export$2600439b3e609c06 = (step, pos)=>{
    // AddMarkStep has additional properties that aren't allowed in the mutation variables
    const markInfo = {
        mark: {
            attrs: {
                annotationType: 'inlineComment',
                id: step.mark.attrs.id
            },
            type: 'annotation'
        }
    };
    // TODO: remove this logic since pos should be read from step
    if (pos !== undefined) return {
        pos: pos,
        ...markInfo
    };
    if (step instanceof (0, $aXG5V.AddMarkStep) || step instanceof (0, $aXG5V.RemoveMarkStep)) {
        const { from: from, to: to } = step;
        return {
            from: from,
            to: to,
            ...markInfo
        };
    }
    return {
        pos: step.pos,
        ...markInfo
    };
};
module.exports["updateRendererAnnotations"] = $194c389c7ab5ab2c$export$bbbd7ccaedea9691;
module.exports["constructStepForGql"] = $194c389c7ab5ab2c$export$2600439b3e609c06;

});

parcelRegister("3Xfi8", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");


var $7nPJ6 = parcelRequire("7nPJ6");


var $6HwWx = parcelRequire("6HwWx");

const $6a7e747c5d5174c7$export$9be7dcbe458ba189 = ({ annotationElement: annotationElement, isEditor: isEditor })=>{
    const classToCheck = '.pm-table-container';
    let elementToObserve = undefined;
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // elements to observe, these are different than elements that determine if the table is sticky
    if (isEditor) elementToObserve = isStickyHeaderExperimentEnabled ? annotationElement?.closest(classToCheck)?.querySelector('.pm-table-wrapper > table > tbody > tr') : annotationElement?.closest(classToCheck)?.parentElement?.querySelector('.pm-table-sticky-sentinel-top');
    else elementToObserve = annotationElement?.closest(classToCheck);
    const [isSticky, setIsSticky] = (0, $7nPJ6.useIsSticky)({
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    (0, $6HwWx.useStickyTableHeaderObserver)({
        setIsSticky: setIsSticky,
        isEditor: isEditor,
        elementToObserve: elementToObserve
    });
    // Check if annotationElement is a child of tr (th element) and th's immediate parent is tbody
    const thElement = annotationElement?.closest('th');
    if (thElement) {
        const trElement = thElement.parentElement;
        const tbodyElement = trElement?.parentElement;
        // If tr is the first child of tbody, return false
        if (tbodyElement?.firstElementChild !== trElement) return {
            isSticky: false
        };
    }
    // if annotation element is inside a nested table, then return false
    if (annotationElement?.closest('.pm-table-nested-table-with-controls')) return {
        isSticky: false
    };
    // if annotation element is not inside a table header, then return false
    if (!annotationElement?.closest('th')) return {
        isSticky: false
    };
    // Remove debug console logs
    return {
        isSticky: isSticky
    };
};
module.exports["useShouldCommentSidebarBeSticky"] = $6a7e747c5d5174c7$export$9be7dcbe458ba189;

});

parcelRegister("7nPJ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jW2Ig = parcelRequire("jW2Ig");

const $b1509838bb0fcfff$export$2cf94d5875603a88 = ({ isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // check if table is already sticky
    const initialStickyState = elementToObserve ? (0, $jW2Ig.getIsSticky)(isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve.parentElement, isEditor) : false;
    const [isSticky, setIsSticky] = (0, $42omo.useState)((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') && initialStickyState);
    // Sticky state effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    // Sticky state effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        setIsSticky(initialStickyState);
    }, [
        initialStickyState
    ]);
    return [
        isSticky,
        setIsSticky
    ];
};
module.exports["useIsSticky"] = $b1509838bb0fcfff$export$2cf94d5875603a88;

});

parcelRegister("jW2Ig", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

const $28177804efc2055d$export$17682ee29db08043 = (tableElement)=>{
    return Boolean(tableElement?.getAttribute('mode') === 'stick');
};
const $28177804efc2055d$export$4676b00e54210cb0 = (tableElement)=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    if (isStickyHeaderExperimentEnabled) return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
    return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};
const $28177804efc2055d$export$f3993a99776f75ca = (tableElement, isEditor)=>isEditor ? $28177804efc2055d$export$4676b00e54210cb0(tableElement) : $28177804efc2055d$export$17682ee29db08043(tableElement);
module.exports["isStickyInViewMode"] = $28177804efc2055d$export$17682ee29db08043;
module.exports["isStickyInEditMode"] = $28177804efc2055d$export$4676b00e54210cb0;
module.exports["getIsSticky"] = $28177804efc2055d$export$f3993a99776f75ca;

});

parcelRegister("6HwWx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $jW2Ig = parcelRequire("jW2Ig");

const $cf08b287de1b8d82$export$204fd756b18b92ff = ({ setIsSticky: setIsSticky, isEditor: isEditor, elementToObserve: elementToObserve })=>{
    const isStickyHeaderExperimentEnabled = (0, $6mKj3.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && (0, $6mKj3.expVal)('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);
    // if the experiment is enabled and this is the editor, we need to observe the table element
    // else, we observe the parent element
    const stickyElementToObserve = isEditor && isStickyHeaderExperimentEnabled ? elementToObserve : elementToObserve?.parentElement;
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        // Create mutation observer to track class changes
        const stickyTableHeaderObserver = new MutationObserver((mutationsList)=>{
            mutationsList.forEach((mutation)=>{
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (isEditor && (0, $jW2Ig.isStickyInEditMode)(target) || (0, $jW2Ig.isStickyInViewMode)(target)) setIsSticky(true);
                    else setIsSticky(false);
                }
            });
        });
        // Start observing class changes
        if (stickyElementToObserve) stickyTableHeaderObserver.observe(stickyElementToObserve, {
            attributes: true,
            attributeFilter: [
                'class'
            ]
        });
        // Clean up all observers
        return ()=>{
            stickyTableHeaderObserver.disconnect();
        };
    }, [
        stickyElementToObserve,
        isEditor,
        setIsSticky
    ]);
};
module.exports["useStickyTableHeaderObserver"] = $cf08b287de1b8d82$export$204fd756b18b92ff;

});

parcelRegister("eA7s6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aHcFH = parcelRequire("aHcFH");

const $168172ede45a02b4$export$aca484f2c8185777 = ({ annotationElement: annotationElement, isEditor: isEditor, isViewCommentMode: isViewCommentMode, windowWidth: windowWidth, isSticky: isSticky })=>{
    return (0, $42omo.useMemo)(()=>{
        if (!annotationElement) return 0;
        if (isEditor) return (0, $aHcFH.calculateEditorOffsetFromParent)(annotationElement, '.fabric-editor-popup-scroll-parent');
        return (0, $aHcFH.calculateRendererOffsetFromParent)(annotationElement, `[data-annotation-draft-mark="true"]`, Boolean(isViewCommentMode));
    // We want to re-calculate when the window width changes or the comment sidebar becomes sticky / unsticky
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isEditor,
        annotationElement,
        isViewCommentMode,
        windowWidth,
        isSticky
    ]);
};
module.exports["useCommentSidebarOffset"] = $168172ede45a02b4$export$aca484f2c8185777;

});

parcelRegister("5pQ1Y", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $676464c7222bdee0$export$d84a6ddaa8e6e9d9 = /*#__PURE__*/ (0, $42omo.createContext)({
    refetchContent: false
});
$676464c7222bdee0$export$d84a6ddaa8e6e9d9.displayName = 'ContentRefetchContext';
const $676464c7222bdee0$export$dfd2d999f6a2731 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRefetchContent: ()=>{}
});
$676464c7222bdee0$export$dfd2d999f6a2731.displayName = 'ContentRefetchDispatchContext';
const $676464c7222bdee0$export$cfa813593f7b7ba = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children } = t0;
    const [refetchContent, setRefetchContent] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== refetchContent) {
        t1 = {
            refetchContent: refetchContent
        };
        $[0] = refetchContent;
        $[1] = t1;
    } else t1 = $[1];
    const providerValue = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            setRefetchContent: (shouldRefetchContent)=>setRefetchContent(shouldRefetchContent)
        };
        $[2] = t2;
    } else t2 = $[2];
    const dispatchProviderValue = t2;
    let t3;
    if ($[3] !== children) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$dfd2d999f6a2731.Provider, {
            value: dispatchProviderValue
        }, children);
        $[3] = children;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== providerValue || $[6] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($676464c7222bdee0$export$d84a6ddaa8e6e9d9.Provider, {
            value: providerValue
        }, t3);
        $[5] = providerValue;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
const $676464c7222bdee0$export$68e22604851d391b = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$d84a6ddaa8e6e9d9);
};
const $676464c7222bdee0$export$8ebf7a2378ada555 = ()=>{
    return (0, $42omo.useContext)($676464c7222bdee0$export$dfd2d999f6a2731);
};
module.exports["ContentRefetchProvider"] = $676464c7222bdee0$export$cfa813593f7b7ba;
module.exports["useContentRefetch"] = $676464c7222bdee0$export$68e22604851d391b;
module.exports["useContentRefetchDispatch"] = $676464c7222bdee0$export$8ebf7a2378ada555;

});

parcelRegister("en1dX", function(module, exports) {
var $88e03e673e36ecc4$export$6890652a1aff7d1c = /*#__PURE__*/ function(AnalyticsSource) {
    AnalyticsSource["COMMENTS_PANEL"] = "commentsPanel";
    AnalyticsSource["STANDALONE"] = "standalone";
    AnalyticsSource["PAGE_FOOTER"] = "pageFooter";
    return AnalyticsSource;
}({});
var $88e03e673e36ecc4$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["REOPEN_COMMENT"] = "reopenComment";
    return ActionName;
}({});
var $88e03e673e36ecc4$export$ffa1150e6a48f9cd = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    CommentType["PAGE"] = "page";
    return CommentType;
}({});
module.exports["AnalyticsSource"] = $88e03e673e36ecc4$export$6890652a1aff7d1c;
module.exports["ActionName"] = $88e03e673e36ecc4$export$9c95d6e1614bad84;
module.exports["CommentType"] = $88e03e673e36ecc4$export$ffa1150e6a48f9cd;

});

parcelRegister("9FoVw", function(module, exports) {
/**
 * @fileoverview Unified comment navigation utilities for scrolling to different comment types
 * and handling various navigation scenarios across editor and renderer contexts.
 */ 
var $21K7m = parcelRequire("21K7m");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6mKj3 = parcelRequire("6mKj3");


var $4L9ve = parcelRequire("4L9ve");


var $kgNLQ = parcelRequire("kgNLQ");


var $i49vP = parcelRequire("i49vP");


var $aHcFH = parcelRequire("aHcFH");

var $0343eaf78527fd4c$export$99058db374262376 = /*#__PURE__*/ function(ShortcutType) {
    ShortcutType["NEXT"] = "next";
    ShortcutType["PREVIOUS"] = "previous";
    ShortcutType["UNREAD"] = "unread";
    return ShortcutType;
}({});
var $0343eaf78527fd4c$var$CommentType = /*#__PURE__*/ function(CommentType) {
    CommentType["INLINE"] = "inline";
    CommentType["GENERAL"] = "general";
    return CommentType;
}($0343eaf78527fd4c$var$CommentType || {});
var $0343eaf78527fd4c$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
// Navigation types based on comment scrolling architecture
var $0343eaf78527fd4c$var$NavigationType = /*#__PURE__*/ function(NavigationType) {
    NavigationType["INLINE_ANNOTATION"] = "inline_annotation";
    NavigationType["COMMENTS_PANEL"] = "comments_panel";
    NavigationType["FOOTER_COMMENTS"] = "footer_comments";
    NavigationType["DEEP_LINK"] = "deep_link";
    NavigationType["KEYBOARD_SHORTCUT"] = "keyboard_shortcut";
    NavigationType["INLINE_HEADER_ARROWS"] = "inline_header_arrows";
    return NavigationType;
}($0343eaf78527fd4c$var$NavigationType || {});
var $0343eaf78527fd4c$export$e6e360ac7d345e5 = /*#__PURE__*/ function(ScrollBehavior) {
    ScrollBehavior["INSTANT"] = "instant";
    ScrollBehavior["SMOOTH"] = "smooth";
    return ScrollBehavior;
}({});
var $0343eaf78527fd4c$export$3044ab7fdabeaee6 = /*#__PURE__*/ function(NavigationContext) {
    NavigationContext["EDITOR"] = "editor";
    NavigationContext["RENDERER"] = "renderer";
    NavigationContext["PANEL"] = "panel";
    NavigationContext["REPLY"] = "reply";
    return NavigationContext;
}({});
var $0343eaf78527fd4c$export$368ed1d84e0ae668 = /*#__PURE__*/ function(CommentNavigationStatus) {
    CommentNavigationStatus["FOUND_IN_DOM"] = "FOUND_IN_DOM";
    CommentNavigationStatus["DELETED_CONTENT"] = "DELETED_CONTENT";
    CommentNavigationStatus["RESOLVED"] = "RESOLVED";
    CommentNavigationStatus["UNKNOWN"] = "UNKNOWN";
    CommentNavigationStatus["REMOVED_BY_ANOTHER_USER"] = "REMOVED_BY_ANOTHER_USER";
    return CommentNavigationStatus;
}({});
const $0343eaf78527fd4c$export$9f32f1ed184088e0 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, inline: inline, markElement: markElement, annotationId: annotationId } = options;
    if (!markElement) return false;
    // Handle different contexts
    switch(context){
        case "editor":
            // Check if element needs to be expanded in editor
            (0, $i49vP.checkElementExpandInEditor)(markElement);
            // Emit the setselectedannotation event
            const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
            editorEmitter.emit('setselectedannotation', markElement.id);
            // Scroll to the element in editor
            (0, $i49vP.scrollToElementInEditor)({
                targetElement: markElement,
                viewingRoomOffset: -100
            });
            return true;
        case "renderer":
            // Renderer-specific logic with improved focus management
            const focusedMarkerRef = document.querySelector("[data-has-focus='true']");
            if (focusedMarkerRef?.id !== markElement.id) {
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: markElement.id
                });
                // Check if element needs to be expanded
                (0, $aHcFH.checkElementExpand)(markElement, true);
            }
            // Scroll to the annotation mark
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        case "panel":
            // For panel context, ensure annotation is visible and highlighted
            if (annotationId) {
                // Emit events to ensure the annotation is properly focused
                const emitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                emitter.emit((0, $21K7m.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, {
                    annotationId: annotationId
                });
            }
            // Scroll the annotation into view
            markElement.scrollIntoView({
                behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
                block: block,
                inline: inline
            });
            return true;
        default:
            return false;
    }
};
/**
 * Wait for the comments panel to be rendered in the DOM
 * Returns a Promise that resolves when the panel is available or times out after 5 seconds
 */ const $0343eaf78527fd4c$var$waitForCommentsPanel = ()=>{
    const commentsPanelListContainerId = 'comments-panel-list-container';
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const panel = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
            if (panel) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Start observing the document body for changes
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 5000); // 5 second timeout
    });
};
/**
 * Wait for the comments panel view/filter to change to the specified view
 * Returns a Promise that resolves when the view change is complete or times out after 3 seconds
 */ const $0343eaf78527fd4c$var$waitForViewChange = (expectedView)=>{
    return new Promise((resolve)=>{
        // Check if the view has already changed by checking the data-current-view attribute on the container
        const checkView = ()=>{
            const container = document.querySelector('[data-testid="comments-panel-list-container"]');
            if (container && container.getAttribute('data-current-view') === expectedView) return true;
        };
        if (checkView()) {
            resolve(true);
            return;
        }
        // Observe document body for both container creation and attribute changes
        // This handles cases where the container gets unmounted/remounted
        const observer = new MutationObserver(()=>{
            if (checkView()) {
                observer.disconnect();
                resolve(true);
            }
        });
        // Observe the entire document body to catch:
        // 1. Container being created/removed
        // 2. Attribute changes on the container when it exists
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                'data-current-view'
            ]
        });
        // Set a timeout to avoid infinite waiting
        setTimeout(()=>{
            observer.disconnect();
            resolve(false);
        }, 3000); // 3 second timeout
    });
};
/**
 * Check if the top edge of an element is visible in the viewport
 * Used to determine if scrolling is needed based on element visibility
 */ const $0343eaf78527fd4c$var$isElementTopVisible = (element)=>{
    const rect = element.getBoundingClientRect();
    return rect.top >= 0;
};
/**
 * Wait for an element to finish scrolling into view
 * Returns a Promise that resolves when the element is reasonably visible or times out
 */ const $0343eaf78527fd4c$var$waitForScrollCompletion = (element, timeout = 3000)=>{
    return new Promise((resolve)=>{
        const startTime = Date.now();
        const check = ()=>{
            if ($0343eaf78527fd4c$var$isElementTopVisible(element)) // Add a small delay after element becomes visible to let scrolling settle
            setTimeout(()=>resolve(true), 150);
            else if (Date.now() - startTime > timeout) resolve(false);
            else requestAnimationFrame(check);
        };
        // Small delay to let scroll animation start
        setTimeout(check, 16);
    });
};
/**
 * Helper function for viewport checking - returns true if should skip scrolling due to viewport visibility
 */ const $0343eaf78527fd4c$var$checkAndHandleViewportVisibility = (element, shouldScrollIfCommentIsInViewport)=>{
    if (!shouldScrollIfCommentIsInViewport) {
        const commentIsInViewport = $0343eaf78527fd4c$var$isElementTopVisible(element);
        if (commentIsInViewport) return true;
    }
    return false;
};
/**
 * Handle scroll completion based on awaitScrollCompletion flag and scroll behavior
 */ const $0343eaf78527fd4c$var$handleScrollCompletion = (awaitScrollCompletion, scrollBehavior, element)=>{
    if (awaitScrollCompletion) return scrollBehavior === "smooth" ? $0343eaf78527fd4c$var$waitForScrollCompletion(element) : Promise.resolve(true);
    return true;
};
/**
 * Check if an element is already fully visible within the panel
 * Avoids unnecessary scrolling if the element is already in view
 */ const $0343eaf78527fd4c$var$isElementFullyVisible = (element)=>{
    const elementRect = element.getBoundingClientRect();
    const panelContainer = document.querySelector('[data-testid="comments-panel-list-container"]');
    const panelRect = panelContainer?.getBoundingClientRect();
    if (!panelRect) return false;
    return elementRect.top >= panelRect.top && elementRect.bottom <= panelRect.bottom;
};
/**
 * Determine the optimal scroll position based on context and comment type
 * Considers whether to scroll to start, center, or end based on various factors
 */ const $0343eaf78527fd4c$var$determineScrollPosition = (element, block, scrollToEnd, commentType)=>{
    let scrollBlock = block;
    if (scrollToEnd) {
        // Check if the comment thread reply is out of view
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const isOutOfView = (0, $aHcFH.isCommentThreadReplyOutOfView)(element, commentTypeEnum);
        if (isOutOfView) scrollBlock = 'end';
    } else {
        // Check if we should scroll to top
        // Map CommentsType to CommentType enum for domUtils functions
        const commentTypeEnum = commentType === 'INLINE' ? "inline" : "general";
        const shouldScrollToTop = (0, $aHcFH.shouldScrollCommentThreadToTop)(element, commentTypeEnum);
        if (shouldScrollToTop) scrollBlock = 'start';
    }
    return scrollBlock;
};
/**
 * Perform the actual scrolling operation with optimized behavior
 * Handles different scroll scenarios based on user interaction context
 */ const $0343eaf78527fd4c$var$performScrollToElement = (element, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType)=>{
    // Skip scrolling if element is already fully visible
    if ($0343eaf78527fd4c$var$isElementFullyVisible(element)) return;
    // Determine scroll behavior based on trigger type
    if (hasKeyPressed || annotationClicked || scrollOnLoad) {
        const scrollBlock = $0343eaf78527fd4c$var$determineScrollPosition(element, block, scrollToEnd, commentType);
        element.scrollIntoView({
            behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
            block: scrollBlock
        });
    } else // Default scroll behavior
    element.scrollIntoView({
        behavior: scrollBehavior === "instant" ? 'instant' : 'smooth',
        block: block
    });
};
const $0343eaf78527fd4c$export$390f6df30bfcd812 = (options)=>{
    const { scrollBehavior: scrollBehavior, context: context, block: block, commentId: commentId, annotationId: annotationId, commentType: commentType, scrollToEnd: scrollToEnd = false, hasKeyPressed: hasKeyPressed = false, annotationClicked: annotationClicked = false, scrollOnLoad: scrollOnLoad = false, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    // Only handle panel context navigation
    if (context !== "panel") return false;
    // Define panel container and thread selectors
    const commentsPanelListContainerId = 'comments-panel-list-container';
    // annotationId is used for DOM selectors, commentId is the actual comment identifier
    const commentThreadContainerId = `comment-thread-${annotationId}-container`;
    // Check if panel is available, wait if not
    const panelContainer = document.querySelector(`[data-testid='${commentsPanelListContainerId}']`);
    if (!panelContainer) // Panel is not rendered yet, wait for it to appear
    return $0343eaf78527fd4c$var$waitForCommentsPanel().then((panelAvailable)=>{
        if (panelAvailable) // Recursively call the function now that panel is available
        return $0343eaf78527fd4c$export$390f6df30bfcd812(options);
        return false;
    });
    // Look for the specific comment thread container
    const commentThreadElement = document.querySelector(`[data-testid='${commentThreadContainerId}']`);
    // If comment thread exists, scroll immediately
    if (commentThreadElement) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(commentThreadElement, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        $0343eaf78527fd4c$var$performScrollToElement(commentThreadElement, scrollBehavior, block, scrollToEnd, hasKeyPressed, annotationClicked, scrollOnLoad, commentType);
        // For panel navigation, always return Promise when awaitScrollCompletion is true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, commentThreadElement);
    }
    // Use optimized observer to watch for comment thread container creation
    commentId && (0, $aHcFH.watchForCommentContainerAndScroll)(commentId);
    return true;
};
const $0343eaf78527fd4c$export$dcd3c0d6a66d0412 = async (options)=>{
    const { expectedView: expectedView, commentId: commentId, annotationId: annotationId, ...navigationOptions } = options;
    // Only wait for view change for panel context
    if (navigationOptions.context === "panel" && expectedView) await $0343eaf78527fd4c$var$waitForViewChange(expectedView);
    // Then perform the navigation - pass both commentId and annotationId
    return $0343eaf78527fd4c$export$390f6df30bfcd812({
        ...navigationOptions,
        commentId: commentId,
        annotationId: annotationId
    });
};
const $0343eaf78527fd4c$export$34fd7e98d0739b5c = (options)=>{
    const { block: block, inline: inline, commentId: commentId, scrollBehavior: scrollBehavior, navigationContext: navigationContext, shouldScrollIfCommentIsInViewport: shouldScrollIfCommentIsInViewport = true, awaitScrollCompletion: awaitScrollCompletion = false } = options;
    let containerId;
    if (!commentId) return false;
    // Check if comment already exists in DOM
    // Determine container ID based on navigation context:
    // - PANEL: uses comment-thread container
    // - REPLY: uses data-comment-id attribute selector
    // - Default (footer): uses footer-comment-thread container
    if (navigationContext === "panel") containerId = `comment-thread-${commentId}-container`;
    else if (navigationContext === "reply") containerId = `[data-comment-id="${commentId}"]`;
    else containerId = `footer-comment-thread-${commentId}-container`;
    // Use querySelector for REPLY context (attribute selector), getElementById for others (ID)
    const existingComment = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
    if (existingComment) {
        const skipScrollDueToViewport = $0343eaf78527fd4c$var$checkAndHandleViewportVisibility(existingComment, shouldScrollIfCommentIsInViewport);
        if (skipScrollDueToViewport) return true;
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        // Wait for scroll completion when awaitScrollCompletion is true, otherwise return true
        return $0343eaf78527fd4c$var$handleScrollCompletion(awaitScrollCompletion, scrollBehavior, existingComment);
    } else {
        // Comment not yet rendered, use DOM resolver to watch for it
        (0, $aHcFH.watchForCommentRepliesAndScroll)({
            targetCommentId: commentId,
            onScrollReady: (commentElement)=>{
                // Find the container element by ID or selector based on navigation context
                const containerElement = navigationContext === "reply" ? document.querySelector(containerId) : document.getElementById(containerId);
                const elementToScroll = containerElement || commentElement;
                elementToScroll.scrollIntoView({
                    behavior: scrollBehavior,
                    block: block,
                    inline: inline
                });
            },
            containerId: containerId
        });
        return true;
    }
};
const $0343eaf78527fd4c$export$ea1c337d9000e2 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, commentId: commentId, markElement: markElement, context: context } = options;
    if (!commentId || !markElement) return false;
    // Check if comment already exists in DOM
    const existingComment = document.querySelector(`[data-comment-id="${commentId}"]`);
    if (existingComment) {
        // Comment is already rendered, scroll to it immediately
        existingComment.scrollIntoView({
            behavior: scrollBehavior,
            block: block,
            inline: inline
        });
        return true;
    }
    // we need to click on the annotation in the editor if the comment is not yet rendered
    if (context === "editor" && markElement) (0, $i49vP.openInlineCommentInEditor)({
        targetElement: markElement,
        targetElementID: markElement.id,
        shouldScroll: false
    });
    // Comment not yet rendered, use DOM resolver to watch for it
    (0, $aHcFH.watchForCommentRepliesAndScroll)({
        targetCommentId: commentId,
        onScrollReady: (commentElement)=>{
            commentElement.scrollIntoView({
                behavior: scrollBehavior,
                block: block,
                inline: inline
            });
        },
        markElement: markElement
    });
    return true;
};
const $0343eaf78527fd4c$export$807107038899c351 = (options)=>{
    const { scrollBehavior: scrollBehavior, block: block, inline: inline, annotationId: annotationId, commentId: commentId, commentType: commentType, isCommentsPanelOpen: isCommentsPanelOpen, hasKeyPressed: hasKeyPressed = true, scrollToEnd: scrollToEnd = false, context: context, shortcutType: shortcutType, isResolved: isResolved, previousAnnotationId: previousAnnotationId } = options;
    // Get the mark element for both inline navigation and annotation events
    let markElement = document.getElementById(annotationId);
    const commentElement = document.querySelector(`[data-comment-id="${commentId}"]`);
    // Get the previous comment element for difference-based scrolling
    const previousCommentElement = previousAnnotationId ? document.getElementById(previousAnnotationId) : null;
    // Check if the mark element is in a sticky table header and adjust if needed
    const isInStickyTableHeader = markElement?.closest && markElement.closest('.pm-table-sticky-wrapper');
    if (isInStickyTableHeader && markElement && (0, $6mKj3.expValEquals)('confluence_comment_enable_table_header_navigation', 'isEnabled', true)) // Get the real element from the non-sticky table using getNodeForTableORMacro
    markElement = (0, $aHcFH.getNodeForTableORMacro)(markElement) || markElement;
    if (commentType === 'FOOTER') $0343eaf78527fd4c$export$34fd7e98d0739b5c({
        scrollBehavior: scrollBehavior,
        block: block,
        inline: inline || 'center',
        commentId: annotationId
    });
    // If comments panel is open, use panel navigation
    if (isCommentsPanelOpen) {
        // For inline comments, also call handleInlineAnnotationNavigation to ensure proper inline comment behavior
        if (commentType === 'INLINE' && !isResolved) $0343eaf78527fd4c$export$9f32f1ed184088e0({
            scrollBehavior: scrollBehavior,
            context: context || "panel",
            block: block,
            inline: inline || 'center',
            markElement: markElement,
            annotationId: annotationId
        });
        // This ensure the ViewComponent useEffect is not triggered
        if (markElement && !isResolved) {
            // Emit annotation events for panel navigation
            if (context === "editor") {
                const editorEmitter = (0, $gfqXk.getEditorAnnotationEventEmitter)();
                editorEmitter.emit('setselectedannotation', annotationId);
            } else if (context === "renderer") {
                const rendererEmitter = (0, $gczDe.getRendererAnnotationEventEmitter)();
                rendererEmitter.emit((0, $21K7m.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
                    annotationIds: [
                        annotationId
                    ],
                    eventTarget: null
                });
            }
        }
        // Use the existing panel navigation logic
        const result = $0343eaf78527fd4c$export$390f6df30bfcd812({
            scrollBehavior: scrollBehavior,
            context: "panel",
            block: block,
            inline: inline,
            annotationId: annotationId,
            commentType: commentType,
            hasKeyPressed: hasKeyPressed,
            scrollToEnd: scrollToEnd
        });
        if (result instanceof Promise) // For async panel navigation, return true immediately
        // The actual navigation will happen asynchronously
        return true;
        return result;
    }
    if (!markElement) return false;
    // For standalone navigation (comments panel closed), expand the element if needed
    if (commentType === 'INLINE' && context === "renderer") (0, $aHcFH.checkElementExpand)(markElement, true);
    // Use difference-based scrolling if we have both previous and next elements
    if (previousCommentElement && markElement && previousCommentElement !== markElement && (0, $6mKj3.expValEquals)('confluence_comment_use_kbs_exp', 'isEnabled', true)) {
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between next and previous comment positions
                const nextRect = markElement.getBoundingClientRect();
                const previousRect = previousCommentElement.getBoundingClientRect();
                const differenceOffset = nextRect.top - previousRect.top;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment with difference-based scrolling
        (0, $aHcFH.scrollToComment)(markElement, previousCommentElement, true, false);
        return true;
    }
    // For unread navigation, scroll to the comment element with data-comment-id instead of markElement
    if (shortcutType === "unread" && commentElement) commentElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    else // For standalone navigation, we don't emit events - just scroll to the element
    markElement.scrollIntoView({
        behavior: scrollBehavior,
        block: block,
        inline: inline || 'nearest'
    });
    return true;
};
/**
 * Calculate the height of media comment placeholder to adjust scroll offset.
 * When the media comment placeholder is visible, it pushes the contents of the page down,
 * so we need to scroll a bit less to keep the cursor over the navigation arrow icon.
 */ const $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight = (options)=>{
    const { previousCommentElement: previousCommentElement, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    const isCurrentCommentContentMediaComment = previousCommentElement?.closest('.media-single-node');
    const isNavigatingToLastCommentFromPreviousAction = action === 'previous' && nextCommentIndex === totalComments - 1;
    const isNavigatingToFirstCommentFromNextAction = action === 'next' && nextCommentIndex === 0;
    if (isCurrentCommentContentMediaComment && (action === 'next' || isNavigatingToLastCommentFromPreviousAction || isNavigatingToFirstCommentFromNextAction)) {
        const mediaCommentSelectedPlaceholder = document.querySelector('[data-id="caption-placeholder"]');
        return mediaCommentSelectedPlaceholder ? mediaCommentSelectedPlaceholder.offsetHeight : 0;
    }
    return 0;
};
const $0343eaf78527fd4c$export$36dad1a923539611 = (options)=>{
    const { previousMarkerRef: previousMarkerRef, nextMarkerRef: nextMarkerRef, context: context, action: action, nextCommentIndex: nextCommentIndex, totalComments: totalComments } = options;
    // Get the next comment element
    const nextMarkElement = document.getElementById(nextMarkerRef);
    if (!nextMarkElement) return false;
    // Get the previous and next comment elements
    const previousCommentElement = document.getElementById(previousMarkerRef);
    const nextCommentElement = document.getElementById(nextMarkerRef);
    if (previousCommentElement && nextCommentElement) {
        const heightOfMediaCommentSelectedPlaceholder = $0343eaf78527fd4c$var$getMediaCommentPlaceholderHeight({
            previousCommentElement: previousCommentElement,
            action: action,
            nextCommentIndex: nextCommentIndex,
            totalComments: totalComments
        });
        if (context === "editor") {
            // For editor: use scrollableContainer.scrollBy with difference offset
            const scrollableContainer = document.querySelector('.fabric-editor-popup-scroll-parent');
            if (scrollableContainer) {
                // Calculate difference between current and previous comment positions using calculateElementOffset
                // This handles special cases like sticky table headers
                const previousOffset = (0, $aHcFH.calculateElementOffset)(previousCommentElement);
                const nextOffset = (0, $aHcFH.calculateElementOffset)(nextCommentElement);
                const differenceOffset = nextOffset - previousOffset - heightOfMediaCommentSelectedPlaceholder;
                scrollableContainer.scrollBy(0, differenceOffset);
            }
        } else // For renderer: use scrollToComment
        (0, $aHcFH.scrollToComment)(nextCommentElement, previousCommentElement, true, false);
    }
    return true;
};
/**
 * Wait for a comment marker element to appear in the DOM.
 * Resolves immediately if the element already exists, otherwise waits via MutationObserver until timeout.
 */ const $0343eaf78527fd4c$var$waitForCommentElement = ({ markerRef: markerRef, timeoutMs: timeoutMs })=>{
    const existingElement = document.getElementById(markerRef);
    if (existingElement) return Promise.resolve(existingElement);
    return new Promise((resolve)=>{
        const observer = new MutationObserver(()=>{
            const element = document.getElementById(markerRef);
            if (!element) return;
            observer.disconnect();
            resolve(element);
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        setTimeout(()=>{
            observer.disconnect();
            const fallbackElement = document.getElementById(markerRef);
            resolve(fallbackElement);
        }, timeoutMs);
    });
};
const $0343eaf78527fd4c$export$6591627df1eb1f44 = async ({ markerRef: markerRef, commentId: commentId, timeoutMs: timeoutMs = 3000, getCommentThreadsRemovedByOtherUsers: getCommentThreadsRemovedByOtherUsers })=>{
    let element = null;
    if (markerRef) element = await $0343eaf78527fd4c$var$waitForCommentElement({
        markerRef: markerRef,
        timeoutMs: timeoutMs
    });
    // Check if comment was removed by another user BEFORE checking processed state
    // This check happens early because it's a specific known state
    // NOTE - we can't import the official type here due to circular dep concerns
    if (commentId) {
        const commentThreadsRemovedByOtherUsers = getCommentThreadsRemovedByOtherUsers?.();
        if (commentThreadsRemovedByOtherUsers?.[commentId] === 'deleted') return {
            status: "REMOVED_BY_ANOTHER_USER",
            element: undefined
        };
    }
    // Read processed state after DOM wait to avoid stale classification.
    const state = (0, $4L9ve.getProcessedCommentsDataState)();
    const rootComment = state.isDataProcessed && markerRef ? state.flatMarkerRefMap[markerRef] : undefined;
    if (element) {
        if (rootComment && (0, $kgNLQ.isCommentResolved)(rootComment)) return {
            status: "RESOLVED",
            element: undefined
        };
        return {
            status: "FOUND_IN_DOM",
            element: element
        };
    }
    // Comment marker is missing from the DOM — classify as DELETED_CONTENT or UNKNOWN.
    // Note: classification depends on cc_comments_new_comments_data_manager being enabled.
    // When disabled, state isn't populated so are forced into FOUND_IN_DOM or UNKNOWN
    if (!state.isDataProcessed) return {
        status: "UNKNOWN",
        element: undefined
    };
    const existsInData = rootComment || commentId && state.flatCommentsMap[commentId];
    return existsInData ? {
        status: "DELETED_CONTENT",
        element: undefined
    } : {
        status: "UNKNOWN",
        element: undefined
    };
};
module.exports["ShortcutType"] = $0343eaf78527fd4c$export$99058db374262376;
module.exports["ScrollBehavior"] = $0343eaf78527fd4c$export$e6e360ac7d345e5;
module.exports["NavigationContext"] = $0343eaf78527fd4c$export$3044ab7fdabeaee6;
module.exports["CommentNavigationStatus"] = $0343eaf78527fd4c$export$368ed1d84e0ae668;
module.exports["handleInlineAnnotationNavigation"] = $0343eaf78527fd4c$export$9f32f1ed184088e0;
module.exports["handleCommentsPanelNavigation"] = $0343eaf78527fd4c$export$390f6df30bfcd812;
module.exports["handleCommentsPanelNavigationWithViewChange"] = $0343eaf78527fd4c$export$dcd3c0d6a66d0412;
module.exports["handleFooterCommentsNavigation"] = $0343eaf78527fd4c$export$34fd7e98d0739b5c;
module.exports["handleDeepLinkNavigation"] = $0343eaf78527fd4c$export$ea1c337d9000e2;
module.exports["handleKeyboardShortcutNavigation"] = $0343eaf78527fd4c$export$807107038899c351;
module.exports["handleInlineHeaderArrowsNavigation"] = $0343eaf78527fd4c$export$36dad1a923539611;
module.exports["waitForCommentStatus"] = $0343eaf78527fd4c$export$6591627df1eb1f44;

});

parcelRegister("5fMeR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");


var $21K7m = parcelRequire("21K7m");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $aWwYt = parcelRequire("aWwYt");


var $jvYFk = parcelRequire("jvYFk");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $htsj6 = parcelRequire("htsj6");


var $cZa7r = parcelRequire("cZa7r");


var $3mVfX = parcelRequire("3mVfX");


var $ep3mz = parcelRequire("ep3mz");


var $dANtQ = parcelRequire("dANtQ");


var $gEtAQ = parcelRequire("gEtAQ");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $gtj7V = parcelRequire("gtj7V");


var $cMvMc = parcelRequire("cMvMc");


var $8aF6s = parcelRequire("8aF6s");


var $bSvtO = parcelRequire("bSvtO");


var $6mKj3 = parcelRequire("6mKj3");


var $jmjWc = parcelRequire("jmjWc");


const $3b7f940e5fdc8097$var$CommentsPanelFilterMenu = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Cp4VO",
    name: "CommentsPanelFilterMenu",
    loader: async ()=>(await (parcelRequire("cNoeW"))).CommentsPanelFilterMenu
});

const $3b7f940e5fdc8097$var$CommentsPanelFooter = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "V6uhH",
    name: "CommentsPanelFooter",
    loader: async ()=>(await (parcelRequire("4YZhm"))).CommentsPanelFooter
});

const $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "EqpEC",
    name: "CommentsPanelHeaderIcon",
    loader: async ()=>(await (parcelRequire("hSNPc"))).CommentsPanelHeaderIcon
});

const $3b7f940e5fdc8097$var$CommentsPanelWrapper = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "r3W5r",
    name: "CommentsPanelWrapper",
    loader: async ()=>(await (parcelRequire("5Rovr"))).CommentsPanelWrapper
});
const $3b7f940e5fdc8097$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    commentsPanelHeaderLabel: {
        id: "comments-panel.panel.header.label",
        defaultMessage: "Comments"
    }
});
const $3b7f940e5fdc8097$export$833f9a16214bbf3d = ()=>{
    const isSpaceOverviewPage = (0, $gEtAQ.isSpaceOverview)();
    const isDatabaseView = (0, $gEtAQ.isDatabase)();
    const isWhiteboardView = (0, $gEtAQ.isWhiteboard)();
    const { contentStatus: contentStatus } = (0, $htsj6.useContentStatus)();
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const { showObjectSidebar: showObjectSidebar, hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const { setViewProps: setViewProps, setEditorViewProps: setEditorViewProps } = (0, $cZa7r.useAnnotationsDispatch)();
    const { setCurrentView: setCurrentView, setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey, setReplyToCommentId: setReplyToCommentId } = (0, $3mVfX.useCommentsPanelActions)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { canAddComments: canAddComments } = (0, $dANtQ.useAddCommentPermissionCheck)(contentId ?? '', true);
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    // a ref is needed here because of a closure issue with canClosePanel
    const hasContentChangedRef = (0, $42omo.useRef)(hasContentChanged);
    (0, $42omo.useEffect)(()=>{
        hasContentChangedRef.current = hasContentChanged;
    }, [
        hasContentChanged
    ]);
    const onPanelCloseFunction = ()=>{
        setCurrentView(undefined);
        // Unselect active annotations on the page
        if (pageMode === (0, $cD1qu.PageMode).VIEW) {
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
            setViewProps(null);
        } else {
            eventEmitter.emit('setselectedannotation', '');
            setEditorViewProps(null);
        }
        // clear selected comment thread in the comments panel
        setCurrentlySelectedThreadKey('');
        setReplyToCommentId();
    };
    const onPanelCloseCallback = (0, $42omo.useCallback)(onPanelCloseFunction, [
        setCurrentView,
        pageMode,
        eventEmitter,
        setViewProps,
        setEditorViewProps,
        setCurrentlySelectedThreadKey,
        setReplyToCommentId
    ]);
    const onPanelClose = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? onPanelCloseCallback : onPanelCloseFunction;
    const canClosePanel = (0, $42omo.useCallback)(async ()=>{
        if (hasContentChangedRef.current && !(0, $9wGTI.fg)('confluence_comments_fix_duplicate_modal')) return new Promise((resolve)=>{
            showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged && resetContentChanged();
                    resolve(true);
                },
                onCancel: ()=>{
                    resolve(false);
                }
            });
        });
        else return true;
    }, [
        resetContentChanged,
        showModal
    ]);
    const showCommentsPanelFunction = ({ openWithView: openWithView } = {})=>{
        if (!allowComments) return;
        experienceTracker.start({
            name: (0, $irVI7.SIDEBAR_COMMENTS_PANEL_LOAD_EXPERIENCE),
            attributes: {
                ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                openWithView: openWithView,
                contentId: contentId,
                pageMode: pageMode
            }
        });
        const loadFooterComments = pageMode !== (0, $cD1qu.PageMode).EDIT;
        showObjectSidebar({
            id: (0, $jvYFk.PanelName).CommentsPanel,
            headerComponentElements: {
                HeaderIcon: $3b7f940e5fdc8097$var$CommentsPanelHeaderIcon,
                headerLabel: $3b7f940e5fdc8097$export$a7357cdd1f0b0168.commentsPanelHeaderLabel,
                HeaderRightAlignedElement: $3b7f940e5fdc8097$var$CommentsPanelFilterMenu
            },
            BodyComponent: ()=>$3b7f940e5fdc8097$var$CommentsPanelWrapper({
                    openWithView: openWithView
                }),
            FooterComponent: canAddComments && contentStatus !== (0, $cD1qu.ContentStatus).DRAFT && loadFooterComments && !isSpaceOverviewPage && !isDatabaseView && !isWhiteboardView ? $3b7f940e5fdc8097$var$CommentsPanelFooter : undefined,
            closeOptions: {
                canClosePanel: canClosePanel,
                onPanelClose: onPanelClose
            }
        }, 'push');
    };
    const showCommentsPanelHandler = (0, $42omo.useCallback)(showCommentsPanelFunction, [
        allowComments,
        canAddComments,
        canClosePanel,
        contentId,
        contentStatus,
        experienceTracker,
        isDatabaseView,
        isSpaceOverviewPage,
        isWhiteboardView,
        onPanelClose,
        pageMode,
        showObjectSidebar
    ]);
    const showCommentsPanel = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? showCommentsPanelHandler : showCommentsPanelFunction;
    // NOTE: Exposing the hide function for now while we have the CommentButton
    return {
        isCommentsPanelShown: isObjectSidebarShown && panel?.id === (0, $jvYFk.PanelName).CommentsPanel,
        showCommentsPanel: showCommentsPanel,
        hideCommentsPanel: hideObjectSidebar
    };
};
module.exports["useShowCommentsPanel"] = $3b7f940e5fdc8097$export$833f9a16214bbf3d;

});

parcelRegister("7aw3q", function(module, exports) {

var $1iSzD = parcelRequire("1iSzD");


var $9bL1w = parcelRequire("9bL1w");


var $cxu5H = parcelRequire("cxu5H");

const $440129e2f2e8f952$export$d22f0c9bbe97be97 = ()=>{
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const { hasComments: hasPageComments, hasInlineCommentsAndHighlightActions: hasViewInlineComments } = (0, $cxu5H.useEmbeddedViewPageFeatures)();
    const { hasInlineCommentsAndHighlightActions: hasEditInlineComments } = (0, $9bL1w.useEmbeddedEditPageFeatures)();
    if (!isEmbeddedConfluence) return true;
    const allowPageCommentsInEmbeddedMode = hasPageComments;
    const allowInlineCommentsInEmbeddedMode = hasViewInlineComments || hasEditInlineComments;
    return allowPageCommentsInEmbeddedMode && allowInlineCommentsInEmbeddedMode;
};
module.exports["useEmbeddedComments"] = $440129e2f2e8f952$export$d22f0c9bbe97be97;

});

parcelRegister("3mVfX", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $4440a0699c7a4c4d$export$ca559f4ef107f965 = /*#__PURE__*/ function(ViewValues) {
    ViewValues["OPEN"] = "OPEN";
    ViewValues["UNREAD"] = "UNREAD";
    ViewValues["DELETED_CONTENT"] = "DELETED_CONTENT";
    ViewValues["RESOLVED"] = "RESOLVED";
    return ViewValues;
}({});
var $4440a0699c7a4c4d$export$edda0a7e0ba757fd = /*#__PURE__*/ function(SortValues) {
    SortValues["PAGE_ORDER"] = "PAGE_ORDER";
    SortValues["MOST_RECENT"] = "MOST_RECENT";
    return SortValues;
}({});
var $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c = /*#__PURE__*/ function(CommentMode) {
    CommentMode["VIEW"] = "view";
    CommentMode["ADD"] = "add";
    return CommentMode;
}({});
var $4440a0699c7a4c4d$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $4440a0699c7a4c4d$var$getInitialState = ()=>({
        currentView: undefined,
        currentSort: "PAGE_ORDER",
        showInlineComments: true,
        showGeneralComments: true,
        currentlySelectedThreadKey: undefined,
        initialDataLoadedForViewMap: {
            ["UNREAD"]: false,
            ["OPEN"]: false,
            ["DELETED_CONTENT"]: false,
            ["RESOLVED"]: false
        },
        replyToCommentId: undefined,
        replyToCommentUser: undefined,
        footerEditCommentIds: new Set(),
        currentlyRenderedThreads: [],
        location: undefined,
        commentType: undefined,
        commentMode: "view",
        isCommentAddPromptFocused: false,
        commentContainerToFocus: undefined,
        addFooterCommentAdf: undefined,
        cachedSummary: null
    });
// Actions for managing the comments state in the comments panel
const $4440a0699c7a4c4d$var$actions = {
    getCommentsPanelState: ()=>({ getState: getState })=>{
            return getState();
        },
    setCurrentView: (view)=>({ setState: setState })=>{
            setState({
                currentView: view
            });
        },
    setCurrentSort: (sort)=>({ setState: setState })=>{
            setState({
                currentSort: sort
            });
        },
    setShowInlineComments: (showInline)=>({ setState: setState })=>{
            setState({
                showInlineComments: showInline
            });
        },
    setShowGeneralComments: (showGeneral)=>({ setState: setState })=>{
            setState({
                showGeneralComments: showGeneral
            });
        },
    setCurrentlySelectedThreadKey: (threadKey, commentType)=>({ setState: setState })=>{
            setState({
                currentlySelectedThreadKey: threadKey,
                commentType: commentType
            });
        },
    setInitialDataLoadedForView: ({ viewToSetLoaded: viewToSetLoaded })=>({ getState: getState, setState: setState })=>{
            const { initialDataLoadedForViewMap: initialDataLoadedForViewMap } = getState();
            initialDataLoadedForViewMap[viewToSetLoaded] = true;
            setState({
                initialDataLoadedForViewMap: initialDataLoadedForViewMap
            });
        },
    setReplyToCommentId: ({ parentCommentId: parentCommentId, location: location, user: user } = {})=>({ setState: setState })=>{
            setState({
                replyToCommentId: parentCommentId,
                location: location,
                replyToCommentUser: user
            });
        },
    resetInitialDataLoadedMap: ()=>({ setState: setState })=>{
            setState($4440a0699c7a4c4d$var$getInitialState());
        },
    setCurrentlyRenderedThreads: (threads)=>({ setState: setState })=>{
            setState({
                currentlyRenderedThreads: threads
            });
        },
    addFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.add(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    removeFooterEditCommentId: (commentId)=>({ setState: setState, getState: getState })=>{
            const { footerEditCommentIds: footerEditCommentIds } = getState();
            // Required to change the state object reference to trigger a re-render
            const newFooterEditCommentIds = new Set(footerEditCommentIds);
            newFooterEditCommentIds.delete(commentId);
            setState({
                footerEditCommentIds: newFooterEditCommentIds
            });
        },
    setCommentMode: (mode)=>({ setState: setState })=>{
            setState({
                commentMode: mode
            });
        },
    setIsCommentAddPromptFocused: (isFocused)=>({ setState: setState })=>{
            setState({
                isCommentAddPromptFocused: isFocused
            });
        },
    resetCommentMode: ()=>({ setState: setState })=>{
            setState({
                commentMode: "view",
                isCommentAddPromptFocused: false
            });
        },
    setCommentContainerToFocus: (commentContainerToFocus)=>({ setState: setState })=>{
            setState({
                commentContainerToFocus: commentContainerToFocus
            });
        },
    setAddFooterCommentAdf: (addFooterCommentAdf)=>({ setState: setState })=>{
            setState({
                addFooterCommentAdf: addFooterCommentAdf
            });
        },
    setCachedSummary: (cachedSummary)=>({ setState: setState })=>{
            setState({
                cachedSummary: cachedSummary
            });
        }
};
const $4440a0699c7a4c4d$var$CommentsStore = (0, $1P1Tu.createStore)({
    initialState: $4440a0699c7a4c4d$var$getInitialState(),
    actions: $4440a0699c7a4c4d$var$actions,
    name: 'CommentsStore'
});
const $4440a0699c7a4c4d$export$8607294e360a4610 = (0, $9zUhf.createHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$1719a5796ebd8e85 = (0, $9zUhf.createActionsHook)($4440a0699c7a4c4d$var$CommentsStore);
const $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb = (0, $9zUhf.createStateHook)($4440a0699c7a4c4d$var$CommentsStore);
module.exports["ViewValues"] = $4440a0699c7a4c4d$export$ca559f4ef107f965;
module.exports["SortValues"] = $4440a0699c7a4c4d$export$edda0a7e0ba757fd;
module.exports["CommentMode"] = $4440a0699c7a4c4d$export$8d8bcfcd1bcc8a7c;
module.exports["AddFooterCommentMode"] = $4440a0699c7a4c4d$export$94f8d08c2312472b;
module.exports["useCommentsPanel"] = $4440a0699c7a4c4d$export$8607294e360a4610;
module.exports["useCommentsPanelActions"] = $4440a0699c7a4c4d$export$1719a5796ebd8e85;
module.exports["useCommentsPanelState"] = $4440a0699c7a4c4d$export$5b0e6f8eb2b6ddcb;

});

parcelRegister("dANtQ", function(module, exports) {

var $i1slQ = parcelRequire("i1slQ");


var $9wEpK = parcelRequire("9wEpK");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $jMyy4 = parcelRequire("jMyy4");

const $be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery = (0, $i1slQ.default);
const $be6154107952d370$var$noOpRefetch = ()=>Promise.resolve();
const $be6154107952d370$export$4cae5d8963399c48 = (contentId, cacheOnly = false)=>{
    const baseOptions = {
        variables: {
            contentId: contentId
        },
        skip: !contentId
    };
    const queryResult = (0, $6mKj3.expValEquals)('confluence_frontend_stop_watching_queries', 'isEnabled', true) ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jtuBN.useQueryNoFurtherUpdateInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, baseOptions) : // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $jMyy4.useQueryInterop)($be6154107952d370$var$useAddCommentPermissionCheckPermissionCheckAddCommentQuery, {
        ...baseOptions,
        notifyOnNetworkStatusChange: true,
        fetchPolicy: cacheOnly ? 'cache-only' : 'cache-and-network'
    });
    const { data: data, loading: loading, error: error } = queryResult;
    const networkStatus = 'networkStatus' in queryResult && queryResult.networkStatus !== undefined ? queryResult.networkStatus : (0, $9wEpK.NetworkStatus).ready;
    const refetch = 'refetch' in queryResult && typeof queryResult.refetch === 'function' ? queryResult.refetch : $be6154107952d370$var$noOpRefetch;
    const contentNode = data?.content?.nodes?.[0];
    const operations = contentNode?.operations ?? [];
    const createPermission = operations.some((operationResults)=>operationResults?.operation === 'create' && operationResults?.targetType === 'comment');
    return {
        canAddComments: createPermission,
        loading: loading,
        contentQueryError: error,
        refetch: refetch,
        networkStatus: networkStatus
    };
};
module.exports["useAddCommentPermissionCheck"] = $be6154107952d370$export$4cae5d8963399c48;

});

parcelRegister("i1slQ", function(module, exports) {
/**
 * @generated SignedSource<<804f0ace7e4b3a32352165d5a6d0a515>>
 * @relayHash 5b33d38d543554afec98c6d129862ca0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9
const $fc06507f37418bb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "draft",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5b33d38d543554afec98c6d129862ca0",
            "id": "c0666e4aa67b4630a3145d746b836d11857cbed57f80ba27619146d9e2fc51f9",
            "metadata": {},
            "name": "useAddCommentPermissionCheckPermissionCheckAddCommentQuery",
            "operationKind": "query",
            "text": "query useAddCommentPermissionCheckPermissionCheckAddCommentQuery($contentId:ID!){content(id:$contentId,status:[\"draft\",\"current\"]){nodes{id,type,operations{operation,targetType}}}}"
        }
    };
}();
$fc06507f37418bb6$var$node.hash = "aad09466db1f47073b1a0249e54dc3a4";
var $fc06507f37418bb6$export$2e2bcd8739ae039 = $fc06507f37418bb6$var$node;
module.exports["default"] = $fc06507f37418bb6$export$2e2bcd8739ae039;

});

parcelRegister("cNoeW", function(module, exports) {

let $950cdd2efa20a863$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $950cdd2efa20a863$var$load("dtASV"),
    $950cdd2efa20a863$var$load("kHOMt"),
    $950cdd2efa20a863$var$load("iP4fd"),
    $950cdd2efa20a863$var$load("eiF7i"),
    $950cdd2efa20a863$var$load("aZinD"),
    $950cdd2efa20a863$var$load("cLmw6"),
    $950cdd2efa20a863$var$load("lNrIG"),
    $950cdd2efa20a863$var$load("iP65w"),
    $950cdd2efa20a863$var$load("4QkRU"),
    $950cdd2efa20a863$var$load("gLGsg"),
    $950cdd2efa20a863$var$load("2fTtV"),
    $950cdd2efa20a863$var$load("8VT23"),
    $950cdd2efa20a863$var$load("fJtJG"),
    $950cdd2efa20a863$var$load("lkOIY"),
    $950cdd2efa20a863$var$load("2Yzw6"),
    $950cdd2efa20a863$var$load("jbxHq"),
    $950cdd2efa20a863$var$load("8YSo7"),
    $950cdd2efa20a863$var$load("7do1E"),
    $950cdd2efa20a863$var$load("77dkW"),
    $950cdd2efa20a863$var$load("9ijrN"),
    $950cdd2efa20a863$var$load("Wowvf"),
    $950cdd2efa20a863$var$load("cyGuT"),
    $950cdd2efa20a863$var$load("hhss7"),
    $950cdd2efa20a863$var$load("4EvEa"),
    $950cdd2efa20a863$var$load("2h6rN"),
    $950cdd2efa20a863$var$load("kknel"),
    $950cdd2efa20a863$var$load("oTvoe"),
    $950cdd2efa20a863$var$load("6mxDS"),
    $950cdd2efa20a863$var$load("3Wg31"),
    $950cdd2efa20a863$var$load("6u1hm"),
    $950cdd2efa20a863$var$load("1hb17"),
    $950cdd2efa20a863$var$load("l6yNt"),
    $950cdd2efa20a863$var$load("8fMw3"),
    $950cdd2efa20a863$var$load("hogcU"),
    $950cdd2efa20a863$var$load("4UuEP"),
    $950cdd2efa20a863$var$load("dAdaw"),
    $950cdd2efa20a863$var$load("2uVTT"),
    $950cdd2efa20a863$var$load("aOQqp"),
    $950cdd2efa20a863$var$load("j47Y5"),
    $950cdd2efa20a863$var$load("ivqr8"),
    $950cdd2efa20a863$var$load("2YGw3"),
    $950cdd2efa20a863$var$load("7aOpi"),
    $950cdd2efa20a863$var$load("beE2d"),
    $950cdd2efa20a863$var$load("dOvTT"),
    $950cdd2efa20a863$var$load("gtZGD"),
    $950cdd2efa20a863$var$load("6wr18"),
    $950cdd2efa20a863$var$load("h3ABO"),
    $950cdd2efa20a863$var$load("ffEVr"),
    $950cdd2efa20a863$var$load("gYeBT"),
    $950cdd2efa20a863$var$load("iif0M"),
    $950cdd2efa20a863$var$load("2cMKQ"),
    $950cdd2efa20a863$var$load("dLXd7"),
    $950cdd2efa20a863$var$load("jwWp5"),
    $950cdd2efa20a863$var$load("7EorR"),
    $950cdd2efa20a863$var$load("dRpV3"),
    $950cdd2efa20a863$var$load("6ffwi"),
    $950cdd2efa20a863$var$load("bZz7X")
]).then(()=>parcelRequire('g9dNl'));

});

parcelRegister("4YZhm", function(module, exports) {

let $3a0c4cc5210c7d72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3a0c4cc5210c7d72$var$load("dtASV"),
    $3a0c4cc5210c7d72$var$load("kHOMt"),
    $3a0c4cc5210c7d72$var$load("iP4fd"),
    $3a0c4cc5210c7d72$var$load("eiF7i"),
    $3a0c4cc5210c7d72$var$load("aZinD"),
    $3a0c4cc5210c7d72$var$load("cLmw6"),
    $3a0c4cc5210c7d72$var$load("lNrIG"),
    $3a0c4cc5210c7d72$var$load("iP65w"),
    $3a0c4cc5210c7d72$var$load("4QkRU"),
    $3a0c4cc5210c7d72$var$load("gLGsg"),
    $3a0c4cc5210c7d72$var$load("2fTtV"),
    $3a0c4cc5210c7d72$var$load("8VT23"),
    $3a0c4cc5210c7d72$var$load("fJtJG"),
    $3a0c4cc5210c7d72$var$load("lkOIY"),
    $3a0c4cc5210c7d72$var$load("2Yzw6"),
    $3a0c4cc5210c7d72$var$load("jbxHq"),
    $3a0c4cc5210c7d72$var$load("8YSo7"),
    $3a0c4cc5210c7d72$var$load("7do1E"),
    $3a0c4cc5210c7d72$var$load("77dkW"),
    $3a0c4cc5210c7d72$var$load("9ijrN"),
    $3a0c4cc5210c7d72$var$load("Wowvf"),
    $3a0c4cc5210c7d72$var$load("cyGuT"),
    $3a0c4cc5210c7d72$var$load("hhss7"),
    $3a0c4cc5210c7d72$var$load("4EvEa"),
    $3a0c4cc5210c7d72$var$load("2h6rN"),
    $3a0c4cc5210c7d72$var$load("kknel"),
    $3a0c4cc5210c7d72$var$load("oTvoe"),
    $3a0c4cc5210c7d72$var$load("6mxDS"),
    $3a0c4cc5210c7d72$var$load("3Wg31"),
    $3a0c4cc5210c7d72$var$load("6u1hm"),
    $3a0c4cc5210c7d72$var$load("1hb17"),
    $3a0c4cc5210c7d72$var$load("l6yNt"),
    $3a0c4cc5210c7d72$var$load("8fMw3"),
    $3a0c4cc5210c7d72$var$load("hogcU"),
    $3a0c4cc5210c7d72$var$load("4UuEP"),
    $3a0c4cc5210c7d72$var$load("dAdaw"),
    $3a0c4cc5210c7d72$var$load("2uVTT"),
    $3a0c4cc5210c7d72$var$load("aOQqp"),
    $3a0c4cc5210c7d72$var$load("j47Y5"),
    $3a0c4cc5210c7d72$var$load("ivqr8"),
    $3a0c4cc5210c7d72$var$load("2YGw3"),
    $3a0c4cc5210c7d72$var$load("7aOpi"),
    $3a0c4cc5210c7d72$var$load("beE2d"),
    $3a0c4cc5210c7d72$var$load("dOvTT"),
    $3a0c4cc5210c7d72$var$load("gtZGD"),
    $3a0c4cc5210c7d72$var$load("6wr18"),
    $3a0c4cc5210c7d72$var$load("h3ABO"),
    $3a0c4cc5210c7d72$var$load("ffEVr"),
    $3a0c4cc5210c7d72$var$load("gYeBT"),
    $3a0c4cc5210c7d72$var$load("iif0M"),
    $3a0c4cc5210c7d72$var$load("2cMKQ"),
    $3a0c4cc5210c7d72$var$load("dLXd7"),
    $3a0c4cc5210c7d72$var$load("jwWp5"),
    $3a0c4cc5210c7d72$var$load("7EorR"),
    $3a0c4cc5210c7d72$var$load("dRpV3"),
    $3a0c4cc5210c7d72$var$load("6ffwi"),
    $3a0c4cc5210c7d72$var$load("bZz7X")
]).then(()=>parcelRequire('gFN6K'));

});

parcelRegister("hSNPc", function(module, exports) {

let $d04e20fd36f6c3fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d04e20fd36f6c3fd$var$load("dtASV"),
    $d04e20fd36f6c3fd$var$load("kHOMt"),
    $d04e20fd36f6c3fd$var$load("iP4fd"),
    $d04e20fd36f6c3fd$var$load("eiF7i"),
    $d04e20fd36f6c3fd$var$load("aZinD"),
    $d04e20fd36f6c3fd$var$load("cLmw6"),
    $d04e20fd36f6c3fd$var$load("lNrIG"),
    $d04e20fd36f6c3fd$var$load("iP65w"),
    $d04e20fd36f6c3fd$var$load("4QkRU"),
    $d04e20fd36f6c3fd$var$load("gLGsg"),
    $d04e20fd36f6c3fd$var$load("2fTtV"),
    $d04e20fd36f6c3fd$var$load("8VT23"),
    $d04e20fd36f6c3fd$var$load("fJtJG"),
    $d04e20fd36f6c3fd$var$load("lkOIY"),
    $d04e20fd36f6c3fd$var$load("2Yzw6"),
    $d04e20fd36f6c3fd$var$load("jbxHq"),
    $d04e20fd36f6c3fd$var$load("8YSo7"),
    $d04e20fd36f6c3fd$var$load("7do1E"),
    $d04e20fd36f6c3fd$var$load("77dkW"),
    $d04e20fd36f6c3fd$var$load("9ijrN"),
    $d04e20fd36f6c3fd$var$load("Wowvf"),
    $d04e20fd36f6c3fd$var$load("cyGuT"),
    $d04e20fd36f6c3fd$var$load("hhss7"),
    $d04e20fd36f6c3fd$var$load("4EvEa"),
    $d04e20fd36f6c3fd$var$load("2h6rN"),
    $d04e20fd36f6c3fd$var$load("kknel"),
    $d04e20fd36f6c3fd$var$load("oTvoe"),
    $d04e20fd36f6c3fd$var$load("6mxDS"),
    $d04e20fd36f6c3fd$var$load("3Wg31"),
    $d04e20fd36f6c3fd$var$load("6u1hm"),
    $d04e20fd36f6c3fd$var$load("1hb17"),
    $d04e20fd36f6c3fd$var$load("l6yNt"),
    $d04e20fd36f6c3fd$var$load("8fMw3"),
    $d04e20fd36f6c3fd$var$load("hogcU"),
    $d04e20fd36f6c3fd$var$load("4UuEP"),
    $d04e20fd36f6c3fd$var$load("dAdaw"),
    $d04e20fd36f6c3fd$var$load("2uVTT"),
    $d04e20fd36f6c3fd$var$load("aOQqp"),
    $d04e20fd36f6c3fd$var$load("j47Y5"),
    $d04e20fd36f6c3fd$var$load("ivqr8"),
    $d04e20fd36f6c3fd$var$load("2YGw3"),
    $d04e20fd36f6c3fd$var$load("7aOpi"),
    $d04e20fd36f6c3fd$var$load("beE2d"),
    $d04e20fd36f6c3fd$var$load("dOvTT"),
    $d04e20fd36f6c3fd$var$load("gtZGD"),
    $d04e20fd36f6c3fd$var$load("6wr18"),
    $d04e20fd36f6c3fd$var$load("h3ABO"),
    $d04e20fd36f6c3fd$var$load("ffEVr"),
    $d04e20fd36f6c3fd$var$load("gYeBT"),
    $d04e20fd36f6c3fd$var$load("iif0M"),
    $d04e20fd36f6c3fd$var$load("2cMKQ"),
    $d04e20fd36f6c3fd$var$load("dLXd7"),
    $d04e20fd36f6c3fd$var$load("jwWp5"),
    $d04e20fd36f6c3fd$var$load("7EorR"),
    $d04e20fd36f6c3fd$var$load("dRpV3"),
    $d04e20fd36f6c3fd$var$load("6ffwi"),
    $d04e20fd36f6c3fd$var$load("bZz7X")
]).then(()=>parcelRequire('ioFqb'));

});

parcelRegister("5Rovr", function(module, exports) {

let $4444e96af49eb1d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4444e96af49eb1d9$var$load("dtASV"),
    $4444e96af49eb1d9$var$load("kHOMt"),
    $4444e96af49eb1d9$var$load("iP4fd"),
    $4444e96af49eb1d9$var$load("eiF7i"),
    $4444e96af49eb1d9$var$load("aZinD"),
    $4444e96af49eb1d9$var$load("cLmw6"),
    $4444e96af49eb1d9$var$load("lNrIG"),
    $4444e96af49eb1d9$var$load("iP65w"),
    $4444e96af49eb1d9$var$load("4QkRU"),
    $4444e96af49eb1d9$var$load("gLGsg"),
    $4444e96af49eb1d9$var$load("2fTtV"),
    $4444e96af49eb1d9$var$load("8VT23"),
    $4444e96af49eb1d9$var$load("fJtJG"),
    $4444e96af49eb1d9$var$load("lkOIY"),
    $4444e96af49eb1d9$var$load("2Yzw6"),
    $4444e96af49eb1d9$var$load("jbxHq"),
    $4444e96af49eb1d9$var$load("8YSo7"),
    $4444e96af49eb1d9$var$load("7do1E"),
    $4444e96af49eb1d9$var$load("77dkW"),
    $4444e96af49eb1d9$var$load("9ijrN"),
    $4444e96af49eb1d9$var$load("Wowvf"),
    $4444e96af49eb1d9$var$load("cyGuT"),
    $4444e96af49eb1d9$var$load("hhss7"),
    $4444e96af49eb1d9$var$load("4EvEa"),
    $4444e96af49eb1d9$var$load("2h6rN"),
    $4444e96af49eb1d9$var$load("kknel"),
    $4444e96af49eb1d9$var$load("oTvoe"),
    $4444e96af49eb1d9$var$load("6mxDS"),
    $4444e96af49eb1d9$var$load("3Wg31"),
    $4444e96af49eb1d9$var$load("6u1hm"),
    $4444e96af49eb1d9$var$load("1hb17"),
    $4444e96af49eb1d9$var$load("l6yNt"),
    $4444e96af49eb1d9$var$load("8fMw3"),
    $4444e96af49eb1d9$var$load("hogcU"),
    $4444e96af49eb1d9$var$load("4UuEP"),
    $4444e96af49eb1d9$var$load("dAdaw"),
    $4444e96af49eb1d9$var$load("2uVTT"),
    $4444e96af49eb1d9$var$load("aOQqp"),
    $4444e96af49eb1d9$var$load("j47Y5"),
    $4444e96af49eb1d9$var$load("ivqr8"),
    $4444e96af49eb1d9$var$load("2YGw3"),
    $4444e96af49eb1d9$var$load("7aOpi"),
    $4444e96af49eb1d9$var$load("beE2d"),
    $4444e96af49eb1d9$var$load("dOvTT"),
    $4444e96af49eb1d9$var$load("gtZGD"),
    $4444e96af49eb1d9$var$load("6wr18"),
    $4444e96af49eb1d9$var$load("h3ABO"),
    $4444e96af49eb1d9$var$load("ffEVr"),
    $4444e96af49eb1d9$var$load("gYeBT"),
    $4444e96af49eb1d9$var$load("iif0M"),
    $4444e96af49eb1d9$var$load("2cMKQ"),
    $4444e96af49eb1d9$var$load("dLXd7"),
    $4444e96af49eb1d9$var$load("jwWp5"),
    $4444e96af49eb1d9$var$load("7EorR"),
    $4444e96af49eb1d9$var$load("dRpV3"),
    $4444e96af49eb1d9$var$load("6ffwi"),
    $4444e96af49eb1d9$var$load("bZz7X")
]).then(()=>parcelRequire('5hqV2'));

});

parcelRegister("b0EGa", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $6d5fb7464c13acdf$var$initialState = {
    hideRequestCount: 0
};
const $6d5fb7464c13acdf$var$actions = {
    /**
	 * Request to hide the OmniBar. Call this when your component/popup opens.
	 * Must be paired with releaseHideOmniBar when the component closes.
	 */ requestHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            setState({
                hideRequestCount: hideRequestCount + 1
            });
        },
    /**
	 * Release a hide request. Call this when your component/popup closes.
	 * Must be paired with a previous requestHideOmniBar call.
	 */ releaseHideOmniBar: ()=>({ setState: setState, getState: getState })=>{
            const { hideRequestCount: hideRequestCount } = getState();
            if (hideRequestCount > 0) setState({
                hideRequestCount: hideRequestCount - 1
            });
        }
};
const $6d5fb7464c13acdf$export$11b4e542b178c9bc = (0, $1P1Tu.createStore)({
    initialState: $6d5fb7464c13acdf$var$initialState,
    actions: $6d5fb7464c13acdf$var$actions,
    name: 'OmniBarVisibilityStore'
});
const $6d5fb7464c13acdf$export$c640b7434448a8d = (0, $9zUhf.createStateHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc, {
    selector: (state)=>state.hideRequestCount > 0
});
const $6d5fb7464c13acdf$export$6c29083870fa1fac = (0, $9zUhf.createActionsHook)($6d5fb7464c13acdf$export$11b4e542b178c9bc);
module.exports["useShouldHideOmniBar"] = $6d5fb7464c13acdf$export$c640b7434448a8d;
module.exports["useOmniBarVisibilityActions"] = $6d5fb7464c13acdf$export$6c29083870fa1fac;

});

parcelRegister("a3q17", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jX1qB = parcelRequire("jX1qB");

const $60a54f1e533f2ef6$export$52ff686bd4414bc5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.EDITOR_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$ac7f79e65475cee7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.RENDERER_INLINE_COMMENT_RENDER_SEGMENT_KEY)
});
const $60a54f1e533f2ef6$export$321e1f68b293bf76 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FABRIC_COMMENTS_HIGHLIGHTS_SEGMENT_KEY),
    timings: [
        {
            key: 'fmp',
            endMark: 'fmp'
        },
        {
            key: 'tti',
            endMark: 'tti'
        },
        {
            key: 'highlightsRendered',
            endMark: 'highlightsRendered'
        }
    ]
});
const $60a54f1e533f2ef6$export$fc794218ec0a6fa5 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: 'direct-comment-data-flow',
    timings: [
        {
            key: 'commentCreationStart',
            startMark: 'commentCreationStart'
        },
        {
            key: 'commentCreationEnd',
            endMark: 'commentCreationEnd'
        },
        {
            key: 'commentDataLoad',
            startMark: 'commentDataLoadStart',
            endMark: 'commentDataLoadEnd'
        }
    ]
});
module.exports["EDITOR_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$52ff686bd4414bc5;
module.exports["RENDERER_INLINE_COMMENT_RENDER_METRIC"] = $60a54f1e533f2ef6$export$ac7f79e65475cee7;
module.exports["FABRIC_COMMENTS_HIGHLIGHTS_METRIC"] = $60a54f1e533f2ef6$export$321e1f68b293bf76;
module.exports["DIRECT_COMMENT_DATA_FLOW_METRIC"] = $60a54f1e533f2ef6$export$fc794218ec0a6fa5;

});

parcelRegister("B3Avz", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $lisKW = parcelRequire("lisKW");


var $T1bCI = parcelRequire("T1bCI");


var $hmuev = parcelRequire("hmuev");


var $ccHMk = parcelRequire("ccHMk");


var $1yB28 = parcelRequire("1yB28");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $cbc8g = parcelRequire("cbc8g");


var $hnvzE = parcelRequire("hnvzE");


var $3gadb = parcelRequire("3gadb");


var $6mKj3 = parcelRequire("6mKj3");


var $5vi32 = parcelRequire("5vi32");


var $9FoVw = parcelRequire("9FoVw");


var $aHcFH = parcelRequire("aHcFH");


var $i49vP = parcelRequire("i49vP");


var $eToX6 = parcelRequire("eToX6");


var $bSvtO = parcelRequire("bSvtO");


var $8SCD6 = parcelRequire("8SCD6");


var $cMvMc = parcelRequire("cMvMc");


var $5fMeR = parcelRequire("5fMeR");


var $3D12W = parcelRequire("3D12W");


var $jvYFk = parcelRequire("jvYFk");


var $3mVfX = parcelRequire("3mVfX");


var $kRW4Y = parcelRequire("kRW4Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");


var $666Tc = parcelRequire("666Tc");


var $aWwYt = parcelRequire("aWwYt");


var $gnkil = parcelRequire("gnkil");


var $8uM2K = parcelRequire("8uM2K");


var $cZa7r = parcelRequire("cZa7r");


var $8aF6s = parcelRequire("8aF6s");


var $6wiaZ = parcelRequire("6wiaZ");


var $bEwJH = parcelRequire("bEwJH");


var $bXQxx = parcelRequire("bXQxx");

const $2cc0402d98a7d80d$export$b8454eaf88df51d0 = (entry, setIsSticky, setSidebarOffset, sidebarOffset)=>{
    if (entry.intersectionRatio === 0) {
        setIsSticky(false);
        setSidebarOffset(sidebarOffset);
    } else {
        setIsSticky(true);
        setSidebarOffset(// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD));
    }
};
const $2cc0402d98a7d80d$var$redesignedViewAllStyle = (0, $ecnYn.xcss)({
    position: 'absolute',
    right: 'space.500',
    // This gives us 4px between the X and the comment icon
    top: 'space.150' // This lines us up exactly with X
});
const $2cc0402d98a7d80d$var$viewAllContainerStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.075',
    alignItems: 'center',
    justifyContent: 'center'
});
const $2cc0402d98a7d80d$var$commentHeaderStyle = (0, $ecnYn.xcss)({
    flexDirection: 'column',
    display: 'flex',
    marginTop: 'space.400'
});
const $2cc0402d98a7d80d$var$commentNewHeaderMargin = (0, $ecnYn.xcss)({
    marginTop: 'space.500'
});
const $2cc0402d98a7d80d$var$shadowElementStyle = {
    height: '4px',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.15) 0%, transparent 100%)',
    width: '100%',
    margin: '0',
    padding: '0'
};
const $2cc0402d98a7d80d$var$commentEditorStyle = (0, $ecnYn.xcss)({
    marginTop: 'space.0'
});
const $2cc0402d98a7d80d$var$boxWithMaxHeight = (0, $ecnYn.xcss)({
    maxHeight: 'calc(100vh - 300px)',
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$var$boxWithoutMaxHeight = (0, $ecnYn.xcss)({
    overflowY: 'visible'
});
const $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto = (0, $ecnYn.xcss)({
    overflowY: 'auto'
});
const $2cc0402d98a7d80d$export$d560bdb1ceec916a = ({ pageId: pageId, onClose: onClose, annotationElement: annotationElement, navigationOptions: navigationOptions, isEditor: isEditor, isViewCommentMode: isViewCommentMode, children: children, sidebarOffset: sidebarOffset, commentId: commentId, isOpeningMediaCommentFromToolbar: isOpeningMediaCommentFromToolbar, sidebarEl: sidebarEl, annotationId: annotationId, inlineCommentRef: inlineCommentRef = ()=>{}, nudgeRef: nudgeRef, isSticky: isSticky, isFabricPage: isFabricPage, authorName: authorName, setPopupsScrollableElement: setPopupsScrollableElement, onMaxHeightApplied: onMaxHeightApplied })=>{
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const [oldIsSticky, setOldIsSticky] = (0, $42omo.useState)(false);
    const [newSidebarOffset, setSidebarOffset] = (0, $42omo.useState)(sidebarOffset);
    const [showA11yAnnouncement, setShowA11yAnnouncement] = (0, $42omo.useState)(false);
    const [isScrolled, setIsScrolled] = (0, $42omo.useState)(false);
    const [isRefSet, setIsRefSet] = (0, $42omo.useState)(false);
    const { commentSidebarContext: commentSidebarContext } = (0, $cZa7r.useAnnotations)();
    // Compute isMaxHeightEnabledForSticky first to pass to hook
    const isMaxHeightEnabledForSticky = (0, $6mKj3.expValEquals)('confluence_comment_enable_maxheight', 'isEnabled', true) || isSticky && (0, $9wGTI.fg)('confluence-fe-comment-temp-max-height-fix');
    // Compute hasMaxHeight locally and notify parent via callback
    const { hasMaxHeight: hasMaxHeight, dynamicMaxHeight: dynamicMaxHeight } = (0, $6wiaZ.useHasMaxHeight)({
        sidebarEl: sidebarEl,
        isRefSet: isRefSet,
        isFabricPage: isFabricPage,
        isSticky: isSticky,
        annotationElement: annotationElement,
        isEditor: isEditor,
        sidebarOffset: sidebarOffset,
        isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky
    });
    const applyMaxHeightStyles = hasMaxHeight && isMaxHeightEnabledForSticky;
    // Notify parent when max height styles change
    (0, $42omo.useEffect)(()=>{
        onMaxHeightApplied?.(!!applyMaxHeightStyles);
    }, [
        applyMaxHeightStyles,
        onMaxHeightApplied
    ]);
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { setCurrentlySelectedThreadKey: setCurrentlySelectedThreadKey } = (0, $3mVfX.useCommentsPanelActions)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates = isEmbeddedConfluence && (0, $6mKj3.expValEquals)('cc-maui-experiment', 'isEnabled', true);
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) return;
        let offset = 0;
        if (annotationElement && !isEditor) {
            let scrollParent;
            if (isEditor) {
                scrollParent = document.querySelector('.fabric-editor-popup-scroll-parent');
                offset = (0, $aHcFH.calculateElementOffset)(annotationElement, scrollParent);
            } else {
                /*
        There's two cases here: a view comment and a create comment.
        We need the correct scrollParent for each case.
        Since it's not the editor in this logical branch we should use #content as the scrollParent.
        */ scrollParent = document.querySelector('div#content[data-inline-comments-target="true"]');
                if (scrollParent) {
                    let annotationOffset = 0;
                    if (isViewCommentMode) // If the sidebar is rendering a view comment, we can use the annotationElement directly.
                    annotationOffset = (0, $aHcFH.calculateElementOffset)(annotationElement);
                    else {
                        /*
            If the sidebar is rendering a create comment the annotationElement is actually the wrapperDOM
            we need to find the actual highlight instead. We can find this by looking for the mark because
            there will always be a mark before the create comment button is clicked.
            */ const actualHiglightElement = scrollParent.querySelector(`[data-annotation-draft-mark="true"]`);
                        annotationOffset = (0, $aHcFH.calculateElementOffset)(actualHiglightElement, undefined, true);
                    }
                    offset = annotationOffset + scrollParent.offsetTop;
                }
            }
            setSidebarOffset(offset);
        }
    }, [
        annotationElement,
        isEditor,
        isViewCommentMode
    ]);
    (0, $42omo.useEffect)(()=>{
        // handles media comment scroll
        if (isRefSet && sidebarEl.current && isEditor) {
            if (isOpeningMediaCommentFromToolbar && annotationElement) (0, $i49vP.scrollToElementInEditor)({
                targetElement: annotationElement,
                viewingRoomOffset: -150
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        annotationElement,
        isOpeningMediaCommentFromToolbar,
        commentId,
        isViewCommentMode,
        isEditor
    ]);
    (0, $42omo.useEffect)(()=>{
        let mouseTrap;
        let focusTrap;
        if (isRefSet && sidebarEl.current) {
            mouseTrap = new (0, (/*@__PURE__*/$parcel$interopDefault($lisKW)))(sidebarEl.current);
            // prevent saving via mod+enter from also publishing the page in edit mode
            mouseTrap.bind((0, $gnkil.INLINE_COMMENTS_SHORTCUT), (event)=>{
                event.stopPropagation();
            });
            if (!showA11yAnnouncement) // We need to show this on a timer so the `aria-live` listener will respond with our message
            setTimeout(()=>{
                setShowA11yAnnouncement(true);
            }, 100);
        }
        return ()=>{
            if (mouseTrap) mouseTrap.reset();
            if (focusTrap) focusTrap.deactivate();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!isRefSet || !isViewCommentMode || isEditor || !sidebarEl.current || !(0, $6mKj3.expVal)('cc_comments_a11y_auto_focus_view_page_inline_modal', 'isEnabled', false)) return;
        // capture current val to use for cleanup down the line
        const sidebarNode = sidebarEl.current;
        (0, $aHcFH.focusElementAndUpdateTabIndex)(sidebarNode);
        if (!annotationId) return;
        const handleFocusOut = (e)=>{
            const next = e.relatedTarget;
            // If relatedTarget is null, focus is leaving to a non-focusable target
            // (e.g. the user is clicking on text to make a selection). Don't steal focus.
            if (!next) return;
            if (sidebarNode.contains(next)) return;
            const annotationEl = (0, $aHcFH.getHighlightFromMarkerRef)(annotationId);
            if (annotationEl) (0, $aHcFH.focusElementAndUpdateTabIndex)(annotationEl);
        };
        sidebarNode.addEventListener('focusout', handleFocusOut);
        return ()=>sidebarNode.removeEventListener('focusout', handleFocusOut);
    // No need to have sidebarEL in here - handled by isRefSet
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isRefSet,
        isViewCommentMode,
        isEditor,
        annotationId
    ]);
    const handlePropagation = (event)=>{
        /**
     * prevents an event bubbling up to removing focus
     * from the highlight displaying the sidebar
     */ event.stopPropagation();
    };
    const handleOpeningCommentsPanel = (0, $42omo.useCallback)(()=>{
        showCommentsPanel({
            openWithView: (0, $3mVfX.ViewValues).OPEN
        });
        if (annotationId) {
            setCurrentlySelectedThreadKey(annotationId);
            (0, $9FoVw.handleCommentsPanelNavigation)({
                scrollBehavior: (0, $9FoVw.ScrollBehavior).SMOOTH,
                context: (0, $9FoVw.NavigationContext).PANEL,
                block: 'center',
                annotationId: annotationId,
                commentId: commentId,
                commentType: 'INLINE',
                annotationClicked: true
            });
        }
    }, [
        showCommentsPanel,
        setCurrentlySelectedThreadKey,
        annotationId,
        commentId
    ]);
    const handleOnClose = (0, $42omo.useCallback)((dialogs, isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) dialogs.showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose && onClose(hasContentChanged);
    }, [
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const updatedHandleOnClose = (0, $42omo.useCallback)((isOpeningCommentsPanel = false)=>{
        if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
            onConfirm: ()=>{
                resetContentChanged();
                isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(false);
            }
        });
        else isOpeningCommentsPanel ? handleOpeningCommentsPanel() : onClose?.(hasContentChanged);
    }, [
        showModal,
        hasContentChanged,
        onClose,
        resetContentChanged,
        handleOpeningCommentsPanel
    ]);
    const handleViewAllClick = (0, $42omo.useCallback)((dialogs)=>{
        handleOnClose(dialogs, true);
    }, [
        handleOnClose
    ]);
    const updatedHandleViewAllClick = (0, $42omo.useCallback)(()=>{
        updatedHandleOnClose(true);
    }, [
        updatedHandleOnClose
    ]);
    const handleScroll = (0, $42omo.useCallback)((event)=>{
        const target = event.currentTarget;
        // Check if the inline-comment-sidebar-wrapper is scrolled
        const scrolled = target.scrollTop > 0;
        setIsScrolled(scrolled);
    }, []);
    const sidebarId = (0, $aHcFH.getSidebarId)(isEditor, isViewCommentMode);
    const mode = isEditor ? 'edit' : 'view';
    const intl = (0, $8C5kA.default)();
    const closeCommentBox = intl.formatMessage((0, $bEwJH.i18n).closeCommentBox);
    const isObjectSidebarShown = (0, $aWwYt.useIsObjectSidebarShown)();
    const panel = (0, $aWwYt.usePanel)();
    const sidebarBoundingRect = sidebarEl.current?.getBoundingClientRect();
    const isSidebarExtendedBeyondViewport = (sidebarBoundingRect?.bottom ?? 0) > window.innerHeight;
    /**
   * useEffect to handle sticky comment behavior when attached to a sticky table header.
   * As the user scrolls, the IntersectionObserver triggers the callback the moment the table header starts/stops being sticky
   */ (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
            const stickyHeader = annotationElement?.closest('.pm-table-sticky-wrapper');
            if (stickyHeader && !isSidebarExtendedBeyondViewport) {
                // eslint-disable-next-line no-restricted-syntax
                const observer = new IntersectionObserver(([entry])=>$2cc0402d98a7d80d$export$b8454eaf88df51d0(entry, setOldIsSticky, setSidebarOffset, sidebarOffset), {
                    threshold: 1.0
                });
                observer.observe(stickyHeader);
                return ()=>observer.disconnect();
            }
        }
    }, [
        annotationElement,
        sidebarOffset,
        sidebarEl,
        isSidebarExtendedBeyondViewport
    ]);
    const commentSidebarIsSticky = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? isSticky : oldIsSticky;
    const commentResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_comment_enable_preview_panel_support') ? (0, $eToX6.isInPreviewPanel)() : false;
    const viewAllResidesInPreviewPanel = (0, $9wGTI.fg)('confluence_previewpanel_enable_comments_panel') ? (0, $eToX6.isInPreviewPanel)() : false;
    /**
   * Below logic to set rightOffset is temporary fix.
   * It is very fragile as there are many conditions in ObjectSidebarControl
   * 	component to show/hide action bar and rovo button.
   * Also values are hardcoded.
   */ const getRightOffset = (0, $42omo.useCallback)(()=>{
        let rightOffset = 0;
        const panelRenderedOutsideMain = (0, $jvYFk.isMigratedToPanelSystem)(panel?.id) && (0, $9wGTI.fg)('ads-panel-system-confluence-object-sidebar');
        if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
        (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) // An improved version of getRightOffset()
        {
            if (!commentResidesInPreviewPanel) {
                const baseRightOffset = 112;
                // rendererContent has an extra 40px padding on the right,
                // which we need to add in 'edit' mode to match 'view' mode.
                const extraPadding = 40;
                if (mode === 'edit') rightOffset = extraPadding + (isObjectSidebarShown ? 0 : baseRightOffset);
                else {
                    // `mode === 'view'`
                    if (isObjectSidebarShown) {
                        if (panelRenderedOutsideMain) // Navigation-system Panel already shrinks Main, so only fixed-position
                        // (sticky) inline comments need a viewport-relative offset.
                        rightOffset = commentSidebarIsSticky ? (0, $aWwYt.MIN_PANEL_WIDTH) + extraPadding : 0;
                        else // When `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' },
                        // so we need to add extraPadding here to match the `commentSidebarIsSticky === false` case.
                        rightOffset = (0, $aWwYt.MIN_PANEL_WIDTH) + (commentSidebarIsSticky ? extraPadding : 0);
                    } else // `isObjectSidebarShown === false`
                    if (!commentSidebarIsSticky) rightOffset = baseRightOffset;
                    else {
                        // `commentSidebarIsSticky === true`, sidebar uses style { position: 'fixed' }
                        // We set rightOffset to be baseRightOffset + the distance between
                        // the right edge of 'main-content' and the right edge of window
                        // (which includes the 40px padding + any extra e.g. the Rovo panel).
                        // The resulting horizontal position of sidebar should match the
                        // `commentSidebarIsSticky === false` case.
                        const rendererContent = document.getElementById('main-content');
                        const rendererContentRight = rendererContent?.getBoundingClientRect()?.right ?? 0;
                        if (rendererContentRight) {
                            const rendererContentDistanceFromWindowRight = window.innerWidth - rendererContentRight;
                            rightOffset = baseRightOffset + rendererContentDistanceFromWindowRight;
                        } else // rendererContentRight === 0, which shouldn't occur, but
                        // we fall back to a hardcoded rightOffset
                        rightOffset = baseRightOffset;
                    }
                }
            } // if `commentResidesInPreviewPanel === true`, rightOffset will be 0
        } else {
            // The old version of getRightOffset()
            if (mode === 'view' && isObjectSidebarShown) /**
         * Need rightOffset only when container size doesn't change when
         * 	action bar panel (e.g details panel, comments panel).
         * That happens currently only in view page.
         */ rightOffset = panelRenderedOutsideMain ? 0 : (0, $aWwYt.MIN_PANEL_WIDTH);
            else if (/**
       * When action bar or rovo button is shown, need to set rightOffset,
       * 	otherwise long comment sidebar overlaps on it.
       */ !isObjectSidebarShown && ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') || isRovoButtonEnabled)) /**
         * Width of action bar is 48px,
         * 	got it from object-sidebar-components/src/ObjectSidebarControl.tsx.
         * This is not ideal solution, as it is hardcoded.
         * check if previewPanel support is enabled
         */ {
                if (!commentResidesInPreviewPanel) {
                    if ((0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic')) {
                        rightOffset = 100; // add more offset from the right edge of the page so it doesn't overlap with the object sidebar
                        if (mode === 'view') rightOffset += commentSidebarIsSticky ? 67 : 12;
                        else rightOffset += commentSidebarIsSticky ? 27 : 12;
                    } else rightOffset = 48 + (commentSidebarIsSticky ? 52 : 12);
                }
            }
        }
        return rightOffset;
    }, [
        mode,
        isObjectSidebarShown,
        commentSidebarIsSticky,
        commentResidesInPreviewPanel,
        isRovoButtonEnabled,
        panel
    ]);
    const a11yProps = (0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
        role: 'dialog',
        'aria-modal': false,
        'aria-label': intl.formatMessage((0, $bEwJH.i18n).commentSidebarLabel, {
            name: authorName || ''
        })
    } : {};
    const pickedStickyCommentVerticalOffsetView = // eslint-disable-next-line confluence-feature-gating/no-preconditioning
    (0, $6mKj3.expValEquals)('confluence_fe_fix_sticky_comment_sidebar_position', 'isEnabled', true) && (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW) : (0, $bEwJH.STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD);
    const sidebarContainerOffset = (0, $9wGTI.fg)('confluence_frontend_remove_duplicate_sidebar_logic') ? commentSidebarIsSticky ? isEditor ? sidebarOffset : pickedStickyCommentVerticalOffsetView : sidebarOffset : newSidebarOffset;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer)
        ]
    }, (dialogs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8SCD6.ReactionsProvider), {
            contentId: pageId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hnvzE.default), {
            name: "comment-sidebar"
        }, commentSidebarContext === 'create' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cbc8g.default), {
            data: {
                commentSidebarContext: 'create'
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.SidebarContainer), {
            offset: sidebarContainerOffset,
            rightOffset: getRightOffset(),
            isSticky: commentSidebarIsSticky,
            onClick: handlePropagation,
            id: sidebarId,
            "data-testid": sidebarId,
            "data-cy": sidebarId,
            mode: mode,
            ref: (el)=>{
                sidebarEl.current = el;
                if (nudgeRef) nudgeRef.current = el;
                setIsRefSet(true);
                inlineCommentRef(el);
            },
            ...a11yProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.TopContainer), {
            showNavigation: Boolean(navigationOptions)
        }, annotationId && !shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: $2cc0402d98a7d80d$var$viewAllContainerStyles,
            testId: "view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleViewAllClick() : ()=>handleViewAllClick(dialogs),
            iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1yB28))), {
                    ...iconProps,
                    label: "Comment Icon",
                    color: "var(--ds-icon-subtle)"
                }),
            appearance: "subtle",
            spacing: "compact",
            testId: "comment-sidebar-viewall-button",
            interactionName: "view-comments-menu-action"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            color: "color.text.subtle"
        }, intl.formatMessage((0, $bEwJH.i18n).viewAllCommentsButtonText)))), navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            isUpdatedStandaloneComment: false,
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleOnClose() : ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: closeCommentBox,
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            })
        })))), (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: [
                $2cc0402d98a7d80d$var$commentHeaderStyle,
                $2cc0402d98a7d80d$var$commentNewHeaderMargin,
                !isViewCommentMode && $2cc0402d98a7d80d$var$commentEditorStyle
            ]
        }, navigationOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bXQxx.CommentNavigation), {
            pageId: pageId,
            commentData: navigationOptions.commentData,
            isEditor: isEditor,
            onNavigationClick: navigationOptions.onNavigationClick
        }), annotationId && !viewAllResidesInPreviewPanel && !shouldHideViewAllCommentsButtonForNativeEmbedUiUpdates && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            testId: "redesigned-view-all-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $2cc0402d98a7d80d$var$redesignedViewAllStyle,
            onClick: // In order to get rid of the a11y suppression 👆,
            // we need to move this onClick handler from this Box to CommentIconWithUnread's IconButton.
            (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? undefined : (e)=>{
                e.stopPropagation();
                handleViewAllClick(dialogs);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3D12W.CommentPanelButton), {
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? updatedHandleViewAllClick : undefined,
            contentId: pageId,
            testId: "standalone-comment-view-all-button",
            isStandaloneComment: true,
            isViewAllIcon: true
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), (0, $bEwJH.i18n).closeSidebarTooltip),
            hideTooltipOnClick: true,
            position: "top"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.CloseButton), {
            appearance: "subtle",
            onClick: (0, $6mKj3.expValEquals)('confluence_frontend_remove_a11y_suppressions', 'isEnabled', true) ? ()=>updatedHandleOnClose() : ()=>handleOnClose(dialogs),
            onMouseDown: (e)=>e.preventDefault(),
            testId: "close-comment-sidebar-button",
            "data-cy": `${isEditor ? 'editor' : 'renderer'}-close-${isViewCommentMode ? 'view' : 'create'}-comment`,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                label: intl.formatMessage((0, $bEwJH.i18n).closeInlineCommentThread),
                color: "var(--ds-icon-subtle, #505258)",
                spacing: "none"
            }),
            isUpdatedStandaloneComment: true
        })))), isScrolled && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            style: $2cc0402d98a7d80d$var$shadowElementStyle
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            testId: "inline-comment-sidebar-wrapper",
            ref: (el)=>{
                if (applyMaxHeightStyles) setPopupsScrollableElement?.(el);
            },
            xcss: [
                applyMaxHeightStyles && !dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithMaxHeight,
                applyMaxHeightStyles && !!dynamicMaxHeight && $2cc0402d98a7d80d$var$boxWithDynamicMaxHeightAuto,
                !applyMaxHeightStyles && $2cc0402d98a7d80d$var$boxWithoutMaxHeight
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            style: // xcss only supports static styles
            applyMaxHeightStyles && !!dynamicMaxHeight ? {
                maxHeight: dynamicMaxHeight
            } : undefined,
            onScroll: handleScroll
        }, children))))));
};
module.exports["CommentSidebar"] = $2cc0402d98a7d80d$export$d560bdb1ceec916a;

});

parcelRegister("5vi32", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1iSzD = parcelRequire("1iSzD");


var $7zgzO = parcelRequire("7zgzO");

function $36802f16e927d19b$export$c850f609dc850980() {
    const { location: location } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    return (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)(location || window.location);
}
module.exports["useIsEmbeddedConfluence_DO_NOT_USE"] = $36802f16e927d19b$export$c850f609dc850980;

});

parcelRegister("8SCD6", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $l5y3Y = parcelRequire("l5y3Y");

const $6881c6359fe8b822$export$4da9db299e81cd38 = /*#__PURE__*/ (0, $42omo.createContext)({
    isReactionsEnabled: false
});
$6881c6359fe8b822$export$4da9db299e81cd38.displayName = 'ReactionsContext';
const $6881c6359fe8b822$export$2157a4212fd7f5b1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { contentId: contentId, children: children } = t0;
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    let t1;
    if ($[0] !== isReactionsEnabled) {
        t1 = {
            isReactionsEnabled: isReactionsEnabled
        };
        $[0] = isReactionsEnabled;
        $[1] = t1;
    } else t1 = $[1];
    const reactionsContextValue = t1;
    let t2;
    if ($[2] !== children || $[3] !== reactionsContextValue) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
            value: reactionsContextValue
        }, children);
        $[2] = children;
        $[3] = reactionsContextValue;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : ({ contentId: contentId, children: children })=>{
    const isReactionsEnabled = (0, $l5y3Y.useIsReactionsEnabled)(contentId);
    const reactionsContextValue = (0, $42omo.useMemo)(()=>({
            isReactionsEnabled: isReactionsEnabled
        }), [
        isReactionsEnabled
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6881c6359fe8b822$export$4da9db299e81cd38.Provider, {
        value: reactionsContextValue
    }, children);
};
module.exports["ReactionsContext"] = $6881c6359fe8b822$export$4da9db299e81cd38;
module.exports["ReactionsProvider"] = $6881c6359fe8b822$export$2157a4212fd7f5b1;

});

parcelRegister("l5y3Y", function(module, exports) {

var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $jtuBN = parcelRequire("jtuBN");


var $eSLr0 = parcelRequire("eSLr0");


var $9Z1sw = parcelRequire("9Z1sw");


var $dPJCf = parcelRequire("dPJCf");

const $13602a0094cde4d6$export$da23010c6e2ddd94 = (contentId)=>{
    const isPDFExport = (0, $dPJCf.usePathnameMatcher)({
        selector: (pathname)=>pathname?.indexOf('/wiki/pdf/') !== -1
    });
    const baseOptions = {
        variables: {
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        },
        skip: isPDFExport
    };
    // eslint-disable-next-line graphql-client-usage/graphql-generic-types
    const { data: data } = (0, $6mKj3.expValEquals)('confluence_stop_watching_webpanellocationquery', 'isEnabled', true) ? (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $9Z1sw.WebPanelLocationQuery), baseOptions) : (0, $jMyy4.useQueryInterop)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $9Z1sw.WebPanelLocationQuery), {
        ...baseOptions,
        fetchPolicy: 'cache-first'
    });
    return !isPDFExport && Boolean(data?.webPanels?.length);
};
module.exports["useIsReactionsEnabled"] = $13602a0094cde4d6$export$da23010c6e2ddd94;

});

parcelRegister("3D12W", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1qfLF = parcelRequire("1qfLF");


var $1yB28 = parcelRequire("1yB28");


var $jypE9 = parcelRequire("jypE9");


var $21K7m = parcelRequire("21K7m");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $aWwYt = parcelRequire("aWwYt");


var $8aF6s = parcelRequire("8aF6s");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $cMvMc = parcelRequire("cMvMc");


var $ep3mz = parcelRequire("ep3mz");


var $fNzRA = parcelRequire("fNzRA");


var $9jl6v = parcelRequire("9jl6v");


var $bSvtO = parcelRequire("bSvtO");


var $5fMeR = parcelRequire("5fMeR");


var $3mVfX = parcelRequire("3mVfX");


var $iBnoc = parcelRequire("iBnoc");


var $fHAwL = parcelRequire("fHAwL");


var $cZa7r = parcelRequire("cZa7r");


var $gczDe = parcelRequire("gczDe");


var $gfqXk = parcelRequire("gfqXk");


var $6GD8y = parcelRequire("6GD8y");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $efvKr = parcelRequire("efvKr");


var $1ggpj = parcelRequire("1ggpj");


var $8uM2K = parcelRequire("8uM2K");


var $7aw3q = parcelRequire("7aw3q");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

const $404f4d0022b5692a$var$commentIconContainerStyle = null;
const $404f4d0022b5692a$var$i18n = (0, $cgtv4.defineMessages)({
    openCommentsPanelLabel: {
        id: "object-sidebar-components.open.comments.panel.label",
        defaultMessage: "Open Comments Panel"
    },
    viewAllCommentsLabel: {
        id: "object-sidebar-components.view.all.comments",
        defaultMessage: "View all comments"
    },
    showCommentsLabel: {
        id: "object-sidebar-components.show.comments.label",
        defaultMessage: "Show comments"
    }
});
const $404f4d0022b5692a$export$f5ef73dad1bb3f02 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(67);
    const { onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: t1, isDisabled: t2, isViewAllIcon: t3 } = t0;
    const isStandaloneComment = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const isViewAllIcon = t3 === undefined ? false : t3;
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    let t4;
    if ($[0] !== pageMode) {
        t4 = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
        $[0] = pageMode;
        $[1] = t4;
    } else t4 = $[1];
    const eventEmitter = t4;
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t5] = (0, $efvKr.useLivePageMode)();
    const { isViewMode: isLiveViewMode, isEditMode: isLiveEditMode } = t5;
    const dataTestId = testId || "object-sidebar-comments-button-id";
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const t6 = pageMode === "edit" || isLiveEditMode;
    let t7;
    if ($[2] !== t6) {
        t7 = {
            shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            isEditorShortcut: t6
        };
        $[2] = t6;
        $[3] = t7;
    } else t7 = $[3];
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t7);
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    let t8;
    if ($[4] !== activeHighlight || $[5] !== closeCommentContainer || $[6] !== editorCreateProps || $[7] !== editorViewProps || $[8] !== eventEmitter || $[9] !== expanded || $[10] !== hideObjectSidebar || $[11] !== hoverProps || $[12] !== newCommentHighlight || $[13] !== panel?.id || $[14] !== selectionOptions || $[15] !== selectionProps || $[16] !== setEditorCreateProps || $[17] !== setEditorViewProps || $[18] !== setHoverProps || $[19] !== setSelectionOptions || $[20] !== setSelectionProps || $[21] !== setShowCreateComponent || $[22] !== setViewProps || $[23] !== showCommentsPanel || $[24] !== showCreateComponent || $[25] !== viewProps) {
        t8 = ()=>{
            if (viewProps) {
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
                eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS);
                setViewProps(null);
            }
            if (showCreateComponent && selectionOptions) {
                setShowCreateComponent(false);
                setSelectionOptions(undefined);
            }
            if (editorViewProps) {
                eventEmitter.emit("setselectedannotation", "");
                setEditorViewProps(null);
            }
            if (selectionProps) {
                selectionProps.onClose();
                setSelectionProps(null);
            }
            if (hoverProps) {
                hoverProps.onClose();
                setHoverProps(null);
            }
            if (editorCreateProps) {
                editorCreateProps?.onClose && editorCreateProps.onClose();
                setEditorCreateProps(null);
            }
            if (newCommentHighlight || activeHighlight) window.dispatchEvent(new Event("closeLegacyInlineCommentSidebar"));
            if (expanded && !(0, $9wGTI.fg)("confluence_comment_panel_close_footer")) closeCommentContainer();
            if (panel?.id === "commentsPanel") hideObjectSidebar();
            else showCommentsPanel();
        };
        $[4] = activeHighlight;
        $[5] = closeCommentContainer;
        $[6] = editorCreateProps;
        $[7] = editorViewProps;
        $[8] = eventEmitter;
        $[9] = expanded;
        $[10] = hideObjectSidebar;
        $[11] = hoverProps;
        $[12] = newCommentHighlight;
        $[13] = panel?.id;
        $[14] = selectionOptions;
        $[15] = selectionProps;
        $[16] = setEditorCreateProps;
        $[17] = setEditorViewProps;
        $[18] = setHoverProps;
        $[19] = setSelectionOptions;
        $[20] = setSelectionProps;
        $[21] = setShowCreateComponent;
        $[22] = setViewProps;
        $[23] = showCommentsPanel;
        $[24] = showCreateComponent;
        $[25] = viewProps;
        $[26] = t8;
    } else t8 = $[26];
    const handleCommentClick = t8;
    let t9;
    if ($[27] !== contentTypeFromState || $[28] !== createAnalyticsEvent || $[29] !== handleCommentClick || $[30] !== hasContentChanged || $[31] !== onClick || $[32] !== pageMode || $[33] !== resetContentChanged || $[34] !== resetInitialDataLoadedMap || $[35] !== showModal) {
        t9 = (t10)=>{
            const { triggeredByKeyboardShortcut: t11, isViewAllIcon: t12 } = t10 === undefined ? {} : t10;
            const triggeredByKeyboardShortcut = t11 === undefined ? false : t11;
            const isViewAllIcon_0 = t12 === undefined ? false : t12;
            return ()=>{
                if (isViewAllIcon_0) {
                    onClick?.();
                    return;
                }
                if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                    onConfirm: ()=>{
                        resetContentChanged();
                        handleCommentClick();
                        if ((0, $9wGTI.fg)("confluence_comments_reset_data_on_comment_discard")) resetInitialDataLoadedMap();
                    }
                });
                else handleCommentClick();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "commentsPanel",
                        source: "contentWrapper",
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            contentType: contentTypeFromState,
                            pageMode: pageMode
                        }
                    }
                }).fire();
            };
        };
        $[27] = contentTypeFromState;
        $[28] = createAnalyticsEvent;
        $[29] = handleCommentClick;
        $[30] = hasContentChanged;
        $[31] = onClick;
        $[32] = pageMode;
        $[33] = resetContentChanged;
        $[34] = resetInitialDataLoadedMap;
        $[35] = showModal;
        $[36] = t9;
    } else t9 = $[36];
    const checkUnsavedOnClickCommentsButton = t9;
    let t10;
    if ($[37] !== checkUnsavedOnClickCommentsButton || $[38] !== isLiveViewMode || $[39] !== pageMode) {
        t10 = (pageMode === "view" || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[37] = checkUnsavedOnClickCommentsButton;
        $[38] = isLiveViewMode;
        $[39] = pageMode;
        $[40] = t10;
    } else t10 = $[40];
    let t11;
    if ($[41] !== checkUnsavedOnClickCommentsButton || $[42] !== isLiveEditMode || $[43] !== pageMode) {
        t11 = (pageMode === "edit" || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
            listener: checkUnsavedOnClickCommentsButton({
                triggeredByKeyboardShortcut: true
            })
        });
        $[41] = checkUnsavedOnClickCommentsButton;
        $[42] = isLiveEditMode;
        $[43] = pageMode;
        $[44] = t11;
    } else t11 = $[44];
    let t12;
    if ($[45] !== t10 || $[46] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[45] = t10;
        $[46] = t11;
        $[47] = t12;
    } else t12 = $[47];
    const shortcutListeners = t12;
    if (collapsed) return shortcutListeners;
    let t13;
    if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (0, $gMc0m.default)([
            "_kqswh2mm"
        ]);
        $[48] = t13;
    } else t13 = $[48];
    let t14;
    if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel);
        $[49] = t14;
    } else t14 = $[49];
    const t15 = isShortcutTextShown ? commentShortcutStrings : undefined;
    let t16;
    if ($[50] !== allowComments || $[51] !== checkUnsavedOnClickCommentsButton || $[52] !== formatMessage || $[53] !== isDisabled || $[54] !== isRovoButtonEnabled || $[55] !== isStandaloneComment || $[56] !== isViewAllIcon || $[57] !== unreadCommentIDSet?.size) {
        t16 = allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
            onClick: checkUnsavedOnClickCommentsButton({
                isViewAllIcon: isViewAllIcon
            }),
            appearance: "subtle",
            spacing: isStandaloneComment ? "compact" : undefined,
            shape: isRovoButtonEnabled ? "default" : "circle",
            icon: isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_cohiti_panel_icon_update", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
            label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
            testId: "sidebar-comments-button",
            interactionName: "view-comments-menu-action",
            ...(0, $6mKj3.expVal)("confluence_frontend_comments_a11y_kb_exp", "isEnabled", false) ? {
                ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
            } : {},
            isDisabled: isDisabled && (0, $6mKj3.expVal)("platform_editor_offline_editing_web", "isEnabled", false)
        }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null));
        $[50] = allowComments;
        $[51] = checkUnsavedOnClickCommentsButton;
        $[52] = formatMessage;
        $[53] = isDisabled;
        $[54] = isRovoButtonEnabled;
        $[55] = isStandaloneComment;
        $[56] = isViewAllIcon;
        $[57] = unreadCommentIDSet?.size;
        $[58] = t16;
    } else t16 = $[58];
    const t17 = !isStandaloneComment && shortcutListeners;
    let t18;
    if ($[59] !== t15 || $[60] !== t16 || $[61] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            position: "left",
            content: t14,
            shortcut: t15,
            delay: 0,
            hideTooltipOnClick: true
        }, t16, t17);
        $[59] = t15;
        $[60] = t16;
        $[61] = t17;
        $[62] = t18;
    } else t18 = $[62];
    let t19;
    if ($[63] !== dataTestId || $[64] !== t13 || $[65] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": dataTestId,
            "data-vc": "object-sidebar-comments-button",
            className: t13
        }, t18);
        $[63] = dataTestId;
        $[64] = t13;
        $[65] = t18;
        $[66] = t19;
    } else t19 = $[66];
    return t19;
} : ({ onClick: onClick, collapsed: collapsed, testId: testId, isStandaloneComment: isStandaloneComment = false, isDisabled: isDisabled = false, isViewAllIcon: isViewAllIcon = false })=>{
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { resetInitialDataLoadedMap: resetInitialDataLoadedMap } = (0, $3mVfX.useCommentsPanelActions)();
    const { showCommentsPanel: showCommentsPanel } = (0, $5fMeR.useShowCommentsPanel)();
    const { viewProps: viewProps, selectionProps: selectionProps, hoverProps: hoverProps, editorViewProps: editorViewProps, editorCreateProps: editorCreateProps, showCreateComponent: showCreateComponent, selectionOptions: selectionOptions } = (0, $cZa7r.useAnnotations)();
    const { setViewProps: setViewProps, setSelectionProps: setSelectionProps, setHoverProps: setHoverProps, setEditorViewProps: setEditorViewProps, setEditorCreateProps: setEditorCreateProps, setShowCreateComponent: setShowCreateComponent, setSelectionOptions: setSelectionOptions } = (0, $cZa7r.useAnnotationsDispatch)();
    const { hideObjectSidebar: hideObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const panel = (0, $aWwYt.usePanel)();
    const { hasContentChanged: hasContentChanged } = (0, $bSvtO.useCommentsContentState)();
    const { resetContentChanged: resetContentChanged } = (0, $bSvtO.useCommentsContentActions)();
    const eventEmitter = pageMode === (0, $cD1qu.PageMode).VIEW ? (0, $gczDe.getRendererAnnotationEventEmitter)() : (0, $gfqXk.getEditorAnnotationEventEmitter)();
    const { newCommentHighlight: newCommentHighlight, activeHighlight: activeHighlight } = (0, $9jl6v.useInlineCommentsContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [{ isViewMode: isLiveViewMode, isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const dataTestId = testId || 'object-sidebar-comments-button-id';
    const [contentTypeFromState] = (0, $ep3mz.useContentType)();
    const isRovoButtonEnabled = (0, $8uM2K.useAIRovoButtonEnablement)();
    const { closeCommentContainer: closeCommentContainer } = (0, $fNzRA.useObjectCommentDispatchContext)();
    const { expanded: expanded } = (0, $fNzRA.useObjectCommentContext)();
    const allowComments = (0, $7aw3q.useEmbeddedComments)();
    const { unreadCommentIDSet: unreadCommentIDSet } = (0, $fHAwL.useUnreadCommentsState)();
    const commentShortcutStrings = (0, $4tOXV.useShortcutStrings)({
        shortcut: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        isEditorShortcut: pageMode === 'edit' || isLiveEditMode
    });
    // keyboard events do not bubble up to confluence when focus is in the db iframe.
    // Since the keyboard shortcut does not work, we must hide the shortcut text.
    const isShortcutTextShown = contentTypeFromState !== (0, $1ggpj.ContentType).DATABASE;
    const handleCommentClick = (0, $42omo.useCallback)(()=>{
        // FABRIC PAGES
        // Close the view component if it's open
        if (viewProps) {
            // Inform the Renderer to de-select the annotation
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).DESELECT_ANNOTATIONS);
            eventEmitter.emit((0, $21K7m.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS); // Remove the display of the comment
            setViewProps(null);
        }
        if (showCreateComponent && selectionOptions) {
            // Inform CreateComment to reset the state
            setShowCreateComponent(false);
            setSelectionOptions(undefined);
        }
        if (editorViewProps) {
            // Inform the editor to de-select the annotation
            eventEmitter.emit('setselectedannotation', ''); // Remove the display of the comment
            setEditorViewProps(null);
        }
        if (selectionProps) {
            selectionProps.onClose();
            setSelectionProps(null);
        }
        if (hoverProps) {
            hoverProps.onClose();
            setHoverProps(null);
        }
        if (editorCreateProps) {
            editorCreateProps?.onClose && editorCreateProps.onClose();
            setEditorCreateProps(null);
        } // LEGACY PAGES
        if (newCommentHighlight || activeHighlight) // Close the legacy inline comment panel
        window.dispatchEvent(new Event('closeLegacyInlineCommentSidebar'));
         // Should unmount the expanded comment editor
        // standalone reply, object footer comment
        if (expanded && !(0, $9wGTI.fg)('confluence_comment_panel_close_footer')) closeCommentContainer();
        if (panel?.id === 'commentsPanel') hideObjectSidebar();
        else showCommentsPanel();
    }, [
        eventEmitter,
        viewProps,
        editorViewProps,
        selectionProps,
        hoverProps,
        newCommentHighlight,
        activeHighlight,
        setViewProps,
        setEditorViewProps,
        setSelectionProps,
        setHoverProps,
        showCommentsPanel,
        hideObjectSidebar,
        panel,
        editorCreateProps,
        closeCommentContainer,
        expanded,
        setEditorCreateProps,
        showCreateComponent,
        selectionOptions,
        setShowCreateComponent,
        setSelectionOptions
    ]);
    const checkUnsavedOnClickCommentsButton = (0, $42omo.useCallback)(({ triggeredByKeyboardShortcut: triggeredByKeyboardShortcut = false, isViewAllIcon: isViewAllIcon_0 = false } = {})=>()=>{
            // Early return for ViewAll icon - no action needed
            if (isViewAllIcon_0) {
                onClick?.();
                return;
            }
            if (hasContentChanged) showModal((0, $cMvMc.CommentWarningDialog), {
                onConfirm: ()=>{
                    resetContentChanged();
                    handleCommentClick();
                    if ((0, $9wGTI.fg)('confluence_comments_reset_data_on_comment_discard')) resetInitialDataLoadedMap();
                }
            });
            else handleCommentClick();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'commentsPanel',
                    source: 'contentWrapper',
                    attributes: {
                        triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                        contentType: contentTypeFromState,
                        pageMode: pageMode
                    }
                }
            }).fire();
        }, [
        onClick,
        hasContentChanged,
        handleCommentClick,
        resetContentChanged,
        resetInitialDataLoadedMap,
        showModal,
        createAnalyticsEvent,
        contentTypeFromState,
        pageMode
    ]);
    const shortcutListeners = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, (pageMode === 'view' || isLiveViewMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: (0, $gnkil.TOGGLE_INLINE_COMMENTS_SHORTCUT_RENDERER),
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }), (pageMode === 'edit' || isLiveEditMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_TOGGLE_INLINE_COMMENTS_SHORTCUT),
        listener: checkUnsavedOnClickCommentsButton({
            triggeredByKeyboardShortcut: true
        })
    }));
    if (collapsed) return shortcutListeners;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": dataTestId,
        "data-vc": "object-sidebar-comments-button",
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        position: "left",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $404f4d0022b5692a$var$i18n.showCommentsLabel),
        shortcut: isShortcutTextShown ? commentShortcutStrings : undefined,
        delay: 0,
        hideTooltipOnClick: true
    }, allowComments && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        onClick: checkUnsavedOnClickCommentsButton({
            isViewAllIcon: isViewAllIcon
        }),
        appearance: "subtle",
        spacing: isStandaloneComment ? 'compact' : undefined,
        shape: isRovoButtonEnabled ? 'default' : 'circle',
        icon: isStandaloneComment && (0, $6mKj3.expValEquals)('confluence_comments_cohiti_panel_icon_update', 'isEnabled', true) ? (0, (/*@__PURE__*/$parcel$interopDefault($jypE9))) : (0, (/*@__PURE__*/$parcel$interopDefault($1yB28))),
        label: formatMessage($404f4d0022b5692a$var$i18n.openCommentsPanelLabel),
        testId: "sidebar-comments-button",
        interactionName: "view-comments-menu-action",
        ...(0, $6mKj3.expVal)('confluence_frontend_comments_a11y_kb_exp', 'isEnabled', false) ? {
            ariaLabel: formatMessage($404f4d0022b5692a$var$i18n.viewAllCommentsLabel)
        } : {},
        isDisabled: isDisabled && (0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)
    }), !isStandaloneComment && unreadCommentIDSet?.size > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iBnoc.UnreadIndicator), null)), !isStandaloneComment && shortcutListeners));
};
module.exports["CommentPanelButton"] = $404f4d0022b5692a$export$f5ef73dad1bb3f02;

});

parcelRegister("fNzRA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $en1dX = parcelRequire("en1dX");


var $irVI7 = parcelRequire("irVI7");


var $8Ss4E = parcelRequire("8Ss4E");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

var $7b4a2f6cc35c72e1$export$94f8d08c2312472b = /*#__PURE__*/ function(AddFooterCommentMode) {
    AddFooterCommentMode["FOOTER"] = "footer";
    // The footer comments section
    AddFooterCommentMode["STICKY_DRAFT"] = "sticky_draft";
    // The sticky draft that persists outside of the footer
    AddFooterCommentMode["STICKY_FOOTER"] = "sticky_footer";
    return AddFooterCommentMode;
}({});
const $7b4a2f6cc35c72e1$export$8a175172a11240d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    expandCommentContainer: ()=>{},
    closeCommentContainer: ()=>{},
    setWrapperWidth: ()=>{},
    setIsObjectCommentWrapperVisible: ()=>{},
    setFooterEditorEntry: ()=>{}
});
$7b4a2f6cc35c72e1$export$8a175172a11240d4.displayName = 'ObjectCommentDispatchContext';
const $7b4a2f6cc35c72e1$export$358734f355c08965 = /*#__PURE__*/ (0, $42omo.createContext)({
    expanded: false,
    footerEditorEntry: undefined,
    width: undefined,
    isObjectCommentWrapperVisible: false
});
$7b4a2f6cc35c72e1$export$358734f355c08965.displayName = 'ObjectCommentContext';
const $7b4a2f6cc35c72e1$export$d248a0e4aca56201 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(19);
    const { children: children } = t0;
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] !== expanded || $[1] !== footerEditorEntry || $[2] !== isObjectCommentWrapperVisible || $[3] !== width) {
        t1 = {
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        };
        $[0] = expanded;
        $[1] = footerEditorEntry;
        $[2] = isObjectCommentWrapperVisible;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const providerValue = t1;
    let t2;
    if ($[5] !== edition) {
        t2 = (props)=>{
            const { entryPoint: entryPoint } = props ?? {};
            if (entryPoint && (0, $9wGTI.fg)("confluence_fe_add_page_comment_exp_coverage")) (0, $8Ss4E.startEditorExperiences)({
                name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                attributes: {
                    editor: "FABRIC",
                    isSingleExperience: true,
                    edition: edition,
                    source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                    entryPoint: entryPoint
                }
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
            }, {
                name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
            });
            setExpanded(true);
        };
        $[5] = edition;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    let t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            setFooterEditorEntry(undefined);
            setExpanded(false);
        };
        t4 = (width_0)=>{
            setWidth(width_0 ? `${width_0}px` : "100%");
        };
        t5 = (visible)=>{
            setIsObjectCommentWrapperVisible(visible);
        };
        t6 = (footerEditorEntry_0)=>{
            setFooterEditorEntry(footerEditorEntry_0);
        };
        $[7] = t3;
        $[8] = t4;
        $[9] = t5;
        $[10] = t6;
    } else {
        t3 = $[7];
        t4 = $[8];
        t5 = $[9];
        t6 = $[10];
    }
    let t7;
    if ($[11] !== t2) {
        t7 = {
            expandCommentContainer: t2,
            closeCommentContainer: t3,
            setWrapperWidth: t4,
            setIsObjectCommentWrapperVisible: t5,
            setFooterEditorEntry: t6
        };
        $[11] = t2;
        $[12] = t7;
    } else t7 = $[12];
    const dispatchProviderValue = t7;
    let t8;
    if ($[13] !== children || $[14] !== dispatchProviderValue) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
            value: dispatchProviderValue
        }, children);
        $[13] = children;
        $[14] = dispatchProviderValue;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== providerValue || $[17] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
            value: providerValue
        }, t8);
        $[16] = providerValue;
        $[17] = t8;
        $[18] = t9;
    } else t9 = $[18];
    return t9;
} : ({ children: children })=>{
    const [expanded, setExpanded] = (0, $42omo.useState)(false);
    const [footerEditorEntry, setFooterEditorEntry] = (0, $42omo.useState)(undefined);
    const [width, setWidth] = (0, $42omo.useState)(undefined);
    const [isObjectCommentWrapperVisible, setIsObjectCommentWrapperVisible] = (0, $42omo.useState)(false);
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const providerValue = (0, $42omo.useMemo)(()=>({
            expanded: expanded,
            footerEditorEntry: footerEditorEntry,
            width: width,
            isObjectCommentWrapperVisible: isObjectCommentWrapperVisible
        }), [
        expanded,
        footerEditorEntry,
        width,
        isObjectCommentWrapperVisible
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            expandCommentContainer: (props)=>{
                const { entryPoint: entryPoint } = props ?? {};
                if (entryPoint && (0, $9wGTI.fg)('confluence_fe_add_page_comment_exp_coverage')) (0, $8Ss4E.startEditorExperiences)({
                    name: (0, $irVI7.ADD_PAGE_COMMENT_EXPERIENCE),
                    attributes: {
                        editor: 'FABRIC',
                        isSingleExperience: true,
                        edition: edition,
                        source: (0, $en1dX.AnalyticsSource).PAGE_FOOTER,
                        entryPoint: entryPoint
                    }
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_LOAD_EXPERIENCE)
                }, {
                    name: (0, $irVI7.ADD_PAGE_COMMENT_PUBLISH_EXPERIENCE)
                });
                setExpanded(true);
            },
            closeCommentContainer: ()=>{
                setFooterEditorEntry(undefined);
                setExpanded(false);
            },
            setWrapperWidth: (width_0)=>{
                setWidth(width_0 ? `${width_0}px` : '100%');
            },
            setIsObjectCommentWrapperVisible: (visible)=>{
                setIsObjectCommentWrapperVisible(visible);
            },
            setFooterEditorEntry: (footerEditorEntry_0)=>{
                setFooterEditorEntry(footerEditorEntry_0);
            }
        }), [
        setExpanded,
        setFooterEditorEntry,
        setWidth,
        setIsObjectCommentWrapperVisible,
        edition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$358734f355c08965.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7b4a2f6cc35c72e1$export$8a175172a11240d4.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $7b4a2f6cc35c72e1$export$da430766ddf17a6b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$358734f355c08965);
};
const $7b4a2f6cc35c72e1$export$8ba3235fe153fa01 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
} : ()=>{
    return (0, $42omo.useContext)($7b4a2f6cc35c72e1$export$8a175172a11240d4);
};
module.exports["AddFooterCommentMode"] = $7b4a2f6cc35c72e1$export$94f8d08c2312472b;
module.exports["ObjectCommentProvider"] = $7b4a2f6cc35c72e1$export$d248a0e4aca56201;
module.exports["useObjectCommentContext"] = $7b4a2f6cc35c72e1$export$da430766ddf17a6b;
module.exports["useObjectCommentDispatchContext"] = $7b4a2f6cc35c72e1$export$8ba3235fe153fa01;

});

parcelRegister("9jl6v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $42omo = parcelRequire("42omo");


var $ag6aQ = parcelRequire("ag6aQ");


var $aHcFH = parcelRequire("aHcFH");


var $9FoVw = parcelRequire("9FoVw");


var $i49vP = parcelRequire("i49vP");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $9wGTI = parcelRequire("9wGTI");

const $427c50c01d3953e2$export$87eb11c3f8007b3b = /*#__PURE__*/ (0, $42omo.createContext)({
    createComment: ()=>{},
    clearCreateHighlight: ()=>{},
    onHighlightClick: ()=>{},
    toggleSidebar: ()=>{},
    setResolvedComment: ()=>{},
    setActiveHighlight: ()=>{},
    navigateToInlineComment: ()=>{}
});
$427c50c01d3953e2$export$87eb11c3f8007b3b.displayName = 'InlineCommentsDispatchContext';
const $427c50c01d3953e2$export$e6352a1cdc05c52c = /*#__PURE__*/ (0, $42omo.createContext)({
    newCommentHighlight: undefined,
    highlightOrigin: 'userHighlight',
    activeHighlight: null,
    firstHighlightClicked: false,
    shouldDisplaySidebar: false,
    resolvedComment: null
});
$427c50c01d3953e2$export$e6352a1cdc05c52c.displayName = 'InlineCommentsContext';
const $427c50c01d3953e2$export$f54686667fb05777 = ({ children: children })=>{
    const [newCommentHighlight, setNewCommentHighlight] = (0, $42omo.useState)();
    const [highlightOrigin, setHighlightOrigin] = (0, $42omo.useState)('userHighlight');
    /**
   * We eventually want this value to be the official state for loading/displaying
   * the UI for inline comments. InlineCommentSidebar and some child components have created
   * stateful logic (active highlight, isSidebarShown, etc) that assumes
   * the code is always loaded which we will eventually adjust.
   */ const [shouldDisplaySidebar, setShouldDisplaySidebar] = (0, $42omo.useState)(false);
    const firstHighlightClicked = (0, $42omo.useRef)(false);
    const [activeHighlight, setActiveHighlight] = (0, $42omo.useState)(null);
    const [resolvedComment, setResolvedComment] = (0, $42omo.useState)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const providerValue = (0, $42omo.useMemo)(()=>({
            newCommentHighlight: newCommentHighlight,
            highlightOrigin: highlightOrigin,
            activeHighlight: activeHighlight,
            resolvedComment: resolvedComment,
            firstHighlightClicked: firstHighlightClicked.current,
            shouldDisplaySidebar: shouldDisplaySidebar
        }), [
        activeHighlight,
        highlightOrigin,
        newCommentHighlight,
        resolvedComment,
        shouldDisplaySidebar,
        firstHighlightClicked
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            createComment: (newHighlight, origin = 'userHighlight')=>{
                /**
       * Creating a comment is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ setShouldDisplaySidebar(true);
                setNewCommentHighlight(newHighlight);
                setHighlightOrigin(origin);
                if (resolvedComment) setResolvedComment(null);
            },
            clearCreateHighlight: ()=>setNewCommentHighlight(undefined),
            onHighlightClick: (markerRef)=>{
                if (!firstHighlightClicked.current) firstHighlightClicked.current = true;
                /**
       * Clicking on a highlight is one of the three user explicit scenarios
       * where we want to load inline comments code.
       */ if (markerRef) setShouldDisplaySidebar(true);
                else setShouldDisplaySidebar(false);
                setActiveHighlight(markerRef);
            },
            setResolvedComment: setResolvedComment,
            toggleSidebar: (shouldDisplay)=>setShouldDisplaySidebar(shouldDisplay),
            setActiveHighlight: setActiveHighlight,
            navigateToInlineComment: ({ action: action, triggeredByKeyboardShortcut: triggeredByKeyboardShortcut, currentCommentIndex: currentCommentIndex, onNavigationClick: onNavigationClick, getCommentIndex: getCommentIndex, isEditor: isEditor, removeCommentQueryParams: removeCommentQueryParams, unresolvedInlineComments: unresolvedInlineComments, createAnalyticsEvent: createAnalyticsEvent, contentId: contentId, isNavigateToNextUnread: isNavigateToNextUnread, unreadInlineComments: unreadInlineComments = [], unreadGeneralComments: unreadGeneralComments = [], footerComments: footerComments = [], scrollToFooterComment: scrollToFooterComment, commentsDataMap: commentsDataMap })=>{
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    navigationAction: action
                });
                const couldBeNavigatingToFooterComment = triggeredByKeyboardShortcut && footerComments?.length > 0 && (0, $9wGTI.fg)('confluence_frontend_content_wrapper');
                if (unresolvedInlineComments?.length < 2 && !couldBeNavigatingToFooterComment) {
                    (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                        abortReason: 'Comment navigation when only one comment'
                    });
                    if ((0, $9wGTI.fg)('confluence_frontend_view_inline_comment_exp_parity')) experienceTracker.abort({
                        name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                        reason: 'Comment navigation when only one comment',
                        checkForTimeout: true,
                        publishDebugPoints: true,
                        attributes: {
                            stopPoint: 'comment-context/InlineCommentsContext'
                        }
                    });
                    return;
                }
                // Clear the focusedCommentId queryParams so that reply does not opens up if any...
                removeCommentQueryParams();
                const combinedInlineFooterComments = [
                    ...unresolvedInlineComments,
                    ...footerComments
                ];
                let nextThreadKey = '';
                let currentThreadKey = '';
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (isNavigateToNextUnread) {
                        // Add 1 to currentCommentIndex to move to the next comment, otherwise it gets stuck on the current comment
                        const nextIndex = currentCommentIndex + 1;
                        nextThreadKey = (0, $aHcFH.getNextUnreadThreadKey)(nextIndex, combinedInlineFooterComments, [
                            ...unreadInlineComments,
                            ...unreadGeneralComments
                        ]) ?? '';
                    } else nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, combinedInlineFooterComments) ?? '';
                    currentThreadKey = combinedInlineFooterComments[currentCommentIndex];
                } else {
                    nextThreadKey = (0, $aHcFH.getNextMarkerRef)(action, currentCommentIndex, unresolvedInlineComments) ?? '';
                    currentThreadKey = unresolvedInlineComments[currentCommentIndex];
                }
                if (!nextThreadKey) {
                    (0, $4EKKB.selectInlineComment).debug(`Couldn't find next annotation to select in document`);
                    return;
                }
                (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                    annotationId: nextThreadKey
                });
                if (triggeredByKeyboardShortcut && (0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
                    if (footerComments.includes(nextThreadKey) && scrollToFooterComment && commentsDataMap?.general?.[nextThreadKey]) {
                        setActiveHighlight(null);
                        scrollToFooterComment(nextThreadKey);
                        (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.abort({
                            abortReason: 'Navigating to general comment'
                        });
                        return;
                    }
                }
                const nextCommentElement = document.getElementById(nextThreadKey) || ((0, $9wGTI.fg)('confluence_frontend_content_wrapper') ? document.getElementById(`footer-comment-thread-${nextThreadKey}-container`) : null);
                if (nextCommentElement) (0, $i49vP.checkElementExpandInEditor)(nextCommentElement);
                else (0, $4EKKB.selectInlineComment).debug('No annotation found in doc to check if in expand');
                onNavigationClick(nextThreadKey);
                const nextCommentIndex = getCommentIndex(nextThreadKey);
                const enableOnArrowNavigation = !triggeredByKeyboardShortcut;
                // Handle scrolling navigation
                if (enableOnArrowNavigation) (0, $9FoVw.handleInlineHeaderArrowsNavigation)({
                    previousMarkerRef: currentThreadKey,
                    nextMarkerRef: nextThreadKey,
                    context: isEditor ? (0, $9FoVw.NavigationContext).EDITOR : (0, $9FoVw.NavigationContext).RENDERER,
                    action: action,
                    nextCommentIndex: nextCommentIndex,
                    totalComments: unresolvedInlineComments.length
                });
                if (nextCommentElement) {
                    // As we navigate inline comments with arrow icons, we want to update the cursor location to where the open inline comment is
                    // unless it is a media node in which case, we want our selection to be the media node element.
                    const media = nextCommentElement.querySelector(`.${(0, $ag6aQ.ClassNames).MEDIA_CONTAINER}`);
                    if (media) {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'block',
                            blockType: 'media'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(media);
                    } else {
                        (0, $4EKKB.selectInlineCommentCompoundExperience).addCommonAttributes({
                            commentType: 'inline'
                        });
                        enableOnArrowNavigation && window.getSelection()?.setPosition(nextCommentElement);
                    }
                }
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'clicked',
                        actionSubject: 'navigate',
                        actionSubjectId: 'inlineCommentArrowsNavigate',
                        attributes: {
                            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
                            action: action
                        },
                        objectType: 'inlineComment',
                        objectId: contentId,
                        source: isEditor ? 'editPageScreen' : 'renderPageScreen'
                    }
                }).fire();
            }
        }), [
        resolvedComment,
        firstHighlightClicked,
        setShouldDisplaySidebar,
        setHighlightOrigin,
        setResolvedComment,
        setActiveHighlight,
        experienceTracker
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$e6352a1cdc05c52c.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($427c50c01d3953e2$export$87eb11c3f8007b3b.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $427c50c01d3953e2$export$89bc450b4e1563a9 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$e6352a1cdc05c52c);
};
const $427c50c01d3953e2$export$43e36990fc9d516b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
} : ()=>{
    return (0, $42omo.useContext)($427c50c01d3953e2$export$87eb11c3f8007b3b);
};
module.exports["InlineCommentsProvider"] = $427c50c01d3953e2$export$f54686667fb05777;
module.exports["useInlineCommentsContext"] = $427c50c01d3953e2$export$89bc450b4e1563a9;
module.exports["useInlineCommentsDispatchContext"] = $427c50c01d3953e2$export$43e36990fc9d516b;

});

parcelRegister("iBnoc", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $0360a9befc1d1e18$export$d101cbe06551091d = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "1wNs0",
    name: "UnreadIndicator",
    loader: async ()=>(await (parcelRequire("9bA4s"))).UnreadIndicator
});
module.exports["UnreadIndicator"] = $0360a9befc1d1e18$export$d101cbe06551091d;

});

parcelRegister("9bA4s", function(module, exports) {

let $6b011f0f99d5e581$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6b011f0f99d5e581$var$load("i8hiG").then(()=>parcelRequire('yTrVP'));

});

parcelRegister("fHAwL", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $7fff4328005dca96$var$initialState = {
    // isUpdatingUnreadComments tracks when we're updating the unread comments set
    // (e.g., during initial render or when manually updating the set).
    isUpdatingUnreadComments: true,
    // isUnreadQueryLoading tracks when we're actively fetching comments from the server.
    isUnreadQueryLoading: false,
    unreadCommentIDSet: new Set(),
    shouldClearVisibleThreads: false
};
const $7fff4328005dca96$var$actions = {
    setIsUpdatingUnreadComments: (isUpdatingUnreadComments)=>({ setState: setState })=>{
            setState({
                isUpdatingUnreadComments: isUpdatingUnreadComments
            });
        },
    setIsUnreadQueryLoading: (loading)=>({ setState: setState })=>{
            setState({
                isUnreadQueryLoading: loading
            });
        },
    updateUnreadCommentIDSet: (unreadCommentIDSet, operation = 'initialize')=>({ setState: setState, getState: getState })=>{
            const { unreadCommentIDSet: existingSet } = getState();
            switch(operation){
                case 'initialize':
                    setState({
                        unreadCommentIDSet: unreadCommentIDSet
                    });
                    break;
                case 'add':
                    setState({
                        unreadCommentIDSet: new Set([
                            ...existingSet,
                            ...unreadCommentIDSet
                        ])
                    });
                    break;
                case 'remove':
                    const newSet = new Set(existingSet);
                    unreadCommentIDSet.forEach((id)=>newSet.delete(id));
                    setState({
                        unreadCommentIDSet: newSet
                    });
                    break;
                case 'removeAll':
                    setState({
                        unreadCommentIDSet: new Set()
                    });
                    break;
            }
        },
    setShouldClearVisibleThreads: (shouldClearVisibleThreads)=>({ setState: setState })=>{
            setState({
                shouldClearVisibleThreads: shouldClearVisibleThreads
            });
        }
};
const $7fff4328005dca96$var$UnreadCommentsStore = (0, $1P1Tu.createStore)({
    initialState: $7fff4328005dca96$var$initialState,
    actions: $7fff4328005dca96$var$actions,
    name: 'UnreadCommentsStore'
});
const $7fff4328005dca96$export$df6365a5248dcd96 = (0, $9zUhf.createHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$b7fe87478f70c759 = (0, $9zUhf.createActionsHook)($7fff4328005dca96$var$UnreadCommentsStore);
const $7fff4328005dca96$export$fdd0a0c032c12265 = (0, $9zUhf.createStateHook)($7fff4328005dca96$var$UnreadCommentsStore);
module.exports["useUnreadComments"] = $7fff4328005dca96$export$df6365a5248dcd96;
module.exports["useUnreadCommentsActions"] = $7fff4328005dca96$export$b7fe87478f70c759;
module.exports["useUnreadCommentsState"] = $7fff4328005dca96$export$fdd0a0c032c12265;

});

parcelRegister("6GD8y", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2944f0e1873f71ce$export$90839ff33b4905a0 = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "pU1rv",
    name: "GeneralShortcutListener",
    loader: async ()=>(await (parcelRequire("9Q4ck"))).GeneralShortcutListener
});
module.exports["GeneralShortcutListener"] = $2944f0e1873f71ce$export$90839ff33b4905a0;

});

parcelRegister("9Q4ck", function(module, exports) {

let $729c39fbd06cc51d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $729c39fbd06cc51d$var$load("fZt2F"),
    $729c39fbd06cc51d$var$load("hhss7"),
    $729c39fbd06cc51d$var$load("kpHRm")
]).then(()=>parcelRequire('3w3bV'));

});

parcelRegister("1ggpj", function(module, exports) {

var $1NBp8 = parcelRequire("1NBp8");


var $lx6jn = parcelRequire("lx6jn");


var $6mKj3 = parcelRequire("6mKj3");

var $2aa2bdb281c6889a$export$e2e108cbe2e4f865 = /*#__PURE__*/ function(ContentType) {
    ContentType["WHITEBOARD"] = "whiteboard";
    ContentType["PAGE"] = "page";
    ContentType["BLOGPOST"] = "blogpost";
    ContentType["DATABASE"] = "database";
    ContentType["SLIDE"] = "slide";
    ContentType["EMBED"] = "embed";
    ContentType["FOLDER"] = "folder";
    return ContentType;
}({});
const $2aa2bdb281c6889a$export$31930b8b7828306b = [
    (0, $1NBp8.DATABASE_VIEW).name,
    (0, $1NBp8.VIEW_PAGE).name,
    (0, $1NBp8.WHITEBOARD_BOARD).name,
    (0, $1NBp8.SLIDES_VIEW).name,
    (0, $1NBp8.EMBED_VIEW).name
];
const $2aa2bdb281c6889a$export$a586f466261ecb73 = ()=>{
    const baseRoutes = [
        (0, $1NBp8.DATABASE_VIEW).name,
        (0, $1NBp8.VIEW_PAGE).name,
        (0, $1NBp8.WHITEBOARD_BOARD).name,
        (0, $1NBp8.SLIDES_VIEW).name,
        (0, $1NBp8.EMBED_VIEW).name
    ];
    if ((0, $6mKj3.expValEquals)('cc-axp-delete-editing-page-redirect', 'isEnabled', true)) return [
        ...baseRoutes,
        (0, $1NBp8.EDIT_PAGE).name,
        (0, $1NBp8.EDIT_PAGE_V2).name
    ];
    return baseRoutes;
};
const $2aa2bdb281c6889a$export$142530096b49b828 = [
    "whiteboard",
    "database",
    "slide",
    "embed",
    "page",
    "folder",
    "blogpost"
];
const $2aa2bdb281c6889a$export$de22146d402d9bdd = {
    ["whiteboard"]: (0, $lx6jn.FeedbackSource).WHITEBOARD,
    ["embed"]: (0, $lx6jn.FeedbackSource).EMBED,
    ["database"]: (0, $lx6jn.FeedbackSource).DATABASE,
    ["slide"]: (0, $lx6jn.FeedbackSource).WHITEBOARD
};
const $2aa2bdb281c6889a$export$4aba9c2e2995f563 = [
    "whiteboard",
    "slide"
];
const $2aa2bdb281c6889a$export$ea7ca1acbbc07168 = (contentType)=>!!contentType && $2aa2bdb281c6889a$export$4aba9c2e2995f563.includes(contentType);
const $2aa2bdb281c6889a$export$10c6f1bef31d587c = [
    'database',
    'slide',
    'embed',
    'folder'
];
const $2aa2bdb281c6889a$export$544bad8872c0b7ed = 400;
module.exports["ContentType"] = $2aa2bdb281c6889a$export$e2e108cbe2e4f865;
module.exports["ARCHIVE_SUCCESS_REDIRECT_ROUTES"] = $2aa2bdb281c6889a$export$31930b8b7828306b;
module.exports["getDeleteSuccessRedirectRoutes"] = $2aa2bdb281c6889a$export$a586f466261ecb73;
module.exports["VALID_OPERATION_TARGETS"] = $2aa2bdb281c6889a$export$142530096b49b828;
module.exports["CONTENT_TYPE_FEEDBACK_SOURCE"] = $2aa2bdb281c6889a$export$de22146d402d9bdd;
module.exports["isCanvasContentType"] = $2aa2bdb281c6889a$export$ea7ca1acbbc07168;
module.exports["TYPES_WITH_ACTIVATIONID"] = $2aa2bdb281c6889a$export$10c6f1bef31d587c;
module.exports["onChangeTitleDebounceTime"] = $2aa2bdb281c6889a$export$544bad8872c0b7ed;

});

parcelRegister("lx6jn", function(module, exports) {
var $4d57d476a3596595$export$1953473fc535c5c1 = /*#__PURE__*/ function(FeedbackSource) {
    FeedbackSource["EDITOR"] = "Editor";
    FeedbackSource["HELP_PANEL"] = "Help Panel";
    FeedbackSource["THEME_SELECTOR"] = "Theme Selector";
    FeedbackSource["WHITEBOARD"] = "Whiteboard";
    FeedbackSource["EMBED"] = "Embed";
    FeedbackSource["DATABASE"] = "Database";
    FeedbackSource["NAV_4"] = "Nav4";
    FeedbackSource["SHARE_DIALOG"] = "Share Dialog";
    FeedbackSource["CONTENT_WRAPPER"] = "Content Wrapper";
    FeedbackSource["LIVE_DOCS"] = "Live Docs";
    FeedbackSource["EDITOR_CONTROLS"] = "Editor Controls";
    FeedbackSource["NOTES"] = "Notes";
    FeedbackSource["CREATE_WITH_ROVO"] = "Create with Rovo";
    return FeedbackSource;
}({});
module.exports["FeedbackSource"] = $4d57d476a3596595$export$1953473fc535c5c1;

});

parcelRegister("8uM2K", function(module, exports) {

var $5spQU = parcelRequire("5spQU");


var $lzcvT = parcelRequire("lzcvT");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");

const $214157f3efbb250b$export$dcc461521a57aee7 = ()=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
    const isAIFeatureEnabled = (0, $9wGTI.fg)('use_frontend_feature_encoding_sdk') ? (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-ai') : !(0, $lzcvT.isFedRamp)();
    return isAIFeatureEnabled && isAdminHubAIEnabled && isRovoLLMEnabled;
};
module.exports["useAIRovoButtonEnablement"] = $214157f3efbb250b$export$dcc461521a57aee7;

});

parcelRegister("kRW4Y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $T1bCI = parcelRequire("T1bCI");


var $2BAFx = parcelRequire("2BAFx");

class $c329db8a0d5b9472$export$11ff2eb6414212c6 extends (0, $T1bCI.Container) {
    onChildClose(key, ...args) {
        // A child dialog called its onClose prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onClose) childFrame.originalProps.onClose(...args);
        // Don't remove this dialog from the stack; instead mark it as not alive. This will pull the
        // component from its enclosing <ModalTransition>, but keep the <ModalTransition> around, for now.
        // The child that we provide to the <ModalTransition> has an onCloseComplete prop, to trigger the
        // final cleanup.
        this.setState((state)=>({
                stack: state.stack.map((frame)=>frame === childFrame ? {
                        ...frame,
                        alive: false
                    } : frame)
            }));
    }
    onChildCloseComplete(key, ...args) {
        // A child dialog called its onCloseComplete prop
        // Find the stack frame for the respective child
        const childFrame = this.state.stack.find((frame)=>frame.key === key);
        if (!childFrame) // This is harmless: it can happen when trying to close the dialog multiple times from different places.
        return;
        if (childFrame.originalProps.onCloseComplete) childFrame.originalProps.onCloseComplete(...args);
        // The transition has completed, so complete the cleanup: remove the
        // frame from the stack to pull the <ModalTransition>.
        this.setState((state)=>({
                stack: state.stack.filter((frame)=>frame.key !== childFrame.key)
            }));
    }
    constructor(stack = []){
        super();
        /*
        Arguably, nextKey belongs in state (as per 'flags' package). But then there's
        an unenviable choice of, in showDialog, putting the React.createElement in the
        setState callback, or giving setState an object instead of a callback and
        risk having two dialogs opened with the same key in the (unlikely) scenario
        that they're both opened in the same tick.
      */ this.showModal = (componentClass, originalProps, children)=>{
            this.showDialog(componentClass, originalProps, children);
        };
        /**
     * @deprecated use `.showModal()` instead (see "next/packages/dialogs/README.md" for migration instructions)
     */ this.showDialog = (componentClass, originalProps, children)=>{
            const key = (0, $2BAFx.dialogKeyState).nextKey;
            const props = originalProps || {};
            const component = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(componentClass, {
                ...props,
                onClose: (...args)=>this.onChildClose(key, ...args),
                onCloseComplete: (...args)=>this.onChildCloseComplete(key, ...args)
            }, children);
            this.setState((state)=>({
                    stack: [
                        ...state.stack,
                        {
                            key: key,
                            component: component,
                            alive: true,
                            originalProps: {
                                onClose: 'onClose' in props ? props.onClose : undefined,
                                onCloseComplete: 'onCloseComplete' in props ? props.onCloseComplete : undefined
                            }
                        }
                    ]
                }));
            // Returns a method that the caller can use to close the dialog (though, most often,
            // a child would self-close)
            return ()=>{
                this.onChildClose(key);
            };
        };
        this.state = {
            stack: stack
        };
        // If you're pre-supplying a stack, make nextKey bigger than any of its keys
        if (stack.length) {
            const maxKey = Math.max(...stack.map((frame)=>frame.key));
            (0, $2BAFx.dialogKeyState).nextKey = maxKey + 1;
        }
    }
}
module.exports["DialogsStateContainer"] = $c329db8a0d5b9472$export$11ff2eb6414212c6;

});

parcelRegister("666Tc", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $4KS7f = parcelRequire("4KS7f");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $003eb47e4cfe7fce$var$slideOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$48377ae1c677702b = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "ul" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8wadc _1yt4v0yc _1e0c1txw _1n261g80 _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4fbc87ee9c503b41 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1as91r31 _j4qy8stv _1wwgnqa1 _v0fytlke",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f39f3f768bc98e3d = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isSticky: isSticky, isAutoDismissResolve: isAutoDismissResolve, ...__cmpldp } = __cmplp;
        const { rightOffset: t3 } = __cmplp;
        const rightOffset = t3 === undefined ? 0 : t3;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_16090q4": (0, $7sObp.default)(`${rightOffset}px`),
                "--_162hus6": (0, $7sObp.default)(__cmplp.offset, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_19itia51 _2rko1l7b _16qs1nax _bfhkvuon _1xi21dwo _154i1odf _1e0c1txw _2lx21bp4 _vchhusvi _otyr53f4 _1bsb1178 _c71lglyw",
                __cmplp.mode === "view" ? "_1pbyibnn" : "_1pby1ap8",
                __cmplp.isSticky ? "_kqsw1n9t" : "_kqswstnw",
                Boolean(__cmplp.isAutoDismissResolve) && "",
                Boolean(__cmplp.isAutoDismissResolve) && "_y44vuwz3",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$18986330a3dbad03 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _521wia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$86b1f0d05f7b12cd = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isCommentsPanel: isCommentsPanel, isFabricPage: isFabricPage, isStandaloneComment: isStandaloneComment, ...__cmpldp } = __cmplp;
        let result;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result = "var(--ds-space-150, 12px)";
        else {
            const basePadding = __cmplp.mode === "view" ? "var(--ds-space-150, 12px) var(--ds-space-200, 16px)" : "var(--ds-space-100, 8px) var(--ds-space-150, 12px)";
            result = __cmplp.isCommentsPanel ? "0" : basePadding;
        }
        const t3 = result;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let result_0;
        if (__cmplp.isStandaloneComment && (0, $6mKj3.expValEquals)("confluence_comments_tuneup", "isEnabled", true)) result_0 = "var(--ds-space-150, 12px)";
        else if (!__cmplp.isCommentsPanel && (0, $9wGTI.fg)("confluence_frontend_content_wrapper")) result_0 = "var(--ds-space-200, 16px)";
        else result_0 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-150, 12px)" : "var(--ds-space-100, 8px)";
        const t5 = result_0;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $7sObp.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        let t7;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-space-075, 6px) var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)");
            $[7] = t7;
        } else t7 = $[7];
        let t8;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t8 = (0, $7sObp.default)((0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "var(--ds-text-subtlest, #6B6E76)" : "var(--ds-text-disabled, #080F214A)");
            $[8] = t8;
        } else t8 = $[8];
        let t9;
        if ($[9] !== __cmpls || $[10] !== t4 || $[11] !== t6) {
            t9 = {
                ...__cmpls,
                "--_35y4il": t4,
                "--_1je193e": t6,
                "--_567avp": t7,
                "--_1n1whry": t8
            };
            $[9] = __cmpls;
            $[10] = t4;
            $[11] = t6;
            $[12] = t9;
        } else t9 = $[12];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1yt4pe71 _n3td1fzo _1k0c1qnt _159vzwfg _1wv15a2x",
                __cmplp.isCommentsPanel || __cmplp.isFabricPage && (0, $9wGTI.fg)("confluence_frontend_content_wrapper") ? "_x3doglyw" : "_x3doj0fz",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $003eb47e4cfe7fce$export$5aae1a36fc838370 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41jx0 _1e0c1txw _4cvr1h6o _2lx21bp4 _1i7vwadc _9a6v14no _kckd15o9 _125xi7uo _31ku1h6o _ekv6wadc _dkzuutpp _5lhmtlke _1pzm1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // View mode styled components
const $003eb47e4cfe7fce$export$b38a2fd24b22fb35 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isReply: isReply, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "",
            !__cmplp.isReply && "_1yt4utpp _n7zlia51",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$d1b98bde82a43bb3 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldHaveButtonGap: shouldHaveButtonGap, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1usn19bv _1achz0dk _1scmazsu",
            __cmplp.shouldHaveButtonGap && "_zulpv77o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$6e006bd290301009 = '24px';
const $003eb47e4cfe7fce$export$3421cb2750fe78a7 = '28px';
const $003eb47e4cfe7fce$export$28ae196bde1430fd = '24px'; // Needed to get the correct overall size to match the comment icon next to it
const $003eb47e4cfe7fce$var$inlineHeaderButtonTheme = (isSSRFocusedComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                background: 'none',
                borderRadius: "var(--ds-radius-small, 4px)",
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: $003eb47e4cfe7fce$export$6e006bd290301009,
                '&:hover': {
                    backgroundColor: `${"var(--ds-surface-hovered, #F0F1F2)"}`
                },
                '&:focus': {
                    boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #4688EC)"}`
                },
                cursor: isSSRFocusedComment ? 'not-allowed' : 'pointer',
                '*': {
                    color: isSSRFocusedComment ? `${"var(--ds-text-subtlest, #6B6E76)"}` : `inherit`
                }
            }
        };
    };
const $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isSSRFocusedComment;
    let props;
    if ($[0] !== t0) {
        ({ isSSRFocusedComment: isSSRFocusedComment, ...props } = t0);
        $[0] = t0;
        $[1] = isSSRFocusedComment;
        $[2] = props;
    } else {
        isSSRFocusedComment = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== isSSRFocusedComment) {
        t1 = $003eb47e4cfe7fce$var$inlineHeaderButtonTheme(isSSRFocusedComment);
        $[3] = isSSRFocusedComment;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t1,
            ...props
        });
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
};
const $003eb47e4cfe7fce$export$e575a964a1fe8b0 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { shouldShowNavigation: shouldShowNavigation, isReattachHeader: isReattachHeader, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1e0c1txw _19bvutpp _u5f3utpp",
            __cmplp.shouldShowNavigation ? "_1bah1yb4" : "_1bahesu3",
            __cmplp.shouldShowNavigation && "_4t3i10yn _ca0qutpp",
            __cmplp.isReattachHeader && "_4t3i10yn _ca0qpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$b3b0191112eea395 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $003eb47e4cfe7fce$export$f39f3f768bc98e3d : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1bsb1178 _4t3irvwn",
            __cmplp.showSkeleton ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$export$f895097fe90363d1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { showNavigation: showNavigation, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.showNavigation ? "_19pkxy5q" : "_19pkze3t",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswstnw _1xi2utpp _1pbykb7n _154iutpp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $003eb47e4cfe7fce$export$4b61d9d7155e9162 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_zulp12x7 _kqswstnw _154ipxbi _1ltvpxbi _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $003eb47e4cfe7fce$var$closeButtonTheme = (isUpdatedStandaloneComment)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        return {
            ...theme,
            buttonStyles: {
                ...theme.buttonStyles,
                height: $003eb47e4cfe7fce$export$6e006bd290301009,
                width: isUpdatedStandaloneComment ? $003eb47e4cfe7fce$export$28ae196bde1430fd : $003eb47e4cfe7fce$export$3421cb2750fe78a7
            }
        };
    };
const $003eb47e4cfe7fce$export$de65de8213222d10 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    let isUpdatedStandaloneComment;
    let props;
    if ($[0] !== t0) {
        ({ isUpdatedStandaloneComment: isUpdatedStandaloneComment, ...props } = t0);
        $[0] = t0;
        $[1] = isUpdatedStandaloneComment;
        $[2] = props;
    } else {
        isUpdatedStandaloneComment = $[1];
        props = $[2];
    }
    const t1 = isUpdatedStandaloneComment ?? false;
    let t2;
    if ($[3] !== t1) {
        t2 = $003eb47e4cfe7fce$var$closeButtonTheme(t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== props || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
            theme: t2,
            ...props
        });
        $[5] = props;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["ActionsContainer"] = $003eb47e4cfe7fce$export$48377ae1c677702b;
module.exports["SidebarContainer"] = $003eb47e4cfe7fce$export$f39f3f768bc98e3d;
module.exports["ReplyListContainer"] = $003eb47e4cfe7fce$export$18986330a3dbad03;
module.exports["NewReplyContainer"] = $003eb47e4cfe7fce$export$86b1f0d05f7b12cd;
module.exports["ResolvedNotificationContainer"] = $003eb47e4cfe7fce$export$5aae1a36fc838370;
module.exports["EditorContainer"] = $003eb47e4cfe7fce$export$b38a2fd24b22fb35;
module.exports["NavigationContainer"] = $003eb47e4cfe7fce$export$d1b98bde82a43bb3;
module.exports["InlineHeaderButton"] = $003eb47e4cfe7fce$export$2616e8e1e1a7c3e5;
module.exports["SidebarHeader"] = $003eb47e4cfe7fce$export$e575a964a1fe8b0;
module.exports["LoadingSkeletonContainer"] = $003eb47e4cfe7fce$export$b3b0191112eea395;
module.exports["TopContainer"] = $003eb47e4cfe7fce$export$f895097fe90363d1;
module.exports["CloseButtonContainer"] = $003eb47e4cfe7fce$export$32dd8f1956fe77b1;
module.exports["CloseButton"] = $003eb47e4cfe7fce$export$de65de8213222d10;

});

parcelRegister("6wiaZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");

const $781ef84c6c89584f$export$d1fb14f3b5498c7a = ({ sidebarEl: sidebarEl, isRefSet: isRefSet, isSticky: isSticky, isFabricPage: isFabricPage, annotationElement: annotationElement, isEditor: isEditor, sidebarOffset: sidebarOffset, isMaxHeightEnabledForSticky: isMaxHeightEnabledForSticky })=>{
    const [hasMaxHeight, setHasMaxHeight] = (0, $42omo.useState)(false);
    const [dynamicMaxHeight, setDynamicMaxHeight] = (0, $42omo.useState)(undefined);
    // Shared max height check logic
    const checkMaxHeight = (0, $42omo.useCallback)(()=>{
        // Check if annotation is in a sticky table header & on edit mode
        if (annotationElement && isEditor && isMaxHeightEnabledForSticky) {
            const stickyTable = annotationElement.closest('table.pm-table-sticky');
            const inStickyTableHeader = Boolean(stickyTable);
            // Special case: annotation in sticky table header - calculate max height based on where sidebar will be positioned
            // Without this check, long comment threads can sometimes have their bottom permanently below the viewport on small-width pages
            if (inStickyTableHeader && isSticky) {
                const annotationRect = annotationElement.getBoundingClientRect();
                const annotationBottom = annotationRect.bottom;
                // Use the sidebar offset that will be applied (STICKY_COMMENT_VERTICAL_OFFSET_VIEW for view, or sidebarOffset for editor)
                const offset = sidebarOffset ?? 0;
                const sidebarTop = annotationBottom + offset;
                const viewportHeight = window.innerHeight;
                // Calculate max height as distance from where sidebar top will be to bottom of viewport
                const calculatedMaxHeight = viewportHeight - sidebarTop;
                // Only apply if the calculated max height is positive and would actually constrain the sidebar
                // Otherwise, continue to default behavior
                if (calculatedMaxHeight > 0) {
                    setDynamicMaxHeight(`${calculatedMaxHeight}px`);
                    setHasMaxHeight(true);
                    return;
                }
            }
        }
        // Default (i.e. non-special-cate) behavior
        if (!sidebarEl.current) return;
        if (isSticky) {
            setHasMaxHeight(true);
            setDynamicMaxHeight(undefined);
            return;
        }
        const rect = sidebarEl.current.getBoundingClientRect();
        const availableHeight = window.innerHeight - 300;
        setHasMaxHeight(rect.height > availableHeight);
        setDynamicMaxHeight(undefined);
    }, [
        isSticky,
        sidebarEl,
        annotationElement,
        isEditor,
        sidebarOffset,
        isMaxHeightEnabledForSticky
    ]);
    // Max height effect for pre-render (useLayoutEffect)
    (0, $42omo.useLayoutEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if (!(0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    // Max height effect for post-render (useEffect)
    (0, $42omo.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_frontend_content_wrapper')) return;
        if (!sidebarEl.current) return;
        if ((0, $6mKj3.expValEquals)('confluence_compute_sidebar_styles_pre-render', 'isEnabled', true)) return;
        checkMaxHeight();
    }, [
        checkMaxHeight,
        isRefSet,
        isFabricPage,
        sidebarEl
    ]);
    return {
        hasMaxHeight: hasMaxHeight,
        dynamicMaxHeight: dynamicMaxHeight
    };
};
module.exports["useHasMaxHeight"] = $781ef84c6c89584f$export$d1fb14f3b5498c7a;

});

parcelRegister("bEwJH", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $6015f360c209854c$export$fafb84dd8a714e7a = 5;
const $6015f360c209854c$export$675e64cf259adeff = 125;
const $6015f360c209854c$export$6882b33952f7e4d2 = 122;
const $6015f360c209854c$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    closeCommentBox: {
        id: "annotation-provider-inline-comments.closeCommentBox",
        defaultMessage: "Close inline comments"
    },
    closeInlineCommentThread: {
        id: "annotation-provider-inline-comments.close.InlineCommentThread",
        defaultMessage: "Close inline comment thread"
    },
    closeSidebarTooltip: {
        id: "annotation-provider-inline-comments.close.icon.tooltip",
        defaultMessage: "Close comment"
    },
    viewAllCommentsButtonText: {
        id: "annotation-provider-inline-comments.view-all.button.text",
        defaultMessage: "View all"
    },
    commentSidebarLabel: {
        id: "annotation-provider-inline-comments.comment.sidebar.label",
        defaultMessage: "Inline comment by {name}"
    },
    commentSidebarAnnouncement: {
        id: "annotation-provider-inline-comments.comment.sidebar.announcement",
        defaultMessage: "Comment sidebar shown, use Shift + Tab to reach the comment sidebar"
    }
});
module.exports["MAX_UNCOLLAPSED_REPIES"] = $6015f360c209854c$export$fafb84dd8a714e7a;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW_OLD"] = $6015f360c209854c$export$675e64cf259adeff;
module.exports["STICKY_COMMENT_VERTICAL_OFFSET_VIEW"] = $6015f360c209854c$export$6882b33952f7e4d2;
module.exports["i18n"] = $6015f360c209854c$export$a7357cdd1f0b0168;

});

parcelRegister("bXQxx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $7N1sB = parcelRequire("7N1sB");


var $9wGTI = parcelRequire("9wGTI");


var $cZa7r = parcelRequire("cZa7r");


var $3BCCf = parcelRequire("3BCCf");

const $d6eff27ff915f22d$var$positionRightStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    right: 'space.800'
});
const $d6eff27ff915f22d$var$positionLeftStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    top: 'space.150',
    left: 'space.150'
});
const $d6eff27ff915f22d$export$c7f093fedf3e73fe = ({ pageId: pageId, commentData: commentData, isEditor: isEditor, onNavigationClick: onNavigationClick })=>{
    const { clearStoredCommentData: clearStoredCommentData } = (0, $cZa7r.useAnnotationsDispatch)();
    const { storedCommentData: storedCommentData } = (0, $cZa7r.useAnnotations)();
    const { goToNextInlineComment: originalGoToNext, goToPrevInlineComment: originalGoToPrev } = (0, $3BCCf.useInlineCommentNavigation)({
        isEditor: isEditor,
        pageId: pageId,
        onNavigationClick: onNavigationClick,
        commentData: commentData
    });
    // Wrap navigation functions to clear stored comment data before navigation
    const goToNextInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToNext();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToNext
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)(()=>{
        if (clearStoredCommentData && storedCommentData) clearStoredCommentData();
        originalGoToPrev();
    }, [
        clearStoredCommentData,
        storedCommentData,
        originalGoToPrev
    ]);
    return (0, $42omo.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            xcss: [
                !(0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionRightStyles,
                (0, $9wGTI.fg)('confluence_frontend_content_wrapper') && $d6eff27ff915f22d$var$positionLeftStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7N1sB.CommentNavigation), {
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment
        })), [
        goToNextInlineComment,
        goToPrevInlineComment
    ]);
};
module.exports["CommentNavigation"] = $d6eff27ff915f22d$export$c7f093fedf3e73fe;

});

parcelRegister("7N1sB", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $3gadb = parcelRequire("3gadb");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $9wGTI = parcelRequire("9wGTI");


var $efvKr = parcelRequire("efvKr");


var $de2j9 = parcelRequire("de2j9");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4EKKB = parcelRequire("4EKKB");


var $gtj7V = parcelRequire("gtj7V");


var $aJPUt = parcelRequire("aJPUt");


var $9QIM2 = parcelRequire("9QIM2");


var $e4o8D = parcelRequire("e4o8D");


var $666Tc = parcelRequire("666Tc");

const $c0db869228662b46$var$i18n = (0, $cgtv4.defineMessages)({
    nextCommentLabel: {
        id: "inline-comments-common.next-comment-label",
        defaultMessage: "Next comment"
    },
    previousCommentLabel: {
        id: "inline-comments-common.previous-comment-label",
        defaultMessage: "Previous comment"
    }
});
const $c0db869228662b46$export$c7f093fedf3e73fe = (t0)=>{
    const $ = (0, $frIzR.c)(47);
    const { isSSRFocusedComment: isSSRFocusedComment, goToNextInlineComment: goToNextInlineComment, goToPrevInlineComment: goToPrevInlineComment } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const pageClass = (0, $9QIM2.usePageClass)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const t2 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_PREV_COMMENT_SHORTCUT) : (0, $gnkil.PREV_COMMENT_SHORTCUT);
    let t3;
    if ($[0] !== t2) {
        t3 = {
            shortcut: t2
        };
        $[0] = t2;
        $[1] = t3;
    } else t3 = $[1];
    const prevCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t3);
    const t4 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_NEXT_COMMENT_SHORTCUT) : (0, $gnkil.NEXT_COMMENT_SHORTCUT);
    let t5;
    if ($[2] !== t4) {
        t5 = {
            shortcut: t4
        };
        $[2] = t4;
        $[3] = t5;
    } else t5 = $[3];
    const nextCommentShortcutStrings = (0, $4tOXV.useShortcutStrings)(t5);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const noop = $c0db869228662b46$var$_temp;
    const isPageOrDoc = pageClass === "renderer" || pageClass === "editor";
    let t6;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
        $[4] = t6;
    } else t6 = $[4];
    let t7;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.previousCommentLabel);
        $[5] = t7;
    } else t7 = $[5];
    let t8;
    if ($[6] !== formatMessage) {
        t8 = formatMessage($c0db869228662b46$var$i18n.previousCommentLabel);
        $[6] = formatMessage;
        $[7] = t8;
    } else t8 = $[7];
    let t9;
    if ($[8] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: t8,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[8] = t8;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== experienceTracker || $[11] !== goToPrevInlineComment || $[12] !== isPageOrDoc || $[13] !== isSSRFocusedComment || $[14] !== pageClass) {
        t10 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to previous comment via button.");
            return goToPrevInlineComment();
        } : noop;
        $[10] = experienceTracker;
        $[11] = goToPrevInlineComment;
        $[12] = isPageOrDoc;
        $[13] = isSSRFocusedComment;
        $[14] = pageClass;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== isSSRFocusedComment || $[17] !== t10 || $[18] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-previous",
            testId: "comment-navigation-prev",
            iconBefore: t9,
            onClick: t10
        });
        $[16] = isSSRFocusedComment;
        $[17] = t10;
        $[18] = t9;
        $[19] = t11;
    } else t11 = $[19];
    let t12;
    if ($[20] !== prevCommentShortcutStrings || $[21] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t7,
            shortcut: prevCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t11);
        $[20] = prevCommentShortcutStrings;
        $[21] = t11;
        $[22] = t12;
    } else t12 = $[22];
    let t13;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c0db869228662b46$var$i18n.nextCommentLabel);
        $[23] = t13;
    } else t13 = $[23];
    let t14;
    if ($[24] !== formatMessage) {
        t14 = formatMessage($c0db869228662b46$var$i18n.nextCommentLabel);
        $[24] = formatMessage;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: t14,
            color: "var(--ds-icon-subtle, #505258)",
            spacing: "spacious",
            size: "small"
        });
        $[26] = t14;
        $[27] = t15;
    } else t15 = $[27];
    let t16;
    if ($[28] !== experienceTracker || $[29] !== goToNextInlineComment || $[30] !== isPageOrDoc || $[31] !== isSSRFocusedComment || $[32] !== pageClass) {
        t16 = !isSSRFocusedComment ? ()=>{
            (0, $4EKKB.selectInlineCommentCompoundExperience).selectAnnotation.start({
                pageClass: pageClass,
                entryPoint: "comment-navigation"
            });
            if (isPageOrDoc && (0, $9wGTI.fg)("confluence_frontend_view_inline_comment_arrow_nav")) experienceTracker.start({
                name: (0, $irVI7.VIEW_INLINE_COMMENT_EXPERIENCE),
                timeout: (0, $aJPUt.ExperienceTimeout).VIEW_INLINE_COMMENT,
                attributes: {
                    ...(0, $gtj7V.getCommentsDataManagerExperimentAttributes)(),
                    entryPoint: "inline-comments-common/CommentNavigation",
                    pageClass: pageClass
                }
            });
            (0, $4EKKB.selectInlineComment).debug("Navigating to next comment via button.");
            return goToNextInlineComment();
        } : noop;
        $[28] = experienceTracker;
        $[29] = goToNextInlineComment;
        $[30] = isPageOrDoc;
        $[31] = isSSRFocusedComment;
        $[32] = pageClass;
        $[33] = t16;
    } else t16 = $[33];
    let t17;
    if ($[34] !== isSSRFocusedComment || $[35] !== t15 || $[36] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.InlineHeaderButton), {
            isSSRFocusedComment: isSSRFocusedComment,
            "data-cy": "inline-nav-next",
            testId: "comment-navigation-next",
            iconBefore: t15,
            onClick: t16
        });
        $[34] = isSSRFocusedComment;
        $[35] = t15;
        $[36] = t16;
        $[37] = t17;
    } else t17 = $[37];
    let t18;
    if ($[38] !== nextCommentShortcutStrings || $[39] !== t17) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: t13,
            shortcut: nextCommentShortcutStrings,
            hideTooltipOnClick: true,
            position: "top"
        }, t17);
        $[38] = nextCommentShortcutStrings;
        $[39] = t17;
        $[40] = t18;
    } else t18 = $[40];
    let t19;
    if ($[41] !== renderServerPlaceholder) {
        t19 = renderServerPlaceholder ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            id: "inline-comment-index"
        }) : null;
        $[41] = renderServerPlaceholder;
        $[42] = t19;
    } else t19 = $[42];
    let t20;
    if ($[43] !== t12 || $[44] !== t18 || $[45] !== t19) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $666Tc.NavigationContainer), {
            "data-testid": "comment-navigation-container",
            shouldHaveButtonGap: t6
        }, t12, t18, t19);
        $[43] = t12;
        $[44] = t18;
        $[45] = t19;
        $[46] = t20;
    } else t20 = $[46];
    return t20;
};
function $c0db869228662b46$var$_temp() {}
module.exports["CommentNavigation"] = $c0db869228662b46$export$c7f093fedf3e73fe;

});

parcelRegister("3BCCf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9jl6v = parcelRequire("9jl6v");


var $liGyh = parcelRequire("liGyh");


var $8i27m = parcelRequire("8i27m");

const $33dbfc40da2aecd4$export$248861b924bd617d = ({ pageId: pageId, isEditor: isEditor, onNavigationClick: onNavigationClick, commentData: commentData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { orderedActiveAnnotationIdList: orderedActiveAnnotationIdList } = (0, $8i27m.useCommentsDataState)();
    const { removeCommentQueryParams: removeCommentQueryParams } = (0, $liGyh.useInlineCommentQueryParams)();
    const { navigateToInlineComment: navigateToInlineComment } = (0, $9jl6v.useInlineCommentsDispatchContext)();
    const orderedActiveAnnotations = (0, $42omo.useMemo)(()=>{
        return orderedActiveAnnotationIdList.map((a)=>a.threadKey);
    }, [
        orderedActiveAnnotationIdList
    ]);
    const getCommentIndex = (0, $42omo.useCallback)((currentMarkerRef)=>{
        return orderedActiveAnnotations?.findIndex((markerRef)=>markerRef === currentMarkerRef);
    }, [
        orderedActiveAnnotations
    ]);
    const currentInlineMarkerRef = commentData?.location?.inlineMarkerRef ?? '';
    const currentCommentIndex = getCommentIndex(currentInlineMarkerRef);
    const goToNextInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'next',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    const goToPrevInlineComment = (0, $42omo.useCallback)((triggeredByKeyboardShortcut = false)=>{
        navigateToInlineComment({
            action: 'previous',
            triggeredByKeyboardShortcut: triggeredByKeyboardShortcut,
            currentCommentIndex: currentCommentIndex,
            getCommentIndex: getCommentIndex,
            onNavigationClick: onNavigationClick,
            isEditor: isEditor,
            removeCommentQueryParams: removeCommentQueryParams,
            unresolvedInlineComments: orderedActiveAnnotations,
            createAnalyticsEvent: createAnalyticsEvent,
            contentId: pageId
        });
    }, [
        getCommentIndex,
        navigateToInlineComment,
        createAnalyticsEvent,
        currentCommentIndex,
        onNavigationClick,
        pageId,
        removeCommentQueryParams,
        orderedActiveAnnotations,
        isEditor
    ]);
    return (0, $42omo.useMemo)(()=>({
            currentCommentIndex: currentCommentIndex,
            goToNextInlineComment: goToNextInlineComment,
            goToPrevInlineComment: goToPrevInlineComment,
            commentsCount: orderedActiveAnnotations.length
        }), [
        goToNextInlineComment,
        goToPrevInlineComment,
        orderedActiveAnnotations.length,
        currentCommentIndex
    ]);
};
module.exports["useInlineCommentNavigation"] = $33dbfc40da2aecd4$export$248861b924bd617d;

});

parcelRegister("liGyh", function(module, exports) {
/**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $6tkbf = parcelRequire("6tkbf");


var $7zgzO = parcelRequire("7zgzO");


var $ep3mz = parcelRequire("ep3mz");


var $7W8i8 = parcelRequire("7W8i8");


var $6mKj3 = parcelRequire("6mKj3");


var $lb2Lp = parcelRequire("lb2Lp");


var $kgNLQ = parcelRequire("kgNLQ");


var $aSsfA = parcelRequire("aSsfA");


var $1rdvc = parcelRequire("1rdvc");

const $ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery = (0, $eSUdr.default)`query useCommentQueryParamsCommentLocationQuery($commentId:ID$contentStatus:[GraphQLContentStatus]){comments(commentId:$commentId contentStatus:$contentStatus){nodes{container{id}location{type}}}}`;
const $ba57c93125c5375a$var$logger = (0, $7W8i8.getLogger)('comment-query-params');
const $ba57c93125c5375a$export$63c5e37b7c8d14d1 = ({ location: location, queryArchivedContent: queryArchivedContent = false } = {})=>{
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [pageId] = (0, $ep3mz.usePageContentId)();
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const { focusedCommentId: focusedCommentId, editComment: editComment, commentId: commentId, replyToComment: replyToComment, showCommentArea: showCommentArea, shouldMention: shouldMention, unreadCommentMark: unreadCommentMark } = getQueryParams();
    const targetCommentId = focusedCommentId || replyToComment || editComment && commentId;
    const shouldSkipQuery = !targetCommentId || !location;
    // NEW FLOW: Use useCommentById when experiment is enabled
    const { comment: comment, error: commentError } = (0, $lb2Lp.useCommentById)({
        commentId: targetCommentId || '',
        contentId: pageId || '',
        contentStatus: (0, $kgNLQ.buildDefaultCommentsContentStatusFilters)(pageMode),
        options: {
            skip: shouldSkipQuery || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
        }
    });
    // OLD FLOW: Direct GraphQL query (fallback when experiment is disabled)
    const { data: legacyData, error: legacyError } = (0, $xQxzY.useQuery)($ba57c93125c5375a$var$useCommentQueryParamsCommentLocationQuery, {
        variables: {
            commentId: targetCommentId,
            contentStatus: [
                queryArchivedContent ? (0, $1rdvc.GraphQLContentStatus).ARCHIVED : (0, $1rdvc.GraphQLContentStatus).DRAFT,
                (0, $1rdvc.GraphQLContentStatus).CURRENT
            ]
        },
        skip: shouldSkipQuery || (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)
    });
    if (legacyError) $ba57c93125c5375a$var$logger.error`Error: Unable to query comment location for ${commentId}`;
    // Determine error state - use new flow error or old flow error
    const error = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? commentError : legacyError;
    // Note that this will detect missing inline and footer comments because the query will find
    // either type of comment - so if the comment doesn't exist, we will get the "not found" error
    // In the new flow, useCommentById returns an error when the comment isn't found after loading completes
    const isCommentNotFound = error ? (0, $6tkbf.isCommentNotFoundError)(error.message || String(error)) : false;
    let focusedId;
    let editCommentId;
    let replyToCommentId;
    // Extract location and container ID from either new or old flow
    const commentLocation = (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false) ? comment?.location?.type : legacyData?.comments?.nodes?.[0]?.location?.type;
    // Extract container ID from either new or old flow
    let commentContainerId;
    if ((0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false)) {
        if (comment && 'container' in comment) // Comment replies coming from the new manager don't have a container
        commentContainerId = comment.container?.id;
        else commentContainerId = undefined;
    } else commentContainerId = legacyData?.comments?.nodes?.[0]?.container?.id;
    // Only return comment IDs for relevant location; If no location is given, return them all
    const shouldReturnIds = (!location || location === commentLocation) && (pageId === commentContainerId || commentContainerId === undefined && (0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false));
    if (shouldReturnIds) {
        /* A focused comment query param just uses "focusedCommentId={COMMENT_ID}" */ focusedId = focusedCommentId ? focusedCommentId : undefined;
        /* An edit comment query param uses a combination of "editComment=true&commentId={COMMENT_ID}" */ editCommentId = editComment && editComment === 'true' && commentId ? commentId : undefined;
        /* A reply to comment query param just uses "replyToComment={COMMENT_ID}" */ replyToCommentId = replyToComment ? replyToComment : undefined;
    }
    /* PAGE COMMENTS ONLY: A new comment uses the "showCommentArea=true" query param */ const shouldOpenNewCommentEditor = showCommentArea === 'true';
    /* A mention comment uses the "shouldMention=true" query param */ const shouldMentionInNewCommentEditor = shouldMention === 'true' && replyToCommentId !== undefined;
    const removeCommentQueryParamsFunction = ()=>{
        let commentTypeKey = '', commentIdKey = '', commentMentionKey = '';
        if (focusedId) commentTypeKey = 'focusedCommentId';
        else if (shouldMentionInNewCommentEditor) {
            commentTypeKey = 'replyToComment';
            commentMentionKey = 'shouldMention';
        } else if (replyToCommentId) commentTypeKey = 'replyToComment';
        else if (editCommentId) {
            commentTypeKey = 'editComment';
            commentIdKey = 'commentId';
        } else if (shouldOpenNewCommentEditor) commentTypeKey = 'showCommentArea';
        if (commentTypeKey || commentIdKey || commentMentionKey || unreadCommentMark) {
            const params = getQueryParams();
            setQueryParams({
                ...params,
                [commentTypeKey]: undefined,
                [commentIdKey]: undefined,
                [commentMentionKey]: undefined,
                unreadCommentMark: undefined
            });
        }
    };
    const removeCommentQueryParamsCallback = (0, $42omo.useCallback)(removeCommentQueryParamsFunction, [
        getQueryParams,
        setQueryParams,
        unreadCommentMark,
        editCommentId,
        replyToCommentId,
        shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor,
        focusedId
    ]);
    const removeCommentQueryParams = (0, $6mKj3.expValEquals)('confluence_edit_page_rerender_optimizations', 'isEnabled', true) ? removeCommentQueryParamsCallback : removeCommentQueryParamsFunction;
    const setFocusedCommentQueryParam = (commentId)=>{
        const params = getQueryParams();
        setQueryParams({
            ...params,
            focusedCommentId: commentId
        });
    };
    return {
        focusedCommentId: focusedId,
        editCommentId: editCommentId,
        replyToCommentId: replyToCommentId,
        shouldOpenNewCommentEditor: shouldOpenNewCommentEditor,
        shouldMentionInNewCommentEditor: shouldMentionInNewCommentEditor,
        unreadCommentMark: unreadCommentMark,
        removeCommentQueryParams: removeCommentQueryParams,
        setFocusedCommentQueryParam: setFocusedCommentQueryParam,
        isCommentNotFound: isCommentNotFound
    };
};
const $ba57c93125c5375a$export$b073d30d47d4035b = ({ queryArchivedContent: queryArchivedContent = false } = {})=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'INLINE',
        queryArchivedContent: queryArchivedContent
    });
const $ba57c93125c5375a$export$97d0ff531551284c = ()=>$ba57c93125c5375a$export$63c5e37b7c8d14d1({
        location: 'FOOTER'
    });
module.exports["useInlineCommentQueryParams"] = $ba57c93125c5375a$export$b073d30d47d4035b;

});

parcelRegister("6tkbf", function(module, exports) {

var $lb2Lp = parcelRequire("lb2Lp");

const $6b00aa328c211ce7$export$9f99b736afd21d01 = (errorMessage)=>{
    if (errorMessage) {
        // Check if the full error message matches the string thrown from useCommentById
        if (errorMessage === (0, $lb2Lp.USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE)) return true;
        // Also check the reason message (extracted from backend error format)
        const reasonStartIdx = errorMessage.lastIndexOf(':') + 1;
        const reasonMessage = errorMessage.substring(reasonStartIdx, errorMessage.length).trim();
        // If this string is ever updated on the BE and you need to change it - make sure to also update USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE for consistency
        const backendReasonMessage = 'No comment found for the given id';
        return reasonMessage === backendReasonMessage;
    }
    return false;
};
module.exports["isCommentNotFoundError"] = $6b00aa328c211ce7$export$9f99b736afd21d01;

});

parcelRegister("lb2Lp", function(module, exports) {

var $dc3kb = parcelRequire("dc3kb");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $6mKj3 = parcelRequire("6mKj3");


var $NYiei = parcelRequire("NYiei");


var $kgNLQ = parcelRequire("kgNLQ");


var $4L9ve = parcelRequire("4L9ve");

// The `useCommentById` hook efficiently fetches a single comment by ID with a simple strategy:
// First, it checks the cache for the allCommentsDataQuery using useAllCommentsData with cache-only
// policy. If the comment is found in the cache and data is processed, it uses that data. Otherwise,
// it makes a separate query for just the specific comment. This ensures quick access to individual
// comments without unnecessary network requests when data is already cached. The hook also provides
// loading states, error handling, and comprehensive type safety.
// Unfortunately our Relay-friendly type generation tools don't support GQL fragments yet - but in
// order to keep the definition of the comment fields in sync (so the cache update fragment is
// always in sync with the full query) we will need to manually make any changes to one definition
// in any others as well, until our tooling supports fragments and then we move to a more
// fragmented-based approach.  Note there are also comment queries or fragments in the following
// files that need to be kept in sync as well:
// - next/packages/comments-data-manager/src/useAllCommentsData.ts
// - next/packages/comments-data-manager/src/updateCommentInCache.ts
// - next/packages/comments-data-manager/src/useCreateObjectCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineCommentMutation.ts
// - next/packages/comments-data-manager/src/useCreateInlineReplyMutation.ts
// - next/packages/object-comments/src/components/ObjectCommentContainer.tsx
// TODO: Replace with the exported fragment from useAllCommentsData.ts when our tooling supports
// it, if we are allowed to share fragments between packages/files.  If we are not allowed to share
// fragments, we should move this hook - or at least the part that executes the query into the
// useAllCommentsData.ts file.
const $f4841d4502be35b2$var$commentByIdQuery = (0, $dc3kb.default);
const $f4841d4502be35b2$export$4bf99575c214d4b = 'Comment not found: No comment found for the given id';
const $f4841d4502be35b2$export$1f091977fe1929e2 = 'useCommentById requires either commentId or markerRef and contentId to be provided';
const $f4841d4502be35b2$export$778dda4ccca7793f = ({ commentId: commentId, markerRef: markerRef, contentId: contentId, contentStatus: contentStatus = [
    'CURRENT'
], options: options = {} })=>{
    const { fetchPolicy: fetchPolicy = 'cache-first', onError: parentOnError, skip: explicitlySkipped = false } = options;
    // Skip queries if experiment is disabled or explicitly skipped through options
    const skip = explicitlySkipped || !(0, $6mKj3.expVal)('cc_comments_new_comments_data_manager', 'isEnabled', false);
    // Get processed comments data for new comments data manager
    const processedCommentsData = (0, $4L9ve.useProcessedCommentsDataState)();
    // Validate that at least one identifier is provided (only if not skipping)
    const validationError = (0, $42omo.useMemo)(()=>!skip && (!contentId || !commentId && !markerRef) ? new Error($f4841d4502be35b2$export$1f091977fe1929e2) : undefined, [
        skip,
        commentId,
        markerRef,
        contentId
    ]);
    const skipQueries = skip || !!validationError;
    // Skip the individual comment query if we have cached data from the full query, it's been processed, and we're not asking for fresh BE data
    const shouldSkipOneCommentQuery = skipQueries || fetchPolicy !== 'network-only' && processedCommentsData.isDataProcessed;
    // Always query with all 4 content statuses to guarantee cache hits on preloaded data
    // We'll filter the result client-side based on the passed-in contentStatus
    const oneCommentData = (0, $jMyy4.useQueryInterop)($f4841d4502be35b2$var$commentByIdQuery, {
        variables: {
            pageId: contentId ?? '',
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy,
        skip: shouldSkipOneCommentQuery,
        onError: (error)=>{
            // Handle specific GraphQL errors gracefully
            // WS-3494 - If the error isn't related to reactionsSummary returning null, just mark it handled
            // COMMENTS-188 - Or if the error isn't related to cc-pages not being reachable just mark it handled
            if (error?.message?.search(/reactions/i) !== -1 || error?.message?.search(/cc-pages/i) !== -1) (0, $7Sm4c.markErrorAsHandled)(error);
        }
    });
    // Look for the comment using the flat map for O(1) lookup, or fall back to searching arrays
    const finalComment = (0, $42omo.useMemo)(()=>{
        if (validationError) return undefined;
        // If data is processed, try to find in the flat maps (fastest - O(1))
        if (processedCommentsData.isDataProcessed) {
            if (commentId) {
                const cachedComment = processedCommentsData.flatCommentsMap?.[commentId];
                if (cachedComment) return cachedComment;
            } else if (markerRef) {
                const cachedCommentByMarkerRef = processedCommentsData.flatMarkerRefMap?.[markerRef];
                if (cachedCommentByMarkerRef) return cachedCommentByMarkerRef;
            }
        }
        // Fall back to searching in oneCommentData if available
        if (oneCommentData.data?.comments?.nodes) {
            // Filter out any null nodes - can't just use .filter because TS complains about type
            // mismatch.  Fortunately, this query should only have one comment node anyway.
            const commentData = oneCommentData.data.comments.nodes.map((node)=>node).filter((node)=>node);
            if (!commentData) return undefined;
            // Search in retrieved comments and their replies
            return (0, $kgNLQ.findAndFilterComment)(commentData, commentId, markerRef, contentStatus);
        }
        return undefined;
    }, [
        validationError,
        commentId,
        processedCommentsData.flatCommentsMap,
        processedCommentsData.flatMarkerRefMap,
        processedCommentsData.isDataProcessed,
        oneCommentData.data?.comments?.nodes,
        markerRef,
        contentStatus
    ]);
    // Create an error if we have the full response but can't find the comment
    // 99% of the time this error will be thrown when cachedUseAllCommentsData is populated, but the comment isn't available
    // useCommentByIdQuery **should** throw a similar error if the comment isn't found from the BE,
    // but keep the check here in case the BE changes, or our comment is in another status & is filtered out
    const commentNotFoundError = (0, $42omo.useMemo)(()=>{
        // Only create error if:
        // 1. We're not loading anymore (have full response)
        // 2. We have data (either from processedCommentsData or oneCommentData)
        // 3. We searched for the comment but didn't find it
        // 4. There's no existing error
        if (!skipQueries && processedCommentsData.isDataProcessed && !oneCommentData.loading && !processedCommentsData.error && !oneCommentData.error && finalComment === undefined) return new Error($f4841d4502be35b2$export$4bf99575c214d4b);
        return undefined;
    }, [
        skipQueries,
        processedCommentsData.isDataProcessed,
        processedCommentsData.error,
        oneCommentData.loading,
        oneCommentData.error,
        finalComment
    ]);
    // Memoize the final error to ensure stable reference for use in external useEffects
    const error = (0, $42omo.useMemo)(()=>{
        return validationError || processedCommentsData.error || oneCommentData.error || commentNotFoundError;
    }, [
        validationError,
        processedCommentsData.error,
        oneCommentData.error,
        commentNotFoundError
    ]);
    // Call onError when the error changes
    (0, $42omo.useEffect)(()=>{
        if (error && parentOnError) parentOnError(error);
    }, [
        error,
        parentOnError
    ]);
    return {
        loading: !processedCommentsData.isDataProcessed && oneCommentData.loading,
        error: // (Only loading state if both are loading)
        error,
        comment: finalComment
    };
};
const $f4841d4502be35b2$export$77a85b13740d9b96 = async ({ commentId: commentId, markerRef: markerRef, contentId: contentId, fetchPolicy: fetchPolicy = 'network-only' })=>{
    if (!contentId || !commentId && !markerRef) return Promise.resolve(null);
    const response = await (0, $c0rhi.queryInterop)({
        query: $f4841d4502be35b2$var$commentByIdQuery,
        variables: {
            pageId: contentId,
            commentId: commentId || undefined,
            inlineMarkerRef: markerRef || undefined,
            // Query for all content statuses - don't filter by contentStatus
            contentStatus: (0, $NYiei.allContentStatuses)
        },
        fetchPolicy: fetchPolicy
    });
    const nodes = response?.data?.comments?.nodes;
    if (!nodes || nodes.length === 0) return null;
    // Filter out nulls and convert readonly array to mutable array
    const comments = nodes.filter((node)=>node !== null);
    return (0, $kgNLQ.findAndFilterComment)(comments, commentId, markerRef, (0, $NYiei.allContentStatuses));
};
module.exports["USE_COMMENT_BY_ID_COMMENT_NOT_FOUND_MESSAGE"] = $f4841d4502be35b2$export$4bf99575c214d4b;
module.exports["useCommentById"] = $f4841d4502be35b2$export$778dda4ccca7793f;
module.exports["fetchCommentById"] = $f4841d4502be35b2$export$77a85b13740d9b96;

});

parcelRegister("dc3kb", function(module, exports) {
/**
 * @generated SignedSource<<5436b93d76e4ad3ca1b847dd48c8568a>>
 * @relayHash 80f6dc5113d6aef8927adf669909b48e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b
const $09771c757ee62765$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentStatus"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "inlineMarkerRef"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "pageId"
    }, v4 = {
        "kind": "Variable",
        "name": "pageId",
        "variableName": "pageId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v8 = {
        "kind": "ScalarField",
        "name": "permissionType"
    }, v9 = {
        "concreteType": "Icon",
        "kind": "LinkedField",
        "name": "profilePicture",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "path"
            }
        ]
    }, v10 = {
        "kind": "ScalarField",
        "name": "type"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "accountId"
            }
        ],
        "type": "KnownUser"
    }, v12 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v13 = {
        "args": [
            {
                "kind": "Literal",
                "name": "representation",
                "value": "ATLAS_DOC_FORMAT"
            }
        ],
        "concreteType": "DocumentBody",
        "kind": "LinkedField",
        "name": "body",
        "plural": false,
        "selections": v12 /*: any*/ ,
        "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
    }, v14 = {
        "kind": "ScalarField",
        "name": "contentStatus"
    }, v15 = {
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdAt",
        "plural": false,
        "selections": v12 /*: any*/ 
    }, v16 = {
        "kind": "ScalarField",
        "name": "createdAtNonLocalized"
    }, v17 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "editui"
            },
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v18 = {
        "kind": "ScalarField",
        "name": "resolved"
    }, v19 = {
        "kind": "ScalarField",
        "name": "resolvedFriendlyDate"
    }, v20 = {
        "kind": "ScalarField",
        "name": "resolvedTime"
    }, v21 = {
        "kind": "ScalarField",
        "name": "resolvedUser"
    }, v22 = {
        "kind": "LinkedField",
        "name": "location",
        "plural": false,
        "selections": [
            v6 /*: any*/ ,
            v10 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "commentResolveProperties",
                        "plural": false,
                        "selections": [
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    }
                ],
                "type": "FooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "inlineMarkerRef"
                    },
                    {
                        "concreteType": "InlineCommentResolveProperties",
                        "kind": "LinkedField",
                        "name": "inlineResolveProperties",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "isDangling"
                            },
                            v18 /*: any*/ ,
                            v19 /*: any*/ ,
                            v20 /*: any*/ ,
                            v21 /*: any*/ 
                        ]
                    },
                    {
                        "kind": "ScalarField",
                        "name": "inlineText"
                    }
                ],
                "type": "InlineComment"
            }
        ]
    }, v23 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v24 = {
        "concreteType": "CommentPermissions",
        "kind": "LinkedField",
        "name": "permissions",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "isEditable"
            },
            {
                "kind": "ScalarField",
                "name": "isRemovable"
            },
            {
                "kind": "ScalarField",
                "name": "isResolvable"
            }
        ]
    }, v25 = {
        "args": [
            {
                "kind": "Literal",
                "name": "childType",
                "value": "comment"
            },
            {
                "kind": "Literal",
                "name": "contentType",
                "value": "page"
            },
            v4 /*: any*/ 
        ],
        "concreteType": "ReactionsSummaryResponse",
        "kind": "LinkedField",
        "name": "reactionsSummary",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "ari"
            },
            {
                "kind": "ScalarField",
                "name": "containerAri"
            },
            {
                "kind": "ScalarField",
                "name": "reactionsCount"
            },
            {
                "concreteType": "ReactionsSummaryForEmoji",
                "kind": "LinkedField",
                "name": "reactionsSummaryForEmoji",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "count"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "emojiId"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "reacted"
                    }
                ]
            }
        ]
    }, v26 = {
        "kind": "ScalarField",
        "name": "number"
    }, v27 = {
        "kind": "ScalarField",
        "name": "when"
    }, v28 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "commentId",
                    "variableName": "commentId"
                },
                {
                    "kind": "Variable",
                    "name": "contentStatus",
                    "variableName": "contentStatus"
                },
                {
                    "kind": "Variable",
                    "name": "inlineMarkerRef",
                    "variableName": "inlineMarkerRef"
                },
                v4 /*: any*/ 
            ],
            "concreteType": "PaginatedCommentList",
            "kind": "LinkedField",
            "name": "comments",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Comment",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v5 /*: any*/ ,
                        {
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        v13 /*: any*/ ,
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "container",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ 
                            ]
                        },
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v16 /*: any*/ ,
                        v17 /*: any*/ ,
                        v22 /*: any*/ ,
                        v23 /*: any*/ ,
                        v24 /*: any*/ ,
                        v25 /*: any*/ ,
                        {
                            "concreteType": "Comment",
                            "kind": "LinkedField",
                            "name": "replies",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "author",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v8 /*: any*/ ,
                                        v11 /*: any*/ ,
                                        v9 /*: any*/ 
                                    ]
                                },
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ ,
                                v16 /*: any*/ ,
                                v17 /*: any*/ ,
                                v22 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v25 /*: any*/ ,
                                {
                                    "concreteType": "Version",
                                    "kind": "LinkedField",
                                    "name": "version",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "by",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ 
                                            ]
                                        },
                                        v26 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                }
                            ]
                        },
                        {
                            "concreteType": "Version",
                            "kind": "LinkedField",
                            "name": "version",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "by",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        v7 /*: any*/ ,
                                        v11 /*: any*/ 
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "friendlyWhen"
                                },
                                v26 /*: any*/ ,
                                v27 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useCommentByIdQuery",
            "selections": v28 /*: any*/ 
        },
        "params": {
            "cacheID": "80f6dc5113d6aef8927adf669909b48e",
            "id": "a7e41ef969ee551d0afd8d103f23ec6991292b83b77931c1782403014e46ce8b",
            "metadata": {},
            "name": "useCommentByIdQuery",
            "operationKind": "query",
            "text": "query useCommentByIdQuery($pageId:ID!,$commentId:ID,$inlineMarkerRef:String,$contentStatus:[GraphQLContentStatus]){comments(pageId:$pageId,contentStatus:$contentStatus,commentId:$commentId,inlineMarkerRef:$inlineMarkerRef){nodes{id,author{__typename,displayName,permissionType,...on KnownUser{accountId,permissionType},profilePicture{path},type},body(representation:ATLAS_DOC_FORMAT){value},container{id},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},replies{id,author{__typename,displayName,permissionType,...on KnownUser{accountId},profilePicture{path}},body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{editui,webui},location{__typename,type,...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on InlineComment{inlineMarkerRef,inlineResolveProperties{isDangling,resolved,resolvedFriendlyDate,resolvedTime,resolvedUser},inlineText}},parentId,permissions{isEditable,isRemovable,isResolvable},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\"){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,count,emojiId,reacted}},version{by{__typename,displayName},number,when}},version{by{__typename,type,displayName,...on KnownUser{accountId}},friendlyWhen,number,when}}}}"
        }
    };
}();
$09771c757ee62765$var$node.hash = "ed7145a8b5d08f815e716de36a4b73ca";
var $09771c757ee62765$export$2e2bcd8739ae039 = $09771c757ee62765$var$node;
module.exports["default"] = $09771c757ee62765$export$2e2bcd8739ae039;

});

parcelRegister("1rdvc", function(module, exports) {
/**
 * @generated SignedSource<<5ee01bec8d3f6c744747b059c459e176>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $39a1d37ae379d69e$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["GraphQLContentStatus"] = $39a1d37ae379d69e$export$b634e5de755b7d35;

});

parcelRegister("kBOGD", function(module, exports) {
/* CreateComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $7zgzO = parcelRequire("7zgzO");


var $de2j9 = parcelRequire("de2j9");


var $4ri4I = parcelRequire("4ri4I");


var $7NoF3 = parcelRequire("7NoF3");


var $6GD8y = parcelRequire("6GD8y");


var $fZAJP = parcelRequire("fZAJP");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");


var $dkIiA = parcelRequire("dkIiA");


var $frIzR = parcelRequire("frIzR");







var $8C5kA = parcelRequire("8C5kA");




/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");





var $6mkwk = parcelRequire("6mkwk");


var $dpPtd = parcelRequire("dpPtd");


var $dh538 = parcelRequire("dh538");


var $bedQP = parcelRequire("bedQP");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");


var $cei05 = parcelRequire("cei05");




parcelRequire("42omo");


var $hnvzE = parcelRequire("hnvzE");


var $4rFRN = parcelRequire("4rFRN");

function $f67c117a92e3943c$export$a546442f39c56898({ id: id, children: children }) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[id];
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: experienceObj.experienceId,
        children: children
    });
}



var $gWF6I = parcelRequire("gWF6I");


var $19BZl = parcelRequire("19BZl");


var $9A2e6 = parcelRequire("9A2e6");


var $VSkIN = parcelRequire("VSkIN");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");

function $d7c773b6c8a524b1$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        },
        children: children
    });
}



var $3Qm0K = parcelRequire("3Qm0K");








var $irOoi = parcelRequire("irOoi");


var $4rwCt = parcelRequire("4rwCt");





var $lGgRw = parcelRequire("lGgRw");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");








var $7K3dX = parcelRequire("7K3dX");








var $fFa3V = parcelRequire("fFa3V");

function $20cb900309b02b52$export$46ec6629f411921d({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const unbind = (0, $fFa3V.bind)(el, {
            type: 'click',
            listener: (e)=>{
                if (isOpen) {
                    e.stopPropagation();
                    handleClose(e);
                }
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
}














var $fP8Uu = parcelRequire("fP8Uu");





var $fMjA6 = parcelRequire("fMjA6");

var $6OnN8 = parcelRequire("6OnN8");


var $dv953 = parcelRequire("dv953");




var $jjCkw = parcelRequire("jjCkw");

function $6be040ea1058f318$export$61de563e38fe014d() {
    const { user: currentUser } = (0, $caUKj.useUserContext)();
    const { fetchUser: fetchUser } = (0, $dv953.useFetchUser)();
    /**
	 * Conditionally fetches user data if menu items require it.
	 * Supports both V1 (flat items array) and V2 (sections with items) data structures.
	 *
	 * @param params - Object containing either items array or sections array
	 */ const fetchUserIfNeeded = ({ items: items, sections: sections })=>{
        // Skip if user already available
        if (currentUser) return;
        // Check V1 format (flat items array)
        if (items) {
            const willNeedUser = items.some((item)=>{
                return item.ati && (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati);
            });
            if (willNeedUser) fetchUser();
        }
        // Check V2 format (sections with items)
        if (sections && Array.isArray(sections)) {
            const willNeedUser = sections.some((section)=>Array.isArray(section.items) && section.items.some((item)=>item && item.ati && (0, $jjCkw.REQUIRED_USER_ITEMS).includes(item.ati)));
            if (willNeedUser) fetchUser();
        }
    };
    return {
        fetchUserIfNeeded: fetchUserIfNeeded
    };
}






var $jJf3a = parcelRequire("jJf3a");









function $364339a651e8ac31$export$c1b17113cb5b0556() {
    const loadPromiseRef = (0, $42omo.useRef)(null);
    const experienceTracker = (0, $42omo.useContext)((0, $jJf3a.ExperienceTrackerContext));
    const { product: product, suggestionConfig: suggestionConfig, crossAppCreationConfig: crossAppCreationConfig } = (0, $19BZl.useMenuStateContext)();
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        if (loadPromiseRef.current) return;
        // Only load if either suggestion config or cross-app creation is enabled
        if (!suggestionConfig.enabled && !crossAppCreationConfig?.enabled) return;
        const { cloudId: cloudId, environment: environment } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : suggestionConfig.enabled ? suggestionConfig : {};
        const finalEnvironment = environment || 'prod';
        const loadingPromise = (async ()=>{
            try {
                if (cloudId) {
                    const [{ initLoomSDK: initLoomSDK }, { convertSourceProductToProductType: convertSourceProductToProductType }] = await Promise.all([
                        (parcelRequire("kOiVn")),
                        (parcelRequire("25I5T"))
                    ]);
                    await initLoomSDK({
                        environment: finalEnvironment,
                        cloudId: cloudId,
                        productName: convertSourceProductToProductType(product),
                        experienceTracker: experienceTracker,
                        entryPointLocation: (0, $jjCkw.SOURCE_LOCATION)
                    });
                }
            } catch  {
            // ignore
            }
        })();
        loadPromiseRef.current = loadingPromise;
    }, [
        experienceTracker,
        product,
        suggestionConfig,
        crossAppCreationConfig
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}


function $2dfa3af24f6ca0d4$export$6d4ebacb909d5ca6() {
    const crossAppCreationEnabled = (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const { product: product, suggestionConfig: suggestionConfig, subProduct: subProduct } = (0, $19BZl.useMenuStateContext)();
    const isPrefetchEnabled = suggestionConfig.enabled && suggestionConfig.prefetch === true;
    const { locale: locale } = (0, $8C5kA.default)();
    const onResultChange = suggestionConfig.enabled ? suggestionConfig?.onResultChange : undefined;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $364339a651e8ac31$export$c1b17113cb5b0556)();
    // Use the shared hooks for ATIs logic
    const nativeAtis = (0, $6OnN8.useSuggestionNativeAtis)();
    const preferredAtis = (0, $fMjA6.useSuggestionPreferredAtis)();
    const excludeAtis = (0, $fMjA6.useSuggestionExcludeAtis)();
    /**
   * Fetching V1 version of menu items
   */ const { status: status, data: data, isLoading: isLoading, hasError: hasError, fetchUCSuggestions: fetchUCSuggestions } = (0, $fP8Uu.useUCSuggestions)({
        cloudId: suggestionConfig.enabled ? suggestionConfig.cloudId : '',
        orgId: suggestionConfig.enabled ? suggestionConfig.orgId : '',
        userId: suggestionConfig.enabled ? suggestionConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: suggestionConfig.enabled ? subProduct : undefined,
        nativeAtis: nativeAtis,
        preferredAtis: preferredAtis,
        excludeAtis: excludeAtis
    });
    const prefetchTriggered = (0, $42omo.useRef)(false);
    const userFetchTriggered = (0, $42omo.useRef)(false);
    const shouldFetchSuggestions = crossAppCreationEnabled && isPrefetchEnabled && suggestionConfig.enabled;
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $6be040ea1058f318$export$61de563e38fe014d)();
    const triggerPrefetch = (0, $42omo.useCallback)(async ()=>{
        if (prefetchTriggered.current) return;
        prefetchTriggered.current = true;
        if (shouldFetchSuggestions) fetchUCSuggestions();
        triggerPrefetchLoom();
    }, [
        triggerPrefetchLoom,
        fetchUCSuggestions,
        shouldFetchSuggestions
    ]);
    const bffHasInitialized = (0, $42omo.useMemo)(()=>{
        return status !== (0, $4jETc.RequestStatus).INIT;
    }, [
        status
    ]);
    (0, $42omo.useEffect)(function notifySuggestionResultChange() {
        if (!shouldFetchSuggestions) return;
        if (onResultChange && bffHasInitialized) onResultChange?.({
            data: data,
            isLoading: isLoading,
            hasError: hasError
        });
    }, [
        onResultChange,
        data,
        isLoading,
        hasError,
        bffHasInitialized,
        shouldFetchSuggestions
    ]);
    // Reactively fetch user data when items become available
    (0, $42omo.useEffect)(function fetchUserWhenDataReady() {
        if (!shouldFetchSuggestions || !data?.items || userFetchTriggered.current) return;
        userFetchTriggered.current = true;
        fetchUserIfNeeded({
            items: data.items
        });
    }, [
        shouldFetchSuggestions,
        data?.items,
        fetchUserIfNeeded
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}









var $a1Oiu = parcelRequire("a1Oiu");





var $a5rWO = parcelRequire("a5rWO");



function $bb15c78ee3b94e5d$export$2eeb31739875ab1e() {
    const { sections: sections, product: product, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig } = (0, $19BZl.useMenuStateContext)();
    const { locale: locale } = (0, $8C5kA.default)();
    const shouldSkip = !crossAppCreationConfig.enabled;
    const shouldFetchData = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $364339a651e8ac31$export$c1b17113cb5b0556)();
    const appMenuConfig = (0, $42omo.useMemo)(()=>(0, $a5rWO.sectionsToAppMenuConfig)(sections), [
        sections
    ]);
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $6be040ea1058f318$export$61de563e38fe014d)();
    /**
   * Fetching V2 version of menu items
   */ const { data: data, fetchUCMenuItems: fetchUCMenuItems } = (0, $a1Oiu.useUCMenuItems)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchData
    });
    const prefetchTriggered = (0, $42omo.useRef)(false);
    const userFetchTriggered = (0, $42omo.useRef)(false);
    const triggerPrefetch = (0, $42omo.useCallback)(()=>{
        if (prefetchTriggered.current || !shouldFetchData) return;
        prefetchTriggered.current = true;
        triggerPrefetchLoom();
        fetchUCMenuItems();
    }, [
        shouldFetchData,
        fetchUCMenuItems,
        triggerPrefetchLoom
    ]);
    // Reactively fetch user data when sections become available
    (0, $42omo.useEffect)(function fetchUserWhenDataReady() {
        if (!shouldFetchData || !data?.sections || userFetchTriggered.current) return;
        userFetchTriggered.current = true;
        fetchUserIfNeeded({
            sections: data.sections
        });
    }, [
        shouldFetchData,
        data?.sections,
        fetchUserIfNeeded
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}


const $ea48362f2f432197$var$emptyEntryPointParams = {};
const $ea48362f2f432197$var$noop = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {});
function $ea48362f2f432197$var$EntryPointPopupInner({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, isOpen: isOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { controlledOpen: controlledOpen, preventClose: preventClose, product: product, crossAppCreationConfig: crossAppCreationConfig, suggestionConfig: suggestionConfig, isV2Mode: isV2Mode } = (0, $19BZl.useMenuStateContext)();
    const isOpenStateRefactor = (0, $dh538.fg)('navx-4182-uc-open-state-refactor');
    const v1PrefetchEnabled = suggestionConfig.enabled && Boolean(suggestionConfig.prefetch) && (0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled');
    const v2PrefetchEnabled = crossAppCreationConfig.enabled && Boolean(crossAppCreationConfig.prefetch);
    const { triggerPrefetch: triggerPrefetchV1 } = (0, $2dfa3af24f6ca0d4$export$6d4ebacb909d5ca6)();
    const { triggerPrefetch: triggerPrefetchV2 } = (0, $bb15c78ee3b94e5d$export$2eeb31739875ab1e)();
    const id = (0, $42omo.useMemo)(()=>entryPoint.root.getModuleName() || 'unknown', [
        entryPoint
    ]);
    // OLD: Internal state for backward compatibility (when gate is off)
    const [internalIsOpen, setInternalIsOpen] = (0, $42omo.useState)(false);
    const [content, setContent] = (0, $42omo.useState)(()=>$ea48362f2f432197$var$noop);
    const contentLoadedRef = (0, $42omo.useRef)(false);
    const handleOpen = (0, $42omo.useCallback)(()=>{
        setInternalIsOpen(true);
    }, []);
    const handleClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        if (product === 'confluence' && preventClose) return;
        // OLD: Update internal state when gate is off
        if (!isOpenStateRefactor) setInternalIsOpen(false);
        onClose?.(event, currentLevel);
        setContent(()=>$ea48362f2f432197$var$noop);
        contentLoadedRef.current = false;
    }, [
        preventClose,
        product,
        onClose,
        isOpenStateRefactor
    ]);
    // Compute effective isOpen state based on feature gate
    const isPopupOpen = isOpenStateRefactor ? isOpen ?? false : controlledOpen ?? internalIsOpen;
    const triggerCloseRef = (0, $20cb900309b02b52$export$46ec6629f411921d)({
        isOpen: isPopupOpen,
        handleClose: handleClose
    });
    const prevIsOpenRef = (0, $42omo.useRef)(isPopupOpen);
    const prevControlledOpenRef = (0, $42omo.useRef)(undefined);
    const entryPointLoadTriggeredRef = (0, $42omo.useRef)(false);
    const { fireMenuStateChanged: fireMenuStateChanged, fireEntryPointLoadTriggered: fireEntryPointLoadTriggered } = (0, $7K3dX.useUniversalCreateAnalytics)();
    (0, $42omo.useEffect)(function fireMenuStateChangedEffect() {
        const prevIsOpen = prevIsOpenRef.current;
        // Only fire analytics on actual state transitions (use displayed state)
        if (isPopupOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isPopupOpen ? 'expanded' : 'collapsed',
            version: isV2Mode ? 'v2' : 'v1'
        });
        prevIsOpenRef.current = isPopupOpen;
    }, [
        isPopupOpen,
        fireMenuStateChanged,
        prevIsOpenRef,
        isV2Mode
    ]);
    const version = isV2Mode ? 'v2' : 'v1';
    // on hover callback
    const load = (0, $42omo.useCallback)((trigger = 'hover')=>{
        if (!entryPointLoadTriggeredRef.current) {
            entryPointLoadTriggeredRef.current = true;
            fireEntryPointLoadTriggered({
                trigger: trigger,
                version: version
            });
        }
        if (v2PrefetchEnabled) triggerPrefetchV2();
        else if (v1PrefetchEnabled) triggerPrefetchV1();
        return (0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $ea48362f2f432197$var$emptyEntryPointParams);
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        fireEntryPointLoadTriggered,
        v1PrefetchEnabled,
        v2PrefetchEnabled,
        triggerPrefetchV1,
        triggerPrefetchV2,
        version
    ]);
    // on menu loaded callback
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when already loaded
        if (contentLoadedRef.current) return;
        // OLD: Update internal state when gate is off
        if (!isOpenStateRefactor) handleOpen();
        contentLoadedRef.current = true;
        setContent(()=>(contentProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                    id: id,
                    entryPointReference: entryPointReference,
                    fallback: fallback || null,
                    errorFallback: errorFallback,
                    runtimeProps: {
                        entryPointProps: entryPointProps,
                        onClose: handleClose,
                        contentProps: contentProps
                    },
                    onError: onError,
                    forcedError: forcedReportErrorUFO
                }));
    }, [
        setContent,
        isOpenStateRefactor,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        onError,
        handleClose,
        handleOpen
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    // Primary button onLoad - preload but don't open popup
    const onLoadPrimary = (0, $42omo.useCallback)(()=>{
    // Primary button should only preload, NOT open the popup
    // The preloaded reference will be disposed automatically by usePressablePreloadRef
    // The actual click behavior is handled by primaryActionItem.onClick
    }, []);
    // Separate ref for the primary button with ONLY preload functionality (no popup opening)
    const primaryButtonRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoadPrimary
    });
    const popupTrigger = (0, $42omo.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4rwCt.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            splitButtonPrimaryRef: primaryButtonRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        primaryButtonRef
    ]);
    const popupContent = (0, $42omo.useCallback)((contentProps)=>content(contentProps), [
        content
    ]);
    // Track previous values to detect prop changes
    // Initialize as undefined to detect initial render with isOpen={true}
    const prevIsOpenPropRef = (0, $42omo.useRef)(undefined);
    // NEW behavior (gate ON): Load when isOpen prop changes to true
    (0, $42omo.useEffect)(function preloadWithControlledOpenStateNew() {
        if (!isOpenStateRefactor) return;
        const isOpenPropChanged = isOpen !== prevIsOpenPropRef.current;
        prevIsOpenPropRef.current = isOpen;
        if (isOpen && isOpenPropChanged && !contentLoadedRef.current) {
            const triggerLoading = ()=>{
                const preloadedRef = load('controlled');
                if (preloadedRef) onLoad({
                    reference: preloadedRef
                });
            };
            const timeoutId = setTimeout(triggerLoading, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        isOpenStateRefactor,
        isOpen,
        load,
        onLoad
    ]);
    // OLD behavior (gate OFF)
    (0, $42omo.useEffect)(function preloadWithControlledOpenStateOld() {
        if (isOpenStateRefactor) return;
        if (controlledOpen !== undefined && controlledOpen !== prevControlledOpenRef.current) {
            prevControlledOpenRef.current = controlledOpen;
            if (isPopupOpen && !internalIsOpen) {
                const triggerLoadingAndOpen = ()=>{
                    const preloadedRef = load('controlled');
                    if (preloadedRef) onLoad({
                        reference: preloadedRef
                    });
                };
                const timeoutId = setTimeout(triggerLoadingAndOpen, 0);
                return ()=>clearTimeout(timeoutId);
            } else if (!isPopupOpen) setInternalIsOpen(false);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        controlledOpen,
        internalIsOpen,
        isPopupOpen
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.Popup), {
        ...popupProps,
        isOpen: isPopupOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
function $ea48362f2f432197$export$8f8a5b7d7394d1f8(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9A2e6.GenericErrorBoundary), {
        name: "entry-point-popup",
        children: /*#__PURE__*/ (0, $l998X.jsx)($ea48362f2f432197$var$EntryPointPopupInner, {
            ...props
        })
    });
}



var $amdkE = parcelRequire("amdkE");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 














var $4KS7f = parcelRequire("4KS7f");


var $9gE7g = parcelRequire("9gE7g");


var $g5gZt = parcelRequire("g5gZt");


var $ghftu = parcelRequire("ghftu");


var $hmuev = parcelRequire("hmuev");


var $aaBfd = parcelRequire("aaBfd");


var $1lhEF = parcelRequire("1lhEF");

var $5izcQ = parcelRequire("5izcQ");





var $291hi = parcelRequire("291hi");

var $26eSY = parcelRequire("26eSY");

var $fFc6D = parcelRequire("fFc6D");














var $fNh3C = parcelRequire("fNh3C");

const $be8eb3f37dd41711$var$triggerButton = null; /**
                             * Refactor this whole logic after T-25, we should use the proper Create component instead.
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $be8eb3f37dd41711$var$nav3ButtonTextStyles = null;
const $be8eb3f37dd41711$var$messages = (0, $cgtv4.defineMessages)({
    secondaryButtonTooltipText: {
        id: "platform.navigation-experiences.universal-create.secondary-tooltip-text",
        defaultMessage: "More create options"
    }
});
function $be8eb3f37dd41711$var$TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: text,
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: true,
        children: children
    });
}
function $be8eb3f37dd41711$var$TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: isEntryPointEnabled = false, buttonOnly: buttonOnly = false }) {
    const isButtonOnly = buttonOnly && (0, $dh538.fg)('navx_4208_uc_button_only_enabled');
    const { product: product, sections: sections } = (0, $19BZl.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isDesktop = (0, $fFc6D.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const version = sections?.length ? 'v2' : 'v1';
    const hasHoveredRef = (0, $42omo.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? 'split' : 'standard';
    (0, $42omo.useEffect)(function fireButtonViewEvent() {
        fireCreateButtonViewed({
            buttonVariant: buttonVariant,
            version: version,
            isButtonOnly: isButtonOnly
        });
    }, [
        fireCreateButtonViewed,
        buttonVariant,
        version,
        isButtonOnly
    ]); // Extract splitPrimaryRef from triggerProps for split button variant
    const { splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = triggerProps ?? {};
    const onButtonClick = (0, $42omo.useCallback)(()=>{
        /// For entrypoint path (isEntryPointEnabled is true), set to expanded when isOpen is true
        // For non-entrypoint path (isEntryPointEnabled is false), set to expanded when isOpen is false (current state), as in the legacy mode, the event is fired before menu opens.
        const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        fireCreateButtonClicked({
            itemState: itemState
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick,
        isEntryPointEnabled,
        isButtonOnly
    ]);
    const CreateIcon = isButtonOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))) : isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))) : (0, (/*@__PURE__*/$parcel$interopDefault($g5gZt)));
    const createEnterEvent = (0, $42omo.useCallback)(({ buttonPart: buttonPart, shouldTriggerMouseEnterProp: shouldTriggerMouseEnterProp = true })=>(event)=>{
            if (!hasHoveredRef.current) {
                hasHoveredRef.current = true;
                const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
                fireCreateButtonHovered({
                    buttonPart: buttonPart,
                    buttonVariant: buttonVariant,
                    itemState: itemState,
                    version: version
                });
            }
            if (shouldTriggerMouseEnterProp) onMouseEnter?.(event);
        }, [
        onMouseEnter,
        fireCreateButtonHovered,
        isOpen,
        isEntryPointEnabled,
        version,
        buttonVariant,
        isButtonOnly
    ]);
    const enterEvent = createEnterEvent({
        buttonPart: 'full'
    }); // Primary button should only fire analytics, not trigger onMouseEnter prop (which triggers lazy loading)
    const enterEventPrimaryAnalyticsOnly = createEnterEvent({
        buttonPart: 'primary',
        shouldTriggerMouseEnterProp: false
    });
    const enterEventDropdown = createEnterEvent({
        buttonPart: 'dropdown'
    });
    const leaveEvent = (0, $42omo.useCallback)((event)=>{
        onMouseLeave?.(event);
    }, [
        onMouseLeave
    ]);
    const button = /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ]),
        children: product === 'confluence' && !isNav4Enabled ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
            className: (0, $gMc0m.default)([
                "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $4KS7f.default), {
                ...restTriggerProps,
                appearance: "primary",
                theme: buttonTheme,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                onClick: onButtonClick,
                iconBefore: /*#__PURE__*/ (0, $l998X.jsx)(CreateIcon, {
                    label: "",
                    "data-vc": "global-content-create-button"
                }),
                testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                isSelected: isOpen,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
            text: children,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                ...restTriggerProps,
                appearance: "primary",
                onClick: onButtonClick,
                onMouseEnter: enterEvent,
                onMouseLeave: leaveEvent,
                isSelected: isOpen,
                iconBefore: CreateIcon,
                testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                "aria-label": children,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                    above: "sm",
                    as: "span",
                    children: children
                })
            })
        })
    });
    const responsiveSafeButton = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                        ...isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        iconBefore: CreateIcon,
                        testId: testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID),
                        "aria-label": children,
                        "data-responsive-variant": "desktop",
                        children: children
                    })
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const splitButtonVariant = /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $26eSY.Show), {
                above: (0, $jjCkw.RESPONSIVE_BREAKPOINT),
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $9gE7g.SplitButton), {
                    appearance: "primary",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: children,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.Button), {
                                ref: splitButtonPrimaryRef,
                                appearance: "primary",
                                onClick: primaryActionItem?.onClick,
                                onMouseEnter: enterEventPrimaryAnalyticsOnly,
                                "aria-label": children,
                                testId: "uc-trigger-button-primary",
                                children: children
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                            text: formatMessage($be8eb3f37dd41711$var$messages.secondaryButtonTooltipText),
                            isScreenReaderAnnouncementDisabled: false,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                                ...isDesktop ? restTriggerProps : {},
                                appearance: "primary",
                                onClick: onButtonClick,
                                isSelected: isOpen,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))),
                                "data-responsive-variant": "desktop",
                                label: children,
                                testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-split`,
                                onMouseEnter: enterEventDropdown,
                                onMouseLeave: leaveEvent
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $291hi.Hide), {
                above: "sm",
                children: /*#__PURE__*/ (0, $l998X.jsx)($be8eb3f37dd41711$var$TooltipWrapper, {
                    text: children,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
                        ...!isDesktop ? restTriggerProps : {},
                        appearance: "primary",
                        onClick: onButtonClick,
                        onMouseEnter: enterEvent,
                        onMouseLeave: leaveEvent,
                        isSelected: isOpen,
                        icon: CreateIcon,
                        testId: `${testId || (0, $jjCkw.TRIGGER_BUTTON_TEST_ID)}-mobile`,
                        label: children,
                        "data-responsive-variant": "mobile"
                    })
                })
            })
        ]
    });
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : button;
    return triggerButtonSpotlightTarget ? /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: triggerButtonSpotlightTarget,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1lhEF.Pulse), {
            radius: 3,
            pulse: enableTriggerPulse,
            children: buttonToRender
        })
    }) : buttonToRender;
}
const $be8eb3f37dd41711$export$4129321aecd13375 = (0, $fNh3C.withIntlProvider)($be8eb3f37dd41711$var$TriggerButtonInner);



var $lz3e7 = parcelRequire("lz3e7");


var $aH9Q1 = parcelRequire("aH9Q1");


var $cab2i = parcelRequire("cab2i");


const $1994d55f15263ec5$export$8970f497f10bcb6 = (0, $cab2i.createEntryPoint)({
    root: (0, $aH9Q1.JSResourceForInteraction)(()=>(parcelRequire("fxgOI")).then((module)=>module.PopupContent), {
        moduleId: "e6344ac7",
        priority: "interaction",
        moduleId: 'universal-create-popup-content'
    }),
    getPreloadProps: (_params)=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});












var $cAXnn = parcelRequire("cAXnn");

function $2c526ef00c6d159b$export$7080b3e976bc91ab(eventName, subscriber) {
    (0, $42omo.useEffect)(()=>{
        return (0, $cAXnn.eventEmitter).on(eventName, subscriber);
    }, [
        eventName,
        subscriber
    ]);
}





const $beb28d2d951f2a81$var$MODULE_ID = 'universal-create-popup-content';
function $beb28d2d951f2a81$export$1fd7afacc69597bb() {
    const { fireJSChunkLoadTime: fireJSChunkLoadTime } = (0, $7K3dX.useUniversalCreateAnalytics)();
    const hasFiredRef = (0, $42omo.useRef)(false);
    const loadStartTimesRef = (0, $42omo.useRef)(new Map());
    const handleLoadStart = (0, $42omo.useCallback)((event)=>{
        if (event.moduleId === $beb28d2d951f2a81$var$MODULE_ID && !hasFiredRef.current && (0, $dh538.fg)('navx_3517_uc_enable_js_load_event_watching')) loadStartTimesRef.current.set(event.transactionId, performance.now());
    }, []);
    const handleLoadCompleteOrError = (0, $42omo.useCallback)((event)=>{
        if (!(0, $dh538.fg)('navx_3517_uc_enable_js_load_event_watching')) return;
        const startTime = loadStartTimesRef.current.get(event.transactionId);
        if (startTime !== undefined) loadStartTimesRef.current.delete(event.transactionId);
        if (event.moduleId === $beb28d2d951f2a81$var$MODULE_ID && startTime !== undefined && !hasFiredRef.current) {
            const loadTime = performance.now() - startTime;
            hasFiredRef.current = true;
            fireJSChunkLoadTime({
                durationInMs: loadTime,
                hasError: Boolean(event.error)
            });
        }
    }, [
        fireJSChunkLoadTime
    ]);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.start', handleLoadStart);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.complete', handleLoadCompleteOrError);
    (0, $2c526ef00c6d159b$export$7080b3e976bc91ab)('jsresource.load.error', handleLoadCompleteOrError);
}


/**
 * Type guard to check if props are v1 (has 'items' property)
 */ function $ef6fa1c49d375522$var$isV1Props(props) {
    return 'items' in props && props.buttonOnly !== true;
}
/**
 * Type guard to check if props are v2 (has 'sections' property)
 */ function $ef6fa1c49d375522$var$isV2Props(props) {
    return 'sections' in props && props.buttonOnly !== true;
}
function $ef6fa1c49d375522$var$UniversalCreateButtonInner(props) {
    const { children: children, testId: testId, onClick: onClick, onClose: onClose, isOpen: isOpen, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent, buttonOnly: buttonOnly = false } = props;
    const isButtonOnly = buttonOnly && (0, $dh538.fg)('navx_4208_uc_button_only_enabled');
    const primaryActionItem = 'primaryActionItem' in props ? props.primaryActionItem : undefined;
    const isResponsive = (0, $lz3e7.useIsResponsiveView)();
    // Track JS chunk load time - must be called before the lazy chunk loads
    (0, $beb28d2d951f2a81$export$1fd7afacc69597bb)();
    // Normalize items for v1, or use empty array for v2
    const items = $ef6fa1c49d375522$var$isV1Props(props) ? props.items : undefined;
    const structuredItems = (0, $VSkIN.useNormalizeItems)(items ?? []);
    const isOpenStateRefactor = (0, $dh538.fg)('navx-4182-uc-open-state-refactor');
    // Use useControlled hook to handle both controlled and uncontrolled state
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>false);
    const handleTriggerButtonClick = (0, $42omo.useCallback)(()=>{
        if (isOpenStateRefactor) setLocalIsOpen(!isLocalOpen);
        // Notify parent
        onClick?.();
    }, [
        isOpenStateRefactor,
        isLocalOpen,
        setLocalIsOpen,
        onClick
    ]);
    const handleClose = (0, $42omo.useCallback)(()=>{
        if (isOpenStateRefactor) setLocalIsOpen(false);
        onClose?.();
    }, [
        isOpenStateRefactor,
        setLocalIsOpen,
        onClose
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)((event)=>{
        onMouseEnter?.(event);
    }, [
        onMouseEnter
    ]);
    const menuStateContextValue = (0, $42omo.useMemo)(()=>{
        const isV2Mode = $ef6fa1c49d375522$var$isV2Props(props);
        const sections = isV2Mode && 'sections' in props && props.sections ? props.sections : [];
        const crossAppCreationConfig = isV2Mode && 'crossAppCreationConfig' in props ? props.crossAppCreationConfig ?? {
            enabled: false
        } : {
            enabled: false
        };
        const selectedItem = 'selectedItem' in props ? props.selectedItem : undefined;
        const controlledOpen = 'isOpen' in props ? props.isOpen : undefined;
        return {
            isV2Mode: isV2Mode,
            items: (0, $dh538.fg)('navx_uc_context_refactor') ? structuredItems : $ef6fa1c49d375522$var$isV1Props(props) ? // keep previous code path, would be removed after fg rollout
            props.items ?? [] : [],
            product: props.product ?? 'unknown',
            subProduct: props.subProduct,
            isNav4Enabled: isNav4Enabled,
            sections: sections,
            crossAppCreationConfig: crossAppCreationConfig,
            suggestionConfig: 'suggestionConfig' in props ? props.suggestionConfig ?? {
                enabled: false
            } : {
                enabled: false
            },
            selectedItem: selectedItem,
            preventClose: props.preventClose,
            primaryActionItem: primaryActionItem,
            ...isOpenStateRefactor ? {} : {
                controlledOpen: controlledOpen
            }
        };
    }, [
        props,
        isNav4Enabled,
        structuredItems,
        primaryActionItem,
        isOpenStateRefactor
    ]);
    const sharedTriggerButtonProps = (0, $42omo.useMemo)(()=>({
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: handleTriggerButtonClick,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme
        }), [
        testId,
        triggerButtonSpotlightTarget,
        enableTriggerPulse,
        handleMouseEnter,
        onMouseLeave,
        handleTriggerButtonClick,
        isNav4Enabled,
        buttonTheme
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $19BZl.MenuStateContext).Provider, {
        value: menuStateContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ef6fa1c49d375522$var$GicModalProviderWithFG, {
            children: isButtonOnly ? /*#__PURE__*/ (0, $l998X.jsx)((0, $be8eb3f37dd41711$export$4129321aecd13375), {
                ...sharedTriggerButtonProps,
                buttonOnly: true,
                children: children
            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $ea48362f2f432197$export$8f8a5b7d7394d1f8), {
                ...isOpenStateRefactor ? {
                    isOpen: isLocalOpen
                } : {},
                placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
                // eslint-disable-next-line @atlaskit/design-system/use-should-render-to-parent
                shouldRenderToParent: shouldRenderToParent,
                onClose: handleClose,
                trigger: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $be8eb3f37dd41711$export$4129321aecd13375), {
                        ...sharedTriggerButtonProps,
                        buttonOnly: undefined,
                        isEntryPointEnabled: true,
                        triggerProps: triggerProps,
                        isOpen: triggerProps['aria-expanded'],
                        primaryActionItem: primaryActionItem,
                        children: children
                    }),
                entryPoint: (0, $1994d55f15263ec5$export$8970f497f10bcb6),
                entryPointProps: props,
                fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $amdkE.LoadingMenu), {
                    padded: true
                })
            })
        })
    });
}
function $ef6fa1c49d375522$var$UFOWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f67c117a92e3943c$export$a546442f39c56898), {
        id: "universalCreateComponentLoad",
        children: children
    });
}
function $ef6fa1c49d375522$var$NoopComponent(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Fragment), {
        children: props.children
    });
}
const $ef6fa1c49d375522$var$GicModalProviderWithFG = (0, $bedQP.componentWithFG)('navx_enable_gic', (0, $3Qm0K.GicModalProvider), $ef6fa1c49d375522$var$NoopComponent);
function $ef6fa1c49d375522$var$UniversalCreateButtonLazyInner(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)($ef6fa1c49d375522$var$UFOWrapper, {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gWF6I.ConditionalRelayEnvironmentProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
                consumer: (0, $4jETc.BFFConsumerEnum).UNIVERSAL_CREATE,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cei05.UniversalCreateBFFProvider), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d7c773b6c8a524b1$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
                            children: /*#__PURE__*/ (0, $l998X.jsx)($ef6fa1c49d375522$var$UniversalCreateButtonInner, {
                                ...props
                            })
                        })
                    })
                })
            })
        })
    });
}
function $ef6fa1c49d375522$export$3739611c05de95f9(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9A2e6.GenericErrorBoundary), {
        name: "universal-create-button-lazy",
        app: props.product,
        children: /*#__PURE__*/ (0, $l998X.jsx)($ef6fa1c49d375522$var$UniversalCreateButtonLazyInner, {
            ...props
        })
    });
}



var $7aRa9 = parcelRequire("7aRa9");


var $9wGTI = parcelRequire("9wGTI");


var $56QzY = parcelRequire("56QzY");


var $1KBSi = parcelRequire("1KBSi");


var $lBYCH = parcelRequire("lBYCH");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $6mKj3 = parcelRequire("6mKj3");








var $3Yga2 = parcelRequire("3Yga2");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $dPJCf = parcelRequire("dPJCf");


var $3jwuS = parcelRequire("3jwuS");


var $d9tcB = parcelRequire("d9tcB");


var $7EIq6 = parcelRequire("7EIq6");


var $eB1TF = parcelRequire("eB1TF");































var $yuLaV = parcelRequire("yuLaV");





var $kDja4 = parcelRequire("kDja4");








var $8cKgI = parcelRequire("8cKgI");





var $fSDMD = parcelRequire("fSDMD");













var $e0ycV = parcelRequire("e0ycV");


var $6yCpa = parcelRequire("6yCpa");


var $lqy4C = parcelRequire("lqy4C");








var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");











var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $ecnYn = parcelRequire("ecnYn");


var $5nBzc = parcelRequire("5nBzc");


var $ibDKJ = parcelRequire("ibDKJ");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $ecnYn.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== lozenge || $[3] !== useLabsLozenge) {
        t2 = useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ibDKJ.AILabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5nBzc.default), {
            appearance: "new"
        }, lozenge);
        $[2] = lozenge;
        $[3] = useLabsLozenge;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};


const $27cf2e1d8d21e923$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.liveDoc.new.lozenge",
        defaultMessage: "New"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af(t0) {
    const $ = (0, $frIzR.c)(24);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, hideLozenge: hideLozenge } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createLiveDocPopoverItem");
            hybridLinkClick(e);
            (0, $3Yga2.setLozengeShownTrackerMax)();
        };
        $[5] = hybridLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $3Yga2.checkShouldShowLozenge)();
        $[8] = t4;
    } else t4 = $[8];
    const shouldShowLozenge = t4;
    let t5;
    if ($[9] !== formatMessage || $[10] !== hideLozenge) {
        t5 = (0, $9wGTI.fg)("confluence_remove_live_page_lozenge_hello") || !shouldShowLozenge || hideLozenge ? formatMessage($27cf2e1d8d21e923$var$messages.title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: formatMessage($27cf2e1d8d21e923$var$messages.newLozenge)
        }, formatMessage($27cf2e1d8d21e923$var$messages.title));
        $[9] = formatMessage;
        $[10] = hideLozenge;
        $[11] = t5;
    } else t5 = $[11];
    const titleItem = t5;
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:livedoc");
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== enforceStorageLimit || $[14] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[13] = enforceStorageLimit;
        $[14] = handleClick;
        $[15] = t7;
    } else t7 = $[15];
    let t8;
    if ($[16] !== createHref || $[17] !== shouldBlockCreate) {
        t8 = !shouldBlockCreate && {
            href: createHref
        };
        $[16] = createHref;
        $[17] = shouldBlockCreate;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t10;
    if ($[19] !== t7 || $[20] !== t8 || $[21] !== t9 || $[22] !== titleItem) {
        t10 = {
            ati: t6,
            children: titleItem,
            onClick: t7,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))),
            ...t8,
            testId: t9
        };
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
        $[22] = titleItem;
        $[23] = t10;
    } else t10 = $[23];
    return t10;
}











var $8jHAi = parcelRequire("8jHAi");













const $f6498381976d168b$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-page-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createPagePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:page");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($f6498381976d168b$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($8jHAi))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}

















var $ZDq1z = parcelRequire("ZDq1z");





var $gj7hi = parcelRequire("gj7hi");





var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1kHsc = parcelRequire("1kHsc");





var $eVXGa = parcelRequire("eVXGa");


var $8aF6s = parcelRequire("8aF6s");

















var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $dcUvx = parcelRequire("dcUvx");

const $10e7e2c648ba4dd0$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $10e7e2c648ba4dd0$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $10e7e2c648ba4dd0$var$F1GameWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(13);
    const { children: children } = t0;
    const [showRacecarIcon, setShowRacecarIcon] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (_)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (__0)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleOnMouseLeave = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.itemWrapper
        ]);
        t4 = (0, $gMc0m.default)([
            $10e7e2c648ba4dd0$var$f1GameStyles.childrenWrapper
        ]);
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== children) {
        t5 = children();
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== showRacecarIcon) {
        t7 = showRacecarIcon && (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($dcUvx))),
            alt: "",
            testId: "confluence-whiteboards-car-icon",
            className: (0, $gMc0m.default)([
                $10e7e2c648ba4dd0$var$f1GameStyles.rightIcon
            ])
        });
        $[8] = showRacecarIcon;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: handleOnMouseEnter,
            onFocus: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onBlur: handleOnMouseLeave,
            className: t3
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
function $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5(t0) {
    const $ = (0, $frIzR.c)(43);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== isOpen) {
        t1 = (0, $9wGTI.fg)("load-whiteboards-paywall-query-when-menu-is-open") && !isOpen;
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    const skipPaywallQuery = t1;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "create-whiteboard-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== deactivationIdentifier || $[4] !== parentId || $[5] !== paywallStatus || $[6] !== source || $[7] !== spaceKey) {
        t3 = (t4, t5)=>{
            const creationOverrides = t4 === undefined ? {} : t4;
            const sourceSuffix = t5 === undefined ? "" : t5;
            return (0, $bZSO8.buildCreationLink)({
                contentType: "whiteboard",
                parentPageId: parentId,
                withFallback: true,
                source: source + sourceSuffix,
                spaceKey: spaceKey,
                deactivationIdentifier: deactivationIdentifier,
                paywallStatus: paywallStatus,
                ...creationOverrides
            });
        };
        $[3] = deactivationIdentifier;
        $[4] = parentId;
        $[5] = paywallStatus;
        $[6] = source;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const buildWhiteboardCreationLink = t3;
    let t4;
    if ($[9] !== buildWhiteboardCreationLink) {
        t4 = buildWhiteboardCreationLink();
        $[9] = buildWhiteboardCreationLink;
        $[10] = t4;
    } else t4 = $[10];
    const createHref = t4;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t5;
    if ($[11] !== buildWhiteboardCreationLink || $[12] !== createAnalyticsEvent || $[13] !== creationPaywallError || $[14] !== experienceTracker || $[15] !== hybridLinkClick || $[16] !== onClick || $[17] !== paywallStatus || $[18] !== showModal || $[19] !== showPaywallBeforeCreate || $[20] !== source) {
        t5 = (e)=>{
            onClick("createWhiteboardPopoverItem");
            if ((0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled")) {
                experienceTracker.start({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                    collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
                });
                if (creationPaywallError) experienceTracker.fail({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    error: creationPaywallError
                });
            }
            if (showPaywallBeforeCreate) {
                e.stopPropagation();
                e.preventDefault();
                showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                    buildWhiteboardCreationLink: buildWhiteboardCreationLink
                });
            } else {
                if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "createUnsetWhiteboardLink",
                        source: source,
                        attributes: {
                            reason: creationPaywallError ? "error" : "loading"
                        }
                    }
                }).fire();
                hybridLinkClick(e);
            }
        };
        $[11] = buildWhiteboardCreationLink;
        $[12] = createAnalyticsEvent;
        $[13] = creationPaywallError;
        $[14] = experienceTracker;
        $[15] = hybridLinkClick;
        $[16] = onClick;
        $[17] = paywallStatus;
        $[18] = showModal;
        $[19] = showPaywallBeforeCreate;
        $[20] = source;
        $[21] = t5;
    } else t5 = $[21];
    const handleClick = t5;
    let t6;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:whiteboard");
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== creationPaywallError) {
        t7 = !(0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $10e7e2c648ba4dd0$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }));
        $[23] = creationPaywallError;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== formatMessage) {
        t8 = formatMessage($10e7e2c648ba4dd0$var$messages.title);
        $[25] = formatMessage;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t7 || $[28] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, t7, t8);
        $[27] = t7;
        $[28] = t8;
        $[29] = t9;
    } else t9 = $[29];
    let t10;
    if ($[30] !== enforceStorageLimit || $[31] !== handleClick) {
        t10 = enforceStorageLimit(handleClick);
        $[30] = enforceStorageLimit;
        $[31] = handleClick;
        $[32] = t10;
    } else t10 = $[32];
    let t11;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && {
            Wrapper: $10e7e2c648ba4dd0$var$F1GameWrapper
        };
        $[33] = t11;
    } else t11 = $[33];
    let t12;
    if ($[34] !== createHref || $[35] !== isAllowedToCreateWhiteboard || $[36] !== shouldBlockCreate) {
        t12 = !shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        };
        $[34] = createHref;
        $[35] = isAllowedToCreateWhiteboard;
        $[36] = shouldBlockCreate;
        $[37] = t12;
    } else t12 = $[37];
    const t13 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t14;
    if ($[38] !== t10 || $[39] !== t12 || $[40] !== t13 || $[41] !== t9) {
        t14 = {
            ati: t6,
            children: t9,
            onClick: t10,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))),
            ...t11,
            ...t12,
            testId: t13
        };
        $[38] = t10;
        $[39] = t12;
        $[40] = t13;
        $[41] = t9;
        $[42] = t14;
    } else t14 = $[42];
    return t14;
}











var $6B0jU = parcelRequire("6B0jU");













const $c6e82055c002803e$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $c6e82055c002803e$export$c03ba1b69410a0fd(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-database-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "database",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createDatabasePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:database");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($c6e82055c002803e$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($6B0jU))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}











var $9RVmI = parcelRequire("9RVmI");













const $b66cd3653b467139$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0(t0) {
    const $ = (0, $frIzR.c)(21);
    const { source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-blog-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== source || $[2] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "blog",
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = source;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[4] !== hybridPageLinkClick || $[5] !== onClick) {
        t3 = (e)=>{
            onClick("createBlogPopoverItem");
            hybridPageLinkClick(e);
        };
        $[4] = hybridPageLinkClick;
        $[5] = onClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:blogpost");
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($b66cd3653b467139$var$messages.title);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== enforceStorageLimit || $[11] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[10] = enforceStorageLimit;
        $[11] = handleClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== createHref || $[14] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[13] = createHref;
        $[14] = shouldBlockCreate;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9RVmI))),
            ...t7,
            testId: t8
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
}











var $duwSm = parcelRequire("duwSm");













const $2e6ededdd99584ac$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $2e6ededdd99584ac$export$da2a30a64353a280(t0) {
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-smart-link-embed-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "smartLinkEmbed",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createSmartLinkEmbedPopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:embed");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($2e6ededdd99584ac$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($duwSm))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}











var $buthI = parcelRequire("buthI");


var $hbYDZ = parcelRequire("hbYDZ");





var $gdv5Z = parcelRequire("gdv5Z");











var $bAyaS = parcelRequire("bAyaS");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");








var $jyA9t = parcelRequire("jyA9t");




const $293cf5b691bb25ab$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $42omo.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleClick = (0, $42omo.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal({
            entryPoint: 'globalCreateSpaceButton',
            spaceKey: ''
        });
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $6yCpa.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($hbYDZ))) : (0, (/*@__PURE__*/$parcel$interopDefault($buthI))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}

















var $2Yaht = parcelRequire("2Yaht");


var $jojoK = parcelRequire("jojoK");





var $4R3wx = parcelRequire("4R3wx");





var $f5Ulo = parcelRequire("f5Ulo");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");








var $7QM6o = parcelRequire("7QM6o");





const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(flags, error, loading, source) {
    const $ = (0, $frIzR.c)(21);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const href = (0, $f5Ulo.useLoomCrossJoinUrl)();
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage || $[2] !== source) {
        t0 = (t1)=>{
            const { children: children } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
                entryPointId: "loom-confluence-create-menu",
                sourceComponent: source,
                shouldRenderToParent: false,
                title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
                sourceActionSubjectId: "createLoomPopoverItem",
                triggerLink: (_, triggerProps)=>children({
                        triggerProps: triggerProps
                    }),
                flags: (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? flags : undefined
            });
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = source;
        $[3] = t0;
    } else t0 = $[3];
    const PopupWrapper = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $6yCpa.Ati).parse(`ati:cloud:${(0, $9wGTI.fg)("navx_4171_uc_fix_loom_ati") ? "loom" : "confluence"}:video`);
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== error || $[6] !== href || $[7] !== loading) {
        t2 = !(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") && !error && !loading && {
            href: href
        };
        $[5] = error;
        $[6] = href;
        $[7] = loading;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== formatMessage) {
        t3 = formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge);
        $[9] = formatMessage;
        $[10] = t3;
    } else t3 = $[10];
    let t4;
    if ($[11] !== formatMessage) {
        t4 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[11] = formatMessage;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== t3 || $[14] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t3
        }, t4);
        $[13] = t3;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    let t6;
    if ($[16] !== PopupWrapper || $[17] !== loading || $[18] !== t2 || $[19] !== t5) {
        t6 = {
            ati: t1,
            ...t2,
            isLoading: loading,
            target: "_blank",
            testId: "create-menu-link-item",
            children: t5,
            Wrapper: PopupWrapper,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht)))
        };
        $[16] = PopupWrapper;
        $[17] = loading;
        $[18] = t2;
        $[19] = t5;
        $[20] = t6;
    } else t6 = $[20];
    return t6;
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t1;
    if ($[0] !== flags) {
        t1 = {
            entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
            flags: flags
        };
        $[0] = flags;
        $[1] = t1;
    } else t1 = $[1];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized } = (0, $9uAPw.useLoomRecorderEntryPoint)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "record-loom-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== onClick || $[5] !== openLoomRecorder || $[6] !== parentId || $[7] !== push || $[8] !== source || $[9] !== spaceId || $[10] !== spaceKey) {
        t3 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        withFallback: true,
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: "topNav"
            });
        };
        $[3] = createAnalyticsEvent;
        $[4] = onClick;
        $[5] = openLoomRecorder;
        $[6] = parentId;
        $[7] = push;
        $[8] = source;
        $[9] = spaceId;
        $[10] = spaceKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $6yCpa.Ati).parse(`ati:cloud:${(0, $9wGTI.fg)("navx_4171_uc_fix_loom_ati") ? "loom" : "confluence"}:video`);
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== formatMessage) {
        t5 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = !isLoomRecorderInitialized;
    let t7;
    if ($[15] !== enforceStorageLimit || $[16] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[15] = enforceStorageLimit;
        $[16] = handleClick;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            ati: t4,
            children: t5,
            isLoading: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))),
            testId: "create-menu-button-item",
            onClick: t7
        };
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, error: error, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(props.flags, error, loading, props.source);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}














var $h7YX1 = parcelRequire("h7YX1");


var $gNXND = parcelRequire("gNXND");





var $16lEl = parcelRequire("16lEl");

var $hUyPY = parcelRequire("hUyPY");





var $dDAsV = parcelRequire("dDAsV");








var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};



var $cbBHq = parcelRequire("cbBHq");


var $1NBp8 = parcelRequire("1NBp8");









var $85eZj = parcelRequire("85eZj");

const $03068ae1a528f6bf$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    },
    smartCreateWithAiTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-rovo-ai.title",
        defaultMessage: "Create with Rovo AI"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2(t0) {
    const $ = (0, $frIzR.c)(31);
    const { spaceKey: spaceKey, onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $hUyPY.useAIMateExperienceTracker)();
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $42omo.useState)("");
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $42omo.useState)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setSpaceKeyLoading(true);
            $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== isOpen || $[3] !== preloadSmartCreationModal) {
        t3 = ()=>{
            if (isOpen) preloadSmartCreationModal();
        };
        t4 = [
            isOpen,
            preloadSmartCreationModal
        ];
        $[2] = isOpen;
        $[3] = preloadSmartCreationModal;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $42omo.useEffect)(t3, t4);
    let t5;
    if ($[6] !== experienceTracker || $[7] !== fetchedSpaceKey || $[8] !== openModal || $[9] !== source || $[10] !== spaceKey) {
        t5 = ()=>{
            experienceTracker.start({
                name: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $16lEl.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal({
                entryPoint: source,
                spaceKey: spaceKey ?? fetchedSpaceKey
            });
        };
        $[6] = experienceTracker;
        $[7] = fetchedSpaceKey;
        $[8] = openModal;
        $[9] = source;
        $[10] = spaceKey;
        $[11] = t5;
    } else t5 = $[11];
    const handleOpenCreateWithRovoExperience = t5;
    let t6;
    if ($[12] !== handleOpenCreateWithRovoExperience || $[13] !== onClick) {
        t6 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenCreateWithRovoExperience();
        };
        $[12] = handleOpenCreateWithRovoExperience;
        $[13] = onClick;
        $[14] = t6;
    } else t6 = $[14];
    const handleItemOnClick = t6;
    let t7;
    if ($[15] !== handleOpenCreateWithRovoExperience || $[16] !== source || $[17] !== spaceKeyLoading) {
        t7 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $85eZj.AnimatedGradientBorder), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a873bb1c9107ef25$export$8432db7340d3c5cd), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children()));
        $[15] = handleOpenCreateWithRovoExperience;
        $[16] = source;
        $[17] = spaceKeyLoading;
        $[18] = t7;
    } else t7 = $[18];
    const CreateWithRovoSpotlightWrapper = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[19] = t8;
    } else t8 = $[19];
    const href = t8;
    let t9;
    if ($[20] !== formatMessage) {
        t9 = ()=>{
            const message = (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? $03068ae1a528f6bf$var$i18n.smartCreateWithAiTitle : $03068ae1a528f6bf$var$i18n.smartCreateTitle;
            if ((0, $9wGTI.fg)("aifc_onboarding_ga_enabled")) {
                if ((0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true)) return formatMessage(message);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
                useLabsLozenge: true
            }, formatMessage(message));
        };
        $[20] = formatMessage;
        $[21] = t9;
    } else t9 = $[21];
    const getChildren = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $6yCpa.Ati).parse(`ati:cloud:confluence:${(0, $9wGTI.fg)("navx_3728_uc_change_cwr_ati") ? "rovo" : "page"}`);
        $[22] = t10;
    } else t10 = $[22];
    let t11;
    if ($[23] !== getChildren) {
        t11 = getChildren();
        $[23] = getChildren;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== handleItemOnClick) {
        t12 = (e_0)=>handleItemOnClick(e_0, "createAISmartCreatePopoverItem");
        $[25] = handleItemOnClick;
        $[26] = t12;
    } else t12 = $[26];
    let t13;
    if ($[27] !== CreateWithRovoSpotlightWrapper || $[28] !== t11 || $[29] !== t12) {
        t13 = {
            ati: t10,
            children: t11,
            Wrapper: CreateWithRovoSpotlightWrapper,
            onClick: t12,
            href: href,
            elemBefore: (0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true) ? (0, (/*@__PURE__*/$parcel$interopDefault($gNXND))) : (0, (/*@__PURE__*/$parcel$interopDefault($h7YX1))),
            testId: "create-menu-link-item"
        };
        $[27] = CreateWithRovoSpotlightWrapper;
        $[28] = t11;
        $[29] = t12;
        $[30] = t13;
    } else t13 = $[30];
    return t13;
}



var $kvDd7 = parcelRequire("kvDd7");

const $279d18c421fdc96b$export$9131280d9d18988b = 'globalCreateContentPopover';
const $279d18c421fdc96b$export$bb6ddeb782a6eace = 6;
const $279d18c421fdc96b$export$9c9b6bde1131681e = 5;
const $279d18c421fdc96b$var$messages = (0, $cgtv4.defineMessages)({
    // eslint-disable-next-line @atlassian/i18n/require-description
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom, splitButtonExperimentEnabled, ucV2MigrationEnabled, isMenuOpen) {
    const $ = (0, $frIzR.c)(133);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isOnEditRoute || $[3] !== openFrom || $[4] !== routeDataRef) {
        t0 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: $279d18c421fdc96b$export$9131280d9d18988b,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        openFrom: openFrom,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isOnEditRoute;
        $[3] = openFrom;
        $[4] = routeDataRef;
        $[5] = t0;
    } else t0 = $[5];
    const handleAnalyticsAndResetStickySearch = t0;
    let t1;
    if ($[6] !== closeMenu || $[7] !== handleAnalyticsAndResetStickySearch) {
        t1 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            closeMenu?.();
        };
        $[6] = closeMenu;
        $[7] = handleAnalyticsAndResetStickySearch;
        $[8] = t1;
    } else t1 = $[8];
    const onClick = t1;
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const t2 = !isMenuOpen;
    let t3;
    if ($[9] !== t2) {
        t3 = {
            skip: t2
        };
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const { isEnabled: isTemplateTouchpointEnabled } = (0, $8cKgI.useCfind5291TemplateTouchpoint)(t3);
    let t4;
    if ($[11] !== contentId || $[12] !== onClick || $[13] !== spaceKey) {
        t4 = {
            source: "globalCreateDropdown-startFromTemplate",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[11] = contentId;
        $[12] = onClick;
        $[13] = spaceKey;
        $[14] = t4;
    } else t4 = $[14];
    const startFromTemplate = (0, $kvDd7.useStartFromTemplateItem)(t4);
    let t5;
    if ($[15] !== onClick || $[16] !== openFrom || $[17] !== spaceKey) {
        t5 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onClick,
            openFrom: openFrom
        };
        $[15] = onClick;
        $[16] = openFrom;
        $[17] = spaceKey;
        $[18] = t5;
    } else t5 = $[18];
    const smartCreate = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t5);
    let t6;
    if ($[19] !== contentId || $[20] !== isTemplateTouchpointEnabled || $[21] !== onClick || $[22] !== spaceKey) {
        t6 = {
            source: "globalCreateDropdown-liveDoc",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            hideLozenge: isTemplateTouchpointEnabled
        };
        $[19] = contentId;
        $[20] = isTemplateTouchpointEnabled;
        $[21] = onClick;
        $[22] = spaceKey;
        $[23] = t6;
    } else t6 = $[23];
    const liveDoc = (0, $27cf2e1d8d21e923$export$5af7ed73ba9cf3af)(t6);
    let t7;
    if ($[24] !== contentId || $[25] !== onClick || $[26] !== spaceKey) {
        t7 = {
            source: "globalCreateDropdown-page",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[24] = contentId;
        $[25] = onClick;
        $[26] = spaceKey;
        $[27] = t7;
    } else t7 = $[27];
    const page = (0, $f6498381976d168b$export$e324b86258d66a8f)(t7);
    let t8;
    if ($[28] !== contentId || $[29] !== onClick || $[30] !== spaceKey) {
        t8 = {
            source: "globalCreateDropdown-whiteboard",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[28] = contentId;
        $[29] = onClick;
        $[30] = spaceKey;
        $[31] = t8;
    } else t8 = $[31];
    const whiteboard = (0, $10e7e2c648ba4dd0$export$15c9136e9dd6e3b5)(t8);
    let t9;
    if ($[32] !== contentId || $[33] !== onClick || $[34] !== spaceKey) {
        t9 = {
            source: "globalCreateDropdown-database",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[32] = contentId;
        $[33] = onClick;
        $[34] = spaceKey;
        $[35] = t9;
    } else t9 = $[35];
    const database = (0, $c6e82055c002803e$export$c03ba1b69410a0fd)(t9);
    let t10;
    if ($[36] !== contentId || $[37] !== onClick || $[38] !== spaceKey) {
        t10 = {
            source: "globalCreateDropdown-blog",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[36] = contentId;
        $[37] = onClick;
        $[38] = spaceKey;
        $[39] = t10;
    } else t10 = $[39];
    const blog = (0, $b66cd3653b467139$export$1850e31ba3eb45b0)(t10);
    let t11;
    if ($[40] !== contentId || $[41] !== onClick || $[42] !== spaceKey) {
        t11 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[40] = contentId;
        $[41] = onClick;
        $[42] = spaceKey;
        $[43] = t11;
    } else t11 = $[43];
    const embed = (0, $2e6ededdd99584ac$export$da2a30a64353a280)(t11);
    let t12;
    if ($[44] !== contentId || $[45] !== flags || $[46] !== onClick || $[47] !== spaceKey) {
        t12 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            flags: flags
        };
        $[44] = contentId;
        $[45] = flags;
        $[46] = onClick;
        $[47] = spaceKey;
        $[48] = t12;
    } else t12 = $[48];
    const loom = (0, $3e0600a499c498b6$export$2c423d86f10c527b)(t12);
    let t13;
    if ($[49] !== contentId || $[50] !== onClick || $[51] !== spaceKey) {
        t13 = {
            source: $279d18c421fdc96b$export$9131280d9d18988b,
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[49] = contentId;
        $[50] = onClick;
        $[51] = spaceKey;
        $[52] = t13;
    } else t13 = $[52];
    const space = (0, $293cf5b691bb25ab$export$4adf07b2777336fa)(t13);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    let t14;
    if ($[53] !== isWhiteboardFeatureEnabled) {
        t14 = isWhiteboardFeatureEnabled("whiteboardOptOut");
        $[53] = isWhiteboardFeatureEnabled;
        $[54] = t14;
    } else t14 = $[54];
    const isOptedOutedOfWhiteboards = t14;
    let t15;
    if ($[55] !== isWhiteboardFeatureEnabled) {
        t15 = isWhiteboardFeatureEnabled("whiteboardsEnabled");
        $[55] = isWhiteboardFeatureEnabled;
        $[56] = t15;
    } else t15 = $[56];
    const isWhiteboardsEnabled = t15;
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    let t16;
    if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database") && !(0, $9wGTI.fg)("confluence_frontend_databases_opt-out");
        $[57] = t16;
    } else t16 = $[57];
    const databaseOptIn = t16;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t17;
    if ($[58] !== isAnonymousUser || $[59] !== isRovoLLMEnabled) {
        t17 = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
        $[58] = isAnonymousUser;
        $[59] = isRovoLLMEnabled;
        $[60] = t17;
    } else t17 = $[60];
    const isAifcEnabled = t17;
    let t18;
    if ($[61] !== blog || $[62] !== canCreateSpace || $[63] !== database || $[64] !== embed || $[65] !== isCreateBlogEnabled || $[66] !== isCreateDatabaseEnabled || $[67] !== isCreateLiveDocEnabled || $[68] !== isCreateSmartLinkEnabled || $[69] !== isCreateWhiteboardEnabled || $[70] !== isLoomEntryPointEnabled || $[71] !== liveDoc || $[72] !== loom || $[73] !== page || $[74] !== space || $[75] !== whiteboard || $[76] !== whiteboardOptIn) {
        t18 = ()=>[
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...canCreateSpace ? [
                    space
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : [],
                ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                    loom
                ] : []
            ];
        $[61] = blog;
        $[62] = canCreateSpace;
        $[63] = database;
        $[64] = embed;
        $[65] = isCreateBlogEnabled;
        $[66] = isCreateDatabaseEnabled;
        $[67] = isCreateLiveDocEnabled;
        $[68] = isCreateSmartLinkEnabled;
        $[69] = isCreateWhiteboardEnabled;
        $[70] = isLoomEntryPointEnabled;
        $[71] = liveDoc;
        $[72] = loom;
        $[73] = page;
        $[74] = space;
        $[75] = whiteboard;
        $[76] = whiteboardOptIn;
        $[77] = t18;
    } else t18 = $[77];
    const getRemainingItems = t18;
    let t19;
    if ($[78] !== blog || $[79] !== canCreateSpace || $[80] !== database || $[81] !== embed || $[82] !== isAifcEnabled || $[83] !== isCreateBlogEnabled || $[84] !== isCreateDatabaseEnabled || $[85] !== isCreateLiveDocEnabled || $[86] !== isCreateSmartLinkEnabled || $[87] !== isCreateWhiteboardEnabled || $[88] !== liveDoc || $[89] !== loom || $[90] !== page || $[91] !== smartCreate || $[92] !== space || $[93] !== splitButtonExperimentEnabled || $[94] !== ucV2MigrationEnabled || $[95] !== whiteboard || $[96] !== whiteboardOptIn) {
        t19 = ()=>[
                ...isAifcEnabled && !splitButtonExperimentEnabled && !ucV2MigrationEnabled ? [
                    smartCreate
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : [],
                ...canCreateSpace ? [
                    space
                ] : [],
                ...ucV2MigrationEnabled ? [
                    loom
                ] : []
            ];
        $[78] = blog;
        $[79] = canCreateSpace;
        $[80] = database;
        $[81] = embed;
        $[82] = isAifcEnabled;
        $[83] = isCreateBlogEnabled;
        $[84] = isCreateDatabaseEnabled;
        $[85] = isCreateLiveDocEnabled;
        $[86] = isCreateSmartLinkEnabled;
        $[87] = isCreateWhiteboardEnabled;
        $[88] = liveDoc;
        $[89] = loom;
        $[90] = page;
        $[91] = smartCreate;
        $[92] = space;
        $[93] = splitButtonExperimentEnabled;
        $[94] = ucV2MigrationEnabled;
        $[95] = whiteboard;
        $[96] = whiteboardOptIn;
        $[97] = t19;
    } else t19 = $[97];
    const getNativeItems = t19;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    if (isTemplateTouchpointEnabled) {
        let t20;
        if ($[98] !== isAifcEnabled || $[99] !== smartCreate || $[100] !== splitButtonExperimentEnabled) {
            t20 = isAifcEnabled && !splitButtonExperimentEnabled ? [
                smartCreate
            ] : [];
            $[98] = isAifcEnabled;
            $[99] = smartCreate;
            $[100] = splitButtonExperimentEnabled;
            $[101] = t20;
        } else t20 = $[101];
        let t21;
        if ($[102] !== startFromTemplate || $[103] !== t20) {
            t21 = {
                items: [
                    ...t20,
                    startFromTemplate
                ]
            };
            $[102] = startFromTemplate;
            $[103] = t20;
            $[104] = t21;
        } else t21 = $[104];
        let t22;
        if ($[105] !== getRemainingItems) {
            t22 = {
                items: getRemainingItems(),
                foldable: $279d18c421fdc96b$export$9c9b6bde1131681e
            };
            $[105] = getRemainingItems;
            $[106] = t22;
        } else t22 = $[106];
        let t23;
        if ($[107] !== t21 || $[108] !== t22) {
            t23 = [
                t21,
                t22
            ];
            $[107] = t21;
            $[108] = t22;
            $[109] = t23;
        } else t23 = $[109];
        return t23;
    }
    let t20;
    if ($[110] !== isAifcEnabled || $[111] !== smartCreate || $[112] !== splitButtonExperimentEnabled || $[113] !== ucV2MigrationEnabled) {
        t20 = isAifcEnabled && !splitButtonExperimentEnabled && ucV2MigrationEnabled ? [
            {
                items: [
                    smartCreate
                ]
            }
        ] : [];
        $[110] = isAifcEnabled;
        $[111] = smartCreate;
        $[112] = splitButtonExperimentEnabled;
        $[113] = ucV2MigrationEnabled;
        $[114] = t20;
    } else t20 = $[114];
    let t21;
    if ($[115] !== getNativeItems) {
        t21 = getNativeItems();
        $[115] = getNativeItems;
        $[116] = t21;
    } else t21 = $[116];
    let t22;
    if ($[117] !== isAnonymousUser || $[118] !== ucV2MigrationEnabled) {
        t22 = ucV2MigrationEnabled ? {
            foldable: $279d18c421fdc96b$export$bb6ddeb782a6eace,
            personalize: !isAnonymousUser && (0, $9wGTI.fg)("navx_uc_confluence_v2_personalize_overflow_enabled") ? "overflow" : "off"
        } : {};
        $[117] = isAnonymousUser;
        $[118] = ucV2MigrationEnabled;
        $[119] = t22;
    } else t22 = $[119];
    let t23;
    if ($[120] !== t21 || $[121] !== t22) {
        t23 = {
            items: t21,
            ...t22
        };
        $[120] = t21;
        $[121] = t22;
        $[122] = t23;
    } else t23 = $[122];
    let t24;
    if ($[123] !== formatMessage || $[124] !== isCreateSmartLinkEnabled || $[125] !== isLoomEntryPointEnabled || $[126] !== loom || $[127] !== ucV2MigrationEnabled) {
        t24 = isCreateSmartLinkEnabled && isLoomEntryPointEnabled && !ucV2MigrationEnabled ? [
            {
                heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
                items: [
                    loom
                ]
            }
        ] : [];
        $[123] = formatMessage;
        $[124] = isCreateSmartLinkEnabled;
        $[125] = isLoomEntryPointEnabled;
        $[126] = loom;
        $[127] = ucV2MigrationEnabled;
        $[128] = t24;
    } else t24 = $[128];
    let t25;
    if ($[129] !== t20 || $[130] !== t23 || $[131] !== t24) {
        t25 = [
            ...t20,
            t23,
            ...t24
        ];
        $[129] = t20;
        $[130] = t23;
        $[131] = t24;
        $[132] = t25;
    } else t25 = $[132];
    return t25;
}



const $f44feda85e5453ef$var$messages = (0, $cgtv4.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = (t0)=>{
    const $ = (0, $frIzR.c)(60);
    const { flags: flags } = t0;
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $eB1TF.useUniversalCreateActions)();
    let t1;
    if ($[0] !== setIsOpen) {
        t1 = ()=>setIsOpen(false);
        $[0] = setIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expVal)("navx_universal_create_cwr_split_button", "isEnabled", false);
        t3 = (0, $9wGTI.fg)("navx_uc_confluence_v2_migration");
        $[2] = t2;
        $[3] = t3;
    } else {
        t2 = $[2];
        t3 = $[3];
    }
    const menuItems = (0, $279d18c421fdc96b$export$aad046bd9909db8f)(flags, t1, undefined, t2, t3, isOpen);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $42omo.useContext)((0, $lBYCH.AppNavigationContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn, cloudId: cloudId, orgId: orgId, userId: userId } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { isLoading: isLoading, isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { loading: canCreateSpaceLoading } = (0, $1KBSi.useCanCreateSpace)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const hasIteratedShownTracker = (0, $42omo.useRef)(false);
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $3Yga2.checkShouldShowLozenge)();
        $[4] = t4;
    } else t4 = $[4];
    const shouldShowLozenge = t4;
    let t5;
    if ($[5] !== theme) {
        t5 = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[5] = theme;
        $[6] = t5;
    } else t5 = $[6];
    const buttonTheme = t5;
    const hasAllItemsLoaded = !isLoading && !canCreateSpaceLoading;
    let t6;
    if ($[7] !== createAnalyticsEvent || $[8] !== isCreateLiveDocEnabled || $[9] !== isOnEditRoute || $[10] !== isOpen || $[11] !== match?.name || $[12] !== setIsOpen) {
        t6 = ()=>{
            if (!isOpen) {
                if (shouldShowLozenge && isCreateLiveDocEnabled && !hasIteratedShownTracker.current) {
                    (0, $3Yga2.iterateLozengeShownTracker)();
                    hasIteratedShownTracker.current = true;
                }
            }
            setIsOpen(!isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute
                    }
                }
            }).fire();
        };
        $[7] = createAnalyticsEvent;
        $[8] = isCreateLiveDocEnabled;
        $[9] = isOnEditRoute;
        $[10] = isOpen;
        $[11] = match?.name;
        $[12] = setIsOpen;
        $[13] = t6;
    } else t6 = $[13];
    const onCreateClick = t6;
    let t7;
    if ($[14] !== createAnalyticsEvent || $[15] !== isLivePage || $[16] !== isOnEditRoute || $[17] !== routeDataRef) {
        t7 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: (0, $279d18c421fdc96b$export$9131280d9d18988b),
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[14] = createAnalyticsEvent;
        $[15] = isLivePage;
        $[16] = isOnEditRoute;
        $[17] = routeDataRef;
        $[18] = t7;
    } else t7 = $[18];
    const handleAnalyticsAndResetStickySearch = t7;
    let t8;
    if ($[19] !== handleAnalyticsAndResetStickySearch || $[20] !== setIsOpen) {
        t8 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            setIsOpen(false);
        };
        $[19] = handleAnalyticsAndResetStickySearch;
        $[20] = setIsOpen;
        $[21] = t8;
    } else t8 = $[21];
    const onSmartCreateClick = t8;
    let t9;
    if ($[22] !== onSmartCreateClick || $[23] !== spaceKey) {
        t9 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onSmartCreateClick
        };
        $[22] = onSmartCreateClick;
        $[23] = spaceKey;
        $[24] = t9;
    } else t9 = $[24];
    const smartCreateItem = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t9);
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t10;
    if ($[25] !== isAnonymousUser || $[26] !== isRovoLLMEnabled) {
        t10 = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
        $[25] = isAnonymousUser;
        $[26] = isRovoLLMEnabled;
        $[27] = t10;
    } else t10 = $[27];
    const isAIFCCreateEnabled = t10;
    let t11;
    if ($[28] !== setIsOpen || $[29] !== setOpenFrom) {
        t11 = ()=>{
            setIsOpen(false);
            setOpenFrom("");
        };
        $[28] = setIsOpen;
        $[29] = setOpenFrom;
        $[30] = t11;
    } else t11 = $[30];
    const onClose = t11;
    let t12;
    bb0: {
        const t13 = cloudId || "";
        const t14 = orgId || "";
        const t15 = userId || "";
        let t16;
        if ($[31] !== t13 || $[32] !== t14 || $[33] !== t15) {
            t16 = {
                enabled: true,
                prefetch: true,
                cloudId: t13,
                orgId: t14,
                accountId: t15
            };
            $[31] = t13;
            $[32] = t14;
            $[33] = t15;
            $[34] = t16;
        } else t16 = $[34];
        const crossAppConfig = t16;
        if ((0, $9wGTI.fg)("navx_uc_confluence_v2_migration")) {
            let t17;
            if ($[35] !== menuItems) {
                t17 = menuItems.map($f44feda85e5453ef$var$_temp);
                $[35] = menuItems;
                $[36] = t17;
            } else t17 = $[36];
            const t18 = t17;
            let t19;
            if ($[37] !== cloudId || $[38] !== crossAppConfig || $[39] !== hasAllItemsLoaded || $[40] !== isAnonymousUser) {
                t19 = hasAllItemsLoaded && !isAnonymousUser && !!cloudId ? crossAppConfig : {
                    enabled: false
                };
                $[37] = cloudId;
                $[38] = crossAppConfig;
                $[39] = hasAllItemsLoaded;
                $[40] = isAnonymousUser;
                $[41] = t19;
            } else t19 = $[41];
            let t20;
            if ($[42] !== t18 || $[43] !== t19) {
                t20 = {
                    sections: t18,
                    crossAppCreationConfig: t19
                };
                $[42] = t18;
                $[43] = t19;
                $[44] = t20;
            } else t20 = $[44];
            t12 = t20;
            break bb0;
        }
        const t17 = menuItems;
        let t18;
        if ($[45] !== t17) {
            t18 = {
                items: t17
            };
            $[45] = t17;
            $[46] = t18;
        } else t18 = $[46];
        t12 = t18;
    }
    const universalCreateItemsProps = t12;
    let t13;
    if ($[47] !== isAIFCCreateEnabled || $[48] !== smartCreateItem) {
        t13 = isAIFCCreateEnabled && (0, $6mKj3.expVal)("navx_universal_create_cwr_split_button", "isEnabled", false) ? {
            primaryActionItem: smartCreateItem
        } : {};
        $[47] = isAIFCCreateEnabled;
        $[48] = smartCreateItem;
        $[49] = t13;
    } else t13 = $[49];
    let t14;
    if ($[50] !== formatMessage) {
        t14 = formatMessage($f44feda85e5453ef$var$messages.create);
        $[50] = formatMessage;
        $[51] = t14;
    } else t14 = $[51];
    let t15;
    if ($[52] !== buttonTheme || $[53] !== isOpen || $[54] !== onClose || $[55] !== onCreateClick || $[56] !== t13 || $[57] !== t14 || $[58] !== universalCreateItemsProps) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ef6fa1c49d375522$export$3739611c05de95f9), {
            ...universalCreateItemsProps,
            onClick: onCreateClick,
            triggerButtonSpotlightTarget: "top-nav-create",
            enableTriggerPulse: false,
            isOpen: isOpen,
            onClose: onClose,
            product: "confluence",
            buttonTheme: buttonTheme,
            testId: "create-content-popover-button",
            shouldRenderToParent: true,
            ...t13
        }, t14);
        $[52] = buttonTheme;
        $[53] = isOpen;
        $[54] = onClose;
        $[55] = onCreateClick;
        $[56] = t13;
        $[57] = t14;
        $[58] = universalCreateItemsProps;
        $[59] = t15;
    } else t15 = $[59];
    return t15;
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    const $ = (0, $frIzR.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}
function $f44feda85e5453ef$var$_temp(section) {
    return {
        type: "appDefinedSection",
        ...section
    };
}






var $jqe2L = parcelRequire("jqe2L");











var $aJv6Q = parcelRequire("aJv6Q");



















var $fT2ta = parcelRequire("fT2ta");


var $caX7N = parcelRequire("caX7N");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");





var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");





var $8Lx5S = parcelRequire("8Lx5S");




const $6db88c87976e5479$var$i18n = (0, $cgtv4.defineMessages)({
    deeplinkReturnTitle: {
        id: "onboarding-ai-first-create.nudge.deeplink-return.title",
        defaultMessage: "Get back to creating with Rovo"
    },
    deeplinkReturnDescription: {
        id: "onboarding-ai-first-create.nudge.deeplink-return.description",
        defaultMessage: "Create with Rovo from here whenever you\u2019re ready."
    },
    deeplinkReturnCTA: {
        id: "onboarding-ai-first-create.nudge.deeplink-return.cta",
        defaultMessage: "OK"
    }
});
const $6db88c87976e5479$export$32b12f08aa5937dd = ({ children: children, offset: offset = [
    0,
    8
], placement: placement = 'bottom-start' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const { entryPoint: entryPoint, showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const [capturedEntryPoint, setCapturedEntryPoint] = (0, $42omo.useState)(null);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const shouldSkip = !isLicensed || !isRovoLLMEnabled;
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], shouldSkip || !(0, $9wGTI.fg)('cc_fd_aifc_deeplink_return_nudge_enabled'));
    const { hasSeenDeeplinkReturnSpotlight: hasSeenDeeplinkReturnSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // Capture and preserve the entryPoint value when it's a deeplink entry
    (0, $42omo.useEffect)(()=>{
        if (!shouldSkip && !hasSeenDeeplinkReturnSpotlight && entryPoint?.includes('atlassianNew')) setCapturedEntryPoint(entryPoint);
    }, [
        entryPoint,
        shouldSkip,
        hasSeenDeeplinkReturnSpotlight
    ]);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        const statesToSet = [
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenDeeplinkReturnSpotlight,
                value: 'true'
            },
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenAIFCSpotlight,
                value: 'true'
            }
        ];
        setOnboardingState(statesToSet);
        setIsSpotlightActive(true);
        setCapturedEntryPoint(null);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AIFCDeeplinkReturnSpotlight',
                attributes: {
                    source: 'deeplinkCreateWithRovo'
                }
            }
        }).fire();
    }, [
        setOnboardingState,
        createAnalyticsEvent
    ]);
    const handleSpotlightStop = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []);
    const choreographer = useChoreographer('AIFCDeeplinkReturnSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        choreographer.stopMessage();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AIFCDeeplinkReturnSpotlight',
                source: 'deeplinkCreateWithRovo'
            }
        }).fire();
    }, [
        choreographer,
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        const loadingCompleteWithoutError = !isOnboardingStateLoading && !isOnboardingStateError;
        if (loadingCompleteWithoutError && !!capturedEntryPoint && !!onboardingStateData && !hasSeenDeeplinkReturnSpotlight && !showSmartCreationModal) choreographer.startMessage();
    }, [
        capturedEntryPoint,
        choreographer,
        onboardingStateData,
        hasSeenDeeplinkReturnSpotlight,
        isOnboardingStateLoading,
        isOnboardingStateError,
        showSmartCreationModal
    ]);
    if (!(0, $9wGTI.fg)('cc_fd_aifc_deeplink_return_nudge_enabled')) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleDismiss,
        isVisible: isSpotlightActive,
        placement: placement,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "aifc-deeplink-return-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage($6db88c87976e5479$var$i18n.deeplinkReturnTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($6db88c87976e5479$var$i18n.deeplinkReturnDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
            onClick: handleDismiss
        }, formatMessage($6db88c87976e5479$var$i18n.deeplinkReturnCTA))))))))));
};


const $152004f1cdec4806$export$a64e598789940c7b = ({ children: children, ...props })=>{
    if (!(0, $9wGTI.fg)('cc_fd_aifc_deeplink_return_nudge_enabled')) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($152004f1cdec4806$var$AIFCDeeplinkReturnSpotlightInternal, props, children);
};
const $152004f1cdec4806$var$AIFCDeeplinkReturnSpotlightInternal = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).FLYWHEEL_FEATURE_DISCOVERY
})((0, $6db88c87976e5479$export$32b12f08aa5937dd));



var $5cryL = parcelRequire("5cryL");





var $fywGr = parcelRequire("fywGr");





var $7yn0t = parcelRequire("7yn0t");


var $6MlZq = parcelRequire("6MlZq");


var $bqyIi = parcelRequire("bqyIi");


var $hqD0X = parcelRequire("hqD0X");


var $gIdnC = parcelRequire("gIdnC");





var $gz8ZY = parcelRequire("gz8ZY");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");





var $efvKr = parcelRequire("efvKr");





var $7DERG = parcelRequire("7DERG");


var $6g41Q = parcelRequire("6g41Q");


var $iGpKB = parcelRequire("iGpKB");

'use no memo';
const $433f7c954f8755e5$var$containerStyles = null;

const $433f7c954f8755e5$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZXF2b",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("gWntw"))).CreateButton
});
const $433f7c954f8755e5$var$LIVE_DOCS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $433f7c954f8755e5$var$CreateComponentContent = ({ flags: flags })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    const { setQueryParams: setQueryParams, match: match, push: push } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-component'
    });
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { isEnabled: isOnboardingNewHomeTakeoverEnabled } = (0, $gIdnC.useOnboardingNewHomeTakeoverEnabled)();
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)
    }), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = (0, $ivb8S.deserializeState)(data);
    const fireAnalytics = (additionalAttributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'create',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: isNav4Enabled ? '4' : '3',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    ...additionalAttributes
                }
            }
        }).fire();
    };
    const openCreateDialog = ()=>{
        fireAnalytics();
        setQueryParams({
            createDialog: true
        });
    };
    const shouldCreateBlankFabricPage = ()=>{
        if (data && editorOnboardingEligiblity) (0, $fywGr.preloadEditorOnboardingState)();
        return true;
    };
    const createPageHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: 'createBlankFabricPage',
        withFallback: true,
        spaceKey: spaceKey,
        parentPageId: contentId
    });
    const handleCreatePageShortcut = ()=>{
        setEditSource((0, $7NoF3.CREATE_PAGE_SHORTCUT));
        fireAnalytics({
            keyboardShortcut: true
        });
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) push(createPageHref);
    };
    const handleCreatePageButtonClick = (e)=>{
        fireAnalytics();
        const shouldCreate_0 = shouldCreateBlankFabricPage();
        if (shouldCreate_0) {
            if (isNav4Enabled) {
                if (e.metaKey || e.ctrlKey) window.open(createPageHref, '_blank', 'noreferrer');
                else push(createPageHref);
            }
        } else // creation is handled by href for button click
        e.preventDefault();
    };
    const createBlog = ()=>{
        const createBlogLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            source: 'globalCreateBlogShortcut',
            spaceKey: spaceKey
        });
        push(createBlogLink);
    };
    const createLiveDoc = ()=>{
        const createLiveDocLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: contentId,
            withFallback: true,
            source: 'globalCreateLiveDocShortcut',
            spaceKey: spaceKey
        });
        push(createLiveDocLink);
    };
    const showLiveDocNotEnabledFlag = ()=>{
        flags.showErrorFlag({
            id: 'live-doc-not-enabled-shortcut-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledAction),
                    onClick: ()=>{
                        window.open($433f7c954f8755e5$var$LIVE_DOCS_LINK, '_blank');
                    }
                }
            ]
        });
    };
    const getButtonHref = ()=>{
        if ((0, $jqe2L.isCreateBlankFabricPageEnabled)() && !shouldBlockCreate) return createPageHref;
        return undefined;
    };
    const [createPageClickListener, createPageShortcutListener] = (0, $jqe2L.isCreateBlankFabricPageEnabled)() ? [
        handleCreatePageButtonClick,
        handleCreatePageShortcut
    ] : [
        openCreateDialog,
        openCreateDialog
    ]; /**
                                                                                                                                                                                                     * Please also update skeleton in appNavigationLazyItems
                                                                                                                                                                                                     *
                                                                                                                                                                                                     * <NavItemWrapper>
                                                                                                                                                                                                        <CreateButton />
                                                                                                                                                                                                      </NavItemWrapper>
                                                                                                                                                                                                     */ 
    const EngagementInlineDialogLoader = isNav4Enabled ? (0, $6g41Q.EngagementInlineDialogLoader) : (0, $6g41Q.EngagementInlineDialogLoaderNav3);
    const globalCreateContentPopover = (0, $42omo.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
            target: (0, $hqD0X.HOVER_TARGET).CREATE,
            shouldWrap: isOnboardingNewHomeTakeoverEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $152004f1cdec4806$export$a64e598789940c7b), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f44feda85e5453ef$export$b8b0dfc3e3d56c92), null))), [
        isOnboardingNewHomeTakeoverEnabled
    ]);
    const universalGlobalCreateShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN);
    const handlePreload = ()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) // preload smart creation
        (0, $7DERG.ConfluenceSmartCreationModalLoader).preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "app-navigation-create",
        "data-pendo-id": "con-*/wiki/home-create",
        "data-vc": "create-component",
        ...ssrPlaceholderIdProp,
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(EngagementInlineDialogLoader, {
        engagementId: "createComponentButton",
        dataVC: "app-navigation-create-engagement-inline-dialog"
    }, isCreationDropdownEnabled ? globalCreateContentPopover() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
        content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: universalGlobalCreateShortcut,
            isTooltip: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7yn0t.CreateContentButtonPreloader), {
        editSource: (0, $7NoF3.CREATE_NAV_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqyIi.CreateButtonNudgeWrappable), {
        target: (0, $hqD0X.HOVER_TARGET).CREATE,
        shouldWrap: isOnboardingNewHomeTakeoverEnabled
    }, isNav4Enabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($433f7c954f8755e5$var$CreateButton, {
        onClick: enforceStorageLimit(createPageClickListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $433f7c954f8755e5$var$i18n.create)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iGpKB.CreateButton), {
        onClick: enforceStorageLimit(createPageClickListener),
        href: getButtonHref()
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GLOBAL_CREATE_SHORTCUT) : undefined,
        accelerator: universalGlobalCreateShortcut,
        listener: enforceStorageLimit(createPageShortcutListener),
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.BLOG_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_BLOG_SHORTCUT),
        listener: enforceStorageLimit(createBlog),
        isAppNavigationShortcut: true
    }), isCreateLiveDocEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(createLiveDoc),
        isAppNavigationShortcut: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(showLiveDocNotEnabledFlag),
        isAppNavigationShortcut: true
    }));
};
const $433f7c954f8755e5$var$i18n = (0, $cgtv4.defineMessages)({
    create: {
        id: "app-navigation.top-navigation.create",
        defaultMessage: "Create"
    },
    liveDocsNotEnabledTitle: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.title",
        defaultMessage: "Live docs aren\u2019t enabled in this space"
    },
    liveDocsNotEnabledDescription: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.description",
        defaultMessage: "To use this shortcut, your space admin will need to enable live docs."
    },
    liveDocsNotEnabledAction: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.action",
        defaultMessage: "Find out more"
    }
});
const $433f7c954f8755e5$export$a9a76753cd947d5c = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $42omo.memo)($433f7c954f8755e5$var$CreateComponentContent));
module.exports["CreateComponent"] = $433f7c954f8755e5$export$a9a76753cd947d5c;

});

parcelRegister("4ri4I", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $4d309a7dc7a1cda3$export$64697004958d0ff1 = {
    editSource: ''
};
const $4d309a7dc7a1cda3$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        ...$4d309a7dc7a1cda3$export$64697004958d0ff1
    },
    actions: {
        setEditSource: (editSource)=>({ setState: setState })=>{
                setState({
                    editSource: editSource
                });
            }
    },
    name: 'setEditSource'
});
const $4d309a7dc7a1cda3$export$ee479a8e5902b302 = (0, $9zUhf.createHook)($4d309a7dc7a1cda3$var$Store);
const $4d309a7dc7a1cda3$export$7e972f51583fdb8e = (0, $9zUhf.createActionsHook)($4d309a7dc7a1cda3$var$Store);
module.exports["useEditSource"] = $4d309a7dc7a1cda3$export$ee479a8e5902b302;
module.exports["useEditSourceActions"] = $4d309a7dc7a1cda3$export$7e972f51583fdb8e;

});

parcelRegister("7NoF3", function(module, exports) {
const $e900dacf455c7c27$export$45d9f22b250b4fa6 = 'PAGE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$daadd9484abf9243 = 'BLOG_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$18ec89b444ed9e13 = 'SPACE_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$1670e1f700b91982 = 'PAGE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$99c4be058cda9518 = 'BLOG_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$9a65fbf92be78751 = 'SPACE_EDIT_SHORTCUT_E';
const $e900dacf455c7c27$export$a5c6eb91dd72e7c0 = 'NAVIGATION_RECENT_DROPDOWN_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$835a97ed77363e2a = 'PAGECARD_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$d8133449fbfd82d4 = 'PAGECARD_DRAFT_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$aca8dbff71ee152b = 'QUICK_ACTIONS_EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$3a91fd27464e4cde = 'EDIT_BUTTON_CLICK';
const $e900dacf455c7c27$export$62ca21e37a92c063 = 'CREATE_PAGE_SHORTCUT';
const $e900dacf455c7c27$export$6eda3121bad7aadf = 'CREATE_NAV_BUTTON_CLICK';
const $e900dacf455c7c27$export$7698b0f9c7cef133 = 'CREATE_PAGETREE_BLOG_BUTTON_CLICK';
const $e900dacf455c7c27$export$d83b4b43e279cde5 = 'CREATE_PAGETREE_CHILDPAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$1dd5c358458f3c8f = 'CREATE_PAGETREE_PAGE_BUTTON_CLICK';
const $e900dacf455c7c27$export$6e88709afea7d3ed = [
    $e900dacf455c7c27$export$aca8dbff71ee152b,
    $e900dacf455c7c27$export$835a97ed77363e2a,
    $e900dacf455c7c27$export$d8133449fbfd82d4,
    $e900dacf455c7c27$export$a5c6eb91dd72e7c0
];
module.exports["PAGE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$45d9f22b250b4fa6;
module.exports["BLOG_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$daadd9484abf9243;
module.exports["SPACE_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$18ec89b444ed9e13;
module.exports["PAGE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$1670e1f700b91982;
module.exports["BLOG_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$99c4be058cda9518;
module.exports["SPACE_EDIT_SHORTCUT_E"] = $e900dacf455c7c27$export$9a65fbf92be78751;
module.exports["PAGECARD_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$835a97ed77363e2a;
module.exports["QUICK_ACTIONS_EDIT_BUTTON_CLICK"] = $e900dacf455c7c27$export$aca8dbff71ee152b;
module.exports["CREATE_PAGE_SHORTCUT"] = $e900dacf455c7c27$export$62ca21e37a92c063;
module.exports["CREATE_NAV_BUTTON_CLICK"] = $e900dacf455c7c27$export$6eda3121bad7aadf;
module.exports["CREATE_PAGETREE_BLOG_BUTTON_CLICK"] = $e900dacf455c7c27$export$7698b0f9c7cef133;
module.exports["InitialLoadEditSources"] = $e900dacf455c7c27$export$6e88709afea7d3ed;

});

parcelRegister("dkIiA", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
var $ee5b1a976329bd8a$export$b634e5de755b7d35 = /*#__PURE__*/ function(GraphQLContentStatus) {
    GraphQLContentStatus["ARCHIVED"] = "ARCHIVED";
    GraphQLContentStatus["CURRENT"] = "CURRENT";
    GraphQLContentStatus["DELETED"] = "DELETED";
    GraphQLContentStatus["DRAFT"] = "DRAFT";
    return GraphQLContentStatus;
}({});
module.exports["ConfluencePageSubType"] = $ee5b1a976329bd8a$export$c5ec0cc4d455d1c8;
module.exports["GraphQLContentStatus"] = $ee5b1a976329bd8a$export$b634e5de755b7d35;

});

parcelRegister("6mkwk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b752f7534b8d0112$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $b752f7534b8d0112$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $42omo.useState)(getDefaultPropValue);
    const isControlledRef = (0, $42omo.useRef)(isControlled);
    (0, $42omo.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $42omo.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("dpPtd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $aD1SW = parcelRequire("aD1SW");


var $eCEXz = parcelRequire("eCEXz");


var $6uGcC = parcelRequire("6uGcC");

const $c997cd3fd9f4ee84$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $c997cd3fd9f4ee84$export$2879604e6aec4ab() {
    const api = (0, $42omo.useContext)($c997cd3fd9f4ee84$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $c997cd3fd9f4ee84$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $c997cd3fd9f4ee84$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $42omo.useState)([]);
    const removeFlag = (0, $42omo.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $42omo.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $c997cd3fd9f4ee84$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6uGcC.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $aD1SW.default) : (0, $eCEXz.default);
                    return /*#__PURE__*/ (0, $42omo.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $c997cd3fd9f4ee84$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $l998X.jsx)($c997cd3fd9f4ee84$export$a4270ab432ac8a58, {
        children: fn()
    });
module.exports["useFlags"] = $c997cd3fd9f4ee84$export$2879604e6aec4ab;
module.exports["FlagsProvider"] = $c997cd3fd9f4ee84$export$a4270ab432ac8a58;

});

parcelRegister("4jETc", function(module, exports) {
var $3fcb4d970a94e7e9$export$9a146e025690327e = /*#__PURE__*/ function(BFFConsumerEnum) {
    BFFConsumerEnum["ATLASSIAN_SWITCHER"] = "ATLASSIAN_SWITCHER";
    BFFConsumerEnum["GLOBAL_SHORTCUTS"] = "GLOBAL_SHORTCUTS";
    BFFConsumerEnum["GLOBAL_SIDE_NAVIGATION"] = "GLOBAL_SIDE_NAVIGATION";
    BFFConsumerEnum["UNIVERSAL_CREATE"] = "UNIVERSAL_CREATE";
    return BFFConsumerEnum;
}({});
const $3fcb4d970a94e7e9$export$45e63649edff1e2a = 'ASSETS';
const $3fcb4d970a94e7e9$export$45c80c6b98d65f36 = 3;
const $3fcb4d970a94e7e9$export$7b4183e5f0de390a = 1000;
const $3fcb4d970a94e7e9$export$2edbfcb69dc77e78 = 1;
const $3fcb4d970a94e7e9$export$891dc7068a3d5e65 = 14;
const $3fcb4d970a94e7e9$export$6e594fe130dbe3b = 14;
var $3fcb4d970a94e7e9$export$600e7c1f9e0414e1 = /*#__PURE__*/ function(RequestStatus) {
    RequestStatus["INIT"] = "initializing";
    RequestStatus["LOADING"] = "loading";
    RequestStatus["COMPLETE"] = "complete";
    RequestStatus["ERROR"] = "error";
    return RequestStatus;
}({});
const $3fcb4d970a94e7e9$export$c889532d47d74e9c = 'bff';
const $3fcb4d970a94e7e9$export$123b1b8742c0ac6a = 'flightdeck';
const $3fcb4d970a94e7e9$export$95d80cce92acae9 = 'uc-suggestions';
const $3fcb4d970a94e7e9$export$1631e8a201b50246 = 'uc-menu-items';
module.exports["BFFConsumerEnum"] = $3fcb4d970a94e7e9$export$9a146e025690327e;
module.exports["ASSETS_APP_KEY"] = $3fcb4d970a94e7e9$export$45e63649edff1e2a;
module.exports["MAX_ATTEMPTS_DEFAULT"] = $3fcb4d970a94e7e9$export$45c80c6b98d65f36;
module.exports["RETRY_INTERVAL_DEFAULT"] = $3fcb4d970a94e7e9$export$7b4183e5f0de390a;
module.exports["MAX_ATTEMPTS_NEW_DEFAULT"] = $3fcb4d970a94e7e9$export$2edbfcb69dc77e78;
module.exports["DAYS_AUTO_PROVISIONED_ITEM_CONSIDERED_NEW"] = $3fcb4d970a94e7e9$export$891dc7068a3d5e65;
module.exports["DAYS_END_USER_ACTIVE_PRODUCT_CONSIDERED_NEW"] = $3fcb4d970a94e7e9$export$6e594fe130dbe3b;
module.exports["RequestStatus"] = $3fcb4d970a94e7e9$export$600e7c1f9e0414e1;
module.exports["BFF_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$c889532d47d74e9c;
module.exports["FLIGHTDECK_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$123b1b8742c0ac6a;
module.exports["UC_SUGGESTIONS_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$95d80cce92acae9;
module.exports["UC_MENU_ITEMS_REQUEST_STATUS_KEY"] = $3fcb4d970a94e7e9$export$1631e8a201b50246;

});

parcelRegister("caUKj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4jETc = parcelRequire("4jETc");

const $f9a84eccaed6c052$export$b2445cd6f2d7fd5 = {
    cache: {},
    cacheKey: '',
    status: null,
    consumer: null
};
const $f9a84eccaed6c052$export$873dcaf380a86d6b = /*#__PURE__*/ (0, $42omo.createContext)({
    value: $f9a84eccaed6c052$export$b2445cd6f2d7fd5,
    currentLoadingRequests: [],
    setValue: ()=>{},
    updateCurrentLoadingRequests: ()=>{}
});
function $f9a84eccaed6c052$export$63342c357ecccda2() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext($f9a84eccaed6c052$export$873dcaf380a86d6b);
}
function $f9a84eccaed6c052$export$71a938590b6955cc({ consumer: consumer, children: children }) {
    const [value, setValue] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState({
        cache: {},
        cacheKey: consumer,
        consumer: consumer,
        status: (0, $4jETc.RequestStatus).INIT
    });
    const [currentLoadingRequests, setCurrentLoadingRequests] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState([]);
    const updateCurrentLoadingRequests = (0, $42omo.useCallback)((name, status)=>{
        switch(status){
            case (0, $4jETc.RequestStatus).LOADING:
                setCurrentLoadingRequests((prev)=>[
                        ...prev,
                        name
                    ]);
                break;
            case (0, $4jETc.RequestStatus).COMPLETE:
                setCurrentLoadingRequests((prev)=>prev.filter((request)=>request !== name));
                break;
            case (0, $4jETc.RequestStatus).ERROR:
                setCurrentLoadingRequests([]);
                break;
        }
    }, [
        setCurrentLoadingRequests
    ]);
    const stableContextValue = (0, $42omo.useMemo)(()=>({
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        }), [
        currentLoadingRequests,
        updateCurrentLoadingRequests,
        value
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($f9a84eccaed6c052$export$873dcaf380a86d6b.Provider, {
        value: (0, $dh538.fg)('navx-2972_fix_fhs_locking_problems') ? stableContextValue : {
            value: value,
            setValue: setValue,
            currentLoadingRequests: currentLoadingRequests,
            updateCurrentLoadingRequests: updateCurrentLoadingRequests
        },
        children: children
    });
}
const $f9a84eccaed6c052$var$defaultUserControls = {
    user: undefined
};
const $f9a84eccaed6c052$export$38ee920e59704589 = /*#__PURE__*/ (0, $42omo.createContext)($f9a84eccaed6c052$var$defaultUserControls);
function $f9a84eccaed6c052$export$87c54b525b914dab() {
    return (0, $42omo.useContext)($f9a84eccaed6c052$export$38ee920e59704589);
}
module.exports["BFFContext"] = $f9a84eccaed6c052$export$873dcaf380a86d6b;
module.exports["useBFFContext"] = $f9a84eccaed6c052$export$63342c357ecccda2;
module.exports["BFFProvider"] = $f9a84eccaed6c052$export$71a938590b6955cc;
module.exports["useUserContext"] = $f9a84eccaed6c052$export$87c54b525b914dab;

});

parcelRegister("4rFRN", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

const $b768d6c0977105ad$export$fe188b07687f765a = {
    goalCreate: {
        experienceId: 'uc-goal-create',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Experience,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    teamCreate: {
        experienceId: 'uc-team-create',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Experience,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    projectCreate: {
        experienceId: 'uc-project-create',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Experience,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    universalCreateComponentLoad: {
        experienceId: 'uc-component-load',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Load,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    universalCreatePrefetch: {
        experienceId: 'uc-backend-prefetch',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Operation,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).Custom
        },
        instanceId: undefined
    },
    globalSideNavigationLoad: {
        experienceId: 'global-side-navigation-load',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Load,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad
        },
        instanceId: undefined
    },
    customizationModalLoad: {
        experienceId: 'customization-modal-load',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Load,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    customizationModalUpdate: {
        experienceId: 'customization-modal-update',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Experience,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    },
    globalMoreMenuLoad: {
        experienceId: 'global-more-menu-load',
        config: {
            type: (0, $9NDUe.ExperienceTypes).Load,
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).InlineResult
        },
        instanceId: undefined
    }
};
module.exports["NavigationExperienceId"] = $b768d6c0977105ad$export$fe188b07687f765a;

});

parcelRegister("gWF6I", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $irOoi = parcelRequire("irOoi");


var $JyXl5 = parcelRequire("JyXl5");

function $8122506f239babd4$export$6c22afad970ad5ac({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $irOoi.RelayEnvironmentProvider), {
        environment: (0, $JyXl5.__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__)
    }, children);
}
const $8122506f239babd4$export$43b1f3e917d65526 = $8122506f239babd4$export$6c22afad970ad5ac;
const $8122506f239babd4$export$2f6292af3d34630d = ({ children: children })=>{
    const isRelayPresent = (0, $42omo.useContext)((0, $irOoi.ReactRelayContext));
    if (isRelayPresent) return children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8122506f239babd4$export$6c22afad970ad5ac, null, children);
};
function $8122506f239babd4$export$e237a628f59c9f4e() {
    const environment = (0, $irOoi.useRelayEnvironment)();
    return (0, $42omo.useMemo)(()=>({
            getEnvironment () {
                return environment;
            }
        }), [
        environment
    ]);
}
module.exports["AtlassianRelayEnvironmentProvider"] = $8122506f239babd4$export$6c22afad970ad5ac;
module.exports["RelayEnvironmentProvider"] = $8122506f239babd4$export$43b1f3e917d65526;
module.exports["ConditionalRelayEnvironmentProvider"] = $8122506f239babd4$export$2f6292af3d34630d;
module.exports["useRelayEnvironmentProvider"] = $8122506f239babd4$export$e237a628f59c9f4e;

});

parcelRegister("JyXl5", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $aPmQM = parcelRequire("aPmQM");


var $hvWxm = parcelRequire("hvWxm");


var $kzjMJ = parcelRequire("kzjMJ");

const $e443eef90c98bdab$var$getLoggingAndMetricsHelper = ()=>{
    return {
        logNonBreakingErrors: ()=>{},
        logError: ()=>{},
        logErrorRetry: ()=>{},
        logQueryFallbackToPost: ()=>{}
    };
};
const $e443eef90c98bdab$export$4a639ebead870a0c = new (0, $kzjMJ.SSRQueryResponseCache)({
    cacheName: 'relay-cache/v2/AGG',
    size: Infinity,
    ttl: Infinity
});
const $e443eef90c98bdab$export$df54517d175e6d6b = (0, $aPmQM.createRelayEnvironment)({
    networkOptions: {
        getLoggingAndMetricsHelper: $e443eef90c98bdab$var$getLoggingAndMetricsHelper,
        withErrorHandling: (source)=>source,
        validateResponse: (request, response)=>{
            const errors = 'errors' in response ? response.errors : undefined;
            if (errors != null) {
                const requestId = response?.extensions?.gateway?.request_id;
                (0, $hvWxm.captureErrors)(errors, {
                    operationName: request.name,
                    requestId: requestId
                });
                if ((0, $dh538.fg)('platform_relay_redirect_on_step_up_auth_studio')) {
                    const { hasStepUpAuthError: hasStepUpAuthError, stepUpUrl: stepUpUrl } = (0, $hvWxm.isStepUpAuthError)(errors);
                    if (hasStepUpAuthError && stepUpUrl) window.location.href = stepUpUrl;
                }
            }
            return true;
        },
        onInvalidResponse: ()=>{},
        queryResponseCache: $e443eef90c98bdab$export$4a639ebead870a0c,
        isServer: globalThis.__SERVER__ ?? false
    }
});
module.exports["__INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__"] = $e443eef90c98bdab$export$df54517d175e6d6b;

});

parcelRegister("aPmQM", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $hZsWa = parcelRequire("hZsWa");


var $dRnqM = parcelRequire("dRnqM");


var $j93Ay = parcelRequire("j93Ay");


var $f2OFx = parcelRequire("f2OFx");


var $59hua = parcelRequire("59hua");


var $7z5rG = parcelRequire("7z5rG");


var $1b0Xp = parcelRequire("1b0Xp");


var $7gNIX = parcelRequire("7gNIX");

// Enable Relay Resolvers globally for this module
(0, $3e6Uc.RelayFeatureFlags).ENABLE_RELAY_RESOLVERS = true;
function $e57f333731aa23ab$var$createNetwork(networkOptions) {
    return (0, $3e6Uc.Network).create((request, variables, cacheConfig)=>(0, $59hua.fetch)(request, variables, cacheConfig, networkOptions), networkOptions.isServer === false ? (0, $7gNIX.createSubscribeFn)(networkOptions) : undefined);
}
const $e57f333731aa23ab$var$createStore = (source, options)=>{
    return new (0, (/*@__PURE__*/$parcel$interopDefault($hZsWa)))(source, options);
};
// Copied from ConnectionHandler.deleteNode implementation with a single change in behaviour:
// nodeID is compared to the `id` field of the node, rather than node.getDataID().
// This is a sane thing to do within the scope of a single connection even in the light of
// id collisions present in AGG for the entities of different types.
// Such change makes @deleteEdge directive usable again.
function $e57f333731aa23ab$var$deleteNode(record, nodeID) {
    const { EDGES: EDGES, NODE: NODE } = (0, $3e6Uc.ConnectionInterface).get();
    const edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    let nextEdges;
    for(let ii = 0; ii < edges.length; ii++){
        const edge = edges[ii];
        const node = edge && edge.getLinkedRecord(NODE);
        // N.B. node.getValue('id') instead of node.getDataID()
        if (node != null && node.getValue('id') === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
// Copied from DeleteEdgeHandler implementation in Relay with a single change in behaviour:
// it calls deleteNode above instead of ConnectionHandler.deleteNode.
const $e57f333731aa23ab$var$DeleteEdgeHandler = {
    update: (store, payload)=>{
        const record = store.get(payload.dataID);
        if (record == null) return;
        // @types/relay-runtime is broken, handleArgs is present in the original Flow types.
        const { connections: connections } = payload.handleArgs;
        (0, $dRnqM.default)(connections != null, 'MutationHandlers: Expected connection IDs to be specified.');
        const idOrIds = record.getValue(payload.fieldKey);
        const idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach((id)=>{
            if (typeof id === 'string') for (const connectionID of connections){
                const connection = store.get(connectionID);
                if (connection == null) {
                    (0, $j93Ay.default)(false, `[Relay] The connection with id ${connectionID} doesn't exist.`);
                    continue;
                }
                $e57f333731aa23ab$var$deleteNode(connection, id);
            }
        });
    }
};
function $e57f333731aa23ab$var$HandlerProvider(handle) {
    switch(handle){
        case 'deleteEdge':
            return $e57f333731aa23ab$var$DeleteEdgeHandler;
        default:
            return (0, $3e6Uc.DefaultHandlerProvider)(handle);
    }
}
function $e57f333731aa23ab$export$7afaa9c867644497({ log: log, requiredFieldLogger: requiredFieldLogger, networkOptions: networkOptions, getDataID: getDataID }) {
    return new (0, $3e6Uc.Environment)({
        configName: 'Atlassian Shared Graphql Gateway',
        network: $e57f333731aa23ab$var$createNetwork(networkOptions || {
            isServer: false
        }),
        store: $e57f333731aa23ab$var$createStore(new (0, $3e6Uc.RecordSource)(), {
            log: log ?? undefined,
            getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $f2OFx.default)
        }),
        log: log,
        relayFieldLogger: requiredFieldLogger,
        getDataID: 'getDataID' in arguments[0] ? getDataID : (0, $f2OFx.default),
        scheduler: (0, $1b0Xp.default),
        missingFieldHandlers: (0, $7z5rG.default),
        handlerProvider: $e57f333731aa23ab$var$HandlerProvider
    });
}
module.exports["createRelayEnvironment"] = $e57f333731aa23ab$export$7afaa9c867644497;

});

parcelRegister("j93Ay", function(module, exports) {
var $df01a438a0c868c1$var$isProduction = true;
function $df01a438a0c868c1$var$warning(condition, message) {
    if (!$df01a438a0c868c1$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== 'undefined') console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $df01a438a0c868c1$export$2e2bcd8739ae039 = $df01a438a0c868c1$var$warning;
module.exports["default"] = $df01a438a0c868c1$export$2e2bcd8739ae039;

});

parcelRegister("59hua", function(module, exports) {

var $33JSI = parcelRequire("33JSI");


var $3e6Uc = parcelRequire("3e6Uc");


var $dh538 = parcelRequire("dh538");


var $4xBBd = parcelRequire("4xBBd");


var $2gQQV = parcelRequire("2gQQV");


var $6YELi = parcelRequire("6YELi");


var $9nJbC = parcelRequire("9nJbC");


var $l9oE3 = parcelRequire("l9oE3");


var $fr6fu = parcelRequire("fr6fu");


var $jne3Q = parcelRequire("jne3Q");


var $gfRVX = parcelRequire("gfRVX");


var $c4zvP = parcelRequire("c4zvP");

const $923cf200d647598a$var$isSsrHandoverIncrementsEnabled = ()=>Boolean(globalThis.__SSR_HANDOVER_INCREMENTS);
const $923cf200d647598a$var$moduleID = 'relay-fetch';
const $923cf200d647598a$export$e7aa7bc5c1b3cfb3 = (request, variables, cacheConfig, dependencies)=>{
    const { name: queryName, operationKind: operationKind } = request;
    const loggingMetadata = {
        queryName: queryName,
        operationKind: operationKind
    };
    const loggingAndMetrics = dependencies?.getLoggingAndMetricsHelper?.(loggingMetadata);
    function augmentResponse(response) {
        (0, $9nJbC.addTraceId)(queryName, (0, $c4zvP.getTraceIdFromExtensions)(response));
        (0, $4xBBd.putExtensions)(queryName, response.extensions);
    }
    // TODO: This needs to be changed by removing each Product, and only if all keys are empty final output is null
    function enforceNonNullability(response) {
        if (response.data && (response.data.jira === null || response.data.customerService === null || response.data.graphStore === null)) // Enforce non-nullability of the jira and customerService namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Data
        response.data = null;
    }
    return (0, $3e6Uc.Observable).create((sink)=>{
        try {
            const requestID = 'cacheID' in request && request.cacheID != null ? request.cacheID : request.id;
            // Unique identifier for the server-to-client channel.
            const sinkID = `${$923cf200d647598a$var$moduleID}-${requestID}`;
            let resolveCompletedResponse;
            const completedResponse = new Promise((resolve)=>{
                resolveCompletedResponse = resolve;
            });
            const finalise = ()=>{
                resolveCompletedResponse();
                sink.complete();
            };
            const handleResponse = (response)=>{
                let payload = null;
                if ('incremental' in response && response.incremental) {
                    if (response.incremental.length) // Relay is expecting the contents of this array rather than the entire array itself. Also, Relay doesn't really care about tracking
                    // the pending versus completed values, so we can just return the array without the extra account keeping.
                    // @ts-expect-error It's hard to type this correctly because the payload sometimes has errors, sometimes not. Relay accounts for it,
                    // TypeScript can't handle the polymorphism.
                    payload = response.incremental;
                    else if (response.hasNext === false) // It's possible for the server to send back an empty final increment.
                    // Attempt to make Relay happy.
                    payload = {
                        data: null,
                        extensions: {
                            is_final: true
                        }
                    };
                } else // @ts-expect-error Typescript isn't happy that sometimes errors is undefined, but relay will manage just fine.
                payload = response;
                // Notify observers that we have more data!
                if (payload) sink.next(payload);
                // Close the stream if there are no more responses.
                if ('hasNext' in response && response.hasNext === false) finalise();
            };
            // handles getting multipart response
            const getData = ()=>{
                const endpoint = (0, $2gQQV.getAggEndpoint)(request, cacheConfig);
                const body = (0, $2gQQV.getRequestBody)(request, variables);
                let options = {
                    body: body
                };
                if (dependencies?.getHeaders) {
                    const headers = dependencies.getHeaders({
                        endpoint: endpoint,
                        options: options,
                        request: request,
                        variables: variables
                    });
                    options = {
                        ...options,
                        headers: {
                            ...options.headers,
                            ...headers
                        }
                    };
                }
                if (dependencies?.getAbortSignal) options.signal = dependencies?.getAbortSignal();
                const fetchOverNetwork = (0, $jne3Q.buildGraphqlSmartFetch)({
                    url: dependencies?.setEndpoint ? dependencies?.setEndpoint(endpoint) : endpoint,
                    options: options,
                    variables: variables,
                    request: request,
                    isServer: dependencies?.isServer || false,
                    cacheConfig: cacheConfig
                });
                const earlyScriptPromise = dependencies?.earlyScriptPromise?.(request, variables);
                let fetchFn = fetchOverNetwork;
                let initialSource = fetchFn;
                if (dependencies?.withErrorHandling) {
                    const withErrorHandling = dependencies.withErrorHandling;
                    initialSource = ()=>!dependencies?.isServer && earlyScriptPromise ? withErrorHandling(earlyScriptPromise) : withErrorHandling(fetchFn());
                }
                const responses = (0, $jne3Q.processMultipartPromise)(()=>(0, $gfRVX.retryOnError)(initialSource, {
                        retryFunc: fetchFn,
                        retryPredicate: (0, $gfRVX.shouldRetry),
                        retryAttempts: (0, $gfRVX.getRetryAttemptsForQuery)(request),
                        onRetry: loggingAndMetrics?.logErrorRetry
                    }));
                // Recreate a bizarre behaviour that will cause the observable to hang indefinitely when the user is not authenticated, presumably because we redirect the user to log in...
                // This should be revised; see https://jplat.atlassian.net/browse/MAGMA-3087
                let responseShouldHang = false;
                let firstResponseUsed = false;
                let resolveFirstResponse;
                const firstResponse = new Promise((resolve)=>{
                    resolveFirstResponse = resolve;
                });
                responses.subscribe({
                    start: ()=>{
                        if (requestID != null) {
                            if (dependencies?.isServer) {
                                // so that SSR SPA knows it is safe to render
                                const renderAfterThisResponse = $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() ? firstResponse : completedResponse;
                                (0, $6YELi.QueryPromisesMap).set(requestID, renderAfterThisResponse);
                            } else (0, $6YELi.QueryPromisesMap).set(requestID, firstResponse);
                            (0, $6YELi.CompletedQueryPromisesMap).set(requestID, completedResponse);
                        }
                    },
                    next: (r)=>{
                        let payload = r;
                        let response = payload || {};
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && firstResponseUsed) {
                            // Send the response payload to a side-channel.
                            // TODO MAGMA-3204: improve robustness. Should be sending ID of module to communicate with, sinkID should be an argument.
                            (0, $fr6fu.registerEvent)({
                                id: sinkID,
                                name: 'default',
                                args: [
                                    response
                                ]
                            });
                            if ('hasNext' in response && response.hasNext === false) finalise();
                            // Don't send any further responses to the fetch subscriber, since we'll be sending them through a side-channel.
                            return;
                        }
                        if (!firstResponseUsed) {
                            firstResponseUsed = true;
                            // according to spec, we can assume the first response is a GraphQLSingularResponse.
                            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            const singularResponse = response;
                            augmentResponse(singularResponse);
                            if (dependencies?.validateResponse && !dependencies.validateResponse(request, singularResponse)) {
                                dependencies?.onInvalidResponse?.(request, singularResponse);
                                responseShouldHang = true;
                                return;
                            }
                            if ((0, $dh538.fg)('platform_relay_use_new_non_nullability')) response = $923cf200d647598a$export$b143926e518df3b(singularResponse);
                            else enforceNonNullability(singularResponse);
                            // write cache query response on SSR
                            // only write cache query response once or else this will break the assumption of graphql response being singular response
                            if (dependencies?.isServer && requestID != null && typeof dependencies?.queryResponseCache !== 'undefined') {
                                if ('appendWithMetadata' in dependencies.queryResponseCache) dependencies.queryResponseCache.appendWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                                else dependencies.queryResponseCache.setWithMetadata(requestID, variables, singularResponse, loggingMetadata);
                            }
                        }
                        handleResponse(response);
                        // signal that the initial response has been received
                        resolveFirstResponse();
                        // After the initial response, further responses are sent through a side-channel.
                        if (dependencies?.isServer && $923cf200d647598a$var$isSsrHandoverIncrementsEnabled()) sink.complete();
                    },
                    error: (error)=>{
                        if (!firstResponseUsed) firstResponseUsed = true;
                        loggingAndMetrics?.logError(error);
                        sink.error(error);
                    },
                    complete: ()=>{
                        if (responseShouldHang) return;
                        finalise();
                    }
                });
            };
            // On client...
            if (!dependencies?.isServer && requestID != null) {
                // read cache from window.SPA_STATE if available
                const ssrCache = dependencies?.queryResponseCache?.get(requestID, variables);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($33JSI)))(ssrCache)) {
                    dependencies?.queryResponseCache?.delete(requestID, variables);
                    sink.next(ssrCache);
                    if ($923cf200d647598a$var$isSsrHandoverIncrementsEnabled() && 'hasNext' in ssrCache && ssrCache.hasNext) {
                        // TODO MAGMA-3017: what about SSR fallback mode, or scenarios where SSR has partially failed?
                        // TODO MAGMA-3204: improve robustness. Should be using a middle-man module rather than client dispatcher directly.
                        // Receive response events as they are streamed from the server.
                        (0, $l9oE3.getClientDispatcher)().register(sinkID, handleResponse);
                        (0, $l9oE3.getClientDispatcher)().onAbort(sinkID, ({ reason: reason })=>{
                            if (!sink.closed) {
                                dependencies?.handleAbort?.(request, reason);
                                // if server throws an exception (such as SSR hanging up due to deadline exceeded)
                                // refetch multipart data again via network
                                getData();
                            }
                        });
                    } else finalise();
                    return;
                }
            }
            getData();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            loggingAndMetrics?.logError(error);
            sink.error(error);
        }
    });
};
function $923cf200d647598a$export$b143926e518df3b(response) {
    if (response.data) {
        // Enforce non-nullability of the product namespaces. This is an intermediary solution to
        // prevent server errors/gateway timeouts from wiping the Relay store. Eventually we'd like this
        // to be enforced at a schema level, see further discussion https://hello.atlassian.net/wiki/spaces/~236031707/pages/2034382845/Top+level+errors+for+namespaces+in+AGG+Relay
        let sanitisedData = Object.assign({}, response.data);
        const productKeys = [
            'jira',
            'customerService',
            'graphStore'
        ];
        for (const product of productKeys)if (sanitisedData[product] === null) delete sanitisedData[product];
        if (Object.keys(sanitisedData).length === 0) // @ts-expect-error - TS2322 - Relay types do not allow null data for a response with errors, however this is valid according to the spec http://spec.graphql.org/June2018/#sec-Dataa
        sanitisedData = null;
        response.data = sanitisedData;
    }
    return response;
}
module.exports["fetch"] = $923cf200d647598a$export$e7aa7bc5c1b3cfb3;

});

parcelRegister("4xBBd", function(module, exports) {
const $b8b31e9388977391$var$OperationExtensionsMap = {};
const $b8b31e9388977391$export$8656ba3981c6f6c1 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = $b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];
};
const $b8b31e9388977391$export$f16fa6040161f056 = (operationName)=>{
    $b8b31e9388977391$var$OperationExtensionsMap[operationName] = undefined;
};
const $b8b31e9388977391$export$17dc47fdf278de21 = (operationName, extension)=>{
    if (extension !== undefined) {
        const extensionsForOperation = $b8b31e9388977391$var$OperationExtensionsMap[operationName];
        if (extensionsForOperation !== undefined) extensionsForOperation.push(extension);
    }
};
const $b8b31e9388977391$export$7c6ea4184129ef74 = (operationName)=>$b8b31e9388977391$var$OperationExtensionsMap[operationName] || [];
module.exports["startCapturingExtensions"] = $b8b31e9388977391$export$8656ba3981c6f6c1;
module.exports["stopCapturingExtensions"] = $b8b31e9388977391$export$f16fa6040161f056;
module.exports["putExtensions"] = $b8b31e9388977391$export$17dc47fdf278de21;
module.exports["getExtensions"] = $b8b31e9388977391$export$7c6ea4184129ef74;

});

parcelRegister("6YELi", function(module, exports) {
/**
 * A map of signals that the initial response from the network has been received for a given relay query.
 *
 * This signal is used on the server-side during SSR to prevent React from running a render pass
 * until we can guarantee the data has arrived and is cached in the relay-client.
 *
 * This allows us to make a meaningful an initial render pass, avoiding needless suspense boundaries
 * and avoiding adding noncritical work to the JS call stack.
 */ const $aec1d0280b51c3e1$export$607b80f5bc6e396d = new Map();
const $aec1d0280b51c3e1$export$cdadce6ed6361a2c = new Map();
module.exports["QueryPromisesMap"] = $aec1d0280b51c3e1$export$607b80f5bc6e396d;
module.exports["CompletedQueryPromisesMap"] = $aec1d0280b51c3e1$export$cdadce6ed6361a2c;

});

parcelRegister("9nJbC", function(module, exports) {
const $d5ce6d160f67e727$var$OperationTraceIdMap = {};
const $d5ce6d160f67e727$export$a2bcb2fac360646c = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];
};
const $d5ce6d160f67e727$export$559128bdc4352001 = (operationName)=>{
    $d5ce6d160f67e727$var$OperationTraceIdMap[operationName] = undefined;
};
const $d5ce6d160f67e727$export$fcaa732775f12226 = (operationName, traceId)=>{
    if (traceId !== undefined) {
        const traceIdsForOperation = $d5ce6d160f67e727$var$OperationTraceIdMap[operationName];
        if (traceIdsForOperation !== undefined) traceIdsForOperation.push(traceId);
    }
};
const $d5ce6d160f67e727$export$5113e470f5c95670 = (operationName)=>$d5ce6d160f67e727$var$OperationTraceIdMap[operationName] || [];
module.exports["addTraceId"] = $d5ce6d160f67e727$export$fcaa732775f12226;

});

parcelRegister("l9oE3", function(module, exports) {

var $kKVci = parcelRequire("kKVci");

const $e5d9c5404c4087ad$export$eb5d9c90d65c7fea = 'ClientDispatcher';
let $e5d9c5404c4087ad$var$dispatcher;
const $e5d9c5404c4087ad$export$5bb012cf9b3a5452 = ()=>{
    if (!$e5d9c5404c4087ad$var$dispatcher) {
        $e5d9c5404c4087ad$var$dispatcher = new (0, $kKVci.ClientDispatcher)();
        // Handle the server hangup scenarios
        $e5d9c5404c4087ad$var$dispatcher.register($e5d9c5404c4087ad$export$eb5d9c90d65c7fea, $e5d9c5404c4087ad$var$dispatcher._abort.bind($e5d9c5404c4087ad$var$dispatcher));
    }
    return $e5d9c5404c4087ad$var$dispatcher;
};
module.exports["getClientDispatcher"] = $e5d9c5404c4087ad$export$5bb012cf9b3a5452;

});

parcelRegister("kKVci", function(module, exports) {
class $dae17d5049a9d798$export$3f5ba18eb97af725 {
    /**
   * Ingest a payload from the server.
   * This will trigger a callback to the component that registered for this event, otherwise the payload will be queued to do so later.
   * @param payload - The payload to ingest.
   */ ingest(payload) {
        const handler = this.handlers.get(payload.id);
        if (handler) this.exec(handler, payload);
        else {
            const queue = this.queuedPayloads.get(payload.id) || [];
            queue.push(payload);
            this.queuedPayloads.set(payload.id, queue);
        }
    }
    /**
   * Register a callback for a given event. If any payloads were queued for this event, they will be processed immediately.
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when the event is ingested.
   */ register(id, callback) {
        this.handlers.set(id, callback);
        // Process any queued payloads for this handler
        const queuedPayloads = this.queuedPayloads.get(id) || [];
        if (queuedPayloads.length > 0) {
            queuedPayloads.forEach((payload)=>this.exec(callback, payload));
            this.queuedPayloads.delete(id);
        }
    }
    /**
   * Unregister a callback for a given event.
   * @param id
   */ unregister(id) {
        this.handlers.delete(id);
        this.queuedPayloads.delete(id);
    }
    /**
   * Register an abort handler that will get called if exceptional circmstances arise (such as SSR hanging up due to deadline exceeded)
   * @param id - The event ID to register for.
   * @param callback - The callback to trigger when abort detected.
   */ onAbort(id, callback) {
        if (this.abortReason) this.exec(callback, {
            args: [
                this.abortReason
            ]
        });
        else this.abortHandlers.set(id, callback);
    }
    /**
   * Notify any registered abort handlers that the server exceeded its deadline before finishing, so we may not have received all events.
   * @private
   * @param props
   */ _abort(props) {
        this.abortReason = props;
        this.abortHandlers.forEach((handler)=>{
            this.exec(handler, {
                args: [
                    props
                ]
            });
        });
        // We can delete these now that we've handled the case and remainder will be dealt with immediately.
        this.abortHandlers = new Map();
    }
    /**
   * Execute a callback with the given payload.
   * @param callback - The callback to execute.
   * @param payload - The payload to execute the callback with.
   */ exec(callback, payload) {
        const { args: args, error: error } = payload;
        try {
            if (error) throw error;
            // @ts-expect-error
            callback(...args);
        } catch (err) {
        // TODO: log error
        // console.error(err);
        }
    }
    constructor(){
        this.handlers = void 0;
        this.queuedPayloads = void 0;
        this.abortReason = void 0;
        this.abortHandlers = void 0;
        this.handlers = new Map();
        this.abortHandlers = new Map();
        this.queuedPayloads = new Map();
    }
}
module.exports["ClientDispatcher"] = $dae17d5049a9d798$export$3f5ba18eb97af725;

});

parcelRegister("fr6fu", function(module, exports) {
const $4852ba516184255b$var$events = [];
const $4852ba516184255b$export$bd50bc4cd3c601ee = (event)=>{
    $4852ba516184255b$var$events.push(event);
};
const $4852ba516184255b$export$3c7145db84d4587c = ()=>{
    return $4852ba516184255b$var$events.splice(0, $4852ba516184255b$var$events.length);
};
module.exports["registerEvent"] = $4852ba516184255b$export$bd50bc4cd3c601ee;

});

parcelRegister("jne3Q", function(module, exports) {
/**
 * @fileOverview Implements a fetch function that can handle multipart/mixed responses.
 * The multipart response is expected to follow the GraphQL multipart request spec.
 *
 * See https://github.com/graphql/graphql-over-http/blob/main/rfcs/IncrementalDelivery.md#content-type-multipartmixed
 * See https://github.com/graphql/graphql-over-http/blob/main/spec/GraphQLOverHTTP.md#multipart-request-format
 */ 
var $lgmus = parcelRequire("lgmus");


var $3e6Uc = parcelRequire("3e6Uc");


var $bDPoq = parcelRequire("bDPoq");

const $ee37f6fc0d924aec$var$NO_CONTENT = 204;
function $ee37f6fc0d924aec$var$getBoundary(contentType) {
    const parts = contentType.split('boundary=');
    if (parts.length < 2) return null;
    return parts[1].trim();
}
function $ee37f6fc0d924aec$export$701544522b0c6c99(chunk, boundaryString, observer) {
    const parts = chunk.split(boundaryString);
    let incompleteChunk = '';
    // Process all complete parts (except the last one which might be incomplete)
    for(let i = 0; i < parts.length - 1; i++){
        const part = parts[i].trim();
        // Skip empty parts and encapsulation boundaries
        if (part && !part.startsWith('--')) {
            // Split content-type header and body
            const [part1, part2] = part.split(/\r?\n\r?\n/);
            // when response content has boundary string, part1 is the actual response
            // when response content does not have boundary string, part2 is the actual response
            const body = part2 ?? part1;
            if (body) try {
                const jsonData = JSON.parse(incompleteChunk + body);
                observer.next(jsonData);
                incompleteChunk = '';
            } catch  {
                // add boundary string back to response for cases when response content has boundary string
                // no error is thrown because next part might be a valid JSON object
                incompleteChunk += body + boundaryString;
            }
        }
    }
    // Return the last part which might be incomplete
    return incompleteChunk + parts[parts.length - 1];
}
async function $ee37f6fc0d924aec$export$efb69f1fe7577739(reader, boundary, observer) {
    const boundaryString = `--${boundary}`;
    let incompleteChunk = '';
    // Process chunks until the stream is done
    for await (const newText of reader){
        const combinedChunk = incompleteChunk + newText;
        // Process the combined chunk and get any incomplete part
        incompleteChunk = $ee37f6fc0d924aec$export$701544522b0c6c99(combinedChunk, boundaryString, observer);
    }
    // Process any remaining data
    if (incompleteChunk.length > 0) $ee37f6fc0d924aec$export$701544522b0c6c99(incompleteChunk, boundaryString, observer);
    observer.complete();
}
function $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer) {
    const contentType = response.headers.get('content-type');
    const boundary = $ee37f6fc0d924aec$var$getBoundary(contentType || '');
    if (!boundary) {
        observer.error(new Error('Invalid multipart boundary'));
        return;
    }
    const decoder = new TextDecoder('utf-8');
    async function* streamReader() {
        // @ts-expect-error a Response object in Node is streamable
        for await (const chunk of response.body){
            const newText = decoder.decode(chunk, {
                stream: true
            });
            yield newText;
        }
    }
    try {
        // Depending on the version of Node we're running in, the Response object may not implement ReadableStream.
        // Here, we treat the response as an async iterator, since both node-fetch and browser implement the response body as a stream.
        // We wrap that iteration in an async generator, which lets us
        $ee37f6fc0d924aec$export$efb69f1fe7577739(streamReader(), boundary, observer).catch((error)=>observer.error(error));
    } catch (e) {
        const error = new Error('Failed to read from response body');
        // @ts-ignore: cause property may not be available in all environments
        error.cause = e;
        observer.error(error);
    }
}
function $ee37f6fc0d924aec$var$handleJsonResponse(response, observer) {
    response.json().then((data)=>{
        return observer.next(data);
    }).catch((error)=>observer.error(error)).finally(()=>observer.complete());
}
function $ee37f6fc0d924aec$var$handleTextResponse(response, observer) {
    response.text().then((data)=>{
        const maybeJson = data ? JSON.parse(data) : null;
        observer.next(maybeJson);
        observer.complete();
    }).catch((error)=>{
        observer.error(new Error(`Error while parsing text response (Content-Type: ${response?.headers?.get('content-type')}): ${error instanceof Error ? error.message : String(error)}`));
    });
}
function $ee37f6fc0d924aec$export$f76505a7f2969e4e(source) {
    // Cache the result of the source promise to avoid calling it multiple times.
    const result = source();
    // Wrap an observer around the result to handle the response.
    return (0, $3e6Uc.Observable).create((observer)=>{
        result.then((response)=>{
            if (response.status === $ee37f6fc0d924aec$var$NO_CONTENT) {
                observer.complete();
                return;
            }
            const contentType = response.headers.get('content-type') || '';
            if (contentType.includes('application/json') || contentType.includes('application/graphql-response+json')) $ee37f6fc0d924aec$var$handleJsonResponse(response, observer);
            else if (contentType.includes('text/plain')) $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
            else if (contentType.includes('multipart/mixed')) $ee37f6fc0d924aec$var$handleMultipartResponse(response, observer);
            else $ee37f6fc0d924aec$var$handleTextResponse(response, observer);
        }).catch((error)=>observer.error(error));
    });
}
const $ee37f6fc0d924aec$var$relayDeferAcceptableFormats = [
    'application/graphql-response+json',
    'application/json',
    // there must not be spacing between `multipart/mixed` and `deferSpec=20220824` since the backend assumes no spacing
    'multipart/mixed;deferSpec=20220824'
];
const $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH = 2000; // Maximum allowed query length
const $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE = 20480; // Maximum header size in bytes (20 KB)
// Calculate the size of the headers
function $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers) {
    let totalBytes = 0;
    const textEncoder = new TextEncoder();
    // Iterate over each header entry (name and value)
    for (const [name, value] of Object.entries(headers)){
        const headerSize = textEncoder.encode(`${name}: ${value}\r\n`).length; // Include CRLF
        totalBytes += headerSize;
    }
    return totalBytes;
}
function $ee37f6fc0d924aec$export$28ae0033b80c6303(baseUrl, variables) {
    const params = new URLSearchParams();
    params.append('variables', JSON.stringify(variables));
    return baseUrl + `${baseUrl.includes('?') ? '&' : '?'}${params.toString()}`;
}
function $ee37f6fc0d924aec$export$5ad31d96a9271d42({ url: baseUrl, variables: variables, request: request, headers: headers, isServer: isServer }) {
    if (isServer) return {
        isGetRequest: false,
        reason: 'SSR'
    };
    if (request.operationKind !== 'query') return {
        isGetRequest: false,
        reason: request.operationKind
    };
    const queryLength = $ee37f6fc0d924aec$export$28ae0033b80c6303(baseUrl, variables).length;
    const headersSize = $ee37f6fc0d924aec$export$dd754c3ef60c6999(headers || {});
    return queryLength <= $ee37f6fc0d924aec$var$MAX_QUERY_LENGTH && headersSize <= $ee37f6fc0d924aec$var$MAX_HEADERS_SIZE ? {
        isGetRequest: true
    } : {
        isGetRequest: false,
        reason: 'URL length or headers size too large'
    };
}
function $ee37f6fc0d924aec$export$33c9c992c7855d86({ url: url, options: options, variables: variables, request: request, isServer: isServer, cacheConfig: cacheConfig }) {
    const headers = {
        'atl-client-name': 'atlassian-frontend-monorepo',
        Accept: $ee37f6fc0d924aec$var$relayDeferAcceptableFormats.join(', '),
        'X-ExperimentalApi': (0, $bDPoq.getRelayExperimentalApis)().join(','),
        ...cacheConfig?.metadata?.headers || {}
    };
    const requestOptions = (0, (/*@__PURE__*/$parcel$interopDefault($lgmus)))(options, {
        credentials: 'same-origin',
        headers: headers
    });
    requestOptions.headers['Content-Type'] = 'application/json';
    // Default `atl-attribution` header value for AGG requests
    // https://hello.atlassian.net/wiki/spaces/AGG/pages/5954141702/Metrics+Attribution+Onboarding+Doc+for+AGG+Clients
    if (!requestOptions.headers['atl-attribution']) requestOptions.headers['atl-attribution'] = JSON.stringify({
        service: 'afm-frontend'
    });
    const { isGetRequest: isGetRequest, reason: reason } = $ee37f6fc0d924aec$export$5ad31d96a9271d42({
        url: url,
        variables: variables,
        request: request,
        headers: requestOptions.headers,
        isServer: isServer
    });
    // Nav4ProjectsContentQuery is forced to go POST route to avoid the stale cache issues when transition between issues in Issue-view
    // that's not a permanent fix, but rather an attampt to unblock the team
    // Context: #jiv-navigation-issue channel
    if (isGetRequest && request.name !== 'Nav4ProjectsContentQuery') {
        requestOptions.method = 'GET';
        url = $ee37f6fc0d924aec$export$28ae0033b80c6303(url, variables);
        delete requestOptions.body; // Not needed for GET
    } else {
        requestOptions.method = 'POST';
        if (reason) requestOptions.headers['X-Request-Fallback-To-Post-Reason'] = reason;
    }
    return ()=>fetch(url, requestOptions);
}
module.exports["processMultipartPromise"] = $ee37f6fc0d924aec$export$f76505a7f2969e4e;
module.exports["buildGraphqlSmartFetch"] = $ee37f6fc0d924aec$export$33c9c992c7855d86;

});

parcelRegister("gfRVX", function(module, exports) {
const $a71dc4ac2c5f78d6$export$81189edc9b923717 = 1;
const $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c = (initialPromiseGetter, { retryFunc: retryFunc, retryPredicate: retryPredicate, retryAttempts: retryAttempts = $a71dc4ac2c5f78d6$export$81189edc9b923717, onRetry: onRetry })=>{
    // Eventually we might like to make max attempts configurable.
    // To do so, we'll need to support jitter & exponential back-off
    const maxAttempts = retryAttempts > $a71dc4ac2c5f78d6$export$81189edc9b923717 ? $a71dc4ac2c5f78d6$export$81189edc9b923717 : retryAttempts;
    const execute = async (getPromise, retryAttempt = 0)=>{
        try {
            return await getPromise();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            // If no retry predicate is passed, retry on every error
            const shouldAttemptRetry = retryPredicate ? retryPredicate(error) : true;
            if (retryAttempt < maxAttempts && shouldAttemptRetry) {
                onRetry && onRetry(error, retryAttempt + 1);
                return execute(retryFunc, retryAttempt + 1);
            }
            throw error;
        }
    };
    return execute(initialPromiseGetter);
};
const $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8 = (error)=>{
    if ('statusCode' in error && typeof error.statusCode === 'number') return [
        502,
        503,
        504
    ].includes(error.statusCode);
    return false;
};
const $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab = (request)=>{
    if (request.operationKind === 'query') return $a71dc4ac2c5f78d6$export$81189edc9b923717;
    return 0;
};
module.exports["retryOnError"] = $a71dc4ac2c5f78d6$export$f859c88bfac2cf2c;
module.exports["shouldRetry"] = $a71dc4ac2c5f78d6$export$7bfea3c3d460ecd8;
module.exports["getRetryAttemptsForQuery"] = $a71dc4ac2c5f78d6$export$9dec0f42cc67f6ab;

});

parcelRegister("c4zvP", function(module, exports) {
const $7d88968840210126$export$eefb7f54c3b07211 = ({ extensions: extensions })=>{
    if (extensions !== undefined && extensions.gateway !== undefined && extensions.gateway !== null && typeof extensions.gateway.trace_id === 'string') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return extensions.gateway.trace_id;
    return undefined;
};
module.exports["getTraceIdFromExtensions"] = $7d88968840210126$export$eefb7f54c3b07211;

});

parcelRegister("7gNIX", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");


var $255Lo = parcelRequire("255Lo");

var $48B0E = parcelRequire("48B0E");

let $c52e2194a2c31d31$var$cachedDefaultSubscribe;
function $c52e2194a2c31d31$export$10f5a0700f263f11(subscribeOptions) {
    if (typeof subscribeOptions === 'undefined' && typeof $c52e2194a2c31d31$var$cachedDefaultSubscribe !== 'undefined') return $c52e2194a2c31d31$var$cachedDefaultSubscribe;
    const fn = ({ id: id, name: operationName }, variables, cacheConfig)=>(0, $3e6Uc.Observable).create((sink)=>{
            const client = (0, $255Lo.getClient)();
            if (!client) return sink.error(new Error('Unable to create subscription client'));
            const replayConfig = cacheConfig?.metadata?.replay || undefined;
            const payload = {
                query: '',
                operationName: operationName,
                variables: variables,
                extensions: {
                    pq: id,
                    ...subscribeOptions?.subscribeExtensions || {},
                    ...replayConfig && {
                        replay: replayConfig
                    }
                }
            };
            let requestId = null;
            subscribeOptions?.onSubscribeTrigger?.(payload);
            return client.subscribe(payload, {
                ...sink,
                next: (value)=>{
                    // @ts-expect-error agg prop is missing on generic "extensions" type
                    const aggRequestId = value?.extensions?.gateway?.request_id;
                    requestId = aggRequestId ?? requestId;
                    // @ts-expect-error incompatible types between two libraries
                    sink.next(value);
                },
                error: (sinkError)=>{
                    const errorInfo = (0, $48B0E.getSinkError)(sinkError);
                    sink.error(errorInfo);
                    subscribeOptions?.onSubscribeError?.({
                        ...payload,
                        requestId: requestId
                    });
                }
            });
        });
    if (typeof subscribeOptions === 'undefined') $c52e2194a2c31d31$var$cachedDefaultSubscribe = fn;
    return fn;
}
const $c52e2194a2c31d31$export$ec068583843480e7 = $c52e2194a2c31d31$export$10f5a0700f263f11();
module.exports["createSubscribeFn"] = $c52e2194a2c31d31$export$10f5a0700f263f11;

});

parcelRegister("255Lo", function(module, exports) {

var $lrJXD = parcelRequire("lrJXD");


var $bDPoq = parcelRequire("bDPoq");


var $95JXf = parcelRequire("95JXf");


var $iFSKP = parcelRequire("iFSKP");

let $4e4d80ce73ad627c$var$client;
const $4e4d80ce73ad627c$export$6bb76d6eba7e258c = ()=>{
    if ((0, $iFSKP.isSSR)()) return null;
    if (!$4e4d80ce73ad627c$var$client) $4e4d80ce73ad627c$var$client = (0, $lrJXD.createClient)({
        url: (0, $iFSKP.getAggSubscriptionEndpoint)(),
        lazy: true,
        keepAlive: (0, $95JXf.WS_CLIENT_KEEP_ALIVE),
        retryAttempts: (0, $95JXf.WS_CLIENT_RETRIES),
        connectionParams: {
            'atl-client-name': 'jira-frontend',
            'atl-client-version': `${window?.BUILD_KEY ?? ''}::${window?.SSR_BUILD_KEY ?? ''}`,
            'X-ExperimentalApi': (0, $bDPoq.getRelayExperimentalApis)().join(',')
        }
    });
    return $4e4d80ce73ad627c$var$client;
};
const $4e4d80ce73ad627c$export$2f0afd443356d36f = ()=>{
    $4e4d80ce73ad627c$var$client = null;
};
module.exports["getClient"] = $4e4d80ce73ad627c$export$6bb76d6eba7e258c;

});

parcelRegister("lrJXD", function(module, exports) {
$parcel$export(module.exports, "createClient", () => $f9cfc574ab3845a4$export$5d730b7aed1a3eb0);
/**
 *
 * client
 *
 */ 
var $hvy9d = parcelRequire("hvy9d");


var $knMkm = parcelRequire("knMkm");

var $f9cfc574ab3845a4$var$__await = undefined && undefined.__await || function(v) {
    return this instanceof $f9cfc574ab3845a4$var$__await ? (this.v = v, this) : new $f9cfc574ab3845a4$var$__await(v);
};
var $f9cfc574ab3845a4$var$__asyncGenerator = undefined && undefined.__asyncGenerator || function(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f9cfc574ab3845a4$var$__await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
};
function $f9cfc574ab3845a4$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries) {
        let retryDelay = 1000; // start with 1s delay
        for(let i = 0; i < retries; i++)retryDelay *= 2;
        await new Promise((resolve)=>setTimeout(resolve, retryDelay + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $f9cfc574ab3845a4$var$isLikeCloseEvent, isFatalConnectionProblem: isFatalConnectionProblem, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == 'x' ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$f9cfc574ab3845a4$var$isWebSocket(webSocketImpl)) throw new Error('Invalid WebSocket implementation provided');
        ws = webSocketImpl;
    } else if (typeof WebSocket !== 'undefined') ws = WebSocket;
    else if (typeof $parcel$global !== 'undefined') ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== 'undefined') ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    // websocket status emitter, subscriptions are handled differently
    const emitter = (()=>{
        const message = (()=>{
            const listeners = {};
            return {
                on (id, listener) {
                    listeners[id] = listener;
                    return ()=>{
                        delete listeners[id];
                    };
                },
                emit (message) {
                    var _a;
                    if ('id' in message) (_a = listeners[message.id]) === null || _a === void 0 || _a.call(listeners, message);
                }
            };
        })();
        const listeners = {
            connecting: (on === null || on === void 0 ? void 0 : on.connecting) ? [
                on.connecting
            ] : [],
            opened: (on === null || on === void 0 ? void 0 : on.opened) ? [
                on.opened
            ] : [],
            connected: (on === null || on === void 0 ? void 0 : on.connected) ? [
                on.connected
            ] : [],
            ping: (on === null || on === void 0 ? void 0 : on.ping) ? [
                on.ping
            ] : [],
            pong: (on === null || on === void 0 ? void 0 : on.pong) ? [
                on.pong
            ] : [],
            message: (on === null || on === void 0 ? void 0 : on.message) ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: (on === null || on === void 0 ? void 0 : on.closed) ? [
                on.closed
            ] : [],
            error: (on === null || on === void 0 ? void 0 : on.error) ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                // we copy the listeners so that unlistens dont "pull the rug under our feet"
                for (const listener of [
                    ...listeners[event]
                ])// @ts-expect-error: The args should fit
                listener(...args);
            }
        };
    })();
    // invokes the callback either when an error or closed event is emitted,
    // first one that gets called prevails, other emissions are ignored
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on('error', (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on('closed', (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        // clear the lazy close timeout immediatelly so that close gets debounced
        // see: https://github.com/enisdenjo/graphql-ws/issues/388
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting !== null && connecting !== void 0 ? connecting : connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    // subscriptions might complete while waiting for retry
                    if (!locks) {
                        connecting = undefined;
                        return denied({
                            code: 1000,
                            reason: 'All Subscriptions Gone'
                        });
                    }
                    retries++;
                }
                emitter.emit('connecting', retrying);
                const socket = new WebSocketImpl(typeof url === 'function' ? await url() : url, (0, $hvy9d.GRAPHQL_TRANSPORT_WS_PROTOCOL));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing); // in case where a pong was received before a ping (this is valid behaviour)
                        queuedPing = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) {
                                socket.send((0, $hvy9d.stringifyMessage)({
                                    type: (0, $hvy9d.MessageType).Ping
                                }));
                                emitter.emit('ping', false, undefined);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = undefined;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $f9cfc574ab3845a4$export$f5b1bfead8e118a7) {
                        socket.close(4499, 'Terminated'); // close event is artificial and emitted manually, see `Client.terminate()` below
                        socket.onerror = null;
                        socket.onclose = null;
                    }
                });
                socket.onerror = (err)=>emitter.emit('error', err);
                socket.onclose = (event)=>emitter.emit('closed', event);
                socket.onopen = async ()=>{
                    try {
                        emitter.emit('opened', socket);
                        const payload = typeof connectionParams === 'function' ? await connectionParams() : connectionParams;
                        // connectionParams might take too long causing the server to kick off the client
                        // the necessary error/close event is already reported - simply stop execution
                        if (socket.readyState !== WebSocketImpl.OPEN) return;
                        socket.send((0, $hvy9d.stringifyMessage)(payload ? {
                            type: (0, $hvy9d.MessageType).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $hvy9d.MessageType).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket.close((0, $hvy9d.CloseCode).ConnectionAcknowledgementTimeout, 'Connection acknowledgement timeout');
                        }, connectionAckWaitTimeout);
                        enqueuePing(); // enqueue ping (noop if disabled)
                    } catch (err) {
                        emitter.emit('error', err);
                        socket.close((0, $hvy9d.CloseCode).InternalClientError, (0, $knMkm.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Internal client error'));
                    }
                };
                let acknowledged = false;
                socket.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $hvy9d.parseMessage)(data, reviver);
                        emitter.emit('message', message);
                        if (message.type === 'ping' || message.type === 'pong') {
                            emitter.emit(message.type, true, message.payload); // received
                            if (message.type === 'pong') enqueuePing(); // enqueue next ping (noop if disabled)
                            else if (!disablePong) {
                                // respond with pong on ping
                                socket.send((0, $hvy9d.stringifyMessage)(message.payload ? {
                                    type: (0, $hvy9d.MessageType).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $hvy9d.MessageType).Pong
                                }));
                                emitter.emit('pong', false, message.payload);
                            }
                            return; // ping and pongs can be received whenever
                        }
                        if (acknowledged) return; // already connected and acknowledged
                        if (message.type !== (0, $hvy9d.MessageType).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit('connected', socket, message.payload, retrying); // connected = socket opened + acknowledged
                        retrying = false; // future lazy connects are not retries
                        retries = 0; // reset the retries on connect
                        connected([
                            socket,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket.onmessage = null; // stop reading messages as soon as reading breaks once
                        emitter.emit('error', err);
                        socket.close((0, $hvy9d.CloseCode).BadResponse, (0, $knMkm.limitCloseReason)(err instanceof Error ? err.message : new Error(err).message, 'Bad response'));
                    }
                };
            })()));
        // if the provided socket is in a closing state, wait for the throw on close
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{
        // releases this connection
        };
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        // and if no more locks are present, complete the connection
                        const complete = ()=>socket.close(1000, 'Normal Closure');
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) // if the keepalive is set, allow for the specified calmdown time and
                        // then complete if the socket is still open.
                        lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else // otherwise complete immediately
                        complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    /**
     * Checks the `connect` problem and evaluates if the client should retry.
     */ function shouldRetryConnectOrThrow(errOrCloseEvent) {
        // some close codes are worth reporting immediately
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && ($f9cfc574ab3845a4$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $hvy9d.CloseCode).InternalServerError,
            (0, $hvy9d.CloseCode).InternalClientError,
            (0, $hvy9d.CloseCode).BadRequest,
            (0, $hvy9d.CloseCode).BadResponse,
            (0, $hvy9d.CloseCode).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $hvy9d.CloseCode).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $hvy9d.CloseCode).SubscriberAlreadyExists,
            (0, $hvy9d.CloseCode).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        // client was disposed, no retries should proceed regardless
        if (disposed) return false;
        // normal closure (possibly all subscriptions have completed)
        // if no locks were acquired in the meantime, shouldnt try again
        if ($f9cfc574ab3845a4$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1000) return locks > 0;
        // retries are not allowed or we tried to many times, report error
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        // throw non-retryable connection problems
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        // @deprecated throw fatal connection problems immediately
        if (isFatalConnectionProblem === null || isFatalConnectionProblem === void 0 ? void 0 : isFatalConnectionProblem(errOrCloseEvent)) throw errOrCloseEvent;
        // looks good, start retrying
        return retrying = true;
    }
    // in non-lazy (hot?) mode always hold one connection lock to persist the socket
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose; // will always throw because releaser is not used
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent) {
                // report thrown error, no further retries
                return onNonLazyError === null || onNonLazyError === void 0 ? void 0 : onNonLazyError(errOrCloseEvent);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            // for handling completions before connect
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                // if done while waiting for connect, release the connection lock right away
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $hvy9d.MessageType).Next:
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                            sink.next(message.payload);
                            return;
                        case (0, $hvy9d.MessageType).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $hvy9d.MessageType).Complete:
                            done = true;
                            releaser(); // release completes the sink
                            return;
                    }
                });
                socket.send((0, $hvy9d.stringifyMessage)({
                    id: id,
                    type: (0, $hvy9d.MessageType).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) // if not completed already and socket is open, send complete message to server on release
                    socket.send((0, $hvy9d.stringifyMessage)({
                        id: id,
                        type: (0, $hvy9d.MessageType).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                // either the releaser will be called, connection completed and
                // the promise resolved or the socket closed and the promise rejected.
                // whatever happens though, we want to stop listening for messages
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return; // completed, shouldnt try again
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            // delivering either an error or a complete terminates the sequence
            if (!errored) sink.complete();
        }) // resolves on release or normal closure
        .catch((err)=>{
            sink.error(err);
        }); // rejects on close events and errors
        return ()=>{
            // dispose only of active subscriptions
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{
                // noop
                }
            };
            const dispose = subscribe(request, {
                next (val) {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- payload will fit type
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = function iterator() {
                return $f9cfc574ab3845a4$var$__asyncGenerator(this, arguments, function* iterator_1() {
                    for(;;){
                        if (!pending.length) // only wait if there are no pending messages available
                        yield $f9cfc574ab3845a4$var$__await(new Promise((resolve)=>deferred.resolve = resolve));
                        // first flush
                        while(pending.length)// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        yield yield $f9cfc574ab3845a4$var$__await(pending.shift());
                        // then error
                        if (deferred.error) throw deferred.error;
                        // or complete
                        if (deferred.done) return yield $f9cfc574ab3845a4$var$__await(void 0);
                    }
                });
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: undefined
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: undefined
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                // if there is a connection, close it
                const [socket] = await connecting;
                socket.close(1000, 'Normal Closure');
            }
        },
        terminate () {
            if (connecting) // only if there is a connection
            emitter.emit('closed', new $f9cfc574ab3845a4$export$f5b1bfead8e118a7());
        }
    };
}
class $f9cfc574ab3845a4$export$f5b1bfead8e118a7 extends Error {
    constructor(){
        super(...arguments);
        this.name = 'TerminatedCloseEvent';
        this.message = '4499: Terminated';
        this.code = 4499;
        this.reason = 'Terminated';
        this.wasClean = false;
    }
}
function $f9cfc574ab3845a4$var$isLikeCloseEvent(val) {
    return (0, $knMkm.isObject)(val) && 'code' in val && 'reason' in val;
}
function $f9cfc574ab3845a4$var$isFatalInternalCloseCode(code) {
    if ([
        1000,
        1001,
        1006,
        1005,
        1012,
        1013,
        1014
    ].includes(code)) return false;
    // all other internal errors are fatal
    return code >= 1000 && code <= 1999;
}
function $f9cfc574ab3845a4$var$isWebSocket(val) {
    return typeof val === 'function' && 'constructor' in val && 'CLOSED' in val && 'CLOSING' in val && 'CONNECTING' in val && 'OPEN' in val;
}

});

parcelRegister("hvy9d", function(module, exports) {
$parcel$export(module.exports, "CloseCode", () => $cbefd1f1d80a870f$export$777128f41f6616ec);
$parcel$export(module.exports, "MessageType", () => $cbefd1f1d80a870f$export$80edbf15fa61a4db);
/**
 *
 * common
 *
 */ 
var $knMkm = parcelRequire("knMkm");

const $cbefd1f1d80a870f$export$5c0a4edfedc7c457 = 'graphql-transport-ws';
const $cbefd1f1d80a870f$export$ec743af8bb66f3be = 'graphql-ws';
var $cbefd1f1d80a870f$export$777128f41f6616ec;
(function(CloseCode) {
    CloseCode[CloseCode["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode[CloseCode["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode[CloseCode["BadRequest"] = 4400] = "BadRequest";
    CloseCode[CloseCode["BadResponse"] = 4004] = "BadResponse";
    /** Tried subscribing before connect ack */ CloseCode[CloseCode["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode[CloseCode["Forbidden"] = 4403] = "Forbidden";
    CloseCode[CloseCode["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode[CloseCode["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode[CloseCode["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    /** Subscriber distinction is very important */ CloseCode[CloseCode["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode[CloseCode["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
})($cbefd1f1d80a870f$export$777128f41f6616ec || ($cbefd1f1d80a870f$export$777128f41f6616ec = {}));
var $cbefd1f1d80a870f$export$80edbf15fa61a4db;
(function(MessageType) {
    MessageType["ConnectionInit"] = "connection_init";
    MessageType["ConnectionAck"] = "connection_ack";
    MessageType["Ping"] = "ping";
    MessageType["Pong"] = "pong";
    MessageType["Subscribe"] = "subscribe";
    MessageType["Next"] = "next";
    MessageType["Error"] = "error";
    MessageType["Complete"] = "complete";
})($cbefd1f1d80a870f$export$80edbf15fa61a4db || ($cbefd1f1d80a870f$export$80edbf15fa61a4db = {}));
function $cbefd1f1d80a870f$export$c17861b159b1b673(val) {
    if (!(0, $knMkm.isObject)(val)) throw new Error(`Message is expected to be an object, but got ${(0, $knMkm.extendedTypeof)(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== 'string') throw new Error(`Message is expects the 'type' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.type)}`);
    switch(val.type){
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionInit:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.ConnectionAck:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Ping:
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Pong:
            if (val.payload != null && !(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Subscribe:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $knMkm.extendedTypeof)(val.payload)}`);
            if (typeof val.payload.query !== 'string') throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.payload.query)}`);
            if (val.payload.variables != null && !(0, $knMkm.isObject)(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.variables)}`);
            if (val.payload.operationName != null && (0, $knMkm.extendedTypeof)(val.payload.operationName) !== 'string') throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.operationName)}`);
            if (val.payload.extensions != null && !(0, $knMkm.isObject)(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${(0, $knMkm.extendedTypeof)(val.payload.extensions)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Next:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.isObject)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${(0, $knMkm.extendedTypeof)(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Error:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!(0, $knMkm.areGraphQLErrors)(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case $cbefd1f1d80a870f$export$80edbf15fa61a4db.Complete:
            if (typeof val.id !== 'string') throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${(0, $knMkm.extendedTypeof)(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $cbefd1f1d80a870f$export$9e0e49e75fa7d548(val) {
    try {
        $cbefd1f1d80a870f$export$c17861b159b1b673(val);
        return true;
    } catch (_a) {
        return false;
    }
}
function $cbefd1f1d80a870f$export$f2f615077a189f21(data, reviver) {
    return $cbefd1f1d80a870f$export$c17861b159b1b673(typeof data === 'string' ? JSON.parse(data, reviver) : data);
}
function $cbefd1f1d80a870f$export$77896e5b47bfd50b(msg, replacer) {
    $cbefd1f1d80a870f$export$c17861b159b1b673(msg);
    return JSON.stringify(msg, replacer);
}
module.exports["GRAPHQL_TRANSPORT_WS_PROTOCOL"] = $cbefd1f1d80a870f$export$5c0a4edfedc7c457;
module.exports["parseMessage"] = $cbefd1f1d80a870f$export$f2f615077a189f21;
module.exports["stringifyMessage"] = $cbefd1f1d80a870f$export$77896e5b47bfd50b;

});

parcelRegister("knMkm", function(module, exports) {
/** @private */ function $ed6b7173c8b91525$export$573326049e1b1c6b(val) {
    if (val === null) return 'null';
    if (Array.isArray(val)) return 'array';
    return typeof val;
}
function $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) {
    return $ed6b7173c8b91525$export$573326049e1b1c6b(val) === 'object';
}
function $ed6b7173c8b91525$export$edb10ab8dd75a915(val) {
    return typeof Object(val)[Symbol.asyncIterator] === 'function';
}
function $ed6b7173c8b91525$export$92bd080471bc30f1(val) {
    return $ed6b7173c8b91525$export$a6cdc56e425d0d0a(val) && typeof Object(val)[Symbol.asyncIterator] === 'function' && typeof val.return === 'function';
}
function $ed6b7173c8b91525$export$e6262fbc2e92290(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>'message' in ob);
}
function $ed6b7173c8b91525$export$2937fa0c8dddae54(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}
module.exports["extendedTypeof"] = $ed6b7173c8b91525$export$573326049e1b1c6b;
module.exports["isObject"] = $ed6b7173c8b91525$export$a6cdc56e425d0d0a;
module.exports["areGraphQLErrors"] = $ed6b7173c8b91525$export$e6262fbc2e92290;
module.exports["limitCloseReason"] = $ed6b7173c8b91525$export$2937fa0c8dddae54;

});

parcelRegister("95JXf", function(module, exports) {
const $036ca9aa83e0f390$export$8b012b965402e06a = 580000; // 9m 40 - timeframe needed for UCT token refresh: https://developer.atlassian.com/platform/graphql-gateway/subscriptions/security/#long-lived-user-context-token
const $036ca9aa83e0f390$export$bf6cd96e19b2987f = 100;
const $036ca9aa83e0f390$export$1ad8434180c5936c = 300000; // 5m
module.exports["WS_CLIENT_KEEP_ALIVE"] = $036ca9aa83e0f390$export$8b012b965402e06a;
module.exports["WS_CLIENT_RETRIES"] = $036ca9aa83e0f390$export$bf6cd96e19b2987f;

});

parcelRegister("iFSKP", function(module, exports) {
const $3f9756dc2e75e45b$export$48d7c418edadb60c = ()=>globalThis.__SERVER__ ?? false;
const $3f9756dc2e75e45b$export$29a72e89601dfc59 = ()=>`${window.location.origin.replace('http', 'ws')}/gateway/api/graphql/subscriptions`;
module.exports["isSSR"] = $3f9756dc2e75e45b$export$48d7c418edadb60c;
module.exports["getAggSubscriptionEndpoint"] = $3f9756dc2e75e45b$export$29a72e89601dfc59;

});

parcelRegister("48B0E", function(module, exports) {
const $b1307ce3a1c15d36$export$ece4736473c28965 = (error)=>{
    let errorInfo;
    if (Array.isArray(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [errorInfo] = error;
    else if (error instanceof Error) errorInfo = error;
    else if (typeof error === 'object' && 'type' in error && error.type === 'close') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`CloseEvent: ${error.reason}`);
    else if (typeof error === 'object' && 'type' in error && error.type === 'error') {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const errorEvent = error;
        errorInfo = new Error(`ErrorEvent: "${errorEvent.error}"`);
    } else if (error instanceof Event) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    errorInfo = new Error(`Event: ${error.type}`);
    else errorInfo = new Error(`Unknown sink error: ${error}`);
    if (error instanceof Error && error.stack) errorInfo.stack = error.stack;
    return errorInfo;
};
module.exports["getSinkError"] = $b1307ce3a1c15d36$export$ece4736473c28965;

});

parcelRegister("kzjMJ", function(module, exports) {

var $3e6Uc = parcelRequire("3e6Uc");

function $55e864d84c99338e$export$611736262b635f8d(queryID, variables) {
    return JSON.stringify((0, $3e6Uc.stableCopy)({
        queryID: queryID,
        variables: variables
    }));
}
function $55e864d84c99338e$export$1e65e863cf3a0f21(cacheKey) {
    return JSON.parse(cacheKey).queryID;
}
class $55e864d84c99338e$export$be21c283b097d175 extends (0, $3e6Uc.QueryResponseCache) {
    /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ setWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        this.set(queryID, variables, payload);
    }
    /**
   * Stores a GraphQLRepsonse along with metadata about the call.
   * If called multiple times (such as when incremental payloads are received),
   * will update the stored response to be an array of GraphQLSingularResponse objects,
   * which Relay is happy to handle.
   * @deprecated works, but does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */ appendWithMetadata(queryID, variables, payload, metadata) {
        this.requestMetadata.set(queryID, metadata);
        const currentResponse = this.get(queryID, variables);
        if (!currentResponse) this.set(queryID, variables, payload);
        else if (currentResponse instanceof Array) {
            const newResponse = [
                ...currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        } else {
            const newResponse = [
                currentResponse
            ].concat(payload);
            this.set(queryID, variables, newResponse);
        }
    }
    /**
   * Deletes a request from the store, if found.
   *
   * IMPORTANT: Make sure DELETE method always has tests that include get/set
   * to ensure our `getCacheKey` matches Relay's.
   *
   * @returns {boolean} indicating if an entry in the cache was deleted
   */ delete(queryID, variables) {
        const cacheKey = $55e864d84c99338e$export$611736262b635f8d(queryID, variables);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        return this._responses.delete(cacheKey);
    }
    serialize() {
        return {
            [this.cacheName]: {
                // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
                requestMetadata: Array.from(this.requestMetadata.entries()),
                // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
                responses: Array.from(this._responses.entries())
            }
        };
    }
    constructor({ cacheName: cacheName, size: size, ttl: ttl, timeoutCallback: timeoutCallback }){
        super({
            size: size,
            ttl: ttl
        });
        this.cacheName = void 0;
        this.requestMetadata = void 0;
        const isServer = typeof window === 'undefined';
        const cachedData = isServer ? {} : window?.SPA_STATE?.[cacheName] || window?.SKELETON_NAVIGATION?.[cacheName] || window?.__PLATFORM_SSR_AGG_CACHE__?.[cacheName] || {};
        this.cacheName = cacheName;
        this.requestMetadata = new Map(cachedData.requestMetadata);
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        this._responses = new Map(cachedData.responses);
        if (!isServer) setTimeout(()=>{
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            timeoutCallback?.(this._responses, this.requestMetadata);
            // cleanup leftover data to reduce unnecessary memory usage
            this.requestMetadata.clear();
            // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
            this._responses.clear();
        }, 60000 /* 1 minute */ );
    }
}
module.exports["SSRQueryResponseCache"] = $55e864d84c99338e$export$be21c283b097d175;

});

parcelRegister("19BZl", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

const $8e4be96129d634f8$var$defaultSectionExpansionContext = {
    sectionExpansionState: {},
    setSectionExpansionState: function() {}
};
const $8e4be96129d634f8$export$fc9ae5c4169099cb = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultSectionExpansionContext);
function $8e4be96129d634f8$export$b316af36f410c3ff() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$fc9ae5c4169099cb);
}
const $8e4be96129d634f8$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {},
    mixedItems: [],
    product: 'unknown',
    subProduct: undefined,
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: []
};
const $8e4be96129d634f8$export$39aa3c8950714d79 = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControls);
function $8e4be96129d634f8$export$56d95dc846453c64() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
}
const $8e4be96129d634f8$var$defaultFormControlsV2 = {
    load: function() {},
    reset: function() {},
    close: function() {}
};
const $8e4be96129d634f8$export$bde3acf5b7a2ab3c = (0, $42omo.createContext)($8e4be96129d634f8$var$defaultFormControlsV2);
function $8e4be96129d634f8$export$24cc61890c8f7885() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$bde3acf5b7a2ab3c);
}
const $8e4be96129d634f8$export$24aad8519b95b41b = (0, $42omo.createContext)({
    isV2Mode: false,
    items: [],
    product: 'unknown',
    subProduct: undefined,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: [],
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    preventClose: undefined,
    controlledOpen: undefined
});
function $8e4be96129d634f8$export$efa3856fc0e85e7f() {
    return (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
}
function $8e4be96129d634f8$export$c7381b2490bb4d36() {
    const menuControlContext = (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
    const menuStateContext = (0, $42omo.useContext)($8e4be96129d634f8$export$24aad8519b95b41b);
    // When FG is enabled, prefer new context
    if ((0, $dh538.fg)('navx_uc_context_refactor')) return menuStateContext;
    // Fall back to constructing state from the old MenuControlContext
    // isV2Mode is determined by whether sections array has items
    const isV2Mode = !!menuControlContext.sections?.length;
    return {
        isV2Mode: isV2Mode,
        items: menuControlContext.mixedItems,
        product: menuControlContext.product,
        subProduct: menuControlContext.subProduct,
        crossAppCreationConfig: menuControlContext.crossAppCreationConfig,
        sections: menuControlContext.sections,
        suggestionConfig: menuControlContext.suggestionConfig,
        isNav4Enabled: menuControlContext.isNav4Enabled,
        preventClose: undefined,
        controlledOpen: undefined
    };
}
function $8e4be96129d634f8$export$2cd627eaf555af8f() {
    const menuControlContext = (0, $42omo.useContext)($8e4be96129d634f8$export$39aa3c8950714d79);
    const menuControlV2Context = (0, $42omo.useContext)($8e4be96129d634f8$export$bde3acf5b7a2ab3c);
    // When FG is enabled, prefer new V2 context
    if ((0, $dh538.fg)('navx_uc_context_refactor')) return menuControlV2Context;
    // Fall back to old MenuControlContext
    return {
        load: menuControlContext.load,
        reset: menuControlContext.reset,
        close: menuControlContext.close
    };
}
module.exports["SectionExpansionContext"] = $8e4be96129d634f8$export$fc9ae5c4169099cb;
module.exports["useSectionExpansionContext"] = $8e4be96129d634f8$export$b316af36f410c3ff;
module.exports["MenuControlContext"] = $8e4be96129d634f8$export$39aa3c8950714d79;
module.exports["MenuControlContextV2"] = $8e4be96129d634f8$export$bde3acf5b7a2ab3c;
module.exports["MenuStateContext"] = $8e4be96129d634f8$export$24aad8519b95b41b;
module.exports["useMenuStateContext"] = $8e4be96129d634f8$export$efa3856fc0e85e7f;
module.exports["useUniversalCreateState"] = $8e4be96129d634f8$export$c7381b2490bb4d36;
module.exports["useUniversalCreateControl"] = $8e4be96129d634f8$export$2cd627eaf555af8f;

});

parcelRegister("9A2e6", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $dh538 = parcelRequire("dh538");


var $49YLc = parcelRequire("49YLc");


var $5IDSL = parcelRequire("5IDSL");


var $jjCkw = parcelRequire("jjCkw");


var $19BZl = parcelRequire("19BZl");

function $31bd555df287b548$export$9e9b5b3f9c08ce57({ children: children, name: name, interactionId: interactionId, fallback: fallback = null, onError: onError, app: app }) {
    const { product: product, subProduct: subProduct } = (0, $19BZl.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $19BZl.useUniversalCreateState)();
    const tags = {
        component: (0, $jjCkw.PACKAGE_PREFIX),
        subProduct: subProduct || subProductV1
    };
    const { handleError: handleError } = $31bd555df287b548$var$useConditionalNavBoundaryContext({
        location: name,
        disableSentry: false,
        disableAnalytics: true,
        onError: onError,
        sentryConfig: {
            product: app || product || productV1
        },
        interactionId: interactionId,
        tags: tags
    });
    const handleOnError = (0, $42omo.useCallback)(async (error)=>{
        if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(error);
        else onError?.(error);
    }, [
        handleError,
        onError
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: fallback,
        onError: handleOnError,
        children: children
    });
}
const $31bd555df287b548$var$useConditionalNavBoundaryContext = (0, $49YLc.functionWithFG)('navx_uc_sentry_enabled', (0, $5IDSL.useNavBoundaryContext), ()=>({
        handleError: ()=>{}
    }));
module.exports["GenericErrorBoundary"] = $31bd555df287b548$export$9e9b5b3f9c08ce57;

});

parcelRegister("49YLc", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $1I43V = parcelRequire("1I43V");

const $45703bb7386f8863$export$53903226fff06fbb = (featureFlagName, functionTrue, functionFalse)=>(0, $1I43V.functionWithCondition)(()=>(0, $dh538.fg)(featureFlagName), functionTrue, functionFalse);
module.exports["functionWithFG"] = $45703bb7386f8863$export$53903226fff06fbb;

});

parcelRegister("5IDSL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4NsV7 = parcelRequire("4NsV7");


var $ekxcy = parcelRequire("ekxcy");


var $8OtrY = parcelRequire("8OtrY");

function $b5e919069742162a$export$335b0c12ccf77339({ location: location = 'unknown', disableSentry: disableSentry = false, disableAnalytics: disableAnalytics = false, onError: onError, sentryConfig: sentryConfig, tags: tags } = {}) {
    const { fireEvent: fireEvent } = (0, $4NsV7.useAnalyticsEvents)();
    if (!disableSentry) try {
        (0, $ekxcy.setupSentryClient)({
            sentryConfig: sentryConfig
        });
    } catch (error) {
        // Log failure to initialize Sentry
        fireEvent('operational.initSentry.failed', {
            location: location,
            reason: error instanceof Error ? error.message : 'unknown'
        });
    }
    const tagsToLog = (0, $42omo.useMemo)(()=>{
        return {
            ...tags,
            location: location,
            teamName: (0, $8OtrY.SENTRY_TEAM_NAME),
            product: sentryConfig?.product ?? (0, $8OtrY.SENTRY_PRODUCT),
            productBuild: $b5e919069742162a$var$getProductBuild()
        };
    }, [
        tags,
        location,
        sentryConfig?.product
    ]);
    const handleError = (0, $42omo.useCallback)((error)=>{
        // Send events to sentry
        if (!disableSentry) try {
            (0, $ekxcy.logException)(error, tagsToLog);
        } catch (err) {
            // Log failure to send to Sentry
            fireEvent('operational.logToSentry.failed', {
                location: location,
                reason: err instanceof Error ? err.message : 'unknown'
            });
        }
        // Fire Analytics event
        if (!disableAnalytics) fireEvent('operational.errorBoundary.unhandledErrorCaught', {
            location: location,
            errorMessage: error.message,
            errorStack: error.stack || 'no stack trace'
        });
        // Invoke external onError
        onError?.(error);
    }, [
        disableSentry,
        disableAnalytics,
        onError,
        location,
        tagsToLog,
        fireEvent
    ]);
    return {
        handleError: handleError
    };
}
function $b5e919069742162a$var$getProductBuild() {
    // Ensure we don't invoke window object in SSR
    if (typeof window === 'undefined') return 'unknown';
    switch(true){
        // Jira - window.BUILD_KEY
        case 'BUILD_KEY' in window:
            return window.BUILD_KEY || 'unknown';
        // Confluence - window.__buildInfo
        case '__buildInfo' in window:
            return window.__buildInfo?.FRONTEND_VERSION || 'unknown';
        default:
            return 'unknown';
    }
}
module.exports["useNavBoundaryContext"] = $b5e919069742162a$export$335b0c12ccf77339;

});

parcelRegister("4NsV7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::852a07e098801d09532a079dc210ca17>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $aHlaw = parcelRequire("aHlaw");


var $5YXCb = parcelRequire("5YXCb");

const $26d2654a80668b7e$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $5YXCb.default)(...params));
        event.fire((0, $aHlaw.EVENT_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $26d2654a80668b7e$export$5bf35293e545f20c;

});

parcelRegister("aHlaw", function(module, exports) {
const $718bd7cb44a047b4$export$3f072f06b90c3985 = 'navigation';
module.exports["EVENT_CHANNEL"] = $718bd7cb44a047b4$export$3f072f06b90c3985;

});

parcelRegister("5YXCb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::85436479424fa726e1c817d9c4b6af72>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen navigation-common
 */ const $246134791e2b1d20$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $246134791e2b1d20$export$2e2bcd8739ae039 = $246134791e2b1d20$var$createEventPayload;
module.exports["default"] = $246134791e2b1d20$export$2e2bcd8739ae039;

});

parcelRegister("ekxcy", function(module, exports) {

var $1RwJS = parcelRequire("1RwJS");

var $2N6Bm = parcelRequire("2N6Bm");

var $dfIQx = parcelRequire("dfIQx");

var $4wHYU = parcelRequire("4wHYU");

var $9lupr = parcelRequire("9lupr");


var $ekTM6 = parcelRequire("ekTM6");


var $l2piV = parcelRequire("l2piV");


var $8OtrY = parcelRequire("8OtrY");

let $21fcd6b6f4d6fe49$var$sentryClient;
let $21fcd6b6f4d6fe49$var$scope = new (0, $9lupr.Scope)();
function $21fcd6b6f4d6fe49$export$f86b2a1a2ce291b3(exception, tags) {
    $21fcd6b6f4d6fe49$var$scope.setTags(tags);
    if (exception instanceof (0, $ekTM6.BFFError)) {
        const error = exception;
        $21fcd6b6f4d6fe49$var$scope.setExtras({
            name: error.name,
            context: error.context,
            status: error.status,
            timestamp: error.timestamp,
            originalError: error.originalError,
            ...error instanceof (0, $ekTM6.BFFNetworkError) && {
                url: error.url
            }
        });
    }
    $21fcd6b6f4d6fe49$var$sentryClient?.captureException(exception, undefined, $21fcd6b6f4d6fe49$var$scope);
    // Unset tags to prevent an instance of the error boundary from logging with a specific tag,
    // and then another instance from wrongly passing it despite not having the tag.
    for (const [key, _] of Object.entries(tags))$21fcd6b6f4d6fe49$var$scope.setTag(key, undefined);
    // Unset any extras to prevent them from persisting
    $21fcd6b6f4d6fe49$var$scope.setExtras({});
}
function $21fcd6b6f4d6fe49$export$d8bd0edf6c978788({ sentryConfig: sentryConfig }) {
    const { dsn: dsn = (0, $8OtrY.SENTRY_DSN), env: env } = sentryConfig || {};
    if (!$21fcd6b6f4d6fe49$var$sentryClient) {
        // SSR-safe check. If we are in SSR, we don't need a sentryClient
        if (typeof window === 'undefined') return false;
        const environment = (0, $l2piV.getEnvironment)(env);
        // filter integrations that use the global variable
        const integrations = (0, $dfIQx.getDefaultIntegrations)({}).filter((defaultIntegration)=>{
            return ![
                'BrowserApiErrors',
                'Breadcrumbs',
                'GlobalHandlers'
            ].includes(defaultIntegration.name);
        });
        $21fcd6b6f4d6fe49$var$sentryClient = new (0, $1RwJS.BrowserClient)({
            ...(0, $8OtrY.DEFAULT_SENTRY_CONFIG),
            dsn: dsn,
            environment: environment,
            beforeSend: (event)=>{
                // We only want errors captured explicitly via logException to avoid unwanted errors being sent
                if (event.tags?.teamName === undefined) return null;
                return event;
            },
            attachStacktrace: true,
            transport: (0, $4wHYU.makeFetchTransport),
            stackParser: (0, $2N6Bm.defaultStackParser),
            integrations: integrations
        });
        $21fcd6b6f4d6fe49$var$scope.setClient($21fcd6b6f4d6fe49$var$sentryClient);
        $21fcd6b6f4d6fe49$var$sentryClient.init();
    }
    return true;
}
function $21fcd6b6f4d6fe49$export$64db7b418e82aaf6() {
    $21fcd6b6f4d6fe49$var$sentryClient = undefined;
    $21fcd6b6f4d6fe49$var$scope = new (0, $9lupr.Scope)();
}
module.exports["logException"] = $21fcd6b6f4d6fe49$export$f86b2a1a2ce291b3;
module.exports["setupSentryClient"] = $21fcd6b6f4d6fe49$export$d8bd0edf6c978788;

});

parcelRegister("1RwJS", function(module, exports) {

var $38Oj8 = parcelRequire("38Oj8");

var $lXuQT = parcelRequire("lXuQT");


var $frHB6 = parcelRequire("frHB6");

var $atmi4 = parcelRequire("atmi4");

var $eHkE2 = parcelRequire("eHkE2");

var $iORpg = parcelRequire("iORpg");


var $30gU3 = parcelRequire("30gU3");


var $1nill = parcelRequire("1nill");


var $l8uFk = parcelRequire("l8uFk");


var $jHwiG = parcelRequire("jHwiG");

/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $15b422f4aef7c497$export$1df9218a526d318d extends (0, $lXuQT.BaseClient) {
    eventFromException(exception, hint) {
        return (0, $1nill.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $1nill.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $jHwiG.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        }); // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).log('No outcomes to send');
            return;
        } // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $frHB6.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $atmi4.dsnToString)(this._dsn)); // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $l8uFk.WINDOW).SENTRY_SDK_SOURCE || (0, $eHkE2.getSDKSource)();
        (0, $38Oj8.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $l8uFk.WINDOW).document) (0, $l8uFk.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $l8uFk.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
}
module.exports["BrowserClient"] = $15b422f4aef7c497$export$1df9218a526d318d;

});

parcelRegister("30gU3", function(module, exports) {
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $22fe7bcfa901e6b7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
module.exports["DEBUG_BUILD"] = $22fe7bcfa901e6b7$export$16a28057038b10ef;

});

parcelRegister("1nill", function(module, exports) {

var $fk3RW = parcelRequire("fk3RW");


var $5rftB = parcelRequire("5rftB");

var $9jlA0 = parcelRequire("9jlA0");

var $ksWTX = parcelRequire("ksWTX");

var $2hgea = parcelRequire("2hgea");

var $aFDzs = parcelRequire("aFDzs");

/**
 * This function creates an exception from a JavaScript Error
 */ function $10062affd5a0a5b8$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $10062affd5a0a5b8$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $10062affd5a0a5b8$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
} /**
   * @hidden
   */ 
function $10062affd5a0a5b8$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $fk3RW.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $ksWTX.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $10062affd5a0a5b8$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $2hgea.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $10062affd5a0a5b8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $10062affd5a0a5b8$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $10062affd5a0a5b8$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
} /** Parses stack frames from an error */ 
function $10062affd5a0a5b8$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $10062affd5a0a5b8$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {}
    return [];
} // Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $10062affd5a0a5b8$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $10062affd5a0a5b8$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($10062affd5a0a5b8$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
} /**
   * There are cases where stacktrace.message is an Event object
   * https://github.com/getsentry/sentry-javascript/issues/1949
   * In this specific case we try to extract stacktrace.message.error.message
   */ 
function $10062affd5a0a5b8$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
} /**
   * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
   * @hidden
   */ 
function $10062affd5a0a5b8$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $10062affd5a0a5b8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5rftB.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $aFDzs.resolvedSyncPromise)(event);
} /**
   * Builds and Event from a Message
   * @hidden
   */ 
function $10062affd5a0a5b8$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $10062affd5a0a5b8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $aFDzs.resolvedSyncPromise)(event);
} /**
   * @hidden
   */ 
function $10062affd5a0a5b8$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $ksWTX.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $10062affd5a0a5b8$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    } // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $ksWTX.isDOMError)(exception) || (0, $ksWTX.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $10062affd5a0a5b8$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $ksWTX.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $10062affd5a0a5b8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $5rftB.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $ksWTX.isError)(exception)) // we have a real Error object, do nothing
    return $10062affd5a0a5b8$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $ksWTX.isPlainObject)(exception) || (0, $ksWTX.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $10062affd5a0a5b8$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $5rftB.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    } // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $10062affd5a0a5b8$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $5rftB.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $5rftB.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $10062affd5a0a5b8$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $10062affd5a0a5b8$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $ksWTX.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $10062affd5a0a5b8$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $9jlA0.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception'; // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $ksWTX.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $ksWTX.isEvent)(exception)) {
        const className = $10062affd5a0a5b8$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $10062affd5a0a5b8$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {}
}
module.exports["exceptionFromError"] = $10062affd5a0a5b8$export$a6c2d27607295951;
module.exports["eventFromException"] = $10062affd5a0a5b8$export$ea3ec7e569b823fc;
module.exports["eventFromUnknownInput"] = $10062affd5a0a5b8$export$9dd56ed1ef0c3420;
module.exports["eventFromMessage"] = $10062affd5a0a5b8$export$5425b53185d13d6c;

});

parcelRegister("l8uFk", function(module, exports) {


var $fk3RW = parcelRequire("fk3RW");


var $5rftB = parcelRequire("5rftB");

var $9jlA0 = parcelRequire("9jlA0");

var $8aOG1 = parcelRequire("8aOG1");

const $f63221dc07a7f414$export$56d8a8a25bd48b81 = (0, $8aOG1.GLOBAL_OBJ);
let $f63221dc07a7f414$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $f63221dc07a7f414$export$b79738ab10c590b2() {
    return $f63221dc07a7f414$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $f63221dc07a7f414$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $f63221dc07a7f414$var$ignoreOnError++;
    setTimeout(()=>{
        $f63221dc07a7f414$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $f63221dc07a7f414$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $9jlA0.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$f63221dc07a7f414$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $f63221dc07a7f414$export$1265a142ff5ba165();
            (0, $fk3RW.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $5rftB.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $5rftB.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $fk3RW.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $9jlA0.markFunctionWrapped)(sentryWrapped, fn);
    (0, $9jlA0.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
module.exports["WINDOW"] = $f63221dc07a7f414$export$56d8a8a25bd48b81;
module.exports["shouldIgnoreOnError"] = $f63221dc07a7f414$export$b79738ab10c590b2;
module.exports["wrap"] = $f63221dc07a7f414$export$4997ffc0176396a6;

});

parcelRegister("jHwiG", function(module, exports) {

var $lV0rV = parcelRequire("lV0rV");

var $atmi4 = parcelRequire("atmi4");

/**
 * Creates an envelope from a user feedback.
 */ function $e57b16a7090aa37d$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $atmi4.dsnToString)(dsn)
        }
    };
    const item = $e57b16a7090aa37d$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $lV0rV.createEnvelope)(headers, [
        item
    ]);
}
function $e57b16a7090aa37d$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}
module.exports["createUserFeedbackEnvelope"] = $e57b16a7090aa37d$export$24a4dfcb686ee5bf;

});

parcelRegister("2N6Bm", function(module, exports) {

var $aNFX0 = parcelRequire("aNFX0");

// global reference to slice
const $2085474e698a0d02$var$UNKNOWN_FUNCTION = '?';
const $2085474e698a0d02$var$OPERA10_PRIORITY = 10;
const $2085474e698a0d02$var$OPERA11_PRIORITY = 20;
const $2085474e698a0d02$var$CHROME_PRIORITY = 30;
const $2085474e698a0d02$var$WINJS_PRIORITY = 40;
const $2085474e698a0d02$var$GECKO_PRIORITY = 50;
function $2085474e698a0d02$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $2085474e698a0d02$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $2085474e698a0d02$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $2085474e698a0d02$var$chromeStackParserFn = (line)=>{
    const parts = $2085474e698a0d02$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $2085474e698a0d02$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $2085474e698a0d02$var$extractSafariExtensionDetails(parts[1] || $2085474e698a0d02$var$UNKNOWN_FUNCTION, parts[2]);
        return $2085474e698a0d02$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $2085474e698a0d02$export$263a749fff749872 = [
    $2085474e698a0d02$var$CHROME_PRIORITY,
    $2085474e698a0d02$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $2085474e698a0d02$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $2085474e698a0d02$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $2085474e698a0d02$var$gecko = (line)=>{
    const parts = $2085474e698a0d02$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $2085474e698a0d02$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $2085474e698a0d02$var$UNKNOWN_FUNCTION;
        [func, filename] = $2085474e698a0d02$var$extractSafariExtensionDetails(func, filename);
        return $2085474e698a0d02$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $2085474e698a0d02$export$cdba47a5dd2804d = [
    $2085474e698a0d02$var$GECKO_PRIORITY,
    $2085474e698a0d02$var$gecko
];
const $2085474e698a0d02$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $2085474e698a0d02$var$winjs = (line)=>{
    const parts = $2085474e698a0d02$var$winjsRegex.exec(line);
    return parts ? $2085474e698a0d02$var$createFrame(parts[2], parts[1] || $2085474e698a0d02$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $2085474e698a0d02$export$179460296da408e8 = [
    $2085474e698a0d02$var$WINJS_PRIORITY,
    $2085474e698a0d02$var$winjs
];
const $2085474e698a0d02$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $2085474e698a0d02$var$opera10 = (line)=>{
    const parts = $2085474e698a0d02$var$opera10Regex.exec(line);
    return parts ? $2085474e698a0d02$var$createFrame(parts[2], parts[3] || $2085474e698a0d02$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $2085474e698a0d02$export$f892b52c880ffc7a = [
    $2085474e698a0d02$var$OPERA10_PRIORITY,
    $2085474e698a0d02$var$opera10
];
const $2085474e698a0d02$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $2085474e698a0d02$var$opera11 = (line)=>{
    const parts = $2085474e698a0d02$var$opera11Regex.exec(line);
    return parts ? $2085474e698a0d02$var$createFrame(parts[5], parts[3] || parts[4] || $2085474e698a0d02$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $2085474e698a0d02$export$af11af13f09fb0dc = [
    $2085474e698a0d02$var$OPERA11_PRIORITY,
    $2085474e698a0d02$var$opera11
];
const $2085474e698a0d02$export$7197c0fe6554c079 = [
    $2085474e698a0d02$export$263a749fff749872,
    $2085474e698a0d02$export$cdba47a5dd2804d,
    $2085474e698a0d02$export$179460296da408e8
];
const $2085474e698a0d02$export$2b2b997d81bf3907 = (0, $aNFX0.createStackParser)(...$2085474e698a0d02$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $2085474e698a0d02$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $2085474e698a0d02$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};
module.exports["defaultStackParser"] = $2085474e698a0d02$export$2b2b997d81bf3907;

});

parcelRegister("dfIQx", function(module, exports) {

var $fk3RW = parcelRequire("fk3RW");

var $5kpxh = parcelRequire("5kpxh");

var $fcfPb = parcelRequire("fcfPb");

var $cxrlu = parcelRequire("cxrlu");

var $32yRT = parcelRequire("32yRT");

var $awF3q = parcelRequire("awF3q");

var $hLSz4 = parcelRequire("hLSz4");


var $8yk6I = parcelRequire("8yk6I");

var $iORpg = parcelRequire("iORpg");

var $aNFX0 = parcelRequire("aNFX0");

var $9Z77k = parcelRequire("9Z77k");


var $1RwJS = parcelRequire("1RwJS");


var $30gU3 = parcelRequire("30gU3");


var $l8uFk = parcelRequire("l8uFk");


var $dGupE = parcelRequire("dGupE");


var $67KXD = parcelRequire("67KXD");


var $FpR3w = parcelRequire("FpR3w");


var $7mD6d = parcelRequire("7mD6d");


var $84v01 = parcelRequire("84v01");


var $7D0m1 = parcelRequire("7D0m1");


var $2N6Bm = parcelRequire("2N6Bm");


var $4wHYU = parcelRequire("4wHYU");


var $6di8y = parcelRequire("6di8y");

/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $9a5f76a78d83d9c8$export$5ef831fccfce35e5 = [
    (0, $awF3q.inboundFiltersIntegration)(),
    (0, $5kpxh.functionToStringIntegration)(),
    (0, $7D0m1.browserApiErrorsIntegration)(),
    (0, $dGupE.breadcrumbsIntegration)(),
    (0, $FpR3w.globalHandlersIntegration)(),
    (0, $84v01.linkedErrorsIntegration)(),
    (0, $67KXD.dedupeIntegration)(),
    (0, $7mD6d.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $9a5f76a78d83d9c8$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$9a5f76a78d83d9c8$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $9a5f76a78d83d9c8$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $9a5f76a78d83d9c8$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $l8uFk.WINDOW).SENTRY_RELEASE && (0, $l8uFk.WINDOW).SENTRY_RELEASE.id) options.release = (0, $l8uFk.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $aNFX0.stackParserFromStackParserOptions)(options.stackParser || (0, $2N6Bm.defaultStackParser)),
        integrations: (0, $cxrlu.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $9Z77k.supportsFetch)() ? (0, $4wHYU.makeFetchTransport) : (0, $6di8y.makeXHRTransport))
    };
    (0, $hLSz4.initAndBind)((0, $1RwJS.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $9a5f76a78d83d9c8$var$startSessionTracking();
}
const $9a5f76a78d83d9c8$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $fcfPb.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $l8uFk.WINDOW).document) {
        (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $l8uFk.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $32yRT.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $l8uFk.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $l8uFk.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $l8uFk.WINDOW).document.head || (0, $l8uFk.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $9a5f76a78d83d9c8$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $9a5f76a78d83d9c8$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $9a5f76a78d83d9c8$export$4997ffc0176396a6(fn) {
    return (0, $l8uFk.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $9a5f76a78d83d9c8$var$startSessionTracking() {
    if (typeof (0, $l8uFk.WINDOW).document === 'undefined') {
        (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $fk3RW.startSession)({
        ignoreDuration: true
    });
    (0, $fk3RW.captureSession)();
    // We want to create a session for every navigation as well
    (0, $8yk6I.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $fk3RW.startSession)({
                ignoreDuration: true
            });
            (0, $fk3RW.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $9a5f76a78d83d9c8$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $fk3RW.getClient)();
    if (client) client.captureUserFeedback(feedback);
}
module.exports["getDefaultIntegrations"] = $9a5f76a78d83d9c8$export$5783b2920b1d62b9;

});

parcelRegister("dGupE", function(module, exports) {

var $fk3RW = parcelRequire("fk3RW");

var $cxrlu = parcelRequire("cxrlu");


var $k510b = parcelRequire("k510b");

var $dFZiU = parcelRequire("dFZiU");

var $cLvqU = parcelRequire("cLvqU");

var $8yk6I = parcelRequire("8yk6I");

var $3YOop = parcelRequire("3YOop");

var $98ifM = parcelRequire("98ifM");

var $5rftB = parcelRequire("5rftB");

var $iORpg = parcelRequire("iORpg");

var $iL8Q7 = parcelRequire("iL8Q7");

var $3kQlF = parcelRequire("3kQlF");

var $fcB4D = parcelRequire("fcB4D");


var $30gU3 = parcelRequire("30gU3");


var $l8uFk = parcelRequire("l8uFk");

/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $9f66c9f2fea9fca2$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $9f66c9f2fea9fca2$var$INTEGRATION_NAME = 'Breadcrumbs';
const $9f66c9f2fea9fca2$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $9f66c9f2fea9fca2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $dFZiU.addConsoleInstrumentationHandler)($9f66c9f2fea9fca2$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $k510b.addClickKeypressInstrumentationHandler)($9f66c9f2fea9fca2$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $3YOop.addXhrInstrumentationHandler)($9f66c9f2fea9fca2$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cLvqU.addFetchInstrumentationHandler)($9f66c9f2fea9fca2$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $8yk6I.addHistoryInstrumentationHandler)($9f66c9f2fea9fca2$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $9f66c9f2fea9fca2$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $9f66c9f2fea9fca2$export$c079d904b326663a = (0, $cxrlu.defineIntegration)($9f66c9f2fea9fca2$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $9f66c9f2fea9fca2$export$2dc68d50d56fbbd = (0, $cxrlu.convertIntegrationFnToClass)($9f66c9f2fea9fca2$var$INTEGRATION_NAME, $9f66c9f2fea9fca2$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $9f66c9f2fea9fca2$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $fk3RW.getClient)() !== client) return;
        (0, $fk3RW.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $5rftB.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $9f66c9f2fea9fca2$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $fk3RW.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $9f66c9f2fea9fca2$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$9f66c9f2fea9fca2$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$9f66c9f2fea9fca2$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $9f66c9f2fea9fca2$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $9f66c9f2fea9fca2$var$_isEvent(event) ? event.target : event;
            target = (0, $98ifM.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $98ifM.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $fk3RW.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $9f66c9f2fea9fca2$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $fk3RW.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $fcB4D.severityLevelFromString)(handlerData.level),
            message: (0, $3kQlF.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $3kQlF.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $fk3RW.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $9f66c9f2fea9fca2$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $fk3RW.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $3YOop.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $fk3RW.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $9f66c9f2fea9fca2$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $fk3RW.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fk3RW.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $fk3RW.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $9f66c9f2fea9fca2$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $fk3RW.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $iL8Q7.parseUrl)((0, $l8uFk.WINDOW).location.href);
        let parsedFrom = from ? (0, $iL8Q7.parseUrl)(from) : undefined;
        const parsedTo = (0, $iL8Q7.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $fk3RW.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $9f66c9f2fea9fca2$var$_isEvent(event) {
    return !!event && !!event.target;
}
module.exports["breadcrumbsIntegration"] = $9f66c9f2fea9fca2$export$c079d904b326663a;

});

parcelRegister("67KXD", function(module, exports) {

var $cxrlu = parcelRequire("cxrlu");


var $iORpg = parcelRequire("iORpg");


var $30gU3 = parcelRequire("30gU3");

const $012693eb311600b8$var$INTEGRATION_NAME = 'Dedupe';
const $012693eb311600b8$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $012693eb311600b8$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($012693eb311600b8$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $012693eb311600b8$export$6d39aa44cd0c7567 = (0, $cxrlu.defineIntegration)($012693eb311600b8$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $012693eb311600b8$export$688d98c249d31ad3 = (0, $cxrlu.convertIntegrationFnToClass)($012693eb311600b8$var$INTEGRATION_NAME, $012693eb311600b8$export$6d39aa44cd0c7567);
function $012693eb311600b8$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($012693eb311600b8$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($012693eb311600b8$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $012693eb311600b8$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$012693eb311600b8$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$012693eb311600b8$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $012693eb311600b8$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $012693eb311600b8$var$_getExceptionFromEvent(previousEvent);
    const currentException = $012693eb311600b8$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$012693eb311600b8$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$012693eb311600b8$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $012693eb311600b8$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $012693eb311600b8$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $012693eb311600b8$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $012693eb311600b8$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $012693eb311600b8$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $012693eb311600b8$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}
module.exports["dedupeIntegration"] = $012693eb311600b8$export$6d39aa44cd0c7567;

});

parcelRegister("FpR3w", function(module, exports) {

var $fk3RW = parcelRequire("fk3RW");

var $cxrlu = parcelRequire("cxrlu");


var $83gx9 = parcelRequire("83gx9");

var $cYIdH = parcelRequire("cYIdH");

var $98ifM = parcelRequire("98ifM");

var $ksWTX = parcelRequire("ksWTX");

var $iORpg = parcelRequire("iORpg");


var $30gU3 = parcelRequire("30gU3");


var $1nill = parcelRequire("1nill");


var $l8uFk = parcelRequire("l8uFk");

/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $07c7e2a98e323d2b$var$INTEGRATION_NAME = 'GlobalHandlers';
const $07c7e2a98e323d2b$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $07c7e2a98e323d2b$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $07c7e2a98e323d2b$var$_installGlobalOnErrorHandler(client);
                $07c7e2a98e323d2b$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $07c7e2a98e323d2b$var$_installGlobalOnUnhandledRejectionHandler(client);
                $07c7e2a98e323d2b$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $07c7e2a98e323d2b$export$66acc70e8cf2b71a = (0, $cxrlu.defineIntegration)($07c7e2a98e323d2b$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $07c7e2a98e323d2b$export$204155decbc90e5a = (0, $cxrlu.convertIntegrationFnToClass)($07c7e2a98e323d2b$var$INTEGRATION_NAME, $07c7e2a98e323d2b$export$66acc70e8cf2b71a);
function $07c7e2a98e323d2b$var$_installGlobalOnErrorHandler(client) {
    (0, $83gx9.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $07c7e2a98e323d2b$var$getOptions();
        if ((0, $fk3RW.getClient)() !== client || (0, $l8uFk.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $ksWTX.isString)(msg) ? $07c7e2a98e323d2b$var$_eventFromIncompleteOnError(msg, url, line, column) : $07c7e2a98e323d2b$var$_enhanceEventWithInitialFrame((0, $1nill.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $fk3RW.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $07c7e2a98e323d2b$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $cYIdH.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $07c7e2a98e323d2b$var$getOptions();
        if ((0, $fk3RW.getClient)() !== client || (0, $l8uFk.shouldIgnoreOnError)()) return;
        const error = $07c7e2a98e323d2b$var$_getUnhandledRejectionError(e);
        const event = (0, $ksWTX.isPrimitive)(error) ? $07c7e2a98e323d2b$var$_eventFromRejectionWithPrimitive(error) : (0, $1nill.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $fk3RW.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $07c7e2a98e323d2b$var$_getUnhandledRejectionError(error) {
    if ((0, $ksWTX.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $07c7e2a98e323d2b$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $07c7e2a98e323d2b$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $ksWTX.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $07c7e2a98e323d2b$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $07c7e2a98e323d2b$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $ksWTX.isString)(url) && url.length > 0 ? url : (0, $98ifM.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $07c7e2a98e323d2b$var$globalHandlerLog(type) {
    (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).log(`Global Handler attached: ${type}`);
}
function $07c7e2a98e323d2b$var$getOptions() {
    const client = (0, $fk3RW.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
module.exports["globalHandlersIntegration"] = $07c7e2a98e323d2b$export$66acc70e8cf2b71a;

});

parcelRegister("7mD6d", function(module, exports) {

var $cxrlu = parcelRequire("cxrlu");


var $l8uFk = parcelRequire("l8uFk");

const $55c8eac6b4bf3fee$var$INTEGRATION_NAME = 'HttpContext';
const $55c8eac6b4bf3fee$var$_httpContextIntegration = ()=>{
    return {
        name: $55c8eac6b4bf3fee$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $l8uFk.WINDOW).navigator && !(0, $l8uFk.WINDOW).location && !(0, $l8uFk.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $l8uFk.WINDOW).location && (0, $l8uFk.WINDOW).location.href;
            const { referrer: referrer } = (0, $l8uFk.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $l8uFk.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $55c8eac6b4bf3fee$export$1378794447170364 = (0, $cxrlu.defineIntegration)($55c8eac6b4bf3fee$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $55c8eac6b4bf3fee$export$5d2ee9a544b09a94 = (0, $cxrlu.convertIntegrationFnToClass)($55c8eac6b4bf3fee$var$INTEGRATION_NAME, $55c8eac6b4bf3fee$export$1378794447170364);
module.exports["httpContextIntegration"] = $55c8eac6b4bf3fee$export$1378794447170364;

});

parcelRegister("84v01", function(module, exports) {

var $cxrlu = parcelRequire("cxrlu");


var $8zgLE = parcelRequire("8zgLE");


var $1nill = parcelRequire("1nill");

const $5e06be45d74b1684$var$DEFAULT_KEY = 'cause';
const $5e06be45d74b1684$var$DEFAULT_LIMIT = 5;
const $5e06be45d74b1684$var$INTEGRATION_NAME = 'LinkedErrors';
const $5e06be45d74b1684$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $5e06be45d74b1684$var$DEFAULT_LIMIT;
    const key = options.key || $5e06be45d74b1684$var$DEFAULT_KEY;
    return {
        name: $5e06be45d74b1684$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $8zgLE.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $1nill.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $5e06be45d74b1684$export$ebabb00eb7f3a395 = (0, $cxrlu.defineIntegration)($5e06be45d74b1684$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $5e06be45d74b1684$export$8d1e60aaf616fb4f = (0, $cxrlu.convertIntegrationFnToClass)($5e06be45d74b1684$var$INTEGRATION_NAME, $5e06be45d74b1684$export$ebabb00eb7f3a395);
module.exports["linkedErrorsIntegration"] = $5e06be45d74b1684$export$ebabb00eb7f3a395;

});

parcelRegister("7D0m1", function(module, exports) {

var $cxrlu = parcelRequire("cxrlu");


var $9jlA0 = parcelRequire("9jlA0");

var $aNFX0 = parcelRequire("aNFX0");


var $l8uFk = parcelRequire("l8uFk");

const $58dc7344989dfa62$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $58dc7344989dfa62$var$INTEGRATION_NAME = 'TryCatch';
const $58dc7344989dfa62$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $58dc7344989dfa62$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $9jlA0.fill)((0, $l8uFk.WINDOW), 'setTimeout', $58dc7344989dfa62$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $9jlA0.fill)((0, $l8uFk.WINDOW), 'setInterval', $58dc7344989dfa62$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $9jlA0.fill)((0, $l8uFk.WINDOW), 'requestAnimationFrame', $58dc7344989dfa62$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $l8uFk.WINDOW)) (0, $9jlA0.fill)(XMLHttpRequest.prototype, 'send', $58dc7344989dfa62$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $58dc7344989dfa62$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($58dc7344989dfa62$var$_wrapEventTarget);
            }
        }
    };
};
const $58dc7344989dfa62$export$59bfe9f1c76150e = (0, $cxrlu.defineIntegration)($58dc7344989dfa62$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $58dc7344989dfa62$export$f1a018517668e6d3 = (0, $cxrlu.convertIntegrationFnToClass)($58dc7344989dfa62$var$INTEGRATION_NAME, $58dc7344989dfa62$export$59bfe9f1c76150e);
function $58dc7344989dfa62$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $l8uFk.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $aNFX0.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $58dc7344989dfa62$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $l8uFk.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $aNFX0.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $58dc7344989dfa62$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $9jlA0.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $aNFX0.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $9jlA0.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $aNFX0.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $l8uFk.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $58dc7344989dfa62$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $l8uFk.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $9jlA0.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $l8uFk.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $aNFX0.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $l8uFk.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $aNFX0.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $9jlA0.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}
module.exports["browserApiErrorsIntegration"] = $58dc7344989dfa62$export$59bfe9f1c76150e;

});

parcelRegister("4wHYU", function(module, exports) {

var $lp3BG = parcelRequire("lp3BG");


var $aFDzs = parcelRequire("aFDzs");


var $dX1oA = parcelRequire("dX1oA");

/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $34bc4459413220ff$export$b2311068c46d7cc8(options, nativeFetch = (0, $dX1oA.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $dX1oA.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $aFDzs.rejectedSyncPromise)(e);
        }
    }
    return (0, $lp3BG.createTransport)(options, makeRequest);
}
module.exports["makeFetchTransport"] = $34bc4459413220ff$export$b2311068c46d7cc8;

});

parcelRegister("dX1oA", function(module, exports) {

var $9Z77k = parcelRequire("9Z77k");

var $iORpg = parcelRequire("iORpg");


var $30gU3 = parcelRequire("30gU3");


var $l8uFk = parcelRequire("l8uFk");

let $a281de31ae38d3d7$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $a281de31ae38d3d7$export$8be2119ce08e3379() {
    if ($a281de31ae38d3d7$var$cachedFetchImpl) return $a281de31ae38d3d7$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $9Z77k.isNativeFetch)((0, $l8uFk.WINDOW).fetch)) return $a281de31ae38d3d7$var$cachedFetchImpl = (0, $l8uFk.WINDOW).fetch.bind((0, $l8uFk.WINDOW));
    const document = (0, $l8uFk.WINDOW).document;
    let fetchImpl = (0, $l8uFk.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $30gU3.DEBUG_BUILD) && (0, $iORpg.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $a281de31ae38d3d7$var$cachedFetchImpl = fetchImpl.bind((0, $l8uFk.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $a281de31ae38d3d7$export$d499686d2dd738c6() {
    $a281de31ae38d3d7$var$cachedFetchImpl = undefined;
}
module.exports["getNativeFetchImplementation"] = $a281de31ae38d3d7$export$8be2119ce08e3379;
module.exports["clearCachedFetchImplementation"] = $a281de31ae38d3d7$export$d499686d2dd738c6;

});

parcelRegister("6di8y", function(module, exports) {

var $lp3BG = parcelRequire("lp3BG");


var $aFDzs = parcelRequire("aFDzs");

/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $4862069faeaaf4a6$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $4862069faeaaf4a6$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $aFDzs.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $4862069faeaaf4a6$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $lp3BG.createTransport)(options, makeRequest);
}
module.exports["makeXHRTransport"] = $4862069faeaaf4a6$export$5e1441cee30d5a39;

});

parcelRegister("ekTM6", function(module, exports) {
/**
 * ------------------------------------------------------------------
 * BFF Error Classes
 * Shared error handling for BFF operations / observability
 * ------------------------------------------------------------------
 */ var $9663994a5f61efe1$export$7d83cc20f4070394 = /*#__PURE__*/ function(BFFErrorEnum) {
    BFFErrorEnum["BFF_ERROR"] = "BFF_ERROR";
    BFFErrorEnum["BFF_NETWORK_ERROR"] = "BFF_NETWORK_ERROR";
    return BFFErrorEnum;
}({});
class $9663994a5f61efe1$export$c6a4f8515f74c5c8 extends Error {
    constructor(message, context){
        super(message);
        this.context = void 0;
        this.originalError = void 0;
        this.status = void 0;
        this.timestamp = void 0;
        this.name = "BFF_ERROR";
        this.context = context.additionalContext;
        this.originalError = context.originalError;
        this.status = context.status;
        this.timestamp = new Date().toISOString();
    }
}
class $9663994a5f61efe1$export$f4de77e3e154579c extends $9663994a5f61efe1$export$c6a4f8515f74c5c8 {
    constructor(message, context){
        super(message, context);
        this.url = void 0;
        this.name = "BFF_NETWORK_ERROR";
        this.url = context.url;
    }
}
module.exports["BFFError"] = $9663994a5f61efe1$export$c6a4f8515f74c5c8;
module.exports["BFFNetworkError"] = $9663994a5f61efe1$export$f4de77e3e154579c;

});

parcelRegister("l2piV", function(module, exports) {

var $cXRzA = parcelRequire("cXRzA");


var $3sWwH = parcelRequire("3sWwH");

function $73b93a3ecab567a4$export$57570b1603cf6adb(env) {
    if (env) return env;
    if (typeof window === 'undefined' || !window.location) return (0, $3sWwH.Environment).Unknown;
    const host = window.location.hostname.toLowerCase();
    // Fast path: exact hostname matches
    const exactMatch = (0, $cXRzA.EXACT_HOST_MAP)[host];
    if (exactMatch) return exactMatch;
    // Extract TLD for efficient branching (find last dot position)
    const lastDot = host.lastIndexOf('.');
    if (lastDot === -1) return (0, $3sWwH.Environment).Unknown;
    const tld = host.slice(lastDot + 1); // 'com', 'net', etc.
    // Branch by TLD to reduce checks
    switch(tld){
        case 'com':
            return $73b93a3ecab567a4$var$classifyComDomain(host);
        case 'net':
            return $73b93a3ecab567a4$var$classifyNetDomain(host);
        default:
            return (0, $3sWwH.Environment).Unknown;
    }
}
/**
 * Classify .com domains
 */ function $73b93a3ecab567a4$var$classifyComDomain(host) {
    // jira-dev.com (staging)
    if (host.endsWith('.jira-dev.com')) return (0, $3sWwH.Environment).Staging;
    // atlassian-us-gov-mod.com (FedRAMP)
    if (host.endsWith('.atlassian-us-gov-mod.com')) {
        // FedRAMP Bifrost CDN: check most specific first
        if (host.endsWith('.frontend.cdn.atlassian-us-gov-mod.com')) return host.includes('.stg.') ? (0, $3sWwH.Environment).Staging : (0, $3sWwH.Environment).Prod;
        if (host.endsWith('.stg.atlassian-us-gov-mod.com')) return (0, $3sWwH.Environment).Staging;
        return (0, $3sWwH.Environment).Prod;
    }
    // atlassian.com domains
    if (host.endsWith('.atlassian.com')) {
        // services.atlassian.com vanity domains (check most specific first)
        if (host.endsWith('.dev.services.atlassian.com')) return (0, $3sWwH.Environment).Development;
        if (host.endsWith('.staging.services.atlassian.com')) return (0, $3sWwH.Environment).Staging;
        if (host.endsWith('.services.atlassian.com')) return (0, $3sWwH.Environment).Prod;
        // Environment-specific subdomains
        if (host.endsWith('.dev.atlassian.com')) return (0, $3sWwH.Environment).Development;
        if (host.endsWith('.stg.atlassian.com')) return (0, $3sWwH.Environment).Staging;
        return (0, $3sWwH.Environment).Prod;
    }
    return (0, $3sWwH.Environment).Unknown;
}
/**
 * Classify .net domains
 */ function $73b93a3ecab567a4$var$classifyNetDomain(host) {
    // atlassian.net (prod tenants)
    if (host.endsWith('.atlassian.net')) return (0, $3sWwH.Environment).Prod;
    // atl-paas-us-gov-mod.net (FedRAMP Micros)
    if (host.endsWith('.atl-paas-us-gov-mod.net')) {
        if (host.includes('.staging.')) return (0, $3sWwH.Environment).Staging;
        if (host.includes('.prod.')) return (0, $3sWwH.Environment).Prod;
        return (0, $3sWwH.Environment).Unknown;
    }
    // atl-paas.net (commercial Micros and Bifrost)
    if (host.endsWith('.atl-paas.net')) {
        // Bifrost commercial: check most specific first
        if (host.endsWith('.frontend.public.atl-paas.net')) {
            if (host.includes('.ddev.') || host.includes('.dev-west2.')) return (0, $3sWwH.Environment).Development;
            if (host.includes('.stg-east.')) return (0, $3sWwH.Environment).Staging;
            if (host.includes('.prod-east.')) return (0, $3sWwH.Environment).Prod;
            return (0, $3sWwH.Environment).Development;
        }
        // Micros commercial
        if (host.includes('.dev.') || host.includes('.platdev.')) return (0, $3sWwH.Environment).Development;
        if (host.includes('.staging.')) return (0, $3sWwH.Environment).Staging;
        if (host.includes('.prod.')) return (0, $3sWwH.Environment).Prod;
    }
    return (0, $3sWwH.Environment).Unknown;
}
module.exports["getEnvironment"] = $73b93a3ecab567a4$export$57570b1603cf6adb;

});

parcelRegister("cXRzA", function(module, exports) {

var $3sWwH = parcelRequire("3sWwH");

const $3db854109edfe2af$export$636c0c57a2ce36e9 = {
    localhost: (0, $3sWwH.Environment).Development,
    '127.0.0.1': (0, $3sWwH.Environment).Development,
    'id.atlassian.com': (0, $3sWwH.Environment).Prod,
    'admin.atlassian.com': (0, $3sWwH.Environment).Prod,
    'id.stg.internal.atlassian.com': (0, $3sWwH.Environment).Staging,
    'admin.stg.atlassian.com': (0, $3sWwH.Environment).Staging
};
module.exports["EXACT_HOST_MAP"] = $3db854109edfe2af$export$636c0c57a2ce36e9;

});

parcelRegister("3sWwH", function(module, exports) {
var $f4fa7dedb54d075c$export$7dc6752a22ab011a = /*#__PURE__*/ function(Environment) {
    Environment["Development"] = "development";
    Environment["Staging"] = "staging";
    Environment["Prod"] = "prod";
    Environment["Unknown"] = "unknown";
    return Environment;
}({});
module.exports["Environment"] = $f4fa7dedb54d075c$export$7dc6752a22ab011a;

});

parcelRegister("8OtrY", function(module, exports) {
// Navigation-experience Sentry DSN
const $6492eee3ae5f6cb2$export$6faa4a850bc4d0ce = 'https://b8c4ebbdd822beb92561fea2a46d2146@o55978.ingest.us.sentry.io/4510463033081856';
const $6492eee3ae5f6cb2$export$eafddbd5a5d6fa6a = 'afe-navigation-experience';
const $6492eee3ae5f6cb2$export$52d764e0fd2a1dc5 = {
    whitelistUrls: [
        /atl-paas.net/,
        /localhost/
    ],
    ignoreErrors: [
        /^SentryIgnore:/
    ],
    ignoreUrls: [
        /extensions\//i,
        /^chrome:\/\//i
    ],
    attachStacktrace: true
};
const $6492eee3ae5f6cb2$export$9f448e5ee63d7699 = 'navigation';
module.exports["SENTRY_DSN"] = $6492eee3ae5f6cb2$export$6faa4a850bc4d0ce;
module.exports["SENTRY_TEAM_NAME"] = $6492eee3ae5f6cb2$export$eafddbd5a5d6fa6a;
module.exports["DEFAULT_SENTRY_CONFIG"] = $6492eee3ae5f6cb2$export$52d764e0fd2a1dc5;
module.exports["SENTRY_PRODUCT"] = $6492eee3ae5f6cb2$export$9f448e5ee63d7699;

});

parcelRegister("jjCkw", function(module, exports) {
const $38e5614694cf6bb5$export$373682275c03fc63 = 'universal-create';
const $38e5614694cf6bb5$export$4fbca0e866deff63 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button-target`;
const $38e5614694cf6bb5$export$3f4cc858c0cb6e84 = `${$38e5614694cf6bb5$export$373682275c03fc63}-trigger-button`;
const $38e5614694cf6bb5$export$85183a312807388d = 'navigation';
const $38e5614694cf6bb5$export$4e49778ae689b92a = 3;
const $38e5614694cf6bb5$export$c2ae99333adf8094 = 'universal-create';
const $38e5614694cf6bb5$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $38e5614694cf6bb5$export$441df76988f6d01 = 344;
const $38e5614694cf6bb5$export$d268f31a83479f83 = 'sm';
const $38e5614694cf6bb5$export$aca7035f4c6a6c0b = -1;
module.exports["PACKAGE_PREFIX"] = $38e5614694cf6bb5$export$373682275c03fc63;
module.exports["TRIGGER_BUTTON_TEST_ID"] = $38e5614694cf6bb5$export$3f4cc858c0cb6e84;
module.exports["MAX_ALLOWED_SECTIONS"] = $38e5614694cf6bb5$export$4e49778ae689b92a;
module.exports["SOURCE_LOCATION"] = $38e5614694cf6bb5$export$c2ae99333adf8094;
module.exports["REQUIRED_USER_ITEMS"] = $38e5614694cf6bb5$export$4c7df19e787d8989;
module.exports["MAX_MENU_HEIGHT"] = $38e5614694cf6bb5$export$441df76988f6d01;
module.exports["RESPONSIVE_BREAKPOINT"] = $38e5614694cf6bb5$export$d268f31a83479f83;
module.exports["PRIMARY_ACTION_ITEM_INDEX"] = $38e5614694cf6bb5$export$aca7035f4c6a6c0b;

});

parcelRegister("VSkIN", function(module, exports) {
function $d27513c3e3d1447c$export$270a88864b52a4aa(items) {
    if (Array.isArray(items)) return items.every((item)=>{
        return typeof item === 'object' && item !== null && 'ati' in item;
    });
    return false;
}
function $d27513c3e3d1447c$export$badb391c957852f7(items) {
    const mixedItems = [];
    if ($d27513c3e3d1447c$export$270a88864b52a4aa(items)) mixedItems.push({
        items: items
    });
    else mixedItems.push(...items);
    return mixedItems;
}
function $d27513c3e3d1447c$export$5a8ab32aeea5694f(items, selectedItem) {
    for (const namedItem of items)for (const menuItem of namedItem.items){
        if (menuItem.ati.toString() === selectedItem.toString()) return menuItem;
    }
    return null;
}
function $d27513c3e3d1447c$export$1ed1ee46541b3e7a(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItemV2 have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $d27513c3e3d1447c$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}
module.exports["useNormalizeItems"] = $d27513c3e3d1447c$export$badb391c957852f7;
module.exports["findSelectedItem"] = $d27513c3e3d1447c$export$5a8ab32aeea5694f;
module.exports["findSelectedItemV2"] = $d27513c3e3d1447c$export$1ed1ee46541b3e7a;
module.exports["extractNativeAtis"] = $d27513c3e3d1447c$export$911e33c48adcec1b;

});

parcelRegister("3Qm0K", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

/* GicIssueCreateModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");





var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $dpPtd = parcelRequire("dpPtd");


var $cvXh8 = parcelRequire("cvXh8");


var $8tdj3 = parcelRequire("8tdj3");


var $a3fRD = parcelRequire("a3fRD");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");


var $u9agA = parcelRequire("u9agA");


var $1FnR2 = parcelRequire("1FnR2");





var $9DI9J = parcelRequire("9DI9J");


var $3ebuO = parcelRequire("3ebuO");


var $a2FWS = parcelRequire("a2FWS");

const $7daa724bead27686$var$JIRA_ITEM_PRODUCT = 'jira';
function $7daa724bead27686$export$c2b496443464407c({ product: product, subProduct: subProduct, isCrossAppCreate: isCrossAppCreate = false }) {
    const { fireObjectCreatedResult: fireObjectCreatedResult, fireFormControlAttributes: fireFormControlAttributes, fireFlagControlAttributes: fireFlagControlAttributes } = (0, $3ebuO.usePlatformCreateAnalytics)();
    const modalViewedRef = (0, $42omo.useRef)(false);
    // Fire "create modal viewed" analytics once per mount.
    (0, $42omo.useEffect)(function fireModalViewAnalytics() {
        if (!modalViewedRef.current) {
            fireFormControlAttributes({
                ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                    itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                    sourceProduct: product,
                    sourceSubProduct: subProduct
                }),
                itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
                action: 'viewed',
                actionSubjectId: 'createModal',
                crossAppCreation: isCrossAppCreate
            });
            modalViewedRef.current = true;
        }
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireCreateSuccessAnalytics = (0, $42omo.useCallback)(()=>{
        fireObjectCreatedResult({
            actionSubjectId: 'universalCreateGicCreation',
            result: 'success',
            itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
            crossAppCreation: isCrossAppCreate,
            sourceProduct: product,
            sourceSubProduct: subProduct
        });
    }, [
        fireObjectCreatedResult,
        product,
        isCrossAppCreate,
        subProduct
    ]);
    const fireCreateFailureAnalytics = (0, $42omo.useCallback)(()=>{
        fireObjectCreatedResult({
            actionSubjectId: 'universalCreateGicCreation',
            result: 'failed',
            itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
            crossAppCreation: isCrossAppCreate,
            sourceProduct: product,
            sourceSubProduct: subProduct
        });
    }, [
        fireObjectCreatedResult,
        product,
        isCrossAppCreate,
        subProduct
    ]);
    const fireModalCloseAnalytics = (0, $42omo.useCallback)(()=>{
        fireFormControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            action: 'dismissed',
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createGicModal',
            crossAppCreation: isCrossAppCreate
        });
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireGicCloseAnalytics = (0, $42omo.useCallback)((isCreateSuccess)=>{
        fireFormControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            action: 'dismissed',
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createGicForm',
            crossAppCreation: isCrossAppCreate,
            isCreateSuccess: isCreateSuccess
        });
    }, [
        fireFormControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireOpenInJiraClickAnalytics = (0, $42omo.useCallback)(()=>{
        fireFlagControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createModalOpenInJiraLink',
            crossAppCreation: isCrossAppCreate,
            flagName: 'issueCreateSuccess'
        });
    }, [
        fireFlagControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    const fireCopyLinkClickAnalytics = (0, $42omo.useCallback)(()=>{
        fireFlagControlAttributes({
            ...(0, $a2FWS.getBaseFormControlAnalyticsAttributes)({
                itemAti: (0, $9DI9J.ATI_PRESETS).WORK_ITEM,
                sourceProduct: product,
                sourceSubProduct: subProduct
            }),
            itemProduct: $7daa724bead27686$var$JIRA_ITEM_PRODUCT,
            actionSubjectId: 'createModalCopyLinkButton',
            crossAppCreation: isCrossAppCreate,
            flagName: 'issueCreateSuccess'
        });
    }, [
        fireFlagControlAttributes,
        isCrossAppCreate,
        product,
        subProduct
    ]);
    return {
        fireCreateSuccessAnalytics: fireCreateSuccessAnalytics,
        fireCreateFailureAnalytics: fireCreateFailureAnalytics,
        fireModalCloseAnalytics: fireModalCloseAnalytics,
        fireGicCloseAnalytics: fireGicCloseAnalytics,
        fireCopyLinkClickAnalytics: fireCopyLinkClickAnalytics,
        fireOpenInJiraClickAnalytics: fireOpenInJiraClickAnalytics
    };
}


const $269cc376e7d8813d$var$styles = {
    issueCreateWrapper: "_4t3i6oy7 _1e0c11p5 _1jyk815d"
};
const $269cc376e7d8813d$var$messages = (0, $cgtv4.defineMessages)({
    title: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.create-title",
        defaultMessage: "Create work item"
    },
    successFlagTitle: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.success-flag-title",
        defaultMessage: "Created {issueKey}"
    },
    openInJira: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.open-in-jira",
        defaultMessage: "Open in Jira"
    },
    workItemErrorFlagTitle: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-title",
        defaultMessage: "We couldn't create your work item"
    },
    workItemErrorFlagDescription: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description",
        defaultMessage: "There was an error while creating your work item. Please try again."
    },
    workItemErrorFlagDescriptionThirdPartyCookies: {
        id: "platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description-third-party-cookies",
        defaultMessage: "There was an error while creating your work item. Please enable third party cookies and try again."
    }
});

const $269cc376e7d8813d$var$GicAnywhere = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("4Lbky")).then((module)=>({
            default: module.GicAnywhere
        })));
/**
 * Default configuration for GIC that hides the site picker.
 * This is used when displaySitePicker should be false as per the ticket requirement.
 */ const $269cc376e7d8813d$var$DEFAULT_GIC_CONFIGURATION = {
    displaySitePicker: false
};
function $269cc376e7d8813d$export$d9ec5138ae1be3bf({ cloudId: cloudId, consumer: consumer = 'universalCreate', product: product, subProduct: subProduct, isCrossAppCreate: isCrossAppCreate, isOpen: isOpen, onClose: onClose, onFailure: onFailure, onInit: onInit, onSuccess: onSuccess }) {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showFlag: showFlag } = (0, $dpPtd.useFlags)();
    const flagCounterRef = (0, $42omo.useRef)(0);
    const { fireModalCloseAnalytics: fireModalCloseAnalytics, fireGicCloseAnalytics: fireGicCloseAnalytics, fireCreateSuccessAnalytics: fireCreateSuccessAnalytics, fireCreateFailureAnalytics: fireCreateFailureAnalytics, fireOpenInJiraClickAnalytics: fireOpenInJiraClickAnalytics } = (0, $7daa724bead27686$export$c2b496443464407c)({
        product: product,
        subProduct: subProduct,
        isCrossAppCreate: isCrossAppCreate
    });
    const showSuccessFlag = (0, $42omo.useCallback)((payload)=>{
        showFlag({
            id: `gic-issue-create-success-${flagCounterRef.current += 1}`,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
                color: "var(--ds-icon-success, #6A9A23)",
                label: "",
                spacing: "spacious"
            }),
            title: formatMessage($269cc376e7d8813d$var$messages.successFlagTitle, {
                issueKey: payload.issueKey
            }),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            formatMessage($269cc376e7d8813d$var$messages.openInJira),
                            ' ',
                            /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                label: "",
                                color: "currentColor"
                            })
                        ]
                    }),
                    href: payload.link,
                    onClick: ()=>{
                        fireOpenInJiraClickAnalytics();
                    }
                }
            ]
        });
    }, [
        showFlag,
        formatMessage,
        fireOpenInJiraClickAnalytics
    ]);
    const handleGicInit = (0, $42omo.useCallback)(()=>{
        onInit?.();
    }, [
        onInit
    ]);
    const handleModalClose = (0, $42omo.useCallback)(()=>{
        fireModalCloseAnalytics();
        onClose?.();
    }, [
        fireModalCloseAnalytics,
        onClose
    ]);
    const handleGicClose = (0, $42omo.useCallback)((isCreateSuccess)=>{
        fireGicCloseAnalytics(isCreateSuccess);
        onClose?.(isCreateSuccess);
    }, [
        fireGicCloseAnalytics,
        onClose
    ]);
    const handleGicSuccess = (0, $42omo.useCallback)((payload)=>{
        fireCreateSuccessAnalytics();
        showSuccessFlag(payload);
        onSuccess?.(payload);
    }, [
        fireCreateSuccessAnalytics,
        onSuccess,
        showSuccessFlag
    ]);
    const handleGicFailure = (0, $42omo.useCallback)((error)=>{
        showFlag({
            id: `gic-issue-create-error-${flagCounterRef.current += 1}`,
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
                label: "",
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "spacious"
            }),
            title: formatMessage($269cc376e7d8813d$var$messages.workItemErrorFlagTitle),
            description: formatMessage($269cc376e7d8813d$var$messages.workItemErrorFlagDescription),
            isAutoDismiss: true
        });
        fireCreateFailureAnalytics();
        onFailure?.(error);
    }, [
        onFailure,
        showFlag,
        formatMessage,
        fireCreateFailureAnalytics
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
        children: isOpen && /*#__PURE__*/ (0, $l998X.jsxs)((0, $8CZUH.default), {
            onClose: ()=>handleModalClose(),
            width: "large",
            shouldScrollInViewport: true,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                    hasCloseButton: true,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                        children: formatMessage($269cc376e7d8813d$var$messages.title)
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1DHa6.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        className: (0, $gMc0m.default)([
                            $269cc376e7d8813d$var$styles.issueCreateWrapper
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, $l998X.jsx)($269cc376e7d8813d$var$GicAnywhere, {
                                cloudId: cloudId,
                                consumer: consumer,
                                summary: "",
                                configuration: $269cc376e7d8813d$var$DEFAULT_GIC_CONFIGURATION,
                                onInit: handleGicInit,
                                onClose: handleGicClose,
                                onSuccess: handleGicSuccess,
                                onFailure: handleGicFailure,
                                isPayloadReady: true
                            })
                        })
                    })
                })
            ]
        })
    });
}
function $269cc376e7d8813d$export$add83b67a410a424(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1FnR2.AsyncIntlProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dpPtd.FlagsProvider), {
            children: /*#__PURE__*/ (0, $l998X.jsx)($269cc376e7d8813d$export$d9ec5138ae1be3bf, {
                ...props
            })
        })
    });
}



var $19BZl = parcelRequire("19BZl");

const $45e2cc33455f22a7$var$GicModalContext = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $45e2cc33455f22a7$export$212673996097ff74 = ()=>{
    const context = (0, $42omo.useContext)($45e2cc33455f22a7$var$GicModalContext);
    if (context === null) throw new Error('useGicModal must be used within a GicModalProvider');
    return context;
};
const $45e2cc33455f22a7$export$3dc00ad9a457ac24 = ({ children: children })=>{
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const { crossAppCreationConfig: crossAppCreationConfig, product: product, subProduct: subProduct } = (0, $19BZl.useUniversalCreateState)();
    const cloudId = crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : null;
    const openGicModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(true);
    }, []);
    const handleCloseGicModal = (0, $42omo.useCallback)(()=>{
        setIsModalOpen(false);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            openGicModal: openGicModal
        }), [
        openGicModal
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)($45e2cc33455f22a7$var$GicModalContext.Provider, {
        value: contextValue,
        children: [
            children,
            cloudId && /*#__PURE__*/ (0, $l998X.jsx)((0, $269cc376e7d8813d$export$add83b67a410a424), {
                cloudId: cloudId,
                product: product,
                subProduct: subProduct,
                // This should always be true in cross-app creation flow
                isCrossAppCreate: true,
                isOpen: isModalOpen,
                onClose: handleCloseGicModal
            })
        ]
    });
};
module.exports["useGicModal"] = $45e2cc33455f22a7$export$212673996097ff74;
module.exports["GicModalProvider"] = $45e2cc33455f22a7$export$3dc00ad9a457ac24;

});

parcelRegister("1FnR2", function(module, exports) {
/* AsyncIntlProvider.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $keVvA = parcelRequire("keVvA");


var $kWIfM = parcelRequire("kWIfM");

function $facd1d381551dc6d$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $facd1d381551dc6d$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("gOCKa"));
        case 'da':
            return (parcelRequire("kgS6g"));
        case 'de':
            return (parcelRequire("6FETJ"));
        case 'en-GB':
            return (parcelRequire("eaG2w"));
        case 'en-ZZ':
            return (parcelRequire("jrncK"));
        case 'en':
            return (parcelRequire("kWIfM"));
        case 'es':
            return (parcelRequire("hNXtP"));
        case 'fi':
            return (parcelRequire("jpKHe"));
        case 'fr':
            return (parcelRequire("egD3h"));
        case 'hu':
            return (parcelRequire("gOBa4"));
        case 'it':
            return (parcelRequire("dJGOW"));
        case 'ja':
            return (parcelRequire("91ceq"));
        case 'ko':
            return (parcelRequire("9BUn1"));
        case 'nb':
            return (parcelRequire("kDan3"));
        case 'nl':
            return (parcelRequire("hlN3p"));
        case 'pl':
            return (parcelRequire("cgC9O"));
        case 'pt':
            return (parcelRequire("caMGq"));
        case 'ru':
            return (parcelRequire("iH1Iu"));
        case 'sv':
            return (parcelRequire("anJkS"));
        case 'th':
            return (parcelRequire("22khn"));
        case 'tr':
            return (parcelRequire("4vKIR"));
        case 'uk':
            return (parcelRequire("hwfR8"));
        case 'vi':
            return (parcelRequire("2drle"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("7iRlg"));
        case 'zh':
            return (parcelRequire("efWdi"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $facd1d381551dc6d$export$12346a674644c156 = 'operational';
const $facd1d381551dc6d$export$515664faa1398f37 = 'navigation';
function $facd1d381551dc6d$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $facd1d381551dc6d$var$fetchLanguageFile($facd1d381551dc6d$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $facd1d381551dc6d$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($facd1d381551dc6d$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $kWIfM.default),
        children: children
    });
}
const $facd1d381551dc6d$export$2f688dfcc031530a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($facd1d381551dc6d$var$Provider, {
        children: children
    });
};
module.exports["AsyncIntlProvider"] = $facd1d381551dc6d$export$2f688dfcc031530a;

});

parcelRegister("keVvA", function(module, exports) {
$parcel$export(module.exports, "default", () => $36f6a30267bec70f$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");


var $e9OZ6 = parcelRequire("e9OZ6");


var $5cR9p = parcelRequire("5cR9p");

function $36f6a30267bec70f$export$2e2bcd8739ae039({ loaderFn: loaderFn, children: children, defaultMessages: defaultMessages }) {
    const intl = (0, $5cR9p.useSafeIntl)();
    const messages = (0, $e9OZ6.useMessages)(intl.locale, loaderFn);
    /**
   * IntlProvider does not inherit from upstream IntlProviders,
   * we lookup messages in the context and pass them downstream
   * This prevents the missing messages error
   */ const mergedMessages = (0, $42omo.useMemo)(()=>{
        return {
            ...defaultMessages,
            ...intl.messages,
            ...messages
        };
    }, [
        intl,
        messages,
        defaultMessages
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1e2E5.default), {
        defaultLocale: "en",
        locale: intl.locale,
        onError: intl.onError,
        messages: mergedMessages,
        children: children
    });
}

});

parcelRegister("e9OZ6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hxPth = parcelRequire("hxPth");

const $e1a1ee666860bb23$export$4d17e2d9c5348842 = (locale, loaderFn)=>{
    const [localeState, setLocaleState] = (0, $42omo.useState)((0, $hxPth.DEFAULT_LOCALE_STATE));
    (0, $42omo.useEffect)(()=>{
        if (!localeState.messages || locale !== localeState.locale) {
            let current = true;
            loaderFn(locale).then((messages)=>{
                if (current) setLocaleState({
                    locale: locale,
                    messages: messages ?? {}
                });
            });
            return ()=>{
                current = false;
            };
        }
        return undefined;
    }, [
        loaderFn,
        locale,
        localeState
    ]);
    return localeState.messages;
};
module.exports["useMessages"] = $e1a1ee666860bb23$export$4d17e2d9c5348842;

});

parcelRegister("hxPth", function(module, exports) {
const $b9a0da62d538b640$export$79618bef82c02d4c = {
    locale: 'en',
    messages: {}
};
module.exports["DEFAULT_LOCALE_STATE"] = $b9a0da62d538b640$export$79618bef82c02d4c;

});

parcelRegister("5cR9p", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1e2E5 = parcelRequire("1e2E5");

var $fI8ba = parcelRequire("fI8ba");

var $gmMgo = parcelRequire("gmMgo");


var $hxPth = parcelRequire("hxPth");

// Prevents memory leaks
const $1961b540cbe6be26$var$cache = (0, $fI8ba.createIntlCache)();
const $1961b540cbe6be26$export$f752ac21ea3960a5 = ()=>{
    const context = (0, $42omo.useContext)((0, $gmMgo.Context));
    if (!context) return (0, $1e2E5.createIntl)((0, $hxPth.DEFAULT_LOCALE_STATE), $1961b540cbe6be26$var$cache);
    return context;
};
module.exports["useSafeIntl"] = $1961b540cbe6be26$export$f752ac21ea3960a5;

});

parcelRegister("kWIfM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $165b45057ff7d0ba$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $165b45057ff7d0ba$export$2e2bcd8739ae039 = {
    'platform.navigation-experiences.universal-create-integrations.back': 'Back',
    'platform.navigation-experiences.universal-create-integrations.goal.create-title': 'Create goal',
    'platform.navigation-experiences.universal-create-integrations.goal.create-title-v2': 'Goal',
    'platform.navigation-experiences.universal-create-integrations.issue.copy-link': 'Copy link',
    'platform.navigation-experiences.universal-create-integrations.issue.create-title': 'Create work item',
    'platform.navigation-experiences.universal-create-integrations.issue.open-in-jira': 'Open in Jira',
    'platform.navigation-experiences.universal-create-integrations.issue.success-flag-title': 'Created {issueKey}',
    'platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-description': 'There was an error while creating your work item. Please try again.',
    'platform.navigation-experiences.universal-create-integrations.issue.work-item-error-flag-title': "We couldn't create your work item",
    'platform.navigation-experiences.universal-create-integrations.project.create-title': 'Create project',
    'platform.navigation-experiences.universal-create-integrations.project.create-title-v2': 'Project',
    'platform.navigation-experiences.universal-create-integrations.required-fields-are-marked': 'Required fields are marked with an asterisk <asterisk></asterisk>',
    'platform.navigation-experiences.universal-create-integrations.team.create-title': 'Create team',
    'platform.navigation-experiences.universal-create-integrations.team.create-title-v2': 'Team',
    'universal-create.loom-video-menu-item.share-video': 'Share'
};

});

parcelRegister("gOCKa", function(module, exports) {

let $c3df5e8bf0b44a81$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3df5e8bf0b44a81$var$load("4XOEX").then(()=>parcelRequire('g3tQg'));

});

parcelRegister("kgS6g", function(module, exports) {

let $ec1f44643886dc6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ec1f44643886dc6b$var$load("gqmha").then(()=>parcelRequire('hCifW'));

});

parcelRegister("6FETJ", function(module, exports) {

let $4db64bdd29215e0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4db64bdd29215e0e$var$load("cweX3").then(()=>parcelRequire('cKDAe'));

});

parcelRegister("eaG2w", function(module, exports) {

let $a5129c10588fe984$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a5129c10588fe984$var$load("bai9u").then(()=>parcelRequire('ksQ21'));

});

parcelRegister("jrncK", function(module, exports) {

let $e27289df456bec13$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e27289df456bec13$var$load("9t1Ib").then(()=>parcelRequire('8Fif4'));

});

parcelRegister("hNXtP", function(module, exports) {

let $cf6526c4d6070545$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cf6526c4d6070545$var$load("eHlQ9").then(()=>parcelRequire('6RKnN'));

});

parcelRegister("jpKHe", function(module, exports) {

let $e224930389ece4a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e224930389ece4a9$var$load("6abco").then(()=>parcelRequire('jBm4D'));

});

parcelRegister("egD3h", function(module, exports) {

let $a630da343b6d6b23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a630da343b6d6b23$var$load("fvLDA").then(()=>parcelRequire('fclNH'));

});

parcelRegister("gOBa4", function(module, exports) {

let $c3de2459ee3a56b8$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c3de2459ee3a56b8$var$load("jYjnT").then(()=>parcelRequire('7iOJp'));

});

parcelRegister("dJGOW", function(module, exports) {

let $a000b1a177f404f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a000b1a177f404f7$var$load("6chG6").then(()=>parcelRequire('4o46R'));

});

parcelRegister("91ceq", function(module, exports) {

let $690db206d079dded$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $690db206d079dded$var$load("bXBzb").then(()=>parcelRequire('82cDt'));

});

parcelRegister("9BUn1", function(module, exports) {

let $6ff34bb529d22ed2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ff34bb529d22ed2$var$load("fMgo4").then(()=>parcelRequire('57xzB'));

});

parcelRegister("kDan3", function(module, exports) {

let $f04f7e974ea5a306$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f04f7e974ea5a306$var$load("1HBhy").then(()=>parcelRequire('jMKyM'));

});

parcelRegister("hlN3p", function(module, exports) {

let $ca1a72efc40ba994$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ca1a72efc40ba994$var$load("9YSn1").then(()=>parcelRequire('7pHxv'));

});

parcelRegister("cgC9O", function(module, exports) {

let $8ee493df0ce89edf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ee493df0ce89edf$var$load("40Jja").then(()=>parcelRequire('bEas4'));

});

parcelRegister("caMGq", function(module, exports) {

let $8dcc2ead7a022171$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8dcc2ead7a022171$var$load("ibJOL").then(()=>parcelRequire('ltVvr'));

});

parcelRegister("iH1Iu", function(module, exports) {

let $d9bd930c52a36b5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d9bd930c52a36b5a$var$load("ipGTo").then(()=>parcelRequire('eYQSf'));

});

parcelRegister("anJkS", function(module, exports) {

let $78ef381d406ade9e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $78ef381d406ade9e$var$load("1dEiK").then(()=>parcelRequire('lioXF'));

});

parcelRegister("22khn", function(module, exports) {

let $17bb7fba3f76370b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $17bb7fba3f76370b$var$load("bNIzh").then(()=>parcelRequire('jypAP'));

});

parcelRegister("4vKIR", function(module, exports) {

let $348e4cc97734f269$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $348e4cc97734f269$var$load("bjl5Z").then(()=>parcelRequire('jVD7j'));

});

parcelRegister("hwfR8", function(module, exports) {

let $cc11b97e6ec0b207$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cc11b97e6ec0b207$var$load("7A6MW").then(()=>parcelRequire('asGOa'));

});

parcelRegister("2drle", function(module, exports) {

let $19d2011add1ec057$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19d2011add1ec057$var$load("gu0nB").then(()=>parcelRequire('d0iu1'));

});

parcelRegister("7iRlg", function(module, exports) {

let $5513977223045f44$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5513977223045f44$var$load("2xhtF").then(()=>parcelRequire('hTwBU'));

});

parcelRegister("efWdi", function(module, exports) {

let $a60f9f61761fae66$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a60f9f61761fae66$var$load("iwPoV").then(()=>parcelRequire('8yoE1'));

});

parcelRegister("9DI9J", function(module, exports) {
const $7387c4ee4c968c68$export$85183a312807388d = 'navigation';
const $7387c4ee4c968c68$export$1f0ede2864ffece6 = 'navigationExperiences';
const $7387c4ee4c968c68$export$40fae459cb78b698 = 'global';
const $7387c4ee4c968c68$export$2ee98aa1b18a8f41 = 'top';
const $7387c4ee4c968c68$export$b4ed8a331b8fd4cc = 4;
const $7387c4ee4c968c68$export$f7109619a5e9e0d6 = 'topNav';
const $7387c4ee4c968c68$export$c091fab9d8f83000 = {
    PAGE: 'ati:cloud:confluence:page',
    WHITEBOARD: 'ati:cloud:confluence:whiteboard',
    GOAL: 'ati:cloud:townsquare:goal',
    WORK_ITEM: 'ati:cloud:jira:issue',
    LOOM: 'ati:cloud:loom:video',
    PROJECT: 'ati:cloud:townsquare:project',
    TEAM: 'ati:cloud:townsquare:team',
    TRELLO_BOARD: 'ati:cloud:trello:board'
};
const $7387c4ee4c968c68$export$9449803ae25a1ccd = $7387c4ee4c968c68$export$c091fab9d8f83000.LOOM;
module.exports["ANALYTICS_CHANNEL"] = $7387c4ee4c968c68$export$85183a312807388d;
module.exports["ANALYTICS_TAG"] = $7387c4ee4c968c68$export$1f0ede2864ffece6;
module.exports["NAV_LAYER"] = $7387c4ee4c968c68$export$40fae459cb78b698;
module.exports["NAV_CONTAINER"] = $7387c4ee4c968c68$export$2ee98aa1b18a8f41;
module.exports["NAV_VERSION"] = $7387c4ee4c968c68$export$b4ed8a331b8fd4cc;
module.exports["ANALYTICS_SOURCE"] = $7387c4ee4c968c68$export$f7109619a5e9e0d6;
module.exports["ATI_PRESETS"] = $7387c4ee4c968c68$export$c091fab9d8f83000;

});

parcelRegister("3ebuO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9DI9J = parcelRequire("9DI9J");

function $f9f6c5a9f12e5699$export$5119f9387406ce5a() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION)
        }), []);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'operational',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    const fireObjectCreated = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'created',
            actionSubjectId: 'universalCreateObject',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireObjectCreatedResult = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, result: result, ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'track',
            action: result,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'ui',
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireFlagControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            eventType: 'ui',
            actionSubject: 'universalCreate',
            action: 'clicked',
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireFlagControlAttributes: fireFlagControlAttributes,
        fireObjectCreated: fireObjectCreated,
        fireObjectCreatedResult: fireObjectCreatedResult,
        fireFormControlAttributes: fireFormControlAttributes
    };
}
module.exports["usePlatformCreateAnalytics"] = $f9f6c5a9f12e5699$export$5119f9387406ce5a;

});

parcelRegister("a2FWS", function(module, exports) {
const $37390df0788634a5$export$242c779274b0e3bf = ({ itemAti: itemAti, sourceProduct: sourceProduct, sourceSubProduct: sourceSubProduct })=>({
        itemAti: itemAti,
        itemProduct: 'townsquare',
        sourceProduct: sourceProduct,
        sourceSubProduct: sourceSubProduct
    });
module.exports["getBaseFormControlAnalyticsAttributes"] = $37390df0788634a5$export$242c779274b0e3bf;

});

parcelRegister("4Lbky", function(module, exports) {

let $3774573536b89562$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3774573536b89562$var$load("j47Y5"),
    $3774573536b89562$var$load("ivqr8"),
    $3774573536b89562$var$load("2O2Xv"),
    $3774573536b89562$var$load("8hNVx"),
    $3774573536b89562$var$load("Wowvf"),
    $3774573536b89562$var$load("d34hg")
]).then(()=>parcelRequire('6aRpj'));

});

parcelRegister("7wYo8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $hBkFA = parcelRequire("hBkFA");

function $68a341f15f9dda7b$export$1ff47f24e06a5d2d({ load: load, onLoad: onLoad, onBeforeLoad: onBeforeLoad, loadOnFocus: loadOnFocus = false, preloadOnFocus: preloadOnFocus = false }) {
    const nodeRef = (0, $42omo.useRef)(null);
    const eventListeners = (0, $42omo.useRef)([]);
    const { preloadReference: preloadReference, cancelPreload: cancelPreload, eagerLoad: eagerLoad } = (0, $hBkFA.useEntryPointPreload)(load);
    const clickListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            if (onBeforeLoad) onBeforeLoad();
            onLoad(eagerLoad());
        };
    }, [
        onBeforeLoad,
        onLoad,
        eagerLoad
    ]);
    const mouseDownListener = (0, $42omo.useMemo)(()=>{
        return ()=>{
            eagerLoad();
        };
    }, [
        eagerLoad
    ]);
    const cleanUpEventListeners = (0, $42omo.useCallback)(()=>{
        eventListeners.current.forEach((unbind)=>{
            unbind();
        });
        eventListeners.current = [];
    }, []);
    const addEventListener = (0, $42omo.useCallback)((element, type, callback)=>{
        const unbind = (0, $fFa3V.bind)(element, {
            type: type,
            listener: callback
        });
        eventListeners.current.push(unbind);
    }, []);
    const refCallback = (0, $42omo.useCallback)((element)=>{
        if (element !== nodeRef.current) {
            if (nodeRef.current) {
                cancelPreload();
                cleanUpEventListeners();
            }
            if (element) {
                addEventListener(element, 'click', clickListener);
                addEventListener(element, 'mousedown', mouseDownListener);
                addEventListener(element, 'mouseenter', preloadReference);
                addEventListener(element, 'mouseleave', cancelPreload);
                if (loadOnFocus) addEventListener(element, 'focusin', clickListener);
                else if (preloadOnFocus) {
                    addEventListener(element, 'focusin', preloadReference);
                    addEventListener(element, 'focusout', cancelPreload);
                }
            }
            // Update the ref with the new element
            nodeRef.current = element;
        }
    }, [
        clickListener,
        mouseDownListener,
        preloadReference,
        cancelPreload,
        loadOnFocus,
        addEventListener,
        cleanUpEventListeners,
        preloadOnFocus
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            cleanUpEventListeners();
        };
    }, [
        cleanUpEventListeners
    ]);
    return refCallback;
}
module.exports["usePressablePreloadRef"] = $68a341f15f9dda7b$export$1ff47f24e06a5d2d;

});

parcelRegister("hBkFA", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $b7a3f72174bcd512$var$PRELOAD_MAX_AGE = 300000; // 5 mins
const $b7a3f72174bcd512$var$TIME_TO_INTENT = 200;
function $b7a3f72174bcd512$export$57effc2a5e3611f(load) {
    return (0, $42omo.useMemo)(()=>{
        const request = {};
        const clearPreloadTimeouts = ()=>{
            if (typeof request.preloadIntentTimeout === 'number') {
                clearTimeout(request.preloadIntentTimeout);
                delete request.preloadIntentTimeout;
            }
            if (typeof request.preloadMaxAgeTimeout === 'number') {
                clearTimeout(request.preloadMaxAgeTimeout);
                delete request.preloadMaxAgeTimeout;
            }
        };
        const cancelPreload = ()=>{
            clearPreloadTimeouts();
            request.preload?.dispose();
        };
        const loadReference = ()=>{
            if (request.load) return request.load;
            const reference = request.preload?.reference ?? load();
            if (request.preload) delete request.preload;
            request.load = {
                reference: reference,
                dispose () {
                    reference.dispose();
                    delete request.load;
                }
            };
            return request.load;
        };
        const eagerLoad = ()=>{
            clearPreloadTimeouts();
            return loadReference();
        };
        const preloadReference = ()=>{
            if (request.preloadIntentTimeout || request.preload) return;
            request.preloadIntentTimeout = setTimeout(()=>{
                delete request.preloadIntentTimeout;
                const reference = load();
                request.preload = {
                    reference: reference,
                    dispose () {
                        reference.dispose();
                        delete request.preload;
                    }
                };
                request.preloadMaxAgeTimeout = setTimeout(()=>{
                    delete request.preloadMaxAgeTimeout;
                    request.preload?.dispose();
                }, $b7a3f72174bcd512$var$PRELOAD_MAX_AGE);
            }, $b7a3f72174bcd512$var$TIME_TO_INTENT);
        };
        return {
            preloadReference: preloadReference,
            cancelPreload: cancelPreload,
            eagerLoad: eagerLoad
        };
    }, [
        load
    ]);
}
module.exports["useEntryPointPreload"] = $b7a3f72174bcd512$export$57effc2a5e3611f;

});

parcelRegister("48FEk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $irOoi = parcelRequire("irOoi");


var $eduVw = parcelRequire("eduVw");


var $hNKXO = parcelRequire("hNKXO");


var $4M6GB = parcelRequire("4M6GB");

function $f9885621a7911f5b$var$InternalEntryPointContainerInner({ entryPointReference: entryPointReference, errorFallback: errorFallback, /** Log and track errors */ onError: onErrorLocal, forcedError: forcedError, fallback: /** Loading fallback */ fallback, id: id, placeholderName: placeholderName, runtimeProps: runtimeProps }) {
    const { PlaceholderComponent: PlaceholderComponent } = (0, $4M6GB.useEntryPointConfig)();
    // useUFOReportError needs to be called under correct UFOSegment to work
    const reportErrorUFO = (0, $eduVw.useUFOReportError)();
    const onError = (0, $42omo.useCallback)((error, errorInfo)=>{
        onErrorLocal?.({
            error: error,
            errorInfo: errorInfo
        });
        (0, $hNKXO.reportError)({
            error: error,
            errorInfo: errorInfo,
            interactionId: id
        });
        reportErrorUFO({
            name: id,
            errorMessage: error?.message ?? 'Unknown error',
            errorStack: error?.stack ?? 'Unknown stack',
            forcedError: forcedError
        });
    }, [
        onErrorLocal,
        id,
        reportErrorUFO,
        forcedError
    ]);
    const FallbackComponent = (0, $42omo.useCallback)(({ error: error })=>{
        const onClose = runtimeProps?.onClose ?? (()=>{});
        return errorFallback ? errorFallback({
            error: error,
            onClose: onClose
        }) : null;
    }, [
        errorFallback,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        FallbackComponent: FallbackComponent,
        onError: onError,
        children: /*#__PURE__*/ (0, $l998X.jsx)(PlaceholderComponent, {
            name: placeholderName ?? 'internal-internal-entry-point-container',
            fallback: fallback,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irOoi.EntryPointContainer), {
                entryPointReference: entryPointReference,
                props: runtimeProps
            })
        })
    });
}
function $f9885621a7911f5b$export$5d4dc37edd8a3adb(props) {
    const { id: id } = props;
    const { UFOSegmentComponent: UFOSegmentComponent } = (0, $4M6GB.useEntryPointConfig)();
    return /*#__PURE__*/ (0, $l998X.jsx)(UFOSegmentComponent, {
        name: id,
        children: /*#__PURE__*/ (0, $l998X.jsx)($f9885621a7911f5b$var$InternalEntryPointContainerInner, {
            ...props
        })
    });
}
module.exports["InternalEntryPointContainer"] = $f9885621a7911f5b$export$5d4dc37edd8a3adb;

});

parcelRegister("hNKXO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $e5b5ac7e446444f2$var$buffer = [];
let $e5b5ac7e446444f2$var$push = (payload)=>{
    $e5b5ac7e446444f2$var$buffer.push(payload);
};
function $e5b5ac7e446444f2$export$b33b857ad1d9900e(payload) {
    $e5b5ac7e446444f2$var$push(payload);
}
function $e5b5ac7e446444f2$export$abd5747ea77ecab9(handler) {
    if ((0, $dh538.fg)('moving_jira_entry-points_api_under_platform')) {
        $e5b5ac7e446444f2$var$push = handler;
        $e5b5ac7e446444f2$var$buffer.forEach((payload)=>handler(payload));
        $e5b5ac7e446444f2$var$buffer.length = 0;
    }
}
module.exports["reportError"] = $e5b5ac7e446444f2$export$b33b857ad1d9900e;

});

parcelRegister("4M6GB", function(module, exports) {

var $bniL1 = parcelRequire("bniL1");


var $hnvzE = parcelRequire("hnvzE");

const $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent = (0, $hnvzE.default);
const $a93efc0d5ccefe43$var$entryPointConfig = {
    PlaceholderComponent: (0, $bniL1.default),
    UFOSegmentComponent: $a93efc0d5ccefe43$var$DefaultUFOSegmentComponent,
    ModalErrorFallback: ()=>null
};
function $a93efc0d5ccefe43$export$93a6801f9db838c4(overrides) {
    Object.assign($a93efc0d5ccefe43$var$entryPointConfig, overrides);
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
function $a93efc0d5ccefe43$export$dfa96f26176fa91f() {
    return $a93efc0d5ccefe43$var$entryPointConfig;
}
module.exports["useEntryPointConfig"] = $a93efc0d5ccefe43$export$dfa96f26176fa91f;

});

parcelRegister("7K3dX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9DI9J = parcelRequire("9DI9J");


var $19BZl = parcelRequire("19BZl");

function $c3ddb99f3c87e2eb$export$eebe354ebe67c94c() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { product: product, subProduct: subProduct } = (0, $19BZl.useUniversalCreateState)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const baseAttributes = (0, $42omo.useMemo)(()=>({
            navLayer: (0, $9DI9J.NAV_LAYER),
            navContainer: (0, $9DI9J.NAV_CONTAINER),
            navVersion: (0, $9DI9J.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct
        }), [
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $42omo.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonHovered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'hovered',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireEntryPointLoadTriggered = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            actionSubject: 'universalCreateEntryPointLoad',
            action: 'triggered',
            eventType: 'track',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNativeMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireSuggestionsMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireMenuItemClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNativeMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireSuggestionsMenuViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireMenuItemsViewed = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $42omo.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92730
    const fireShowMoreButtonClicked = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateShowMoreButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/96626
    const fireJSChunkLoadTime = (0, $42omo.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'loaded',
            actionSubject: 'universalCreateJSChunkLoad',
            actionSubjectId: 'universalCreateJSChunkLoad',
            eventType: 'operational',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireCreateButtonHovered: fireCreateButtonHovered,
        fireCreateButtonViewed: fireCreateButtonViewed,
        fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
        fireNativeMenuItemClicked: fireNativeMenuItemClicked,
        fireSuggestionsMenuItemClicked: fireSuggestionsMenuItemClicked,
        fireMenuItemClicked: fireMenuItemClicked,
        fireNativeMenuViewed: fireNativeMenuViewed,
        fireSuggestionsMenuViewed: fireSuggestionsMenuViewed,
        fireMenuItemsViewed: fireMenuItemsViewed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes,
        fireShowMoreButtonClicked: fireShowMoreButtonClicked,
        fireJSChunkLoadTime: fireJSChunkLoadTime
    };
}
module.exports["useUniversalCreateAnalytics"] = $c3ddb99f3c87e2eb$export$eebe354ebe67c94c;

});

parcelRegister("fP8Uu", function(module, exports) {
// ===============================
// UC Suggestions API Communication types
// ===============================

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ekTM6 = parcelRequire("ekTM6");

var $5IDSL = parcelRequire("5IDSL");


var $l7sDu = parcelRequire("l7sDu");


var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");


var $6lFYf = parcelRequire("6lFYf");


var $dG1kO = parcelRequire("dG1kO");


var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const boundaryConfig = (0, $42omo.useMemo)(()=>({
            location: 'useUCSuggestions',
            disableSentry: (0, $dh538.fg)('navx_uc_sentry_enabled') ? false : true,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)(boundaryConfig);
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCRecommendationURL: buildUCRecommendationURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $dG1kO.useGenericCache)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        nativeAtis: nativeAtis,
        excludeAtis: excludeAtis,
        preferredAtis: preferredAtis
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    // We need to set the data from the cache on mount (if applicable)
    // because setting it as the initial state value causes it to
    // return undefined in component usages and not be fetched from the network when expected
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCSuggestions = (0, $42omo.useCallback)(async ()=>{
        // Kill switch: return early if feature flag is disabled
        if (!(0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) return;
        // Early exit: filter out invalid param requests when required identifiers are missing
        if (!cloudId || !orgId) return;
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $l7sDu.createExperienceTracker)('universalCreatePrefetch');
        experience?.start();
        try {
            const url = buildUCRecommendationURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                nativeAtis: nativeAtis,
                excludeAtis: excludeAtis,
                preferredAtis: preferredAtis
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) return;
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFNetworkError)('Failed to fetch universal create suggestions', {
                    url: url,
                    status: response.status,
                    originalError: response.error
                }));
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY));
            }
            if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFError)('Error occurred during fetchUCSuggestions', {
                status: (0, $4jETc.RequestStatus).ERROR,
                originalError: error
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        cachedObject,
        setStatus,
        buildUCRecommendationURL,
        product,
        userId,
        locale,
        subProduct,
        nativeAtis,
        excludeAtis,
        preferredAtis,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('navx_universal_create_cross_app_creation_enabled')) {
            // We check if the current loading requests include UC suggestions rather than the BFF status directly
            // to ensure that it only returns true for UC suggestions and not other BFF requests.
            const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
            // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
            // before running things like onResultChange, so that we don't do those things an unnecessary extra time
            // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
            const hasSuggestionDataBeenReturned = data !== undefined || hasError;
            return isBffLoadingOurStuff && !hasSuggestionDataBeenReturned;
        }
        return currentLoadingRequests?.includes((0, $4jETc.UC_SUGGESTIONS_REQUEST_STATUS_KEY)) ?? false;
    }, [
        currentLoadingRequests,
        data,
        hasError
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCSuggestions: fetchUCSuggestions
    };
}
module.exports["useUCSuggestions"] = $fa4ca6a68a7d4b0f$export$b0f8ffa1c91c3ff2;

});

parcelRegister("l7sDu", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5aVN7 = parcelRequire("5aVN7");

var $24xEE = parcelRequire("24xEE");


var $4rFRN = parcelRequire("4rFRN");

function $eebcb10e5daa907f$var$useUFOExperience(id, config, instanceId) {
    return (0, $42omo.useMemo)(()=>new (0, $5aVN7.UFOExperience)(id, config, instanceId), [
        id,
        config,
        instanceId
    ]);
}
function $eebcb10e5daa907f$export$cdefb2a8b53f879f(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    const experience = $eebcb10e5daa907f$var$useUFOExperience(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
    (0, $24xEE.useUFOComponentExperience)(experience); // this hook starts the experience and aborts it when the component is unmounted
    return experience;
}
function $eebcb10e5daa907f$export$15f9dc99109fec75(key) {
    const experienceObj = (0, $4rFRN.NavigationExperienceId)[key];
    return new (0, $5aVN7.UFOExperience)(experienceObj.experienceId, experienceObj.config, experienceObj.instanceId);
}
module.exports["useExperienceTracker"] = $eebcb10e5daa907f$export$cdefb2a8b53f879f;
module.exports["createExperienceTracker"] = $eebcb10e5daa907f$export$15f9dc99109fec75;

});

parcelRegister("24xEE", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f4e2c76b2dc4439a$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $42omo.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $f4e2c76b2dc4439a$export$30ab340faaed55d4 = (experience)=>{
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $f4e2c76b2dc4439a$var$useConstructor(()=>experience.start());
    return null;
};
module.exports["useUFOComponentExperience"] = $f4e2c76b2dc4439a$export$30ab340faaed55d4;

});

parcelRegister("6lFYf", function(module, exports) {

var $4jETc = parcelRequire("4jETc");


var $cdX3N = parcelRequire("cdX3N");


var $dr83e = parcelRequire("dr83e");

function $1d9cedda3a5081bf$export$f931afb2c5ecf7c7() {
    const host = window.location.host;
    return host.includes('localhost') && host.includes(':');
}
async function $1d9cedda3a5081bf$export$81bec6e38e8b706b(url, init) {
    try {
        const response = await fetch(url, {
            ...init,
            credentials: 'include',
            headers: {
                'Atl-BFF-Payload-Version': (0, $dr83e.default).packageVersion,
                ...init?.headers
            }
        });
        // Validate response status and throw an error for non-OK responses, except for specific cases handled by feature flags.
        if (!response.ok) {
            const isAvailableProductsEndpoint = URL.parse(url)?.pathname.includes((0, $cdX3N.BFFEndpointsEnum).AVAILABLE_PRODUCTS);
            // The Available Products endpoint returns a 403 status code exclusively from blockBotsMiddleware.
            if (response.status === 403 && isAvailableProductsEndpoint) // Return an empty list of sites to prevent pollinator from treating this as a failed request.
            return {
                status: (0, $4jETc.RequestStatus).COMPLETE,
                data: {
                    sites: []
                }
            };
            throw new Error(`Failed to fetch data: ${response.status} ${response.statusText}`);
        }
        const jsonResponse = await response.json();
        return {
            status: (0, $4jETc.RequestStatus).COMPLETE,
            data: jsonResponse
        };
    } catch (e) {
        return {
            status: (0, $4jETc.RequestStatus).ERROR,
            error: e,
            data: null
        };
    }
}
module.exports["fetchJSON"] = $1d9cedda3a5081bf$export$81bec6e38e8b706b;

});

parcelRegister("cdX3N", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4jETc = parcelRequire("4jETc");


var $iAFAo = parcelRequire("iAFAo");


var $6Tx9o = parcelRequire("6Tx9o");


var $7hl58 = parcelRequire("7hl58");


var $6jORV = parcelRequire("6jORV");

var $e5af1279e152c705$export$92af951f33a9009c = /*#__PURE__*/ function(BFFEndpointsEnum) {
    BFFEndpointsEnum["AVAILABLE_PRODUCTS"] = "/gateway/api/app-switcher/api/available-products";
    BFFEndpointsEnum["SUGGESTIONS"] = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
    BFFEndpointsEnum["MENU_ITEMS_V2"] = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
    return BFFEndpointsEnum;
}({});
function $e5af1279e152c705$export$3748aab334e7d372({ cloudId: cloudId, userId: userId, product: product }) {
    const { consumer: consumer } = (0, $7hl58.useConsumer)();
    const { items: cachedItems } = (0, $6Tx9o.useCache)();
    const originUrl = (0, $6jORV.default)();
    const buildUCRecommendationURL = (0, $42omo.useCallback)(({ product: product, orgId: orgId, userId: userId, locale: locale, subProduct: subProduct, nativeAtis: nativeAtis, excludeAtis: excludeAtis, preferredAtis: preferredAtis })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v1/suggestions";
        const url = new URL(`${getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}`);
        const searchParams = new URLSearchParams();
        const queryParams = {
            tenantid: cloudId,
            product: product,
            orgid: orgId,
            userid: userId,
            source: consumer,
            locale: locale,
            subproduct: subProduct,
            nativeatis: (0, $iAFAo.atiArrayToParams)(nativeAtis),
            excludeatis: (0, $iAFAo.atiArrayToParams)(excludeAtis),
            preferredatis: (0, $iAFAo.atiArrayToParams)(preferredAtis)
        };
        Object.entries(queryParams).forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        consumer,
        cloudId,
        originUrl
    ]);
    const buildUCMenuItemsURL = (0, $42omo.useCallback)(({ product: productParam, orgId: orgId, userId: userIdParam, locale: locale, subProduct: subProduct, d: d, ro: ro, rt: rt, ap: ap })=>{
        const baseUrl = "/gateway/api/app-switcher/api/universal-create/v2/menu-items";
        const url = new URL(`${getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}`);
        const searchParams = new URLSearchParams();
        // Maintain specific order: tenantid, product, orgid, userid, source, then other params
        const queryParams = [
            [
                'tenantid',
                cloudId
            ],
            [
                'product',
                productParam || product
            ],
            [
                'orgid',
                orgId
            ],
            [
                'userid',
                userIdParam || userId
            ],
            [
                'source',
                consumer
            ],
            [
                'locale',
                locale
            ],
            [
                'subproduct',
                subProduct
            ],
            [
                'd',
                d
            ],
            [
                'ro',
                ro
            ],
            [
                'rt',
                rt
            ],
            [
                'ap',
                ap
            ]
        ];
        queryParams.forEach(([key, value])=>{
            if (value) searchParams.append(key, value);
        });
        // Append search params to URL
        url.search = searchParams.toString();
        return url.toString();
    }, [
        cloudId,
        product,
        userId,
        consumer,
        originUrl
    ]);
    const buildProductShortcutURL = (0, $42omo.useCallback)(({ baseUrl: baseUrl })=>{
        baseUrl = baseUrl ?? "/gateway/api/app-switcher/api/available-products";
        // No point in building a URL if there are no items to fetch and the cache is already populated
        if (cachedItems.length > 0) return '';
        const queryValues = '';
        return `${getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}?${queryValues}`;
    }, [
        cachedItems,
        originUrl
    ]);
    const buildURL = (0, $42omo.useCallback)(({ baseUrl: baseUrl })=>{
        let url = '';
        if (baseUrl) url = `${getOriginUrl({
            originUrl: originUrl
        })}${baseUrl}`;
        // Consumer specific URL building implementations happen here
        switch(consumer){
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS:
                url = buildProductShortcutURL({});
                break;
            case (0, $4jETc.BFFConsumerEnum).GLOBAL_SIDE_NAVIGATION:
                url = buildProductShortcutURL({});
                break;
        }
        if (!url) return url;
        // Append the consumer to the URL
        const formattedUrl = new URL(url);
        const updatedParams = new URLSearchParams(formattedUrl.search);
        if (consumer) updatedParams.append('source', consumer);
        if (cloudId) updatedParams.append('tenantid', cloudId);
        if (userId) updatedParams.append('userid', userId);
        if (product) updatedParams.append('product', product);
        return `${formattedUrl.origin}${formattedUrl.pathname}?${updatedParams}`;
    }, [
        buildProductShortcutURL,
        consumer,
        cloudId,
        userId,
        product,
        originUrl
    ]);
    const getOriginUrl = ({ originUrl: originUrl } = {})=>originUrl || new URL(window.location.href).origin;
    return {
        buildURL: buildURL,
        buildProductShortcutURL: buildProductShortcutURL,
        buildUCRecommendationURL: buildUCRecommendationURL,
        buildUCMenuItemsURL: buildUCMenuItemsURL
    };
}
module.exports["BFFEndpointsEnum"] = $e5af1279e152c705$export$92af951f33a9009c;
module.exports["useURLBuilder"] = $e5af1279e152c705$export$3748aab334e7d372;

});

parcelRegister("iAFAo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

const $abc574e5bd82b638$export$905fe28a7c283e1d = (text)=>{
    return typeof text === 'string' ? text : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        ...text
    });
};
const $abc574e5bd82b638$export$60f5d4abb43a14b3 = (direction)=>(a, b)=>{
        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();
        if (direction === 'asc') return aLower.localeCompare(bLower);
        return bLower.localeCompare(aLower);
    };
const $abc574e5bd82b638$export$e57a6793604f15ac = (atiArray)=>{
    return atiArray && atiArray.length > 0 ? atiArray.join(',') : undefined;
};
module.exports["formatText"] = $abc574e5bd82b638$export$905fe28a7c283e1d;
module.exports["sortAlphabetically"] = $abc574e5bd82b638$export$60f5d4abb43a14b3;
module.exports["atiArrayToParams"] = $abc574e5bd82b638$export$e57a6793604f15ac;

});

parcelRegister("6Tx9o", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caUKj = parcelRequire("caUKj");

function $a3b98e022000e430$export$c6e89b6bb9436bc0() {
    const { value: { consumer: consumer, cache: cache, cacheKey: cacheKey }, setValue: setValue } = (0, $42omo.useContext)((0, $caUKj.BFFContext));
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    const items = (0, $42omo.useMemo)(()=>{
        return cache[cacheKey] ?? [];
    }, [
        cache,
        cacheKey
    ]);
    const updateCacheKey = (0, $42omo.useCallback)((updatedCacheKey)=>{
        setValue((prev)=>({
                ...prev,
                cacheKey: `${consumer}-${updatedCacheKey}`
            }));
    }, [
        setValue,
        consumer
    ]);
    const addItemsToCache = (0, $42omo.useCallback)((items, compareKey = 'cloudId')=>{
        setValue((prev)=>{
            const itemData = prev.cache[cacheKey] ?? [];
            // Overwrite values with matched key if a new value is present
            // This shouldn't be necessary, but it helps act as a safeguard
            // for duplication.
            for (let item of items){
                const replacedItemIndex = itemData.findIndex((i)=>i[compareKey] === item[compareKey]);
                if (replacedItemIndex !== -1) itemData[replacedItemIndex] = item;
                else itemData.push(item);
            }
            return {
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: itemData
                }
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const clearCache = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: []
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    return {
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        updateCacheKey: updateCacheKey,
        cacheKey: cacheKey,
        items: items
    };
}
module.exports["useCache"] = $a3b98e022000e430$export$c6e89b6bb9436bc0;

});

parcelRegister("7hl58", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caUKj = parcelRequire("caUKj");

function $9c1427a12622d9c5$export$33062d550933de6f() {
    const { value: { consumer: consumer } } = (0, $42omo.useContext)((0, $caUKj.BFFContext));
    return {
        consumer: consumer
    };
}
module.exports["useConsumer"] = $9c1427a12622d9c5$export$33062d550933de6f;

});

parcelRegister("6jORV", function(module, exports) {

var $eGGIv = parcelRequire("eGGIv");

/**
 * Hook that returns the context of a forced origin url (used for supporting global shortcuts locally)
 */ const $4478d364359c007a$var$useOriginUrl = ()=>{
    const context = (0, $eGGIv.useBFFOriginUrlContext)();
    return context;
};
var $4478d364359c007a$export$2e2bcd8739ae039 = $4478d364359c007a$var$useOriginUrl;
module.exports["default"] = $4478d364359c007a$export$2e2bcd8739ae039;

});

parcelRegister("eGGIv", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $35a22a28e791828e$var$BFFOriginUrlContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $35a22a28e791828e$export$405f92d0950d3d4f = ({ children: children, url: url })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($35a22a28e791828e$var$BFFOriginUrlContext.Provider, {
        value: url,
        children: children
    });
};
const $35a22a28e791828e$export$13a55721f6e3a9e = ()=>{
    return (0, $42omo.useContext)($35a22a28e791828e$var$BFFOriginUrlContext);
};
module.exports["useBFFOriginUrlContext"] = $35a22a28e791828e$export$13a55721f6e3a9e;

});

parcelRegister("dr83e", function(module, exports) {
$parcel$export(module.exports, "default", () => $4553d074abf99d69$export$2e2bcd8739ae039);
const $4553d074abf99d69$var$packageName = "platform-pkg";
const $4553d074abf99d69$var$packageVersion = "0.0.0-use.local";
var $4553d074abf99d69$export$2e2bcd8739ae039 = {
    packageName: $4553d074abf99d69$var$packageName,
    packageVersion: $4553d074abf99d69$var$packageVersion
};

});

parcelRegister("ik19A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");

function $745446d53837e3a6$export$53cc6abb6942ce72() {
    const { setValue: setValue, value: { status: status, error: error }, currentLoadingRequests: currentLoadingRequests, updateCurrentLoadingRequests: updateCurrentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const isInitializing = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).INIT, [
        status
    ]);
    const isComplete = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).COMPLETE, [
        status
    ]);
    const isError = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).ERROR, [
        status
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>status === (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    const isLoaded = (0, $42omo.useMemo)(()=>status !== (0, $4jETc.RequestStatus).LOADING, [
        status
    ]);
    // Globally update the status based on the request queue for the BFF
    (0, $42omo.useEffect)(()=>{
        if (!currentLoadingRequests.length && status === (0, $4jETc.RequestStatus).LOADING) // Ensure that the error state remains if it was previously set
        setValue((prev)=>{
            if (prev.status === (0, $4jETc.RequestStatus).ERROR) return prev;
            return {
                ...prev,
                status: (0, $4jETc.RequestStatus).COMPLETE
            };
        });
    }, [
        currentLoadingRequests,
        setValue,
        status
    ]);
    // Globally manage the request queue of any calls to the BFF
    const setStatus = (0, $42omo.useCallback)((newStatus, integratingComponent, error)=>{
        if (newStatus === (0, $4jETc.RequestStatus).LOADING && integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).LOADING);
        if (newStatus === (0, $4jETc.RequestStatus).COMPLETE) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).COMPLETE);
        }
        if (newStatus === (0, $4jETc.RequestStatus).ERROR) {
            if (integratingComponent) updateCurrentLoadingRequests(integratingComponent, (0, $4jETc.RequestStatus).ERROR);
        }
        setValue((prev)=>{
            const isErrorStatus = newStatus === (0, $4jETc.RequestStatus).ERROR;
            return {
                ...prev,
                status: isErrorStatus ? (0, $4jETc.RequestStatus).ERROR : (0, $4jETc.RequestStatus).LOADING,
                error: isErrorStatus ? error : undefined
            };
        });
    }, [
        updateCurrentLoadingRequests,
        setValue
    ]);
    return {
        error: error,
        status: status,
        isInitializing: isInitializing,
        isComplete: isComplete,
        isError: isError,
        isLoading: isLoading,
        isLoaded: isLoaded,
        setStatus: setStatus
    };
}
module.exports["useStatus"] = $745446d53837e3a6$export$53cc6abb6942ce72;

});

parcelRegister("fMjA6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $19BZl = parcelRequire("19BZl");

function $060ce356f1549e47$export$a0e86d06727a8039(atiType) {
    // Access the Universal Create state
    const { suggestionConfig: suggestionConfig } = (0, $19BZl.useUniversalCreateState)();
    // Determine ATIs to pass to the hook
    const atis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled) return undefined;
        const atiArray = atiType === 'preferred' ? suggestionConfig.preferredAtis : suggestionConfig.excludeAtis;
        if (!atiArray) return undefined;
        // Convert Ati[] to string[]
        if (Array.isArray(atiArray) && atiArray.length > 0) return atiArray.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        atiType
    ]);
    return atis;
}
function $060ce356f1549e47$export$4984a78a2f2592cd() {
    return $060ce356f1549e47$export$a0e86d06727a8039('preferred');
}
function $060ce356f1549e47$export$d6dcc91285361556() {
    return $060ce356f1549e47$export$a0e86d06727a8039('exclude');
}
module.exports["useSuggestionPreferredAtis"] = $060ce356f1549e47$export$4984a78a2f2592cd;
module.exports["useSuggestionExcludeAtis"] = $060ce356f1549e47$export$d6dcc91285361556;

});

parcelRegister("6OnN8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $19BZl = parcelRequire("19BZl");


var $VSkIN = parcelRequire("VSkIN");

function $bdcbf50357937847$export$ace2aad66e79cd4e() {
    // Access the Universal Create state
    const { suggestionConfig: suggestionConfig, items: items } = (0, $19BZl.useUniversalCreateState)();
    // Determine native ATIs to pass to the hook
    const nativeAtis = (0, $42omo.useMemo)(()=>{
        if (!suggestionConfig.enabled || !suggestionConfig.nativeAtis) return undefined;
        // If nativeAtis is 'auto', extract ATIs from native menu items
        if (suggestionConfig.nativeAtis === 'auto') return (0, $VSkIN.extractNativeAtis)(items);
        // If nativeAtis is manually defined as Ati[], convert to strings and use it
        if (Array.isArray(suggestionConfig.nativeAtis) && suggestionConfig.nativeAtis.length > 0) return suggestionConfig.nativeAtis.map((ati)=>ati.toString());
        // Default fallback
        return undefined;
    }, [
        suggestionConfig,
        items
    ]);
    return nativeAtis;
}
module.exports["useSuggestionNativeAtis"] = $bdcbf50357937847$export$ace2aad66e79cd4e;

});

parcelRegister("dv953", function(module, exports) {

var $42omo = parcelRequire("42omo");

function $41db8bac43dc4cde$export$61de563e38fe014d() {
    const fetchUser = (0, $42omo.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
}
module.exports["useFetchUser"] = $41db8bac43dc4cde$export$61de563e38fe014d;

});

parcelRegister("kOiVn", function(module, exports) {

let $f26728225047ff68$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f26728225047ff68$var$load("3VpLA").then(()=>parcelRequire('b6A6z'));

});

parcelRegister("25I5T", function(module, exports) {

let $185e409158537583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $185e409158537583$var$load("3VpLA"),
    $185e409158537583$var$load("2NjlT")
]).then(()=>parcelRequire('irQ3Q'));

});

parcelRegister("a1Oiu", function(module, exports) {
// ===============================
// UC Menu Items V2 API Communication
// ===============================

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $ekTM6 = parcelRequire("ekTM6");

var $5IDSL = parcelRequire("5IDSL");


var $l7sDu = parcelRequire("l7sDu");

/**
 * Encode configuration to binary format with query parameters
 */ /**
 * Encode ATI string to binary representation
 */ /**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 
var $6yCpa = parcelRequire("6yCpa");

function $0bf79e81331e4541$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $6yCpa.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $0bf79e81331e4541$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $6yCpa.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $0bf79e81331e4541$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $6yCpa.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $0bf79e81331e4541$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}


/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
const $dccf36f4b2146e6b$export$3167453beff01750 = 2;
const $dccf36f4b2146e6b$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $dccf36f4b2146e6b$export$61beacecbf214ae6 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$b2144c689c2ff042);
const $dccf36f4b2146e6b$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $dccf36f4b2146e6b$export$83dfff18be6bef06 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$89e1a37ecee09500);
const $dccf36f4b2146e6b$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $dccf36f4b2146e6b$export$38830b2321100ef2 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9dd62a2b56d5462d);
const $dccf36f4b2146e6b$export$b1e8f8dc54861a99 = 3;
const $dccf36f4b2146e6b$export$21d9e5eeb6ffaecd = 1;
const $dccf36f4b2146e6b$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $dccf36f4b2146e6b$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $dccf36f4b2146e6b$export$597234ac346c7ad8 = 256;
const $dccf36f4b2146e6b$export$8c22d9b338278eca = 4096;
const $dccf36f4b2146e6b$export$3010378ceda42048 = 256;
const $dccf36f4b2146e6b$export$6048538928ea261a = 4096;
const $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa = 2;
const $dccf36f4b2146e6b$export$4030221cfc1fb63c = 5;
const $dccf36f4b2146e6b$export$ece7c64a85a33d85 = 255;
const $dccf36f4b2146e6b$export$6747badc61b8e57b = 512;
const $dccf36f4b2146e6b$export$48ffef5fac2e11a = 10;
const $dccf36f4b2146e6b$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $dccf36f4b2146e6b$export$3dcfc8418d714114 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c38e76af505e38a1);
const $dccf36f4b2146e6b$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow'
];
const $dccf36f4b2146e6b$export$6cabc9b146da4ac8 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$c89f8194e7716284);
const $dccf36f4b2146e6b$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $dccf36f4b2146e6b$export$1e5c4f2c7d35f342 = (0, $0bf79e81331e4541$export$912bb685303c4ec7)($dccf36f4b2146e6b$export$9c3e0a77c247e0c);
const $dccf36f4b2146e6b$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];


/**
 * Get configuration for a specific component kind
 */ function $bcdba2959b20769a$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $dccf36f4b2146e6b$export$fd3a5bd85e4c7caa})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $dccf36f4b2146e6b$export$3010378ceda42048),
                errorMessage: `Too many unknown resource owners (max ${0, $dccf36f4b2146e6b$export$3010378ceda42048})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $dccf36f4b2146e6b$export$6048538928ea261a),
                errorMessage: `Too many unknown resource types (max ${0, $dccf36f4b2146e6b$export$6048538928ea261a})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $bcdba2959b20769a$var$ensureCapacity(unknowns, kind) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $bcdba2959b20769a$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $bcdba2959b20769a$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $bcdba2959b20769a$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $bcdba2959b20769a$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $bcdba2959b20769a$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $bcdba2959b20769a$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $0bf79e81331e4541$export$5597e67f4dded1e6)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $dccf36f4b2146e6b$export$61beacecbf214ae6)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $dccf36f4b2146e6b$export$83dfff18be6bef06)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $bcdba2959b20769a$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $dccf36f4b2146e6b$export$38830b2321100ef2)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $bcdba2959b20769a$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $dccf36f4b2146e6b$export$4c68bfc8c9124205).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}


/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $iA9co = parcelRequire("iA9co");

var $5120b89f81d97ddd$require$Buffer = $iA9co.Buffer;
function $5120b89f81d97ddd$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $5120b89f81d97ddd$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}



// =============================================================================
// Configuration Validation
// =============================================================================
const $e39212095b0d4be5$var$MAX_SECTIONS = 15;
function $e39212095b0d4be5$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $e39212095b0d4be5$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$e39212095b0d4be5$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $bcdba2959b20769a$export$4b052fcb66ebb451)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $bcdba2959b20769a$export$9fa514be131db9ec)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $e39212095b0d4be5$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$e39212095b0d4be5$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $e39212095b0d4be5$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $dccf36f4b2146e6b$export$dab292c7293b69ae)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $e39212095b0d4be5$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $e39212095b0d4be5$var$encodeMenuItem(item, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const typeCode = item.type !== undefined ? $e39212095b0d4be5$var$getCodeByType(item) : undefined;
    const atiBase64 = $e39212095b0d4be5$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $e39212095b0d4be5$var$PROMOTED_FLAG : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $e39212095b0d4be5$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $dccf36f4b2146e6b$export$3dcfc8418d714114)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $e39212095b0d4be5$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $dccf36f4b2146e6b$export$1e5c4f2c7d35f342)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $e39212095b0d4be5$var$personalizeCodeByMode(mode) {
    const code = (0, $dccf36f4b2146e6b$export$6cabc9b146da4ac8)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an overflow threshold
 *
 * @param overflowThreshold - Overflow threshold
 * @returns Encoded overflow threshold string
 */ function $e39212095b0d4be5$var$encodeOverflowThreshold(overflowThreshold) {
    if (overflowThreshold < 0) throw new Error('Overflow threshold must be positive');
    return overflowThreshold.toString();
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$e39212095b0d4be5$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $e39212095b0d4be5$var$personalizeCodeByMode(section.personalize) : undefined;
    const overflowThreshold = personalizeCode !== undefined && section.personalize === 'overflow' && section.overflowThreshold !== undefined ? $e39212095b0d4be5$var$encodeOverflowThreshold(section.overflowThreshold) : undefined;
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode,
        overflowThreshold
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $e39212095b0d4be5$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $e39212095b0d4be5$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $e39212095b0d4be5$var$encodeATIList(section.preferredAtis, unknowns);
    return $e39212095b0d4be5$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $e39212095b0d4be5$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $e39212095b0d4be5$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $e39212095b0d4be5$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $e39212095b0d4be5$var$buildRawConfigString(encodedSections) {
    return `v${0, $dccf36f4b2146e6b$export$3167453beff01750}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $e39212095b0d4be5$export$1282978798683232(config) {
    $e39212095b0d4be5$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$e39212095b0d4be5$var$encodeSection(section, unknowns));
    const rawConfigString = $e39212095b0d4be5$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $5120b89f81d97ddd$export$b0ffcdf8b133e63c)(utf8Bytes);
    return $e39212095b0d4be5$var$attachQueryParameters(encodedData, unknowns);
}



var $4jETc = parcelRequire("4jETc");


var $caUKj = parcelRequire("caUKj");


var $cei05 = parcelRequire("cei05");


var $6lFYf = parcelRequire("6lFYf");


var $dG1kO = parcelRequire("dG1kO");


var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

function $3ef0e6a21c4da545$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $caUKj.useBFFContext)();
    const boundaryConfig = (0, $42omo.useMemo)(()=>({
            location: 'useUCMenuItems',
            disableSentry: (0, $dh538.fg)('navx_uc_sentry_enabled') ? false : true,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)(boundaryConfig);
    const { inFlightRequests: inFlightRequests, setInFlightRequests: setInFlightRequests } = (0, $cei05.useUniversalCreateBFFContext)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [data, setData] = (0, $42omo.useState)(undefined);
    const [hasError, setHasError] = (0, $42omo.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId
    });
    const requestIdRef = (0, $42omo.useRef)(0);
    /**
	 * Helper functions for feature gated inflight request tracking
	 */ const isRequestInflight = (0, $42omo.useCallback)((requestKey)=>{
        return inFlightRequests.has(requestKey);
    }, [
        inFlightRequests
    ]);
    const setRequestInFlight = (0, $42omo.useCallback)((requestKey, value)=>{
        return setInFlightRequests(requestKey, value);
    }, [
        setInFlightRequests
    ]);
    const clearInFlightRequest = (0, $42omo.useCallback)((requestKey)=>{
        return inFlightRequests.delete(requestKey);
    }, [
        inFlightRequests
    ]);
    // Encode the config to get binary parameters
    const encodedConfig = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $e39212095b0d4be5$export$1282978798683232)(appMenuConfig);
        } catch  {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $dG1kO.useGenericCache)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $42omo.useCallback)(async ()=>{
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in flight
        if (isRequestInflight(requestKey)) return;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $l7sDu.createExperienceTracker)('universalCreatePrefetch');
        experience?.start();
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            // Mark request key as in-flight before fetch fires to prevent race conditions
            setRequestInFlight(requestKey, true);
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (isRequestInflight(requestKey)) clearInFlightRequest(requestKey);
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                clearInFlightRequest(requestKey);
                if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFNetworkError)('Failed to fetch universal create menu items', {
                    url: url,
                    status: response.status,
                    originalError: response.error,
                    additionalContext: {
                        requestKey: requestKey
                    }
                }));
                return;
            }
            if (response.status === (0, $4jETc.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                clearInFlightRequest(requestKey);
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            clearInFlightRequest(requestKey);
            if ((0, $dh538.fg)('navx_uc_sentry_enabled')) handleError(new (0, $ekTM6.BFFError)('Error occurred during fetchUCMenuItems', {
                status: (0, $4jETc.RequestStatus).ERROR,
                originalError: error,
                additionalContext: {
                    requestKey: requestKey
                }
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        skipInitialization,
        encodedConfig,
        cachedObject,
        product,
        userId,
        locale,
        subProduct,
        isRequestInflight,
        setStatus,
        buildUCMenuItemsURL,
        setRequestInFlight,
        clearInFlightRequest,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if (skipInitialization) return false;
        // We check if the current loading requests include UC menu items rather than the BFF status directly
        // to ensure that it only returns true for UC menu items and not other BFF requests.
        const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $4jETc.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
        // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
        // before running things like onResultChange, so that we don't do those things an unnecessary extra time
        // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
        const hasMenuItemDataBeenReturned = data !== undefined || hasError;
        return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}
module.exports["useUCMenuItems"] = $3ef0e6a21c4da545$export$23f37315094bc4d3;

});

parcelRegister("a5rWO", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $4d8cf794b5538381$export$e5a5b1df38d9e289 = 4;



var $6oodB = parcelRequire("6oodB");

const $6f8e2274fdd0fece$export$20ae29efbf02e075 = (item)=>({
        type: (0, $6oodB.isNativeMenuItem)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $6f8e2274fdd0fece$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') {
        if ((0, $dh538.fg)('navx-2827-add-menu-v2-overflow-threshold')) {
            const overflowThreshold = Boolean(section.foldable) ? typeof section.foldable === 'number' ? section.foldable : (0, $4d8cf794b5538381$export$e5a5b1df38d9e289) : undefined;
            return {
                type: 'appDefinedSection',
                items: section.items.map($6f8e2274fdd0fece$export$20ae29efbf02e075),
                personalize: section.personalize,
                ...overflowThreshold && {
                    overflowThreshold: overflowThreshold
                }
            };
        } else return {
            type: 'appDefinedSection',
            items: section.items.map($6f8e2274fdd0fece$export$20ae29efbf02e075),
            personalize: section.personalize
        };
    }
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $6f8e2274fdd0fece$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($6f8e2274fdd0fece$export$95539883fd80ce6)
    });
module.exports["sectionsToAppMenuConfig"] = $6f8e2274fdd0fece$export$c9ba238fd04e08d2;

});

parcelRegister("6oodB", function(module, exports) {
const $79b80363c4ad79e3$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};
module.exports["isNativeMenuItem"] = $79b80363c4ad79e3$export$68f958d92a17ef71;

});

parcelRegister("amdkE", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $9DI9J = parcelRequire("9DI9J");


var $7WMLZ = parcelRequire("7WMLZ");

const $cfb31863b8c4fcaa$var$styles = {
    wrapper: "_1ul91dhz",
    wrapperWithPadding: "_1ul91dhz _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi"
};
function $cfb31863b8c4fcaa$export$dab1248df0cdf0ab({ padded: padded = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        // Intentional inline this analytics events due to
        // loading menu component can be used outside of context
        createAnalyticsEvent({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $9DI9J.ANALYTICS_SOURCE),
            tags: [
                (0, $9DI9J.ANALYTICS_TAG)
            ],
            action: 'viewed',
            actionSubjectId: 'universalCreateLoadingMenu',
            attributes: {}
        }).fire((0, $9DI9J.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $cfb31863b8c4fcaa$var$styles.wrapperWithPadding : $cfb31863b8c4fcaa$var$styles.wrapper,
        children: Array.from({
            length: 6
        }, (_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $7WMLZ.SkeletonItem), {
                contentHeight: 8
            }, `loading-skeleton-item-${index}`))
    });
}
module.exports["LoadingMenu"] = $cfb31863b8c4fcaa$export$dab1248df0cdf0ab;

});

parcelRegister("7WMLZ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $1s5hv = parcelRequire("1s5hv");

var $eyWa4 = parcelRequire("eyWa4");


var $kpYGL = parcelRequire("kpYGL");


var $6F6hl = parcelRequire("6F6hl");


var $cgtv4 = parcelRequire("cgtv4");

const $63d1bead1b1651fc$var$messages = (0, $cgtv4.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $63d1bead1b1651fc$export$2e2bcd8739ae039 = $63d1bead1b1651fc$var$messages;


const $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT = 8;
const $f0781448a6f252f4$var$menuSkeletonStyles = {
    wrapper: "_4t3izwfg _1bsb1osq _19bv1b66 _u5f31b66"
};
const $f0781448a6f252f4$export$cde35cc9e1359709 = ({ testId: testId, contentHeight: contentHeight = $f0781448a6f252f4$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        xcss: $f0781448a6f252f4$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $kpYGL.default), {
                    testId: "skeleton-item-v2",
                    width: "100%",
                    height: contentHeight,
                    isShimmering: true
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: formatMessage((0, $63d1bead1b1651fc$export$2e2bcd8739ae039).menuItemLoading)
            })
        ]
    });
};


const $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $f0781448a6f252f4$export$cde35cc9e1359709), {
        ...props
    });
};
module.exports["SkeletonItem"] = $e8f4c6ac79c4c49f$export$fbc0ea7debdb77e;

});

parcelRegister("aaBfd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ccHMk = parcelRequire("ccHMk");

var $1qfLF = parcelRequire("1qfLF");

var $7p4As = parcelRequire("7p4As");

var $dE1p6 = parcelRequire("dE1p6");


var $aGop9 = parcelRequire("aGop9");


var $efXed = parcelRequire("efXed");

// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$c25acd513dcc8062 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedIconButton) : (0, $1qfLF.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$edad7fca51b767e1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedLinkIconButton) : (0, $dE1p6.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedButton) : (0, $ccHMk.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
// Explicitly typed to use only the themed button API,
// which is a subset of the normal button API
const $8856355ea91006d2$export$29d11c0fe2fc51d8 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const Component = hasCustomTheme ? (0, $aGop9.ThemedLinkButton) : (0, $7p4As.default);
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ref: ref,
        ...props
    });
});
module.exports["IconButton"] = $8856355ea91006d2$export$c25acd513dcc8062;
module.exports["LinkIconButton"] = $8856355ea91006d2$export$edad7fca51b767e1;
module.exports["Button"] = $8856355ea91006d2$export$353f5b6fc5456de1;
module.exports["LinkButton"] = $8856355ea91006d2$export$29d11c0fe2fc51d8;

});

parcelRegister("aGop9", function(module, exports) {
/* button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $lcVz9 = parcelRequire("lcVz9");

// eslint-disable no-unused-vars
function $90c58b5063b4a6d0$var$getPrimitiveSpreadProps({ style: style, xcss: xcss, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, ...props }) {
    return props;
} // eslint-enable no-unused-vars
const $90c58b5063b4a6d0$export$b93b81aa41a8061a = '--ds-top-bar-button-background';
const $90c58b5063b4a6d0$export$96a2312c81489aa1 = '--ds-top-bar-button-background-hovered';
const $90c58b5063b4a6d0$export$9db7a918ddfed23e = '--ds-top-bar-button-background-pressed';
const $90c58b5063b4a6d0$export$2b00bded80635cbb = '--ds-top-bar-button-border';
const $90c58b5063b4a6d0$export$eca746d7c1a9cd6e = '--ds-top-bar-button-primary-text';
const $90c58b5063b4a6d0$export$2c2bc298cddb8aca = '--ds-top-bar-button-primary-background';
const $90c58b5063b4a6d0$export$6b28e650669cd3c7 = '--ds-top-bar-button-primary-background-hovered';
const $90c58b5063b4a6d0$export$1656be06aad539b9 = '--ds-top-bar-button-primary-background-pressed';
const $90c58b5063b4a6d0$export$c26a897d419ef487 = '--ds-top-bar-button-selected-text';
const $90c58b5063b4a6d0$export$4e50e625ccffdb13 = '--ds-top-bar-button-selected-background';
const $90c58b5063b4a6d0$export$55c84c90f36bda4d = '--ds-top-bar-button-selected-background-hovered';
const $90c58b5063b4a6d0$export$c5c0213472126c08 = '--ds-top-bar-button-selected-background-pressed';
const $90c58b5063b4a6d0$export$22928007ff541429 = '--ds-top-bar-button-selected-border';
const $90c58b5063b4a6d0$export$787ad93d0f2276af = '--ds-top-bar-button-disabled-text';
const $90c58b5063b4a6d0$export$5e774f44b77335d6 = '--ds-top-bar-button-disabled-background';
const $90c58b5063b4a6d0$var$styles = {
    root: "_zulp12x7 _11c8fhey _2rkofajl _v5649dqc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjcze3t _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i5r7u _kqswh2mm _1nrm1r31 _1a3b1r31 _9oik1r31 _c2waglyw _4fprglyw _1bnxglyw _1iohnqa1 _5goinqa1 _jf4cnqa1",
    rootT26Shape: "_2rko1qi0",
    border: "_14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _aetrb3bt _18postnw",
    selected: "_11q71qds _syazw5ct _8l3m15jn _f8pjw5ct _1053w5ct _19lcjrv1 _30l3w5ct _j6xtnh62 _9h8hw5ct",
    disabled: "_11q71c9b _syaz1i3i _8l3m1j28 _f8pj1i3i _10531i3i _19lc1c9b _30l31i3i _j6xt1c9b _9h8h1i3i"
};
const $90c58b5063b4a6d0$var$shapeStyles = {
    default: "_18zrutpp",
    square: "_18zrze3t _1bsb5r7u _vwz4idpf"
};
const $90c58b5063b4a6d0$var$appearanceStyles = {
    default: "_11q7pkxg _syaz1r31 _8l3maykr _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    subtle: "_11q7pkxg _syaz1r31 _f8pj1r31 _10531r31 _19lc1rps _30l31r31 _j6xtqtgh _9h8h1r31",
    primary: "_11q7esko _syaz15o7 _f8pj15o7 _105315o7 _19lcp6hf _30l315o7 _j6xt5sko _9h8h15o7"
}; /**
    * Props shared by `ThemedPressable` and `ThemedAnchor`
    */ 
const $90c58b5063b4a6d0$var$ThemedPressable = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedPressable({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ...$90c58b5063b4a6d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        type: "button",
        /**
                                                                                 * We are using some style values that are outside of the strict
                                                                                 * `@atlaskit/css` types.
                                                                                 */ // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($90c58b5063b4a6d0$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $90c58b5063b4a6d0$var$styles.rootT26Shape, $90c58b5063b4a6d0$var$shapeStyles[shape], hasBorder && $90c58b5063b4a6d0$var$styles.border, $90c58b5063b4a6d0$var$appearanceStyles[appearance], isSelected && $90c58b5063b4a6d0$var$styles.selected, isDisabled && $90c58b5063b4a6d0$var$styles.disabled),
        isDisabled: isDisabled
    });
});
function $90c58b5063b4a6d0$var$ThemedAnchorFn({ appearance: appearance = 'default', shape: shape = 'default', isSelected: isSelected, isDisabled: isDisabled, ...props }, ref) {
    const hasBorder = appearance === 'default' || isSelected;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        ...$90c58b5063b4a6d0$var$getPrimitiveSpreadProps(props),
        ref: ref,
        // @ts-expect-error
        // eslint-disable-next-line @compiled/no-suppress-xcss
        xcss: (0, $1bHXt.cx)($90c58b5063b4a6d0$var$styles.root, (0, $dh538.fg)('platform-dst-shape-theme-default') && $90c58b5063b4a6d0$var$styles.rootT26Shape, $90c58b5063b4a6d0$var$shapeStyles[shape], hasBorder && $90c58b5063b4a6d0$var$styles.border, $90c58b5063b4a6d0$var$appearanceStyles[appearance], isSelected && $90c58b5063b4a6d0$var$styles.selected, isDisabled && $90c58b5063b4a6d0$var$styles.disabled)
    });
} /**
   * Intentionally an almost-duplicate of `ThemedPressable` - make sure to update both.
   *
   * More 'clever' solutions were tried but I couldn't get them working in an acceptable state.
   *
   * Polymorphism had many typing issues and required sacrificing type safety.
   *
   * Render props had problems passing down styles through `xcss` to the `children` function.
   */ 
const $90c58b5063b4a6d0$var$ThemedAnchor = (0, $3hoG4.default)($90c58b5063b4a6d0$var$ThemedAnchorFn);
const $90c58b5063b4a6d0$var$textButtonStyles = {
    iconBefore: "_vwz4idpf",
    text: "_k48p1wq8"
}; /**
    * Props shared by `Button` and `LinkButton`
    */ 
const $90c58b5063b4a6d0$export$f67fb575035cc7d0 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedButton({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsxs)($90c58b5063b4a6d0$var$ThemedPressable, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.iconBefore
                ]),
                children: (0, $dh538.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lcVz9.default), {
                    icon: IconBefore
                }) : /*#__PURE__*/ (0, $l998X.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    });
});
function $90c58b5063b4a6d0$var$ThemedLinkButtonFn({ iconBefore: IconBefore, children: children, ...props }, ref) {
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $l998X.jsxs)($90c58b5063b4a6d0$var$ThemedAnchor, {
        ...props,
        ref: ref,
        children: [
            IconBefore && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.iconBefore
                ]),
                children: /*#__PURE__*/ (0, $l998X.jsx)(IconBefore, {
                    label: "",
                    color: "currentColor"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                className: (0, $gMc0m.default)([
                    $90c58b5063b4a6d0$var$textButtonStyles.text
                ]),
                children: children
            })
        ]
    }));
} /**
   * __Themed link button__
   *
   * A themed link button for the top bar.
   */ 
const $90c58b5063b4a6d0$export$b0b5aeed52623827 = (0, $3hoG4.default)($90c58b5063b4a6d0$var$ThemedLinkButtonFn); /**
                                                                                                                                                                                                                                                          * Props shared by `ThemedIconButtonProps` and `ThemedLinkIconButton`
                                                                                                                                                                                                                                                          */ 
const $90c58b5063b4a6d0$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $42omo.forwardRef)(function ThemedIconButton({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $l998X.jsxs)($90c58b5063b4a6d0$var$ThemedPressable, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    (0, $dh538.fg)('platform_themed_button_use_icon_renderer') ? /*#__PURE__*/ (0, $l998X.jsx)((0, $lcVz9.default), {
                        icon: Icon
                    }) : /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
});
function $90c58b5063b4a6d0$var$ThemedLinkIconButtonFn({ icon: Icon, label: label, tooltip: tooltip, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        ...tooltip,
        content: tooltip?.content ?? label,
        children: (triggerProps)=>/**
     * The `aria-describedby` from `triggerProps` is intentionally not passed down,
     * because it would cause double announcements with the `VisuallyHidden` label.
     *
     * The `@atlaskit/button` IconButton uses the same approach.
     */ /*#__PURE__*/ (0, $l998X.jsxs)($90c58b5063b4a6d0$var$ThemedAnchor, {
                ...props,
                shape: "square",
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps.ref
                ]),
                onClick: (event, analyticsEvent)=>{
                    props.onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    props.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    props.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    props.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    props.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    props.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    props.onBlur?.(e);
                },
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
                        label: "",
                        color: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                        children: label
                    })
                ]
            })
    });
} /**
   * __Themed link icon button__
   *
   * A themed link icon button for the top bar.
   */ 
const $90c58b5063b4a6d0$export$a1ab08e79d264ec8 = (0, $3hoG4.default)($90c58b5063b4a6d0$var$ThemedLinkIconButtonFn);
module.exports["themedButtonBackground"] = $90c58b5063b4a6d0$export$b93b81aa41a8061a;
module.exports["themedButtonBackgroundHovered"] = $90c58b5063b4a6d0$export$96a2312c81489aa1;
module.exports["themedButtonBackgroundPressed"] = $90c58b5063b4a6d0$export$9db7a918ddfed23e;
module.exports["themedButtonBorder"] = $90c58b5063b4a6d0$export$2b00bded80635cbb;
module.exports["themedButtonPrimaryText"] = $90c58b5063b4a6d0$export$eca746d7c1a9cd6e;
module.exports["themedButtonPrimaryBackground"] = $90c58b5063b4a6d0$export$2c2bc298cddb8aca;
module.exports["themedButtonPrimaryBackgroundHovered"] = $90c58b5063b4a6d0$export$6b28e650669cd3c7;
module.exports["themedButtonPrimaryBackgroundPressed"] = $90c58b5063b4a6d0$export$1656be06aad539b9;
module.exports["themedButtonSelectedText"] = $90c58b5063b4a6d0$export$c26a897d419ef487;
module.exports["themedButtonSelectedBackground"] = $90c58b5063b4a6d0$export$4e50e625ccffdb13;
module.exports["themedButtonSelectedBackgroundHovered"] = $90c58b5063b4a6d0$export$55c84c90f36bda4d;
module.exports["themedButtonSelectedBackgroundPressed"] = $90c58b5063b4a6d0$export$c5c0213472126c08;
module.exports["themedButtonSelectedBorder"] = $90c58b5063b4a6d0$export$22928007ff541429;
module.exports["themedButtonDisabledText"] = $90c58b5063b4a6d0$export$787ad93d0f2276af;
module.exports["themedButtonDisabledBackground"] = $90c58b5063b4a6d0$export$5e774f44b77335d6;
module.exports["ThemedButton"] = $90c58b5063b4a6d0$export$f67fb575035cc7d0;
module.exports["ThemedLinkButton"] = $90c58b5063b4a6d0$export$b0b5aeed52623827;
module.exports["ThemedIconButton"] = $90c58b5063b4a6d0$export$d9c2d067feb61447;
module.exports["ThemedLinkIconButton"] = $90c58b5063b4a6d0$export$a1ab08e79d264ec8;

});

parcelRegister("lcVz9", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

function $6b6d58426e4ff3f5$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 * This is copied from @atlaskit/button to render IconButtons. Some IconButton's DOM element
 * will be re-created during SSR -> SPA hydration without using this, which delays TTVC. As
 * IconRenderer is already used in @atlaskit/button to mitigate this issue, add it here to
 * mitigate the same issue for IconButtons in navigation-system, especially for ThemedIconButton.
 *
 */ const $6b6d58426e4ff3f5$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $6b6d58426e4ff3f5$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dh538.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $6b6d58426e4ff3f5$export$2e2bcd8739ae039 = $6b6d58426e4ff3f5$var$IconRenderer;
module.exports["default"] = $6b6d58426e4ff3f5$export$2e2bcd8739ae039;

});

parcelRegister("efXed", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $02aebea47caa4c41$export$d158fa15757a1890 = /*#__PURE__*/ (0, $42omo.createContext)(false);
function $02aebea47caa4c41$export$abfcaeeca4ae7a55() {
    return (0, $42omo.useContext)($02aebea47caa4c41$export$d158fa15757a1890);
}
module.exports["HasCustomThemeContext"] = $02aebea47caa4c41$export$d158fa15757a1890;
module.exports["useHasCustomTheme"] = $02aebea47caa4c41$export$abfcaeeca4ae7a55;

});

parcelRegister("291hi", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $lIKKD = parcelRequire("lIKKD");

const $725b0c40c654c097$var$hideAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$var$hideBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $725b0c40c654c097$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $725b0c40c654c097$var$hideAboveQueries[above],
            below && $725b0c40c654c097$var$hideBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Hide"] = $725b0c40c654c097$export$bed28288a051538;

});

parcelRegister("lIKKD", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $1LBzd = parcelRequire("1LBzd");


var $bWLcG = parcelRequire("bWLcG");

const $4cf80e6d1c5d4415$export$918f8818cfbbeb2c = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $4cf80e6d1c5d4415$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $1LBzd.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: /*#__PURE__*/ (0, $9K4OG.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                [(0, $bWLcG.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};
module.exports["UNSAFE_buildAboveMediaQueryCSS"] = $4cf80e6d1c5d4415$export$918f8818cfbbeb2c;
module.exports["UNSAFE_buildBelowMediaQueryCSS"] = $4cf80e6d1c5d4415$export$b2a4e2b0c6417297;

});

parcelRegister("1LBzd", function(module, exports) {
const $a161739fae125cf6$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '110.49rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110.5rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $a161739fae125cf6$export$2d293d9871c38e91 = Object.keys($a161739fae125cf6$export$e5ee4fe8b989fd09);
const $a161739fae125cf6$export$b7ed752a57b4177b = $a161739fae125cf6$export$2d293d9871c38e91[0];
module.exports["UNSAFE_BREAKPOINTS_ORDERED_LIST"] = $a161739fae125cf6$export$2d293d9871c38e91;

});

parcelRegister("26eSY", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $lIKKD = parcelRequire("lIKKD");

function $81e208d7c03fb2bd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e208d7c03fb2bd$var$showAboveQueries = (0, $lIKKD.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$showBelowQueries = (0, $lIKKD.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $81e208d7c03fb2bd$var$defaultHiddenStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $81e208d7c03fb2bd$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $81e208d7c03fb2bd$var$defaultHiddenStyles,
            above && $81e208d7c03fb2bd$var$showAboveQueries[above],
            below && $81e208d7c03fb2bd$var$showBelowQueries[below],
            ...resolvedStyles.emotion || []
        ]
    }, children);
};
module.exports["Show"] = $81e208d7c03fb2bd$export$f6a3d19be20f5819;

});

parcelRegister("fFc6D", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $bNwbD = parcelRequire("bNwbD");


var $bWLcG = parcelRequire("bWLcG");

const $1487a997836a60f3$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $bWLcG.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $1487a997836a60f3$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $1487a997836a60f3$var$queries[queryString];
    (0, $bNwbD.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $1487a997836a60f3$export$49e55ae2c03d6045;

});

parcelRegister("bNwbD", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $95c4b21f9fd4bea1$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $42omo.useEffect) : (0, $42omo.useLayoutEffect);
module.exports["useLayoutEffect"] = $95c4b21f9fd4bea1$export$e5c5a5f917a5871c;

});

parcelRegister("fNh3C", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $keVvA = parcelRequire("keVvA");


var $i2kCO = parcelRequire("i2kCO");

function $503da3927b063db6$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $503da3927b063db6$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("ahMRD"));
        case 'da':
            return (parcelRequire("2lzUO"));
        case 'de':
            return (parcelRequire("ctCPM"));
        case 'en-GB':
            return (parcelRequire("ijaow"));
        case 'en-ZZ':
            return (parcelRequire("hEfqd"));
        case 'en':
            return (parcelRequire("i2kCO"));
        case 'es':
            return (parcelRequire("25NMb"));
        case 'fi':
            return (parcelRequire("2a0cX"));
        case 'fr':
            return (parcelRequire("k3zzF"));
        case 'hu':
            return (parcelRequire("eLo8y"));
        case 'it':
            return (parcelRequire("j1kDF"));
        case 'ja':
            return (parcelRequire("g0SoK"));
        case 'ko':
            return (parcelRequire("dOr8D"));
        case 'nb':
            return (parcelRequire("eAsKQ"));
        case 'nl':
            return (parcelRequire("b6GRB"));
        case 'pl':
            return (parcelRequire("juEKn"));
        case 'pt':
            return (parcelRequire("2ORjt"));
        case 'ru':
            return (parcelRequire("gnt5x"));
        case 'sv':
            return (parcelRequire("lTqxa"));
        case 'th':
            return (parcelRequire("5UKAA"));
        case 'tr':
            return (parcelRequire("ls3Hr"));
        case 'uk':
            return (parcelRequire("d0iA6"));
        case 'vi':
            return (parcelRequire("fmmjN"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("hbMa0"));
        case 'zh':
            return (parcelRequire("1QisB"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $503da3927b063db6$export$12346a674644c156 = 'operational';
const $503da3927b063db6$export$515664faa1398f37 = 'navigation';
function $503da3927b063db6$var$Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $503da3927b063db6$var$fetchLanguageFile($503da3927b063db6$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $503da3927b063db6$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($503da3927b063db6$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $i2kCO.default),
        children: children
    });
}
const $503da3927b063db6$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, $l998X.jsx)($503da3927b063db6$var$Provider, {
            children: /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                ...props
            })
        });
module.exports["withIntlProvider"] = $503da3927b063db6$export$a5d940130f33be3f;

});

parcelRegister("i2kCO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $2e0f4708d02b569e$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $2e0f4708d02b569e$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'goal-create-success-flag-action': 'Go to goal',
    'goal-create-success-flag-title': 'Goal has been created',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.area-label': 'Toggle for {text}{heading} options',
    'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
    'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title': 'Sorry, something went wrong',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title': 'Team has been created',
    'platform.navigation-experiences.universal-create.project.create-error-flag-description': 'There was an error while creating your project. Please try again.',
    'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
    'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
    'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
    'platform.navigation-experiences.universal-create.secondary-tooltip-text': 'More create options',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More',
    'platform.navigation-experiences.universal-create.show-more.area-label': 'Show {text} {heading} options',
    'platform.navigation-experiences.universal-create.suggestion.section-heading': '{count, plural, one {Suggestion} other {Suggestions}}',
    'universal-create.loom-video-menu-item.create-loom-video': 'Loom video',
    'universal-create.loom-video-menu-item.share-video': 'Share'
};

});

parcelRegister("ahMRD", function(module, exports) {

let $77d1654c1c15e55e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $77d1654c1c15e55e$var$load("4XOEX").then(()=>parcelRequire('2nrO6'));

});

parcelRegister("2lzUO", function(module, exports) {

let $1b5966f880e76542$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1b5966f880e76542$var$load("gqmha").then(()=>parcelRequire('cmlqi'));

});

parcelRegister("ctCPM", function(module, exports) {

let $91565123f5e14147$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $91565123f5e14147$var$load("cweX3").then(()=>parcelRequire('lbNO6'));

});

parcelRegister("ijaow", function(module, exports) {

let $03708ca713a2c0be$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $03708ca713a2c0be$var$load("bai9u").then(()=>parcelRequire('egI7t'));

});

parcelRegister("hEfqd", function(module, exports) {

let $cd922291e66c8f11$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd922291e66c8f11$var$load("9t1Ib").then(()=>parcelRequire('gkIoe'));

});

parcelRegister("25NMb", function(module, exports) {

let $1862a8ecd6636580$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1862a8ecd6636580$var$load("eHlQ9").then(()=>parcelRequire('B195q'));

});

parcelRegister("2a0cX", function(module, exports) {

let $192cad396a6bdd1a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $192cad396a6bdd1a$var$load("6abco").then(()=>parcelRequire('j0Mtc'));

});

parcelRegister("k3zzF", function(module, exports) {

let $e99faec648a13ad6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e99faec648a13ad6$var$load("fvLDA").then(()=>parcelRequire('8fG30'));

});

parcelRegister("eLo8y", function(module, exports) {

let $abf82d8fe658586b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $abf82d8fe658586b$var$load("jYjnT").then(()=>parcelRequire('kh2Eq'));

});

parcelRegister("j1kDF", function(module, exports) {

let $dd8e1ec3f9d1cb33$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd8e1ec3f9d1cb33$var$load("6chG6").then(()=>parcelRequire('klvFQ'));

});

parcelRegister("g0SoK", function(module, exports) {

let $ba86d7c94acc26c5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ba86d7c94acc26c5$var$load("bXBzb").then(()=>parcelRequire('fXwAq'));

});

parcelRegister("dOr8D", function(module, exports) {

let $a0e4fefaf988d9b0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a0e4fefaf988d9b0$var$load("fMgo4").then(()=>parcelRequire('8ZHVH'));

});

parcelRegister("eAsKQ", function(module, exports) {

let $a9eabb8433af1a71$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a9eabb8433af1a71$var$load("1HBhy").then(()=>parcelRequire('5kpn9'));

});

parcelRegister("b6GRB", function(module, exports) {

let $816181108f87e114$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $816181108f87e114$var$load("9YSn1").then(()=>parcelRequire('cql7z'));

});

parcelRegister("juEKn", function(module, exports) {

let $e3106d2ec9b70e82$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e3106d2ec9b70e82$var$load("40Jja").then(()=>parcelRequire('gYqMF'));

});

parcelRegister("2ORjt", function(module, exports) {

let $20d99b2a51a6915d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $20d99b2a51a6915d$var$load("ibJOL").then(()=>parcelRequire('oyKRX'));

});

parcelRegister("gnt5x", function(module, exports) {

let $bec55ba52dad228a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bec55ba52dad228a$var$load("ipGTo").then(()=>parcelRequire('9FWL3'));

});

parcelRegister("lTqxa", function(module, exports) {

let $ff035117e6327794$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff035117e6327794$var$load("1dEiK").then(()=>parcelRequire('5SliH'));

});

parcelRegister("5UKAA", function(module, exports) {

let $44e6525118de287d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $44e6525118de287d$var$load("bNIzh").then(()=>parcelRequire('ecW9b'));

});

parcelRegister("ls3Hr", function(module, exports) {

let $f9df1529a958cc99$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f9df1529a958cc99$var$load("bjl5Z").then(()=>parcelRequire('lGdFo'));

});

parcelRegister("d0iA6", function(module, exports) {

let $9779b04e13c8d738$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9779b04e13c8d738$var$load("7A6MW").then(()=>parcelRequire('jf2AA'));

});

parcelRegister("fmmjN", function(module, exports) {

let $b2ea3905cd9abd94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b2ea3905cd9abd94$var$load("gu0nB").then(()=>parcelRequire('50EZL'));

});

parcelRegister("hbMa0", function(module, exports) {

let $c838d2638f928cbe$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c838d2638f928cbe$var$load("2xhtF").then(()=>parcelRequire('dZU7K'));

});

parcelRegister("1QisB", function(module, exports) {

let $1578f79daacfef72$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1578f79daacfef72$var$load("iwPoV").then(()=>parcelRequire('7yjbB'));

});

parcelRegister("lz3e7", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $5qzNs = parcelRequire("5qzNs");


var $lvsjl = parcelRequire("lvsjl");

const $a714a9fde214d42c$export$f8e186cd2da1abff = 100;
const $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT = 767;
function $a714a9fde214d42c$export$2a50c0408cf3ddb8() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $42omo.useState)(window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT);
    const [handleResizeDebounced] = (0, $lvsjl.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= $a714a9fde214d42c$var$MOBILE_WIDTH_BREAKPOINT;
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, $a714a9fde214d42c$export$f8e186cd2da1abff);
    (0, $42omo.useEffect)(()=>{
        let unbind;
        unbind = (0, $fFa3V.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
}
const $a714a9fde214d42c$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($5qzNs)))(item, ...properties);
const $a714a9fde214d42c$export$fdd2c0ba94025c3c = (contextConfig)=>contextConfig.enabled ? contextConfig.cloudId : '';
const $a714a9fde214d42c$export$5a762450d50ca901 = (contextConfig)=>contextConfig.enabled ? contextConfig.orgId : undefined;
module.exports["useIsResponsiveView"] = $a714a9fde214d42c$export$2a50c0408cf3ddb8;
module.exports["omitSafely"] = $a714a9fde214d42c$export$d6eadbd047ebd460;
module.exports["getCloudId"] = $a714a9fde214d42c$export$fdd2c0ba94025c3c;
module.exports["getOrgId"] = $a714a9fde214d42c$export$5a762450d50ca901;

});

parcelRegister("5qzNs", function(module, exports) {

var $5ukOg = parcelRequire("5ukOg");


var $ipwYn = parcelRequire("ipwYn");


var $5kt6R = parcelRequire("5kt6R");


var $f2rYC = parcelRequire("f2rYC");


var $gR42R = parcelRequire("gR42R");


var $5baaE = parcelRequire("5baaE");


var $5Nw7l = parcelRequire("5Nw7l");


var $jHiyU = parcelRequire("jHiyU");

/** Used to compose bitmasks for cloning. */ var $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG = 1, $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG = 2, $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $3f3b25eb0c07a9d2$var$omit = $5Nw7l(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = $5ukOg(paths, function(path) {
        path = $f2rYC(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    $gR42R(object, $jHiyU(object), result);
    if (isDeep) result = $ipwYn(result, $3f3b25eb0c07a9d2$var$CLONE_DEEP_FLAG | $3f3b25eb0c07a9d2$var$CLONE_FLAT_FLAG | $3f3b25eb0c07a9d2$var$CLONE_SYMBOLS_FLAG, $5baaE);
    var length = paths.length;
    while(length--)$5kt6R(result, paths[length]);
    return result;
});
module.exports = $3f3b25eb0c07a9d2$var$omit;

});

parcelRegister("ipwYn", function(module, exports) {

var $en5bh = parcelRequire("en5bh");


var $hLryH = parcelRequire("hLryH");


var $jykdj = parcelRequire("jykdj");


var $3g4Fn = parcelRequire("3g4Fn");


var $juOMD = parcelRequire("juOMD");


var $dYI4C = parcelRequire("dYI4C");


var $irmBX = parcelRequire("irmBX");


var $3qHtb = parcelRequire("3qHtb");


var $80RNM = parcelRequire("80RNM");


var $d5B92 = parcelRequire("d5B92");


var $jHiyU = parcelRequire("jHiyU");


var $1WABR = parcelRequire("1WABR");


var $1Z3rm = parcelRequire("1Z3rm");


var $ka5vO = parcelRequire("ka5vO");


var $8LtzT = parcelRequire("8LtzT");


var $fZxmY = parcelRequire("fZxmY");


var $cSA01 = parcelRequire("cSA01");


var $83PD5 = parcelRequire("83PD5");


var $lc9ud = parcelRequire("lc9ud");


var $6b9OI = parcelRequire("6b9OI");


var $d6TaN = parcelRequire("d6TaN");


var $jVTxf = parcelRequire("jVTxf");

/** Used to compose bitmasks for cloning. */ var $d674238523d4f2bb$var$CLONE_DEEP_FLAG = 1, $d674238523d4f2bb$var$CLONE_FLAT_FLAG = 2, $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $d674238523d4f2bb$var$argsTag = '[object Arguments]', $d674238523d4f2bb$var$arrayTag = '[object Array]', $d674238523d4f2bb$var$boolTag = '[object Boolean]', $d674238523d4f2bb$var$dateTag = '[object Date]', $d674238523d4f2bb$var$errorTag = '[object Error]', $d674238523d4f2bb$var$funcTag = '[object Function]', $d674238523d4f2bb$var$genTag = '[object GeneratorFunction]', $d674238523d4f2bb$var$mapTag = '[object Map]', $d674238523d4f2bb$var$numberTag = '[object Number]', $d674238523d4f2bb$var$objectTag = '[object Object]', $d674238523d4f2bb$var$regexpTag = '[object RegExp]', $d674238523d4f2bb$var$setTag = '[object Set]', $d674238523d4f2bb$var$stringTag = '[object String]', $d674238523d4f2bb$var$symbolTag = '[object Symbol]', $d674238523d4f2bb$var$weakMapTag = '[object WeakMap]';
var $d674238523d4f2bb$var$arrayBufferTag = '[object ArrayBuffer]', $d674238523d4f2bb$var$dataViewTag = '[object DataView]', $d674238523d4f2bb$var$float32Tag = '[object Float32Array]', $d674238523d4f2bb$var$float64Tag = '[object Float64Array]', $d674238523d4f2bb$var$int8Tag = '[object Int8Array]', $d674238523d4f2bb$var$int16Tag = '[object Int16Array]', $d674238523d4f2bb$var$int32Tag = '[object Int32Array]', $d674238523d4f2bb$var$uint8Tag = '[object Uint8Array]', $d674238523d4f2bb$var$uint8ClampedTag = '[object Uint8ClampedArray]', $d674238523d4f2bb$var$uint16Tag = '[object Uint16Array]', $d674238523d4f2bb$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $d674238523d4f2bb$var$cloneableTags = {};
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$argsTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$arrayBufferTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dataViewTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$boolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$dateTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$float64Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$int32Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$mapTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$numberTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$objectTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$regexpTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$setTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$stringTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$symbolTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint8ClampedTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint16Tag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$uint32Tag] = true;
$d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$errorTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$funcTag] = $d674238523d4f2bb$var$cloneableTags[$d674238523d4f2bb$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $d674238523d4f2bb$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $d674238523d4f2bb$var$CLONE_DEEP_FLAG, isFlat = bitmask & $d674238523d4f2bb$var$CLONE_FLAT_FLAG, isFull = bitmask & $d674238523d4f2bb$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lc9ud(value)) return value;
    var isArr = $fZxmY(value);
    if (isArr) {
        result = $1Z3rm(value);
        if (!isDeep) return $irmBX(value, result);
    } else {
        var tag = $1WABR(value), isFunc = tag == $d674238523d4f2bb$var$funcTag || tag == $d674238523d4f2bb$var$genTag;
        if ($cSA01(value)) return $dYI4C(value, isDeep);
        if (tag == $d674238523d4f2bb$var$objectTag || tag == $d674238523d4f2bb$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $8LtzT(value);
            if (!isDeep) return isFlat ? $80RNM(value, $juOMD(result, value)) : $3qHtb(value, $3g4Fn(result, value));
        } else {
            if (!$d674238523d4f2bb$var$cloneableTags[tag]) return object ? value : {};
            result = $ka5vO(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $en5bh);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($6b9OI(value)) value.forEach(function(subValue) {
        result.add($d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($83PD5(value)) value.forEach(function(subValue, key) {
        result.set(key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $jHiyU : $d5B92 : isFlat ? $jVTxf : $d6TaN;
    var props = isArr ? undefined : keysFunc(value);
    $hLryH(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $jykdj(result, key, $d674238523d4f2bb$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $d674238523d4f2bb$var$baseClone;

});

parcelRegister("hLryH", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $ceec3402dc147ea9$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $ceec3402dc147ea9$var$arrayEach;

});

parcelRegister("3g4Fn", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $d6TaN = parcelRequire("d6TaN");

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $25f67c63e240b594$var$baseAssign(object, source) {
    return object && $gR42R(source, $d6TaN(source), object);
}
module.exports = $25f67c63e240b594$var$baseAssign;

});

parcelRegister("juOMD", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jVTxf = parcelRequire("jVTxf");

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $e318362ea5151771$var$baseAssignIn(object, source) {
    return object && $gR42R(source, $jVTxf(source), object);
}
module.exports = $e318362ea5151771$var$baseAssignIn;

});

parcelRegister("3qHtb", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $jcne3 = parcelRequire("jcne3");

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $27f584f8141687cb$var$copySymbols(source, object) {
    return $gR42R(source, $jcne3(source), object);
}
module.exports = $27f584f8141687cb$var$copySymbols;

});

parcelRegister("80RNM", function(module, exports) {

var $gR42R = parcelRequire("gR42R");


var $75Obx = parcelRequire("75Obx");

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $5d580ec319704467$var$copySymbolsIn(source, object) {
    return $gR42R(source, $75Obx(source), object);
}
module.exports = $5d580ec319704467$var$copySymbolsIn;

});

parcelRegister("1Z3rm", function(module, exports) {
/** Used for built-in method references. */ var $171e28212cd49be3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $171e28212cd49be3$var$hasOwnProperty = $171e28212cd49be3$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $171e28212cd49be3$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $171e28212cd49be3$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $171e28212cd49be3$var$initCloneArray;

});

parcelRegister("ka5vO", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");


var $43GUE = parcelRequire("43GUE");


var $62nGv = parcelRequire("62nGv");


var $eBmVy = parcelRequire("eBmVy");


var $jDkcM = parcelRequire("jDkcM");

/** `Object#toString` result references. */ var $ead9046a77579327$var$boolTag = '[object Boolean]', $ead9046a77579327$var$dateTag = '[object Date]', $ead9046a77579327$var$mapTag = '[object Map]', $ead9046a77579327$var$numberTag = '[object Number]', $ead9046a77579327$var$regexpTag = '[object RegExp]', $ead9046a77579327$var$setTag = '[object Set]', $ead9046a77579327$var$stringTag = '[object String]', $ead9046a77579327$var$symbolTag = '[object Symbol]';
var $ead9046a77579327$var$arrayBufferTag = '[object ArrayBuffer]', $ead9046a77579327$var$dataViewTag = '[object DataView]', $ead9046a77579327$var$float32Tag = '[object Float32Array]', $ead9046a77579327$var$float64Tag = '[object Float64Array]', $ead9046a77579327$var$int8Tag = '[object Int8Array]', $ead9046a77579327$var$int16Tag = '[object Int16Array]', $ead9046a77579327$var$int32Tag = '[object Int32Array]', $ead9046a77579327$var$uint8Tag = '[object Uint8Array]', $ead9046a77579327$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ead9046a77579327$var$uint16Tag = '[object Uint16Array]', $ead9046a77579327$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $ead9046a77579327$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $ead9046a77579327$var$arrayBufferTag:
            return $jZrbP(object);
        case $ead9046a77579327$var$boolTag:
        case $ead9046a77579327$var$dateTag:
            return new Ctor(+object);
        case $ead9046a77579327$var$dataViewTag:
            return $43GUE(object, isDeep);
        case $ead9046a77579327$var$float32Tag:
        case $ead9046a77579327$var$float64Tag:
        case $ead9046a77579327$var$int8Tag:
        case $ead9046a77579327$var$int16Tag:
        case $ead9046a77579327$var$int32Tag:
        case $ead9046a77579327$var$uint8Tag:
        case $ead9046a77579327$var$uint8ClampedTag:
        case $ead9046a77579327$var$uint16Tag:
        case $ead9046a77579327$var$uint32Tag:
            return $jDkcM(object, isDeep);
        case $ead9046a77579327$var$mapTag:
            return new Ctor;
        case $ead9046a77579327$var$numberTag:
        case $ead9046a77579327$var$stringTag:
            return new Ctor(object);
        case $ead9046a77579327$var$regexpTag:
            return $62nGv(object);
        case $ead9046a77579327$var$setTag:
            return new Ctor;
        case $ead9046a77579327$var$symbolTag:
            return $eBmVy(object);
    }
}
module.exports = $ead9046a77579327$var$initCloneByTag;

});

parcelRegister("43GUE", function(module, exports) {

var $jZrbP = parcelRequire("jZrbP");

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $2f48bad00268e015$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jZrbP(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $2f48bad00268e015$var$cloneDataView;

});

parcelRegister("62nGv", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $46554d38b2abfa6c$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $46554d38b2abfa6c$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $46554d38b2abfa6c$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $46554d38b2abfa6c$var$cloneRegExp;

});

parcelRegister("eBmVy", function(module, exports) {

var $agzqu = parcelRequire("agzqu");

/** Used to convert symbols to primitives and strings. */ var $aa164e47d9e5bdc6$var$symbolProto = $agzqu ? $agzqu.prototype : undefined, $aa164e47d9e5bdc6$var$symbolValueOf = $aa164e47d9e5bdc6$var$symbolProto ? $aa164e47d9e5bdc6$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $aa164e47d9e5bdc6$var$cloneSymbol(symbol) {
    return $aa164e47d9e5bdc6$var$symbolValueOf ? Object($aa164e47d9e5bdc6$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $aa164e47d9e5bdc6$var$cloneSymbol;

});

parcelRegister("83PD5", function(module, exports) {

var $3Ap6k = parcelRequire("3Ap6k");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $5de6a718766ecdb3$var$nodeIsMap = $cl53l && $cl53l.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $5de6a718766ecdb3$var$isMap = $5de6a718766ecdb3$var$nodeIsMap ? $dFnBO($5de6a718766ecdb3$var$nodeIsMap) : $3Ap6k;
module.exports = $5de6a718766ecdb3$var$isMap;

});

parcelRegister("3Ap6k", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $29c8346be35e214d$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $29c8346be35e214d$var$baseIsMap(value) {
    return $6eZU2(value) && $1WABR(value) == $29c8346be35e214d$var$mapTag;
}
module.exports = $29c8346be35e214d$var$baseIsMap;

});

parcelRegister("6b9OI", function(module, exports) {

var $sQE8x = parcelRequire("sQE8x");


var $dFnBO = parcelRequire("dFnBO");


var $cl53l = parcelRequire("cl53l");

/* Node.js helper references. */ var $47fb629c5fa31bac$var$nodeIsSet = $cl53l && $cl53l.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $47fb629c5fa31bac$var$isSet = $47fb629c5fa31bac$var$nodeIsSet ? $dFnBO($47fb629c5fa31bac$var$nodeIsSet) : $sQE8x;
module.exports = $47fb629c5fa31bac$var$isSet;

});

parcelRegister("sQE8x", function(module, exports) {

var $1WABR = parcelRequire("1WABR");


var $6eZU2 = parcelRequire("6eZU2");

/** `Object#toString` result references. */ var $056b741c66fd28fb$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $056b741c66fd28fb$var$baseIsSet(value) {
    return $6eZU2(value) && $1WABR(value) == $056b741c66fd28fb$var$setTag;
}
module.exports = $056b741c66fd28fb$var$baseIsSet;

});

parcelRegister("5kt6R", function(module, exports) {

var $f2rYC = parcelRequire("f2rYC");


var $apAFY = parcelRequire("apAFY");


var $9rfkh = parcelRequire("9rfkh");


var $w287Y = parcelRequire("w287Y");

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $3e1566926de40aab$var$baseUnset(object, path) {
    path = $f2rYC(path, object);
    object = $9rfkh(object, path);
    return object == null || delete object[$w287Y($apAFY(path))];
}
module.exports = $3e1566926de40aab$var$baseUnset;

});

parcelRegister("9rfkh", function(module, exports) {

var $aT80v = parcelRequire("aT80v");


var $3BqCC = parcelRequire("3BqCC");

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $6df28623e183fd76$var$parent(object, path) {
    return path.length < 2 ? object : $aT80v(object, $3BqCC(path, 0, -1));
}
module.exports = $6df28623e183fd76$var$parent;

});

parcelRegister("5baaE", function(module, exports) {

var $gTZCn = parcelRequire("gTZCn");

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $3c55de8c787dd7a6$var$customOmitClone(value) {
    return $gTZCn(value) ? undefined : value;
}
module.exports = $3c55de8c787dd7a6$var$customOmitClone;

});

parcelRegister("5Nw7l", function(module, exports) {

var $5qOzM = parcelRequire("5qOzM");


var $iK2Oc = parcelRequire("iK2Oc");


var $gnVVm = parcelRequire("gnVVm");

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $438a713c021efc47$var$flatRest(func) {
    return $gnVVm($iK2Oc(func, undefined, $5qOzM), func + '');
}
module.exports = $438a713c021efc47$var$flatRest;

});

parcelRegister("5qOzM", function(module, exports) {

var $8jC8i = parcelRequire("8jC8i");

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $3f469ccb29f16086$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $8jC8i(array, 1) : [];
}
module.exports = $3f469ccb29f16086$var$flatten;

});

parcelRegister("8jC8i", function(module, exports) {

var $hwwIB = parcelRequire("hwwIB");


var $ifqdW = parcelRequire("ifqdW");

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $60ddad71e9a2305d$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $ifqdW);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $60ddad71e9a2305d$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hwwIB(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $60ddad71e9a2305d$var$baseFlatten;

});

parcelRegister("ifqdW", function(module, exports) {

var $agzqu = parcelRequire("agzqu");


var $dI6Ko = parcelRequire("dI6Ko");


var $fZxmY = parcelRequire("fZxmY");

/** Built-in value references. */ var $d48df83729a0e096$var$spreadableSymbol = $agzqu ? $agzqu.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $d48df83729a0e096$var$isFlattenable(value) {
    return $fZxmY(value) || $dI6Ko(value) || !!($d48df83729a0e096$var$spreadableSymbol && value && value[$d48df83729a0e096$var$spreadableSymbol]);
}
module.exports = $d48df83729a0e096$var$isFlattenable;

});

parcelRegister("lvsjl", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa82743632a2ad8f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $fa82743632a2ad8f$export$2e2bcd8739ae039(callback, delay, options) {
    if (options === void 0) options = {};
    var maxWait = options.maxWait;
    var maxWaitHandler = (0, $42omo.useRef)(null);
    var maxWaitArgs = (0, $42omo.useRef)([]);
    var leading = options.leading;
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = (0, $42omo.useRef)(false);
    var functionTimeoutHandler = (0, $42omo.useRef)(null);
    var isComponentUnmounted = (0, $42omo.useRef)(false);
    var debouncedFunction = (0, $42omo.useRef)(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = (0, $42omo.useCallback)(function() {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    (0, $42omo.useEffect)(function() {
        // We have to set isComponentUnmounted to be truth, as fast-refresh runs all useEffects
        isComponentUnmounted.current = false;
        return function() {
            // we use flag, as we allow to call callPending outside the hook
            isComponentUnmounted.current = true;
        };
    }, []);
    var debouncedCallback = (0, $42omo.useCallback)(function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) leadingCall.current = false;
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function() {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) shouldCallFunction = false;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) debouncedFunction.current.apply(debouncedFunction, args);
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) maxWaitHandler.current = setTimeout(function() {
            var args = maxWaitArgs.current;
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current) debouncedFunction.current.apply(null, args);
        }, maxWait);
    }, [
        maxWait,
        delay,
        cancelDebouncedCallback,
        leading,
        trailing
    ]);
    var callPending = (0, $42omo.useCallback)(function() {
        // Call pending callback only if we have anything in our queue
        if (!functionTimeoutHandler.current) return;
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [
        cancelDebouncedCallback
    ]);
    // At the moment, we use 3 args array so that we save backward compatibility
    return [
        debouncedCallback,
        cancelDebouncedCallback,
        callPending
    ];
}

});

parcelRegister("aH9Q1", function(module, exports) {

var $2xciB = parcelRequire("2xciB");


var $58Nu8 = parcelRequire("58Nu8");


var $56LFI = parcelRequire("56LFI");

const $da1a55ed1292d791$var$cache = (0, $2xciB.createCache)(new Map());
function $da1a55ed1292d791$export$e83743682263315a(loader, opts) {
    return $da1a55ed1292d791$var$cache.get(opts.moduleId, ()=>(0, $58Nu8.PreloadableJSResource)(()=>(0, $56LFI.postTask)(loader, {
                priority: 'user-visible'
            }), opts));
}
module.exports["JSResourceForInteraction"] = $da1a55ed1292d791$export$e83743682263315a;

});

parcelRegister("2xciB", function(module, exports) {
function $148a59911478cb25$export$cf6fa0bbcc94b912(store) {
    return {
        get (key, supplier) {
            const value = store.get(key);
            if (value != null) return value;
            const v = supplier();
            store.set(key, v);
            return v;
        }
    };
}
module.exports["createCache"] = $148a59911478cb25$export$cf6fa0bbcc94b912;

});

parcelRegister("58Nu8", function(module, exports) {

var $2X3nY = parcelRequire("2X3nY");

function $ba332286d251cd41$export$4fe5fba5bb1d3c09(loader, opts) {
    const resource = (0, $2X3nY.JSResource)(loader, opts);
    return Object.assign(resource, {
        preload () {
            const jsModule = resource.getModuleIfRequired();
            if (jsModule != null) return;
            resource.load().catch(()=>{});
        }
    });
}
module.exports["PreloadableJSResource"] = $ba332286d251cd41$export$4fe5fba5bb1d3c09;

});

parcelRegister("2X3nY", function(module, exports) {

var $6hmze = parcelRequire("6hmze");


var $cAXnn = parcelRequire("cAXnn");


var $7Z6yP = parcelRequire("7Z6yP");

function $39dd57c545107221$export$148e45a6d4b4d65(loader, opts) {
    const { moduleId: moduleId, moduleName: moduleName, modulePath: modulePath, priority: priority } = opts;
    const listeners = new Set();
    let promise;
    let state = {
        type: 'init'
    };
    function createOnLoad(event) {
        return (module)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.complete', event);
            state = {
                type: 'module',
                module: module
            };
            for (const listener of listeners)listener.onLoad(module);
        };
    }
    function createOnError(event) {
        return (error)=>{
            (0, $cAXnn.eventEmitter).emit('jsresource.load.error', {
                ...event,
                error: error
            });
            state = {
                type: 'error',
                error: error
            };
            for (const listener of listeners)listener.onError?.(error);
        };
    }
    return {
        getModuleId () {
            return moduleId;
        },
        getModuleName () {
            return moduleName;
        },
        getModulePath () {
            return modulePath;
        },
        getPriority () {
            return priority;
        },
        getModuleIfRequired () {
            if (state.type === 'error') throw state.error;
            return state.type === 'module' ? state.module : null;
        },
        load () {
            if (!promise) {
                const event = {
                    moduleId: moduleId,
                    transactionId: (0, $6hmze.generateId)()
                };
                const onError = createOnError(event);
                const onLoad = createOnLoad(event);
                (0, $cAXnn.eventEmitter).emit('jsresource.load.start', event);
                try {
                    promise = loader().then((result)=>{
                        const module = (0, $7Z6yP.isJSModuleWithDefaultExport)(result) ? result.default : result;
                        onLoad(module);
                        return module;
                    }).catch((error)=>{
                        onError(error);
                        throw error;
                    });
                } catch (error) {
                    if (error instanceof Error) onError(error);
                    promise = Promise.reject(error);
                }
            }
            return promise;
        },
        onComplete (onLoad, onError) {
            if (state.type === 'module') {
                onLoad(state.module);
                return ()=>{};
            }
            if (state.type === 'error') {
                onError?.(state.error);
                return ()=>{};
            }
            const listener = {
                onError: onError,
                onLoad: onLoad
            };
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
}
module.exports["JSResource"] = $39dd57c545107221$export$148e45a6d4b4d65;

});

parcelRegister("6hmze", function(module, exports) {
let $546b0d6600b43919$var$id = 100000;
function $546b0d6600b43919$export$567fc7097e064344() {
    $546b0d6600b43919$var$id += 1;
    return $546b0d6600b43919$var$id.toString();
}
module.exports["generateId"] = $546b0d6600b43919$export$567fc7097e064344;

});

parcelRegister("cAXnn", function(module, exports) {
function $df7beae67697fe3a$var$createEventEmitter() {
    const eventSubscribers = new Map();
    return {
        emit (eventName, event) {
            const subscribers = eventSubscribers.get(eventName);
            for (const subscriber of subscribers ?? [])subscriber(event);
        },
        on (eventName, subscriber) {
            if (!eventSubscribers.has(eventName)) eventSubscribers.set(eventName, new Set([
                subscriber
            ]));
            else eventSubscribers.get(eventName).add(subscriber);
            return ()=>{
                const set = eventSubscribers.get(eventName);
                set.delete(subscriber);
                if (set.size === 0) eventSubscribers.delete(eventName);
            };
        }
    };
}
const $df7beae67697fe3a$export$10dc3edfc20c8ff = $df7beae67697fe3a$var$createEventEmitter();
module.exports["eventEmitter"] = $df7beae67697fe3a$export$10dc3edfc20c8ff;

});

parcelRegister("7Z6yP", function(module, exports) {
function $1cfe6d8b66e6a41d$export$3b514faac3ba993c(module) {
    try {
        // This should be replaced with Object.hasOwn once it is more widely supported
        return Object.prototype.hasOwnProperty.call(module, 'default');
    } catch (_) {
        // This fallback will occur when module is undefined, or null after converting to Object.hasOwn
        return false;
    }
}
module.exports["isJSModuleWithDefaultExport"] = $1cfe6d8b66e6a41d$export$3b514faac3ba993c;

});

parcelRegister("56LFI", function(module, exports) {
async function $d3c226111d006051$var$toPromise(callback) {
    return callback();
}
function $d3c226111d006051$var$getScheduler(obj) {
    if ('scheduler' in obj && obj.scheduler !== 'undefined') return obj.scheduler;
}

function $d3c226111d006051$export$13c9d02ca54955a3(callback, options) {
    // Dynamically import the scheduler-polyfill module, so browsers that do support the Prioritized Task Scheduling API
    // do not pay the performance cost (e.g. bundle size, runtime, etc).
    const scheduler = $d3c226111d006051$var$getScheduler(globalThis);
    if (!scheduler) {
        // Only load the polyfill if we are using the background priority
        if (options.priority === 'background') // This polyfill will be removed once the Prioritized Task Scheduling API is more widely supported in browsers.
        // eslint-disable-next-line import/dynamic-import-chunkname
        // @ts-ignore error TS7016: Could not find a declaration file for module 'scheduler-polyfill' seen in Jira Typechecking (Cypress) step
        return (parcelRequire("j5M61")).then(()=>$d3c226111d006051$var$getScheduler(globalThis).postTask(callback, options));
        return $d3c226111d006051$var$toPromise(callback);
    }
    return scheduler.postTask(callback, options);
}
module.exports["postTask"] = $d3c226111d006051$export$13c9d02ca54955a3;

});

parcelRegister("j5M61", function(module, exports) {

let $de63cad6e511e9d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $de63cad6e511e9d7$var$load("5a167").then(()=>parcelRequire('jUuBC'));

});

parcelRegister("cab2i", function(module, exports) {
/* eslint-disable @typescript-eslint/ban-types */ function $991254190d627578$export$fa00dd5c1a75592f(// The param types can only be inferred if the shape of the entrypoint (i.e. root and getPreloadProps) is specified
// within the function definition itself. Using EntryPoint, EntryPointComponent, or a custom EntryPointRepresentation
// in place of this will cause Root to be inferred as an 'unknown' type.
params) {
    return params;
}
module.exports["createEntryPoint"] = $991254190d627578$export$fa00dd5c1a75592f;

});

parcelRegister("fxgOI", function(module, exports) {

let $b4f6fb9518af3928$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b4f6fb9518af3928$var$load("7do1E"),
    $b4f6fb9518af3928$var$load("77dkW"),
    $b4f6fb9518af3928$var$load("6wr18"),
    $b4f6fb9518af3928$var$load("3VpLA"),
    $b4f6fb9518af3928$var$load("iYF63"),
    $b4f6fb9518af3928$var$load("ffEVr"),
    $b4f6fb9518af3928$var$load("7EorR"),
    $b4f6fb9518af3928$var$load("ixLhb")
]).then(()=>parcelRequire('6C7bq'));

});

parcelRegister("1KBSi", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $fEhQK = parcelRequire("fEhQK");

const $15029de520f1b9e8$export$cadd7e072478f5e = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(7);
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const t0 = !isLicensed;
    let t1;
    if ($[0] !== t0) {
        t1 = {
            skip: t0
        };
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)((0, $fEhQK.default), t1);
    let t2;
    if ($[2] !== canCreateData?.user?.confluence?.operations) {
        t2 = canCreateData?.user?.confluence?.operations.some($15029de520f1b9e8$var$_temp);
        $[2] = canCreateData?.user?.confluence?.operations;
        $[3] = t2;
    } else t2 = $[3];
    const canCreateSpace = Boolean(t2);
    let t3;
    if ($[4] !== canCreateSpace || $[5] !== loading) {
        t3 = {
            canCreateSpace: canCreateSpace,
            loading: loading
        };
        $[4] = canCreateSpace;
        $[5] = loading;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
} : ()=>{
    const { isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { data: canCreateData, loading: loading } = (0, $jMyy4.useQueryInterop)(// Due to circular dependency issues we are using the PreloadCreateSpaceQuery from create-space-preload package
    (0, $fEhQK.default), {
        skip: !isLicensed
    });
    const canCreateSpace = Boolean(canCreateData?.user?.confluence?.operations.some((obj)=>obj?.operation === 'create_space'));
    return {
        canCreateSpace: canCreateSpace,
        loading: loading
    };
};
function $15029de520f1b9e8$var$_temp(obj) {
    return obj?.operation === "create_space";
}
module.exports["useCanCreateSpace"] = $15029de520f1b9e8$export$cadd7e072478f5e;

});

parcelRegister("3Yga2", function(module, exports) {

var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6mKj3 = parcelRequire("6mKj3");

const $6522d8231f11b4f4$var$MAX_TIMES_SHOWN = 3;
const $6522d8231f11b4f4$export$2dd930e418397758 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return true;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    return currentValue < $6522d8231f11b4f4$var$MAX_TIMES_SHOWN;
};
const $6522d8231f11b4f4$export$ac038305f1d136b9 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    const currentValue = Number((0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER));
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, currentValue + 1);
};
const $6522d8231f11b4f4$export$78c6def31d4333a6 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, $6522d8231f11b4f4$var$MAX_TIMES_SHOWN);
};
const $6522d8231f11b4f4$export$fb6c8b2f3b8bb597 = ()=>{
    if (!(0, $6mKj3.expValEquals)('confluence_hide_live_doc_lozenge', 'isEnabled', true)) return;
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER, 0);
};
module.exports["checkShouldShowLozenge"] = $6522d8231f11b4f4$export$2dd930e418397758;
module.exports["iterateLozengeShownTracker"] = $6522d8231f11b4f4$export$ac038305f1d136b9;
module.exports["setLozengeShownTrackerMax"] = $6522d8231f11b4f4$export$78c6def31d4333a6;

});

parcelRegister("7EIq6", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jtuBN = parcelRequire("jtuBN");


var $iLgzu = parcelRequire("iLgzu");


var $7NtNc = parcelRequire("7NtNc");

function $649b778bbd82b1bb$export$1defcb29347f9ac6(spaceKey) {
    const $ = (0, $frIzR.c)(18);
    const t0 = spaceKey !== undefined;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1,
            promotedSpaceKey: null
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== t0) {
        t2 = {
            skip: t0,
            variables: t1
        };
        $[1] = t0;
        $[2] = t2;
    } else t2 = $[2];
    const { data: defaultSpaceKeyData, loading: isDefaultSpaceKeyLoading } = (0, $iLgzu.useExperimentalPromotedSpacesQuery)(t2);
    const t3 = !spaceKey && !defaultSpaceKeyData;
    const t4 = spaceKey || defaultSpaceKeyData?.experimentalPromotedSpaces?.nodes?.[0]?.id;
    let t5;
    if ($[3] !== t4) {
        t5 = {
            spaceKey: t4
        };
        $[3] = t4;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== t3 || $[6] !== t5) {
        t6 = {
            errorPolicy: "all",
            skip: t3,
            variables: t5
        };
        $[5] = t3;
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    const spaceEnabledContentTypesQueryOptions = t6;
    const { data: enabledContentTypesData, loading: isAnyContentTypesLoading } = (0, $jtuBN.useQueryNoFurtherUpdateInterop)((0, $7NtNc.SpaceEnabledContentTypesQuery), spaceEnabledContentTypesQueryOptions);
    const enabledContentTypes = enabledContentTypesData?.space?.spaceTypeSettings?.enabledContentTypes;
    let t7;
    if ($[8] !== enabledContentTypes) {
        t7 = enabledContentTypes === undefined || Object.values(enabledContentTypes).some($649b778bbd82b1bb$var$_temp);
        $[8] = enabledContentTypes;
        $[9] = t7;
    } else t7 = $[9];
    const hasUndefinedContentTypes = t7;
    const isLoading = isDefaultSpaceKeyLoading || isAnyContentTypesLoading || hasUndefinedContentTypes;
    const t8 = Boolean(enabledContentTypes?.isWhiteboardsEnabled);
    const t9 = Boolean(enabledContentTypes?.isBlogsEnabled);
    const t10 = Boolean(enabledContentTypes?.isDatabasesEnabled);
    const t11 = Boolean(enabledContentTypes?.isEmbedsEnabled);
    const t12 = Boolean(enabledContentTypes?.isLivePagesEnabled);
    const t13 = Boolean(enabledContentTypes?.isFoldersEnabled);
    let t14;
    if ($[10] !== isLoading || $[11] !== t10 || $[12] !== t11 || $[13] !== t12 || $[14] !== t13 || $[15] !== t8 || $[16] !== t9) {
        t14 = {
            isCreateWhiteboardEnabled: t8,
            isCreateBlogEnabled: t9,
            isCreateDatabaseEnabled: t10,
            isCreateSmartLinkEnabled: t11,
            isCreateLiveDocEnabled: t12,
            isCreateFolderEnabled: t13,
            isLoading: isLoading
        };
        $[10] = isLoading;
        $[11] = t10;
        $[12] = t11;
        $[13] = t12;
        $[14] = t13;
        $[15] = t8;
        $[16] = t9;
        $[17] = t14;
    } else t14 = $[17];
    return t14;
}
function $649b778bbd82b1bb$var$_temp(type) {
    return type === undefined;
}
module.exports["useSpaceEnabledContentTypes"] = $649b778bbd82b1bb$export$1defcb29347f9ac6;

});

parcelRegister("iLgzu", function(module, exports) {

var $jaPWl = parcelRequire("jaPWl");


var $dK51B = parcelRequire("dK51B");

const $e671a111e943b77f$export$409ac92b3aba27f5 = ({ skip: skip, onError: onError, variables: variables = {}, fetchPolicy: fetchPolicy } = {})=>{
    const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables.promotedSpaceKey || '';
    return (0, $dK51B.useExperimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        },
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalPromotedSpacesQuery"] = $e671a111e943b77f$export$409ac92b3aba27f5;

});

parcelRegister("jaPWl", function(module, exports) {
var $5e96abf23293f6d5$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $5e96abf23293f6d5$export$483c11740a902fcd;

});

parcelRegister("7NtNc", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $ada047e01258ab08$export$a08098e2700d7e94 = (0, $eSUdr.default)`query SpaceEnabledContentTypesQuery($spaceKey:String){space(key:$spaceKey){id key spaceTypeSettings{enabledContentTypes{isBlogsEnabled isDatabasesEnabled isEmbedsEnabled isLivePagesEnabled isWhiteboardsEnabled isFoldersEnabled}}}}`;
module.exports["SpaceEnabledContentTypesQuery"] = $ada047e01258ab08$export$a08098e2700d7e94;

});

parcelRegister("eB1TF", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $1P1Tu.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $9zUhf.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $9zUhf.createActionsHook)($bf0e479659c73d50$var$Store);
module.exports["useUniversalCreateState"] = $bf0e479659c73d50$export$c7381b2490bb4d36;
module.exports["useUniversalCreateActions"] = $bf0e479659c73d50$export$6c5b9a107b000099;

});

parcelRegister("yuLaV", function(module, exports) {

var $lzcvT = parcelRequire("lzcvT");


var $5spQU = parcelRequire("5spQU");


var $9wGTI = parcelRequire("9wGTI");

const $705f1ec06aff7fce$export$dd376e644565eb89 = (contentType)=>{
    if (contentType === 'database' || contentType === 'whiteboard' || contentType === 'slide') {
        // Gate ON: environment-aware enablement via feature encoding; Gate OFF: legacy FedRAMP fallback
        if ((0, $9wGTI.fg)('use_frontend_feature_encoding_sdk')) {
            const featureKeyMap = {
                database: 'confluence-databases',
                slide: 'confluence-slides',
                whiteboard: 'confluence-whiteboards'
            };
            return (0, $5spQU.isFeatureEnabled)('confluence', featureKeyMap[contentType]);
        }
        return !(0, $lzcvT.isFedRamp)();
    }
    return true;
};
module.exports["isContentTypeEnabledInCurrentEnv"] = $705f1ec06aff7fce$export$dd376e644565eb89;

});

parcelRegister("kDja4", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9wGTI = parcelRequire("9wGTI");


var $yuLaV = parcelRequire("yuLaV");

// These flags are no longer used in confluence and can be removed from this array entirely after we confirm that have been removed from the whiteboards side too
const $9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS = [
    'headerV1',
    'headerV2',
    'whiteboardArchive',
    'removeWhiteboardsHome',
    'removeWhiteboardsHomeInSideNav',
    'whiteboardCreation',
    'whiteboardsEnabled',
    'whiteboardBifrost',
    'whiteboardVersionHistory'
];
const $9cbb170f29556407$export$6f83cfa4fd660300 = ()=>{
    const isWhiteboardsEnabledInEnv = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)('whiteboard');
    const isWhiteboardFeatureEnabled = (0, $42omo.useCallback)((featureName)=>{
        if (featureName === 'whiteboardsEnabled') return isWhiteboardsEnabledInEnv;
        // If the FF has been cleaned up on our end just return true
        if ($9cbb170f29556407$var$ARCHIVED_FEATURE_FLAGS.some((feature)=>feature === featureName)) return true;
        // Use static feature gate calls to satisfy confluence-feature-gating/static-feature-gates
        switch(featureName){
            case 'whiteboardSolidHeader':
                return (0, $9wGTI.fg)('confluence_frontend_solid_whiteboard_header');
            case 'whiteboardOptOut':
                return (0, $9wGTI.fg)('whiteboards_compliance_opt_out');
            case 'digitalTeammate':
                return (0, $9wGTI.fg)('cc-ai-whiteboards-enable-digital-teammate');
            case 'aiFirstCreation':
                return (0, $9wGTI.fg)('aifc_create_enabled');
            default:
                return false;
        }
    }, [
        isWhiteboardsEnabledInEnv
    ]);
    const isWhiteboardCreationDropdownEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    const isWhiteboardGAOnboardingEnabled = (0, $42omo.useCallback)(()=>{
        return isWhiteboardFeatureEnabled('whiteboardsEnabled') && !isWhiteboardFeatureEnabled('whiteboardOptOut');
    }, [
        isWhiteboardFeatureEnabled
    ]);
    return {
        platformFeatureFlagResolver: (0, $dh538.getBooleanFF),
        isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled,
        isWhiteboardCreationDropdownEnabled: isWhiteboardCreationDropdownEnabled,
        isWhiteboardGAOnboardingEnabled: isWhiteboardGAOnboardingEnabled
    };
};
module.exports["useIsWhiteboardFeatureEnabled"] = $9cbb170f29556407$export$6f83cfa4fd660300;

});

parcelRegister("8cKgI", function(module, exports) {

var $917iu = parcelRequire("917iu");


var $6mKj3 = parcelRequire("6mKj3");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");


var $JCGnt = parcelRequire("JCGnt");

const $36afb9ae9aa29505$var$FIRST_TWO_WEEKS_THRESHOLD = 14;
const $36afb9ae9aa29505$export$272725b5c7da7eec = ({ skip: skip } = {})=>{
    const { isNewUser: isNewUser, loading: isNewUserLoading } = (0, $JCGnt.useIsNewUser)({
        activeDaysThreshold: $36afb9ae9aa29505$var$FIRST_TWO_WEEKS_THRESHOLD
    });
    // Only fetch onboarding state when isNewUser is indeterminate (not a boolean)
    const { data: onboardingStateData, loading: isOnboardingStateLoading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.ONBOARDING_EXPERIENCES).NTH_USER_ONBOARDING_COMPLETED_TIMESTAMP
    ], !isNewUserLoading && typeof isNewUser === 'boolean');
    const { nthUserOnboardingCompletedTimestamp: nthUserOnboardingCompletedTimestamp } = (0, $ivb8S.deserializeState)(onboardingStateData);
    // newUser trait can have a latency leading to an indeterminate value,
    // as a fallback we check if the user onboarded within the threshold based on the onboarding completed timestamp
    const completedTimestamp = Number(nthUserOnboardingCompletedTimestamp);
    const isUserOnboardedRecently = Boolean(completedTimestamp) && (0, $917iu.default)(new Date(), new Date(completedTimestamp)) <= $36afb9ae9aa29505$var$FIRST_TWO_WEEKS_THRESHOLD;
    // When skip is true, return without calling expVal (which fires exposure).
    // This is used by the global create menu to avoid firing exposure on every page load,
    // deferring it until the menu is actually opened.
    // Note: hooks above must still be called unconditionally to satisfy React's rules of hooks.
    if (skip) return {
        isEnabled: false,
        loading: false
    };
    // If still loading, don't enable yet
    if (isNewUserLoading || isOnboardingStateLoading) return {
        isEnabled: false,
        loading: true
    };
    // If isNewUser resolved to a definitive boolean, use it directly
    if (typeof isNewUser === 'boolean') {
        if (!isNewUser) return {
            isEnabled: false,
            loading: false
        };
        return {
            isEnabled: (0, $6mKj3.expVal)('cfind-5291-template-touchpoint', 'isEnabled', false),
            loading: false
        };
    }
    // Fallback: isNewUser is indeterminate, use onboarding timestamp
    if (!isUserOnboardedRecently) return {
        isEnabled: false,
        loading: false
    };
    return {
        isEnabled: (0, $6mKj3.expVal)('cfind-5291-template-touchpoint', 'isEnabled', false),
        loading: false
    };
};
module.exports["useCfind5291TemplateTouchpoint"] = $36afb9ae9aa29505$export$272725b5c7da7eec;

});

parcelRegister("JCGnt", function(module, exports) {

var $6vgLy = parcelRequire("6vgLy");


var $f7MuR = parcelRequire("f7MuR");

const $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $affa2edf03b5b535$export$750d18e9348a361a = ({ activeDaysThreshold: activeDaysThreshold = 28, activeUserCutoffDate: activeUserCutoffDate }, skip = false)=>{
    const { data: data, loading: loading, error: error } = (0, $f7MuR.useSiteUserTraits)({
        skipBootstrap: skip
    });
    const confluenceFirstActive = data?.attributes?.find(({ name: name })=>name === $affa2edf03b5b535$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const firstActiveDate = confluenceFirstActive ? new Date(confluenceFirstActive) : null;
    const { isNewlyCreatedUser: isNewlyCreatedUser } = (0, $6vgLy.useShouldExcludeUser)({
        checkDate: firstActiveDate,
        daysThreshold: activeDaysThreshold,
        cutoffDate: activeUserCutoffDate
    });
    if (loading) return {
        isNewUser: null,
        loading: true
    };
    if (error) return {
        isNewUser: null,
        error: error
    };
    return {
        isNewUser: isNewlyCreatedUser,
        loading: false,
        error: null
    };
};
module.exports["useIsNewUser"] = $affa2edf03b5b535$export$750d18e9348a361a;

});

parcelRegister("6vgLy", function(module, exports) {

var $922yL = parcelRequire("922yL");

var $e0SBo = parcelRequire("e0SBo");

var $cFEpk = parcelRequire("cFEpk");

const $859f2d1feb92d345$export$30b189c21f25ee23 = ({ checkDate: checkDate, daysThreshold: daysThreshold = 14, cutoffDate: cutoffDate })=>{
    // If there is no check date, we cannot determine if user is new
    if (!checkDate) return {
        shouldExclude: true,
        isNewlyCreatedUser: null,
        isNewUserAfterCutoffDate: false
    };
    const isNewlyCreatedUser = (0, $e0SBo.default)((0, $922yL.default)(checkDate, daysThreshold), new Date());
    // Check if user is a new user (date is AFTER the cutoff date)
    // These users don't need changeboarding since it's all new to them
    const isNewUserAfterCutoffDate = cutoffDate && (0, $cFEpk.default)(cutoffDate) ? (0, $e0SBo.default)(checkDate, cutoffDate) : false;
    const shouldExclude = isNewlyCreatedUser || isNewUserAfterCutoffDate;
    return {
        shouldExclude: shouldExclude,
        isNewlyCreatedUser: isNewlyCreatedUser,
        isNewUserAfterCutoffDate: isNewUserAfterCutoffDate
    };
};
module.exports["useShouldExcludeUser"] = $859f2d1feb92d345$export$30b189c21f25ee23;

});

parcelRegister("f7MuR", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");


var $60cDW = parcelRequire("60cDW");


var $dcJRl = parcelRequire("dcJRl");

const $26d702ce000cc6e9$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $26d702ce000cc6e9$var$actions = {
    start: ()=>({ setState: setState })=>{
            setState({
                loading: true,
                error: null
            });
        },
    success: (data)=>({ setState: setState })=>{
            setState({
                data: data,
                loading: false,
                error: null
            });
        },
    error: (err)=>({ setState: setState })=>{
            setState({
                error: err,
                loading: false
            });
        },
    reset: ()=>({ setState: setState })=>{
            setState({
                data: null,
                loading: false,
                error: null
            });
        }
};
const $26d702ce000cc6e9$export$39f521003d60a645 = (0, $1P1Tu.createStore)({
    initialState: $26d702ce000cc6e9$var$initialState,
    actions: $26d702ce000cc6e9$var$actions,
    name: 'siteUserTraitsStore'
});
const $26d702ce000cc6e9$export$55703aaacc066827 = (0, $9zUhf.createHook)($26d702ce000cc6e9$export$39f521003d60a645);
const $26d702ce000cc6e9$export$60cc1c45e628d86f = (0, $9zUhf.createActionsHook)($26d702ce000cc6e9$export$39f521003d60a645);
async function $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId) {
    const res = await (0, $f7B1p.cfetch)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`, {
        method: 'GET'
    });
    if (!res.ok) {
        const text = await res.text().catch(()=>'');
        throw new Error(`Request failed with ${res.status}: ${text || res.statusText}`);
    }
    return await res.json();
}
// Use a module-level variable to ensure we only fetch once per app lifecycle
// This way multiple components using the hook won't trigger multiple fetches
let $26d702ce000cc6e9$var$hasFetched = false;
function $26d702ce000cc6e9$export$f1fbc6ad89f91b89() {
    $26d702ce000cc6e9$var$hasFetched = false;
}
function $26d702ce000cc6e9$var$getSiteUserTraitsFromSources() {
    let attributes = null;
    // First check window.__SSR_TAP_CONTEXT__ which contains raw tapContext data
    if (typeof window !== 'undefined' && window.__SSR_TAP_CONTEXT__) {
        attributes = (0, $dcJRl.formatTapTraits)(window.__SSR_TAP_CONTEXT__.siteUser);
        if (attributes) return {
            attributes: attributes
        };
    }
    // Fallback to getSSRRenderInputs() for SSR scenarios
    const { tapContext: tapContext } = (0, $60cDW.getSSRRenderInputs)();
    attributes = (0, $dcJRl.formatTapTraits)(tapContext?.siteUser);
    if (attributes) return {
        attributes: attributes
    };
    return null;
}
function $26d702ce000cc6e9$export$f02520a2cf0afa96({ skipBootstrap: skipBootstrap } = {}) {
    const preloadedData = (0, $42omo.useMemo)(()=>$26d702ce000cc6e9$var$getSiteUserTraitsFromSources(), []);
    const [{ data: data, loading: loading, error: error }, storeActions] = $26d702ce000cc6e9$export$55703aaacc066827();
    const { accessStatus: accessStatus, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const hasLicensedAccess = accessStatus === 'LICENSED_USE_ACCESS' || accessStatus === 'LICENSED_ADMIN_ACCESS';
    (0, $42omo.useEffect)(()=>{
        if (preloadedData || data || loading || error) return;
        if ($26d702ce000cc6e9$var$hasFetched || skipBootstrap) return;
        if (!hasLicensedAccess || !cloudId || !userId) return;
        $26d702ce000cc6e9$var$hasFetched = true;
        storeActions.start();
        $26d702ce000cc6e9$var$fetchSiteUserTraitsData(cloudId, userId).then(storeActions.success).catch(storeActions.error);
    }, [
        skipBootstrap,
        preloadedData,
        data,
        loading,
        error,
        storeActions,
        hasLicensedAccess,
        cloudId,
        userId
    ]);
    if (preloadedData) return {
        data: preloadedData,
        loading: false,
        error: null
    };
    return {
        data: data,
        loading: loading,
        error: error
    };
}
module.exports["useSiteUserTraits"] = $26d702ce000cc6e9$export$f02520a2cf0afa96;

});

parcelRegister("dcJRl", function(module, exports) {
const $1eca0028b5407519$export$bab1229873daab56 = (tapTraits)=>{
    if (!tapTraits || Object.entries(tapTraits).length === 0) return null;
    return Object.entries(tapTraits).reduce((acc, [name, value])=>[
            ...acc,
            {
                name: name,
                value: String(value)
            }
        ], []);
};
module.exports["formatTapTraits"] = $1eca0028b5407519$export$bab1229873daab56;

});

parcelRegister("fSDMD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $2Yaht = parcelRequire("2Yaht");


var $cQDYl = parcelRequire("cQDYl");


var $7hpmn = parcelRequire("7hpmn");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $jojoK = parcelRequire("jojoK");


var $7aRa9 = parcelRequire("7aRa9");


var $4R3wx = parcelRequire("4R3wx");


var $9uAPw = parcelRequire("9uAPw");


var $dPJCf = parcelRequire("dPJCf");


var $7QM6o = parcelRequire("7QM6o");


var $lqy4C = parcelRequire("lqy4C");


var $bZSO8 = parcelRequire("bZSO8");


var $h7OOD = parcelRequire("h7OOD");


var $5Krdf = parcelRequire("5Krdf");

const $30211231850ecfc1$var$i18n = (0, $cgtv4.defineMessages)({
    openingLoomRecorder: {
        id: "create-blank-fabric-page.create.content.loom-video.opening-loom-recorder",
        defaultMessage: "Opening Loom recorder"
    },
    loomVideoTitle: {
        id: "create-blank-fabric-page.create.content.loom-video.title",
        defaultMessage: "Loom video"
    }
});
const $30211231850ecfc1$var$iconWrapperStyles = (0, $ecnYn.xcss)({
    display: 'flex',
    flexShrink: 0
});
const $30211231850ecfc1$export$fb281ae10f502d32 = ()=>{
    const $ = (0, $frIzR.c)(1);
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [
            "BETA",
            "CO_USE",
            "CROSS_JOIN"
        ];
        $[0] = t0;
    } else t0 = $[0];
    return t0.includes(entryPointVariant);
};
const $30211231850ecfc1$var$RecordLoomPopoverItemComponent = (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { entryPointLocation: entryPointLocation, flags: flags, onClick: onClick, onRecorderOpenComplete: onRecorderOpenComplete, source: source, spaceKey: spaceKey, parentId: parentId, withFallback: t1, isDisabled: t2, location: t3 } = t0;
    const withFallback = t1 === undefined ? false : t1;
    const isDisabled = t2 === undefined ? false : t2;
    const location = t3 === undefined ? "" : t3;
    const intl = (0, $8C5kA.default)();
    const prefersReducedMotion = (0, $7hpmn.useIsReducedMotion)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = {
            source: "record-loom-popover-item"
        };
        $[0] = t4;
    } else t4 = $[0];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t4);
    const prevIsOpeningRecorder = (0, $42omo.useRef)(false);
    let t5;
    if ($[1] !== entryPointLocation || $[2] !== flags) {
        t5 = {
            entryPointLocation: entryPointLocation,
            flags: flags
        };
        $[1] = entryPointLocation;
        $[2] = flags;
        $[3] = t5;
    } else t5 = $[3];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized, isOpeningRecorder: isOpeningRecorder } = (0, $9uAPw.useLoomRecorderEntryPoint)(t5);
    let t6;
    let t7;
    if ($[4] !== isOpeningRecorder || $[5] !== onRecorderOpenComplete) {
        t6 = ()=>{
            if (prevIsOpeningRecorder.current && !isOpeningRecorder) onRecorderOpenComplete?.();
            prevIsOpeningRecorder.current = isOpeningRecorder;
        };
        t7 = [
            isOpeningRecorder,
            onRecorderOpenComplete
        ];
        $[4] = isOpeningRecorder;
        $[5] = onRecorderOpenComplete;
        $[6] = t6;
        $[7] = t7;
    } else {
        t6 = $[6];
        t7 = $[7];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[8] !== createAnalyticsEvent || $[9] !== location || $[10] !== onClick || $[11] !== openLoomRecorder || $[12] !== parentId || $[13] !== push || $[14] !== source || $[15] !== spaceId || $[16] !== spaceKey || $[17] !== withFallback) {
        t8 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        ...withFallback && {
                            withFallback: withFallback
                        },
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $jojoK.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: location
            });
        };
        $[8] = createAnalyticsEvent;
        $[9] = location;
        $[10] = onClick;
        $[11] = openLoomRecorder;
        $[12] = parentId;
        $[13] = push;
        $[14] = source;
        $[15] = spaceId;
        $[16] = spaceKey;
        $[17] = withFallback;
        $[18] = t8;
    } else t8 = $[18];
    const handleClick = t8;
    let t9;
    if ($[19] !== enforceStorageLimit || $[20] !== handleClick) {
        t9 = enforceStorageLimit(handleClick);
        $[19] = enforceStorageLimit;
        $[20] = handleClick;
        $[21] = t9;
    } else t9 = $[21];
    const handleClickWithStorageEnforcement = t9;
    let t10;
    if ($[22] !== handleClickWithStorageEnforcement || $[23] !== intl || $[24] !== isDisabled || $[25] !== isLoomRecorderInitialized || $[26] !== isOpeningRecorder || $[27] !== prefersReducedMotion) {
        t10 = !isLoomRecorderInitialized ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cQDYl.default), {
            hasIcon: true,
            isShimmering: !prefersReducedMotion,
            testId: "skeleton-create-menu-button-item"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.MenuItemWrapper), {
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $h7OOD.LoadingPopoverItem), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.ContentIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $30211231850ecfc1$var$iconWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yaht))), {
                label: "",
                color: "var(--ds-icon-subtle, #505258)"
            }))),
            isLoading: isOpeningRecorder,
            loadingLabel: intl.formatMessage($30211231850ecfc1$var$i18n.openingLoomRecorder),
            onClick: handleClickWithStorageEnforcement,
            testId: "create-menu-button-item",
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.TitleContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5Krdf.ContentTitle), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $30211231850ecfc1$var$i18n.loomVideoTitle)))));
        $[22] = handleClickWithStorageEnforcement;
        $[23] = intl;
        $[24] = isDisabled;
        $[25] = isLoomRecorderInitialized;
        $[26] = isOpeningRecorder;
        $[27] = prefersReducedMotion;
        $[28] = t10;
    } else t10 = $[28];
    const menuItem = t10;
    return menuItem;
};
const $30211231850ecfc1$export$4d5ee8c1efd60993 = (0, $7aRa9.withFlags)($30211231850ecfc1$var$RecordLoomPopoverItemComponent);
module.exports["useIsCreateMenuLoomRecorderEntryPointEnabled"] = $30211231850ecfc1$export$fb281ae10f502d32;
module.exports["RecordLoomPopoverItem"] = $30211231850ecfc1$export$4d5ee8c1efd60993;

});

parcelRegister("cQDYl", function(module, exports) {
/* skeleton-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e0b2ee147542345d$var$skeletonItemElemSize = 20;
const $e0b2ee147542345d$var$N20A = 'rgba(9, 30, 66, 0.04)';
const $e0b2ee147542345d$var$N30A = 'rgba(9, 30, 66, 0.08)';
const $e0b2ee147542345d$var$styles = {
    root: "_1rjcze3t _18zrv47k _1e0c1txw _1tke1ylp _4cvr1h6o _lcxvglyw _14mj53f4 _1qdgrdoj _1hfkizff _aetrb3bt _3mxot94y",
    defaultWidth: "_sf1e1n8h _4rfy1ssb _baud1nrf _mr7o1vuk _69tq19wn _kt4d1n05",
    customWidth: "_11w8rzut",
    beforeElement: "_1mp4gktf _kfgtgktf _7bjqidpf _1rusizff _1kt9b3bt _1mbqdlk8 _1rhxv77o",
    avatar: "_rfx31rr0",
    icon: "_rfx3fajl",
    sideNavSkeleton: "_18zru2gc _kfgt1k8s _1mbqpxbi _1mp41k8s"
};
/**
 * These styles are mirrored in:
 * packages/design-system/theme/src/constants.tsx
 * packages/design-system/menu/src/menu-item/skeleton-heading-item.tsx
 *
 * Please update both.
 */ const $e0b2ee147542345d$var$shimmerKeyframes = null; /**
                                * These styles are defined using `css` rather than `cssMap` as there is a bug when using
                                * `cssMap` that causes a build failure due to the use of keyframes within this pseudo-element.
                                */ 
const $e0b2ee147542345d$var$shimmerStyles = null; /**
                             * __Skeleton item__
                             *
                             * A skeleton item is used in place of an item when its contents it not ready.
                             *
                             * - [Examples](https://atlaskit.atlassian.com/packages/design-system/menu/docs/skeleton-item)
                             * - [Code](https://atlaskit.atlassian.com/packages/design-system/menu)
                             */ 
const $e0b2ee147542345d$var$SkeletonItem = ({ hasAvatar: hasAvatar, hasIcon: hasIcon, isShimmering: isShimmering = false, isSideNavSkeleton: isSideNavSkeleton = false, testId: testId, width: width, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $e0b2ee147542345d$var$styles.root,
            (hasAvatar || hasIcon) && $e0b2ee147542345d$var$styles.beforeElement,
            hasAvatar && $e0b2ee147542345d$var$styles.avatar,
            hasIcon && $e0b2ee147542345d$var$styles.icon,
            width ? $e0b2ee147542345d$var$styles.customWidth : $e0b2ee147542345d$var$styles.defaultWidth,
            isSideNavSkeleton && $e0b2ee147542345d$var$styles.sideNavSkeleton,
            isShimmering && "",
            isShimmering && "_unfq1yy8 _9nev1yy8 _kwc012o8 _joxl12o8 _18f312c5 _evp612c5 _19oh1254 _10881254 _18lgp3kn _zo24p3kn _1hfkizff _1rusizff",
            xcss
        ]),
        style: {
            '--width': width
        },
        "data-testid": testId
    });
};
var $e0b2ee147542345d$export$2e2bcd8739ae039 = $e0b2ee147542345d$var$SkeletonItem;
module.exports["default"] = $e0b2ee147542345d$export$2e2bcd8739ae039;

});

parcelRegister("jojoK", function(module, exports) {
const $6eadce97261b744f$var$LOOM_URL_REGEX = // @ts-ignore - TS1503 TypeScript 5.9.2 upgrade
RegExp("^https:\\/\\/(.*?\\.)?(loom\\..*?\\/(share|embed))\\/([a-zA-Z0-9-]*-)?(?<videoId>[a-f0-9]{32})");
function $6eadce97261b744f$var$extractLoomVideoId(url) {
    const match = url.match($6eadce97261b744f$var$LOOM_URL_REGEX);
    return match?.groups?.videoId;
}
async function $6eadce97261b744f$var$digestMessage(message) {
    // https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
    if (window?.crypto?.subtle?.digest) {
        const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8); // hash the message
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
        const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join(''); // convert bytes to hex string
        return hashHex;
    }
    return '';
}
async function $6eadce97261b744f$export$495fb2ecc80ca6c0(url) {
    try {
        const videoId = $6eadce97261b744f$var$extractLoomVideoId(url);
        if (videoId) {
            const data = atob('c2U1UTwgekZlVEYkP1MzRno1QmV5WXBoSE13SHg8RWpjM10saHJQZmhPMVVHKHM=') + videoId;
            const digestHex = await $6eadce97261b744f$var$digestMessage(data);
            return digestHex ? `vidhash-${digestHex}` : '';
        }
        return '';
    } catch (_) {
        return '';
    }
}
module.exports["getHashedLoomVideoIdFromUrl"] = $6eadce97261b744f$export$495fb2ecc80ca6c0;

});

parcelRegister("4R3wx", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $932VV = parcelRequire("932VV");


var $cYe4v = parcelRequire("cYe4v");


var $dpJII = parcelRequire("dpJII");


var $eNjW4 = parcelRequire("eNjW4");

const $c8aabf9b2e3d2d10$export$62184c98af916d7a = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(10);
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    let t0;
    if ($[0] !== isBetaEnabled || $[1] !== isLoomDisabled || $[2] !== isLoomEntryPointsEnabled) {
        t0 = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell");
        $[0] = isBetaEnabled;
        $[1] = isLoomDisabled;
        $[2] = isLoomEntryPointsEnabled;
        $[3] = t0;
    } else t0 = $[3];
    const skipPermsCheck = t0;
    const t1 = skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t2;
    if ($[4] !== t1) {
        t2 = {
            skip: t1
        };
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)(t2);
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) {
        let t3;
        if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[6] = t3;
        } else t3 = $[6];
        return t3;
    }
    if (isBetaEnabled) {
        let t3;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "BETA"
            };
            $[7] = t3;
        } else t3 = $[7];
        return t3;
    }
    if (!(0, $9wGTI.fg)("confluence_frontend_loom_cross_sell")) {
        let t3;
        if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[8] = t3;
        } else t3 = $[8];
        return t3;
    }
    if (loomEntryPointVariant.entryPointVariant === "CROSS_FLOW" && (0, $9wGTI.fg)("confluence_frontend_loom_cross_flow_ads_opt_out")) {
        let t3;
        if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                entryPointVariant: "DISABLED"
            };
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    return loomEntryPointVariant;
} : ()=>{
    const isBetaEnabled = (0, $cYe4v.useIsLoomBetaEnabled)();
    const isLoomDisabled = (0, $eNjW4.useIsLoomDisabled)();
    const isLoomEntryPointsEnabled = (0, $932VV.useIsLoomEntryPointsEnabled)();
    // This can be replaced entirely by `isLoomDisabled` once Loom Beta is cleaned up
    const skipPermsCheck = !isLoomEntryPointsEnabled || isBetaEnabled || isLoomDisabled || !(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell');
    const loomEntryPointVariant = (0, $dpJII.useLoomPermissionStatus)({
        // If the entry point variant has been SSRd, use that result and skip the permissions check
        skip: skipPermsCheck || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    // If the entry point already exists via SSR, return that value in the hook here (no need to check anything else)
    if (window.__SSR_LOOM_ENTRY_POINT__) return window.__SSR_LOOM_ENTRY_POINT__;
    if (isLoomDisabled || !isLoomEntryPointsEnabled) return {
        entryPointVariant: 'DISABLED'
    };
    if (isBetaEnabled) return {
        entryPointVariant: 'BETA'
    };
    // This should be moved into useIsLoomDisabled once Loom Beta is cleaned up.
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) return {
        entryPointVariant: 'DISABLED'
    };
    if (loomEntryPointVariant.entryPointVariant === 'CROSS_FLOW' && (0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) return {
        entryPointVariant: 'DISABLED'
    };
    return loomEntryPointVariant;
};
module.exports["useLoomEntryPointVariant"] = $c8aabf9b2e3d2d10$export$62184c98af916d7a;

});

parcelRegister("932VV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dHiKK = parcelRequire("dHiKK");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $7Sm4c = parcelRequire("7Sm4c");


var $i8Ofl = parcelRequire("i8Ofl");

const $45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery = (0, $dHiKK.default);
const $45094daeb894a50e$export$5d821a9fc4b7faa = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(11);
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            cloudId: cloudId
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== activationId || $[3] !== cloudId) {
        t1 = (0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId);
        $[2] = activationId;
        $[3] = cloudId;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== t1) {
        t2 = {
            headers: {
                ...t1
            }
        };
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const t3 = shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__);
    let t4;
    if ($[7] !== t0 || $[8] !== t2 || $[9] !== t3) {
        t4 = {
            variables: t0,
            context: t2,
            skip: t3
        };
        $[7] = t0;
        $[8] = t2;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, t4);
    if (window.__SSR_LOOM_ENTRY_POINT__) return;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
} : ()=>{
    const { accessStatus: accessStatus, activationId: activationId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS && accessStatus !== (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($45094daeb894a50e$var$UseIsLoomEntryPointsEnabledQuery, {
        variables: {
            cloudId: cloudId
        },
        context: {
            headers: {
                ...(0, $i8Ofl.createAtlAttributionHeader)(cloudId, activationId)
            }
        },
        skip: shouldSkip || Boolean(window.__SSR_LOOM_ENTRY_POINT__)
    });
    if (window.__SSR_LOOM_ENTRY_POINT__) return undefined;
    if (error) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return true;
    }
    if (!loading && data) return data?.confluence_loomEntryPoints?.isLoomEntryPointsEnabled;
};
module.exports["useIsLoomEntryPointsEnabled"] = $45094daeb894a50e$export$5d821a9fc4b7faa;

});

parcelRegister("dHiKK", function(module, exports) {
/**
 * @generated SignedSource<<b0fb41d42738db4128917afea956b213>>
 * @relayHash 255e1eee858b61b7fb061e8b9eb8fbc9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0
const $dc96dcb71a986382$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                }
            ],
            "concreteType": "ConfluenceLoomEntryPoints",
            "kind": "LinkedField",
            "name": "confluence_loomEntryPoints",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isLoomEntryPointsEnabled"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsLoomEntryPointsEnabledQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "255e1eee858b61b7fb061e8b9eb8fbc9",
            "id": "52be4f1688dfc9b763d15d15e543dcc1f7fa631a706f30d258877564a282dbc0",
            "metadata": {},
            "name": "useIsLoomEntryPointsEnabledQuery",
            "operationKind": "query",
            "text": "query useIsLoomEntryPointsEnabledQuery($cloudId:ID!){confluence_loomEntryPoints(cloudId:$cloudId){isLoomEntryPointsEnabled}}"
        }
    };
}();
$dc96dcb71a986382$var$node.hash = "767e6480b08dd1cf6643fe7ca065c357";
var $dc96dcb71a986382$export$2e2bcd8739ae039 = $dc96dcb71a986382$var$node;
module.exports["default"] = $dc96dcb71a986382$export$2e2bcd8739ae039;

});

parcelRegister("i8Ofl", function(module, exports) {
const $bde9a1914731baf3$var$PRODUCT = 'Confluence Cloud';
const $bde9a1914731baf3$var$buildWorkspaceId = (tenantId, activationId)=>{
    return `ari:cloud:confluence:${tenantId}:workspace/${activationId}`;
};
const $bde9a1914731baf3$export$14ef296862e3705e = (tenantId, activationId)=>{
    const atlAttributionHeader = {
        atlWorkspaceId: $bde9a1914731baf3$var$buildWorkspaceId(tenantId, activationId),
        tenantId: tenantId,
        product: $bde9a1914731baf3$var$PRODUCT,
        service: 'cc-fe-bifrost'
    };
    return {
        'atl-attribution': JSON.stringify(atlAttributionHeader)
    };
};
module.exports["createAtlAttributionHeader"] = $bde9a1914731baf3$export$14ef296862e3705e;

});

parcelRegister("cYe4v", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $9wGTI = parcelRequire("9wGTI");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $8dwdz = parcelRequire("8dwdz");

const $9ecfddb6136413dc$export$a3777efa0eef336c = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
        $[0] = t0;
    } else t0 = $[0];
    const isMobileDeviceOrMobileWeb = t0;
    let t1;
    if ($[1] !== isConfluenceLicensed) {
        t1 = isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)("confluence_loom_beta_enabled");
        $[1] = isConfluenceLicensed;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};
module.exports["useIsLoomBetaEnabled"] = $9ecfddb6136413dc$export$a3777efa0eef336c;

});

parcelRegister("dpJII", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $5CUwy = parcelRequire("5CUwy");

const $42c1694041a86183$export$da228976f78945fd = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(12);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { skip: t2 } = t1;
    const skip = t2 === undefined ? false : t2;
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [t3, t4] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { loomEntryPointVariant: loomEntryPointVariant } = t3;
    const { initLoomEntryPointVariant: initLoomEntryPointVariant } = t4;
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    let t5;
    let t6;
    if ($[2] !== cloudId || $[3] !== entryPointVariant || $[4] !== environment || $[5] !== initLoomEntryPointVariant || $[6] !== loading || $[7] !== skip || $[8] !== userId) {
        t5 = ()=>{
            if (skip) return;
            if (entryPointVariant === "NONE" && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
        };
        t6 = [
            cloudId,
            initLoomEntryPointVariant,
            loading,
            entryPointVariant,
            skip,
            userId,
            environment
        ];
        $[2] = cloudId;
        $[3] = entryPointVariant;
        $[4] = environment;
        $[5] = initLoomEntryPointVariant;
        $[6] = loading;
        $[7] = skip;
        $[8] = userId;
        $[9] = t5;
        $[10] = t6;
    } else {
        t5 = $[9];
        t6 = $[10];
    }
    (0, $42omo.useEffect)(t5, t6);
    if (entryPointVariant === "NONE") {
        let t7;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = {
                entryPointVariant: "NONE",
                loading: true
            };
            $[11] = t7;
        } else t7 = $[11];
        return t7;
    }
    return loomEntryPointVariant;
} : ({ skip: skip = false } = {})=>{
    const { cloudId: cloudId, userId: userId, environment: environment } = (0, $bQm3c.useSessionData)();
    const [{ loomEntryPointVariant: loomEntryPointVariant }, { initLoomEntryPointVariant: initLoomEntryPointVariant }] = (0, $5CUwy.useLoomEntryPointVariantState)();
    const { entryPointVariant: entryPointVariant, loading: loading } = loomEntryPointVariant;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        if (entryPointVariant === 'NONE' && !loading) initLoomEntryPointVariant(cloudId, userId, environment);
    }, [
        cloudId,
        initLoomEntryPointVariant,
        loading,
        entryPointVariant,
        skip,
        userId,
        environment
    ]);
    if (entryPointVariant === 'NONE') return {
        entryPointVariant: 'NONE',
        loading: true
    };
    return loomEntryPointVariant;
};
module.exports["useLoomPermissionStatus"] = $42c1694041a86183$export$da228976f78945fd;

});

parcelRegister("5CUwy", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cbc8g = parcelRequire("cbc8g");


var $c0rhi = parcelRequire("c0rhi");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");



var $8999o = parcelRequire("8999o");


var $lnyJf = parcelRequire("lnyJf");


var $8J8QJ = parcelRequire("8J8QJ");


var $2gAEP = parcelRequire("2gAEP");

var $9633e2f0bea217d1$export$ebe749be4eb13ac4 = /*#__PURE__*/ function(LoomTenantProvisionStatus) {
    LoomTenantProvisionStatus["PROVISIONED"] = "provisioned";
    LoomTenantProvisionStatus["NOT_PROVISIONED"] = "not-provisioned";
    LoomTenantProvisionStatus["ERROR"] = "error,";
    return LoomTenantProvisionStatus;
}({});
var $9633e2f0bea217d1$export$7909e54672d1c423 = /*#__PURE__*/ function(LoomUserPermissionStatus) {
    LoomUserPermissionStatus["PERMITTED"] = "permitted";
    LoomUserPermissionStatus["NOT_PERMITTED"] = "not-permitted";
    LoomUserPermissionStatus["ERROR"] = "error,";
    return LoomUserPermissionStatus;
}({});
const $9633e2f0bea217d1$var$getLoomTenantProvisionStatus = async ()=>{
    try {
        const licensedProducts = await (0, $c0rhi.queryInterop)({
            query: (0, $2gAEP.default)
        });
        const isTenantLicensed = licensedProducts.data.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === 'ACTIVE');
        return isTenantLicensed ? "provisioned" : "not-provisioned";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$export$85de6c803181afa9 = async (cloudId, userId, environment)=>{
    const resourceId = `ari:cloud:loom::site/${cloudId}`;
    try {
        let permitted;
        {
            const response = await (0, $8J8QJ.postJson)(`/gateway/api/permissions/permitted`, {
                permissionId: 'write',
                resourceId: resourceId,
                checkProductStatus: true
            });
            permitted = response?.permitted;
        }
        return !!permitted ? "permitted" : "not-permitted";
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return "error,";
    }
};
const $9633e2f0bea217d1$var$initialState = {
    loomEntryPointVariant: window.__SSR_LOOM_ENTRY_POINT__ ? window.__SSR_LOOM_ENTRY_POINT__ : {
        entryPointVariant: 'NONE'
    }
};
const $9633e2f0bea217d1$export$cbb01c57ec9c933e = {
    initLoomEntryPointVariant: (cloudId, userId, environment)=>async ({ getState: getState, setState: setState })=>{
            const state = getState();
            if (state.loomEntryPointVariant.entryPointVariant !== 'NONE') return;
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_FLOW',
                    loading: true
                }
            });
            const loomTenantProvisionStatus = await $9633e2f0bea217d1$var$getLoomTenantProvisionStatus();
            if (loomTenantProvisionStatus === "not-provisioned") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW'
                    }
                });
                return;
            }
            if (loomTenantProvisionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_FLOW',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CROSS_JOIN',
                    loading: true
                }
            });
            const loomUserPermissionStatus = await $9633e2f0bea217d1$export$85de6c803181afa9(cloudId, userId, environment);
            if (loomUserPermissionStatus === "not-permitted") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN'
                    }
                });
                return;
            }
            if (loomUserPermissionStatus === "error,") {
                setState({
                    loomEntryPointVariant: {
                        entryPointVariant: 'CROSS_JOIN',
                        error: true
                    }
                });
                return;
            }
            setState({
                loomEntryPointVariant: {
                    entryPointVariant: 'CO_USE'
                }
            });
        },
    crossFlowSuccessCheck: ({ cloudId: cloudId, onCrossflowFailure: onCrossflowFailure, createAnalyticsEvent: createAnalyticsEvent, sourceComponent: sourceComponent })=>async ({ setState: setState })=>{
            // refetch license information since TCS doesn't update automatically
            try {
                const { ok: hasLoom, tries: tries } = await (0, $8999o.waitUntil)({
                    fn: ()=>(0, $lnyJf.fetchLicenseInformation)(cloudId),
                    condition: (info)=>info.products['loom']?.state === 'ACTIVE',
                    maxTries: 2,
                    // arbitrarily deciding on just 1 retry until we have more data to understand the eventual consistency here
                    retryWait: 500
                });
                (0, $cbc8g.addUFOCustomData)({
                    pollingTries: tries,
                    hasLoom: hasLoom
                });
                if (hasLoom) {
                    // don't bother getLoomUserPermissionStatus here, we assume if the site has loom, the admin will have been given a license during provisioning
                    setState({
                        loomEntryPointVariant: {
                            entryPointVariant: 'CO_USE'
                        }
                    });
                    //This is needed for SSR to work correctly, since we skip logic in useLoomEntryPointVariant.ts if the entry point was SSR-ed
                    window.__SSR_LOOM_ENTRY_POINT__ = {
                        entryPointVariant: 'CO_USE'
                    };
                } else onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'success',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            hasLoom: hasLoom,
                            tries: tries,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            } catch (error) {
                onCrossflowFailure && onCrossflowFailure();
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        actionSubject: 'confluenceLoomUtils.fetchLicenseInformation',
                        action: 'fail',
                        source: 'confluenceLoomUtils',
                        attributes: {
                            error: error.message,
                            sourceComponent: sourceComponent
                        }
                    }
                }).fire();
            }
        }
};
const $9633e2f0bea217d1$var$loomEntryPointVariantStore = (0, $1P1Tu.createStore)({
    initialState: $9633e2f0bea217d1$var$initialState,
    actions: $9633e2f0bea217d1$export$cbb01c57ec9c933e,
    name: 'loomEntryPointVariantState'
});
const $9633e2f0bea217d1$export$9d93351985de2290 = (0, $9zUhf.createHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
const $9633e2f0bea217d1$export$fd0650c7a15c6ef2 = (0, $9zUhf.createActionsHook)($9633e2f0bea217d1$var$loomEntryPointVariantStore);
module.exports["LoomTenantProvisionStatus"] = $9633e2f0bea217d1$export$ebe749be4eb13ac4;
module.exports["LoomUserPermissionStatus"] = $9633e2f0bea217d1$export$7909e54672d1c423;
module.exports["getLoomUserPermissionStatus"] = $9633e2f0bea217d1$export$85de6c803181afa9;
module.exports["useLoomEntryPointVariantState"] = $9633e2f0bea217d1$export$9d93351985de2290;
module.exports["useLoomEntryPointVariantActions"] = $9633e2f0bea217d1$export$fd0650c7a15c6ef2;

});

parcelRegister("8999o", function(module, exports) {
const $887bf6ed89c38788$export$4e57ed416e50788e = async ({ fn: fn, condition: condition, retryWait: retryWait, maxTries: maxTries })=>{
    let tries = 0;
    while(true){
        tries++;
        const result = await fn();
        const ok = condition(result);
        if (tries === maxTries || ok) return {
            ok: ok,
            result: result,
            tries: tries
        };
        await new Promise((resolve)=>setTimeout(resolve, retryWait));
    }
};
module.exports["waitUntil"] = $887bf6ed89c38788$export$4e57ed416e50788e;

});

parcelRegister("lnyJf", function(module, exports) {

var $8J8QJ = parcelRequire("8J8QJ");

const $1f2e3e69723febb9$export$a573b79a27d213cc = (cloudId)=>(0, $8J8QJ.fetchJSON)(`/gateway/api/xflow/${cloudId}/license-information`);
module.exports["fetchLicenseInformation"] = $1f2e3e69723febb9$export$a573b79a27d213cc;

});

parcelRegister("8J8QJ", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $d6NtA = parcelRequire("d6NtA");

const $a326082f26863093$export$c776284ef4b1209a = (url, data)=>{
    const fetchOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
const $a326082f26863093$export$81bec6e38e8b706b = (url)=>{
    const fetchOptions = {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ...Boolean(undefined) && Boolean(undefined) && !(0, $d6NtA.isLocal)() ? {
                'x-ssr-service-name': 'identity-platform'
            } : {}
        }
    };
    return (0, $f7B1p.cfetch)(url, fetchOptions).then((response)=>{
        return response.json();
    });
};
module.exports["postJson"] = $a326082f26863093$export$c776284ef4b1209a;
module.exports["fetchJSON"] = $a326082f26863093$export$81bec6e38e8b706b;

});

parcelRegister("2gAEP", function(module, exports) {
/**
 * @generated SignedSource<<e139440afb86fce20d0d7fdd22b96ac3>>
 * @relayHash e7355c15b066e2e1bf0badd5083ad1e0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af
const $936b36fbe81f4fb7$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicensedProduct",
                    "kind": "LinkedField",
                    "name": "licensedProducts",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "licenseStatus"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "productKey"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useLoomTenantProvisionStatusQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e7355c15b066e2e1bf0badd5083ad1e0",
            "id": "828d3d71f54e604f54b7f67c20834db4af8fce46b828590b916534ec1ced08af",
            "metadata": {},
            "name": "useLoomTenantProvisionStatusQuery",
            "operationKind": "query",
            "text": "query useLoomTenantProvisionStatusQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}}}"
        }
    };
}();
$936b36fbe81f4fb7$var$node.hash = "21c387cdafea215b61e4183319580a69";
var $936b36fbe81f4fb7$export$2e2bcd8739ae039 = $936b36fbe81f4fb7$var$node;
module.exports["default"] = $936b36fbe81f4fb7$export$2e2bcd8739ae039;

});

parcelRegister("eNjW4", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $5spQU = parcelRequire("5spQU");


var $8dwdz = parcelRequire("8dwdz");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $a42f1b873e59961a$export$9cca7cb3443dfd1 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)("confluence", "confluence-loom-integration");
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (!isLoomFeatureEnabled) return true;
    if (isMobile) return true;
    return false;
} : ()=>{
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLoomFeatureEnabled = (0, $5spQU.isFeatureEnabled)('confluence', 'confluence-loom-integration');
    const { accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    // Disable when feature is not enabled in current environment/evaluation
    if (!isLoomFeatureEnabled) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};
module.exports["useIsLoomDisabled"] = $a42f1b873e59961a$export$9cca7cb3443dfd1;

});

parcelRegister("9uAPw", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $2Nwuj = parcelRequire("2Nwuj");


var $inPa6 = parcelRequire("inPa6");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $7dgT3 = parcelRequire("7dgT3");


var $cl98v = parcelRequire("cl98v");


var $jHGaM = parcelRequire("jHGaM");


var $4R3wx = parcelRequire("4R3wx");

const $a5710166add0079d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorTitleRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.title.recording-already-in-progress",
        defaultMessage: "Recording already in progress"
    },
    errorTitleNotReady: {
        id: "loom-utils.error-flag.title.not-ready",
        defaultMessage: "The Loom recorder wasn\u2019t ready"
    },
    errorIncompatibleBrowser: {
        id: "loom-utils.error-flag.description.incompatible-browser",
        defaultMessage: "The browser you\u2019re currently using isn\u2019t compatible with Loom (or you could be trying to use it in private/incognito mode). <a>Which browsers are compatible?</a>"
    },
    errorThirdPartyCookieDisabled: {
        id: "loom-utils.error-flag.description.third-party-cookie-disabled",
        defaultMessage: "Check that you have third-party cookies enabled, then try again."
    },
    errorNoMediaStreamSupport: {
        id: "loom-utils.error-flag.description.no-media-stream-support",
        defaultMessage: "You might need to try a different browser. <a>Which browsers are compatible?</a>"
    },
    errorSDKNotInitialized: {
        id: "loom-utils.error-flag.description.sdk-not-initialized",
        defaultMessage: "Try to start recording again now."
    },
    errorBackendFFNotEnabledYet: {
        id: "loom-utils.error-flag.description.be-ff-not-enabled-yet",
        defaultMessage: "Loom was recently enabled. Try again in a few minutes."
    },
    errorUnexpectedAuthTokenFailure: {
        id: "loom-utils.error-flag.description.unexpected-auth-token-failure",
        defaultMessage: "Something went wrong with the Loom recorder. Try again later, or contact Atlassian Support for help."
    },
    errorLoomUserNotCreatedYet: {
        id: "loom-utils.error-flag.description.loom-user-not-created-yet",
        defaultMessage: "Loom is enabled, just give us a few minutes to set everything up. You can try recording again in a bit."
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    },
    errorRecordingAlreadyInProgress: {
        id: "loom-utils.error-flag.description.recording-already-in-progress",
        defaultMessage: "Finish your current Loom video so you can start another."
    }
});
const $a5710166add0079d$var$LoomSDKSupportLink = 'https://support.loom.com/hc/en-us/articles/360020667617-loomSDK-FAQ';
function $a5710166add0079d$var$getUnsupportedSDKErrorDescription(error) {
    if (error === 'third-party-cookies-disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorThirdPartyCookieDisabled);
    else if (error === 'no-media-streams-support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorNoMediaStreamSupport,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
    else if (error === 'incompatible-browser') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...$a5710166add0079d$export$a7357cdd1f0b0168.errorIncompatibleBrowser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
                    href: $a5710166add0079d$var$LoomSDKSupportLink,
                    target: "_blank"
                }, chunks)
        }
    });
}
const $a5710166add0079d$export$c8d9dc913e9e33ec = ({ entryPointLocation: entryPointLocation, flags: flags, resetInsertFunctionOnUnmount: resetInsertFunctionOnUnmount = false })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { entryPointVariant: entryPointVariant } = (0, $4R3wx.useLoomEntryPointVariant)();
    const [singletonLoomSDK, { initLoomSDK: initLoomSDK }] = (0, $jHGaM.useLoomEntryPointGlobalState)();
    const [isOpeningRecorder, setIsOpeningRecorder] = (0, $42omo.useState)(false);
    const runningSDKButton = (0, $42omo.useRef)(null);
    // the call site for openLoomRecorder might be outside of React lifecycle
    // (e.g. editor DOM button onclick) so we need to ensure we maintain reference
    const singletonLoomSDKRef = (0, $42omo.useRef)(singletonLoomSDK);
    singletonLoomSDKRef.current = singletonLoomSDK;
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        if (entryPointVariant === 'BETA' || entryPointVariant === 'CO_USE') initLoomSDK({
            cloudId: cloudId,
            environment: environment,
            entryPointLocation: entryPointLocation
        });
    }, [
        initLoomSDK,
        cloudId,
        createAnalyticsEvent,
        environment,
        entryPointVariant,
        entryPointLocation
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (resetInsertFunctionOnUnmount && runningSDKButton.current && singletonLoomSDKRef.current.initializedLoomSDK) {
                singletonLoomSDKRef.current.initializedLoomSDK.updateConfig({
                    config: {
                        insertButtonText: 'Open on Loom'
                    }
                });
                runningSDKButton.current.off('insert-click');
                runningSDKButton.current.on('insert-click', (video)=>{
                    window.open(video.sharedUrl, '_blank');
                    experienceTracker.succeed({
                        name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                        attributes: {
                            inserted: true,
                            insertFunctionWasReset: true
                        }
                    });
                    /**
           * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
           * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
           */ createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            source: entryPointLocation,
                            action: 'clicked',
                            actionSubject: 'button',
                            actionSubjectId: 'insertVideoLink',
                            attributes: {
                                insertFunctionWasReset: true
                            }
                        }
                    }).fire();
                });
            }
        };
    }, [
        entryPointLocation,
        resetInsertFunctionOnUnmount,
        experienceTracker,
        createAnalyticsEvent
    ]);
    const openLoomRecorder = (0, $42omo.useCallback)(async (loomRecorderParams)=>{
        if (singletonLoomSDKRef.current.initializedLoomSDK && singletonLoomSDKRef.current.initializedLoomSDK.status().state === 'active-recording') {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleRecordingAlreadyInProgress),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorRecordingAlreadyInProgress)
            });
            return;
        }
        experienceTracker.start({
            name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
            attributes: {
                entryPointLocation: entryPointLocation
            }
        });
        if (singletonLoomSDKRef.current.isInitializing) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleNotReady),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKNotInitialized)
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: 'SDK has not been configured yet.'
            });
            return;
        }
        // TODO CTIA- 2019: fire a clicked UI event here
        if (singletonLoomSDKRef.current.isLoomSDKSupportedError) {
            const description = $a5710166add0079d$var$getUnsupportedSDKErrorDescription(singletonLoomSDKRef.current.isLoomSDKSupportedError);
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: description
            });
            experienceTracker.abort({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                reason: `SDK not supported: ${singletonLoomSDKRef.current.isLoomSDKSupportedError}.`
            });
            return;
        }
        if (!singletonLoomSDKRef.current.hasRecordingAccess) {
            const noRecordingAccessReason = singletonLoomSDKRef.current.noRecordingAccessReason;
            if (noRecordingAccessReason === 'backendFF') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorBackendFFNotEnabledYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'loom enablement in progress'
                });
            } else if (noRecordingAccessReason === 'not-created') {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorLoomUserNotCreatedYet)
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'user not created yet'
                });
            } else if (noRecordingAccessReason === 'not-mastered' || noRecordingAccessReason === 'not-mastered-enterprise') {
                // mastering for enterprise users is not available until M3
                const isMasteringFlowEnabledForEdition = noRecordingAccessReason !== 'not-mastered-enterprise';
                showModal((0, $7dgT3.NonMasteredUserModalLoader), {
                    isMasteringFlowEnabled: isMasteringFlowEnabledForEdition
                });
                experienceTracker.abort({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    reason: 'Does not have access to record looms from Confluence.',
                    attributes: {
                        noRecordingAccessReason: noRecordingAccessReason
                    }
                });
            } else {
                flags.showInfoFlag({
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorUnexpectedAuthTokenFailure)
                });
                experienceTracker.fail({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    error: singletonLoomSDKRef.current.authTokenError || new Error('unexpected error from Loom auth token or Loom user status')
                });
            }
            return;
        }
        if (!singletonLoomSDKRef.current.initializedLoomSDK || !singletonLoomSDKRef.current.initializedLoomSDK.status().success) {
            flags.showInfoFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorTitleCannotStart),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $a5710166add0079d$export$a7357cdd1f0b0168.errorSDKFailedToInitialize)
            });
            experienceTracker.fail({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                error: singletonLoomSDKRef.current.initializedLoomSDKError || new Error('Loom SDK did not successfully initialize.'),
                attributes: {
                    loomSDKSuccessStatus: singletonLoomSDKRef.current.initializedLoomSDK?.status()?.success
                }
            });
            return;
        }
        (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        setIsOpeningRecorder(true);
        createAnalyticsEvent({
            // a track event is fired once recorder is opened, this event is speficially used for monitoring in StatSig
            type: 'sendTrackEvent',
            data: {
                source: entryPointLocation,
                action: 'opened',
                actionSubject: 'loomSdkRecorder'
            }
        }).fire();
        const { configureButton: configureButton, updateConfig: updateConfig } = singletonLoomSDKRef.current.initializedLoomSDK;
        const sdkButton = configureButton();
        updateConfig({
            config: {
                insertButtonText: loomRecorderParams ? loomRecorderParams.insertButtonText : undefined,
                entryPointName: entryPointLocation
            }
        });
        if (loomRecorderParams) sdkButton.on('insert-click', async (video_0)=>{
            // TODO CTIA-2019: fire a inserted track event here
            loomRecorderParams.onInsert(video_0.sharedUrl, video_0);
            experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    inserted: true
                }
            });
            /**
         * Why do we need to add sendUIEvent if we are already sending a experienceTracker.succeed(ui taskSuccess) event?
         * "ui taskSuccess" does not have Statsig as destination, so we need to send a sendUIEvent to Statsig
         */ createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'insertVideoLink',
                    attributes: {
                        insertFunctionWasReset: false
                    }
                }
            }).fire();
        });
        sdkButton.on('start', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingStart'
                }
            }).fire();
        });
        sdkButton.on('recording-start', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'started',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('cancel', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingCancel'
                }
            }).fire();
        });
        sdkButton.on('complete', ()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: entryPointLocation,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'loomRecordingComplete',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('recording-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'completed',
                    actionSubject: 'loomRecording',
                    attributes: {
                        location: loomRecorderParams?.location
                    }
                }
            }).fire();
        });
        sdkButton.on('upload-complete', ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: entryPointLocation,
                    action: 'uploaded',
                    actionSubject: 'loomRecording'
                }
            }).fire();
        });
        sdkButton.on('lifecycle-update', (lifecycleState)=>{
            if (lifecycleState === 'pre-recording') {
                (0, $cl98v.OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
                setIsOpeningRecorder(false);
            } else if (lifecycleState === 'closed') {
                runningSDKButton.current = null;
                experienceTracker.succeed({
                    name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                    attributes: {
                        closed: true,
                        insertFunctionDefined: loomRecorderParams !== undefined
                    }
                });
            } else if (lifecycleState === 'cascaded') experienceTracker.succeed({
                name: (0, $irVI7.RECORD_LOOM_ENTRY_POINT),
                attributes: {
                    cascaded: true,
                    entryPointLocation: entryPointLocation
                }
            });
        });
        sdkButton.openPreRecordPanel();
        runningSDKButton.current = sdkButton;
    }, [
        entryPointLocation,
        experienceTracker,
        flags,
        showModal,
        createAnalyticsEvent
    ]);
    return {
        openLoomRecorder: openLoomRecorder,
        isOpeningRecorder: isOpeningRecorder,
        isLoomRecorderInitialized: !singletonLoomSDKRef.current.isInitializing,
        hasRecordingAccess: singletonLoomSDKRef.current.hasRecordingAccess
    };
};
module.exports["useLoomRecorderEntryPoint"] = $a5710166add0079d$export$c8d9dc913e9e33ec;

});

parcelRegister("7dgT3", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "n2Ktr",
    name: "NonMasteredUserModalLoader",
    loader: async ()=>(await (parcelRequire("g2fKo"))).NonMasteredUserModal
});
module.exports["NonMasteredUserModalLoader"] = $e2faf2da1cbb0cf6$export$fc2bc837ff93e32f;

});

parcelRegister("g2fKo", function(module, exports) {

let $bac90c565c4e75f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bac90c565c4e75f7$var$load("hhss7"),
    $bac90c565c4e75f7$var$load("np2ZB")
]).then(()=>parcelRequire('6i2Ga'));

});

parcelRegister("cl98v", function(module, exports) {

var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $dd21d598b55c38cc$export$873f91e3be81ab94 = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.OPEN_LOOM_RECORDER_SDK_INTERACTION)
});
const $dd21d598b55c38cc$export$bf1068aa9f020d8f = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION)
});
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$873f91e3be81ab94;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC"] = $dd21d598b55c38cc$export$bf1068aa9f020d8f;

});

parcelRegister("jIOyV", function(module, exports) {
// "confluence.fe.interaction.XXX"
const $4fa41f80373a2ebe$export$f49429c67898bd15 = 'more-actions-dropdown';
const $4fa41f80373a2ebe$export$daaf73616fe91ce9 = 'move-page-dialog';
const $4fa41f80373a2ebe$export$d4222bce9029f393 = 'content-analytics-dialog';
const $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c = 'content-analytics-dialog-mentions-tab';
const $4fa41f80373a2ebe$export$eb06363d6ef3b8dd = 'restrictions-dialog';
const $4fa41f80373a2ebe$export$ef2fb65c026ab7d3 = 'quick-summary-dialog';
const $4fa41f80373a2ebe$export$8122cf0ca2968a7b = 'open-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$ea9696a28a6fbc61 = 'initialize-loom-recorder-sdk';
const $4fa41f80373a2ebe$export$e561726b92a6162d = 'comments_summary_component';
const $4fa41f80373a2ebe$export$e348981755bdab67 = 'create-space-drawer';
const $4fa41f80373a2ebe$export$af1eb8557193d022 = 'ai-presentation-modal';
const $4fa41f80373a2ebe$export$7f72b8ffbbbfef58 = 'ai-content-catchup';
const $4fa41f80373a2ebe$export$576b15c3bba51667 = 'ai-audio-briefing';
module.exports["MORE_ACTIONS_DROPDOWN_INTERACTION"] = $4fa41f80373a2ebe$export$f49429c67898bd15;
module.exports["MOVE_PAGE_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$daaf73616fe91ce9;
module.exports["CONTENT_ANALYTICS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$d4222bce9029f393;
module.exports["CONTENT_ANALYTICS_DIALOG_MENTIONS_TAB_INTERACTION"] = $4fa41f80373a2ebe$export$b6f3d4f73cb88d6c;
module.exports["RESTRICTIONS_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$eb06363d6ef3b8dd;
module.exports["QUICK_SUMMARY_DIALOG_INTERACTION"] = $4fa41f80373a2ebe$export$ef2fb65c026ab7d3;
module.exports["OPEN_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$8122cf0ca2968a7b;
module.exports["INITIALIZE_LOOM_RECORDER_SDK_INTERACTION"] = $4fa41f80373a2ebe$export$ea9696a28a6fbc61;
module.exports["COMMENTS_SUMMARY_COMPONENT_INTERACTION"] = $4fa41f80373a2ebe$export$e561726b92a6162d;
module.exports["CREATE_SPACE_DRAWER_INTERACTION"] = $4fa41f80373a2ebe$export$e348981755bdab67;
module.exports["VIEW_AI_PRESENTATION_INTERACTION"] = $4fa41f80373a2ebe$export$af1eb8557193d022;
module.exports["AI_CONTENT_CATCHUP_INTERACTION"] = $4fa41f80373a2ebe$export$7f72b8ffbbbfef58;
module.exports["AI_AUDIO_BRIEFING_INTERACTION"] = $4fa41f80373a2ebe$export$576b15c3bba51667;

});

parcelRegister("jHGaM", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cl98v = parcelRequire("cl98v");


var $3d6VZ = parcelRequire("3d6VZ");


var $gmNpb = parcelRequire("gmNpb");


var $38NxZ = parcelRequire("38NxZ");

const $82feff28757ef801$var$initialState = {
    isInitializing: true,
    initializedLoomSDK: null,
    _hasLoomSDKInitializationStarted: false,
    hasRecordingAccess: false,
    noRecordingAccessReason: undefined,
    authTokenError: undefined,
    isLoomSDKSupportedError: undefined,
    initializedLoomSDKError: null
};


const $82feff28757ef801$var$initSDK = ({ cloudId: cloudId, environment: environment, entryPointLocation: entryPointLocation })=>async ({ getState: getState, setState: setState })=>{
        if (getState().initializedLoomSDK || getState()._hasLoomSDKInitializationStarted) // singleton: only want 1 Loom SDK instance
        return;
        setState({
            _hasLoomSDKInitializationStarted: true
        });
        (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).start();
        try {
            const { isSupported: isSupported } = await (parcelRequire("aWuvK"));
            const { supported: supported, error: isLoomSDKSupportedError } = await isSupported();
            if (!supported) {
                setState({
                    isLoomSDKSupportedError: isLoomSDKSupportedError,
                    isInitializing: false
                });
                (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
                return;
            }
        } catch  {
            // If SDK isSupported import/exec fails: treat as incompatible browser
            setState({
                isLoomSDKSupportedError: 'incompatible-browser',
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        const { recorderToken: recorderToken, tokenError: tokenError } = await (0, $3d6VZ.getAuthToken)();
        if (!recorderToken || tokenError) {
            const noRecordingAccessReason = await (0, $38NxZ.getNoRecordingAccessReason)(tokenError);
            setState({
                isInitializing: false,
                noRecordingAccessReason: noRecordingAccessReason,
                authTokenError: tokenError
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
            return;
        }
        setState({
            hasRecordingAccess: true
        });
        try {
            const { createInstance: createInstance } = await (parcelRequire("6Qh3y"));
            const initializedLoomSDK = await createInstance((0, $gmNpb.getLoomInstanceDataByEnvironment)({
                environment: environment,
                jws: recorderToken,
                siteId: cloudId,
                entryPointName: entryPointLocation
            }));
            setState({
                initializedLoomSDK: initializedLoomSDK,
                isInitializing: false
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).stop();
        } catch (err) {
            setState({
                isInitializing: false,
                initializedLoomSDKError: err
            });
            (0, $cl98v.INITIALIZE_LOOM_RECORDER_SDK_INTERACTION_METRIC).cancel();
        }
    };
const $82feff28757ef801$var$actions = {
    initLoomSDK: $82feff28757ef801$var$initSDK
};
const $82feff28757ef801$export$6f57813fe9f31bf9 = (0, $1P1Tu.createStore)({
    initialState: $82feff28757ef801$var$initialState,
    actions: $82feff28757ef801$var$actions,
    name: 'loomEntryPointGlobalStateStore'
});
const $82feff28757ef801$export$160753b85ca93fc7 = (0, $9zUhf.createHook)($82feff28757ef801$export$6f57813fe9f31bf9);
module.exports["useLoomEntryPointGlobalState"] = $82feff28757ef801$export$160753b85ca93fc7;

});

parcelRegister("3d6VZ", function(module, exports) {

var $hp2SH = parcelRequire("hp2SH");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $e01Lp = parcelRequire("e01Lp");


var $55UbZ = parcelRequire("55UbZ");

const $000d418a80b56fba$export$38e1f53b76ec7fed = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const tokenQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $e01Lp.LoomAuthTokenQuery),
            fetchPolicy: 'network-only'
        });
        return {
            recorderToken: tokenQuery.data.loomToken?.token
        };
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return {
            tokenError: e
        };
    }
};
const $000d418a80b56fba$export$36491da625b5403b = async ()=>{
    try {
        // eslint-disable-next-line graphql-relay-compat/no-direct-apollo-query-and-mutation-operations -- Read http://go/cfe-no-direct-apollo-query-and-mutation-operations
        const authStateQuery = await (0, $hp2SH.getApolloClient)().query({
            query: (0, $55UbZ.LoomAuthStateQuery)
        });
        return authStateQuery.data.loomUserStatus;
    } catch (e) {
        (0, $5ZqQS.getMonitoringClient)().submitError(e, {
            attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
        });
        (0, $7Sm4c.markErrorAsHandled)(e);
        return undefined;
    }
};
module.exports["getAuthToken"] = $000d418a80b56fba$export$38e1f53b76ec7fed;
module.exports["getAuthState"] = $000d418a80b56fba$export$36491da625b5403b;

});

parcelRegister("e01Lp", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $eeb31b52c8d53ac0$export$68069cc596b806b = (0, $eSUdr.default)`query LoomAuthTokenQuery{loomToken{token}}`;
module.exports["LoomAuthTokenQuery"] = $eeb31b52c8d53ac0$export$68069cc596b806b;

});

parcelRegister("55UbZ", function(module, exports) {

var $eSUdr = parcelRequire("eSUdr");

const $80afd1194d3d0c84$export$ee3fd3c5221b99c = (0, $eSUdr.default)`query LoomAuthStateQuery{loomUserStatus}`;
module.exports["LoomAuthStateQuery"] = $80afd1194d3d0c84$export$ee3fd3c5221b99c;

});

parcelRegister("gmNpb", function(module, exports) {
const $39913087ba6f73e2$var$PUBLIC_APP_IDS = {
    noBackend: 'a3f31403-5892-4b68-baf9-a8b1c1f9ef80',
    staging: '811e05d4-b0aa-4ec9-80e4-68cf5e924102',
    production: {
        development: 'dba4f6db-8419-44f6-ac25-32b6fc352747',
        userFacing: '8e345daf-482a-4abf-a612-cb6457110817'
    }
};
const $39913087ba6f73e2$export$c150e4a8d8a3ab35 = ({ environment: environment, jws: jws, siteId: siteId, entryPointName: entryPointName })=>{
    const commonParams = {
        jws: jws,
        siteId: siteId,
        config: {
            enableNewUi: true,
            productName: 'Confluence',
            entryPointName: entryPointName
        }
    };
    if (environment === 'DEVELOPMENT') return {
        ...commonParams,
        mode: 'standard',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.noBackend,
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    if (environment === 'STAGING') return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: $39913087ba6f73e2$var$PUBLIC_APP_IDS.staging,
        environment: 'staging' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
    return {
        ...commonParams,
        mode: 'first-party',
        publicAppId: (0, $39913087ba6f73e2$var$PUBLIC_APP_IDS.production.userFacing),
        environment: 'production' // TODO CTIA-2116: importing the enum as a value causes a big jump in package size (250kb).
    };
};
module.exports["getLoomInstanceDataByEnvironment"] = $39913087ba6f73e2$export$c150e4a8d8a3ab35;

});

parcelRegister("38NxZ", function(module, exports) {

var $3d6VZ = parcelRequire("3d6VZ");


var $dn8bs = parcelRequire("dn8bs");

const $0e5a08ec05b30096$var$graphqlErrorHasMessage = (error, messageMatch)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>message.includes(messageMatch));
    return false;
};
const $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE = 'Attempted to fetch Loom token without feature flag enabled';
const $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE = 'Failed to fetch loom auth token. Status code: 404';
const $0e5a08ec05b30096$export$5a9a2c39ccb5534c = async (tokenError)=>{
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$FF_DISABLED_MESSAGE)) return 'backendFF';
    if ($0e5a08ec05b30096$var$graphqlErrorHasMessage(tokenError, $0e5a08ec05b30096$var$UNFOUND_OR_UNMASTERED_USER_MESSAGE)) {
        const authState = await (0, $3d6VZ.getAuthState)();
        if (authState === (0, $dn8bs.LoomUserStatus).NOT_FOUND) return 'not-created';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED) return 'not-mastered';
        if (authState === (0, $dn8bs.LoomUserStatus).LINKED_ENTERPRISE) return 'not-mastered-enterprise';
    }
    return 'unexpected';
};
module.exports["getNoRecordingAccessReason"] = $0e5a08ec05b30096$export$5a9a2c39ccb5534c;

});

parcelRegister("dn8bs", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $80735413f00f04fc$export$9d643cbb1392f8e6 = /*#__PURE__*/ function(LoomUserStatus) {
    LoomUserStatus["LINKED"] = "LINKED";
    LoomUserStatus["LINKED_ENTERPRISE"] = "LINKED_ENTERPRISE";
    LoomUserStatus["MASTERED"] = "MASTERED";
    LoomUserStatus["NOT_FOUND"] = "NOT_FOUND";
    return LoomUserStatus;
}({});
module.exports["LoomUserStatus"] = $80735413f00f04fc$export$9d643cbb1392f8e6;

});

parcelRegister("aWuvK", function(module, exports) {

let $7f76fd05798145a7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f76fd05798145a7$var$load("lwKXH"),
    $7f76fd05798145a7$var$load("4byV5")
]).then(()=>parcelRequire('3f9PV'));

});

parcelRegister("6Qh3y", function(module, exports) {

let $4fb4d471b23de150$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4fb4d471b23de150$var$load("lkOIY"),
    $4fb4d471b23de150$var$load("6wr18"),
    $4fb4d471b23de150$var$load("a3Uq6"),
    $4fb4d471b23de150$var$load("xvDzM"),
    $4fb4d471b23de150$var$load("jle6Z"),
    $4fb4d471b23de150$var$load("4drdS"),
    $4fb4d471b23de150$var$load("lLK0D"),
    $4fb4d471b23de150$var$load("9LQGG"),
    $4fb4d471b23de150$var$load("wIOhQ"),
    $4fb4d471b23de150$var$load("28l1x"),
    $4fb4d471b23de150$var$load("lwKXH"),
    $4fb4d471b23de150$var$load("1okAQ"),
    $4fb4d471b23de150$var$load("fisfU"),
    $4fb4d471b23de150$var$load("9a2oY"),
    $4fb4d471b23de150$var$load("ffEVr"),
    $4fb4d471b23de150$var$load("j47Y5"),
    $4fb4d471b23de150$var$load("ivqr8"),
    $4fb4d471b23de150$var$load("7EorR"),
    $4fb4d471b23de150$var$load("btYwu")
]).then(()=>parcelRequire('fIeud'));

});

parcelRegister("lqy4C", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $4c1VG = parcelRequire("4c1VG");


var $alLTz = parcelRequire("alLTz");


var $cLhhP = parcelRequire("cLhhP");

const $047fd93b8f400f5d$export$5419ac0b96bac54b = ({ source: source })=>{
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isEligibleUser = (0, $alLTz.useIsStorageEnforcementEligible)();
    const { isStorageEnforcementGracePeriodComplete: isStorageEnforcementGracePeriodComplete } = (0, $4c1VG.useGetCurrentStorageUsage)({
        skip: !isEligibleUser
    });
    const { showBlockCreateModal: showBlockCreateModal } = (0, $cLhhP.useBlockCreateModalActions)();
    const shouldBlockCreate = isEligibleUser && Boolean(isStorageEnforcementGracePeriodComplete);
    const enforceStorageLimit = (0, $42omo.useCallback)((callback)=>(...args)=>{
            if (shouldBlockCreate) {
                // If the callback is a DOM event (e.g. click, keydown/keyup)
                // handler, prevent the default action (e.g. navigating to an href):
                const event = args?.[0];
                if (event && typeof event.preventDefault === 'function') event.preventDefault();
                experienceTracker.start({
                    name: (0, $irVI7.ONBOARDING_STORAGE_ENFORCEMENT_BLOCK_CREATE_MODAL)
                });
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'render',
                        actionSubject: 'hardStorageEnforcement',
                        actionSubjectId: 'enforceStorageLimit',
                        source: source || 'onboarding'
                    }
                }).fire();
                showBlockCreateModal(source);
                return;
            }
            return callback.apply(undefined, args);
        }, [
        createAnalyticsEvent,
        experienceTracker,
        shouldBlockCreate,
        showBlockCreateModal,
        source
    ]);
    return {
        shouldBlockCreate: shouldBlockCreate,
        enforceStorageLimit: enforceStorageLimit
    };
};
module.exports["useHardStorageEnforcement"] = $047fd93b8f400f5d$export$5419ac0b96bac54b;

});

parcelRegister("4c1VG", function(module, exports) {

var $1hmAp = parcelRequire("1hmAp");


var $jMyy4 = parcelRequire("jMyy4");

const $1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery = (0, $1hmAp.default);
const $1f652a8c0a42982a$export$8bf54c39c48ff2d2 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1f652a8c0a42982a$var$useGetCurrentStorageUsageQuery, {
        skip: skip
    });
    return {
        currentUsage: data?.storage?.bytesUsed ?? 0,
        isStorageEnforcementGracePeriodComplete: data?.storage?.isStorageEnforcementGracePeriodComplete,
        gracePeriodEndDate: data?.storage?.gracePeriodEndDate,
        loading: loading,
        error: error
    };
};
module.exports["useGetCurrentStorageUsage"] = $1f652a8c0a42982a$export$8bf54c39c48ff2d2;

});

parcelRegister("1hmAp", function(module, exports) {
/**
 * @generated SignedSource<<634d8ca034d2498a989d5a4ffee872da>>
 * @relayHash 70e80297d041fb31c0639d661a01c799
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54
const $dc4c6b557b36d823$var$node = function() {
    var v0 = [
        {
            "alias": "storage",
            "concreteType": "ConfluenceStorage",
            "kind": "LinkedField",
            "name": "confluence_storage",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "bytesUsed"
                },
                {
                    "kind": "ScalarField",
                    "name": "isStorageEnforcementGracePeriodComplete"
                },
                {
                    "kind": "ScalarField",
                    "name": "gracePeriodEndDate"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useGetCurrentStorageUsageQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "70e80297d041fb31c0639d661a01c799",
            "id": "6578095b63bae12a8f819f71aa69d97fa02d466cfabbd61192951b7f59869e54",
            "metadata": {},
            "name": "useGetCurrentStorageUsageQuery",
            "operationKind": "query",
            "text": "query useGetCurrentStorageUsageQuery{storage:confluence_storage{bytesUsed,isStorageEnforcementGracePeriodComplete,gracePeriodEndDate}}"
        }
    };
}();
$dc4c6b557b36d823$var$node.hash = "41d2bf41d832c3866355b26b49942948";
var $dc4c6b557b36d823$export$2e2bcd8739ae039 = $dc4c6b557b36d823$var$node;
module.exports["default"] = $dc4c6b557b36d823$export$2e2bcd8739ae039;

});

parcelRegister("alLTz", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $euL71 = parcelRequire("euL71");

const $2f3a7af74886cca0$export$3fc4fcb674af9bce = ()=>{
    const { edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isEligibleUser = edition === (0, $euL71.ConfluenceEdition).FREE && isLoggedIn;
    return isEligibleUser;
};
module.exports["useIsStorageEnforcementEligible"] = $2f3a7af74886cca0$export$3fc4fcb674af9bce;

});

parcelRegister("cLhhP", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ff89d2fd8e30c2ae$var$initialState = {
    isActive: false,
    source: ''
};
const $ff89d2fd8e30c2ae$var$NAME = 'BLOCK_CREATE_MODAL_STORE';
const $ff89d2fd8e30c2ae$var$BlockCreateModalStore = (0, $1P1Tu.createStore)({
    name: $ff89d2fd8e30c2ae$var$NAME,
    initialState: $ff89d2fd8e30c2ae$var$initialState,
    actions: {
        showBlockCreateModal: (source)=>({ setState: setState })=>{
                setState({
                    isActive: true,
                    source: source
                });
            },
        onBlockCreateModalClose: ()=>({ setState: setState })=>{
                setState({
                    isActive: false,
                    source: ''
                });
            }
    }
});
const $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc = (0, $9zUhf.createHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
const $ff89d2fd8e30c2ae$export$d0e21e34c085fe56 = (0, $9zUhf.createActionsHook)($ff89d2fd8e30c2ae$var$BlockCreateModalStore);
module.exports["useBlockCreateModalStore"] = $ff89d2fd8e30c2ae$export$88ea7ab80ee27dbc;
module.exports["useBlockCreateModalActions"] = $ff89d2fd8e30c2ae$export$d0e21e34c085fe56;

});

parcelRegister("bZSO8", function(module, exports) {

var $c3Qwv = parcelRequire("c3Qwv");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");


var $6mKj3 = parcelRequire("6mKj3");


var $98wxI = parcelRequire("98wxI");

const $e7afa99020494478$var$queryParamKeys = {
    subType: 'subType',
    parentPageId: 'parentPageId',
    title: 'title',
    draftId: 'draftId',
    linkCreation: 'linkCreation',
    fromPageId: 'fromPageId',
    // used by createpage.action endpoint.
    spaceKey: 'spaceKey',
    source: 'source',
    withFallback: 'withFallback',
    openTemplatesGallery: 'openTemplatesGallery',
    paywallStatus: 'paywallStatus',
    deactivationIdentifier: 'deactivationIdentifier',
    openJiraImportTool: (0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM),
    cloudId: (0, $hQnHK.CLOUD_ID),
    projectUuid: (0, $hQnHK.PROJECT_UUID),
    autoImportJiraIssues: (0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM),
    jiraImportJql: (0, $hQnHK.JIRA_IMPORT_JQL),
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    smartLinkCreateSource: 'smartLinkCreateSource',
    smartLinkEmbedUrl: 'smartLinkEmbedUrl',
    restoreVersionContentId: 'restoreVersionContentId',
    openTemplatePicker: 'openTemplatePicker',
    journeyId: 'journeyId',
    templateKey: 'templateKey'
};
const $e7afa99020494478$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'blog',
    'whiteboard',
    'database',
    'smartLinkEmbed',
    'folder'
];
const $e7afa99020494478$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$e7afa99020494478$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$e7afa99020494478$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$e7afa99020494478$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('openTemplatePicker' in options && options.openTemplatePicker !== undefined) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatePicker] = options.openTemplatePicker;
    if ('title' in options && options.title) queryParams[$e7afa99020494478$var$queryParamKeys.title] = options.title;
    if ('draftId' in options && options.draftId) queryParams[$e7afa99020494478$var$queryParamKeys.draftId] = options.draftId;
    if ('linkCreation' in options && options.linkCreation) queryParams[$e7afa99020494478$var$queryParamKeys.linkCreation] = options.linkCreation;
    if ('withFallback' in options && options.withFallback) queryParams[$e7afa99020494478$var$queryParamKeys.withFallback] = options.withFallback;
    if ('openTemplatesGallery' in options && options.openTemplatesGallery) queryParams[$e7afa99020494478$var$queryParamKeys.openTemplatesGallery] = options.openTemplatesGallery;
    if ('source' in options && options.source) queryParams[$e7afa99020494478$var$queryParamKeys.source] = options.source;
    if ('paywallStatus' in options && options.paywallStatus) queryParams[$e7afa99020494478$var$queryParamKeys.paywallStatus] = options.paywallStatus;
    if ('deactivationIdentifier' in options && options.deactivationIdentifier) queryParams[$e7afa99020494478$var$queryParamKeys.deactivationIdentifier] = options.deactivationIdentifier;
    if ((0, $hQnHK.JIRA_IMPORT_TOOL_QUERY_PARAM) in options && options.openJiraImportTool) queryParams[$e7afa99020494478$var$queryParamKeys.openJiraImportTool] = options.openJiraImportTool;
    if ((0, $hQnHK.CLOUD_ID) in options && options.cloudId) queryParams[$e7afa99020494478$var$queryParamKeys.cloudId] = options.cloudId;
    if ((0, $hQnHK.PROJECT_UUID) in options && options.projectUuid) queryParams[$e7afa99020494478$var$queryParamKeys.projectUuid] = options.projectUuid;
    if ((0, $hQnHK.AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM) in options && options.autoImportJiraIssues) queryParams[$e7afa99020494478$var$queryParamKeys.autoImportJiraIssues] = options.autoImportJiraIssues;
    if ((0, $hQnHK.JIRA_IMPORT_JQL) in options && options.jiraImportJql) queryParams[$e7afa99020494478$var$queryParamKeys.jiraImportJql] = options.jiraImportJql;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$e7afa99020494478$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('smartLinkCreateSource' in options && options.smartLinkCreateSource) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkCreateSource] = options.smartLinkCreateSource;
    if ('smartLinkEmbedUrl' in options && options.smartLinkEmbedUrl) queryParams[$e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl] = options.smartLinkEmbedUrl;
    if ('restoreVersionContentId' in options && options.restoreVersionContentId) queryParams[$e7afa99020494478$var$queryParamKeys.restoreVersionContentId] = options.restoreVersionContentId;
    if ('journeyId' in options && options.journeyId) queryParams[$e7afa99020494478$var$queryParamKeys.journeyId] = options.journeyId;
    if ('templateKey' in options && options.templateKey) queryParams[$e7afa99020494478$var$queryParamKeys.templateKey] = options.templateKey;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $e7afa99020494478$var$useContentType = (0, $dPJCf.createRouteParamHook)('contentType');
const $e7afa99020494478$export$963d972ae7433a64 = ()=>{
    const contentType = $e7afa99020494478$var$useContentType();
    if ($e7afa99020494478$var$SUPPORTED_CONTENT_TYPES.includes(contentType)) {
        if (contentType === "folder" && !(0, $6mKj3.UNSAFE_expValNoExposure)("cfind-4930-get-started-doc-notification", "isEnabled", false)) return;
        return contentType;
    }
};
const $e7afa99020494478$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.parentPageId);
    const title = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.title);
    const draftId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.draftId);
    const linkCreation = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.linkCreation);
    const fromPageId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.fromPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.withFallback) ? true : undefined;
    const openTemplatesGallery = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatesGallery) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.source);
    const deactivationIdentifier = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.deactivationIdentifier);
    const paywallStatus = (0, $98wxI.PaywallStatus)[(0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.paywallStatus) || ''];
    const openJiraImportTool = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openJiraImportTool) ? true : undefined;
    const cloudId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.cloudId);
    const projectUuid = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.projectUuid);
    const autoImportJiraIssues = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.autoImportJiraIssues) ? true : undefined;
    const jiraImportJql = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.jiraImportJql);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const smartLinkCreateSource = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkCreateSource);
    const smartLinkEmbedUrl = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.smartLinkEmbedUrl);
    const restoreVersionContentId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.restoreVersionContentId);
    const journeyId = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.journeyId);
    const openTemplatePickerParam = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.openTemplatePicker);
    const openTemplatePicker = openTemplatePickerParam ? openTemplatePickerParam === 'true' : undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $e7afa99020494478$var$queryParamKeys.templateKey);
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId || fromPageId,
        title: // prefer new parameter over old parameter
        title,
        draftId: draftId,
        linkCreation: linkCreation,
        withFallback: withFallback,
        source: source,
        paywallStatus: paywallStatus,
        deactivationIdentifier: deactivationIdentifier,
        openJiraImportTool: openJiraImportTool,
        cloudId: cloudId,
        projectUuid: projectUuid,
        autoImportJiraIssues: autoImportJiraIssues,
        jiraImportJql: jiraImportJql,
        insertTemplateWithKey: insertTemplateWithKey,
        smartLinkCreateSource: smartLinkCreateSource,
        smartLinkEmbedUrl: smartLinkEmbedUrl,
        restoreVersionContentId: restoreVersionContentId,
        openTemplatesGallery: openTemplatesGallery,
        openTemplatePicker: openTemplatePicker,
        journeyId: journeyId,
        templateKey: templateKey
    };
};
var $e7afa99020494478$export$f9ad0711e89cafb5 = /*#__PURE__*/ function(ExperienceResolution) {
    ExperienceResolution[ExperienceResolution["ABORT"] = 0] = "ABORT";
    ExperienceResolution[ExperienceResolution["SUCCEED"] = 1] = "SUCCEED";
    return ExperienceResolution;
}({});
module.exports["buildCreationLink"] = $e7afa99020494478$export$b3086acbf0304043;
module.exports["useCreateRouteSupportedContentType"] = $e7afa99020494478$export$963d972ae7433a64;
module.exports["parseQueryParams"] = $e7afa99020494478$export$67c4cee80a3410cd;
module.exports["ExperienceResolution"] = $e7afa99020494478$export$f9ad0711e89cafb5;

});

parcelRegister("hQnHK", function(module, exports) {
const $0037b6bfd6daf741$export$8cda2e6ee87e510b = 'openTemplatePicker';
const $0037b6bfd6daf741$export$2deb4fd8c7cecd6b = 'isNewWhiteboard';
const $0037b6bfd6daf741$export$58465f9d39dce215 = 'insertTemplateWithKey';
const $0037b6bfd6daf741$export$6b4bb9c01a5ea809 = 'headless';
const $0037b6bfd6daf741$export$fe7e318da6d65170 = 'canvas-server';
const $0037b6bfd6daf741$export$f356f97db9b96f17 = 'canvas-relay';
const $0037b6bfd6daf741$export$1cebfc86ac630bb9 = 'whiteboard-frame';
const $0037b6bfd6daf741$export$3078341395c8cb8e = 'whiteboard-locale';
const $0037b6bfd6daf741$export$8103f24eb51911e7 = 'whiteboard-linked-object';
const $0037b6bfd6daf741$export$d7fb875e30263264 = 'initial-theme';
const $0037b6bfd6daf741$export$abce116b94c493f9 = 'bifrost-override';
const $0037b6bfd6daf741$export$d3cf0d39019c8c7f = 'deactivationIdentifier';
const $0037b6bfd6daf741$export$390fc29767c845fc = 'whiteboardPaywallUpsellButton';
const $0037b6bfd6daf741$export$7864364f55e7d48e = 'whiteboardPaywallLearnMoreButton';
const $0037b6bfd6daf741$export$4541324acb17bf12 = 'whiteboardCreationPaywall-';
const $0037b6bfd6daf741$export$c896c362d8b74a87 = 'openJiraImportTool';
const $0037b6bfd6daf741$export$54b9795b714f5c18 = 'autoImportJiraIssues';
const $0037b6bfd6daf741$export$321c00d8e9c04c4f = 'jiraImportJql';
const $0037b6bfd6daf741$export$72b22303fb080064 = 'openMiroImportTool';
const $0037b6bfd6daf741$export$1ef18edc28f65989 = 'openMuralImportTool';
const $0037b6bfd6daf741$export$cbbd90bf5df877bd = 'cloudId';
const $0037b6bfd6daf741$export$2f0c01c772bbe851 = 'projectUuid';
const $0037b6bfd6daf741$export$f045456260cdfa6f = new Date('2024-02-29T00:00Z');
const $0037b6bfd6daf741$export$1c237a39a0b4e9d9 = 'parentProduct';
const $0037b6bfd6daf741$export$2fe42b7bd8ad9641 = 'parentDomain';
const $0037b6bfd6daf741$export$e75d2079ca761674 = 'presentationMode';
const $0037b6bfd6daf741$export$6c706ba208a447e = 'themeState';
const $0037b6bfd6daf741$export$8b639ae03e233763 = 'visualRefresh';
const $0037b6bfd6daf741$export$628c002e5c2252ee = 'createdAt';
const $0037b6bfd6daf741$export$cab138e355452790 = 'focusedCommentId';
const $0037b6bfd6daf741$export$fc53afa4d35a37cf = 'focusedMentionId';
const $0037b6bfd6daf741$export$95e280144fb6ae44 = 'replyToComment';
const $0037b6bfd6daf741$export$4f5dbfe1c54c9e86 = 'version';
const $0037b6bfd6daf741$export$4b9f8234d01d21e9 = 'createdFromSlug';
const $0037b6bfd6daf741$export$8718ad6f6cf65056 = 'debugLayouts';
const $0037b6bfd6daf741$export$326bc0b4b25bc0cb = 'racing';
const $0037b6bfd6daf741$export$148d5c0fade1be8d = 'slides';
module.exports["TEMPLATE_PICKER_QUERY_PARAM"] = $0037b6bfd6daf741$export$8cda2e6ee87e510b;
module.exports["NEW_WHITEBOARD_QUERY_PARAM"] = $0037b6bfd6daf741$export$2deb4fd8c7cecd6b;
module.exports["INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM"] = $0037b6bfd6daf741$export$58465f9d39dce215;
module.exports["HEADLESS_QUERY_PARAM"] = $0037b6bfd6daf741$export$6b4bb9c01a5ea809;
module.exports["SERVER_SPOT_PARAM"] = $0037b6bfd6daf741$export$fe7e318da6d65170;
module.exports["RELAY_SPOT_PARAM"] = $0037b6bfd6daf741$export$f356f97db9b96f17;
module.exports["WHITEBOARD_IFRAME_TITLE"] = $0037b6bfd6daf741$export$1cebfc86ac630bb9;
module.exports["WHITEBOARD_LOCALE"] = $0037b6bfd6daf741$export$3078341395c8cb8e;
module.exports["WHITEBOARD_LINKED_OBJECT"] = $0037b6bfd6daf741$export$8103f24eb51911e7;
module.exports["INITIAL_THEME_PARAM"] = $0037b6bfd6daf741$export$d7fb875e30263264;
module.exports["BIFROST_OVERRIDE_PARAM"] = $0037b6bfd6daf741$export$abce116b94c493f9;
module.exports["PAYWALL_DEACTIVATION_IDENTIFIER"] = $0037b6bfd6daf741$export$d3cf0d39019c8c7f;
module.exports["WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$390fc29767c845fc;
module.exports["WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID"] = $0037b6bfd6daf741$export$7864364f55e7d48e;
module.exports["WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX"] = $0037b6bfd6daf741$export$4541324acb17bf12;
module.exports["JIRA_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$c896c362d8b74a87;
module.exports["AUTO_IMPORT_JIRA_ISSUES_QUERY_PARAM"] = $0037b6bfd6daf741$export$54b9795b714f5c18;
module.exports["JIRA_IMPORT_JQL"] = $0037b6bfd6daf741$export$321c00d8e9c04c4f;
module.exports["MIRO_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$72b22303fb080064;
module.exports["MURAL_IMPORT_TOOL_QUERY_PARAM"] = $0037b6bfd6daf741$export$1ef18edc28f65989;
module.exports["CLOUD_ID"] = $0037b6bfd6daf741$export$cbbd90bf5df877bd;
module.exports["PROJECT_UUID"] = $0037b6bfd6daf741$export$2f0c01c772bbe851;
module.exports["PARENT_PRODUCT_QUERY_PARAM"] = $0037b6bfd6daf741$export$1c237a39a0b4e9d9;
module.exports["PARENT_DOMAIN_QUERY_PARAM"] = $0037b6bfd6daf741$export$2fe42b7bd8ad9641;
module.exports["PRESENTATION_MODE_QUERY_PARAM"] = $0037b6bfd6daf741$export$e75d2079ca761674;
module.exports["EMBEDDED_THEME_STATE"] = $0037b6bfd6daf741$export$6c706ba208a447e;
module.exports["VISUAL_REFRESH_PARAM"] = $0037b6bfd6daf741$export$8b639ae03e233763;
module.exports["EMBEDDED_WHITEBOARD_CREATED_AT_QUERY_PARAM"] = $0037b6bfd6daf741$export$628c002e5c2252ee;
module.exports["FOCUSED_COMMENT_ID"] = $0037b6bfd6daf741$export$cab138e355452790;
module.exports["FOCUSED_MENTION_ID"] = $0037b6bfd6daf741$export$fc53afa4d35a37cf;
module.exports["REPLY_TO_COMMENT"] = $0037b6bfd6daf741$export$95e280144fb6ae44;
module.exports["WHITEBOARD_VERSION_ID"] = $0037b6bfd6daf741$export$4f5dbfe1c54c9e86;
module.exports["CREATED_FROM_SLUG"] = $0037b6bfd6daf741$export$4b9f8234d01d21e9;
module.exports["DEBUG_LAYOUTS_QUERY_PARAM"] = $0037b6bfd6daf741$export$8718ad6f6cf65056;
module.exports["RACING_QUERY_PARAM"] = $0037b6bfd6daf741$export$326bc0b4b25bc0cb;
module.exports["SLIDES_QUERY_PARAM"] = $0037b6bfd6daf741$export$148d5c0fade1be8d;

});

parcelRegister("98wxI", function(module, exports) {
var $5046ea0ba58442ff$export$d9669dcdbd1161d9 = /*#__PURE__*/ function(PaywallStatus) {
    PaywallStatus["ACTIVE"] = "ACTIVE";
    PaywallStatus["DEACTIVATED"] = "DEACTIVATED";
    PaywallStatus["UNSET"] = "UNSET";
    return PaywallStatus;
}({});
module.exports["PaywallStatus"] = $5046ea0ba58442ff$export$d9669dcdbd1161d9;

});

parcelRegister("h7OOD", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $56M4r = parcelRequire("56M4r");


var $9hlns = parcelRequire("9hlns");


var $6F6hl = parcelRequire("6F6hl");

const $8acd43e7dd84c3a6$export$a0fbd5b601316213 = (t0)=>{
    const $ = (0, $frIzR.c)(22);
    let children;
    let isLoading;
    let loadingLabel;
    let onClick;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isLoading: isLoading, loadingLabel: loadingLabel, onClick: onClick, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isLoading;
        $[3] = loadingLabel;
        $[4] = onClick;
        $[5] = props;
    } else {
        children = $[1];
        isLoading = $[2];
        loadingLabel = $[3];
        onClick = $[4];
        props = $[5];
    }
    let t1;
    if ($[6] !== isLoading || $[7] !== onClick) {
        t1 = (e)=>{
            if (isLoading) return;
            onClick?.(e);
        };
        $[6] = isLoading;
        $[7] = onClick;
        $[8] = t1;
    } else t1 = $[8];
    const handleClick = t1;
    let t2;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        });
        $[9] = t2;
    } else t2 = $[9];
    let t3;
    if ($[10] !== loadingLabel) {
        t3 = {
            "aria-disabled": true,
            "aria-label": loadingLabel,
            iconAfter: t2
        };
        $[10] = loadingLabel;
        $[11] = t3;
    } else t3 = $[11];
    const loadingProps = t3;
    const t4 = isLoading ? loadingLabel : undefined;
    let t5;
    if ($[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6F6hl.default), {
            role: "status"
        }, t4);
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    const t6 = isLoading && loadingProps;
    let t7;
    if ($[14] !== children || $[15] !== handleClick || $[16] !== props || $[17] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $56M4r.default), {
            onClick: handleClick,
            ...props,
            ...t6
        }, children);
        $[14] = children;
        $[15] = handleClick;
        $[16] = props;
        $[17] = t6;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t5 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t5, t7);
        $[19] = t5;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
module.exports["LoadingPopoverItem"] = $8acd43e7dd84c3a6$export$a0fbd5b601316213;

});

parcelRegister("5Krdf", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");

const $853df67b1c2afe8a$var$contentTitleStyles = (0, $ecnYn.xcss)({
    fontWeight: 'font.weight.medium',
    color: 'color.text',
    marginRight: 'space.075'
});
const $853df67b1c2afe8a$export$35e09ba17cc51c69 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$aaf6264d06ddc4ce = (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $853df67b1c2afe8a$var$contentTitleStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $853df67b1c2afe8a$export$f80c710c106023ee = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_k48p127f _syaz1gmx",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$75180efdd3f4d9c2 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$var$nonStandardIconSize = '18px !important';
const $853df67b1c2afe8a$export$5159722bed5f8afe = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _1o9zidpf _1bah1h6o _1bsb1ejb _1xjx1o4j _17521o4j _e2oo1o4j _w8l51o4j",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $853df67b1c2afe8a$export$d69e1d473e997f8 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isDisabled ? "50%" : "100%";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_y1fz7b": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_tzy4jn7l _159i1lhn _1tdsn7od _1pum1jfw _10jxn7od _1m8y1jfw",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
module.exports["TitleContainer"] = $853df67b1c2afe8a$export$35e09ba17cc51c69;
module.exports["ContentTitle"] = $853df67b1c2afe8a$export$aaf6264d06ddc4ce;
module.exports["DisabledContentTitle"] = $853df67b1c2afe8a$export$f80c710c106023ee;
module.exports["LozengeWrapper"] = $853df67b1c2afe8a$export$75180efdd3f4d9c2;
module.exports["ContentIconWrapper"] = $853df67b1c2afe8a$export$5159722bed5f8afe;
module.exports["MenuItemWrapper"] = $853df67b1c2afe8a$export$d69e1d473e997f8;

});

parcelRegister("e0ycV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a32b99a806197ff2$var$_react = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("42omo")));

var $a32b99a806197ff2$var$_baseNew = $a32b99a806197ff2$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $a32b99a806197ff2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a32b99a806197ff2$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a32b99a806197ff2$var$_react.default.createElement($a32b99a806197ff2$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a32b99a806197ff2$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a32b99a806197ff2$var$_default = module.exports.default = $a32b99a806197ff2$var$PageLiveDocIcon;

});

parcelRegister("bBaUQ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $dHSeC = parcelRequire("dHSeC");


var $dPJCf = parcelRequire("dPJCf");

const $de58db0b8f5ba7ec$export$7947243b7b7e6ed9 = (href)=>{
    const $ = (0, $frIzR.c)(4);
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    let t0;
    if ($[0] !== href || $[1] !== matchRoute || $[2] !== push) {
        t0 = (event)=>{
            const isSpaTransition = !!(0, $dHSeC.getSpaTransitionDetails)(event, {
                matchRoute: matchRoute
            });
            if (isSpaTransition && href) {
                event.preventDefault();
                push(href);
            }
        };
        $[0] = href;
        $[1] = matchRoute;
        $[2] = push;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
};
module.exports["useHybridLinkClick"] = $de58db0b8f5ba7ec$export$7947243b7b7e6ed9;

});

parcelRegister("ibDKJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");


var $cOrQJ = parcelRequire("cOrQJ");


var $3gadb = parcelRequire("3gadb");

var $afneb = parcelRequire("afneb");


var $36Swo = parcelRequire("36Swo");

const $e5b02ec9368d4295$var$i18n = (0, $cgtv4.defineMessages)({
    tooltip: {
        id: "ai-common.ai-labs-lozenge.tooltip",
        defaultMessage: "Beta: This feature is still in development."
    }
});
const $e5b02ec9368d4295$var$lozengeStyles = {
    lozenge: "_2rko12b0 _18zr1b66 _1e0c1txw _4cvr1h6o _1bah1h6o",
    tooltip: "_2rko12b0 _11c8wadc _vchhusvi _p12f7l9q _bfhk1aqn _syaz15cr _152tze3t _1e02ze3t _1i4q1hna _85i5v77o _1q51v77o _y4ti12x7 _bozg12x7 _slp31hna"
};
const $e5b02ec9368d4295$var$gradientWaveKeyframes = null;
const $e5b02ec9368d4295$var$sampResetStyles = null;
const $e5b02ec9368d4295$var$lozengeAnimatedBorder = null; // Using a custom tooltip is a workaround to avoid odd spacing due to default styles,
// primarily for the English locale
const $e5b02ec9368d4295$var$CustomTooltip = /*#__PURE__*/ (0, $42omo.forwardRef)(function CustomTooltip({ children: children, ...props }, ref) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $afneb.default), {
        ...props,
        ref: ref,
        className: (0, $gMc0m.default)([
            $e5b02ec9368d4295$var$lozengeStyles.tooltip
        ]),
        children: children
    });
});
const $e5b02ec9368d4295$export$48aba4499a97f6bf = ()=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)(); // We don't want to i18n the term 'AI Labs' because it is the branding name
    // and should be the same across all languages
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        component: $e5b02ec9368d4295$var$CustomTooltip,
        content: formatMessage($e5b02ec9368d4295$var$i18n.tooltip),
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "data-testid": "ai-labs-lozenge",
            className: (0, $gMc0m.default)([
                $e5b02ec9368d4295$var$lozengeStyles.lozenge,
                "_2rko12b0 _18zr1b66 _kqswh2mm _bfhksm61 _1e0c1txw _4cvr1h6o _1bah1h6o _1pbyidpf _1tesidpf _rfx312b0 _1414t94y _p7f0t94y _7gpxt94y _syayt94y _1s6kyrfl _16qq1ajn _1kt9b3bt _1cs8stnw _1ankm4tz _12a1epuu _x5brkvto _13sb1p67 _dsq4glyw _1g0v1mrw"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                grow: "hug",
                space: "space.025",
                alignBlock: "center",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $36Swo.LabsIcon), {
                        darkMode: colorMode === 'dark'
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            size: "small",
                            weight: "semibold",
                            color: "color.text",
                            children: /*#__PURE__*/ (0, $l998X.jsx)("samp", {
                                className: (0, $gMc0m.default)([
                                    "_11c81kw7"
                                ]),
                                children: "LABS"
                            })
                        })
                    })
                ]
            })
        })
    });
};
module.exports["AILabsLozenge"] = $e5b02ec9368d4295$export$48aba4499a97f6bf;

});

parcelRegister("36Swo", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");

const $ffeb61eca9109eeb$export$36be37b392de5213 = ({ darkMode: darkMode = false })=>{
    return darkMode ? /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon-dark",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1466_13761)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "white"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1466_13761",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "10",
        height: "8",
        viewBox: "0 0 10 8",
        fill: "none",
        "data-testid": "ai-labs-icon",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("g", {
                clipPath: "url(#clip0_1352_45568)",
                children: /*#__PURE__*/ (0, $l998X.jsx)("path", {
                    d: "M8.66319 5.51003C6.1943 4.31624 5.47305 4.13786 4.43279 4.13786C3.21221 4.13786 2.17195 4.64556 1.24264 6.07262L1.09007 6.30589C0.96524 6.498 0.9375 6.5666 0.9375 6.64893C0.9375 6.73127 0.979111 6.79987 1.13168 6.89593L2.69901 7.87017C2.78223 7.92506 2.85159 7.9525 2.92094 7.9525C3.00416 7.9525 3.05964 7.91133 3.14286 7.78784L3.39252 7.40363C3.78089 6.8136 4.12764 6.62149 4.57149 6.62149C4.95985 6.62149 5.41757 6.73127 5.98625 7.0057L7.62293 7.77412C7.78937 7.85645 7.96968 7.81528 8.0529 7.62318L8.82963 5.92168C8.91286 5.72958 8.85737 5.60608 8.66319 5.51003ZM1.46457 2.50497C3.93346 3.69876 4.65471 3.87714 5.69497 3.87714C6.91555 3.87714 7.95581 3.36944 8.88512 1.94238L9.03769 1.70911C9.16252 1.517 9.19026 1.4484 9.19026 1.36607C9.19026 1.28373 9.14865 1.21513 8.99608 1.11907L7.42875 0.14483C7.34552 0.0899435 7.27617 0.0625 7.20682 0.0625C7.1236 0.0625 7.06812 0.103665 6.9849 0.227161L6.73524 0.61137C6.34687 1.2014 6.00012 1.39351 5.55627 1.39351C5.16791 1.39351 4.71019 1.28373 4.14151 1.0093L2.50483 0.240883C2.33839 0.158552 2.15808 0.199717 2.07486 0.391822L1.29812 2.09332C1.2149 2.28542 1.27038 2.40892 1.46457 2.50497Z",
                    fill: "#1E1F21"
                })
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("defs", {
                children: /*#__PURE__*/ (0, $l998X.jsx)("clipPath", {
                    id: "clip0_1352_45568",
                    children: /*#__PURE__*/ (0, $l998X.jsx)("rect", {
                        width: "8.25276",
                        height: "7.89",
                        fill: "white",
                        transform: "translate(0.9375 0.0625)"
                    })
                })
            })
        ]
    });
};
module.exports["LabsIcon"] = $ffeb61eca9109eeb$export$36be37b392de5213;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("eVXGa", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

const $1337beb96693807c$var$isAllowedToCreate = (accessStatus)=>accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
const $1337beb96693807c$export$1060ff57674ca8ef = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $1337beb96693807c$var$isAllowedToCreate(accessStatus);
};
module.exports["useIsAllowedToCreateWhiteboard"] = $1337beb96693807c$export$1060ff57674ca8ef;

});

parcelRegister("5nX81", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $xQxzY = parcelRequire("xQxzY");


var $euL71 = parcelRequire("euL71");


var $bQm3c = parcelRequire("bQm3c");


var $irVI7 = parcelRequire("irVI7");


var $eVXGa = parcelRequire("eVXGa");


var $98wxI = parcelRequire("98wxI");

const $4581e300b3378ab2$export$6ff73ccc41a81a83 = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const forceSkipQuery = t0 === undefined ? false : t0;
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const shouldSkipQuery = forceSkipQuery || !isAllowedToCreateWhiteboard || isPremium;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query useWhiteboardCreationPaywallWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== shouldSkipQuery) {
        t2 = {
            fetchPolicy: "no-cache",
            skip: shouldSkipQuery
        };
        $[1] = shouldSkipQuery;
        $[2] = t2;
    } else t2 = $[2];
    const { data: data, error: error } = (0, $xQxzY.useQuery)(t1, t2);
    if (isPremium) {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = {
                deactivationIdentifier: undefined,
                paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE,
                showPaywallBeforeCreate: false
            };
            $[3] = t3;
        } else t3 = $[3];
        return t3;
    }
    const deactivationIdentifier = data?.paywallContentToDisable?.deactivationIdentifier;
    const t3 = data ? (0, $98wxI.PaywallStatus).ACTIVE : (0, $98wxI.PaywallStatus).UNSET;
    const t4 = Boolean(deactivationIdentifier);
    let t5;
    if ($[4] !== deactivationIdentifier || $[5] !== error || $[6] !== t3 || $[7] !== t4) {
        t5 = {
            deactivationIdentifier: deactivationIdentifier,
            error: error,
            paywallStatus: t3,
            showPaywallBeforeCreate: t4
        };
        $[4] = deactivationIdentifier;
        $[5] = error;
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
};
const $4581e300b3378ab2$export$a8c755bcaca8c3d1 = (events, experience)=>{
    const whiteboardExperienceStart = events.find((event)=>event.action === 'taskStart' && event.name === (0, $irVI7.CREATE_WHITEBOARD_EXPERIENCE));
    if (whiteboardExperienceStart) experience.succeed();
};
module.exports["useWhiteboardCreationPaywall"] = $4581e300b3378ab2$export$6ff73ccc41a81a83;
module.exports["collectStartCreateWhiteboardExperience"] = $4581e300b3378ab2$export$a8c755bcaca8c3d1;

});

parcelRegister("fCfQ7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $xQxzY = parcelRequire("xQxzY");


var $inPa6 = parcelRequire("inPa6");


var $2Nwuj = parcelRequire("2Nwuj");


var $fpGTa = parcelRequire("fpGTa");

var $ecnYn = parcelRequire("ecnYn");


var $9wGTI = parcelRequire("9wGTI");


var $euL71 = parcelRequire("euL71");


var $1NBp8 = parcelRequire("1NBp8");


var $bQm3c = parcelRequire("bQm3c");


var $5vUJ3 = parcelRequire("5vUJ3");


var $dPJCf = parcelRequire("dPJCf");


var $b3j2Y = parcelRequire("b3j2Y");


var $1ytiN = parcelRequire("1ytiN");


var $hQnHK = parcelRequire("hQnHK");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");


var $98wxI = parcelRequire("98wxI");

const $804515fdfa3a1f20$var$SCREEN_NAME = `${(0, $hQnHK.WHITEBOARD_CREATION_PAYWALL_SOURCE_PREFIX)}upfrontDialog`;
const $804515fdfa3a1f20$var$i18n = (0, $cgtv4.defineMessages)({
    body: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body",
        defaultMessage: "You have a limit of three editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    // For feature flag: FREE edition variant (three whiteboards)
    bodyFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-free",
        defaultMessage: "You have a limit of three editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    // For feature flag: STANDARD edition variant (ten whiteboards)
    bodyStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-standard",
        defaultMessage: "You have a limit of ten editable whiteboards. If you create a new whiteboard, an older whiteboard will become view-only."
    },
    bodyUpsell: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.bodyUpsell",
        defaultMessage: "To create unlimited whiteboards, upgrade to Premium."
    },
    bodyAdminStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserStandard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-standard",
        defaultMessage: "You can only edit ten whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    bodyAdminFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-admin-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade, your oldest boards will become view-only as you create new ones."
    },
    bodyEndUserFree: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.body-end-user-free",
        defaultMessage: "You can only edit three whiteboards at a time. Until you upgrade through your admin, your oldest boards will become view-only as you create new ones."
    },
    createWhiteboard: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.createWhiteboard",
        defaultMessage: "Create whiteboard"
    },
    defaultTitle: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.defaultWhiteboardName",
        defaultMessage: "An older board will become view-only"
    },
    learnMore: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.learnMore",
        defaultMessage: "Learn about usage"
    },
    title: {
        id: "create-blank-fabric-page.whiteboard-creation-paywall-dialog.title",
        defaultMessage: "{whiteboardName} will become view-only"
    }
});
const $804515fdfa3a1f20$var$whiteboardLinkStyle = (0, $ecnYn.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline',
        cursor: 'pointer'
    }
});
const $804515fdfa3a1f20$var$DialogTitle = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { href: href, name: name } = t0;
    const renderWhiteboardLink = $804515fdfa3a1f20$var$_temp;
    let t1;
    if ($[0] !== href || $[1] !== name) {
        t1 = ()=>{
            if (!name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$804515fdfa3a1f20$var$i18n.defaultTitle,
                tagName: "span"
            });
            const whiteboardName_0 = href ? renderWhiteboardLink(`${(0, $1NBp8.WIKI).toUrl()}${href}`, name) : name;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$804515fdfa3a1f20$var$i18n.title,
                values: {
                    whiteboardName: whiteboardName_0
                }
            });
        };
        $[0] = href;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    const getTitleText = t1;
    let t2;
    if ($[3] !== getTitleText) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", {
            "data-testid": "paywall-title"
        }, getTitleText());
        $[3] = getTitleText;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
const $804515fdfa3a1f20$export$9736e1fe2430fa6 = (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { onClose: onClose, onCloseComplete: onCloseComplete, buildWhiteboardCreationLink: buildWhiteboardCreationLink } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const sessionData = (0, $bQm3c.useSessionData)();
    const edition = sessionData?.edition;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $eSUdr.default)`query WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:"whiteboard"){deactivationIdentifier link title}}`;
        t2 = {
            fetchPolicy: "no-cache"
        };
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    const { data: data, loading: loading, error: error } = (0, $xQxzY.useQuery)(t1, t2);
    let deactivationIdentifier;
    let link;
    let t3;
    let title;
    if ($[2] !== buildWhiteboardCreationLink || $[3] !== data?.paywallContentToDisable) {
        ({ link: link, title: title, deactivationIdentifier: deactivationIdentifier } = data?.paywallContentToDisable || {});
        t3 = buildWhiteboardCreationLink({
            deactivationIdentifier: deactivationIdentifier,
            paywallStatus: (0, $98wxI.PaywallStatus).ACTIVE
        }, "-creationPaywall");
        $[2] = buildWhiteboardCreationLink;
        $[3] = data?.paywallContentToDisable;
        $[4] = deactivationIdentifier;
        $[5] = link;
        $[6] = t3;
        $[7] = title;
    } else {
        deactivationIdentifier = $[4];
        link = $[5];
        t3 = $[6];
        title = $[7];
    }
    const creationHref = t3;
    let t4;
    let t5;
    if ($[8] !== createAnalyticsEvent || $[9] !== creationHref || $[10] !== deactivationIdentifier || $[11] !== error || $[12] !== loading || $[13] !== onClose || $[14] !== onCloseComplete || $[15] !== push) {
        t4 = ()=>{
            if (!loading && !error && !deactivationIdentifier) {
                push(creationHref);
                createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "autoCreate",
                        actionSubject: "activeSlotAvailableAfterRenderingCreationPaywall",
                        source: $804515fdfa3a1f20$var$SCREEN_NAME
                    }
                }).fire();
                onClose();
                onCloseComplete();
            }
        };
        t5 = [
            deactivationIdentifier,
            loading,
            error,
            creationHref,
            onClose,
            onCloseComplete,
            push,
            createAnalyticsEvent
        ];
        $[8] = createAnalyticsEvent;
        $[9] = creationHref;
        $[10] = deactivationIdentifier;
        $[11] = error;
        $[12] = loading;
        $[13] = onClose;
        $[14] = onCloseComplete;
        $[15] = push;
        $[16] = t4;
        $[17] = t5;
    } else {
        t4 = $[16];
        t5 = $[17];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[18] !== onClose || $[19] !== onCloseComplete) {
        t6 = ()=>{
            onClose();
            onCloseComplete();
        };
        $[18] = onClose;
        $[19] = onCloseComplete;
        $[20] = t6;
    } else t6 = $[20];
    let t7;
    if ($[21] !== creationHref || $[22] !== t6) {
        t7 = {
            actionSubjectId: "whiteboardPaywallCreateNewWhiteboardButton",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.createWhiteboard,
            href: creationHref,
            onClick: t6,
            target: "_self"
        };
        $[21] = creationHref;
        $[22] = t6;
        $[23] = t7;
    } else t7 = $[23];
    const creationLink = t7;
    let t8;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = {
            actionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_INFO_ACTION_SUBJECT_ID),
            href: "https://support.atlassian.com/confluence-cloud/docs/understand-confluence-whiteboards-plans-and-features/",
            messageDescriptor: $804515fdfa3a1f20$var$i18n.learnMore
        };
        $[24] = t8;
    } else t8 = $[24];
    const learnMoreLink = t8;
    let bodyMessage = $804515fdfa3a1f20$var$i18n.body;
    if ((0, $9wGTI.fg)("ten_active_boards_in_standard")) {
        if (edition === (0, $euL71.ConfluenceEdition).STANDARD) bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminStandard : $804515fdfa3a1f20$var$i18n.bodyEndUserStandard;
        else bodyMessage = isSiteAdmin ? $804515fdfa3a1f20$var$i18n.bodyAdminFree : $804515fdfa3a1f20$var$i18n.bodyEndUserFree;
    }
    let t9;
    if ($[25] !== link || $[26] !== title) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($804515fdfa3a1f20$var$DialogTitle, {
            href: link,
            name: title
        });
        $[25] = link;
        $[26] = title;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== bodyMessage) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...bodyMessage,
            tagName: "p"
        });
        $[28] = bodyMessage;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = !(0, $9wGTI.fg)("ten_active_boards_in_standard") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$804515fdfa3a1f20$var$i18n.bodyUpsell,
            tagName: "p"
        });
        $[30] = t11;
    } else t11 = $[30];
    let t12;
    if ($[31] !== error) {
        t12 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: error
        }));
        $[31] = error;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] !== creationLink || $[34] !== onClose || $[35] !== onCloseComplete || $[36] !== t10 || $[37] !== t12 || $[38] !== t9) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5vUJ3.WhiteboardsActiveBoardLimitModal), {
            learnMoreLink: learnMoreLink,
            onClose: onClose,
            onCloseComplete: onCloseComplete,
            secondaryLink: creationLink,
            source: $804515fdfa3a1f20$var$SCREEN_NAME,
            title: t9,
            upgradeEditionActionSubjectId: (0, $hQnHK.WHITEBOARD_PAYWALL_UPSELL_ACTION_SUBJECT_ID)
        }, t10, t11, t12);
        $[33] = creationLink;
        $[34] = onClose;
        $[35] = onCloseComplete;
        $[36] = t10;
        $[37] = t12;
        $[38] = t9;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
};
function $804515fdfa3a1f20$var$_temp(url, whiteboardName) {
    if ((0, $9wGTI.fg)("ten_active_boards_in_standard")) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
        xcss: $804515fdfa3a1f20$var$whiteboardLinkStyle,
        href: url
    }, whiteboardName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: url,
        target: "_blank"
    }, whiteboardName);
}
module.exports["WhiteboardCreationPaywallDialog"] = $804515fdfa3a1f20$export$9736e1fe2430fa6;

});

parcelRegister("5vUJ3", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $ci7Ox = parcelRequire("ci7Ox");


var $gj7hi = parcelRequire("gj7hi");


var $8TTLA = parcelRequire("8TTLA");

var $8CZUH = parcelRequire("8CZUH");


var $3gadb = parcelRequire("3gadb");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $lHQAj = parcelRequire("lHQAj");


var $hvXOl = parcelRequire("hvXOl");


var $5hK0S = parcelRequire("5hK0S");


var $iDxbX = parcelRequire("iDxbX");


var $2aQ91 = parcelRequire("2aQ91");


var $cHKtk = parcelRequire("cHKtk");

const $5b99abaa71dd0a9a$var$CardWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko22hw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _2rko22hw",
            __cmplp.className
        ])
    });
});
const $5b99abaa71dd0a9a$var$getLinkAppearance = (isSiteAdmin, secondaryLink, endUserRequestUpgradeButtonExists)=>{
    if (endUserRequestUpgradeButtonExists) return 'default';
    else if (secondaryLink.appearance) return secondaryLink.appearance;
    return isSiteAdmin ? 'link' : 'primary';
};
const $5b99abaa71dd0a9a$var$WhiteboardsActiveBoardLimitModalContents = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(44);
    const { children: children, learnMoreLink: learnMoreLink, secondaryLink: secondaryLink, onClose: onClose, source: source, title: title, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(source);
    let t1;
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== source) {
        t1 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: source
                }
            }).fire();
        };
        t2 = [
            createAnalyticsEvent,
            source
        ];
        $[0] = createAnalyticsEvent;
        $[1] = source;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== learnMoreLink.actionSubjectId || $[6] !== source) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: learnMoreLink.actionSubjectId,
                    source: source
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = learnMoreLink.actionSubjectId;
        $[6] = source;
        $[7] = t3;
    } else t3 = $[7];
    const fireLearnMoreClickedAnalytics = t3;
    let t4;
    if ($[8] !== isSiteAdmin) {
        t4 = isSiteAdmin && !(0, $9wGTI.fg)("ten_active_boards_in_standard");
        $[8] = isSiteAdmin;
        $[9] = t4;
    } else t4 = $[9];
    const showLearnMoreButton = t4;
    let t5;
    if ($[10] !== children) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
        $[10] = children;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== learnMoreLink || $[13] !== showRequestUpgradeButton) {
        t6 = showRequestUpgradeButton ? undefined : {
            ...learnMoreLink,
            appearance: learnMoreLink.appearance || "link"
        };
        $[12] = learnMoreLink;
        $[13] = showRequestUpgradeButton;
        $[14] = t6;
    } else t6 = $[14];
    const t7 = Boolean(showRequestUpgradeButton);
    let t8;
    if ($[15] !== isSiteAdmin || $[16] !== secondaryLink || $[17] !== t7) {
        t8 = $5b99abaa71dd0a9a$var$getLinkAppearance(isSiteAdmin, secondaryLink, t7);
        $[15] = isSiteAdmin;
        $[16] = secondaryLink;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== secondaryLink || $[20] !== t8) {
        t9 = {
            ...secondaryLink,
            appearance: t8
        };
        $[19] = secondaryLink;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== fireLearnMoreClickedAnalytics || $[23] !== formatMessage || $[24] !== learnMoreLink.href || $[25] !== learnMoreLink.messageDescriptor || $[26] !== showLearnMoreButton) {
        t10 = showLearnMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage(learnMoreLink.messageDescriptor)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle-link",
                href: learnMoreLink.href,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: formatMessage(learnMoreLink.messageDescriptor),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                spacing: "none",
                target: "_blank",
                ...tooltipProps,
                onClick: (event)=>{
                    tooltipProps?.onClick?.(event);
                    fireLearnMoreClickedAnalytics();
                }
            }));
        $[22] = fireLearnMoreClickedAnalytics;
        $[23] = formatMessage;
        $[24] = learnMoreLink.href;
        $[25] = learnMoreLink.messageDescriptor;
        $[26] = showLearnMoreButton;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== onClose) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            testId: "whiteboards-active-board-modal-close-button",
            onClick: ()=>{
                onClose?.("close");
            }
        });
        $[28] = onClose;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    let t13;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, $9wGTI.fg)("ten_active_boards_in_standard") ? (0, (/*@__PURE__*/$parcel$interopDefault($iDxbX))) : (0, (/*@__PURE__*/$parcel$interopDefault($hvXOl))),
            srcDark: (0, $9wGTI.fg)("ten_active_boards_in_standard") ? (0, (/*@__PURE__*/$parcel$interopDefault($2aQ91))) : (0, (/*@__PURE__*/$parcel$interopDefault($5hK0S))),
            alt: "",
            width: "100%"
        });
        $[33] = t13;
    } else t13 = $[33];
    let t14;
    if ($[34] !== loading || $[35] !== showRequestUpgradeButton || $[36] !== source || $[37] !== t12 || $[38] !== t5 || $[39] !== t6 || $[40] !== t9 || $[41] !== title || $[42] !== upgradeEditionActionSubjectId) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$CardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
            body: t5,
            isLoadingRequestUpgradeButton: loading,
            showRequestUpgradeButton: showRequestUpgradeButton,
            learnMoreLink: t6,
            secondaryLink: t9,
            source: source,
            targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
            title: title,
            upgradeEditionActionSubjectId: upgradeEditionActionSubjectId,
            headerButton: t12
        }, t13));
        $[34] = loading;
        $[35] = showRequestUpgradeButton;
        $[36] = source;
        $[37] = t12;
        $[38] = t5;
        $[39] = t6;
        $[40] = t9;
        $[41] = title;
        $[42] = upgradeEditionActionSubjectId;
        $[43] = t14;
    } else t14 = $[43];
    return t14;
} : ({ children: children, learnMoreLink: learnMoreLink, secondaryLink: secondaryLink, onClose: onClose, source: source, title: title, upgradeEditionActionSubjectId: upgradeEditionActionSubjectId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { showRequestUpgradeButton: showRequestUpgradeButton, loading: loading } = (0, $cHKtk.useEnableEndUserRequestUpgrade)(source);
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: source
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source
    ]);
    const fireLearnMoreClickedAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: learnMoreLink.actionSubjectId,
                source: source
            }
        }).fire();
    };
    const showLearnMoreButton = isSiteAdmin && !(0, $9wGTI.fg)('ten_active_boards_in_standard');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$CardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lHQAj.Card), {
        body: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children),
        isLoadingRequestUpgradeButton: loading,
        showRequestUpgradeButton: showRequestUpgradeButton,
        learnMoreLink: showRequestUpgradeButton ? undefined : {
            ...learnMoreLink,
            appearance: learnMoreLink.appearance || 'link'
        },
        secondaryLink: {
            ...secondaryLink,
            appearance: $5b99abaa71dd0a9a$var$getLinkAppearance(isSiteAdmin, secondaryLink, Boolean(showRequestUpgradeButton))
        },
        source: source,
        targetEdition: (0, $euL71.ConfluenceEdition).PREMIUM,
        title: title,
        upgradeEditionActionSubjectId: upgradeEditionActionSubjectId,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, showLearnMoreButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: formatMessage(learnMoreLink.messageDescriptor)
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "subtle-link",
                href: learnMoreLink.href,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: formatMessage(learnMoreLink.messageDescriptor),
                    color: "var(--ds-text-subtle, #505258)"
                }),
                spacing: "none",
                target: "_blank",
                ...tooltipProps,
                onClick: (event)=>{
                    tooltipProps?.onClick?.(event);
                    fireLearnMoreClickedAnalytics();
                }
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8TTLA.CloseButton), {
            testId: "whiteboards-active-board-modal-close-button",
            onClick: ()=>{
                onClose?.('close');
            }
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: (0, $9wGTI.fg)('ten_active_boards_in_standard') ? (0, (/*@__PURE__*/$parcel$interopDefault($iDxbX))) : (0, (/*@__PURE__*/$parcel$interopDefault($hvXOl))),
        srcDark: (0, $9wGTI.fg)('ten_active_boards_in_standard') ? (0, (/*@__PURE__*/$parcel$interopDefault($2aQ91))) : (0, (/*@__PURE__*/$parcel$interopDefault($5hK0S))),
        alt: "",
        width: "100%"
    })));
};
const $5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
})($5b99abaa71dd0a9a$var$WhiteboardsActiveBoardLimitModalContents);
const $5b99abaa71dd0a9a$export$f66bbc4d5ea612d4 = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
    const $ = (0, $frIzR.c)(8);
    let t0;
    if ($[0] !== props) {
        t0 = ()=>props.onClose?.("close");
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents, props);
        $[2] = props;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== props.onCloseComplete || $[5] !== t0 || $[6] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
            onClose: t0,
            onCloseComplete: props.onCloseComplete,
            shouldScrollInViewport: true,
            testId: "whiteboards-upsell-modal",
            width: "440px"
        }, t1);
        $[4] = props.onCloseComplete;
        $[5] = t0;
        $[6] = t1;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8CZUH.default), {
        onClose: ()=>props.onClose?.('close'),
        onCloseComplete: props.onCloseComplete,
        shouldScrollInViewport: true,
        testId: "whiteboards-upsell-modal",
        width: "440px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5b99abaa71dd0a9a$var$WrappedWhiteboardsActiveBoardLimitModalContents, props));
module.exports["WhiteboardsActiveBoardLimitModal"] = $5b99abaa71dd0a9a$export$f66bbc4d5ea612d4;

});

parcelRegister("lHQAj", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4WmbV = parcelRequire("4WmbV");

const $5558feba06e8dbf9$export$60332b2344f7fe41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(10);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[3] = children;
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
            ...props,
            withTasteAndToneStyling: true,
            buttonGroupAlignment: "right"
        }));
        $[5] = props;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== t1 || $[8] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, t1, t2);
        $[7] = t1;
        $[8] = t2;
        $[9] = t3;
    } else t3 = $[9];
    return t3;
} : ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardLayout, null, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) < 2 ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardSectionMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4WmbV.ChangeEditionSectionMessage), {
        ...props,
        withTasteAndToneStyling: true,
        buttonGroupAlignment: "right"
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardLayout = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _16jlkb7n _4cvr1h6o _bfhk1bhr _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardSectionMessageContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _1wpz1fhb",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$var$CardContentsContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_18rx4jg8",
            __cmplp.className
        ])
    });
});
$5558feba06e8dbf9$var$CardContentsContainer.displayName = 'CardContentsContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5558feba06e8dbf9$var$CardWithBorderAndBox = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _19itoecm _11q71bhr _1reo15vq _18m915vq _16qs130s",
            __cmplp.className
        ])
    });
});
const $5558feba06e8dbf9$export$8a23e74e5cf3ca41 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
} : ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardWithBorderAndBox, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($5558feba06e8dbf9$var$CardContentsContainer, null, children));
module.exports["Card"] = $5558feba06e8dbf9$export$60332b2344f7fe41;
module.exports["CardContainer"] = $5558feba06e8dbf9$export$8a23e74e5cf3ca41;

});

parcelRegister("4WmbV", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $hArLp = parcelRequire("hArLp");

var $eEA8O = parcelRequire("eEA8O");


var $1ytiN = parcelRequire("1ytiN");


var $iJ9aA = parcelRequire("iJ9aA");


var $ki6F7 = parcelRequire("ki6F7");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");


var $lNKOh = parcelRequire("lNKOh");


var $bhvFb = parcelRequire("bhvFb");


var $5u7Ox = parcelRequire("5u7Ox");


var $kpYGL = parcelRequire("kpYGL");

var $3a454656eb0e87cd$export$d33a80488b9cab17 = /*#__PURE__*/ function(SectionMessageButtonConfig) {
    SectionMessageButtonConfig["DEFAULT"] = "default";
    SectionMessageButtonConfig["UPGRADE_ONLY"] = "upgradeOnly";
    SectionMessageButtonConfig["NONE"] = "none";
    return SectionMessageButtonConfig;
}({});
const $3a454656eb0e87cd$export$2e68cfab3dc25476 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(61);
    let footer;
    let grandfathered;
    let headerButton;
    let learnMoreLink;
    let onUpFlowOpen;
    let props;
    let secondaryLink;
    let source;
    let t1;
    let t2;
    let t3;
    let t4;
    let t5;
    let targetEdition;
    if ($[0] !== t0) {
        ({ canShowUpgradeButton: t1, buttonConfig: t2, upgradeEditionActionSubjectId: t3, grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: t4, isLoadingRequestUpgradeButton: t5, ...props } = t0);
        $[0] = t0;
        $[1] = footer;
        $[2] = grandfathered;
        $[3] = headerButton;
        $[4] = learnMoreLink;
        $[5] = onUpFlowOpen;
        $[6] = props;
        $[7] = secondaryLink;
        $[8] = source;
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
        $[13] = t5;
        $[14] = targetEdition;
    } else {
        footer = $[1];
        grandfathered = $[2];
        headerButton = $[3];
        learnMoreLink = $[4];
        onUpFlowOpen = $[5];
        props = $[6];
        secondaryLink = $[7];
        source = $[8];
        t1 = $[9];
        t2 = $[10];
        t3 = $[11];
        t4 = $[12];
        t5 = $[13];
        targetEdition = $[14];
    }
    const canShowUpgradeButton = t1 === undefined ? true : t1;
    const buttonConfig = t2 === undefined ? "default" : t2;
    const upgradeEditionActionSubjectId = t3 === undefined ? "freeTryNow" : t3;
    const showRequestUpgradeButton = t4 === undefined ? false : t4;
    const isLoadingRequestUpgradeButton = t5 === undefined ? false : t5;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const t6 = Boolean(grandfathered);
    let t7;
    if ($[15] !== isSiteAdmin || $[16] !== t6) {
        t7 = {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: t6
        };
        $[15] = isSiteAdmin;
        $[16] = t6;
        $[17] = t7;
    } else t7 = $[17];
    const CTAAnalyticsAttributes = t7;
    let t8;
    if ($[18] !== CTAAnalyticsAttributes || $[19] !== source) {
        t8 = (actionSubjectId)=>({
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: CTAAnalyticsAttributes
            });
        $[18] = CTAAnalyticsAttributes;
        $[19] = source;
        $[20] = t8;
    } else t8 = $[20];
    const generateCTAAnalyticsProps = t8;
    let t9;
    if ($[21] !== CTAAnalyticsAttributes || $[22] !== createAnalyticsEvent || $[23] !== source) {
        t9 = (clickEventActionSubjectId, linkMessage)=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: clickEventActionSubjectId,
                    source: source,
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        linkMessage: linkMessage
                    }
                }
            }).fire();
        };
        $[21] = CTAAnalyticsAttributes;
        $[22] = createAnalyticsEvent;
        $[23] = source;
        $[24] = t9;
    } else t9 = $[24];
    const triggerLinkClickAnalytics = t9;
    let t10;
    if ($[25] !== secondaryLink || $[26] !== triggerLinkClickAnalytics) {
        t10 = ()=>{
            const link = secondaryLink;
            if (link) {
                triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
                if (typeof link.onClick === "function") link.onClick();
            }
        };
        $[25] = secondaryLink;
        $[26] = triggerLinkClickAnalytics;
        $[27] = t10;
    } else t10 = $[27];
    const handleSecondaryLinkClick = t10;
    let t11;
    let t12;
    if ($[28] !== CTAAnalyticsAttributes || $[29] !== createAnalyticsEvent || $[30] !== source) {
        t11 = ()=>{
            if (createAnalyticsEvent) createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "changeEditionGatewayScreen",
                    attributes: {
                        ...CTAAnalyticsAttributes,
                        source: source
                    }
                }
            }).fire();
        };
        t12 = [
            createAnalyticsEvent,
            CTAAnalyticsAttributes,
            source
        ];
        $[28] = CTAAnalyticsAttributes;
        $[29] = createAnalyticsEvent;
        $[30] = source;
        $[31] = t11;
        $[32] = t12;
    } else {
        t11 = $[31];
        t12 = $[32];
    }
    (0, $42omo.useEffect)(t11, t12);
    let T0;
    let t13;
    if ($[33] !== buttonConfig || $[34] !== canShowUpgradeButton || $[35] !== generateCTAAnalyticsProps || $[36] !== handleSecondaryLinkClick || $[37] !== isLoadingRequestUpgradeButton || $[38] !== isSiteAdmin || $[39] !== learnMoreLink || $[40] !== onUpFlowOpen || $[41] !== props || $[42] !== secondaryLink || $[43] !== showRequestUpgradeButton || $[44] !== source || $[45] !== targetEdition || $[46] !== upgradeEditionActionSubjectId) {
        const renderButtons = ()=>{
            if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
                testId: "loading-end-user-request-upgrade-button-skeleton",
                width: "200px",
                height: "32px"
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
                isSiteAdmin: isSiteAdmin,
                canShowUpgradeButton: canShowUpgradeButton,
                shouldShowLearnMore: !Boolean(secondaryLink),
                showRequestUpgradeButton: showRequestUpgradeButton
            }, (t14)=>{
                const { showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA } = t14;
                let primary;
                const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                    analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                    onUpFlowOpen: onUpFlowOpen,
                    targetEdition: targetEdition,
                    ...props
                }) : null;
                if (upgradeEditionButton) primary = upgradeEditionButton;
                else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                    source: source
                });
                let secondaries;
                if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                    if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                            appearance: "link"
                        })
                    ];
                    else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
            });
        };
        const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
            const withIcon = Boolean(learnMoreLink?.icon);
            const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || "default" : "link";
            const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
                appearance: learnMoreAppearance
            }) : null;
            const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                key: "secondLink",
                appearance: secondaryLink.appearance || "default",
                href: secondaryLink.href ? secondaryLink.href : undefined,
                id: "secondaryLink",
                spacing: "default",
                target: secondaryLink.target || "_blank",
                onClick: handleSecondaryLinkClick,
                testId: (0, $k4Vdy.calculateTestId)({
                    source: source,
                    actionSubjectId: secondaryLink.actionSubjectId
                })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
            return secondaryLink?.appearance === "primary" && learnMoreAppearance !== "primary" ? [
                secondaryLinkComponent,
                learnMoreButton
            ] : [
                learnMoreButton,
                secondaryLinkComponent
            ];
        };
        const renderLearnMoreLink = (t15)=>{
            const { children: children, ...learnMoreProps } = t15;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
                key: "learnMore",
                analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || "freeLearnMore"),
                appearance: learnMoreLink?.appearance || "default",
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                inProductHelpId: learnMoreLink?.inProductHelpId,
                inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
                href: learnMoreLink?.href,
                icon: learnMoreLink?.icon,
                ariaLabel: learnMoreLink?.ariaLabel,
                ...learnMoreProps,
                onClick: learnMoreLink?.onClick
            }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
        };
        T0 = (0, $bhvFb.EditionSectionMessage);
        t13 = buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined;
        $[33] = buttonConfig;
        $[34] = canShowUpgradeButton;
        $[35] = generateCTAAnalyticsProps;
        $[36] = handleSecondaryLinkClick;
        $[37] = isLoadingRequestUpgradeButton;
        $[38] = isSiteAdmin;
        $[39] = learnMoreLink;
        $[40] = onUpFlowOpen;
        $[41] = props;
        $[42] = secondaryLink;
        $[43] = showRequestUpgradeButton;
        $[44] = source;
        $[45] = targetEdition;
        $[46] = upgradeEditionActionSubjectId;
        $[47] = T0;
        $[48] = t13;
    } else {
        T0 = $[47];
        t13 = $[48];
    }
    let t14;
    if ($[49] !== footer || $[50] !== isSiteAdmin) {
        t14 = isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null;
        $[49] = footer;
        $[50] = isSiteAdmin;
        $[51] = t14;
    } else t14 = $[51];
    let t15;
    if ($[52] !== headerButton) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton);
        $[52] = headerButton;
        $[53] = t15;
    } else t15 = $[53];
    let t16;
    if ($[54] !== T0 || $[55] !== props || $[56] !== t13 || $[57] !== t14 || $[58] !== t15 || $[59] !== targetEdition) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            actions: t13,
            edition: targetEdition,
            footer: t14,
            headerButton: t15,
            ...props
        });
        $[54] = T0;
        $[55] = props;
        $[56] = t13;
        $[57] = t14;
        $[58] = t15;
        $[59] = targetEdition;
        $[60] = t16;
    } else t16 = $[60];
    return t16;
} : ({ canShowUpgradeButton: canShowUpgradeButton = true, buttonConfig: buttonConfig = "default", upgradeEditionActionSubjectId: upgradeEditionActionSubjectId = 'freeTryNow', grandfathered: grandfathered, source: source, onUpFlowOpen: onUpFlowOpen, secondaryLink: secondaryLink, targetEdition: targetEdition, learnMoreLink: learnMoreLink, footer: footer, headerButton: headerButton, showRequestUpgradeButton: showRequestUpgradeButton = false, isLoadingRequestUpgradeButton: isLoadingRequestUpgradeButton = false, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const CTAAnalyticsAttributes = (0, $42omo.useMemo)(()=>{
        return {
            isSiteAdmin: isSiteAdmin,
            isGrandfathered: Boolean(grandfathered)
        };
    }, [
        grandfathered,
        isSiteAdmin
    ]);
    const generateCTAAnalyticsProps = (actionSubjectId)=>({
            actionSubjectId: actionSubjectId,
            source: source,
            attributes: CTAAnalyticsAttributes
        });
    const triggerLinkClickAnalytics = (clickEventActionSubjectId, linkMessage)=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: clickEventActionSubjectId,
                source: source,
                attributes: {
                    ...CTAAnalyticsAttributes,
                    linkMessage: linkMessage
                }
            }
        }).fire();
    };
    const handleSecondaryLinkClick = ()=>{
        const link = secondaryLink;
        if (link) {
            triggerLinkClickAnalytics(link.actionSubjectId, link.messageDescriptor.defaultMessage);
            if (typeof link.onClick === 'function') link.onClick();
        }
    };
    (0, $42omo.useEffect)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'changeEditionGatewayScreen',
                attributes: {
                    ...CTAAnalyticsAttributes,
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        CTAAnalyticsAttributes,
        source
    ]);
    const renderButtons = ()=>{
        if (isLoadingRequestUpgradeButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $kpYGL.default), {
            testId: "loading-end-user-request-upgrade-button-skeleton",
            width: "200px",
            height: "32px"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lNKOh.ChangeEditionSectionMessageButtonsWrapper), {
            isSiteAdmin: isSiteAdmin,
            canShowUpgradeButton: canShowUpgradeButton,
            shouldShowLearnMore: !Boolean(secondaryLink),
            showRequestUpgradeButton: showRequestUpgradeButton
        }, ({ showUpgradeTryNowButton: showUpgradeTryNowButton, showLearnMore: showLearnMore, learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA })=>{
            //
            // primary
            //
            let primary;
            const upgradeEditionButton = showUpgradeTryNowButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ki6F7.UpgradeEditionButton), {
                analyticsProps: generateCTAAnalyticsProps(upgradeEditionActionSubjectId),
                onUpFlowOpen: onUpFlowOpen,
                targetEdition: targetEdition,
                ...props
            }) : null;
            if (upgradeEditionButton) primary = upgradeEditionButton;
            else if (showRequestUpgradeButton) primary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5u7Ox.EndUserRequestUpgradeButton), {
                source: source
            });
            //
            // secondaries
            //
            let secondaries;
            if (buttonConfig !== "upgradeOnly" || !isSiteAdmin) {
                // If the 'Try it free/now' button is to be shown, but it is not the
                // primary CTA, then make sure its appearance is appropriate for a
                // secondary:
                if (upgradeEditionButton && primary !== upgradeEditionButton) secondaries = [
                    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).cloneElement(upgradeEditionButton, {
                        appearance: 'link'
                    })
                ];
                else secondaries = getSecondaries(showLearnMore, learnMoreIsPrimaryCTA);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, primary, secondaries);
        });
    };
    const getSecondaries = (showLearnMore_0, learnMoreIsPrimaryCTA_0)=>{
        const withIcon = Boolean(learnMoreLink?.icon);
        const learnMoreAppearance = withIcon || learnMoreIsPrimaryCTA_0 ? learnMoreLink?.appearance || 'default' : 'link';
        const learnMoreButton = showLearnMore_0 ? renderLearnMoreLink({
            appearance: learnMoreAppearance
        }) : null;
        const secondaryLinkComponent = secondaryLink ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            key: "secondLink",
            appearance: secondaryLink.appearance || 'default',
            href: secondaryLink.href ? secondaryLink.href : undefined,
            id: "secondaryLink",
            spacing: "default",
            target: secondaryLink.target || '_blank',
            onClick: handleSecondaryLinkClick,
            testId: (0, $k4Vdy.calculateTestId)({
                source: source,
                actionSubjectId: secondaryLink.actionSubjectId
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), secondaryLink.messageDescriptor)) : null;
        return secondaryLink?.appearance === 'primary' && learnMoreAppearance !== 'primary' ? [
            secondaryLinkComponent,
            learnMoreButton
        ] : [
            learnMoreButton,
            secondaryLinkComponent
        ];
    };
    const renderLearnMoreLink = ({ children: children, ...learnMoreProps })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iJ9aA.LearnMoreButton), {
            key: "learnMore",
            analyticsProps: generateCTAAnalyticsProps(learnMoreLink?.actionSubjectId || 'freeLearnMore'),
            appearance: learnMoreLink?.appearance || 'default',
            onUpFlowOpen: onUpFlowOpen,
            targetEdition: targetEdition,
            inProductHelpId: learnMoreLink?.inProductHelpId,
            inProductHelpTopic: learnMoreLink?.inProductHelpTopic,
            href: learnMoreLink?.href,
            icon: learnMoreLink?.icon,
            ariaLabel: learnMoreLink?.ariaLabel,
            ...learnMoreProps,
            onClick: learnMoreLink?.onClick
        }, children !== undefined ? children : learnMoreLink?.messageDescriptor ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), learnMoreLink.messageDescriptor) : undefined);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bhvFb.EditionSectionMessage), {
        actions: buttonConfig !== "none" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, renderButtons()) : undefined,
        edition: targetEdition,
        footer: isSiteAdmin && footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, footer) : null,
        headerButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hArLp.default), null, headerButton),
        ...props
    });
};
module.exports["SectionMessageButtonConfig"] = $3a454656eb0e87cd$export$d33a80488b9cab17;
module.exports["ChangeEditionSectionMessage"] = $3a454656eb0e87cd$export$2e68cfab3dc25476;

});

parcelRegister("iJ9aA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $bsrY7 = parcelRequire("bsrY7");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $eEA8O = parcelRequire("eEA8O");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $2KmnS = parcelRequire("2KmnS");


var $bQm3c = parcelRequire("bQm3c");


var $f7tt0 = parcelRequire("f7tt0");


var $gsZdA = parcelRequire("gsZdA");


var $f7Bnv = parcelRequire("f7Bnv");


var $iC1wS = parcelRequire("iC1wS");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $k4Vdy = parcelRequire("k4Vdy");

const $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding = (0, $ecnYn.xcss)({
    paddingLeft: 'space.100',
    paddingRight: 'space.100',
    margin: 'auto'
});
const $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding = (0, $ecnYn.xcss)({
    padding: 'space.0'
});
const $c00269aedb3a5e7e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.section.message.try.free",
        defaultMessage: "Try it free"
    },
    learnMoreButton: {
        id: "change-edition.section.message.general.button.link",
        defaultMessage: "Learn more"
    }
});
const $c00269aedb3a5e7e$export$628b38b203828231 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    let { analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: t1, isGrandfathered: t2, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps } = t0;
    const targetEdition = t1 === undefined ? (0, $euL71.ConfluenceEdition).STANDARD : t1;
    const isGrandfathered = t2 === undefined ? false : t2;
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    let t3;
    if ($[0] !== children) {
        t3 = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
        $[0] = children;
        $[1] = t3;
    } else t3 = $[1];
    const message = t3;
    const iconOnly = icon && !message;
    let t4;
    let t5;
    if ($[2] !== experienceTracker || $[3] !== showUpFlow) {
        t4 = ()=>()=>{
                if (!showUpFlow) experienceTracker.abort({
                    name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                    reason: "Canceled by user"
                });
            };
        t5 = [
            experienceTracker,
            showUpFlow
        ];
        $[2] = experienceTracker;
        $[3] = showUpFlow;
        $[4] = t4;
        $[5] = t5;
    } else {
        t4 = $[4];
        t5 = $[5];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[6] !== actionSubjectId || $[7] !== analyticsProps || $[8] !== createAnalyticsEvent || $[9] !== edition || $[10] !== experienceTracker || $[11] !== isSiteAdmin || $[12] !== showUpFlow || $[13] !== source || $[14] !== targetEdition) {
        t6 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "link",
                    actionSubjectId: "freeLearnMore",
                    ...analyticsProps,
                    attributes: {
                        currentEdition: edition,
                        isSiteAdmin: isSiteAdmin,
                        linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                        targetEdition: targetEdition,
                        ...analyticsProps.attributes
                    }
                }
            }).fire();
            experienceTracker.start({
                name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: edition,
                    linkClicked: actionSubjectId || "freeLearnMore",
                    source: source,
                    targetEdition: targetEdition
                }
            });
        };
        $[6] = actionSubjectId;
        $[7] = analyticsProps;
        $[8] = createAnalyticsEvent;
        $[9] = edition;
        $[10] = experienceTracker;
        $[11] = isSiteAdmin;
        $[12] = showUpFlow;
        $[13] = source;
        $[14] = targetEdition;
        $[15] = t6;
    } else t6 = $[15];
    const fireClickAnalytics = t6;
    let t7;
    if ($[16] !== onUpFlowOpen) {
        t7 = ()=>{
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) setIsUpFlowOpen(false);
        };
        $[16] = onUpFlowOpen;
        $[17] = t7;
    } else t7 = $[17];
    const onUpFlowClose = t7;
    const renderLearnMoreButton = (t8)=>{
        const props = t8 === undefined ? {} : t8;
        if (appearance === "inline-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message);
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            className: appearance === "subtle-link" ? undefined : "primaryButton",
            id: "learnMoreLink",
            spacing: iconOnly ? "none" : "default",
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    let t9;
    if ($[18] !== createAnalyticsEvent || $[19] !== inProductHelpId) {
        t9 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "helpLink",
                    source: "adminKeyUpSell",
                    attributes: {
                        targetArticleId: inProductHelpId,
                        isSPA: true
                    }
                }
            }).fire();
        };
        $[18] = createAnalyticsEvent;
        $[19] = inProductHelpId;
        $[20] = t9;
    } else t9 = $[20];
    const fireAnalyticsEvent = t9;
    if (isGrandfathered && !isSiteAdmin) return null;
    if (!href) href = showUpFlow ? "#" : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith("#") ? undefined : "_blank";
    let t10;
    if ($[21] !== fireClickAnalytics || $[22] !== onClick || $[23] !== showUpFlow || $[24] !== target) {
        t10 = (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        };
        $[21] = fireClickAnalytics;
        $[22] = onClick;
        $[23] = showUpFlow;
        $[24] = target;
        $[25] = t10;
    } else t10 = $[25];
    const buttonProps = {
        target: target,
        href: href,
        onClick: t10,
        "aria-label": ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    const t11 = !showUpFlow && inProductHelpId && inProductHelpTopic ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps);
    let t12;
    if ($[26] !== cloudId || $[27] !== edition || $[28] !== isSiteAdmin || $[29] !== isUpFlowOpen || $[30] !== onUpFlowClose || $[31] !== onUpFlowOpen || $[32] !== showUpFlow || $[33] !== source || $[34] !== targetEdition || $[35] !== userId) {
        t12 = showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            cloudId: cloudId,
            atlassianAccountId: userId || undefined,
            canChangeEdition: isSiteAdmin,
            currentEdition: edition || undefined,
            targetEdition: targetEdition,
            flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
            product: "confluence",
            touchpointId: source,
            onClose: onUpFlowClose,
            onOpen: onUpFlowOpen,
            isExperienceTrackerEnabled: true,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
        $[26] = cloudId;
        $[27] = edition;
        $[28] = isSiteAdmin;
        $[29] = isUpFlowOpen;
        $[30] = onUpFlowClose;
        $[31] = onUpFlowOpen;
        $[32] = showUpFlow;
        $[33] = source;
        $[34] = targetEdition;
        $[35] = userId;
        $[36] = t12;
    } else t12 = $[36];
    let t13;
    if ($[37] !== t11 || $[38] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t11, t12);
        $[37] = t11;
        $[38] = t12;
        $[39] = t13;
    } else t13 = $[39];
    return t13;
} : ({ analyticsProps: analyticsProps, appearance: appearance, isSiteAdmin: isSiteAdmin, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, isGrandfathered: isGrandfathered = false, inProductHelpId: inProductHelpId, inProductHelpTopic: inProductHelpTopic, href: href, children: children, icon: icon, onClick: onClick, ariaLabel: ariaLabel, ...learnMoreProps })=>{
    const intl = (0, $8C5kA.default)();
    const { cloudId: cloudId, edition: edition, userId: userId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const [isUpFlowOpen, setIsUpFlowOpen] = (0, $42omo.useState)(false);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const showUpFlow = isLicensed && (!isSiteAdmin || edition === (0, $euL71.ConfluenceEdition).FREE);
    const { source: source, actionSubjectId: actionSubjectId } = analyticsProps;
    const testId = (0, $k4Vdy.calculateTestId)({
        source: source,
        actionSubjectId: actionSubjectId
    });
    const message = children !== undefined ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton);
    const iconOnly = icon && !message;
    (0, $42omo.useEffect)(()=>()=>{
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    const fireClickAnalytics = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'freeLearnMore',
                ...analyticsProps,
                attributes: {
                    currentEdition: edition,
                    isSiteAdmin: isSiteAdmin,
                    linkMessage: $c00269aedb3a5e7e$export$a7357cdd1f0b0168.learnMoreButton.defaultMessage,
                    targetEdition: targetEdition,
                    ...analyticsProps.attributes
                }
            }
        }).fire();
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: edition,
                linkClicked: actionSubjectId || 'freeLearnMore',
                source: source,
                targetEdition: targetEdition
            }
        });
    };
    const onUpFlowClose = ()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bsrY7)))(onUpFlowOpen)) // only attempt to close if there is no onUpFlowOpen handler (as
        // UpFlowComponent will invoke it to unmount our parent already)
        setIsUpFlowOpen(false);
    };
    const renderLearnMoreButton = (props = {})=>{
        if (appearance === 'inline-link') return(// eslint-disable-next-line @atlaskit/design-system/no-html-anchor
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("a", props, message));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
            appearance: appearance,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: appearance === 'subtle-link' ? undefined : 'primaryButton',
            id: "learnMoreLink",
            spacing: iconOnly ? 'none' : 'default',
            iconBefore: icon,
            testId: testId,
            ...props
        }, message);
    };
    const fireAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'helpLink',
                source: 'adminKeyUpSell',
                attributes: {
                    targetArticleId: inProductHelpId,
                    isSPA: true
                }
            }
        }).fire();
    };
    if (isGrandfathered && !isSiteAdmin) return null;
    // prioritizing href if it passed by the consumer regardless of edition type
    if (!href) href = showUpFlow ? '#' : (0, $gsZdA.LEARN_MORE_LINK);
    const target = href.startsWith('#') ? undefined : '_blank';
    const buttonProps = {
        target: target,
        href: href,
        onClick: (ev)=>{
            fireClickAnalytics();
            if (onClick) {
                onClick();
                return;
            }
            if (!target && showUpFlow) {
                setIsUpFlowOpen(true);
                ev.preventDefault();
            }
        },
        'aria-label': ariaLabel && intl.formatMessage(ariaLabel),
        testId: testId,
        ...learnMoreProps
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, !showUpFlow && inProductHelpId && inProductHelpTopic ? /**
     * Special handling In Product Help Button
     * InProductHelpButton force the spacing to none, thus creating a BOX here to add back the padding and margin
     */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: iconOnly ? $c00269aedb3a5e7e$var$inProductHelpButtonWithoutPadding : $c00269aedb3a5e7e$var$inProductHelpButtonWithPadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f7tt0.InProductHelpButton), {
        articleId: inProductHelpId,
        onClick: fireAnalyticsEvent,
        articleTopic: inProductHelpTopic,
        testId: testId,
        ...learnMoreProps
    }, iconOnly ? icon : message)) : renderLearnMoreButton(buttonProps), showUpFlow && isUpFlowOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
        cloudId: cloudId,
        atlassianAccountId: userId || undefined,
        canChangeEdition: isSiteAdmin,
        currentEdition: edition || undefined,
        targetEdition: targetEdition,
        flow: (0, $2KmnS.UpFlowComponentFlowType).LEARN_MORE,
        product: "confluence",
        touchpointId: source,
        onClose: onUpFlowClose,
        onOpen: onUpFlowOpen,
        isExperienceTrackerEnabled: true,
        epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
    }));
};
const $c00269aedb3a5e7e$export$176492db868efc7f = (0, $f7Bnv.withIsSiteAdmin)($c00269aedb3a5e7e$export$628b38b203828231);
module.exports["i18n"] = $c00269aedb3a5e7e$export$a7357cdd1f0b0168;
module.exports["LearnMoreButtonComponent"] = $c00269aedb3a5e7e$export$628b38b203828231;
module.exports["LearnMoreButton"] = $c00269aedb3a5e7e$export$176492db868efc7f;

});

parcelRegister("2KmnS", function(module, exports) {
var $af6754ea8048b03c$export$a719c036dcaa8cea = /*#__PURE__*/ function(UpFlowComponentFlowType) {
    UpFlowComponentFlowType["LEARN_MORE"] = "learn-more";
    UpFlowComponentFlowType["UPGRADE"] = "upgrade";
    UpFlowComponentFlowType["REQUEST_UPGRADE"] = "request-upgrade";
    UpFlowComponentFlowType["REQUEST_LEARN_MORE"] = "request-learn-more";
    return UpFlowComponentFlowType;
}({});
module.exports["UpFlowComponentFlowType"] = $af6754ea8048b03c$export$a719c036dcaa8cea;

});

parcelRegister("f7tt0", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $d0dfdd35e9850cea$export$b14685a9b52779e1 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "xD_n9",
    name: "InProductHelpButton",
    loader: async ()=>(await (parcelRequire("j0wkI"))).InProductHelpButton
});
module.exports["InProductHelpButton"] = $d0dfdd35e9850cea$export$b14685a9b52779e1;

});

parcelRegister("j0wkI", function(module, exports) {

let $dd671919af841761$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dd671919af841761$var$load("82QsP").then(()=>parcelRequire('lcEzf'));

});

parcelRegister("gsZdA", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ const $f57489e4f8cda39e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/ConfCloud/Confluence+Cloud+plans';
var $f57489e4f8cda39e$export$fd53124e1292f3e0 = /*#__PURE__*/ function(SECTION_MESSAGE_APPEARANCE_TYPES) {
    SECTION_MESSAGE_APPEARANCE_TYPES["DEFAULT"] = "default";
    SECTION_MESSAGE_APPEARANCE_TYPES["FLAT"] = "flat";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE"] = "inline";
    SECTION_MESSAGE_APPEARANCE_TYPES["INLINE_MODAL"] = "inline-modal";
    return SECTION_MESSAGE_APPEARANCE_TYPES;
}({});
const $f57489e4f8cda39e$export$9d01cd0779f8a694 = 'confluence-up-flow-modal';
module.exports["LEARN_MORE_LINK"] = $f57489e4f8cda39e$export$997e23a0aec74966;
module.exports["SECTION_MESSAGE_APPEARANCE_TYPES"] = $f57489e4f8cda39e$export$fd53124e1292f3e0;
module.exports["UP_FLOW_EP_MESSAGE_ID"] = $f57489e4f8cda39e$export$9d01cd0779f8a694;

});

parcelRegister("f7Bnv", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $1ytiN = parcelRequire("1ytiN");

function $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5(WrappedComponent) {
    return function WithIsSiteAdminComponent(props) {
        const { isSiteAdmin: isSiteAdmin, error: error, loading: loading } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
        if (error || loading) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            isSiteAdmin: isSiteAdmin
        });
    };
}
module.exports["withIsSiteAdmin"] = $7faf87d57bd98ac2$export$a3bfa6bb89ccecd5;

});

parcelRegister("iC1wS", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $8ea1c6a3abbe8170$var$EditionsAnalyticsContext = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $8ea1c6a3abbe8170$export$198c73506737f848 = (payload, data)=>({
        ...payload,
        data: {
            ...payload.data,
            attributes: {
                ...payload.data.attributes,
                ...data?.customAttributes
            }
        }
    });
const $8ea1c6a3abbe8170$export$ce3e4b18be9c194b = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(8);
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== internalData) {
        t0 = (data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData);
        $[0] = internalData;
        $[1] = t0;
    } else t0 = $[1];
    const wrapAnalyticsEventPayload = t0;
    let t1;
    if ($[2] !== createAnalyticsEvent || $[3] !== wrapAnalyticsEventPayload) {
        t1 = (initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload));
        $[2] = createAnalyticsEvent;
        $[3] = wrapAnalyticsEventPayload;
        $[4] = t1;
    } else t1 = $[4];
    const wrappedCreateAnalyticsEvent = t1;
    let t2;
    if ($[5] !== wrapAnalyticsEventPayload || $[6] !== wrappedCreateAnalyticsEvent) {
        t2 = {
            createAnalyticsEvent: wrappedCreateAnalyticsEvent,
            wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
        };
        $[5] = wrapAnalyticsEventPayload;
        $[6] = wrappedCreateAnalyticsEvent;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
} : ()=>{
    const internalData = (0, $42omo.useContext)($8ea1c6a3abbe8170$var$EditionsAnalyticsContext);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const wrapAnalyticsEventPayload = (0, $42omo.useCallback)((data)=>$8ea1c6a3abbe8170$export$198c73506737f848(data, internalData), [
        internalData
    ]);
    const wrappedCreateAnalyticsEvent = (0, $42omo.useCallback)((initialPayload)=>createAnalyticsEvent(wrapAnalyticsEventPayload(initialPayload)), [
        createAnalyticsEvent,
        wrapAnalyticsEventPayload
    ]);
    return {
        createAnalyticsEvent: wrappedCreateAnalyticsEvent,
        wrapAnalyticsEventPayload: wrapAnalyticsEventPayload
    };
};
const $8ea1c6a3abbe8170$var$emptyAttributes = {};
const $8ea1c6a3abbe8170$export$1b581a2ec13e37f1 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { children: children, customAttributes: t1 } = t0;
    const customAttributes = t1 === undefined ? $8ea1c6a3abbe8170$var$emptyAttributes : t1;
    let t2;
    if ($[0] !== customAttributes) {
        t2 = {
            customAttributes: customAttributes
        };
        $[0] = customAttributes;
        $[1] = t2;
    } else t2 = $[1];
    const editionsAnalyticsContextValue = t2;
    let t3;
    if ($[2] !== children || $[3] !== editionsAnalyticsContextValue) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
            value: editionsAnalyticsContextValue
        }, children);
        $[2] = children;
        $[3] = editionsAnalyticsContextValue;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
} : ({ children: children, customAttributes: customAttributes = $8ea1c6a3abbe8170$var$emptyAttributes })=>{
    const editionsAnalyticsContextValue = (0, $42omo.useMemo)(()=>({
            customAttributes: customAttributes
        }), [
        customAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8ea1c6a3abbe8170$var$EditionsAnalyticsContext.Provider, {
        value: editionsAnalyticsContextValue
    }, children);
};
const $8ea1c6a3abbe8170$export$19bbfac2f7120ab5 = (Component)=>{
    const WrappedComponent = (0, $3u0dr.isReactCompilerActiveV2)() ? (props)=>{
        const $ = (0, $frIzR.c)(3);
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        let t0;
        if ($[0] !== context || $[1] !== props) {
            t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
                ...props,
                ...context
            });
            $[0] = context;
            $[1] = props;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    } : (props)=>{
        const context = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, {
            ...props,
            ...context
        });
    };
    return WrappedComponent;
};
module.exports["useEditionsAnalyticsContext"] = $8ea1c6a3abbe8170$export$ce3e4b18be9c194b;
module.exports["AnalyticsProvider"] = $8ea1c6a3abbe8170$export$1b581a2ec13e37f1;

});

parcelRegister("k4Vdy", function(module, exports) {

var $12IaO = parcelRequire("12IaO");

const $b05bae0ef566e919$export$b1556774836001f5 = ({ actionSubjectId: actionSubjectId, source: source })=>actionSubjectId !== undefined ? `${source}${(0, (/*@__PURE__*/$parcel$interopDefault($12IaO)))(actionSubjectId)}` : undefined;
module.exports["calculateTestId"] = $b05bae0ef566e919$export$b1556774836001f5;

});

parcelRegister("ki6F7", function(module, exports) {

var $ey6Pt = parcelRequire("ey6Pt");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $4KS7f = parcelRequire("4KS7f");


var $ccHMk = parcelRequire("ccHMk");


var $izVB4 = parcelRequire("izVB4");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $fGzMp = parcelRequire("fGzMp");


var $b3j2Y = parcelRequire("b3j2Y");


var $bQm3c = parcelRequire("bQm3c");


var $ij4CE = parcelRequire("ij4CE");


var $2UjZJ = parcelRequire("2UjZJ");


var $gsZdA = parcelRequire("gsZdA");


var $5M47w = parcelRequire("5M47w");


var $dqdrq = parcelRequire("dqdrq");


var $ktelT = parcelRequire("ktelT");


var $l0DoV = parcelRequire("l0DoV");


var $euL71 = parcelRequire("euL71");


var $e5k34 = parcelRequire("e5k34");


var $fDbEj = parcelRequire("fDbEj");


var $k4Vdy = parcelRequire("k4Vdy");


var $iC1wS = parcelRequire("iC1wS");




const $3615035320db7a8b$var$i18n = (0, $cgtv4.defineMessages)({
    tryItFree: {
        id: "change-edition.upgrade.try.free",
        defaultMessage: "Try it free"
    },
    tryItNow: {
        id: "change-edition.upgrade.try.now",
        defaultMessage: "Try it now"
    },
    tryPremium: {
        id: "change-edition.upgrade.try.premium",
        defaultMessage: "Try Premium"
    }
});
const $3615035320db7a8b$var$editionMap = {
    [(0, $euL71.ConfluenceEdition).FREE]: (0, $5M47w.CommerceDeepLinksTargetEdition).FREE,
    [(0, $euL71.ConfluenceEdition).STANDARD]: (0, $5M47w.CommerceDeepLinksTargetEdition).STANDARD,
    [(0, $euL71.ConfluenceEdition).PREMIUM]: (0, $5M47w.CommerceDeepLinksTargetEdition).PREMIUM
};
const $3615035320db7a8b$var$determineButtonComponent = (appearance)=>{
    if (appearance === 'primary') return 0, $dqdrq.GradientCTAButton;
    if (appearance === 'subtle-link') return 0, $ktelT.GradientSubtleLinkButton;
    return 0, $4KS7f.default;
};
const $3615035320db7a8b$export$2f4bd8d23e81b246 = ({ analyticsProps: { actionSubjectId: actionSubjectId, attributes: attributes, source: source }, appearance: appearance = 'primary', children: children, onUpFlowOpen: onUpFlowOpen, targetEdition: targetEdition = (0, $euL71.ConfluenceEdition).STANDARD, onUpgradeButtonClick: onUpgradeButtonClick })=>{
    const [openUpFlow, setOpenUpFlow] = (0, $42omo.useState)(false);
    const [pollingError, setPollingError] = (0, $42omo.useState)();
    const { cloudId: cloudId, edition: currentEdition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $iC1wS.useEditionsAnalyticsContext)();
    const writeFragmentInterop = (0, $ij4CE.useWriteFragmentInterop)({
        fragmentSpec: (0, $ey6Pt.default),
        fragmentArtifact: (0, $ey6Pt.default)
    });
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // free -> standard: upflow spa;
    // free/standard -> premium: adminhub
    const showUpFlow = targetEdition === (0, $euL71.ConfluenceEdition).STANDARD;
    const { cohort: upflowV2ExperimentCohort, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, loading: upflowV2EligibilityHookLoading } = (0, $2UjZJ.useUpflowV2ConfluenceStandardFGsExperiment)({
        skip: !showUpFlow || !openUpFlow,
        touchpointId: source,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    const { commerceBackendName: commerceBackendName, planConsentDeepLink: planConsentDeepLink, errorMessage: commerceDeepLinksError } = (0, $5M47w.useCommerceDeepLinks)({
        targetEdition: $3615035320db7a8b$var$editionMap[targetEdition],
        skipDeepLinks: showUpFlow
    });
    (0, $42omo.useEffect)(()=>()=>{
            // 1. With upflow enabled, when the user clicks on the upgrade CTA, the
            //    upflow dialog opens and this component unmounts; the upsell experience
            //    continues and experience tracking is subsequently handled by the
            //    UpFlow component.
            // or
            // 2. With upflow DISabled, unmounting here simply means user navigated away
            //    from the upsell UI and we DO want to signal an aborted experience.
            if (!showUpFlow) experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Canceled by user'
            });
        }, [
        experienceTracker,
        showUpFlow
    ]);
    (0, $42omo.useEffect)(()=>{
        // Using a TRACK event for tacking the traffic to the UpgradeEditionButton.
        // This will help us gauage Commerce API traffic to compute the deep links.
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'upgradeEditionButton',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition
                }
            }
        }).fire();
    // We only need this to fire once, when the component mounts
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalytics = ()=>{
        if (attributes) {
            attributes.currentEdition = currentEdition;
            attributes.targetEdition = targetEdition;
            attributes.commerceBackend = commerceBackendName;
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: attributes
            }
        }).fire();
        if (commerceDeepLinksError) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'errored',
                actionSubject: 'useCommerceDeepLinks',
                actionSubjectId: actionSubjectId,
                source: source,
                attributes: {
                    ...attributes,
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    upsellDeepLink: planConsentDeepLink ? planConsentDeepLink.split('?')[0] : undefined,
                    errorMessage: commerceDeepLinksError
                }
            }
        }).fire();
    };
    const onTryWithoutUpFlowClick = async ()=>{
        if (onUpgradeButtonClick) onUpgradeButtonClick();
        // start polling and reload the page when done
        try {
            const updatedEdition = await (0, $fDbEj.waitForEditionChange)(currentEdition, writeFragmentInterop);
            experienceTracker.succeed({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                attributes: {
                    currentEdition: currentEdition,
                    targetEdition: updatedEdition
                }
            });
            // Default behavior
            window.location.reload();
        } catch (error) {
            if (error === (0, $fDbEj.TimeoutError)) // We don't expect the user to always proceed to upgrade in Admin Hub after seeing the estimated billing info.
            experienceTracker.abort({
                name: (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
                reason: 'Possibly canceled by user'
            });
            else {
                (0, $fGzMp.stopExperienceOnError)((0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE), error);
                setPollingError(error);
            }
        }
    };
    const onUpFlowClose = ()=>{
        setOpenUpFlow(false);
    };
    const onTryButtonClick = ()=>{
        // we always want to fire both the exposure event as well as the click event
        fireClickAnalytics();
        // start the experience tracker
        experienceTracker.start({
            name: showUpFlow ? (0, $irVI7.UPSELL_EDITION_UPFLOW_EXPERIENCE) : (0, $irVI7.UPSELL_EDITION_PREMIUM_EXPERIENCE),
            attributes: {
                currentEdition: currentEdition,
                linkClicked: actionSubjectId,
                source: source,
                targetEdition: targetEdition
            }
        });
        // then handle the click behaviour based on FF
        if (showUpFlow) setOpenUpFlow(true);
        else onTryWithoutUpFlowClick();
    };
    const buttonProps = {
        appearance: appearance,
        className: 'primaryButton',
        href: showUpFlow ? undefined : planConsentDeepLink,
        onClick: onTryButtonClick,
        target: showUpFlow ? undefined : '_blank',
        iconBefore: appearance === 'primary' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }) : undefined,
        testId: (0, $k4Vdy.calculateTestId)({
            source: source,
            actionSubjectId: actionSubjectId
        })
    };
    const upflowV2ExperimentButtonProps = {
        appearance: appearance,
        testId: 'upflowV2ExperimentLoadingButton',
        isDisabled: true,
        isLoading: true,
        iconBefore: appearance === 'primary' ? (0, (/*@__PURE__*/$parcel$interopDefault($izVB4))) : undefined
    };
    const buttonChildren = children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $3615035320db7a8b$var$i18n.tryItFree);
    const ButtonComponent = $3615035320db7a8b$var$determineButtonComponent(appearance);
    const renderModalContent = ()=>{
        if (upflowV2EligibilityHookLoading) return null;
        if (upflowV2ExperimentCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $l0DoV.TryStandardUpflowV2ExperimentTreatmentModalLoadable), {
            isOpen: openUpFlow,
            closeModal: onUpFlowClose,
            touchpointId: source,
            targetEdition: targetEdition,
            isBillingAdmin: isBillingAdmin,
            isSiteAdmin: isSiteAdmin,
            currentEdition: currentEdition
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e5k34.UpFlowCommerceRouterLoadable), {
            canChangeEdition: true // this component should only ever be used for site admins
            ,
            cloudId: cloudId,
            currentEdition: currentEdition || undefined,
            atlassianAccountId: userId || undefined,
            flow: "upgrade",
            product: "confluence",
            targetEdition: targetEdition,
            touchpointId: source,
            isExperienceTrackerEnabled: true,
            onClose: // Note: onUpFlowOpen function closes the parent component which
            // means we don't need to trigger the onClose.
            onUpFlowOpen ? undefined : onUpFlowClose,
            onOpen: onUpFlowOpen,
            epMessageId: (0, $gsZdA.UP_FLOW_EP_MESSAGE_ID)
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, pollingError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: pollingError
    }) : null, upflowV2EligibilityHookLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), upflowV2ExperimentButtonProps, buttonChildren) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ButtonComponent, buttonProps, buttonChildren), showUpFlow && openUpFlow ? renderModalContent() : null);
};
module.exports["UpgradeEditionButton"] = $3615035320db7a8b$export$2f4bd8d23e81b246;

});

parcelRegister("ey6Pt", function(module, exports) {
/**
 * @generated SignedSource<<9788b38f2bb32f836366310152c95cca>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $377a05a3faea70b3$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "UpgradeEditionButtonFragment",
        "selections": [
            {
                "concreteType": "Editions",
                "kind": "LinkedField",
                "name": "editions",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "confluence"
                    },
                    v0 /*: any*/ 
                ]
            },
            v0 /*: any*/ 
        ],
        "type": "ConfluenceTenantContext"
    };
}();
$377a05a3faea70b3$var$node.hash = "bee007bb99f1be1656322a1f41effd37";
var $377a05a3faea70b3$export$2e2bcd8739ae039 = $377a05a3faea70b3$var$node;
module.exports["default"] = $377a05a3faea70b3$export$2e2bcd8739ae039;

});

parcelRegister("izVB4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5a9109095f0a9b69c0b01202dc3ed5e4>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d8682c67cc42b6ad$var$_react = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("42omo")));

var $d8682c67cc42b6ad$var$_baseNew = $d8682c67cc42b6ad$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d8682c67cc42b6ad$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Editions".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing premium features in upsell experiences. The Editions gem icon has officially replaced the sparkle icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d8682c67cc42b6ad$var$EditionsIcon = (props)=>/*#__PURE__*/ $d8682c67cc42b6ad$var$_react.default.createElement($d8682c67cc42b6ad$var$_baseNew.default, Object.assign({
        name: "EditionsIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m12.75 1 .096.006a.75.75 0 0 1 .54.347l2.5 4a.75.75 0 0 1-.066.883l-7.25 8.5a.75.75 0 0 1-1.14 0l-7.25-8.5a.75.75 0 0 1-.066-.883l2.5-4 .056-.079A.75.75 0 0 1 3.25 1zM8 11.813 9.719 6.5H6.28zm-1.873-.914L4.704 6.5H2.375zm3.745 0L13.625 6.5h-2.33zM11.302 5h2.596l-1.563-2.5H10.52zM6.27 5h3.46l-.782-2.5H7.052zM2.103 5h2.595l.781-2.5H3.665z"/>`
    }, props));
$d8682c67cc42b6ad$var$EditionsIcon.displayName = 'EditionsIcon';
var $d8682c67cc42b6ad$var$_default = module.exports.default = $d8682c67cc42b6ad$var$EditionsIcon;

});

parcelRegister("2UjZJ", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $gXR0B = parcelRequire("gXR0B");


var $f1B2z = parcelRequire("f1B2z");

const $dd8da84ad086336b$export$2bbc11bf12d076a0 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(20);
    const { skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    let t1;
    if ($[0] !== currentEdition || $[1] !== skip || $[2] !== targetEdition) {
        t1 = {
            skip: skip,
            currentEdition: currentEdition,
            targetEdition: targetEdition
        };
        $[0] = currentEdition;
        $[1] = skip;
        $[2] = targetEdition;
        $[3] = t1;
    } else t1 = $[3];
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)(t1);
    let t2;
    let t3;
    if ($[4] !== currentEdition || $[5] !== eligibilityHookError || $[6] !== fireExperimentExposureEvent || $[7] !== isBillingAdmin || $[8] !== isEligible || $[9] !== isSiteAdmin || $[10] !== targetEdition || $[11] !== touchpointId) {
        t2 = ()=>{
            if (isEligible) {
                fireExperimentExposureEvent({
                    flagKey: "grw-1930_confluence_upv2_standard_ab",
                    cohort: (0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"),
                    growthInitiative: "luna",
                    touchpointId: touchpointId,
                    additionalAttributes: {
                        currentEdition: currentEdition,
                        targetEdition: targetEdition,
                        isSiteAdmin: isSiteAdmin,
                        isBillingAdmin: isBillingAdmin
                    }
                });
                setAbCohort((0, $6mKj3.expVal)("grw-1930_confluence_upv2_standard_ab", "cohort", "not-enrolled"));
            } else if (eligibilityHookError) setAbCohort(null);
            else setAbCohort("not-enrolled");
        };
        t3 = [
            fireExperimentExposureEvent,
            isEligible,
            eligibilityHookError,
            currentEdition,
            targetEdition,
            isSiteAdmin,
            isBillingAdmin,
            touchpointId
        ];
        $[4] = currentEdition;
        $[5] = eligibilityHookError;
        $[6] = fireExperimentExposureEvent;
        $[7] = isBillingAdmin;
        $[8] = isEligible;
        $[9] = isSiteAdmin;
        $[10] = targetEdition;
        $[11] = touchpointId;
        $[12] = t2;
        $[13] = t3;
    } else {
        t2 = $[12];
        t3 = $[13];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[14] !== abCohort || $[15] !== eligibilityHookError || $[16] !== eligibilityHookLoading || $[17] !== isBillingAdmin || $[18] !== isSiteAdmin) {
        t4 = {
            cohort: abCohort,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: eligibilityHookLoading,
            error: eligibilityHookError
        };
        $[14] = abCohort;
        $[15] = eligibilityHookError;
        $[16] = eligibilityHookLoading;
        $[17] = isBillingAdmin;
        $[18] = isSiteAdmin;
        $[19] = t4;
    } else t4 = $[19];
    return t4;
} : ({ skip: skip, touchpointId: touchpointId, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const fireExperimentExposureEvent = (0, $gXR0B.useFeatureExposedAnalytics)();
    const [abCohort, setAbCohort] = (0, $42omo.useState)(null);
    const { isEligible: isEligible, isSiteAdmin: isSiteAdmin, isBillingAdmin: isBillingAdmin, error: eligibilityHookError, loading: eligibilityHookLoading } = (0, $f1B2z.useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment)({
        skip: skip,
        currentEdition: currentEdition,
        targetEdition: targetEdition
    });
    (0, $42omo.useEffect)(()=>{
        if (isEligible) {
            fireExperimentExposureEvent({
                flagKey: 'grw-1930_confluence_upv2_standard_ab',
                cohort: (0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'),
                growthInitiative: 'luna',
                touchpointId: touchpointId,
                additionalAttributes: {
                    currentEdition: currentEdition,
                    targetEdition: targetEdition,
                    isSiteAdmin: isSiteAdmin,
                    isBillingAdmin: isBillingAdmin
                }
            });
            setAbCohort((0, $6mKj3.expVal)('grw-1930_confluence_upv2_standard_ab', 'cohort', 'not-enrolled'));
        } else if (eligibilityHookError) // Error occurred, reset to null
        setAbCohort(null);
        else setAbCohort('not-enrolled');
    }, [
        fireExperimentExposureEvent,
        isEligible,
        eligibilityHookError,
        currentEdition,
        targetEdition,
        isSiteAdmin,
        isBillingAdmin,
        touchpointId
    ]);
    return {
        cohort: abCohort,
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: eligibilityHookLoading,
        error: eligibilityHookError
    };
};
module.exports["useUpflowV2ConfluenceStandardFGsExperiment"] = $dd8da84ad086336b$export$2bbc11bf12d076a0;

});

parcelRegister("gXR0B", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $c07cc869290551b6$export$5218ddb3d9c658c0 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(3);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    const sentFlagKeys = (0, $42omo.useRef)(t0);
    let t1;
    if ($[1] !== createAnalyticsEvent) {
        t1 = (t2)=>{
            const { flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: t3 } = t2;
            const additionalAttributes = t3 === undefined ? {} : t3;
            const flagTouchpointKey = `${flagKey}:${touchpointId}`;
            if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "exposed",
                    actionSubject: "experiment",
                    actionSubjectId: `${flagKey}-exposed`,
                    source: flagKey,
                    attributes: {
                        cohort: cohort,
                        touchpointId: touchpointId,
                        growthInitiative: growthInitiative,
                        ...additionalAttributes
                    }
                }
            }).fire();
            sentFlagKeys.current.push(flagTouchpointKey);
        };
        $[1] = createAnalyticsEvent;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sentFlagKeys = (0, $42omo.useRef)([]);
    // This ensures the experiment exposure event is only fired once per flagKey / touchpoint combination.
    return (0, $42omo.useCallback)(({ flagKey: flagKey, cohort: cohort, touchpointId: touchpointId, growthInitiative: growthInitiative, additionalAttributes: additionalAttributes = {} })=>{
        const flagTouchpointKey = `${flagKey}:${touchpointId}`;
        if (sentFlagKeys.current.includes(flagTouchpointKey)) return;
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'experiment',
                actionSubjectId: `${flagKey}-exposed`,
                source: flagKey,
                attributes: {
                    cohort: cohort,
                    touchpointId: touchpointId,
                    growthInitiative: growthInitiative,
                    ...additionalAttributes
                }
            }
        }).fire();
        sentFlagKeys.current.push(flagTouchpointKey);
    }, [
        createAnalyticsEvent
    ]);
};
module.exports["useFeatureExposedAnalytics"] = $c07cc869290551b6$export$5218ddb3d9c658c0;

});

parcelRegister("f1B2z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $iFJDd = parcelRequire("iFJDd");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $1ytiN = parcelRequire("1ytiN");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $euL71 = parcelRequire("euL71");


var $jMyy4 = parcelRequire("jMyy4");

const $26baada861c32413$var$extractBillingAdminStatus = (billingData)=>{
    return billingData?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.transactionAccount?.isCurrentUserBillingAdmin;
};
const $26baada861c32413$export$6da6d4db5c51c32 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(18);
    const { skip: t1, currentEdition: currentEdition, targetEdition: targetEdition } = t0;
    const skip = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $gKr8t.getAGGClient)();
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== cloudId) {
        t3 = {
            cloudId: cloudId
        };
        $[1] = cloudId;
        $[2] = t3;
    } else t3 = $[2];
    const t4 = skip || !isBasicEligible;
    let t5;
    if ($[3] !== t3 || $[4] !== t4) {
        t5 = {
            client: t2,
            variables: t3,
            skip: t4
        };
        $[3] = t3;
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), t5);
    let t6;
    let t7;
    if ($[6] !== billingAdminQueryError || $[7] !== createAnalyticsEvent) {
        t6 = ()=>{
            if (billingAdminQueryError) {
                const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                    product: (0, $gwZbZ.Product).CONFLUENCE,
                    team: (0, $6o7wX.Team).GROWTH_LUNA,
                    experimentMeta: {
                        experimentKey: "grw-1930_confluence_upv2_standard_ab"
                    },
                    errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                    errorMessage: billingAdminQueryError.message,
                    source: "useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook",
                    severity: (0, $gwZbZ.Severity).HIGH
                });
                createAnalyticsEvent(eventPayload).fire();
            }
        };
        t7 = [
            billingAdminQueryError,
            createAnalyticsEvent
        ];
        $[6] = billingAdminQueryError;
        $[7] = createAnalyticsEvent;
        $[8] = t6;
        $[9] = t7;
    } else {
        t6 = $[8];
        t7 = $[9];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[10] !== billingAdminData) {
        t8 = $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
        $[10] = billingAdminData;
        $[11] = t8;
    } else t8 = $[11];
    const isBillingAdmin = t8;
    const t9 = Boolean(isBasicEligible && isBillingAdmin);
    let t10;
    if ($[12] !== billingAdminQueryError || $[13] !== isBillingAdmin || $[14] !== isBillingAdminQueryLoading || $[15] !== isSiteAdmin || $[16] !== t9) {
        t10 = {
            isEligible: t9,
            isSiteAdmin: isSiteAdmin,
            isBillingAdmin: isBillingAdmin,
            loading: isBillingAdminQueryLoading,
            error: billingAdminQueryError
        };
        $[12] = billingAdminQueryError;
        $[13] = isBillingAdmin;
        $[14] = isBillingAdminQueryLoading;
        $[15] = isSiteAdmin;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
} : ({ skip: skip = false, currentEdition: currentEdition, targetEdition: targetEdition })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const isBasicEligible = Boolean(cloudId && currentEdition === (0, $euL71.ConfluenceEdition).FREE && targetEdition === (0, $euL71.ConfluenceEdition).STANDARD && isSiteAdmin);
    const { data: billingAdminData, loading: isBillingAdminQueryLoading, error: billingAdminQueryError } = (0, $jMyy4.useQueryInterop)((0, $iFJDd.default), {
        client: (0, $gKr8t.getAGGClient)(),
        variables: {
            cloudId: cloudId
        },
        skip: skip || !isBasicEligible
    });
    (0, $42omo.useEffect)(()=>{
        if (billingAdminQueryError) {
            const eventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
                product: (0, $gwZbZ.Product).CONFLUENCE,
                team: (0, $6o7wX.Team).GROWTH_LUNA,
                experimentMeta: {
                    experimentKey: 'grw-1930_confluence_upv2_standard_ab'
                },
                errorType: (0, $gwZbZ.ErrorType).GRAPHQL,
                errorMessage: billingAdminQueryError.message,
                source: 'useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment hook',
                severity: (0, $gwZbZ.Severity).HIGH
            });
            createAnalyticsEvent(eventPayload).fire();
        }
    }, [
        billingAdminQueryError,
        createAnalyticsEvent
    ]);
    const isBillingAdmin = (0, $42omo.useMemo)(()=>{
        return $26baada861c32413$var$extractBillingAdminStatus(billingAdminData);
    }, [
        billingAdminData
    ]);
    return {
        isEligible: Boolean(isBasicEligible && isBillingAdmin),
        isSiteAdmin: isSiteAdmin,
        isBillingAdmin: isBillingAdmin,
        loading: isBillingAdminQueryLoading,
        error: billingAdminQueryError
    };
};
module.exports["useIsEligibleForUpflowV2ConfluenceStandardFGsExperiment"] = $26baada861c32413$export$6da6d4db5c51c32;

});

parcelRegister("iFJDd", function(module, exports) {
/**
 * @generated SignedSource<<55232f830a8d69a21f0a8ce7a6128f2f>>
 * @relayHash f9ca0c6d46f517f6d908bd327972e2da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6
const $a78c8196dfce8e13$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "isCurrentUserBillingAdmin"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                },
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v4 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v3 /*: any*/ 
                                                    ],
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "f9ca0c6d46f517f6d908bd327972e2da",
            "id": "d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6",
            "metadata": {},
            "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
            "operationKind": "query",
            "text": "query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,id,transactionAccount{__typename,...on Node{__isNode:__typename,id,__typename},isCurrentUserBillingAdmin}}}}}"
        }
    };
}();
$a78c8196dfce8e13$var$node.hash = "5ffb5864cc8b6acf0f584617c954e009";
var $a78c8196dfce8e13$export$2e2bcd8739ae039 = $a78c8196dfce8e13$var$node;
module.exports["default"] = $a78c8196dfce8e13$export$2e2bcd8739ae039;

});

parcelRegister("8hmrm", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $gvWCD = parcelRequire("gvWCD");


var $3HIy9 = parcelRequire("3HIy9");


var $39G0n = parcelRequire("39G0n");

const $31b517e9b4290477$export$8c06ae8e7f403dea = ({ product: product, team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, additionalAttributes: additionalAttributes = {} }, isActiveExperiment = true)=>{
    (0, $39G0n.validateExperimentName)(experimentMeta.experimentKey);
    const eventPayload = (0, $gvWCD.createEventPayload)({
        team: team,
        experimentMeta: experimentMeta,
        errorType: errorType,
        errorMessage: errorMessage,
        source: source,
        severity: severity,
        isActiveExperiment: isActiveExperiment,
        additionalAttributes: additionalAttributes,
        product: product
    });
    switch(product){
        case (0, $gwZbZ.Product).ADMIN_HUB:
            return {
                data: eventPayload
            };
        case (0, $gwZbZ.Product).JIRA:
            return {
                data: eventPayload,
                productSpecificRules: {
                    jira: {
                        createAnalyticsEventPayload: (0, $3HIy9.convertEventPayloadForJiraCreateAnalyticsEvent)({
                            data: eventPayload
                        }),
                        fireEventPayload: (0, $3HIy9.convertEventAttributesForJiraFireEvent)({
                            data: eventPayload
                        })
                    }
                }
            };
        case (0, $gwZbZ.Product).CONFLUENCE:
            return {
                type: (0, $gwZbZ.CONFLUENCE_OPERATIONAL_EVENT_TYPE),
                data: eventPayload
            };
        default:
            throw new Error(`Unsupported product: ${product}`);
    }
};
module.exports["createProductSpecificAnalyticsIntegrationPayload"] = $31b517e9b4290477$export$8c06ae8e7f403dea;

});

parcelRegister("gwZbZ", function(module, exports) {
const $64e202edaa8eb03b$export$ec4825154d679381 = 'error';
const $64e202edaa8eb03b$export$a924d1f92c0e2e78 = 'growth-experiment';
const $64e202edaa8eb03b$export$e5025d93161b0712 = 'sendOperationalEvent';
const $64e202edaa8eb03b$export$5c3e8a6b8e7ba45b = 'growth-error-analytics';
var $64e202edaa8eb03b$export$264ad599d7cef668 = /*#__PURE__*/ function(Product) {
    Product["JIRA"] = "jira";
    Product["CONFLUENCE"] = "confluence";
    Product["ADMIN_HUB"] = "admin-hub";
    return Product;
}({});
var $64e202edaa8eb03b$export$dba1278861bf0dc1 = /*#__PURE__*/ function(ErrorType) {
    ErrorType["GRAPHQL"] = "graphql";
    ErrorType["REST"] = "rest";
    ErrorType["ERROR_BOUNDARY"] = "error-boundary";
    ErrorType["GENERIC"] = "generic";
    return ErrorType;
}({});
var $64e202edaa8eb03b$export$918a9776c0a3cf27 = /*#__PURE__*/ function(Severity) {
    Severity["LOW"] = "low";
    Severity["MEDIUM"] = "medium";
    Severity["HIGH"] = "high";
    return Severity;
}({});
const $64e202edaa8eb03b$export$a61493d7ab73936 = 'growth';
module.exports["ERROR_ACTION"] = $64e202edaa8eb03b$export$ec4825154d679381;
module.exports["ERROR_ACTION_SUBJECT"] = $64e202edaa8eb03b$export$a924d1f92c0e2e78;
module.exports["CONFLUENCE_OPERATIONAL_EVENT_TYPE"] = $64e202edaa8eb03b$export$e5025d93161b0712;
module.exports["Product"] = $64e202edaa8eb03b$export$264ad599d7cef668;
module.exports["ErrorType"] = $64e202edaa8eb03b$export$dba1278861bf0dc1;
module.exports["Severity"] = $64e202edaa8eb03b$export$918a9776c0a3cf27;
module.exports["EVENT_TAG_GROWTH"] = $64e202edaa8eb03b$export$a61493d7ab73936;

});

parcelRegister("gvWCD", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");

const $d2a9f5f63821177b$export$f2a94361d01a626c = ({ team: team, experimentMeta: experimentMeta, errorType: errorType, errorMessage: errorMessage, source: source, severity: severity, isActiveExperiment: isActiveExperiment, product: product, additionalAttributes: additionalAttributes = {} })=>{
    const actionSubjectId = `${(0, $gwZbZ.ERROR_ACTION_SUBJECT)}-${experimentMeta.experimentKey}-${errorType}`;
    return {
        action: (0, $gwZbZ.ERROR_ACTION),
        actionSubject: (0, $gwZbZ.ERROR_ACTION_SUBJECT),
        actionSubjectId: actionSubjectId,
        source: experimentMeta.experimentKey,
        attributes: {
            errorType: errorType,
            team: team,
            experimentKey: experimentMeta.experimentKey,
            cohort: experimentMeta?.cohort,
            severity: severity,
            errorMessage: errorMessage,
            isActiveExperiment: isActiveExperiment,
            product: product,
            detailedSource: source,
            ...additionalAttributes
        },
        tags: [
            (0, $gwZbZ.EVENT_TAG_GROWTH)
        ]
    };
};
module.exports["createEventPayload"] = $d2a9f5f63821177b$export$f2a94361d01a626c;

});

parcelRegister("3HIy9", function(module, exports) {

var $gwZbZ = parcelRequire("gwZbZ");


var $8hmrm = parcelRequire("8hmrm");

const $de70a0c4deb210a2$export$d5090ca98c07c12d = (payload)=>{
    const { data: data } = payload;
    return {
        action: data.action,
        actionSubject: data.actionSubject,
        source: data.source,
        actionSubjectId: data.actionSubjectId,
        tags: data.tags
    };
};
const $de70a0c4deb210a2$export$2144cc21b87dd554 = (payload)=>{
    const { data: data } = payload;
    const eventName = `${data.actionSubject} ${data.action}`;
    return {
        eventName: eventName,
        attributes: data.attributes
    };
};
const $de70a0c4deb210a2$export$f106561f47f05126 = (event)=>{
    const { payload: payload } = event;
    // Extract attributes from the event payload and create a formatted payload
    // specifically for Jira product integration
    const analyticsEventPayload = (0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
        product: (0, $gwZbZ.Product).JIRA,
        team: payload.attributes.team,
        experimentMeta: {
            experimentKey: payload.attributes.experimentKey,
            cohort: payload.attributes.cohort
        },
        errorType: payload.attributes.errorType,
        errorMessage: payload.attributes.errorMessage,
        source: payload.attributes.source,
        severity: payload.attributes.severity
    });
    // Return both payload formats needed for complete Jira analytics integration:
    // 1. createEventPayload: Used with Jira's createAnalyticsEvent
    // 2. fireEventPayload: Used with Jira's fireEvent
    return {
        createEventPayload: $de70a0c4deb210a2$export$d5090ca98c07c12d(analyticsEventPayload),
        fireEventPayload: $de70a0c4deb210a2$export$2144cc21b87dd554(analyticsEventPayload)
    };
};
module.exports["convertEventPayloadForJiraCreateAnalyticsEvent"] = $de70a0c4deb210a2$export$d5090ca98c07c12d;
module.exports["convertEventAttributesForJiraFireEvent"] = $de70a0c4deb210a2$export$2144cc21b87dd554;

});

parcelRegister("39G0n", function(module, exports) {
/**
 * Validates that an experiment name doesn't contain spaces.
 * Experiment names with spaces can cause issues in dashboards and analytics tracking.
 *
 * @param experimentName The experiment name to validate
 * @throws Error if experiment name contains spaces
 */ const $34ecc222054f7431$export$7fa6b5da621cbeb2 = (experimentName)=>{
    if (experimentName.includes(' ')) throw new Error(`Experiment name "${experimentName}" contains spaces. ` + 'Experiment names must not contain spaces to ensure proper tracking in dashboards. ' + 'Use camelCase or hyphens instead (e.g., "myExperiment" or "my-experiment").');
};
module.exports["validateExperimentName"] = $34ecc222054f7431$export$7fa6b5da621cbeb2;

});

parcelRegister("6o7wX", function(module, exports) {
/**
 * Enumeration of authorized teams for growth error analytics
 *
 * IMPORTANT: If your team wants to use growth-commons-error-analytics:
 * 1. Add your team name following the convention 'TEAM_NAME = team-name'
 * 2. Create a PR and request review from the #growth-luna channel
 * 3. Provide context about your team and use case in the PR description
 *
 * The growth-luna team reviews all additions to maintain analytics quality
 * and ensure proper integration with dashboards.
 *
 * @example
 * // Adding a new team:
 * // GROWTH_NEW_TEAM = 'growth-new-team', // requires approval
 */ var $7d6dde24ede24951$export$3e5d0af8e738b082 = /*#__PURE__*/ function(Team) {
    Team["GROWTH_LUNA"] = "growth-luna";
    return Team;
}({});
module.exports["Team"] = $7d6dde24ede24951$export$3e5d0af8e738b082;

});

parcelRegister("5M47w", function(module, exports) {

var $63Hn9 = parcelRequire("63Hn9");


var $jJ96k = parcelRequire("jJ96k");


var $42omo = parcelRequire("42omo");


var $6Co6F = parcelRequire("6Co6F");


var $6bHqX = parcelRequire("6bHqX");


var $lzcvT = parcelRequire("lzcvT");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $8H5XZ = parcelRequire("8H5XZ");


var $7Sm4c = parcelRequire("7Sm4c");





var $lh1MN = parcelRequire("lh1MN");


var $hfUvC = parcelRequire("hfUvC");


var $jMyy4 = parcelRequire("jMyy4");

var $ae96eb60e6557b8b$export$92b15cc7e26a62fb = /*#__PURE__*/ function(CommerceDeepLinksTargetEdition) {
    CommerceDeepLinksTargetEdition["FREE"] = "free";
    CommerceDeepLinksTargetEdition["STANDARD"] = "standard";
    CommerceDeepLinksTargetEdition["PREMIUM"] = "premium";
    return CommerceDeepLinksTargetEdition;
}({});
const $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS = {
    PRODUCTION: 'https://admin.atlassian.com',
    STAGING: 'https://admin.stg.atlassian.com'
};
const $ae96eb60e6557b8b$export$16287b6da0e34b4e = '/admin/billing/applications/change-edition/confluence.ondemand';
const $ae96eb60e6557b8b$export$4591cf268e289775 = '/admin/billing/applications';
const $ae96eb60e6557b8b$var$addAtlOriginToUrl = (url)=>{
    const origin = new (0, $6Co6F.default)({
        product: 'confluence'
    });
    return origin.addToUrl(url);
};
const $ae96eb60e6557b8b$export$39685ba9de2c4192 = ({ cloudId: cloudId, environment: environment, orgId: orgId })=>{
    const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
    if (orgId || cloudId) return orgId ? `${CLOUD_ADMIN_URL}/o/${orgId}/billing-preview` : `${CLOUD_ADMIN_URL}/s/${cloudId}/billing-preview`;
    // In an extreme case where we cannot detect cloudId or orgId, we route user to main AdminHub page.
    return CLOUD_ADMIN_URL;
};
const $ae96eb60e6557b8b$var$buildPlanSelectionLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, transactionAccountId: transactionAccountId, orgId: orgId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$16287b6da0e34b4e;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?referrer=[referrer]
        // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2652063891/How+to+Deeplink+to+BAC+s+change+plan
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}/change-plan?referrer=confluence`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildPlanConsentLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, entitlementId: entitlementId, environment: environment, orgId: orgId, transactionAccountId: transactionAccountId, targetEdition: targetEdition } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}/${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId/change-plan?offeringName=[offering name]&referrer=[referrer]
    // See https://hello.atlassian.net/wiki/spaces/BILLIONS/pages/2820329173/How+to+Deeplink+change+plan+consent
    return targetEdition ? `${$ae96eb60e6557b8b$var$buildPlanSelectionLink(params)}&offeringName=${targetEdition}` : $ae96eb60e6557b8b$var$buildPlanSelectionLink(params);
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
const $ae96eb60e6557b8b$var$buildSubscriptionDetailsLink = (params)=>{
    const { cloudId: cloudId, commerceBackendName: commerceBackendName, environment: environment, entitlementId: entitlementId, orgId: orgId, transactionAccountId: transactionAccountId } = params;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_HAMS)) return $ae96eb60e6557b8b$export$4591cf268e289775;
    if (commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) && entitlementId && transactionAccountId) {
        const CLOUD_ADMIN_URL = $ae96eb60e6557b8b$var$CLOUD_ADMIN_ENV_URLS[environment ?? 'PRODUCTION'];
        // https://admin.atlassian.com/billing/:txaId/entitlement/:entitlementId
        return `${CLOUD_ADMIN_URL}/billing/${transactionAccountId}/entitlement/${entitlementId}`;
    }
    return $ae96eb60e6557b8b$export$39685ba9de2c4192({
        cloudId: cloudId,
        environment: environment,
        orgId: orgId
    });
};
// (Concept is adopted from Kent C. Dodds here:
//  https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript)
const $ae96eb60e6557b8b$var$getErrorMessage = (label, error)=>{
    const message = error instanceof Error ? error.message : String(error);
    return `${label}: ${message}`;
};
const $ae96eb60e6557b8b$export$91505ae0b86ded0b = ({ targetEdition: targetEdition, skipDeepLinks: skipDeepLinks = false })=>{
    const { environment: environment, cloudId: cloudId, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    if (!isSiteAdmin || !cloudId) skipDeepLinks = true;
    /**
   * The best practice advocates for one graphql per component and ideally no graphql quries in a hook
   * but to construct the deeplink, we need to:
   * 1. first call Commerce API to retrieve the Confluence instance backend service (CCP or HAMS),
   * 2. for CCP, call ccgraphql to retrieve the ccpEntitlementId
   * 3. for CCP, call AGG to retrieve the CCP transaction account Id using the ccpEntitlementId retrieved in step #2.
   *
   * This is a stop gap solution while we work with Commerce to eventually have one AGG query
   * to provide everything we need with just a CloudId and the product key (e.g. confluence
   */ const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $hfUvC.useCommerceRolloutInformation)(skipDeepLinks || (0, $lzcvT.isFedRamp)());
    // If it is in FedRamp, we can assume it is CCP backend.
    // More details -> https://atlassian.slack.com/archives/C04LF8UKAE4/p1734981625650579
    const isCcpBackend = commerceBackendName === (0, $6bHqX.COMMERCE_BACKEND_CCP) || (0, $lzcvT.isFedRamp)();
    const { data: ccpEntitlementIdData, loading: ccpEntitlementIdLoading, error: ccpEntitlementIdError } = (0, $jMyy4.useQueryInterop)(/** @schema cc */ (0, $jJ96k.default), {
        skip: skipDeepLinks || !isCcpBackend
    });
    const ccpEntitlementId = !ccpEntitlementIdLoading ? (0, $lh1MN.getCcpEntitlementFromQuery)(ccpEntitlementIdData) : undefined;
    const { data: ccpEntitlementTxaIdData, loading: ccpEntitlementTxaIdLoading, error: ccpEntitlementTxaIdError } = (0, $jMyy4.useQueryInterop)(/** @schema agg */ (0, $63Hn9.default), {
        variables: {
            entitlementId: ccpEntitlementId || '',
            targetEditionName: targetEdition || ''
        },
        skip: skipDeepLinks || !isCcpBackend || !ccpEntitlementId,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (skipDeepLinks) return {
        commerceBackendName: null,
        planSelectionDeepLink: undefined,
        planConsentDeepLink: undefined,
        subscriptionDetailsDeepLink: undefined,
        loading: false,
        errorMessage: undefined
    };
    let errorMessage;
    let planSelectionDeepLink;
    let planConsentDeepLink;
    let subscriptionDetailsDeepLink;
    let changeOfferingDeepLink;
    try {
        const entitlementId = ccpEntitlementId;
        const transactionAccountId = ccpEntitlementTxaIdData?.ccp?.entitlement?.transactionAccountId;
        // format -> https://admin.stg.atlassian.com/billing/UUID/entitlement/TWC-UUID-OR-CONF/change-plan?requireAtlOrigin=true&referrer=confluence
        // Note: if product is TWC Confluence, then there is no referrer param added from ccp-graphql
        const changeOfferingExperienceUrl = ccpEntitlementTxaIdData?.ccp?.entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl ?? undefined;
        const commerceParams = {
            cloudId: cloudId,
            commerceBackendName: commerceBackendName,
            environment: environment,
            entitlementId: entitlementId,
            orgId: orgId,
            transactionAccountId: transactionAccountId || undefined
        };
        planSelectionDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanSelectionLink(commerceParams));
        planConsentDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildPlanConsentLink({
            targetEdition: targetEdition,
            ...commerceParams
        }));
        if (changeOfferingExperienceUrl) {
            if ((0, $6mKj3.expValEquals)('confluence_fix_referrer_param_commerce_deeplinks', 'cohort', 'variation')) {
                const url = new URL(changeOfferingExperienceUrl);
                url.searchParams.set('referrer', 'confluence');
                changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(url.toString());
            } else changeOfferingDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl(`${changeOfferingExperienceUrl}confluence`);
        }
        subscriptionDetailsDeepLink = $ae96eb60e6557b8b$var$addAtlOriginToUrl($ae96eb60e6557b8b$var$buildSubscriptionDetailsLink(commerceParams));
        // Mark all graphql errors as handled since we will return the fallback plan selection url
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementIdError);
        if ((0, $8H5XZ.isGraphQLError)(ccpEntitlementTxaIdError) && !(0, $7Sm4c.isErrorMarkedAsHandled)(ccpEntitlementTxaIdError)) (0, $7Sm4c.markErrorAsHandled)(ccpEntitlementTxaIdError);
        if (commerceBackendNameError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving Commerce Backend Service', commerceBackendNameError);
        else if (ccpEntitlementIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Entitlement Id', ccpEntitlementIdError);
        else if (ccpEntitlementTxaIdError) errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error retrieving CCP Transaction Account Id', ccpEntitlementTxaIdError);
    } catch (e) {
        errorMessage = $ae96eb60e6557b8b$var$getErrorMessage('Error in useCommerceDeepLinks', e);
    }
    const loading = commerceBackendNameLoading || ccpEntitlementIdLoading || ccpEntitlementTxaIdLoading;
    return {
        commerceBackendName: commerceBackendName,
        planSelectionDeepLink: planSelectionDeepLink,
        planConsentDeepLink: changeOfferingDeepLink || planConsentDeepLink,
        subscriptionDetailsDeepLink: subscriptionDetailsDeepLink,
        loading: loading,
        errorMessage: errorMessage
    };
};
module.exports["CommerceDeepLinksTargetEdition"] = $ae96eb60e6557b8b$export$92b15cc7e26a62fb;
module.exports["useCommerceDeepLinks"] = $ae96eb60e6557b8b$export$91505ae0b86ded0b;

});

parcelRegister("63Hn9", function(module, exports) {
/**
 * @generated SignedSource<<aaa1b42d2ee5d6bc179b58f5a8a79ad5>>
 * @relayHash 1550b53499cc9c4c43997e297fa050c5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5
const $9dd5459212e2b154$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "entitlementId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "targetEditionName"
        }
    ], v1 = [
        {
            "concreteType": "CcpQueryApi",
            "kind": "LinkedField",
            "name": "ccp",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "entitlementId"
                        }
                    ],
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "transactionAccountId"
                        },
                        {
                            "concreteType": "CcpEntitlementExperienceCapabilities",
                            "kind": "LinkedField",
                            "name": "experienceCapabilities",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Variable",
                                            "name": "offeringName",
                                            "variableName": "targetEditionName"
                                        }
                                    ],
                                    "concreteType": "CcpChangeOfferingExperienceCapability",
                                    "kind": "LinkedField",
                                    "name": "changeOfferingV2",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "experienceUrl"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1550b53499cc9c4c43997e297fa050c5",
            "id": "10738af8cd0e26e61c93e96a9aa88d2a81fd8fade160ae57f575778fdf62b7c5",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpTransactionAccountIdQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpTransactionAccountIdQuery($entitlementId:ID!,$targetEditionName:String){ccp{entitlement(id:$entitlementId){transactionAccountId,experienceCapabilities{changeOfferingV2(offeringName:$targetEditionName){experienceUrl}},id}}}"
        }
    };
}();
$9dd5459212e2b154$var$node.hash = "0078d9648e47947324143eae530f4046";
var $9dd5459212e2b154$export$2e2bcd8739ae039 = $9dd5459212e2b154$var$node;
module.exports["default"] = $9dd5459212e2b154$export$2e2bcd8739ae039;

});

parcelRegister("jJ96k", function(module, exports) {
/**
 * @generated SignedSource<<7ff3d6436d992002e934e359883f7f59>>
 * @relayHash 7b6d56299e8bad23570ed5580bdc5641
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797
const $edae1a4299d7e8da$var$node = function() {
    var v0 = [
        {
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "LicenseStates",
                    "kind": "LinkedField",
                    "name": "licenseStates",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "LicenseState",
                            "kind": "LinkedField",
                            "name": "confluence",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "ccpEntitlementId"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "Tenant",
            "kind": "LinkedField",
            "name": "tenant",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "cloudId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "7b6d56299e8bad23570ed5580bdc5641",
            "id": "6a5e4f4a4d3d13a42fadcbccaa10e14ae28ca67b7e22b87a8246aa660c4e7797",
            "metadata": {},
            "name": "useCommerceDeepLinksCcpEntitlementQuery",
            "operationKind": "query",
            "text": "query useCommerceDeepLinksCcpEntitlementQuery{confluence_tenantContext{licenseStates{confluence{ccpEntitlementId}}},tenant{cloudId}}"
        }
    };
}();
$edae1a4299d7e8da$var$node.hash = "f1b8b946a65b7c16eb6735dad6d5b323";
var $edae1a4299d7e8da$export$2e2bcd8739ae039 = $edae1a4299d7e8da$var$node;
module.exports["default"] = $edae1a4299d7e8da$export$2e2bcd8739ae039;

});

parcelRegister("6bHqX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6H9BA = parcelRequire("6H9BA");


var $4Twfb = parcelRequire("4Twfb");


var $3yFL2 = parcelRequire("3yFL2");

var $3SLm1 = parcelRequire("3SLm1");

var $cEhot = parcelRequire("cEhot");


var $1Y5Zp = parcelRequire("1Y5Zp");

const $30c48f23b8aa47be$export$56507f8f3f7349a5 = 'HAMS';
const $30c48f23b8aa47be$export$9a39331b1bb2f849 = 'CCP';
const $30c48f23b8aa47be$export$49ab1426acf387e4 = async (_params, _options)=>{
    return {
        payload: {
            commerceBackend: 'CCP',
            ccp: {}
        },
        error: undefined,
        exception: undefined
    };
};
const $30c48f23b8aa47be$export$532017a098b73852 = (params, options)=>{
    const fetch = (0, $6H9BA.useCommerceFetch)();
    const effectiveOptions = (0, $42omo.useMemo)(()=>({
            fetch: fetch,
            ...options
        }), [
        fetch,
        options
    ]);
    const startTask = (0, $cEhot.useTaskTracker)({
        action: 'fetched',
        actionSubject: 'commerceRolloutInformation',
        source: 'unknown'
    });
    return (0, $4Twfb.useFetchService)((0, $42omo.useCallback)(async ()=>{
        const taskResult = await startTask(async ()=>{
            const result = await $30c48f23b8aa47be$export$49ab1426acf387e4(params, effectiveOptions);
            if ((0, $1Y5Zp.isSuccessful)(result)) return {
                succeed: {
                    payload: result.payload
                }
            };
            else if ((0, $1Y5Zp.isException)(result)) // fetch can sometimes throw, but most likely this is a bug
            return {
                fail: {
                    payload: result.exception,
                    loggablePayload: result.exception,
                    responsibleService: (0, $3SLm1).COMMERCE_LIBRARIES,
                    probabilityOfBug: (0, $3yFL2).GUARANTEED
                }
            };
            return {
                // Failed response from server.
                fail: {
                    payload: result.error,
                    responsibleService: (0, $3SLm1).BILLING_API_GATEWAY,
                    // TODO: Review HTTP codes to differentiate between bug and normal errors
                    probabilityOfBug: (0, $3yFL2).MAYBE
                }
            };
        });
        if (taskResult.succeed !== undefined) return taskResult.succeed.payload;
        throw taskResult.fail.payload;
    }, [
        startTask,
        params,
        effectiveOptions
    ]));
};
module.exports["COMMERCE_BACKEND_HAMS"] = $30c48f23b8aa47be$export$56507f8f3f7349a5;
module.exports["COMMERCE_BACKEND_CCP"] = $30c48f23b8aa47be$export$9a39331b1bb2f849;
module.exports["fetchCommerceRolloutInformation"] = $30c48f23b8aa47be$export$49ab1426acf387e4;

});

parcelRegister("6H9BA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $goqBE = parcelRequire("goqBE");


var $bIMHH = parcelRequire("bIMHH");


var $1cK19 = parcelRequire("1cK19");


var $1EMUC = parcelRequire("1EMUC");


var $lzJ3V = parcelRequire("lzJ3V");

const $5f57f8a421838b9c$export$5f844fc0012b62a = ()=>{
    const commerceContextFetch = (0, $1EMUC.useCommerceOverride)(fetch);
    const dispatchSentryException = (0, $bIMHH.useSentryExceptionDispatch)();
    return (0, $42omo.useCallback)(async (...args)=>{
        const startTime = performance.now();
        const [fetchInput] = args;
        const sanitizedUrl = (0, $1cK19.sanitizeUrlString)((0, $lzJ3V.getRequestUrl)(fetchInput));
        try {
            const response = await commerceContextFetch(...args);
            if (response.status >= 400) dispatchSentryException({
                exception: new Error(`Status: ${response.status}\nURL: ${sanitizedUrl}`)
            });
            (0, $4u5NT.addSpanToAll)('fetch', sanitizedUrl, [
                {
                    name: 'network'
                }
            ], startTime, performance.now(), JSON.stringify(response).length);
            return response;
        } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
            const oldErrorMessage = (()=>{
                if (error instanceof Error) return error.stack ?? error.toString();
                else return JSON.stringify(error);
            })();
            const newErrorMessage = `An error occurred when fetching from ${sanitizedUrl}\n\n ${oldErrorMessage}`;
            const wrappedError = new Error(newErrorMessage);
            dispatchSentryException({
                exception: wrappedError
            });
            throw error;
        }
    }, [
        commerceContextFetch,
        dispatchSentryException
    ]);
};
const $5f57f8a421838b9c$export$2eeff918208c7909 = (request, dispatchSentryException)=>request.catch((error)=>{
        // reportHttpError doesn't dispatch url as HttpResponseError has a resource name in the message
        if (error instanceof (0, $goqBE.HttpResponseError)) dispatchSentryException({
            exception: error
        });
        const oldErrorMessage = (()=>{
            if (error instanceof Error) return error.stack ?? error.toString();
            else return JSON.stringify(error);
        })();
        const newErrorMessage = `An error occurred when fetching data\n\n ${oldErrorMessage}`;
        dispatchSentryException({
            exception: new Error(newErrorMessage)
        });
        return error;
    });
module.exports["useCommerceFetch"] = $5f57f8a421838b9c$export$5f844fc0012b62a;

});

parcelRegister("goqBE", function(module, exports) {
class $de24e055bcb736b9$export$d2f2761cbe9cebf2 extends Error {
    constructor(resourceName, statusCode, body){
        super(`Unable to fetch ${resourceName}, status: ${statusCode}`);
        this.statusCode = void 0;
        this.body = void 0;
        this.name = 'HttpResponseError';
        this.statusCode = statusCode;
        this.body = body;
        // necessary as Subclassing Error needs special treatment in typescript for some compilation targets
        //https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $de24e055bcb736b9$export$d2f2761cbe9cebf2.prototype);
    }
}
const $de24e055bcb736b9$export$a4c208475de70990 = async (resourceName, response)=>{
    const res = await response;
    if (res.ok) return response;
    throw new $de24e055bcb736b9$export$d2f2761cbe9cebf2(resourceName, res.status, // ignore error if there is no body,
    // there is no way to check if body is set as https://developer.mozilla.org/en-US/docs/Web/API/Body/bodyUsed is not supported by many browsers
    await res.json().catch(()=>undefined));
};
module.exports["HttpResponseError"] = $de24e055bcb736b9$export$d2f2761cbe9cebf2;
module.exports["rejectOnHttpError"] = $de24e055bcb736b9$export$a4c208475de70990;

});

parcelRegister("bIMHH", function(module, exports) {

var $aNwpq = parcelRequire("aNwpq");


var $k6lJw = parcelRequire("k6lJw");


var $6YLhE = parcelRequire("6YLhE");

const $48dc7deec6188f73$export$3c3f21d4489e178a = (0, $aNwpq.internalGasV3UIEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$5e75c4fb0a07e6f4 = (0, $aNwpq.internalGasV3ScreenEventChannel).useEventDispatch;
const $48dc7deec6188f73$export$eb1dac57abae25e8 = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$ab6d20b2228c09c6 = (0, $aNwpq.internalGasV3OperationalEventChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$cf4d833c52e18bed = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch;
const $48dc7deec6188f73$export$8eb9a37a282b8ea6 = (0, $k6lJw.createAtlaskitToEventChannelRepackager)($48dc7deec6188f73$export$3c3f21d4489e178a);
const $48dc7deec6188f73$export$d6cab26720f11779 = (0, $aNwpq.breadcrumbMountedEventChannel).Listener;
const $48dc7deec6188f73$export$794ea2871d096951 = (Component, name, attributes)=>(0, $6YLhE.withBreadcrumb)(Component, (0, $aNwpq.Breadcrumb), name, attributes);
module.exports["useSentryExceptionDispatch"] = $48dc7deec6188f73$export$cf4d833c52e18bed;

});

parcelRegister("aNwpq", function(module, exports) {

var $6YLhE = parcelRequire("6YLhE");


var $eUjEX = parcelRequire("eUjEX");

const $48f3d8edf25a7fa7$var$breadcrumbAPI = (0, $6YLhE.createBreadcrumbAPI)();
const $48f3d8edf25a7fa7$export$1622e7b9340efb0 = $48f3d8edf25a7fa7$var$breadcrumbAPI.breadcrumbMountedEventChannel;
const $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc = $48f3d8edf25a7fa7$var$breadcrumbAPI.Breadcrumb;
const $48f3d8edf25a7fa7$export$a841c408695b0137 = $48f3d8edf25a7fa7$var$breadcrumbAPI.useGetBreadcrumbs;
const $48f3d8edf25a7fa7$export$58a908b728d2cddc = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$34eb9485fd3a664a = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$fb5e587076f78057 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$f92d259194a988f8 = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$d9c23c680d73705d = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$b7973f9532f3f87f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$5a78c7e669ed705e = (0, $eUjEX.createCatchingEventChannel)();
const $48f3d8edf25a7fa7$export$90a2fbbf51eb525f = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
const $48f3d8edf25a7fa7$export$d9101fe70b7457a1 = (0, $6YLhE.createBreadcrumbedEventChannel)($48f3d8edf25a7fa7$var$breadcrumbAPI, (0, $eUjEX.createCatchingEventChannel));
module.exports["breadcrumbMountedEventChannel"] = $48f3d8edf25a7fa7$export$1622e7b9340efb0;
module.exports["Breadcrumb"] = $48f3d8edf25a7fa7$export$dabcc1ec9dd9d1cc;
module.exports["internalGasV3UIEventChannel"] = $48f3d8edf25a7fa7$export$b7973f9532f3f87f;
module.exports["internalGasV3ScreenEventChannel"] = $48f3d8edf25a7fa7$export$5a78c7e669ed705e;
module.exports["internalGasV3TrackEventChannel"] = $48f3d8edf25a7fa7$export$90a2fbbf51eb525f;
module.exports["internalGasV3OperationalEventChannel"] = $48f3d8edf25a7fa7$export$c70a8fa9e6b52c91;
module.exports["internalSentryExceptionChannel"] = $48f3d8edf25a7fa7$export$d9101fe70b7457a1;

});

parcelRegister("6YLhE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eUjEX = parcelRequire("eUjEX");

const $098bf883a354e4d9$var$emptyObject = {};
const $098bf883a354e4d9$export$783e5d823c500873 = ()=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(()=>undefined);
    const useGetBreadcrumbs = ()=>(0, $42omo.useContext)(context);
    const breadcrumbMountedEventChannel = (0, $eUjEX.createEventChannel)();
    const { useEventDispatch: useEventDispatch } = breadcrumbMountedEventChannel;
    const EmitEventOnMount = ({ name: name, getMountedBreadcrumbPayload: getMountedBreadcrumbPayload })=>{
        const eventDispatch = useEventDispatch();
        (0, $42omo.useEffect)(()=>{
            // Should always be defined at this point.
            eventDispatch(getMountedBreadcrumbPayload());
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            name
        ]);
        return null;
    };
    const Breadcrumb = ({ children: children, ...breadcrumbPayload })=>{
        const getParentBreadcrumbs = useGetBreadcrumbs();
        // TODO: Type inference doesn't seem to understand that children and name are never a part of breadcrumbPayload. Investigate and fix.
        const castBreadcrumbPayload = breadcrumbPayload;
        // Prevents breadcrumb callback from being recreated everytime props change/every-render
        const breadcrumbRef = (0, $42omo.useRef)(castBreadcrumbPayload);
        (0, $42omo.useLayoutEffect)(()=>{
            // Ensures that the breadcrumb only updates when it component is mounted
            breadcrumbRef.current = castBreadcrumbPayload;
        });
        // TODO: Memoize this in the future?
        const getMountedBreadcrumbPayload = (0, $42omo.useCallback)(()=>({
                breadcrumbs: [
                    ...getParentBreadcrumbs()?.breadcrumbs ?? [],
                    breadcrumbRef.current
                ],
                payload: breadcrumbRef.current
            }), [
            getParentBreadcrumbs
        ]);
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)(EmitEventOnMount, {
                    name: breadcrumbPayload.name,
                    getMountedBreadcrumbPayload: getMountedBreadcrumbPayload
                }),
                /*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
                    value: getMountedBreadcrumbPayload,
                    children: children
                })
            ]
        });
    };
    return {
        breadcrumbMountedEventChannel: /**
		 * An event channel whos event represents that a breadcrumb was mounted
		 */ breadcrumbMountedEventChannel,
        Breadcrumb: Breadcrumb,
        useGetBreadcrumbs: useGetBreadcrumbs
    };
};
const $098bf883a354e4d9$export$d3653322274df895 = ({ useGetBreadcrumbs: useGetBreadcrumbs }, createEventChannelFn = (0, $eUjEX.createEventChannel))=>{
    const { Listener: Listener, useEventDispatch: useEventDispatch } = createEventChannelFn();
    const useBreadcrumbedEventDispatch = ()=>{
        const eventDispatch = useEventDispatch();
        const getParentBreadcrumbs = useGetBreadcrumbs();
        const breadcrumbedEventDispatch = (0, $42omo.useCallback)((payload)=>eventDispatch({
                breadcrumbs: getParentBreadcrumbs()?.breadcrumbs ?? [],
                payload: payload
            }), [
            getParentBreadcrumbs,
            eventDispatch
        ]);
        return breadcrumbedEventDispatch;
    };
    return {
        Listener: Listener,
        useEventDispatch: useEventDispatch,
        useBreadcrumbedEventDispatch: useBreadcrumbedEventDispatch
    };
};
const $098bf883a354e4d9$export$794ea2871d096951 = (Component, Breadcrumb, name, // TODO: Fix up this type
breadcrumbFields = $098bf883a354e4d9$var$emptyObject)=>{
    const ComponentWithBreadcrumb = (props)=>/*#__PURE__*/ (0, $l998X.jsx)(Breadcrumb, {
            ...breadcrumbFields,
            name: name,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...props
            })
        });
    return ComponentWithBreadcrumb;
};
module.exports["createBreadcrumbAPI"] = $098bf883a354e4d9$export$783e5d823c500873;
module.exports["createBreadcrumbedEventChannel"] = $098bf883a354e4d9$export$d3653322274df895;
module.exports["withBreadcrumb"] = $098bf883a354e4d9$export$794ea2871d096951;

});

parcelRegister("eUjEX", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e = (defaultOnEventCallback)=>{
    const context = /*#__PURE__*/ (0, $42omo.createContext)(defaultOnEventCallback);
    const useEventDispatch = ()=>{
        const onEventCallback = (0, $42omo.useContext)(context);
        const fireEventCallback = (0, $42omo.useCallback)((event)=>{
            onEventCallback?.(event);
        }, [
            onEventCallback
        ]);
        return fireEventCallback;
    };
    const EventCatcher = ({ onEvent: onEvent, children: children })=>/*#__PURE__*/ (0, $l998X.jsx)(context.Provider, {
            value: onEvent,
            children: children
        });
    return {
        Listener: EventCatcher,
        useEventDispatch: useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$7b182ad6fa711a33 = ()=>{
    const catchingEventChannel = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e();
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99({
        from: catchingEventChannel.Listener,
        to: catchingEventChannel.useEventDispatch
    });
    return {
        Listener: ListenerThatDoesntConsumeEvent,
        useEventDispatch: catchingEventChannel.useEventDispatch
    };
};
const $e0bd124d99ee3c1b$export$21d0f08655d40180 = (...listenersToCombine)=>{
    const CombinedListener = ({ children: children, onEvent: onEvent })=>{
        let wrappedChildren = children;
        for (const ListenerToCombine of listenersToCombine)wrappedChildren = ListenerToCombine({
            onEvent: onEvent,
            children: wrappedChildren
        });
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: wrappedChildren
        });
    };
    return CombinedListener;
};
const $e0bd124d99ee3c1b$export$9591aa59b8e3deeb = ({ from: inboundListenerValue, to: useOutboundEventDispatch, useTransformer: useTransformer })=>{
    const InboundListener = Array.isArray(inboundListenerValue) ? $e0bd124d99ee3c1b$export$21d0f08655d40180(...inboundListenerValue) : inboundListenerValue;
    const Transformer = ({ children: children, ...transformerProps })=>{
        const dispatchTransformedEvent = useOutboundEventDispatch();
        const transform = useTransformer(transformerProps);
        const transformFn = (0, $42omo.useCallback)((payload)=>{
            const transformed = transform(payload);
            dispatchTransformedEvent(transformed);
        }, [
            dispatchTransformedEvent,
            transform
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(InboundListener, {
            onEvent: transformFn,
            children: children
        });
    };
    return Transformer;
};
const $e0bd124d99ee3c1b$export$a5fa32b3c7f79e99 = ({ from: from, to: to })=>{
    const ListenerThatDoesntConsumeEvent = $e0bd124d99ee3c1b$export$9591aa59b8e3deeb({
        from: from,
        to: to,
        useTransformer: ({ onEvent: onEvent })=>(0, $42omo.useCallback)((payload)=>{
                onEvent(payload);
                return payload;
            }, [
                onEvent
            ])
    });
    return ListenerThatDoesntConsumeEvent;
};
const $e0bd124d99ee3c1b$export$6c91a1925c226122 = (Listener, filter)=>{
    const FilteredListener = ({ onEvent: onEvent, ...other })=>{
        const filteredOnEvent = (0, $42omo.useCallback)((eventPayload)=>{
            if (filter(eventPayload)) onEvent(eventPayload);
        }, [
            onEvent
        ]);
        return Listener({
            onEvent: filteredOnEvent,
            ...other
        });
    };
    return FilteredListener;
};
const $e0bd124d99ee3c1b$export$acca048df1683b81 = (children, components)=>{
    let wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    for(let i = components.length - 1; i >= 0; i--){
        const { Listener: Listener, onEvent: onEvent } = components[i];
        wrappedChildren = /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: onEvent,
            children: wrappedChildren
        });
    }
    return wrappedChildren;
};
module.exports["createCatchingEventChannel"] = $e0bd124d99ee3c1b$export$5f3dbb5babc7e42e;
module.exports["createEventChannel"] = $e0bd124d99ee3c1b$export$7b182ad6fa711a33;

});

parcelRegister("k6lJw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $kDuN4 = parcelRequire("kDuN4");

var $inPa6 = parcelRequire("inPa6");

const $39d282bcf5375d57$var$ATLASKIT_CHANNEL = 'atlaskit';
const $39d282bcf5375d57$export$b1e3a2222bb9a86d = (useEventDispatch, channel)=>{
    const RepackageAnalyticsNextEvent = ({ children: children, ...uiProperties })=>{
        const dispatchAnalytics = useEventDispatch();
        const repackageAtlaskitEvent = (0, $42omo.useCallback)((event)=>{
            dispatchAnalytics({
                ...uiProperties,
                ...event.payload,
                attributes: {
                    ...uiProperties.attributes,
                    ...event.payload.attributes
                }
            });
        }, [
            dispatchAnalytics,
            uiProperties
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $kDuN4.default), {
            channel: channel,
            onEvent: repackageAtlaskitEvent,
            children: children
        });
    };
    return RepackageAnalyticsNextEvent;
};
const $39d282bcf5375d57$export$1ec809871e34d2f0 = (// TODO: Technically, we can make the type more specific than just UIAnalyticsPayload
useEventDispatch)=>{
    const RepackageAtlaskitEvent = $39d282bcf5375d57$export$b1e3a2222bb9a86d(useEventDispatch, 'atlaskit');
    return RepackageAtlaskitEvent;
};
const $39d282bcf5375d57$export$ad0c43fbe23d07ab = (Listener, channel = $39d282bcf5375d57$var$ATLASKIT_CHANNEL)=>{
    return ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
        const fireAsAtlaskitEvent = (0, $42omo.useCallback)((payload)=>{
            createAnalyticsEvent(payload).fire(channel);
        }, [
            createAnalyticsEvent
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)(Listener, {
            onEvent: fireAsAtlaskitEvent,
            children: children
        });
    };
};
module.exports["createAtlaskitToEventChannelRepackager"] = $39d282bcf5375d57$export$1ec809871e34d2f0;

});

parcelRegister("1cK19", function(module, exports) {
/**
 * @param url The URL you want to sanitize
 * @returns A URL string without any user generated content (UGC) or PII (personally identifiable information). The URL will not necessarily be valid URL.
 */ const $3031758fc3a9c9bd$export$ceb09b958e605eff = (url)=>{
    // TODO: Should redact anything not from atlassian.com/atlassian.net/bitbucket.org/etc
    return url.replace(/\?.*$/, '');
};
module.exports["sanitizeUrlString"] = $3031758fc3a9c9bd$export$ceb09b958e605eff;

});

parcelRegister("1EMUC", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9Bcp3 = parcelRequire("9Bcp3");

const $fb2833db791c8fde$export$8d3ccdf5c3b9600a = ({ children: children, overrides: overrides })=>{
    const [registry] = (0, $42omo.useState)(()=>new Map(overrides));
    (0, $42omo.useEffect)(()=>{
        const callbacks = overrides.map(([subject, target])=>$fb2833db791c8fde$export$87a46fc2314946e0(registry, subject, target));
        return ()=>callbacks.forEach((cb)=>cb());
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    overrides);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9Bcp3.overrideContext).Provider, {
        value: registry,
        children: children
    });
};
const $fb2833db791c8fde$export$edb6244a86733174 = ()=>(0, $42omo.useContext)((0, $9Bcp3.overrideContext));
const $fb2833db791c8fde$export$87a46fc2314946e0 = (registry, subject, override)=>{
    registry.set(subject, override);
    return ()=>{
        registry.delete(subject);
    };
};
const $fb2833db791c8fde$export$9218bfcced62f524 = (registry, subject)=>{
    return registry.get(subject) || subject;
};
const $fb2833db791c8fde$export$cf6f15ae0c6d3b84 = (subject)=>{
    const registry = $fb2833db791c8fde$export$edb6244a86733174();
    return (registry || new Map()).get(subject) || subject;
};
const $fb2833db791c8fde$export$ef191f4a42af511d = (subject, target)=>[
        subject,
        target
    ];
module.exports["useCommerceOverride"] = $fb2833db791c8fde$export$cf6f15ae0c6d3b84;

});

parcelRegister("9Bcp3", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $0f5923cabface8ba$export$81b0387840a1a60c = (0, $42omo.createContext)(new Map());
module.exports["overrideContext"] = $0f5923cabface8ba$export$81b0387840a1a60c;

});

parcelRegister("lzJ3V", function(module, exports) {
const $8b805f09b2bef0e7$export$14619c0eed01a470 = (fetchInput)=>typeof fetchInput === 'string' ? fetchInput : fetchInput instanceof URL ? fetchInput.href : fetchInput.url;
module.exports["getRequestUrl"] = $8b805f09b2bef0e7$export$14619c0eed01a470;

});

parcelRegister("4Twfb", function(module, exports) {
// eslint-disable-next-line import/no-extraneous-dependencies

var $42omo = parcelRequire("42omo");

const $b022c09cd7385a9a$export$6de4685a6c88b4e9 = (request, initialState = {
    loading: false,
    data: undefined,
    error: undefined
})=>{
    const [state, setState] = (0, $42omo.useState)(initialState);
    const fetchData = (0, $42omo.useCallback)(async (...requestArgs)=>{
        setState({
            loading: true,
            data: undefined,
            error: undefined
        });
        try {
            const data = await request(...requestArgs);
            setState({
                loading: false,
                data: data,
                error: undefined
            });
            return data;
        } catch (error) {
            // Casting promise error to provided type. I assumes that the person that
            // provides types know that kind of type promise will return on reject.
            setState({
                loading: false,
                data: undefined,
                error: error
            });
            throw error;
        }
    }, [
        request
    ]);
    return (0, $42omo.useMemo)(()=>({
            ...state,
            fetchData: fetchData
        }), [
        state,
        fetchData
    ]);
};
const $b022c09cd7385a9a$export$ff7e5879ade03276 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: true,
        data: undefined,
        error: undefined
    });
    const { fetchData: fetchData } = service;
    (0, $42omo.useEffect)(()=>{
        // on error promise will be resolved to undefined, error instance available in state
        // eslint-disable-next-line no-console
        fetchData().catch((error)=>console.warn(error));
    }, [
        fetchData
    ]);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            refresh: ()=>fetchData()
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$18e513c1248d8ad5 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request, {
        loading: false,
        data: undefined,
        error: undefined
    });
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            update: fetchData
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$d9765c5cd98039 = (request)=>{
    const service = $b022c09cd7385a9a$export$18e513c1248d8ad5(request);
    return (0, $42omo.useMemo)(()=>{
        const { update: update, ...state } = service;
        return {
            ...state,
            fetch: update
        };
    }, [
        service
    ]);
};
const $b022c09cd7385a9a$export$7077fee76310bc60 = (request)=>{
    const service = $b022c09cd7385a9a$export$6de4685a6c88b4e9(request);
    return (0, $42omo.useMemo)(()=>{
        const { fetchData: fetchData, ...state } = service;
        return {
            ...state,
            create: fetchData
        };
    }, [
        service
    ]);
};
module.exports["useFetchService"] = $b022c09cd7385a9a$export$ff7e5879ade03276;
module.exports["useUpdateService"] = $b022c09cd7385a9a$export$18e513c1248d8ad5;

});

parcelRegister("3yFL2", function(module, exports) {
/**
 * For when the code is meant to only ever executed when a bug has ocurred.
 *
 * Note: Choosing a probability-of-bug value should not be speculate/account for specific bugs in the code base
 *
 * Examples:
 * - A top-level try-catch whos only purpose is to prevent your entire application from crashing when random exceptions are thrown
 * - HTTP 500 status code handling logic (assuming 500s only happen when the server has experienced a bug/crash)
 * - Server responses that signal that the JSON payload frontend sent was completely wrong
 * - Part of your app unexpectedly crashes
 * - Any response bodys/HTTP statuses you were not expecting to receive
 */ const $46d5cbdb1ec76aac$export$6af268b89fae390b = 'guaranteed';
const $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf = 'maybe';
const $46d5cbdb1ec76aac$export$c53d0f541b41b88e = 'none';
module.exports["GUARANTEED"] = $46d5cbdb1ec76aac$export$6af268b89fae390b;
module.exports["MAYBE"] = $46d5cbdb1ec76aac$export$dab33e9f81ed2cbf;
module.exports["NONE"] = $46d5cbdb1ec76aac$export$c53d0f541b41b88e;

});

parcelRegister("3SLm1", function(module, exports) {
/**
 * Note: If you add a service here please name after what's mentioned in Microscope.
 * It'll make figuring out who to page (if we need to) easier. See: https://microscope.prod.atl-paas.net/services/commerce-libraries
 *
 * TODO: Probably worth adding some sort of build check to make sure this is enforced
 */ /**
 * It's not enforced, but if you add a service here
 */ /**
 * Generally, you'll want to use this value if you're not 100% sure who can cause the error.
 */ const $a2df338368098843$export$78244dbb77cfa6b6 = 'unknown';
const $a2df338368098843$export$aed27a6561cc0f5c = 'unknown-external';
const $a2df338368098843$export$983d8427a452c1b = 'commerce-libraries';
const $a2df338368098843$export$d5a5208541f78b0 = 'hams';
const $a2df338368098843$export$856303030f6df405 = 'billing-api-gateway';
module.exports["UNKNOWN"] = $a2df338368098843$export$78244dbb77cfa6b6;
module.exports["UNKNOWN_EXTERNAL"] = $a2df338368098843$export$aed27a6561cc0f5c;
module.exports["COMMERCE_LIBRARIES"] = $a2df338368098843$export$983d8427a452c1b;
module.exports["HAMS"] = $a2df338368098843$export$d5a5208541f78b0;
module.exports["BILLING_API_GATEWAY"] = $a2df338368098843$export$856303030f6df405;

});

parcelRegister("cEhot", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3yFL2 = parcelRequire("3yFL2");


var $aNwpq = parcelRequire("aNwpq");


var $in0Xj = parcelRequire("in0Xj");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $d09c0c9679eec46e$export$9a00dee1beb8f576 = (actionSubject)=>{
    return actionSubject.charAt(0).toUpperCase() + actionSubject.substring(1);
};
const $d09c0c9679eec46e$export$4903c942fa101973 = {
    TASK_FAILURE: 'fe.user.task.failure',
    TASK_SUCCESS: 'fe.user.task.success'
};
const $d09c0c9679eec46e$export$b921bb722afe30af = ({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, histogramBuckets: _histogramBuckets = '4000' })=>{
    const dispatchGasV3Track = (0, $aNwpq.internalGasV3TrackEventChannel).useBreadcrumbedEventDispatch();
    const dispatchSentry = (0, $aNwpq.internalSentryExceptionChannel).useBreadcrumbedEventDispatch();
    const task = actionSubjectId ? `${actionSubjectId}` : `${action}${$d09c0c9679eec46e$export$9a00dee1beb8f576(actionSubject)}`;
    return (0, $42omo.useCallback)((payload)=>{
        const sharedGasV3Payload = {
            ...payload
        };
        const sendSentryEvent = (loggablePayload, eventName, eventTaskId, exceptionTags)=>{
            if (loggablePayload === undefined && [
                (0, $3yFL2.MAYBE),
                (0, $3yFL2.NONE)
            ].includes(exceptionTags.probabilityOfBug)) // Don't bother sending a payload if it's undefined and the probability of bug isn't guaranteed
            // TODO: Should enforce that it's never undefined for ProbabilityOfBug.GUARANTEED
            return;
            dispatchSentry({
                exception: loggablePayload,
                scopeContext: (0, $in0Xj.withTelemetryInfoScopeContext)({
                    tags: {
                        task: task,
                        eventName: eventName,
                        ...exceptionTags,
                        ...eventTaskId !== undefined ? {
                            eventTaskId: eventTaskId
                        } : undefined,
                        ...payload.actionSubjectId !== undefined ? {
                            actionSubjectId: payload.actionSubjectId
                        } : undefined
                    }
                })
            });
        };
        const fail = ({ loggablePayload: loggablePayload, probabilityOfBug: probabilityOfBug = (0, $3yFL2.MAYBE), eventTaskId: baseEventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            const eventTaskId = (()=>{
                if (baseEventTaskId !== undefined) return baseEventTaskId;
                if (probabilityOfBug === (0, $3yFL2.GUARANTEED)) {
                    if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'guaranteed-bug';
                    return 'external-bug';
                }
                // Not sending any other values in fear of cardinality problems
                return undefined;
            })();
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_FAILURE, eventTaskId, {
                probabilityOfBug: probabilityOfBug,
                responsibleService: responsibleService
            });
        // TODO: Consider sending some sort of GasV3 failure information
        };
        const succeed = ({ loggablePayload: loggablePayload, eventTaskId: eventTaskId, responsibleService: responsibleService = (0, $3SLm1.UNKNOWN) } = {})=>{
            sendSentryEvent(loggablePayload, $d09c0c9679eec46e$export$4903c942fa101973.TASK_SUCCESS, eventTaskId, {
                probabilityOfBug: (0, $3yFL2.NONE),
                responsibleService: responsibleService
            });
            dispatchGasV3Track(sharedGasV3Payload);
        };
        return {
            fail: fail,
            succeed: succeed
        };
    }, [
        dispatchGasV3Track,
        dispatchSentry,
        task
    ]);
};
const $d09c0c9679eec46e$export$94273a7593441cd3 = (x)=>x.succeed !== undefined;
const $d09c0c9679eec46e$export$8ea5335bded027a0 = (taskInfo)=>{
    const startTask = $d09c0c9679eec46e$export$b921bb722afe30af(taskInfo);
    const taskInfoRef = (0, $42omo.useRef)(taskInfo);
    // TODO: replace by useEvent once it is available. Ponyfilling with useRef for now
    const higherLevelStartTask = (0, $42omo.useCallback)(/**
		 * Please note that thrown errors will be interpreted as guaranteed buggy failures.
		 * @param payload This data passed into this function will be shared between both failure and successful tasks
		 */ async (callback, payload)=>{
        const { fail: fail, succeed: succeed } = startTask(payload || taskInfoRef.current);
        try {
            const result = await callback();
            if (result.succeed !== undefined) succeed(result.succeed);
            else if (result.fail !== undefined) fail(result.fail);
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: {
                    result: result,
                    error: new Error('Could not find succeed nor fail')
                }
            });
            return result;
        } catch (err) {
            if (err instanceof TypeError && err.message === 'Failed to fetch') fail({
                probabilityOfBug: (0, $3yFL2.MAYBE),
                loggablePayload: err
            });
            else fail({
                probabilityOfBug: (0, $3yFL2.GUARANTEED),
                loggablePayload: err
            });
            throw err;
        }
    }, [
        startTask
    ]);
    return higherLevelStartTask;
};
module.exports["useTaskTracker"] = $d09c0c9679eec46e$export$8ea5335bded027a0;

});

parcelRegister("in0Xj", function(module, exports) {

var $3yFL2 = parcelRequire("3yFL2");


var $3SLm1 = parcelRequire("3SLm1");


var $jVQXW = parcelRequire("jVQXW");

const $2cec5ac4f8c71665$export$bf5f90a1a9d2de58 = ({ probabilityOfBug: probabilityOfBug, responsibleService: responsibleService })=>{
    switch(probabilityOfBug){
        case 0, $3yFL2.GUARANTEED:
            if ((0, $jVQXW.responsibleServiceIncludesCommerceLibraries)(responsibleService)) return 'fatal';
            return 'error';
        case 0, $3yFL2.MAYBE:
            return 'warning';
        case 0, $3yFL2.NONE:
            return 'log';
        default:
            // Should never happen so sending critical :3
            return 'fatal';
    }
};
const $2cec5ac4f8c71665$var$severityOrdering = new Map([
    [
        'fatal',
        0
    ],
    [
        'fatal',
        1
    ],
    [
        'error',
        2
    ],
    [
        'warning',
        3
    ],
    [
        'info',
        4
    ],
    [
        'log',
        5
    ],
    [
        undefined,
        6
    ]
]);
const $2cec5ac4f8c71665$export$cae73843c52c598b = (severity1, severity2)=>{
    if ($2cec5ac4f8c71665$var$severityOrdering.get(severity1) <= $2cec5ac4f8c71665$var$severityOrdering.get(severity2)) return severity1;
    return severity2;
};
const $2cec5ac4f8c71665$export$c7063fd1387b3458 = (scopeContext)=>{
    const tags = {
        ...scopeContext.tags,
        responsibleService: scopeContext.tags.responsibleService ?? (0, $3SLm1.UNKNOWN)
    };
    return {
        ...scopeContext,
        tags: tags,
        level: $2cec5ac4f8c71665$export$bf5f90a1a9d2de58(tags)
    };
};
module.exports["withTelemetryInfoScopeContext"] = $2cec5ac4f8c71665$export$c7063fd1387b3458;

});

parcelRegister("jVQXW", function(module, exports) {

var $3SLm1 = parcelRequire("3SLm1");

const $d91c14f6a33096f8$export$6d5fcf71bce583e2 = (responsibleService)=>responsibleService === (0, $3SLm1.COMMERCE_LIBRARIES) || responsibleService === (0, $3SLm1.UNKNOWN);
module.exports["responsibleServiceIncludesCommerceLibraries"] = $d91c14f6a33096f8$export$6d5fcf71bce583e2;

});

parcelRegister("1Y5Zp", function(module, exports) {
const $1fb762876766bde5$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $1fb762876766bde5$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $1fb762876766bde5$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $1fb762876766bde5$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $1fb762876766bde5$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $1fb762876766bde5$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $1fb762876766bde5$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $1fb762876766bde5$export$a7324067d5b1efd6;

});

parcelRegister("lh1MN", function(module, exports) {
const $7f1ee6750f4adf66$export$db45730c9afae012 = (data)=>{
    if (!data) return undefined;
    return data.confluence_tenantContext?.licenseStates?.confluence?.ccpEntitlementId || undefined;
};
module.exports["getCcpEntitlementFromQuery"] = $7f1ee6750f4adf66$export$db45730c9afae012;

});

parcelRegister("hfUvC", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $42omo = parcelRequire("42omo");


var $6bHqX = parcelRequire("6bHqX");


var $bXe73 = parcelRequire("bXe73");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $e7daf7179cc3ad9e$export$b65b36d21c9a62a9 = 'confluence.ondemand';
const $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation = (0, $2XqLN.default)(async (cloudId)=>{
    const rolloutInfoResult = await (0, $6bHqX.fetchCommerceRolloutInformation)({
        cloudId: cloudId,
        productKey: $e7daf7179cc3ad9e$export$b65b36d21c9a62a9
    }, {
        fetch: (0, $f7B1p.cfetch)
    });
    return rolloutInfoResult;
});
const $e7daf7179cc3ad9e$export$44d1450d6b2633f0 = (skip = false)=>{
    const [loading, setLoading] = (0, $42omo.useState)(true);
    const [error, setError] = (0, $42omo.useState)(null);
    const [commerceBackendName, setCommerceBackendName] = (0, $42omo.useState)(null);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    if (!cloudId) skip = true;
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        const fetchCommerceRolloutInformation = async ()=>{
            try {
                const rolloutInfoResult = await $e7daf7179cc3ad9e$var$memoizedFetchCommerceRolloutInformation(cloudId);
                if ((0, $bXe73.isSuccessful)(rolloutInfoResult)) setCommerceBackendName(rolloutInfoResult.payload.commerceBackend);
                else {
                    const error_1 = (0, $bXe73.isException)(rolloutInfoResult) ? rolloutInfoResult.exception : rolloutInfoResult.error;
                    setError(error_1);
                }
            } catch (error_0) {
                error_0.message = `useCommerceBackendName: ${error_0.message}`;
                setError(error_0);
            } finally{
                setLoading(false);
            }
        };
        fetchCommerceRolloutInformation();
    }, [
        cloudId,
        skip
    ]);
    return {
        commerceBackendName: skip ? null : commerceBackendName,
        loading: skip ? false : loading,
        error: skip ? null : error
    };
};
module.exports["useCommerceRolloutInformation"] = $e7daf7179cc3ad9e$export$44d1450d6b2633f0;

});

parcelRegister("bXe73", function(module, exports) {
const $f975479e12996987$export$40f07171f4b6ee01 = (result)=>result.exception !== undefined;
const $f975479e12996987$export$e6127cc7fe7395c3 = (result)=>result.error !== undefined;
const $f975479e12996987$export$a7324067d5b1efd6 = (result)=>result.payload !== undefined;
const $f975479e12996987$export$4ece3b219cb1e8e7 = (result)=>result.payload === undefined;
const $f975479e12996987$export$d0a8c5cfb02e95fe = (error)=>({
        error: error,
        payload: undefined,
        exception: undefined
    });
const $f975479e12996987$export$6338ef6f72008c7 = (payload)=>({
        payload: payload,
        error: undefined,
        exception: undefined
    });
const $f975479e12996987$export$89242b2b73a7bdd = (exception)=>{
    return {
        payload: undefined,
        error: undefined,
        exception: exception
    };
};
module.exports["isException"] = $f975479e12996987$export$40f07171f4b6ee01;
module.exports["isSuccessful"] = $f975479e12996987$export$a7324067d5b1efd6;

});

parcelRegister("dqdrq", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $izVB4 = parcelRequire("izVB4");


var $j4WDj = parcelRequire("j4WDj");


var $6J7Bn = parcelRequire("6J7Bn");

const $ce55fe36479bc4cf$var$StyledButton = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(11);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? (0, $6J7Bn.ButtonBase) : t2;
        let t3;
        let t4;
        let t5;
        let t6;
        let t7;
        let t8;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START));
            t4 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END));
            t5 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START));
            t6 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END));
            t7 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START));
            t8 = (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END));
            $[3] = t3;
            $[4] = t4;
            $[5] = t5;
            $[6] = t6;
            $[7] = t7;
            $[8] = t8;
        } else {
            t3 = $[3];
            t4 = $[4];
            t5 = $[5];
            t6 = $[6];
            t7 = $[7];
            t8 = $[8];
        }
        let t9;
        if ($[9] !== __cmpls) {
            t9 = {
                ...__cmpls,
                "--_iozncj": t3,
                "--_id2ec3": t4,
                "--_1wa1xp5": t5,
                "--_1ck0ygl": t6,
                "--_1jf6nc6": t7,
                "--_1kksnqn": t8
            };
            $[9] = __cmpls;
            $[10] = t9;
        } else t9 = $[10];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t9,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = (0, $6J7Bn.ButtonBase), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_iozncj": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_START)),
            "--_id2ec3": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_DEFAULT_END)),
            "--_1wa1xp5": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_START)),
            "--_1ck0ygl": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_HOVER_END)),
            "--_1jf6nc6": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_START)),
            "--_1kksnqn": (0, $7sObp.default)((0, $j4WDj.GRADIENT_CTA_BUTTON_ACTIVE_END))
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1wgmglyw _1tnq12b0 _nup9qsa8 _ge1r1cay _h99ltlke _r7sm1uxc _1xlotlke _1jypidpf _1fm3idpf _12z9idpf _1dwpidpf _kl6h116y _1w901gfe _1l5a1gfe _zelm1gfe _1fh11gfe _1f1j1gfe",
            __cmplp.className
        ])
    });
});
const $ce55fe36479bc4cf$var$ButtonText = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1e0c1txw _4cvr1h6o _1bah1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
}); /**
     * A styled button with a gradient background, intended to be used as a product edition upgrade CTA button.
     */ 
const $ce55fe36479bc4cf$export$d1aef6466b5ecaa5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(9);
    let buttonProps;
    let children;
    if ($[0] !== t0) {
        ({ children: children, ...buttonProps } = t0);
        $[0] = t0;
        $[1] = buttonProps;
        $[2] = children;
    } else {
        buttonProps = $[1];
        children = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children);
        $[4] = children;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== buttonProps || $[7] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
            iconBefore: t1,
            ...buttonProps
        }, t2);
        $[6] = buttonProps;
        $[7] = t2;
        $[8] = t3;
    } else t3 = $[8];
    return t3;
} : ({ children: children, ...buttonProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$StyledButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        }),
        ...buttonProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ce55fe36479bc4cf$var$ButtonText, null, children));
};
module.exports["GradientCTAButton"] = $ce55fe36479bc4cf$export$d1aef6466b5ecaa5;

});

parcelRegister("j4WDj", function(module, exports) {
const $67193f3c2d75b820$export$3ff4048780acdec9 = "var(--ds-chart-purple-bolder, #AF59E1)";
const $67193f3c2d75b820$export$ac8ee41608bff6f4 = "var(--ds-chart-blue-bolder, #357DE8)";
const $67193f3c2d75b820$export$12fbdde791205cea = "var(--ds-chart-purple-bolder-hovered, #964AC0)";
const $67193f3c2d75b820$export$7653c62635354aaf = "var(--ds-chart-blue-bolder-hovered, #1868DB)";
const $67193f3c2d75b820$export$d4accc94291dcf84 = "var(--ds-chart-purple-boldest, #803FA5)";
const $67193f3c2d75b820$export$16a15d5a9b73591b = "var(--ds-chart-blue-boldest, #1558BC)";
const $67193f3c2d75b820$export$fca70c3c81bb0f58 = "var(--ds-background-accent-blue-subtlest, #E9F2FE)";
const $67193f3c2d75b820$export$f737ffc625de304f = "var(--ds-background-accent-purple-subtlest, #F8EEFE)";
const $67193f3c2d75b820$export$b1ab5fb618714abb = "var(--ds-border-accent-purple, #AF59E1)";
const $67193f3c2d75b820$export$7a262e0e9c5a1e2a = "var(--ds-border-accent-blue, #357DE8)";
const $67193f3c2d75b820$export$71b6aed4f8256b2 = "var(--ds-background-discovery-bold-pressed, #673286)";
const $67193f3c2d75b820$export$c9d89eb8e0b59a5a = "var(--ds-background-selected-bold-pressed, #123263)";
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_START"] = $67193f3c2d75b820$export$3ff4048780acdec9;
module.exports["GRADIENT_CTA_BUTTON_DEFAULT_END"] = $67193f3c2d75b820$export$ac8ee41608bff6f4;
module.exports["GRADIENT_CTA_BUTTON_HOVER_START"] = $67193f3c2d75b820$export$12fbdde791205cea;
module.exports["GRADIENT_CTA_BUTTON_HOVER_END"] = $67193f3c2d75b820$export$7653c62635354aaf;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_START"] = $67193f3c2d75b820$export$d4accc94291dcf84;
module.exports["GRADIENT_CTA_BUTTON_ACTIVE_END"] = $67193f3c2d75b820$export$16a15d5a9b73591b;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_START"] = $67193f3c2d75b820$export$fca70c3c81bb0f58;
module.exports["GRADIENT_BACKGROUND_SUBTLEST_END"] = $67193f3c2d75b820$export$f737ffc625de304f;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_START"] = $67193f3c2d75b820$export$b1ab5fb618714abb;
module.exports["GRADIENT_CTA_BUTTON_INVERTED_BORDER_END"] = $67193f3c2d75b820$export$7a262e0e9c5a1e2a;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_START"] = $67193f3c2d75b820$export$71b6aed4f8256b2;
module.exports["GRADIENT_CTA_BUTTON_SELECTED_END"] = $67193f3c2d75b820$export$c9d89eb8e0b59a5a;

});

parcelRegister("6J7Bn", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eEA8O = parcelRequire("eEA8O");

const $e9beab952dc913a3$export$b0bb876e969289cd = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $eEA8O.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ $42omo.createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $42omo.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_d16p1ano _1dqt12x7 _1toh1r31 _5jyqglyw _mrqmnqa1 _if29116y _1kba1h6o",
            __cmplp.className
        ])
    });
});
module.exports["ButtonBase"] = $e9beab952dc913a3$export$b0bb876e969289cd;

});

parcelRegister("ktelT", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $izVB4 = parcelRequire("izVB4");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $903332396267b541$var$LinkWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71879 _11c8fhey _zulpv77o _1e0c116y _4cvr1h6o _80omtlke _k48pwu06 _1bsb1ns9 _pjrq1758 _oo9g1j28 _18u01b66 _1xjxgktf _1nj1uyj3 _13r27vkz _1nm57vkz _19lc19y2 _1fyq1yf3 _1h7d1kdv _v6kc1j28",
            __cmplp.className
        ])
    });
});
const $903332396267b541$export$7e6e2bf13161f2a = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(6);
    const { href: href, onClick: onClick, target: target, children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
            label: ""
        });
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children || $[2] !== href || $[3] !== onClick || $[4] !== target) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
            href: href,
            onClick: onClick,
            target: target,
            role: "link"
        }, t1, children);
        $[1] = children;
        $[2] = href;
        $[3] = onClick;
        $[4] = target;
        $[5] = t2;
    } else t2 = $[5];
    return t2;
} : ({ href: href, onClick: onClick, target: target, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($903332396267b541$var$LinkWrapper, {
        href: href,
        onClick: onClick,
        target: target,
        role: "link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: ""
    }), children);
};
module.exports["GradientSubtleLinkButton"] = $903332396267b541$export$7e6e2bf13161f2a;

});

parcelRegister("l0DoV", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $537ed6b0b56c707f$export$5422bd88477f90e5 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "uHF1j",
    name: "TryStandardUpflowV2ExperimentTreatmentModalLoadable",
    loader: async ()=>(await (parcelRequire("jbdUC"))).TryStandardUpflowV2ExperimentTreatmentModalWithErrorBoundary
});
module.exports["TryStandardUpflowV2ExperimentTreatmentModalLoadable"] = $537ed6b0b56c707f$export$5422bd88477f90e5;

});

parcelRegister("jbdUC", function(module, exports) {

let $df69d60cfcf7a9c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $df69d60cfcf7a9c4$var$load("6wr18"),
    $df69d60cfcf7a9c4$var$load("eeaKR"),
    $df69d60cfcf7a9c4$var$load("ffEVr"),
    $df69d60cfcf7a9c4$var$load("4UuEP"),
    $df69d60cfcf7a9c4$var$load("hhss7"),
    $df69d60cfcf7a9c4$var$load("fYFVU")
]).then(()=>parcelRequire('h60zh'));

});

parcelRegister("fDbEj", function(module, exports) {

var $c0rhi = parcelRequire("c0rhi");


var $gQY3Y = parcelRequire("gQY3Y");


var $jKFU9 = parcelRequire("jKFU9");

const $3737157ebbad3bf6$var$timeNow = ()=>new Date().getTime();
const $3737157ebbad3bf6$export$66d311bf29d5c89c = new Error('TIMEOUT');
const $3737157ebbad3bf6$export$d63cfb67ca7b2a0 = (currentEdition, writeFragmentInterop)=>{
    if (!currentEdition) return Promise.reject(new Error('No currentEdition supplied'));
    const pollEndTime = new Date($3737157ebbad3bf6$var$timeNow() + (0, $jKFU9.CHANGE_EDITION_POLL_DURATION_MINS) * 60000).getTime();
    const pollAndResolve = (resolve, reject)=>{
        if ($3737157ebbad3bf6$var$timeNow() > pollEndTime) reject($3737157ebbad3bf6$export$66d311bf29d5c89c);
        (0, $c0rhi.queryInterop)({
            query: (0, $gQY3Y.waitForEditionChangeQuery),
            errorPolicy: 'all',
            fetchPolicy: 'network-only'
        }).then((response)=>{
            const polledEdition = response.data?.tenant?.editions?.confluence;
            if (polledEdition && currentEdition !== polledEdition) {
                // Write the latest edition to cache.
                writeFragmentInterop({
                    fragmentId: '$ROOT_QUERY.confluence_tenantContext',
                    data: {
                        editions: {
                            confluence: polledEdition,
                            __typename: 'ConfluenceEditions'
                        },
                        __typename: 'Tenant'
                    }
                });
                resolve(polledEdition);
            } else setTimeout(()=>{
                pollAndResolve(resolve, reject);
            }, (0, $jKFU9.CHANGE_EDITION_POLL_INTERVAL_SECS) * 1000);
        }).catch(reject);
    };
    return new Promise((resolve, reject)=>pollAndResolve(resolve, reject));
};
module.exports["TimeoutError"] = $3737157ebbad3bf6$export$66d311bf29d5c89c;
module.exports["waitForEditionChange"] = $3737157ebbad3bf6$export$d63cfb67ca7b2a0;

});

parcelRegister("gQY3Y", function(module, exports) {

var $cLzsY = parcelRequire("cLzsY");

const $1047f6c600fde1f6$export$291c2fa2b3781c67 = (0, $cLzsY.default);
module.exports["waitForEditionChangeQuery"] = $1047f6c600fde1f6$export$291c2fa2b3781c67;

});

parcelRegister("cLzsY", function(module, exports) {
/**
 * @generated SignedSource<<95812c7ba11101e06e44cec8cc75a6cd>>
 * @relayHash 1f96316e590a2b194e51c68e90ba41fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3
const $5953893bb8ead2fa$var$node = function() {
    var v0 = [
        {
            "alias": "tenant",
            "concreteType": "ConfluenceTenantContext",
            "kind": "LinkedField",
            "name": "confluence_tenantContext",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Editions",
                    "kind": "LinkedField",
                    "name": "editions",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "confluence"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "waitForEditionChangeQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "1f96316e590a2b194e51c68e90ba41fe",
            "id": "241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3",
            "metadata": {},
            "name": "waitForEditionChangeQuery",
            "operationKind": "query",
            "text": "query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}"
        }
    };
}();
$5953893bb8ead2fa$var$node.hash = "6fd7b1d4e0dd25a6c39ba6c8851caa63";
var $5953893bb8ead2fa$export$2e2bcd8739ae039 = $5953893bb8ead2fa$var$node;
module.exports["default"] = $5953893bb8ead2fa$export$2e2bcd8739ae039;

});

parcelRegister("jKFU9", function(module, exports) {
const $97f7046950ca68f7$export$4f9b7eb5b7999045 = 3;
const $97f7046950ca68f7$export$6925031fb600919f = 1;
module.exports["CHANGE_EDITION_POLL_INTERVAL_SECS"] = $97f7046950ca68f7$export$4f9b7eb5b7999045;
module.exports["CHANGE_EDITION_POLL_DURATION_MINS"] = $97f7046950ca68f7$export$6925031fb600919f;

});

parcelRegister("lNKOh", function(module, exports) {
const $5ea77288491beecf$export$2321d4fb07b49d13 = ({ canShowUpgradeButton: canShowUpgradeButton, children: children, isSiteAdmin: isSiteAdmin, shouldShowLearnMore: shouldShowLearnMore = true, showRequestUpgradeButton: showRequestUpgradeButton })=>{
    let showUpgradeTryNowButton = false;
    let showLearnMore = true;
    let learnMoreIsPrimaryCTA = true;
    if (canShowUpgradeButton) {
        if (isSiteAdmin) showUpgradeTryNowButton = true;
        if (showUpgradeTryNowButton) {
            // NOTE: Don't show 'Learn More' CTA if it will appear in between the
            // Upgrade Edition button and a secondary feature link (like
            // "Remove this page's restrictions" button). In those cases, "Learn
            // More" CTA will be displayed at the end of the general text content,
            // outside of this component.
            showLearnMore = shouldShowLearnMore;
            learnMoreIsPrimaryCTA = false;
        }
    }
    if (showRequestUpgradeButton) // If an end user request upgrade button is present,
    // we don't show the learn more link if it's not specifically provided.
    showLearnMore = shouldShowLearnMore;
    return children({
        showUpgradeTryNowButton: showUpgradeTryNowButton,
        showLearnMore: showLearnMore,
        learnMoreIsPrimaryCTA: learnMoreIsPrimaryCTA
    });
};
module.exports["ChangeEditionSectionMessageButtonsWrapper"] = $5ea77288491beecf$export$2321d4fb07b49d13;

});

parcelRegister("bhvFb", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $3HQYo = parcelRequire("3HQYo");


var $9wGTI = parcelRequire("9wGTI");


var $gsZdA = parcelRequire("gsZdA");

const $1848832735763b59$var$contentContainerStyles = {
    regular: "_1e0c1txw _2lx21bp4 _16jlkb7n _p12f1lk2",
    isCard: "_p12f1osq"
};
const $1848832735763b59$var$sectionMessageTitleStyles = {
    regular: "_11c81e3o _19pkidpf _syazi7uo",
    regularNew: "_11c81af2 _k48p1wq8 _19pkidpf _syazi7uo",
    inlineModal: "_11c81af2 _19pkze3t _n3tdpxbi"
};
const $1848832735763b59$var$sectionMessageBodyStyles = {
    withTitle: "_19pku2gc",
    noTitle: "_19pkidpf"
};
const $1848832735763b59$var$sectionMessageHeaderButtonStyles = {
    regular: "_1e0c1txw _1bahesu3 _kqswstnw _154ipxbi _1xi21ejb",
    default: "_154ixy5q _1xi2oahv",
    isCardDefault: "_1xi2xy5q",
    isCard: "_1xi2pxbi"
};
const $1848832735763b59$var$sectionMessageActionRowStyles = {
    default: "_1e0c1txw _19pkpxbi",
    right: "_1bahesu3 _166l1sbv _6ufw1q9c",
    inlineModal: "_19pk16xz _1e0c1txw"
};
const $1848832735763b59$var$sectionMessageFooterStyles = {
    default: "_x3do1uh4 _19pkpxbi _otyrpxbi _ca0qutpp"
};
const $1848832735763b59$var$sectionMessageContainerStyles = {
    regular: "_2rkofajl _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhk1bhr _1e0c1txw _16jlkb7n",
    withTasteAndToneStyling: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk1j28",
    default: "_1yt44ar7 _16qs130s _p12fasau",
    flat: "_1yt44ar7 _p12fasau",
    inline: "_11c8fhey",
    inlineModal: "_p12f1kdj"
};
const $1848832735763b59$export$d8126cfce410377d = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(35);
    const { actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: t1, buttonGroupAlignment: t2 } = t0;
    const withTasteAndToneStyling = t1 === undefined ? false : t1;
    const buttonGroupAlignment = t2 === undefined ? "left" : t2;
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === "right");
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    const t3 = withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles.withTasteAndToneStyling;
    const t4 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles["default"];
    const t5 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles.flat;
    const t6 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles.inline;
    const t7 = updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles.inlineModal;
    let t8;
    if ($[0] !== t3 || $[1] !== t4 || $[2] !== t5 || $[3] !== t6 || $[4] !== t7) {
        t8 = (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles.regular,
            t3,
            t4,
            t5,
            t6,
            t7
        ]);
        $[0] = t3;
        $[1] = t4;
        $[2] = t5;
        $[3] = t6;
        $[4] = t7;
        $[5] = t8;
    } else t8 = $[5];
    const t9 = isCard && $1848832735763b59$var$contentContainerStyles.isCard;
    let t10;
    if ($[6] !== t9) {
        t10 = (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles.regular,
            t9
        ]);
        $[6] = t9;
        $[7] = t10;
    } else t10 = $[7];
    let t11;
    if ($[8] !== title || $[9] !== updatedAppearanceType || $[10] !== withTitle) {
        t11 = withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)("ten_active_boards_in_standard") ? "regularNew" : "regular"],
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles.inlineModal
            ])
        }, title);
        $[8] = title;
        $[9] = updatedAppearanceType;
        $[10] = withTitle;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== body || $[13] !== withTitle) {
        t12 = typeof body === "string" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
            },
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageBodyStyles.noTitle,
                withTitle && $1848832735763b59$var$sectionMessageBodyStyles.withTitle
            ])
        }, body);
        $[12] = body;
        $[13] = withTitle;
        $[14] = t12;
    } else t12 = $[14];
    let t13;
    if ($[15] !== headerButton || $[16] !== isCard || $[17] !== updatedAppearanceType) {
        t13 = headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageHeaderButtonStyles.regular,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles["default"],
                isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCard,
                isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles.isCardDefault
            ])
        }, headerButton);
        $[15] = headerButton;
        $[16] = isCard;
        $[17] = updatedAppearanceType;
        $[18] = t13;
    } else t13 = $[18];
    let t14;
    if ($[19] !== actions || $[20] !== buttonGroupAlignment || $[21] !== updatedAppearanceType) {
        t14 = actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageActionRowStyles["default"],
                buttonGroupAlignment === "right" && $1848832735763b59$var$sectionMessageActionRowStyles.right,
                updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles.inlineModal,
                "actionButtons"
            ])
        }, actions);
        $[19] = actions;
        $[20] = buttonGroupAlignment;
        $[21] = updatedAppearanceType;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== footer) {
        t15 = footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $1848832735763b59$var$sectionMessageFooterStyles["default"]
            ])
        }, footer);
        $[23] = footer;
        $[24] = t15;
    } else t15 = $[24];
    let t16;
    if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t14 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: t10
        }, t11, t12, t13, t14, t15);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
        $[28] = t13;
        $[29] = t14;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== t16 || $[33] !== t8) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "edition-section-message",
            className: t8
        }, t16);
        $[32] = t16;
        $[33] = t8;
        $[34] = t17;
    } else t17 = $[34];
    return t17;
} : ({ actions: actions, appearanceType: appearanceType, body: body, footer: footer, title: title, headerButton: headerButton, withTasteAndToneStyling: withTasteAndToneStyling = false, buttonGroupAlignment: buttonGroupAlignment = 'left' })=>{
    const withTitle = Boolean(title);
    const isCard = Boolean(buttonGroupAlignment === 'right');
    const updatedAppearanceType = appearanceType || (withTasteAndToneStyling ? (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE : (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-testid": "edition-section-message",
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageContainerStyles['regular'],
            withTasteAndToneStyling && $1848832735763b59$var$sectionMessageContainerStyles['withTasteAndToneStyling'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageContainerStyles['default'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).FLAT && $1848832735763b59$var$sectionMessageContainerStyles['flat'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE && $1848832735763b59$var$sectionMessageContainerStyles['inline'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageContainerStyles['inlineModal']
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$contentContainerStyles['regular'],
            isCard && $1848832735763b59$var$contentContainerStyles['isCard']
        ])
    }, withTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageTitleStyles[(0, $9wGTI.fg)('ten_active_boards_in_standard') ? 'regularNew' : 'regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageTitleStyles['inlineModal']
        ])
    }, title), typeof body === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // See https://hello.atlassian.net/browse/APOLLO-3511
    , {
        // and other code tagged with this ticket
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($3HQYo))).sanitize(body)
        },
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageBodyStyles['noTitle'],
            withTitle && $1848832735763b59$var$sectionMessageBodyStyles['withTitle']
        ])
    }, body), headerButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageHeaderButtonStyles['regular'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['default'],
            isCard && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCard'],
            isCard && updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).DEFAULT && $1848832735763b59$var$sectionMessageHeaderButtonStyles['isCardDefault']
        ])
    }, headerButton), actions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageActionRowStyles['default'],
            buttonGroupAlignment === 'right' && $1848832735763b59$var$sectionMessageActionRowStyles['right'],
            updatedAppearanceType === (0, $gsZdA.SECTION_MESSAGE_APPEARANCE_TYPES).INLINE_MODAL && $1848832735763b59$var$sectionMessageActionRowStyles['inlineModal'],
            "actionButtons"
        ])
    }, actions), footer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            $1848832735763b59$var$sectionMessageFooterStyles['default']
        ])
    }, footer)));
};
module.exports["EditionSectionMessage"] = $1848832735763b59$export$d8126cfce410377d;

});

parcelRegister("3HQYo", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("5u7Ox", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $ccHMk = parcelRequire("ccHMk");


var $6xdDU = parcelRequire("6xdDU");


var $inPa6 = parcelRequire("inPa6");


var $4PPzL = parcelRequire("4PPzL");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $TCbX7 = parcelRequire("TCbX7");


var $bZmiL = parcelRequire("bZmiL");

const $125b05aca1e71376$export$ccc7e3a47fa3a9b0 = ({ source: source })=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const hasSentViewedEvent = (0, $42omo.useRef)(false);
    const [showModal, setShowModal] = (0, $42omo.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const handleCloseModal = ()=>{
        setShowModal(false);
    };
    const handleOpenModal = ()=>{
        setIsLoadingModal(true);
        setShowModal(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    };
    (0, $42omo.useEffect)(()=>{
        if (hasSentViewedEvent.current) return;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'button',
                actionSubjectId: 'endUserRequestUpgradeButton',
                source: source,
                attributes: {
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
        hasSentViewedEvent.current = true;
    }, [
        createAnalyticsEvent,
        edition,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: edition === (0, $d9tcB.ConfluenceEdition).STANDARD ? 'growth-luna' : 'growth-transmuters'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "experiment-confluence-enable-end-user-request.request-upgrade-button",
        onClick: handleOpenModal,
        appearance: "primary",
        isLoading: isLoadingModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        id: "experiment-confluence-enable-end-user-request.request-upgrade-button.label",
        defaultMessage: "Request to try"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, showModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $TCbX7.EndUserRequestUpgradeModalEntrypoint), {
        source: source,
        handleCloseModal: handleCloseModal,
        setIsLoadingModal: setIsLoadingModal
    })));
};
module.exports["EndUserRequestUpgradeButton"] = $125b05aca1e71376$export$ccc7e3a47fa3a9b0;

});

parcelRegister("TCbX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $2d60c82434c5c2c8$export$8512e09daabbe9d7 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "i-AMj",
    name: "EndUserRequestUpgradeModalEntrypoint",
    loader: async ()=>(await (parcelRequire("L4O2U"))).EndUserRequestUpgradeModal
});
module.exports["EndUserRequestUpgradeModalEntrypoint"] = $2d60c82434c5c2c8$export$8512e09daabbe9d7;

});

parcelRegister("L4O2U", function(module, exports) {

let $08d81e4f9420b7a3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $08d81e4f9420b7a3$var$load("6wr18"),
    $08d81e4f9420b7a3$var$load("8UKe0"),
    $08d81e4f9420b7a3$var$load("8YAkP"),
    $08d81e4f9420b7a3$var$load("kiGNy"),
    $08d81e4f9420b7a3$var$load("Wowvf"),
    $08d81e4f9420b7a3$var$load("ffEVr"),
    $08d81e4f9420b7a3$var$load("4UuEP"),
    $08d81e4f9420b7a3$var$load("hhss7"),
    $08d81e4f9420b7a3$var$load("eRrWU")
]).then(()=>parcelRequire('4YFRT'));

});

parcelRegister("bZmiL", function(module, exports) {

var $7L1H0 = parcelRequire("7L1H0");

const $ac662e4699f149b2$export$a6ecd874f477affc = (edition)=>({
        currentProductEdition: (0, $7L1H0.mapConfluenceEditionToSupportedCurrentEdition)(edition)
    });
module.exports["editionAnalytics"] = $ac662e4699f149b2$export$a6ecd874f477affc;

});

parcelRegister("7L1H0", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $4f5583827653668a$var$supportedCurrentEditionsMap = {
    [(0, $d9tcB.ConfluenceEdition).FREE]: 'free',
    [(0, $d9tcB.ConfluenceEdition).STANDARD]: 'standard'
};
const $4f5583827653668a$var$isSupportedEdition = (edition)=>{
    return edition in $4f5583827653668a$var$supportedCurrentEditionsMap;
};
const $4f5583827653668a$export$b48897de0c2497d9 = (edition)=>{
    if (!edition || !$4f5583827653668a$var$isSupportedEdition(edition)) return undefined;
    return $4f5583827653668a$var$supportedCurrentEditionsMap[edition];
};
module.exports["mapConfluenceEditionToSupportedCurrentEdition"] = $4f5583827653668a$export$b48897de0c2497d9;

});

parcelRegister("hvXOl", function(module, exports) {
module.exports = new URL("WhiteboardsPaywall.cf2c63af.svg", import.meta.url).toString();

});

parcelRegister("5hK0S", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallDark.0948bce6.svg", import.meta.url).toString();

});

parcelRegister("iDxbX", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallV2.5dd554e3.svg", import.meta.url).toString();

});

parcelRegister("2aQ91", function(module, exports) {
module.exports = new URL("WhiteboardsPaywallDarkV2.e9c25635.svg", import.meta.url).toString();

});

parcelRegister("cHKtk", function(module, exports) {

var $hG9ZM = parcelRequire("hG9ZM");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $7tXrp = parcelRequire("7tXrp");


var $bZmiL = parcelRequire("bZmiL");

const $0db05c5b00b76da2$export$4af81e07a25a3fcc = (source)=>{
    // TODO: During productionization replace with EligibleTouchpoints type for source
    const { cloudId: cloudId, edition: edition, userId: userId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const eligibleTouchpoint = (0, $7tXrp.getEligibleTouchpointForEdition)(source, edition);
    const offeringName = eligibleTouchpoint?.requestedEdition ?? 'standard';
    const { isEnabledFreeEdition: isEnabledFreeEdition, isEnabledStandardEdition: isEnabledStandardEdition, isFreeOrStandardEdition: isFreeOrStandardEdition } = (0, $42omo.useMemo)(()=>{
        return {
            isEnabledFreeEdition: edition === (0, $d9tcB.ConfluenceEdition).FREE,
            isEnabledStandardEdition: (0, $9wGTI.fg)('twcg-1169_ceurs2p_end_user_requests_kill_switch') && edition === (0, $d9tcB.ConfluenceEdition).STANDARD,
            isFreeOrStandardEdition: edition === (0, $d9tcB.ConfluenceEdition).FREE || edition === (0, $d9tcB.ConfluenceEdition).STANDARD
        };
    }, [
        edition
    ]);
    const { loading: loading, data: data } = (0, $jMyy4.useQueryInterop)((0, $hG9ZM.default), {
        variables: {
            cloudId: cloudId,
            offeringName: offeringName,
            shouldCheckForTrial: isEnabledStandardEdition
        },
        fetchPolicy: 'cache-first',
        skip: !isFreeOrStandardEdition || // Skip if not free or standard edition
        !isEnabledFreeEdition && !isEnabledStandardEdition || // Skip if on free or standard edition and either not enabled
        isSiteAdmin || !eligibleTouchpoint,
        client: (0, $gKr8t.getAGGClient)()
    });
    const { isEligibleForEndUserRequestFree: isEligibleForEndUserRequestFree, isEligibleForEndUserRequestStandard: isEligibleForEndUserRequestStandard } = (0, $42omo.useMemo)(()=>{
        const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;
        const isInCollection = entitlement?.relatesFromEntitlements?.find((item)=>item?.relationshipType === 'COLLECTION')?.entitlementId;
        const isChangeOfferingAvailable = entitlement?.experienceCapabilities?.changeOfferingV2?.isAvailableToUser;
        const changeOfferingExperienceUrl = entitlement?.experienceCapabilities?.changeOfferingV2?.experienceUrl;
        const canUpgrade = Boolean(isChangeOfferingAvailable && changeOfferingExperienceUrl);
        const hasPaymentDetailsEntered = Boolean(entitlement?.transactionAccount?.isBillToPresent);
        const entitlementInfo = data?.tenantContexts?.[0]?.entitlementInfo;
        const entitlementId = entitlementInfo?.entitlementId;
        const transactionAccountId = entitlement?.transactionAccount?.key;
        // Additional eligibility checks for Standard
        const trialTimeLeft = entitlement?.subscription?.trial?.timeLeft;
        const isInTrial = Boolean(trialTimeLeft && trialTimeLeft > 0);
        const invoiceableStatus = typeof entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable === 'boolean' ? entitlement.subscription.accountDetails.invoiceGroup.invoiceable ? 'INVOICEABLE' : 'NOT_INVOICEABLE' : 'UNKNOWN';
        const isInPredunning = entitlement?.preDunning?.status === 'IN_PRE_DUNNING' && invoiceableStatus === 'NOT_INVOICEABLE';
        return {
            isEligibleForEndUserRequestFree: Boolean(!loading && !isInCollection && isEnabledFreeEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId)),
            isEligibleForEndUserRequestStandard: Boolean(!loading && !isInCollection && isEnabledStandardEdition && hasPaymentDetailsEntered && !canUpgrade && Boolean(userId) && Boolean(changeOfferingExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId) && !isInTrial && !isInPredunning)
        };
    }, [
        data,
        loading,
        isEnabledFreeEdition,
        isEnabledStandardEdition,
        userId
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForEndUserRequestFree) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('connie_end_user_request_exp', 'cohort', 'not-enrolled'),
                    flagKey: 'connie_end_user_request_exp',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestFree,
        createAnalyticsEvent,
        source
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isEligibleForEndUserRequestStandard) createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'exposed',
                actionSubject: 'feature',
                source: 'useEnableEndUserRequestUpgrade',
                attributes: {
                    cohort: (0, $6mKj3.expVal)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'not-enrolled'),
                    flagKey: 'twcg-1169_ceurs2p_end_user_requests',
                    touchpoint: source,
                    ...(0, $bZmiL.editionAnalytics)(edition)
                }
            }
        }).fire();
    }, [
        edition,
        isEligibleForEndUserRequestStandard,
        createAnalyticsEvent,
        source
    ]);
    return {
        showRequestUpgradeButton: // Free Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestFree && (0, $6mKj3.expValEquals)('connie_end_user_request_exp', 'cohort', 'variation') || // Standard Edition
        // eslint-disable-next-line confluence-feature-gating/no-preconditioning
        isEligibleForEndUserRequestStandard && (0, $6mKj3.expValEquals)('twcg-1169_ceurs2p_end_user_requests', 'cohort', 'variation'),
        loading: loading
    };
};
module.exports["useEnableEndUserRequestUpgrade"] = $0db05c5b00b76da2$export$4af81e07a25a3fcc;

});

parcelRegister("hG9ZM", function(module, exports) {
/**
 * @generated SignedSource<<688db25804eb753702b8bd8f4154bcde>>
 * @relayHash 95c17f8ab13d7575aa221eba1b6971a5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2
const $a3d3dc9056ba2c7e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "offeringName"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shouldCheckForTrial"
        }
    ], v1 = [
        {
            "items": [
                {
                    "kind": "Variable",
                    "name": "cloudIds.0",
                    "variableName": "cloudId"
                }
            ],
            "kind": "ListValue",
            "name": "cloudIds"
        }
    ], v2 = [
        {
            "kind": "Literal",
            "name": "hamsProductKey",
            "value": "confluence.ondemand"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "entitlementId"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "Variable",
            "name": "offeringName",
            "variableName": "offeringName"
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "isAvailableToUser"
    }, v8 = {
        "kind": "ScalarField",
        "name": "experienceUrl"
    }, v9 = {
        "kind": "ScalarField",
        "name": "key"
    }, v10 = {
        "kind": "ScalarField",
        "name": "isBillToPresent"
    }, v11 = {
        "kind": "ScalarField",
        "name": "relationshipType"
    }, v12 = {
        "kind": "ScalarField",
        "name": "status"
    }, v13 = {
        "kind": "ScalarField",
        "name": "timeLeft"
    }, v14 = {
        "kind": "ScalarField",
        "name": "invoiceable"
    }, v15 = [
        v4 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v14 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useEnableEndUserRequestUpgradeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "TenantContext",
                    "kind": "LinkedField",
                    "name": "tenantContexts",
                    "plural": true,
                    "selections": [
                        {
                            "args": v2 /*: any*/ ,
                            "kind": "LinkedField",
                            "name": "entitlementInfo",
                            "plural": false,
                            "selections": [
                                v5 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "entitlement",
                                    "plural": false,
                                    "selections": [
                                        v4 /*: any*/ ,
                                        v5 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "experienceCapabilities",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                {
                                                    "args": v6 /*: any*/ ,
                                                    "kind": "LinkedField",
                                                    "name": "changeOfferingV2",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "transactionAccount",
                                            "plural": false,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v9 /*: any*/ ,
                                                v10 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v15 /*: any*/ ,
                                                    "type": "Node",
                                                    "abstractKey": "__isNode"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "name": "relatesFromEntitlements",
                                            "plural": true,
                                            "selections": [
                                                v5 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v11 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "shouldCheckForTrial",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "preDunning",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "subscription",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "trial",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "accountDetails",
                                                            "plural": false,
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "invoiceGroup",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v15 /*: any*/ ,
                                                                            "type": "CcpInvoiceGroup"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": v15 /*: any*/ ,
                                                            "type": "CcpSubscription"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "95c17f8ab13d7575aa221eba1b6971a5",
            "id": "e810472e5bef79ddd590fcbef7d716cc8bfbcf5a0d5843c4293d62692950c1c2",
            "metadata": {},
            "name": "useEnableEndUserRequestUpgradeQuery",
            "operationKind": "query",
            "text": "query useEnableEndUserRequestUpgradeQuery($cloudId:ID!,$offeringName:String!,$shouldCheckForTrial:Boolean!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlementId,entitlement{id,__typename,experienceCapabilities{__typename,changeOfferingV2(offeringName:$offeringName){__typename,isAvailableToUser,experienceUrl}},transactionAccount{__typename,key,isBillToPresent,...on Node{__isNode:__typename,id}},relatesFromEntitlements{__typename,entitlementId,relationshipType},preDunning@include(if:$shouldCheckForTrial){__typename,status}\n        subscription@include(if:$shouldCheckForTrial){__typename,trial{__typename,timeLeft},accountDetails{__typename,invoiceGroup{__typename,invoiceable,...on CcpInvoiceGroup{id}}},...on CcpSubscription{id}}}}}}"
        }
    };
}();
$a3d3dc9056ba2c7e$var$node.hash = "ab7d869d4ea7e269d66f1403bf66098f";
var $a3d3dc9056ba2c7e$export$2e2bcd8739ae039 = $a3d3dc9056ba2c7e$var$node;
module.exports["default"] = $a3d3dc9056ba2c7e$export$2e2bcd8739ae039;

});

parcelRegister("7tXrp", function(module, exports) {

var $d9tcB = parcelRequire("d9tcB");

const $f4962613d517e76c$var$FREE_TOUCHPOINTS = {
    pageInsights: {
        requestedEdition: 'standard',
        requestedFeature: 'pageInsights'
    },
    archiveUpsellDialog: {
        requestedEdition: 'standard',
        requestedFeature: 'archive'
    },
    generalAccessLevelSelector: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    shareAndRestrictDialogUpsell: {
        requestedEdition: 'standard',
        requestedFeature: 'pagePermissions'
    },
    quickSummaryUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'rovo'
    },
    teamCalendarUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'calendars'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$var$STANDARD_TOUCHPOINTS = {
    viewSpacePerms: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    createSpaceDrawer: {
        requestedEdition: 'premium',
        requestedFeature: 'copySpacePermissions'
    },
    contentManagerUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'contentManager'
    },
    adminCenter: {
        requestedEdition: 'premium',
        requestedFeature: 'adminCenter'
    },
    userAccessUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    shareAndRestrictDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    restrictionsDialogInspectPermissionsUpsell: {
        requestedEdition: 'premium',
        requestedFeature: 'inspectPermissions'
    },
    companyHubUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'companyHub'
    },
    premiumCardsInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightInsertUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCardsConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumCarouselConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    premiumSpotlightConfigUpsellScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'pageDynamicInsert'
    },
    whiteboardsUpsellCtaScreen: {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboardInsert'
    },
    'whiteboardCreationPaywall-upfrontDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-unsetDialog': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    },
    'whiteboardCreationPaywall-viewOnlyButton': {
        requestedEdition: 'premium',
        requestedFeature: 'whiteboards'
    }
};
const $f4962613d517e76c$export$354adb22437506d7 = (source, edition)=>{
    switch(edition){
        case (0, $d9tcB.ConfluenceEdition).FREE:
            return $f4962613d517e76c$var$FREE_TOUCHPOINTS[source];
        case (0, $d9tcB.ConfluenceEdition).STANDARD:
            return $f4962613d517e76c$var$STANDARD_TOUCHPOINTS[source];
        default:
            return undefined;
    }
};
module.exports["getEligibleTouchpointForEdition"] = $f4962613d517e76c$export$354adb22437506d7;

});

parcelRegister("dcUvx", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});

parcelRegister("hbYDZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3aa391a3d57e28f300b24cee0bba3c43>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c842815f2fb3ef87$var$_react = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("42omo")));

var $c842815f2fb3ef87$var$_baseNew = $c842815f2fb3ef87$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c842815f2fb3ef87$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Spaces".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for use for Jira Projects for now. This will replace the Jira rocket. 

More context: Later, it will eventually replace the Confluence Spaces icon later when Jira Projects -> Jira Spaces. This is a planned phased rollout.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c842815f2fb3ef87$var$SpacesIcon = (props)=>/*#__PURE__*/ $c842815f2fb3ef87$var$_react.default.createElement($c842815f2fb3ef87$var$_baseNew.default, Object.assign({
        name: "SpacesIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.809 9.496a5.98 5.98 0 0 1-2.809 3.7 5.98 5.98 0 0 1-4.608.583 29.4 29.4 0 0 0 3.858-1.881 29.4 29.4 0 0 0 3.559-2.402"/><path fill="currentcolor" fill-rule="evenodd" d="M5 2.804a6 6 0 0 1 6.515.333c.859-.264 1.65-.425 2.308-.447.377-.013.751.017 1.083.126.338.11.678.32.888.684.354.613.152 1.297-.107 1.8-.276.538-.736 1.113-1.306 1.688q-.197.196-.413.397a20 20 0 0 1-1.517 1.263 29 29 0 0 1-2.951 1.95 29 29 0 0 1-3.165 1.58c-.65.275-1.272.506-1.85.683h-.003q-.28.087-.548.159c-.783.206-1.511.317-2.116.288-.505-.025-1.114-.162-1.49-.63l-.052-.069-.07-.109-.07-.139a1.6 1.6 0 0 1-.078-.972c.071-.342.231-.681.431-1.001.35-.559.883-1.164 1.541-1.776A6 6 0 0 1 5 2.804m-2.541 7.499c-.302.324-.536.62-.698.879-.147.235-.213.407-.236.515l-.004.046c.048.022.155.056.37.067.329.016.78-.036 1.343-.165a6 6 0 0 1-.775-1.342m8.429-5.756A4.502 4.502 0 0 0 3.52 8.435l.045.34c.089.504.265 1.004.538 1.475.198.344.435.652.702.921 1.181-.43 2.542-1.062 3.945-1.872s2.63-1.672 3.593-2.48a4.5 4.5 0 0 0-1.31-2.146zm2.987-.36a6 6 0 0 0-1.111.166q.233.306.432.647.196.341.342.695c.394-.423.665-.788.816-1.08.098-.192.121-.303.127-.355q-.016-.009-.041-.019a1.7 1.7 0 0 0-.565-.053" clip-rule="evenodd"/>`
    }, props));
$c842815f2fb3ef87$var$SpacesIcon.displayName = 'SpacesIcon';
var $c842815f2fb3ef87$var$_default = module.exports.default = $c842815f2fb3ef87$var$SpacesIcon;

});

parcelRegister("bAyaS", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $8eabddf4fe78ba91$var$initialState = {
    showCreateSpaceDrawer: false,
    shouldRenderDrawer: false,
    createSpaceButtonRef: {
        current: null
    },
    createSpaceButtonLocation: undefined
};
const $8eabddf4fe78ba91$export$e324594224ef24da = {
    openDrawer: (value, createSpaceButtonLocation)=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: true,
                shouldRenderDrawer: true,
                createSpaceButtonRef: value,
                createSpaceButtonLocation: createSpaceButtonLocation
            });
        },
    closeDrawer: ()=>({ setState: setState })=>{
            setState({
                showCreateSpaceDrawer: false,
                createSpaceButtonLocation: undefined
            });
        }
};
const $8eabddf4fe78ba91$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $8eabddf4fe78ba91$var$initialState,
    actions: $8eabddf4fe78ba91$export$e324594224ef24da,
    name: 'createSpaceStore'
});
const $8eabddf4fe78ba91$export$5642c413017336a4 = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
const $8eabddf4fe78ba91$var$getShouldRenderDrawer = (state)=>{
    return state.shouldRenderDrawer;
};
const $8eabddf4fe78ba91$export$34596812152477bc = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getShouldRenderDrawer
});
const $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing = (state)=>{
    return state.showCreateSpaceDrawer;
};
const $8eabddf4fe78ba91$export$5ff6e7335b182a8e = (0, $9zUhf.createHook)($8eabddf4fe78ba91$export$390f32400eaf98c9, {
    selector: $8eabddf4fe78ba91$var$getIsCreateSpaceDrawerShowing
});
const $8eabddf4fe78ba91$export$ad3d638eaaafd693 = (0, $9zUhf.createActionsHook)($8eabddf4fe78ba91$export$390f32400eaf98c9);
module.exports["useCreateSpaceStore"] = $8eabddf4fe78ba91$export$5642c413017336a4;
module.exports["useShouldRenderDrawer"] = $8eabddf4fe78ba91$export$34596812152477bc;
module.exports["useCreateSpaceStoreActions"] = $8eabddf4fe78ba91$export$ad3d638eaaafd693;

});

parcelRegister("4vyfK", function(module, exports) {

var $dAxoX = parcelRequire("dAxoX");


var $dYU3e = parcelRequire("dYU3e");


var $fEmGS = parcelRequire("fEmGS");


var $iEfsZ = parcelRequire("iEfsZ");

const $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery = (0, $dAxoX.default);
function $2272f3d6a41ef128$export$8120ee10837c1dd({ location: location = null, contentId: contentId = null, spaceKey: spaceKey = null, version: version = null } = {}) {
    if (!contentId && spaceKey) return (0, $dYU3e.query)({
        query: $2272f3d6a41ef128$var$preloadWebItemLocationWithSpaceKeyQuery,
        variables: {
            location: Array.isArray(location) ? null : location,
            locations: Array.isArray(location) ? location : [],
            spaceKey: spaceKey,
            version: version
        }
    }).then(({ data: data })=>{
        if (data?.space?.homepageId) (0, $fEmGS.writeQueryInterop)({
            query: (0, $iEfsZ.default),
            variables: {
                location: Array.isArray(location) ? null : location,
                locations: Array.isArray(location) ? location : [],
                contentId: data?.space?.homepageId,
                spaceKey: null,
                version: version
            },
            data: {
                webItemSections: data?.space?.homepageWebSections || []
            }
        });
    });
    const variables = {
        // GraphQL doesn't cache single location strings properly when passed to locations
        // unless we're using multiple locations we should be using the location variable
        location: Array.isArray(location) ? null : location,
        locations: Array.isArray(location) ? location : [],
        contentId: contentId,
        spaceKey: spaceKey,
        version: version
    };
    return (0, $dYU3e.query)({
        query: (0, $iEfsZ.default),
        variables: variables
    });
}
module.exports["preloadWebItemLocation"] = $2272f3d6a41ef128$export$8120ee10837c1dd;

});

parcelRegister("dAxoX", function(module, exports) {
/**
 * @generated SignedSource<<ed760a61c0c4025dac1c4e0b43c3297f>>
 * @relayHash c407d329f5154dd3cb147b16d24f7f21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511
const $074c400385fc6141$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "location"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "locations"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "label"
    }, v3 = {
        "kind": "ScalarField",
        "name": "styleClass"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "homepageId"
                },
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "location",
                            "variableName": "location"
                        },
                        {
                            "kind": "Variable",
                            "name": "locations",
                            "variableName": "locations"
                        },
                        {
                            "kind": "Variable",
                            "name": "version",
                            "variableName": "version"
                        }
                    ],
                    "concreteType": "WebSection",
                    "kind": "LinkedField",
                    "name": "homepageWebSections",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "cacheKey"
                        },
                        v3 /*: any*/ ,
                        {
                            "concreteType": "WebItem",
                            "kind": "LinkedField",
                            "name": "items",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "accessKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "completeKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasCondition"
                                },
                                v1 /*: any*/ ,
                                {
                                    "concreteType": "Icon",
                                    "kind": "LinkedField",
                                    "name": "icon",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "height"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "width"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "path"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "MapOfStringToString",
                                    "kind": "LinkedField",
                                    "name": "params",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "key"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "value"
                                        }
                                    ]
                                },
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "moduleKey"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "section"
                                },
                                v3 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "tooltip"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "url"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "urlWithoutContextPath"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "weight"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "c407d329f5154dd3cb147b16d24f7f21",
            "id": "3d78827b45ffa00d23f59d49283e3186acd1fae25701669aff456c7a90416511",
            "metadata": {},
            "name": "preloadWebItemLocationWithSpaceKeyQuery",
            "operationKind": "query",
            "text": "query preloadWebItemLocationWithSpaceKeyQuery($location:String,$locations:[String],$spaceKey:String,$version:Int){space(key:$spaceKey){id,homepageId,homepageWebSections(location:$location,locations:$locations,version:$version){id,label,cacheKey,styleClass,items{accessKey,completeKey,hasCondition,id,icon{height,width,path},params{key,value},label,moduleKey,section,styleClass,tooltip,url,urlWithoutContextPath,weight}}}}"
        }
    };
}();
$074c400385fc6141$var$node.hash = "fb9ef136f5257fc82dc16b8dc37de41b";
var $074c400385fc6141$export$2e2bcd8739ae039 = $074c400385fc6141$var$node;
module.exports["default"] = $074c400385fc6141$export$2e2bcd8739ae039;

});

parcelRegister("jyA9t", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $691f60820ad9b181$var$initialState = {
    showSmartCreationModal: false,
    spaceKey: '',
    parentContent: {
        id: '',
        title: '',
        contentType: ''
    },
    content: undefined,
    stagingAreaActive: false,
    isFloating: false,
    shouldShowBackButton: undefined,
    entryPoint: 'confluenceUnknown',
    submitCallback: undefined
};
const $691f60820ad9b181$export$e324594224ef24da = {
    openModal: ({ entryPoint: entryPoint, spaceKey: spaceKey, parentContent: parentContent, stagingAreaActive: stagingAreaActive, isFloating: isFloating, shouldShowBackButton: shouldShowBackButton, content: content, submitCallback: submitCallback })=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: true,
                entryPoint: entryPoint,
                spaceKey: spaceKey,
                parentContent: parentContent ?? {
                    id: '',
                    title: '',
                    contentType: ''
                },
                content: content ?? undefined,
                stagingAreaActive: stagingAreaActive ?? false,
                isFloating: isFloating ?? false,
                shouldShowBackButton: shouldShowBackButton ?? undefined,
                submitCallback: submitCallback ?? undefined
            });
        },
    closeModal: ()=>({ setState: setState })=>{
            setState({
                showSmartCreationModal: false,
                content: undefined,
                stagingAreaActive: false,
                isFloating: false,
                shouldShowBackButton: undefined,
                entryPoint: 'confluenceUnknown'
            });
        }
};
const $691f60820ad9b181$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $691f60820ad9b181$var$initialState,
    actions: $691f60820ad9b181$export$e324594224ef24da,
    name: 'smartCreationModalStore'
});
const $691f60820ad9b181$export$137abd744dc8b433 = (0, $9zUhf.createHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$809bddce75a17b3 = (0, $9zUhf.createActionsHook)($691f60820ad9b181$export$390f32400eaf98c9);
const $691f60820ad9b181$export$46ab492df7c46301 = (0, $9zUhf.createStateHook)($691f60820ad9b181$export$390f32400eaf98c9);
module.exports["useSmartCreationModalStore"] = $691f60820ad9b181$export$137abd744dc8b433;
module.exports["useSmartCreationModalActions"] = $691f60820ad9b181$export$809bddce75a17b3;
module.exports["useSmartCreationModalState"] = $691f60820ad9b181$export$46ab492df7c46301;

});

parcelRegister("f5Ulo", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $dedJV = parcelRequire("dedJV");


var $bQm3c = parcelRequire("bQm3c");

const $3326fe0c1f9a5868$var$environmentMap = {
    DEVELOPMENT: 'dev',
    STAGING: 'stg',
    PRODUCTION: 'prod'
};
const $3326fe0c1f9a5868$export$80677895f41c9591 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $frIzR.c)(2);
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    const t0 = $3326fe0c1f9a5868$var$environmentMap[environment];
    let t1;
    if ($[0] !== t0) {
        t1 = (0, $dedJV.getATLContextDomain)("id", [
            t0,
            "commercial"
        ]);
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const identityDomain = t1;
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === "PRODUCTION" ? "https://loom.com/api/auth/atlassian" : "https://stage.loom.com/api/auth/atlassian";
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
} : ()=>{
    const { cloudId: cloudId, environment: environment } = (0, $bQm3c.useSessionData)();
    // Using `environment` from session data (rather than letting `getATLContextDomain` determine it
    // internally) in order to better support local development that can be targeted at different
    // Confluence BE environments
    const identityDomain = (0, $dedJV.getATLContextDomain)('id', [
        $3326fe0c1f9a5868$var$environmentMap[environment],
        'commercial'
    ]);
    const loomResourceAri = `ari:cloud:loom::site/${cloudId}`;
    const continueUrl = environment === 'PRODUCTION' ? 'https://loom.com/api/auth/atlassian' : 'https://stage.loom.com/api/auth/atlassian';
    const userAccessUrl = encodeURIComponent(`https://${identityDomain}/join/user-access?resource=${loomResourceAri}&continue=${continueUrl}`);
    return `https://${identityDomain}/login?continue=${userAccessUrl}`;
};
module.exports["useLoomCrossJoinUrl"] = $3326fe0c1f9a5868$export$80677895f41c9591;

});

parcelRegister("8Q0mA", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $gd8AW = parcelRequire("gd8AW");


var $erVVf = parcelRequire("erVVf");


var $f5Ulo = parcelRequire("f5Ulo");


var $cnQgR = parcelRequire("cnQgR");

const $012e0fafda229e4e$var$sourceAdType = 'crossJoin';
const $012e0fafda229e4e$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    crossJoinCTA: {
        id: "loom-utils.loom-cross-sell-popup-card.crossJoinCTA",
        defaultMessage: "Try now"
    },
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    }
});
const $012e0fafda229e4e$export$9937e9f99bf53911 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(40);
    const { description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    let t1;
    if ($[0] !== entryPointId || $[1] !== flags || $[2] !== sourceComponent) {
        t1 = {
            entryPointId: entryPointId,
            flags: flags,
            source: "loomCrossJoinPopupCard",
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        };
        $[0] = entryPointId;
        $[1] = flags;
        $[2] = sourceComponent;
        $[3] = t1;
    } else t1 = $[3];
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)(t1);
    let t2;
    if ($[4] !== stopPulse) {
        t2 = ()=>{
            stopPulse();
        };
        $[4] = stopPulse;
        $[5] = t2;
    } else t2 = $[5];
    const stopDiscoverabilityPulse = t2;
    let t3;
    if ($[6] !== entryPointId || $[7] !== experienceTracker || $[8] !== stopDiscoverabilityPulse) {
        t3 = ()=>{
            stopDiscoverabilityPulse();
            experienceTracker.succeed({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: $012e0fafda229e4e$var$sourceAdType
                }
            });
        };
        $[6] = entryPointId;
        $[7] = experienceTracker;
        $[8] = stopDiscoverabilityPulse;
        $[9] = t3;
    } else t3 = $[9];
    const onCrossJoinSuccess = t3;
    let t4;
    if ($[10] !== createAnalyticsEvent || $[11] !== entryPointId || $[12] !== onCrossJoinSuccess || $[13] !== sourceComponent || $[14] !== streamliningCrossJoinOnButtonClicked) {
        t4 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(false);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "tryNow",
                    source: "loomCrossJoinPopupCard",
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[10] = createAnalyticsEvent;
        $[11] = entryPointId;
        $[12] = onCrossJoinSuccess;
        $[13] = sourceComponent;
        $[14] = streamliningCrossJoinOnButtonClicked;
        $[15] = t4;
    } else t4 = $[15];
    const onTryNowButtonClick = t4;
    let t5;
    if ($[16] !== createAnalyticsEvent || $[17] !== entryPointId || $[18] !== onCrossJoinSuccess || $[19] !== sourceActionSubjectId || $[20] !== sourceComponent || $[21] !== streamliningCrossJoinOnButtonClicked) {
        t5 = async ()=>{
            if ((0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate")) await streamliningCrossJoinOnButtonClicked(true);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: sourceActionSubjectId,
                    source: sourceActionSubjectId,
                    attributes: {
                        adType: $012e0fafda229e4e$var$sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent
                    }
                }
            }).fire();
            onCrossJoinSuccess();
        };
        $[16] = createAnalyticsEvent;
        $[17] = entryPointId;
        $[18] = onCrossJoinSuccess;
        $[19] = sourceActionSubjectId;
        $[20] = sourceComponent;
        $[21] = streamliningCrossJoinOnButtonClicked;
        $[22] = t5;
    } else t5 = $[22];
    const onCrossJoinTriggerClick = t5;
    let t6;
    if ($[23] !== crossJoinHref || $[24] !== intl || $[25] !== onTryNowButtonClick) {
        t6 = (0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA));
        $[23] = crossJoinHref;
        $[24] = intl;
        $[25] = onTryNowButtonClick;
        $[26] = t6;
    } else t6 = $[26];
    let t7;
    if ($[27] !== crossJoinHref || $[28] !== onCrossJoinTriggerClick || $[29] !== triggerLink) {
        t7 = (popupTriggerProps)=>triggerLink(!(0, $9wGTI.fg)("twcg-1241_streamlining_loom_cross_join_gate") ? crossJoinHref : "", {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            });
        $[27] = crossJoinHref;
        $[28] = onCrossJoinTriggerClick;
        $[29] = triggerLink;
        $[30] = t7;
    } else t7 = $[30];
    let t8;
    if ($[31] !== description || $[32] !== entryPointId || $[33] !== placement || $[34] !== shouldRenderToParent || $[35] !== sourceComponent || $[36] !== t6 || $[37] !== t7 || $[38] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
            actions: t6,
            description: description,
            entryPointId: entryPointId,
            placement: placement,
            shouldRenderToParent: shouldRenderToParent,
            title: title,
            trigger: t7,
            sourceAdType: $012e0fafda229e4e$var$sourceAdType,
            sourceComponent: sourceComponent
        });
        $[31] = description;
        $[32] = entryPointId;
        $[33] = placement;
        $[34] = shouldRenderToParent;
        $[35] = sourceComponent;
        $[36] = t6;
        $[37] = t7;
        $[38] = title;
        $[39] = t8;
    } else t8 = $[39];
    return t8;
} : ({ description: description, entryPointId: entryPointId, placement: placement, shouldRenderToParent: shouldRenderToParent, sourceActionSubjectId: sourceActionSubjectId, sourceComponent: sourceComponent, title: title, triggerLink: triggerLink, flags: flags })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { stopPulse: stopPulse } = (0, $gd8AW.useDiscoverabilityPulseActions)();
    const streamliningCrossJoinOnButtonClicked = (0, $erVVf.useStreamliningCrossJoin)({
        entryPointId: entryPointId,
        flags: flags,
        source: 'loomCrossJoinPopupCard',
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
    const stopDiscoverabilityPulse = (0, $42omo.useCallback)(()=>{
        stopPulse();
    }, [
        stopPulse
    ]);
    const onCrossJoinSuccess = (0, $42omo.useCallback)(()=>{
        stopDiscoverabilityPulse();
        experienceTracker.succeed({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: $012e0fafda229e4e$var$sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        stopDiscoverabilityPulse
    ]);
    const onTryNowButtonClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'tryNow',
                source: 'loomCrossJoinPopupCard',
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    const onCrossJoinTriggerClick = (0, $42omo.useCallback)(async ()=>{
        if ((0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate')) await streamliningCrossJoinOnButtonClicked(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: sourceActionSubjectId,
                source: sourceActionSubjectId,
                attributes: {
                    adType: $012e0fafda229e4e$var$sourceAdType,
                    entrypoint: entryPointId,
                    sourceComponent: sourceComponent
                }
            }
        }).fire();
        onCrossJoinSuccess();
    }, [
        createAnalyticsEvent,
        entryPointId,
        onCrossJoinSuccess,
        sourceActionSubjectId,
        sourceComponent,
        streamliningCrossJoinOnButtonClicked
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cnQgR.BaseLoomPopupCard), {
        actions: (0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "discovery",
            onClick: onTryNowButtonClick
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            appearance: "discovery",
            href: crossJoinHref,
            onClick: onTryNowButtonClick,
            rel: "noreferrer",
            target: "_blank"
        }, intl.formatMessage($012e0fafda229e4e$export$a7357cdd1f0b0168.crossJoinCTA)),
        description: description,
        entryPointId: entryPointId,
        placement: placement,
        shouldRenderToParent: shouldRenderToParent,
        title: title,
        trigger: (popupTriggerProps)=>// the link button behaviour is handled in streamliningCrossJoinOnButtonClicked
            // when feature gate is on for Loom crossjoin experiment
            triggerLink(!(0, $9wGTI.fg)('twcg-1241_streamlining_loom_cross_join_gate') ? crossJoinHref : '', {
                ...popupTriggerProps,
                onClick: onCrossJoinTriggerClick
            }),
        sourceAdType: $012e0fafda229e4e$var$sourceAdType,
        sourceComponent: sourceComponent
    });
};
module.exports["LoomCrossJoinPopupCard"] = $012e0fafda229e4e$export$9937e9f99bf53911;

});

parcelRegister("gd8AW", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $f4d1b21b30388c2e$export$48bd74b0cdc86564 = ()=>{
    return !!(0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED);
};
const $f4d1b21b30388c2e$export$675fdafde077272f = ()=>{
    return (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED, true);
};
const $f4d1b21b30388c2e$var$initialState = {
    activeMessageId: null,
    entryPointIds: [],
    clickTrackingHandler: null,
    dismissHandler: null,
    wasDismissedByUser: false
};
const $f4d1b21b30388c2e$var$actions = {
    startPulse: (entryPointId, messageId, handlers)=>({ getState: getState, setState: setState })=>{
            const state = getState();
            const nextState = state.activeMessageId !== messageId ? {
                activeMessageId: messageId,
                entryPointIds: [
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? null,
                dismissHandler: handlers?.onDismiss ?? null,
                wasDismissedByUser: false
            } : {
                activeMessageId: messageId,
                entryPointIds: state.entryPointIds.includes(entryPointId) ? state.entryPointIds : [
                    ...state.entryPointIds,
                    entryPointId
                ],
                clickTrackingHandler: handlers?.onClick ?? state.clickTrackingHandler,
                dismissHandler: handlers?.onDismiss ?? state.dismissHandler,
                wasDismissedByUser: false
            };
            const hasEntryPointListChanged = nextState.entryPointIds !== state.entryPointIds;
            const hasClickHandlerChanged = nextState.clickTrackingHandler !== state.clickTrackingHandler;
            const hasDismissHandlerChanged = nextState.dismissHandler !== state.dismissHandler;
            const hasMessageChanged = nextState.activeMessageId !== state.activeMessageId;
            const hasDismissalReset = state.wasDismissedByUser;
            if (!hasEntryPointListChanged && !hasClickHandlerChanged && !hasDismissHandlerChanged && !hasMessageChanged && !hasDismissalReset) return;
            setState(nextState);
        },
    stopPulse: ()=>({ getState: getState, setState: setState })=>{
            const state = getState();
            state.clickTrackingHandler?.();
            state.dismissHandler?.();
            if (!$f4d1b21b30388c2e$export$48bd74b0cdc86564()) $f4d1b21b30388c2e$export$675fdafde077272f();
            if (state.activeMessageId === null && state.entryPointIds.length === 0 && state.dismissHandler === null && state.clickTrackingHandler === null && state.wasDismissedByUser) return;
            setState({
                activeMessageId: null,
                entryPointIds: [],
                clickTrackingHandler: null,
                dismissHandler: null,
                wasDismissedByUser: true
            });
        }
};
const $f4d1b21b30388c2e$var$Store = (0, $1P1Tu.createStore)({
    initialState: $f4d1b21b30388c2e$var$initialState,
    actions: $f4d1b21b30388c2e$var$actions,
    name: 'LoomEntryPointsDiscoverabilityPulse'
});
const $f4d1b21b30388c2e$export$e812389786ffbfd0 = (0, $9zUhf.createStateHook)($f4d1b21b30388c2e$var$Store, {
    selector: (state, entryPointId)=>state.entryPointIds.includes(entryPointId) && !state.wasDismissedByUser
});
const $f4d1b21b30388c2e$export$5628ed37e6d9f626 = (0, $9zUhf.createActionsHook)($f4d1b21b30388c2e$var$Store);
module.exports["havePulsesEnded"] = $f4d1b21b30388c2e$export$48bd74b0cdc86564;
module.exports["endPulses"] = $f4d1b21b30388c2e$export$675fdafde077272f;
module.exports["useIsPulseActive"] = $f4d1b21b30388c2e$export$e812389786ffbfd0;
module.exports["useDiscoverabilityPulseActions"] = $f4d1b21b30388c2e$export$5628ed37e6d9f626;

});

parcelRegister("erVVf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $7p4As = parcelRequire("7p4As");


var $6mKj3 = parcelRequire("6mKj3");


var $f5Ulo = parcelRequire("f5Ulo");


var $64hvi = parcelRequire("64hvi");

const $7197be9efeb6a957$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    requestAccessSuccessFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.title",
        defaultMessage: "Your admins were notified of your request"
    },
    requestAccessSuccessFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-success-flag.description",
        defaultMessage: "You\u2019ll receive an email once they\u2019ve approved it."
    },
    requestAccessErrorFlagTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.title",
        defaultMessage: "We couldn't add you to Loom"
    },
    requestAccessErrorFlagDescription: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.description",
        defaultMessage: "Try again in a few minutes. If you still aren't able to join, "
    },
    requestAccessErrorFlagActionTitle: {
        id: "loom-utils.loom-cross-join-popup-card.request-access-error-flag.action.title",
        defaultMessage: "contact support"
    },
    requestAccessNote: {
        id: "loom-utils.use-streamlining-cross-join.request-access-note.content",
        defaultMessage: "Hi, admin \uD83D\uDC4B I'd like to use Loom to collaborate with my team."
    }
});
const $7197be9efeb6a957$export$76d3f97e5e2f022d = ({ entryPointId: entryPointId, flags: flags, source: source, sourceAdType: sourceAdType, sourceComponent: sourceComponent })=>{
    const intl = (0, $8C5kA.default)();
    const crossJoinHref = (0, $f5Ulo.useLoomCrossJoinUrl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const requestAccess = (0, $64hvi.useRequestAccessService)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType,
        note: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessNote)
    });
    const fetchRequestAccessCapability = (0, $64hvi.useFetchRequestAccessCapability)({
        entryPointId: entryPointId,
        source: source,
        sourceAdType: sourceAdType
    });
    return (0, $42omo.useCallback)(async (fromTrigger = false)=>{
        const capability = await fetchRequestAccessCapability();
        if (capability === 'REQUEST_ACCESS') {
            if ([
                'control',
                'variation'
            ].includes((0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'))) {
                if (fromTrigger) {
                    // Open new tab for control and do nothing for variation
                    if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'control')) window && window.open(crossJoinHref, '_blank');
                    return;
                }
                // fire manual feature exposed event for control and variation cohorts only
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'exposed',
                        actionSubject: 'feature',
                        source: source,
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            flagKey: 'twcg-1241_streamlining_loom_cross_join',
                            cohort: (0, $6mKj3.expVal)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'not-enrolled'),
                            fromTrigger: fromTrigger // we should always receive false here
                        }
                    }
                }).fire();
                // streamlining access request flow for variation cohort
                if ((0, $6mKj3.expValEquals)('twcg-1241_streamlining_loom_cross_join', 'cohort', 'variation')) try {
                    const requestedAccess = await requestAccess();
                    if (requestedAccess) {
                        flags && flags.showSuccessFlag({
                            title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagTitle),
                            description: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessSuccessFlagDescription)
                        });
                        // after successful access request, we do not proceed to open the cross join link
                        return;
                    }
                } catch (error) {
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'failed',
                            actionSubject: 'requestAccess',
                            source: source,
                            attributes: {
                                adType: sourceAdType,
                                entrypoint: entryPointId,
                                sourceComponent: sourceComponent,
                                error: error instanceof Error ? error.message : 'unknown'
                            }
                        }
                    }).fire();
                    flags && flags.showErrorFlag({
                        title: intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagTitle),
                        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
                            href: "https://support.atlassian.com/contact",
                            target: "_blank",
                            rel: "noreferrer"
                        }, intl.formatMessage($7197be9efeb6a957$export$a7357cdd1f0b0168.requestAccessErrorFlagActionTitle)))
                    });
                }
            }
        }
        // for other capability, we bring back the default link behaviour here
        // as we have disabled the default link behaviour for the trigger button
        window && window.open(crossJoinHref, '_blank');
    }, [
        createAnalyticsEvent,
        crossJoinHref,
        entryPointId,
        fetchRequestAccessCapability,
        flags,
        intl,
        requestAccess,
        source,
        sourceAdType,
        sourceComponent
    ]);
};
module.exports["useStreamliningCrossJoin"] = $7197be9efeb6a957$export$76d3f97e5e2f022d;

});

parcelRegister("64hvi", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $hCOLa = parcelRequire("hCOLa");


var $fNwcJ = parcelRequire("fNwcJ");


var $f7B1p = parcelRequire("f7B1p");


var $bQm3c = parcelRequire("bQm3c");

const $92f7d7126b973070$var$fetchJson = async (input)=>{
    const { url: url, ...options } = input;
    const response = await (0, $f7B1p.cfetch)(url, options);
    return response.json();
};
const $92f7d7126b973070$export$1c1d3bfbd79d853f = ({ entryPointId: entryPointId, note: note, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const deps = (0, $42omo.useMemo)(()=>({
            createAnalyticsEvent: ({ type: type, data: data })=>createAnalyticsEvent({
                    type: type,
                    data: {
                        source: source,
                        ...data
                    }
                }),
            fetchJSON: $92f7d7126b973070$var$fetchJson,
            getCurrentCloudId: ()=>cloudId,
            getCurrentUserId: ()=>userId ?? '',
            getCurrentProduct: ()=>'confluence'
        }), [
        createAnalyticsEvent,
        cloudId,
        source,
        userId
    ]);
    const requestAccess = (0, $hCOLa.useService)((0, $fNwcJ.requestAccess), deps);
    return (0, $42omo.useCallback)(async ()=>{
        try {
            const { result: result = '' } = await requestAccess({
                product: 'loom',
                integration: entryPointId,
                note: note
            });
            const success = result === 'PENDING_REQUEST_CREATED';
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        result: result,
                        success: success
                    }
                }
            }).fire();
            return success;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccess',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        result: undefined,
                        success: false
                    }
                }
            }).fire();
            throw error;
        }
    }, [
        entryPointId,
        note,
        requestAccess,
        source,
        sourceAdType,
        createAnalyticsEvent
    ]);
};
const $92f7d7126b973070$export$a74078d93650d63f = ({ entryPointId: entryPointId, source: source, sourceAdType: sourceAdType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    return (0, $42omo.useCallback)(async ()=>{
        const resource = `ari:cloud:loom::site/${cloudId}`;
        try {
            const params = new URLSearchParams({
                resource: resource
            });
            const url = `/gateway/api/invitations/v1/access-requests/capabilities?${params.toString()}`;
            const response = await $92f7d7126b973070$var$fetchJson({
                url: url
            });
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        resource: resource
                    }
                }
            }).fire();
            return response.results[resource] || undefined;
        } catch (error) {
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'fetch',
                    actionSubjectId: 'requestAccessCapability',
                    source: source,
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        error: error instanceof Error ? error.message : 'unknown',
                        resource: resource
                    }
                }
            }).fire();
        }
        return undefined;
    }, [
        cloudId,
        createAnalyticsEvent,
        entryPointId,
        source,
        sourceAdType
    ]);
};
module.exports["useRequestAccessService"] = $92f7d7126b973070$export$1c1d3bfbd79d853f;
module.exports["useFetchRequestAccessCapability"] = $92f7d7126b973070$export$a74078d93650d63f;

});

parcelRegister("hCOLa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jdJm1 = parcelRequire("jdJm1");

const $5c38ed4eae58ec94$export$6de4685a6c88b4e9 = (service, depsOverrides)=>{
    const memoizedRef = (0, $42omo.useRef)({
        service: undefined,
        depsOverrides: undefined,
        result: undefined
    });
    const memoized = memoizedRef.current;
    if (!memoized || memoized.service !== service || !$5c38ed4eae58ec94$var$areObjectsEqualShallow(memoized.depsOverrides, depsOverrides)) {
        memoizedRef.current.result = (0, $jdJm1.resolveService)(service, depsOverrides);
        memoizedRef.current.depsOverrides = depsOverrides;
        memoizedRef.current.service = service;
    }
    return memoizedRef.current.result;
};
const $5c38ed4eae58ec94$var$DIFFERENT = false;
const $5c38ed4eae58ec94$var$EQUAL = true;
const $5c38ed4eae58ec94$var$areObjectsEqualShallow = (prevObject, nextObject)=>{
    if (nextObject === prevObject) return $5c38ed4eae58ec94$var$EQUAL;
    if (!prevObject || !nextObject) return $5c38ed4eae58ec94$var$DIFFERENT;
    else {
        const prevKeys = Object.keys(prevObject);
        const keys = Object.keys(nextObject);
        if (keys.length !== prevKeys.length) return $5c38ed4eae58ec94$var$DIFFERENT;
        else for (let key of keys){
            if (nextObject[key] !== prevObject[key]) return $5c38ed4eae58ec94$var$DIFFERENT;
        }
        return $5c38ed4eae58ec94$var$EQUAL;
    }
};
module.exports["useService"] = $5c38ed4eae58ec94$export$6de4685a6c88b4e9;

});

parcelRegister("jdJm1", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

function $e28c424ef32ed9ff$export$388f24d19a29b0a2(service, providedDeps) {
    if (typeof service === 'function' && (0, $7DBey.isServiceWithDeps)(service)) return (input)=>{
        return service(input, $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext(service.dependencies, providedDeps ?? {}));
    };
    return service;
}
const $e28c424ef32ed9ff$var$ResolvedServiceDependencyContext = (declaredDependencies, depsOverrides)=>{
    let resolvedDeps = undefined;
    return {
        dependencies () {
            if (resolvedDeps) return resolvedDeps;
            resolvedDeps = {};
            for (let [k, dependency] of Object.entries(declaredDependencies)){
                const key = k;
                resolvedDeps[key] = // TODO is this type-safe?
                // TODO resolve the override dep as well?
                key in depsOverrides ? depsOverrides[key] : $e28c424ef32ed9ff$export$388f24d19a29b0a2(dependency, depsOverrides);
            }
            return resolvedDeps;
        }
    };
}; // TODO: support multiple services to be resolved with common deps
 // export function resolveServices<DeclaredServices extends DeclaredServicesBase>(
 // 	services: DeclaredServices,
 // 	deps: any /*TODO*/,
 // ) {
 // 	return services as ResolvedServices<DeclaredServices>;
 // }
module.exports["resolveService"] = $e28c424ef32ed9ff$export$388f24d19a29b0a2;

});

parcelRegister("7DBey", function(module, exports) {
const $91acf6157f8b5c3c$export$4094c5185600bd73 = (maybeService)=>typeof maybeService === 'function' && 'dependencies' in maybeService;
const $91acf6157f8b5c3c$export$6e9f7b680f09bab1 = (serviceName)=>Object.assign((_input)=>{
        throw TypeError(`Unimplemented abstract service: ${serviceName}`);
    }, {
        abstract: true
    });
const $91acf6157f8b5c3c$export$cc3b967c039ed3e7 = (maybeError)=>{
    if (maybeError instanceof Error) return maybeError;
    return new TypeError('Service Error: ' + maybeError);
};
module.exports["isServiceWithDeps"] = $91acf6157f8b5c3c$export$4094c5185600bd73;
module.exports["unimplementedAbstractService"] = $91acf6157f8b5c3c$export$6e9f7b680f09bab1;
module.exports["toError"] = $91acf6157f8b5c3c$export$cc3b967c039ed3e7;

});

parcelRegister("fNwcJ", function(module, exports) {
/**
 * This file defines the requestAccess() service.
 */ 
var $dh538 = parcelRequire("dh538");


var $k4HRJ = parcelRequire("k4HRJ");


var $7DBey = parcelRequire("7DBey");


var $2Q94g = parcelRequire("2Q94g");


var $bmTr3 = parcelRequire("bmTr3");

/**
 * Valid values are defined in IIS:
 * https://bitbucket.org/atlassian/id-invitations-service/src/master/src/main/java/com/atlassian/identity/invitations/model/EnablementTouchpoint.java
 */ const $bf9bb0e4c78e4bdb$var$EnablementTouchpoint = {
    CROSSJOIN_NUDGE: 'Crossjoin Nudge'
};
// Dependencies - generally common to all RA's/joins:
const $bf9bb0e4c78e4bdb$var$dependencies = {
    fetchJSON: $bmTr3.fetchJSON,
    createAnalyticsEvent: $2Q94g.createAnalyticsEvent,
    getStargateURL: $2Q94g.getStargateURL,
    getCurrentUserId: $2Q94g.getCurrentUserId,
    getCurrentCloudId: $2Q94g.getCurrentCloudId,
    getCurrentProduct: $2Q94g.getCurrentProduct
};
const $bf9bb0e4c78e4bdb$export$cd9e5995821603e1 = Object.assign($bf9bb0e4c78e4bdb$var$requestAccessImpl, {
    dependencies: $bf9bb0e4c78e4bdb$var$dependencies
});
async function $bf9bb0e4c78e4bdb$var$requestAccessImpl(input, context) {
    const deps = context.dependencies();
    const cloudId = input.cloudId ?? deps.getCurrentCloudId();
    const userId = deps.getCurrentUserId();
    let result;
    const resource = (0, $k4HRJ.AnyAri).create({
        resourceType: 'site',
        resourceId: cloudId,
        resourceOwner: input.product
    }).toString();
    try {
        // https://developer.atlassian.com/platform/identity/rest/v1/api-group-access-requests/#api-v2-access-requests-request-post
        const response = await deps.fetchJSON({
            url: deps.getStargateURL('/invitations/v1/access-requests/request'),
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                resource: resource,
                ...input.note && (0, $dh538.fg)('puma-1287-add-note-payload') ? {
                    note: input.note
                } : {},
                metadata: {
                    sourceProduct: deps.getCurrentProduct(),
                    ...input.touchpoint ? {
                        touchpoint: input.touchpoint
                    } : {}
                }
            })
        });
        result = $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, {
            resource: resource,
            userId: userId,
            ...input
        });
    } catch (error) {
        result = {
            error: (0, $7DBey.toError)(error),
            ...input,
            result: null,
            resource: resource,
            userId: userId
        };
    }
    $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({
        ...input,
        ...result
    }, context);
    return result;
}
function $bf9bb0e4c78e4bdb$var$mapRequestAccessResponse(response, input) {
    return {
        error: null,
        result: response.results[input.resource],
        ...input
    };
}
// Analytics functions for these common events might later become
// exported for standalone use
function $bf9bb0e4c78e4bdb$var$fireRequestAccessAnalytics({ error: error, product: product, result: result }, context) {
    if (!error) {
        const currentUserId = context.dependencies().getCurrentUserId();
        const attributes = {
            userAaid: currentUserId,
            actorAaid: currentUserId,
            roleName: 'product/member',
            inviteStatus: result,
            sourceProduct: context.dependencies().getCurrentProduct(),
            sourceTenantId: context.dependencies().getCurrentCloudId(),
            ...(0, $dh538.fg)('puma-1344-request-access-attributes') ? {
                PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: true,
                targetProduct: product
            } : {
                PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: false,
                product: product
            }
        };
        if (result === 'ACCESS_GRANTED') $bf9bb0e4c78e4bdb$var$fireProductJoined(attributes, context);
        else $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(attributes, context);
    }
}
function $bf9bb0e4c78e4bdb$var$fireProductAccessRequested(input, context) {
    const { PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES, ...attributes } = input;
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'productAccess',
            action: 'requested',
            actionSubjectId: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? input.targetProduct : input.product,
            attributes: attributes
        }
    }).fire();
}
function $bf9bb0e4c78e4bdb$var$fireProductJoined(input, context) {
    const { userUuid: userUuid, userAaid: userAaid, roleName: roleName, sourceTenantId: sourceTenantId, sourceProduct: sourceProduct, recommendationSources: recommendationSources, PUMA_1344_REQUEST_ACCESS_ATTRIBUTES: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES } = input;
    context.dependencies().createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            actionSubject: 'product',
            action: 'joined',
            actionSubjectId: PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? input.targetProduct : input.product,
            attributes: {
                userUuid: userUuid,
                userAaid: userAaid,
                roleName: roleName,
                sourceTenantId: sourceTenantId,
                sourceProduct: sourceProduct,
                recommendationSources: recommendationSources,
                ...PUMA_1344_REQUEST_ACCESS_ATTRIBUTES ? {
                    targetProduct: input.targetProduct
                } : {
                    product: input.product
                }
            }
        }
    }).fire();
}
module.exports["requestAccess"] = $bf9bb0e4c78e4bdb$export$cd9e5995821603e1;

});

parcelRegister("2Q94g", function(module, exports) {
/**
 * This file contains declaration of smaller services,
 * commonly used as building blocks to create more specific
 * endpoint wrapping services
 */ 
var $dh538 = parcelRequire("dh538");


var $7DBey = parcelRequire("7DBey");

const $26f4407bbf6764a3$export$c7904a8284e43beb = (url)=>`/gateway/api${url}`;
const $26f4407bbf6764a3$export$ddb1688281a3443e = (0, $7DBey.unimplementedAbstractService)('getCurrentCloudId');
const $26f4407bbf6764a3$export$5ebc6cb2748e1881 = (0, $7DBey.unimplementedAbstractService)('getCurrentUserId');
const $26f4407bbf6764a3$export$d01408ed6f850a64 = (0, $7DBey.unimplementedAbstractService)('getCurrentProduct');
const $26f4407bbf6764a3$export$a48841c0475a8073 = (0, $7DBey.unimplementedAbstractService)('createAnalyticsEvent');
const $26f4407bbf6764a3$export$a27c21aa3ed8f0f1 = (0, $7DBey.unimplementedAbstractService)('fireErrorAnalytics');
class $26f4407bbf6764a3$export$26e841bcf1aeb894 extends Error {
    constructor(action, responseCode, response, responseJson, errorType){
        if (responseJson?.message) {
            super(responseJson.message);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        } else {
            super(`Received error response during action ${action}: ${response.statusText}`);
            this.responseCode = void 0;
            this.errorType = void 0;
            this.response = void 0;
            this.responseJson = void 0;
        }
        this.name = 'FetchError';
        this.responseCode = responseCode;
        this.response = response;
        this.responseJson = responseJson;
        this.errorType = errorType;
    }
}
const $26f4407bbf6764a3$export$33e83b6fee5d732d = (err)=>({
        code: err instanceof Error ? err.name : 'UNKNOWN',
        message: err instanceof Error ? err.message : String(err),
        status: // Trying to get the status code (404, 500 etc.) from multiple properties
        // because Expansion Services can be used in different environments,
        // which may dependency-inject different fetchJSON() implementations.
        // These throw different FetchError shapes across the main products.
        // Because we're dealing with exceptions, this is not guarded by types.
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        (0, $dh538.fg)('puma-1321-expansion-services-event-error-status') && err ? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'responseCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'statusCode') ?? $26f4407bbf6764a3$var$getErrorStatusProperty(err, 'status') : err instanceof $26f4407bbf6764a3$export$26e841bcf1aeb894 ? err.responseCode : undefined
    });
const $26f4407bbf6764a3$var$getErrorStatusProperty = (error, key)=>{
    const value = error[key];
    if (typeof value === 'number') return value;
};
const $26f4407bbf6764a3$export$678d91a98f79a24d = (errorMessage, statusCode)=>!statusCode && $26f4407bbf6764a3$export$e1b6bb1617649e83(errorMessage) || statusCode === 401;
const $26f4407bbf6764a3$export$1f2663aaa83f036d = 'Failed to fetch';
const $26f4407bbf6764a3$export$65e55894e6e38a89 = 'NetworkError when attempting to fetch resource.';
const $26f4407bbf6764a3$export$f25400ad927aa79c = 'A server with the specified hostname could not be found.';
const $26f4407bbf6764a3$export$6827a0909c1bf12f = [
    $26f4407bbf6764a3$export$1f2663aaa83f036d,
    $26f4407bbf6764a3$export$65e55894e6e38a89,
    $26f4407bbf6764a3$export$f25400ad927aa79c
];
const $26f4407bbf6764a3$export$e1b6bb1617649e83 = (errorMessage)=>$26f4407bbf6764a3$export$6827a0909c1bf12f.some((failureMessage)=>errorMessage?.includes(failureMessage));
const $26f4407bbf6764a3$export$c53f16dd5442ef61 = 'EMAIL_BLOCKED';
const $26f4407bbf6764a3$export$e27975535396141b = 'REACHED_MAX_NUMBER_OF_EMAIL_ALIAS_SIGNUPS';
const $26f4407bbf6764a3$var$INVALID_EMAIL = 'INVALID_EMAIL';
const $26f4407bbf6764a3$var$MISSING_USERNAME = 'MISSING_USERNAME';
const $26f4407bbf6764a3$var$EMPTY_USERNAME = 'EMPTY_USERNAME';
const $26f4407bbf6764a3$var$USERNAME_MUST_BE_EMAIL = 'USERNAME_MUST_BE_EMAIL';
const $26f4407bbf6764a3$export$80a3c1a1eb6f063 = 'noDefaultGroup';
const $26f4407bbf6764a3$export$e089e1d2018847da = 'Default group for the requested resource not found.';
const $26f4407bbf6764a3$export$cb3290253184cb70 = (message, error)=>{
    try {
        const badRequestResponse = JSON.parse(message);
        return badRequestResponse.some((val)=>val.errorCodes.userName.includes(error));
    } catch (e) {
        return false;
    }
};
const $26f4407bbf6764a3$export$395f41a02d6a8be0 = (errorKey, errorMessage)=>errorKey === $26f4407bbf6764a3$export$80a3c1a1eb6f063 || errorMessage === $26f4407bbf6764a3$export$e089e1d2018847da;
const $26f4407bbf6764a3$export$1c4c1f7e2d529330 = (response)=>{
    const { key: key, message: message, status: status } = response;
    return $26f4407bbf6764a3$export$678d91a98f79a24d(message, status) || status === 400 && ($26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$c53f16dd5442ef61) || $26f4407bbf6764a3$export$cb3290253184cb70(message, $26f4407bbf6764a3$export$e27975535396141b)) || status === 412 && $26f4407bbf6764a3$export$395f41a02d6a8be0(key, message);
};
const $26f4407bbf6764a3$export$9de493bcd9b1d977 = 'bad-request';
const $26f4407bbf6764a3$export$e5254cb9f7678ab9 = 'licence-exceeded';
const $26f4407bbf6764a3$export$90cda429f609d666 = (response)=>{
    const { code: code, message: message } = response;
    if (code === $26f4407bbf6764a3$export$9de493bcd9b1d977 && message === 'User cannot invite themselves') return false;
    if (code === $26f4407bbf6764a3$export$e5254cb9f7678ab9) return false;
    return true;
};
module.exports["getStargateURL"] = $26f4407bbf6764a3$export$c7904a8284e43beb;
module.exports["getCurrentCloudId"] = $26f4407bbf6764a3$export$ddb1688281a3443e;
module.exports["getCurrentUserId"] = $26f4407bbf6764a3$export$5ebc6cb2748e1881;
module.exports["getCurrentProduct"] = $26f4407bbf6764a3$export$d01408ed6f850a64;
module.exports["createAnalyticsEvent"] = $26f4407bbf6764a3$export$a48841c0475a8073;
module.exports["getErrorDetails"] = $26f4407bbf6764a3$export$33e83b6fee5d732d;
module.exports["isAcceptableFailure"] = $26f4407bbf6764a3$export$678d91a98f79a24d;
module.exports["isAcceptableFailureForUserInvite"] = $26f4407bbf6764a3$export$1c4c1f7e2d529330;
module.exports["shouldReportFailedInvite"] = $26f4407bbf6764a3$export$90cda429f609d666;

});

parcelRegister("bmTr3", function(module, exports) {

var $7DBey = parcelRequire("7DBey");

const $c1aca408fa9ca14a$export$81bec6e38e8b706b = // XXX: This is a generic function - careful with types!
// TypeScript has limitations when transforming generic functions.
// Here, the function signature will pass through our helper unimplementedAbstractService()
// untouched, which TypeScript can handle.
(0, $7DBey.unimplementedAbstractService)('fetchJSON');
module.exports["fetchJSON"] = $c1aca408fa9ca14a$export$81bec6e38e8b706b;

});

parcelRegister("cnQgR", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4rwCt = parcelRequire("4rwCt");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $cOrQJ = parcelRequire("cOrQJ");


var $lAFHW = parcelRequire("lAFHW");


var $lGgRw = parcelRequire("lGgRw");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");


var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");


var $6mKj3 = parcelRequire("6mKj3");


var $2fvAC = parcelRequire("2fvAC");


var $5M6IM = parcelRequire("5M6IM");


var $kqrkb = parcelRequire("kqrkb");

const $282df3a04f7add9c$export$e4ecefef0a48fd72 = 400;
const $282df3a04f7add9c$var$i18n = (0, $cgtv4.defineMessages)({
    tryNow: {
        id: "loom-utils.loom-cross-sell-popup-card.tryNow",
        defaultMessage: "Try now"
    }
});
const $282df3a04f7add9c$var$cardStyles = (0, $ecnYn.xcss)({
    borderRadius: 'radius.small',
    overflow: 'auto',
    width: '352px'
});
const $282df3a04f7add9c$var$cardContentStyles = (0, $ecnYn.xcss)({
    padding: 'space.300'
});
const $282df3a04f7add9c$var$imageContainerStyles = (0, $ecnYn.xcss)({
    height: '201px'
});
const $282df3a04f7add9c$var$spotlightContentContainerStyles = (0, $ecnYn.xcss)({
    position: 'fixed'
});
const $282df3a04f7add9c$export$48e89f1cdc429537 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(87);
    const { actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: t1, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl } = t0;
    const shouldRenderToParent = t1 === undefined ? true : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === "dark";
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            if (closePopupTimerRef.current) {
                clearTimeout(closePopupTimerRef.current);
                closePopupTimerRef.current = null;
            }
        };
        $[0] = t2;
    } else t2 = $[0];
    const clearClosePopupTimer = t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = ()=>{
            if (openPopupTimerRef.current) {
                clearTimeout(openPopupTimerRef.current);
                openPopupTimerRef.current = null;
            }
        };
        $[1] = t3;
    } else t3 = $[1];
    const clearOpenPopupTimer = t3;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t4;
    let t5;
    if ($[2] !== entryPointId || $[3] !== experienceTracker || $[4] !== isOpen || $[5] !== sourceAdType) {
        t4 = ()=>{
            if (isOpen) experienceTracker.start({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
        };
        t5 = [
            entryPointId,
            experienceTracker,
            isOpen,
            sourceAdType
        ];
        $[2] = entryPointId;
        $[3] = experienceTracker;
        $[4] = isOpen;
        $[5] = sourceAdType;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $42omo.useEffect)(t4, t5);
    let t6;
    if ($[8] !== entryPointId || $[9] !== experienceTracker || $[10] !== sourceAdType) {
        t6 = ()=>{
            setIsOpen(false);
            experienceTracker.abort({
                name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
                reason: "Loom pop up closed",
                attributes: {
                    sourceComponent: entryPointId,
                    adType: sourceAdType
                }
            });
            isOpenOnFocusDisabled.current = true;
            setTimeout(()=>{
                isOpenOnFocusDisabled.current = false;
            }, 0);
        };
        $[8] = entryPointId;
        $[9] = experienceTracker;
        $[10] = sourceAdType;
        $[11] = t6;
    } else t6 = $[11];
    const safeClosePopup = t6;
    let t7;
    if ($[12] !== safeClosePopup) {
        t7 = ()=>{
            clearOpenPopupTimer();
            if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
                safeClosePopup();
                closePopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[12] = safeClosePopup;
        $[13] = t7;
    } else t7 = $[13];
    const startClosePopupTimer = t7;
    let t8;
    if ($[14] !== createAnalyticsEvent || $[15] !== entryPointId || $[16] !== sourceAdType || $[17] !== sourceComponent) {
        t8 = ()=>{
            clearClosePopupTimer();
            if (!hasStartedPreloadingImage.current) {
                hasStartedPreloadingImage.current = true;
                const img = new Image();
                img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
            }
            if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
                if (sourceAdType === "crossFlow") (0, $6mKj3.expVal)("migrate_confluence_loom_xflow_popup_to_spotlight", "exposure", false);
                createAnalyticsEvent({
                    type: "sendScreenEvent",
                    data: {
                        name: "loomAdPopupCard",
                        attributes: {
                            adType: sourceAdType,
                            entrypoint: entryPointId,
                            sourceComponent: sourceComponent,
                            isMigrateToSpotlightEnabled: sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)
                        }
                    }
                }).fire();
                setIsOpen(true);
                openPopupTimerRef.current = null;
            }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
        };
        $[14] = createAnalyticsEvent;
        $[15] = entryPointId;
        $[16] = sourceAdType;
        $[17] = sourceComponent;
        $[18] = t8;
    } else t8 = $[18];
    const startOpenPopupTimer = t8;
    let t9;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = ()=>{
            clearOpenPopupTimer();
        };
        $[19] = t9;
    } else t9 = $[19];
    const handleTriggerBlur = t9;
    let t10;
    if ($[20] !== startOpenPopupTimer) {
        t10 = ()=>{
            if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
        };
        $[20] = startOpenPopupTimer;
        $[21] = t10;
    } else t10 = $[21];
    const handleTriggerFocus = t10;
    let t11;
    if ($[22] !== startOpenPopupTimer) {
        t11 = ()=>{
            startOpenPopupTimer();
        };
        $[22] = startOpenPopupTimer;
        $[23] = t11;
    } else t11 = $[23];
    const handleTriggerMouseEnter = t11;
    let t12;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = ()=>{
            clearClosePopupTimer();
        };
        $[24] = t12;
    } else t12 = $[24];
    const handleCardMouseEnter = t12;
    let t13;
    if ($[25] !== startClosePopupTimer) {
        t13 = ()=>{
            if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
        };
        $[25] = startClosePopupTimer;
        $[26] = t13;
    } else t13 = $[26];
    const handleMouseLeave = t13;
    let t14;
    if ($[27] !== actions || $[28] !== description || $[29] !== handleMouseLeave || $[30] !== title) {
        t14 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: contentWrapperElementRef,
                xcss: $282df3a04f7add9c$var$cardStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $282df3a04f7add9c$var$imageContainerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                height: "201px",
                width: "352px",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.300",
                xcss: $282df3a04f7add9c$var$cardContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
                space: "space.100"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "h2",
                size: "small"
            }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p",
                color: "color.text.subtle"
            }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                spread: "space-between"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
                appearance: "brand",
                size: "medium"
            }), actions)));
        $[27] = actions;
        $[28] = description;
        $[29] = handleMouseLeave;
        $[30] = title;
        $[31] = t14;
    } else t14 = $[31];
    const content = t14;
    if (sourceAdType === "crossFlow" && (0, $6mKj3.UNSAFE_expValNoExposure)("migrate_confluence_loom_xflow_popup_to_spotlight", "isEnabled", false)) {
        let t15;
        if ($[32] !== handleMouseLeave || $[33] !== handleTriggerFocus || $[34] !== handleTriggerMouseEnter || $[35] !== isOpen || $[36] !== trigger) {
            t15 = trigger({
                ref: triggerElementRef,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                "aria-expanded": isOpen,
                "aria-haspopup": true
            });
            $[32] = handleMouseLeave;
            $[33] = handleTriggerFocus;
            $[34] = handleTriggerMouseEnter;
            $[35] = isOpen;
            $[36] = trigger;
            $[37] = t15;
        } else t15 = $[37];
        let t16;
        if ($[38] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, t15);
            $[38] = t15;
            $[39] = t16;
        } else t16 = $[39];
        const t17 = spotlightPlacement || "left-start";
        let t18;
        if ($[40] !== title) {
            t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
                as: "span",
                size: "xsmall"
            }, title);
            $[40] = title;
            $[41] = t18;
        } else t18 = $[41];
        let t19;
        if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
            t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null);
            $[42] = t19;
        } else t19 = $[42];
        let t20;
        if ($[43] !== adControl) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, t19, adControl);
            $[43] = adControl;
            $[44] = t20;
        } else t20 = $[44];
        let t21;
        if ($[45] !== t18 || $[46] !== t20) {
            t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, t18, t20);
            $[45] = t18;
            $[46] = t20;
            $[47] = t21;
        } else t21 = $[47];
        const t22 = isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)));
        let t23;
        if ($[48] !== t22) {
            t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
                alt: "",
                src: t22
            }));
            $[48] = t22;
            $[49] = t23;
        } else t23 = $[49];
        let t24;
        if ($[50] !== description) {
            t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                as: "p"
            }, description));
            $[50] = description;
            $[51] = t24;
        } else t24 = $[51];
        let t25;
        if ($[52] !== intl) {
            t25 = intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow);
            $[52] = intl;
            $[53] = t25;
        } else t25 = $[53];
        let t26;
        if ($[54] !== primaryOnClick || $[55] !== t25) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
                onClick: primaryOnClick
            }, t25)));
            $[54] = primaryOnClick;
            $[55] = t25;
            $[56] = t26;
        } else t26 = $[56];
        let t27;
        if ($[57] !== t21 || $[58] !== t23 || $[59] !== t24 || $[60] !== t26) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
                testId: "loom-cross-sell-spotlight-content-card"
            }, t21, t23, t24, t26);
            $[57] = t21;
            $[58] = t23;
            $[59] = t24;
            $[60] = t26;
            $[61] = t27;
        } else t27 = $[61];
        let t28;
        if ($[62] !== isOpen || $[63] !== safeClosePopup || $[64] !== t17 || $[65] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
                isVisible: isOpen,
                placement: t17,
                dismiss: safeClosePopup,
                testId: "loom-cross-sell-spotlight-content",
                strategy: "absolute",
                shouldDismissOnClickOutside: false
            }, t27);
            $[62] = isOpen;
            $[63] = safeClosePopup;
            $[64] = t17;
            $[65] = t27;
            $[66] = t28;
        } else t28 = $[66];
        let t29;
        if ($[67] !== handleMouseLeave || $[68] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                ref: triggerElementRef,
                testId: "loom-cross-sell-spotlight-content-container",
                onMouseEnter: handleCardMouseEnter,
                onMouseLeave: handleMouseLeave,
                xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
            }, t28);
            $[67] = handleMouseLeave;
            $[68] = t28;
            $[69] = t29;
        } else t29 = $[69];
        let t30;
        if ($[70] !== t16 || $[71] !== t29) {
            t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, t16, t29);
            $[70] = t16;
            $[71] = t29;
            $[72] = t30;
        } else t30 = $[72];
        return t30;
    }
    const t15 = placement || "auto";
    let t16;
    if ($[73] !== handleMouseLeave || $[74] !== handleTriggerFocus || $[75] !== handleTriggerMouseEnter || $[76] !== isOpen || $[77] !== trigger) {
        t16 = (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            });
        $[73] = handleMouseLeave;
        $[74] = handleTriggerFocus;
        $[75] = handleTriggerMouseEnter;
        $[76] = isOpen;
        $[77] = trigger;
        $[78] = t16;
    } else t16 = $[78];
    let t17;
    if ($[79] !== content || $[80] !== isOpen || $[81] !== safeClosePopup || $[82] !== shouldRenderToParent || $[83] !== t15 || $[84] !== t16 || $[85] !== title) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            autoFocus: false,
            content: content,
            isOpen: isOpen,
            label: title,
            onClose: safeClosePopup,
            placement: t15,
            role: "dialog",
            shouldRenderToParent: shouldRenderToParent,
            trigger: t16
        });
        $[79] = content;
        $[80] = isOpen;
        $[81] = safeClosePopup;
        $[82] = shouldRenderToParent;
        $[83] = t15;
        $[84] = t16;
        $[85] = title;
        $[86] = t17;
    } else t17 = $[86];
    return t17;
} : ({ actions: actions, description: description, entryPointId: entryPointId, placement: placement, spotlightPlacement: spotlightPlacement, shouldRenderToParent: shouldRenderToParent = true, title: title, trigger: trigger, sourceAdType: sourceAdType, sourceComponent: sourceComponent, primaryOnClick: primaryOnClick, adControl: adControl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const isDarkMode = colorMode === 'dark';
    const intl = (0, $8C5kA.default)();
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const hasStartedPreloadingImage = (0, $42omo.useRef)(false);
    const closePopupTimerRef = (0, $42omo.useRef)(null);
    const openPopupTimerRef = (0, $42omo.useRef)(null);
    const contentWrapperElementRef = (0, $42omo.useRef)(null);
    const triggerElementRef = (0, $42omo.useRef)(null);
    const isOpenOnFocusDisabled = (0, $42omo.useRef)(false);
    const clearClosePopupTimer = (0, $42omo.useCallback)(()=>{
        if (closePopupTimerRef.current) {
            clearTimeout(closePopupTimerRef.current);
            closePopupTimerRef.current = null;
        }
    }, []);
    const clearOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        if (openPopupTimerRef.current) {
            clearTimeout(openPopupTimerRef.current);
            openPopupTimerRef.current = null;
        }
    }, []);
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    (0, $42omo.useEffect)(()=>{
        if (isOpen) experienceTracker.start({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
    }, [
        entryPointId,
        experienceTracker,
        isOpen,
        sourceAdType
    ]);
    /**
   * Temporarily disable the popup from re-opening (for a tick) on focus
   * because in many cases, closing the popup returns focus back to the
   * trigger, which would normally open the popup again.
   */ const safeClosePopup = (0, $42omo.useCallback)(()=>{
        setIsOpen(false);
        experienceTracker.abort({
            name: (0, $irVI7.LOOM_CROSS_SELL_EXPERIENCE),
            reason: 'Loom pop up closed',
            attributes: {
                sourceComponent: entryPointId,
                adType: sourceAdType
            }
        });
        isOpenOnFocusDisabled.current = true;
        setTimeout(()=>{
            isOpenOnFocusDisabled.current = false;
        }, 0);
    }, [
        entryPointId,
        experienceTracker,
        sourceAdType
    ]);
    const startClosePopupTimer = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
        if (!closePopupTimerRef.current) closePopupTimerRef.current = setTimeout(()=>{
            safeClosePopup();
            closePopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearOpenPopupTimer,
        safeClosePopup
    ]);
    /**
   * Don't open the popup card immediately on hover or focus
   *
   * 1) Focus: We want KB users to be able to quickly navigate through areas with entrypoints that
   * are alongside many other UI controls (e.g., Page Header, Page Editor Toolbar) without triggering
   * the popup card and getting "stuck" (needing to hit "esc" to continue).
   *
   * 2) Hover: We don't want users to feel like the popup card gets in their way of clicking other
   * things in the UI just because their mouse briefly brushed over the entrypoint button.
   *
   * This was heavily inspired by the hover cards used in the Page Tree (`useHoverPageCard`)
   */ const startOpenPopupTimer = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
        if (!hasStartedPreloadingImage.current) {
            hasStartedPreloadingImage.current = true;
            const img = new Image();
            img.src = (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)));
        }
        if (!openPopupTimerRef.current) openPopupTimerRef.current = setTimeout(()=>{
            if (sourceAdType === 'crossFlow') // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099)
            (0, $6mKj3.expVal)('migrate_confluence_loom_xflow_popup_to_spotlight', 'exposure', false); // fire exposure event when the popup is actually opened
            createAnalyticsEvent({
                type: 'sendScreenEvent',
                data: {
                    name: 'loomAdPopupCard',
                    attributes: {
                        adType: sourceAdType,
                        entrypoint: entryPointId,
                        sourceComponent: sourceComponent,
                        isMigrateToSpotlightEnabled: sourceAdType === 'crossFlow' && (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)
                    }
                }
            }).fire();
            setIsOpen(true);
            openPopupTimerRef.current = null;
        }, $282df3a04f7add9c$export$e4ecefef0a48fd72);
    }, [
        clearClosePopupTimer,
        createAnalyticsEvent,
        entryPointId,
        sourceAdType,
        sourceComponent
    ]);
    const handleTriggerBlur = (0, $42omo.useCallback)(()=>{
        clearOpenPopupTimer();
    }, [
        clearOpenPopupTimer
    ]);
    const handleTriggerFocus = (0, $42omo.useCallback)(()=>{
        if (!isOpenOnFocusDisabled.current) startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleTriggerMouseEnter = (0, $42omo.useCallback)(()=>{
        startOpenPopupTimer();
    }, [
        startOpenPopupTimer
    ]);
    const handleCardMouseEnter = (0, $42omo.useCallback)(()=>{
        clearClosePopupTimer();
    }, [
        clearClosePopupTimer
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        /**
     * Don't close the popup card when moving the mouse outside of it (or the trigger) if something
     * inside it (or the trigger itself) is focused
     */ if (!contentWrapperElementRef.current?.contains(document.activeElement) && document.activeElement !== triggerElementRef.current) startClosePopupTimer();
    }, [
        startClosePopupTimer
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            onMouseEnter: handleCardMouseEnter,
            onMouseLeave: handleMouseLeave,
            ref: contentWrapperElementRef,
            xcss: $282df3a04f7add9c$var$cardStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $282df3a04f7add9c$var$imageContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            alt: "",
            height: "201px",
            width: "352px",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($2fvAC)))
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.300",
            xcss: $282df3a04f7add9c$var$cardContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            as: "h2",
            size: "small"
        }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            as: "p",
            color: "color.text.subtle"
        }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lAFHW.LoomAttributionLogo), {
            appearance: "brand",
            size: "medium"
        }), actions)));
    if (sourceAdType === 'crossFlow' && // We are only migrating the cross-flow popup to spotlight for now https://atlassian.slack.com/archives/C0A7J84AS68/p1768356523913099
    (0, $6mKj3.UNSAFE_expValNoExposure)('migrate_confluence_loom_xflow_popup_to_spotlight', 'isEnabled', false)) /**
     * We are migrating the crossflow popup to use the new ADS spotlight design.
     * We will be conducting this as a no-harm experiment.
     * Poster: https://hello.atlassian.net/wiki/spaces/Growth/pages/6294901981/Migrate+Confluence+Loom+Crossflow+Popup+to+Spotlight+Eng+led+TWCG-1446+Project+Poster+FY26
     */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, trigger({
        ref: triggerElementRef,
        isSelected: isOpen,
        onBlur: handleTriggerBlur,
        onFocus: handleTriggerFocus,
        onMouseEnter: handleTriggerMouseEnter,
        onMouseLeave: handleMouseLeave,
        'aria-expanded': isOpen,
        'aria-haspopup': true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        ref: triggerElementRef,
        testId: "loom-cross-sell-spotlight-content-container",
        onMouseEnter: handleCardMouseEnter,
        onMouseLeave: handleMouseLeave,
        xcss: $282df3a04f7add9c$var$spotlightContentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        isVisible: isOpen,
        placement: spotlightPlacement || 'left-start',
        dismiss: safeClosePopup,
        testId: "loom-cross-sell-spotlight-content",
        strategy: "absolute",
        shouldDismissOnClickOutside: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
        testId: "loom-cross-sell-spotlight-content-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        as: "span",
        size: "xsmall"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null), adControl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        alt: "",
        src: isDarkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($kqrkb))) : (0, (/*@__PURE__*/$parcel$interopDefault($5M6IM)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
        onClick: primaryOnClick
    }, intl.formatMessage($282df3a04f7add9c$var$i18n.tryNow))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        autoFocus: false,
        content: content,
        isOpen: isOpen,
        /**
   * Using `titleId` and adding the same value as an `id` to the Heading in the popup content
   * does not announce properly in macOS VoiceOver
   */ label: title,
        onClose: safeClosePopup,
        placement: placement || 'auto',
        role: "dialog",
        shouldRenderToParent: shouldRenderToParent,
        trigger: (popupTriggerProps)=>trigger({
                ...popupTriggerProps,
                isSelected: isOpen,
                onBlur: handleTriggerBlur,
                onFocus: handleTriggerFocus,
                onMouseEnter: handleTriggerMouseEnter,
                onMouseLeave: handleMouseLeave,
                ref: (0, $4rwCt.mergeRefs)([
                    popupTriggerProps.ref,
                    triggerElementRef
                ])
            })
    });
};
module.exports["BaseLoomPopupCard"] = $282df3a04f7add9c$export$48e89f1cdc429537;

});

parcelRegister("2fvAC", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImage.6e60c328.png", import.meta.url).toString();

});

parcelRegister("5M6IM", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Light.55587eef.png", import.meta.url).toString();

});

parcelRegister("kqrkb", function(module, exports) {
module.exports = new URL("LoomCrossSellPopupCardImageNewVisual_Dark.c1c1769c.png", import.meta.url).toString();

});

parcelRegister("h7YX1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c646a99d277cd4b5b22a16e5f42dbd2f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7825eb38d10cf15$var$_react = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("42omo")));

var $c7825eb38d10cf15$var$_baseNew = $c7825eb38d10cf15$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c7825eb38d10cf15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for auto draft functionality in Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c7825eb38d10cf15$var$AiGenerativeTextIcon = (props)=>/*#__PURE__*/ $c7825eb38d10cf15$var$_react.default.createElement($c7825eb38d10cf15$var$_baseNew.default, Object.assign({
        name: "AiGenerativeTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M12.617 9.011a.75.75 0 0 1 .588.483l.615 1.687 1.687.615a.75.75 0 0 1 0 1.41l-1.687.615-.615 1.686a.75.75 0 0 1-1.409 0l-.616-1.686-1.686-.616a.75.75 0 0 1 0-1.409l1.686-.615.616-1.687.048-.106A.75.75 0 0 1 12.5 9z"/><path fill="currentcolor" fill-rule="evenodd" d="M9.337.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.1 8.099a2 2 0 0 1-1.022.547l-3.378.676a.75.75 0 0 1-.883-.883l.676-3.38a2 2 0 0 1 .546-1.02zm-7.04 9.159a.5.5 0 0 0-.136.256l-.456 2.275 2.278-.455a.5.5 0 0 0 .254-.137l6.078-6.078-1.94-1.94zm8.808-8.099a.5.5 0 0 0-.707 0l-.961.961 1.94 1.94.96-.961a.5.5 0 0 0 0-.707z" clip-rule="evenodd"/>`
    }, props));
$c7825eb38d10cf15$var$AiGenerativeTextIcon.displayName = 'AiGenerativeTextIcon';
var $c7825eb38d10cf15$var$_default = module.exports.default = $c7825eb38d10cf15$var$AiGenerativeTextIcon;

});

parcelRegister("gNXND", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a463dbdb96f5dd0cff6dca797202b246>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3bf9be9856ff4d9$var$_react = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("42omo")));

var $c3bf9be9856ff4d9$var$_baseNew = $c3bf9be9856ff4d9$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $c3bf9be9856ff4d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Rovo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing Rovo
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c3bf9be9856ff4d9$var$RovoIcon = (props)=>/*#__PURE__*/ $c3bf9be9856ff4d9$var$_react.default.createElement($c3bf9be9856ff4d9$var$_baseNew.default, Object.assign({
        name: "RovoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.687.64a2.63 2.63 0 0 1 2.625 0l4.404 2.544a2.63 2.63 0 0 1 1.313 2.273v5.084c0 .938-.5 1.804-1.313 2.274l-4.404 2.542a2.63 2.63 0 0 1-2.625 0l-4.403-2.542A2.63 2.63 0 0 1 .97 10.54V5.457c0-.938.5-1.804 1.313-2.273zM3.034 4.483a1.13 1.13 0 0 0-.563.975v5.084c0 .402.215.774.563.975l4.403 2.543c.348.2.777.2 1.125 0l.688-.398v-1.997L5.896 9.568a1.38 1.38 0 0 1-.646-1.166V3.203zM8.562 1.94a1.13 1.13 0 0 0-1.125 0l-.687.398v1.996l3.354 2.097c.402.251.646.692.646 1.166v5.199l2.216-1.28c.348-.2.563-.572.563-.974V5.457c0-.402-.215-.774-.563-.975zM6.75 8.333l2.5 1.563V7.663l-2.5-1.561z" clip-rule="evenodd"/>`
    }, props));
$c3bf9be9856ff4d9$var$RovoIcon.displayName = 'RovoIcon';
var $c3bf9be9856ff4d9$var$_default = module.exports.default = $c3bf9be9856ff4d9$var$RovoIcon;

});

parcelRegister("16lEl", function(module, exports) {
const $99e3e594de94f1bc$export$b881bd9f00ed8ed1 = {
    LOAD_PANEL: 'aiMateLoadPanel',
    LOAD_PANEL_COMPOSABLE_EDITOR: 'aiMateLoadPanelComposableEditor',
    LOAD_INLINE_EDITOR: 'aiMateLoadInlineComposableEditor',
    LOAD_BROWSE_AGENTS: 'aiMateLoadBrowseAgents',
    LOAD_CREATE_AGENT: 'aiMateLoadCreateAgent',
    FETCH_CHAT: 'aiMateFetchChat',
    FETCH_AGENTS: 'aiMateFetchAgents',
    FETCH_AGENTS_PAGINATED: 'aiMateFetchAgentsPaginated',
    FETCH_AGENTS_OVERRIDES: 'aiMateFetchAgentsOverrides',
    FETCH_AGENT_BY_AGENT_ID: 'aiMateFetchAgentByAgentId',
    FETCH_SCENARIO_LIST: 'aiMateFetchScenarioList',
    FETCH_AGENT_BY_IDENTITY_ACCOUNT_ID: 'aiMateFetchAgentByIdentityAccountId',
    FETCH_AGENT_BY_EXTERNAL_CONFIG_REFERENCE: 'aiMateFetchAgentByExternalConfigReference',
    FETCH_AGENT_DEBUG_MODAL_DATA: 'aiMateFetchAgentDebugModalData',
    FETCH_AGENT_DEBUG_MODAL_CONVERSATION_REVIEW: 'aiMateFetchAgentDebugModalDataConversationReview',
    CREATE_AGENT: 'aiMateCreateAgent',
    UPDATE_AGENT: 'aiMateUpdateAgent',
    DELETE_AGENT: 'aiMateDeleteAgent',
    HYDRATE_AGENT_DATA: 'aiMateHydrateAgentData',
    HYDRATE_SKILL_METADATA: 'aiMateHydrateSkillMetadata',
    FAVOURITE_AGENT: 'aiMateFavouriteAgent',
    UNFAVOURITE_AGENT: 'aiMateUnfavouriteAgent',
    CLEAR_CHAT: 'aiMateClearChat',
    SEND_MESSAGE: 'aiMateSendMessage',
    SEND_MESSAGE_ROVO_CUSTOM_AGENT: 'aiMateSendMessageRovoCustomAgent',
    SEND_DR_MESSAGE: 'aiMateSendDRMessage',
    SEND_TD_MESSAGE: 'aiMateSendThinkDeeperMessage',
    SEND_CONFIRMED_TOOLS_MESSAGE: 'aiMateSendConfirmedToolsMessage',
    RECONNECT_TO_ACTIVE_STREAM: 'aiMateReconnectToActiveStream',
    ABORT_AGENT_STREAM: 'aiMateAbortAgentStream',
    ANSWER_NOW: 'aiMateAnswerNow',
    HYDRATE_CONVERSATION: 'aiMateHydrateConversation',
    GET_CONVERSATION_CHANNELS: 'aiMateGetConversationChannels',
    GET_CONVERSATION_CHANNELS_INITIAL_LOAD: 'aiMateGetConversationChannelsInitialLoad',
    UPDATE_CONVERSATION_CHANNEL: 'aiMateUpdateConversationChannel',
    CREATE_SEEDED_CONVERSATION_CHANNEL: 'aiMateCreateSeededConversationChannel',
    PUBSUB_LISTENER: 'aiMatePubSubListener',
    FETCH_AGENT_TENANT_DATA: 'aiMateFetchAgentTenantData',
    RESOLVE_CONVERSATION_ACTION: 'aiMateResolveConversationAction',
    BULK_RESOLVE_CONVERSATION_ACTIONS: 'aiMateBulkResolveConversationActions',
    MESSAGE_RENDERER: 'aiMateMessageRenderer',
    FETCH_CONTEXTUAL_STARTERS: 'aiMateFetchContextualStarters',
    FETCH_DYNAMIC_CONVERSATION_STARTERS: 'aiMateFetchDynamicConversationStarters',
    GENERATE_CONVERSATION_STARTERS: 'aiMateGenerateConversationStarters',
    FETCH_AGENT_TEAM_DATA: 'aiMateFetchAgentTeamData',
    FETCH_CONNECTED_KNOWLEDGE_SOURCES: 'aiMateFetchConnectedKnowledgeSources',
    FETCH_AGENT_ACTIONS: 'aiMateFetchAgentActions',
    CHANGE_AGENT_OWNER: 'aiMateChangeAgentOwner',
    GET_AGENT_PERMISSIONS: 'aiMateGetAgentPermissions',
    AIFC_FINALIZE_CONTENT: 'aiMateAIFCFinalizeContent',
    PREVIEW_CONTENT: 'aiMatePreviewContent',
    PREVIEW_CARD_RENDER: 'aiMatePreviewCardRender',
    JIRA_PREVIEW_CARD_RENDER: 'aiMateJiraPreviewCardRender',
    FETCH_AGENT_SITE_PERMISSIONS: 'aiMateFetchAgentSitePermissions',
    SEND_MESSAGE_NL_AGENT: 'aiMateSendMessageNLAgent',
    GET_RECOMMENDED_AGENTS: 'aiMateGetRecommendedAgents',
    UPLOAD_FILES_TO_CONVERSATION: 'aiMateUploadFilesToConversation',
    VALIDATE_FILES: 'aiMateValidateFiles',
    GET_CONVERSATION_FILES: 'aiMateGetConversationFiles',
    AIFC_MESSAGE: 'aiMateAifcMessage',
    AIFC_LOAD_STAGING_AREA_MODAL: 'aiMateLoadStagingAreaModal',
    AIFC_LOAD_CHAT_ONLY_CREATION_MODAL: 'aiMateLoadChatOnlyCreationModal',
    AIFC_LOAD_DRAFTS_SECTION: 'aiMateLoadDraftsSection',
    AIFC_GENERATE_CONTENT: 'aiMateAifcGenerateContent',
    AIFC_GENERATE_CONTENT_IN_CHAT: 'aiMateAifcGenerateContentInChat',
    AIFC_INITIAL_DATA_RECEIVED: 'aiMateAifcInitialDataReceived',
    AIFC_ALL_DATA_HANDLED: 'aiMateAifcAllDataHandled',
    AIFC_UPDATE_CONTENT: 'aiMateAifcUpdateContent',
    AIFC_MODAL_SESSION: 'aiMateAifcModalSession',
    CSM_WIDGET_RENDER: 'csmWidgetRender',
    CSM_AGENT_IDENTITY_NAME: 'csmAgentIdentityName',
    CSM_AGENT_IDENTITY_COMPANY: 'csmAgentIdentityCompany',
    CSM_AGENT_IDENTITY_TONE: 'csmAgentIdentityTone',
    CSM_AGENT_IDENTITY_GREETING_MESSAGE: 'csmAgentIdentityGreetingMessage',
    CSM_AGENT_IDENTITY_CONVERSATION_STARTERS: 'csmAgentIdentityConversationStarters',
    CSM_AGENT_IDENTITY_GENERATE_CONVERSATION_STARTERS: 'csmAgentIdentityGenerateConversationStarters',
    GET_AUTO_APPLY_STATE: 'aiMateGetAutoApplyState',
    SET_AUTO_APPLY_STATE: 'aiMateSetAutoApplyState',
    AGENTS_MODAL_AND_SIDEBAR_LIST: 'aiMateAgentsModalAndSidebarList',
    AGENTS_MODAL_FAVOURITE_AGENTS: 'aiMateAgentsModalFavouriteAgents',
    AGENTS_FULLSCREEN_AGENT_LIST: 'aiMateAgentsFullscreenAgentList'
};
var $99e3e594de94f1bc$export$3615d040a39afa1e = /*#__PURE__*/ function(ExperienceNamePostfix) {
    ExperienceNamePostfix["MINI_MODAL"] = "miniModal";
    return ExperienceNamePostfix;
}({});
const $99e3e594de94f1bc$export$97bfa295b10f6f9e = ({ deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, isCustomRovoAgent: isCustomRovoAgent })=>{
    if (isCustomRovoAgent) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE_ROVO_CUSTOM_AGENT;
    if (deepResearchEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_DR_MESSAGE;
    if (thinkDeeperEnabled) return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_TD_MESSAGE;
    if (fastModeEnabled) // Sending the same experience name for fast mode as it is the same as the default (auto) mode
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
    return $99e3e594de94f1bc$export$b881bd9f00ed8ed1.SEND_MESSAGE;
};
const $99e3e594de94f1bc$export$233a4307e330ea30 = [
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_GENERATE_CONTENT_IN_CHAT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_UPDATE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_FINALIZE_CONTENT,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_LOAD_STAGING_AREA_MODAL,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_MODAL_SESSION
];
const $99e3e594de94f1bc$export$449b821dadec8760 = [
    // Experiences with timeouts must be listed first:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_INITIAL_DATA_RECEIVED,
    // Experiences without timeouts:
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.AIFC_ALL_DATA_HANDLED,
    $99e3e594de94f1bc$export$b881bd9f00ed8ed1.PREVIEW_CONTENT,
    ...$99e3e594de94f1bc$export$233a4307e330ea30
];
module.exports["ExperienceName"] = $99e3e594de94f1bc$export$b881bd9f00ed8ed1;
module.exports["ExperienceNamePostfix"] = $99e3e594de94f1bc$export$3615d040a39afa1e;
module.exports["sendMessageExperienceName"] = $99e3e594de94f1bc$export$97bfa295b10f6f9e;
module.exports["AIFC_EXPERIENCES_TO_FAIL"] = $99e3e594de94f1bc$export$233a4307e330ea30;
module.exports["AIFC_EXPERIENCES_TO_ABORT"] = $99e3e594de94f1bc$export$449b821dadec8760;

});

parcelRegister("hUyPY", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $c6GJD = parcelRequire("c6GJD");


var $4u5NT = parcelRequire("4u5NT");


var $9tntP = parcelRequire("9tntP");


var $j2DyP = parcelRequire("j2DyP");


var $1yaYZ = parcelRequire("1yaYZ");


var $kIvLT = parcelRequire("kIvLT");


var $16lEl = parcelRequire("16lEl");

var $a0b22d0a467d60f5$var$_ExperienceTrackerHandler;
const $a0b22d0a467d60f5$var$isRovoInstrumentedError = (error)=>error && typeof error === 'object' && 'errorAttributes' in error && typeof error.errorAttributes === 'object';
class $a0b22d0a467d60f5$export$5a92a056565f01cc {
    setSendAnalyticsEvent(sendAnalyticsEvent) {
        this.sendAnalyticsEvent = sendAnalyticsEvent;
    }
    static getInstance() {
        if (!$a0b22d0a467d60f5$export$5a92a056565f01cc.instance) {
            const dropEvents = (0, $c6GJD.default).getExperimentValue('platform_ai_drop_instrumentation_tracking', 'value', false);
            $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = new $a0b22d0a467d60f5$export$5a92a056565f01cc(dropEvents);
        }
        return $a0b22d0a467d60f5$export$5a92a056565f01cc.instance;
    }
    /**
   * @internal For tests only.
   */ static resetInstance() {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.instance = undefined;
    }
    static setLabelStack(labelStack) {
        $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = labelStack;
    }
    constructor(dropEvents){
        this.experienceTracker = new (0, $9tntP.ExperienceTracker)();
        this.sendAnalyticsEvent = null;
        if (!dropEvents) this.experienceTracker.subscribe((event)=>{
            let filteredErrorAttributes = {};
            let preventSendingLogException = false;
            // for FailEvent
            if ('error' in event) {
                // do not fail experience tracking if the error is a client fetch error
                if ((0, $j2DyP.isClientFetchError)(event.error)) preventSendingLogException = true;
                if (event.attributes) {
                    const { webSearchEnabled: webSearchEnabled, deepResearchEnabled: deepResearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled } = event.attributes;
                    if (webSearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        webSearchEnabled: webSearchEnabled
                    };
                    if (deepResearchEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        deepResearchEnabled: deepResearchEnabled
                    };
                    if (fastModeEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        fastModeEnabled: fastModeEnabled
                    };
                    if (thinkDeeperEnabled !== undefined) filteredErrorAttributes = {
                        ...filteredErrorAttributes,
                        thinkDeeperEnabled: thinkDeeperEnabled
                    };
                }
                if ($a0b22d0a467d60f5$var$isRovoInstrumentedError(event.error)) {
                    const errorAttributes = event.error.errorAttributes;
                    // Remove undefined properties
                    filteredErrorAttributes = Object.fromEntries(Object.entries(errorAttributes).filter(([, value])=>value !== undefined));
                }
                if (!preventSendingLogException) {
                    const error = event.error instanceof Error ? event.error : new Error(JSON.stringify(event.error));
                    const attributes = event.attributes;
                    // this is added by `useExperienceTracker` below
                    const touchpointSource = attributes?.touchpointSource;
                    const teamName = attributes?.teamName;
                    const { traceId: traceIdFromErrorObject, ...filteredErrorAttributesRest } = filteredErrorAttributes;
                    const altTraceId = attributes?.traceId || traceIdFromErrorObject;
                    (0, $1yaYZ.logException)({
                        exception: error,
                        name: event.name,
                        tags: {
                            source: 'aiMateExperienceTracker',
                            ...filteredErrorAttributesRest,
                            ...touchpointSource && {
                                touchpointSource: touchpointSource
                            },
                            ...teamName && {
                                teamName: teamName
                            },
                            // Rename traceId to atlTraceId if present in attributes to distinguish from Sentry's Trace ID
                            ...altTraceId && {
                                altTraceId: altTraceId
                            }
                        }
                    });
                }
            }
            if (event.action === 'taskSuccess' || event.action === 'taskFail' || event.action === 'taskAbort') // the experience tracker already uses performance.now() to calculate the duration, so we can just piggyback on that,
            // we will loose some precision due to rounding of duration, but it's good enough for our purposes
            (0, $4u5NT.addSpanToAll)('custom', `exp-${event.name}`, $a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack, event.startTime, event.startTime + event.duration);
            this.sendAnalyticsEvent?.({
                eventType: 'operational',
                action: event.action,
                actionSubject: 'ui',
                attributes: {
                    task: event.name,
                    taskId: event.id,
                    startTime: event.startTime,
                    // Only add duration if event is SuccessEvent or FailEvent
                    ...(event.action === 'taskSuccess' || event.action === 'taskFail') && {
                        duration: event.duration
                    },
                    ...event.action === 'taskFail' && {
                        error: event.error.message,
                        ...filteredErrorAttributes
                    },
                    ...event.attributes
                }
            }, {
                removeDefaultTags: true
            });
        });
    }
}
$a0b22d0a467d60f5$var$_ExperienceTrackerHandler = $a0b22d0a467d60f5$export$5a92a056565f01cc;
$a0b22d0a467d60f5$export$5a92a056565f01cc.instance = void 0;
$a0b22d0a467d60f5$export$5a92a056565f01cc.labelStack = [];
const $a0b22d0a467d60f5$export$63af6e7bbb4f375d = ()=>{
    return (0, $42omo.useCallback)((componentLabelStack)=>{
        $a0b22d0a467d60f5$export$5a92a056565f01cc.setLabelStack(componentLabelStack);
    }, []);
};
const $a0b22d0a467d60f5$export$412c53791574f6f0 = (params)=>{
    (0, $fBMbo.di)((0, $kIvLT.useAnalytics));
    const { sendAnalyticsEvent: sendAnalyticsEvent, mode: conversationAssistantUIMode } = (0, $kIvLT.useAnalytics)();
    const getNameOverride = (0, $42omo.useCallback)((name)=>{
        switch(conversationAssistantUIMode){
            case 'mini-modal':
                return `${name}.${(0, $16lEl.ExperienceNamePostfix).MINI_MODAL}`;
            default:
                return name;
        }
    }, [
        conversationAssistantUIMode
    ]);
    (0, $42omo.useMemo)(()=>{
        const experienceTracker = $a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance();
        // this is not ideal, okay just because `sendAnalyticsEvent` is never change
        // since every hook instance will override the singleton sendAnalyticsEvent
        experienceTracker.setSendAnalyticsEvent(sendAnalyticsEvent);
    }, [
        sendAnalyticsEvent
    ]);
    const experienceTrackerProxy = (0, $42omo.useMemo)(()=>{
        const proxyHandler = {
            get: (target, prop)=>{
                // Overriding the experienceTracker target methods to add additional attributes
                if (prop === 'fail') return (failParams)=>{
                    target.fail({
                        ...failParams,
                        attributes: {
                            ...failParams.attributes,
                            name: !!failParams.name ? getNameOverride(failParams.name) : failParams.name,
                            touchpointSource: params?.touchpointSource,
                            teamName: failParams.teamName
                        }
                    });
                };
                if (prop === 'succeed') return (succeedParams)=>{
                    target.succeed({
                        ...succeedParams,
                        name: !!succeedParams.name ? getNameOverride(succeedParams.name) : succeedParams.name,
                        attributes: {
                            ...succeedParams.attributes,
                            touchpointSource: params?.touchpointSource
                        }
                    });
                };
                if (prop === 'start') return (startParams)=>{
                    target.start({
                        ...startParams,
                        name: !!startParams.name ? getNameOverride(startParams.name) : startParams.name
                    });
                };
                if (prop === 'abort') return (abortParams)=>{
                    target.abort({
                        ...abortParams,
                        name: !!abortParams.name ? getNameOverride(abortParams.name) : abortParams.name
                    });
                };
                if (prop === 'stopOnError') return (stopOnErrorParams)=>{
                    target.stopOnError({
                        ...stopOnErrorParams,
                        name: !!stopOnErrorParams.name ? getNameOverride(stopOnErrorParams.name) : stopOnErrorParams.name
                    });
                };
                return typeof target[prop] === 'function' ? target[prop].bind(target) : target[prop];
            }
        };
        return new Proxy($a0b22d0a467d60f5$export$5a92a056565f01cc.getInstance().experienceTracker, proxyHandler);
    }, [
        params?.touchpointSource,
        getNameOverride
    ]);
    return experienceTrackerProxy;
};
module.exports["useUFOLabelStackSetter"] = $a0b22d0a467d60f5$export$63af6e7bbb4f375d;
module.exports["useAIMateExperienceTracker"] = $a0b22d0a467d60f5$export$412c53791574f6f0;

});

parcelRegister("fBMbo", function(module, exports) {

var $dNGPK = parcelRequire("dNGPK");


var $7qH1e = parcelRequire("7qH1e");

function $b5cfafc926496f98$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $dNGPK.Context)._currentRenderer2 && (0, $dNGPK.Context)._currentValue2 || // grab value from default renderer
    (0, $dNGPK.Context)._currentValue || (0, $7qH1e.globalDi);
    return getDependencies(deps, target);
}
module.exports["di"] = $b5cfafc926496f98$export$479d1ccc5f2ab701;

});

parcelRegister("dNGPK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $7qH1e = parcelRequire("7qH1e");

const $a0c113d1cdcf525c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext({
    getDependencies: (0, $7qH1e.globalDi).getDependencies
});
module.exports["Context"] = $a0c113d1cdcf525c$export$841858b892ce1f4c;

});

parcelRegister("7qH1e", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $b1tX2 = parcelRequire("b1tX2");

const $568c54c2a75aa99b$var$replacementMap = new Map();
const $568c54c2a75aa99b$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($568c54c2a75aa99b$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $b1tX2.findInjectable)($568c54c2a75aa99b$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($568c54c2a75aa99b$var$replacementMap.size) throw new Error(`${(0, $ipvr6.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj));
    },
    clear () {
        $568c54c2a75aa99b$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $ipvr6.diRegistry).get(inj).global) (0, $b1tX2.addInjectableToMap)($568c54c2a75aa99b$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $b1tX2.removeInjectableFromMap)($568c54c2a75aa99b$var$replacementMap, inj));
    }
};
function $568c54c2a75aa99b$export$b887ce09d70113f9(thunk, deps) {
    $568c54c2a75aa99b$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($568c54c2a75aa99b$export$a775919ebd7dd28a.clear, $568c54c2a75aa99b$export$a775919ebd7dd28a.clear);
        else $568c54c2a75aa99b$export$a775919ebd7dd28a.clear();
    }
}
module.exports["globalDi"] = $568c54c2a75aa99b$export$a775919ebd7dd28a;

});

parcelRegister("ipvr6", function(module, exports) {
const $d672f259068efdcd$export$4203fb010fad9bf0 = new WeakMap();
const $d672f259068efdcd$export$b8b9d90f9e5bd72b = 'react-magnetic-di';
module.exports["diRegistry"] = $d672f259068efdcd$export$4203fb010fad9bf0;
module.exports["PACKAGE_NAME"] = $d672f259068efdcd$export$b8b9d90f9e5bd72b;

});

parcelRegister("b1tX2", function(module, exports) {

var $ipvr6 = parcelRequire("ipvr6");


var $aqxLC = parcelRequire("aqxLC");

let $80670563c880fcd1$var$hasWarned = false;
function $80670563c880fcd1$export$5b28268982f175ba(message) {
    if (!$80670563c880fcd1$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $80670563c880fcd1$var$hasWarned = true;
    }
}
function $80670563c880fcd1$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $aqxLC.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $80670563c880fcd1$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $ipvr6.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $80670563c880fcd1$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $80670563c880fcd1$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $80670563c880fcd1$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $aqxLC.stats).track(candidate);
    return candidate;
}
module.exports["addInjectableToMap"] = $80670563c880fcd1$export$7a7134bdd2f9ae2e;
module.exports["removeInjectableFromMap"] = $80670563c880fcd1$export$8057a2244a849b7b;
module.exports["findInjectable"] = $80670563c880fcd1$export$7c436e151c3ee289;

});

parcelRegister("aqxLC", function(module, exports) {
const $79768685dc5c2f62$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $79768685dc5c2f62$export$7804429c45dff272 = {
    state: $79768685dc5c2f62$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $79768685dc5c2f62$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};
module.exports["stats"] = $79768685dc5c2f62$export$7804429c45dff272;

});

parcelRegister("j2DyP", function(module, exports) {
// Referenced from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Issues we are not gonna track in Sentry
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED = [
    'server with the specified hostname could not be found',
    'connection failure',
    'Failed to fetch',
    'Network request failed',
    'NetworkError',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted'
];
const $3c7c331d93a4dcee$var$isClientFetchErrorMessage = (message)=>{
    const errorTypes = $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_LIMITED;
    return Boolean(message) && !!errorTypes.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
};
const $3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $3c7c331d93a4dcee$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($3c7c331d93a4dcee$var$KNOWN_NETWORK_ERRORS_TYPES.includes(error.cause.name) || $3c7c331d93a4dcee$var$isClientFetchErrorMessage(error.cause.message)));
module.exports["isClientFetchError"] = $3c7c331d93a4dcee$export$2e7adc44463c3f4f;

});

parcelRegister("1yaYZ", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $8Igpw = parcelRequire("8Igpw");


var $j2DyP = parcelRequire("j2DyP");


var $35fh0 = parcelRequire("35fh0");


var $ldpU6 = parcelRequire("ldpU6");


// importing local file instead of from '@sentry/browser' otherwise there will be typescript errors
const $26a7abafe1ae99d6$var$importSentryAsync = async ()=>(parcelRequire("6jYyB"));
let $26a7abafe1ae99d6$var$sentryClient;
let $26a7abafe1ae99d6$var$accountIdPromise;
// copied from platform/packages/people-and-teams/teams-client/src/services/sentry/utils/initialise-sentry.ts
const $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS = [
    'onerror',
    'onunhandledrejection',
    // In Jira this integration is being initialised twice, resulting in no events being sent to Sentry
    'Dedupe'
];
const $26a7abafe1ae99d6$var$getEnvironment = ()=>{
    return 'production';
};
const $26a7abafe1ae99d6$export$d8bd0edf6c978788 = async ({ customSentryDsn: customSentryDsn, packageName: packageName, product: productOverride, ignoreErrors: ignoreErrors, packageVersion: packageVersion } = {})=>{
    let accountId = 'UNKNOWN_AAID';
    let product = productOverride ?? (0, $35fh0.getRovoChatProduct)();
    try {
        if ((0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) {
            if (!$26a7abafe1ae99d6$var$accountIdPromise) $26a7abafe1ae99d6$var$accountIdPromise = new Promise((resolve, reject)=>{
                (0, $8Igpw.performHttpFetch)({
                    path: '/gateway/api/me',
                    options: {
                        method: 'GET'
                    }
                }).then((profileData)=>{
                    if (profileData?.account_id) resolve(profileData.account_id);
                    else reject(new Error('Profile data not loaded'));
                }).catch((error)=>{
                    reject(error);
                });
            });
            accountId = await $26a7abafe1ae99d6$var$accountIdPromise;
        } else {
            const profileData = await (0, $8Igpw.performHttpFetch)({
                path: '/gateway/api/me',
                options: {
                    method: 'GET'
                }
            });
            if (profileData?.account_id) accountId = profileData.account_id;
        }
    } catch  {
    // do nothing
    }
    if ($26a7abafe1ae99d6$var$sentryClient) {
        // if sentry is trying to be initialized again with new product or account id
        // update the user and tags
        $26a7abafe1ae99d6$var$sentryClient.setTag('product', product);
        $26a7abafe1ae99d6$var$sentryClient.setUser({
            id: accountId
        });
        // do not initialise sentry again, only update the existing one
        return;
    }
    let importedSentry;
    try {
        importedSentry = await $26a7abafe1ae99d6$var$importSentryAsync();
    } catch (e) {
        console.warn('Failed to load conversation-assistant sentry', e); // eslint-disable-line no-console
        return;
    }
    // https://atlassian-2y.sentry.io/projects/ai-mate-conversation-assistant/getting-started/
    const defaultSentryDsn = 'https://0d679a1c0fe3816e2b2e34d4ca85d5da@o55978.ingest.sentry.io/4506794008903680';
    importedSentry.init({
        dsn: customSentryDsn || defaultSentryDsn,
        environment: $26a7abafe1ae99d6$var$getEnvironment(),
        integrations: (integrations)=>{
            return integrations.filter((integration)=>{
                return $26a7abafe1ae99d6$var$DISABLED_INTEGRATIONS.indexOf(integration.name) === -1;
            });
        },
        initialScope: {
            user: {
                id: accountId
            },
            tags: {
                packageName: packageName || '@atlassian/conversation-assistant',
                product: product,
                packageVersion: packageVersion
            }
        },
        // referencing jira/src/packages/platform/observability/errors-handling/src/utils/sentry/handling/normalise-sentry-event.tsx
        beforeSend: (event, hint)=>{
            const exception = hint?.originalException;
            // Ignore network-like errors
            if ((0, $j2DyP.isClientFetchError)(exception)) return null;
            if (!event.tags?.name) // we only want to capture errors that has `name` tag from `logException` function below
            // since the `DISABLED_INTEGRATIONS` filter above is not enough to prevent unhandled errors
            return null;
            let updatedEvent = event;
            if (updatedEvent.request?.url) {
                // Ignore events from localhost and staging
                if (updatedEvent.request.url.includes('localhost') || updatedEvent.request.url.includes('jira-dev.com') || updatedEvent.request.url.includes('stg.atlassian.com') || updatedEvent.request.url.includes('stg.internal.atlassian.com') || updatedEvent.request.url.includes('stg-east.frontend.public.atl-paas.net')) return null;
                updatedEvent.request.url = (0, $ldpU6.normaliseUrl)(updatedEvent.request.url);
            }
            if (updatedEvent.exception?.values) {
                const allMatchedUUIDs = [];
                updatedEvent.exception.values = updatedEvent.exception.values.map((exception)=>{
                    const { normalized: normalized, matchedUUIDs: matchedUUIDs } = (0, $ldpU6.normalizeUUID)(exception.value);
                    allMatchedUUIDs.push(...matchedUUIDs);
                    return {
                        ...exception,
                        value: normalized
                    };
                });
                if (allMatchedUUIDs.length > 0) {
                    if (!updatedEvent.tags) updatedEvent.tags = {};
                    updatedEvent.tags.matchedUUID = JSON.stringify(allMatchedUUIDs);
                }
            }
            return updatedEvent;
        },
        attachStacktrace: true,
        ignoreErrors: ignoreErrors
    });
    $26a7abafe1ae99d6$var$sentryClient = importedSentry;
};
const $26a7abafe1ae99d6$var$getSentryClient = async ()=>{
    if (!$26a7abafe1ae99d6$var$sentryClient) // this only happens if something using sentry before the initialisation in root app
    await $26a7abafe1ae99d6$export$d8bd0edf6c978788();
    return $26a7abafe1ae99d6$var$sentryClient;
};
const $26a7abafe1ae99d6$export$f86b2a1a2ce291b3 = async ({ exception: exception, name: name, tags: tags })=>{
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.withScope((scope)=>{
        scope.setTag('name', name);
        if (tags) scope.setTags(tags);
        if (tags?.source === 'aiMateExperienceTracker') scope.setTag('experience', name);
        sentryClient.captureException(exception, scope);
    });
};
async function $26a7abafe1ae99d6$export$de29810e0b4aa46e(crumb) {
    if (!(0, $dh538.fg)('rovo_chat_enable_additional_breadcrumbs')) // do not add breadcrumbs if the feature flag is disabled
    return;
    const sentryClient = await $26a7abafe1ae99d6$var$getSentryClient();
    if (!sentryClient || typeof sentryClient.captureException !== 'function') return;
    sentryClient.addBreadcrumb(typeof crumb === 'string' ? {
        message: crumb
    } : crumb);
}
module.exports["setupSentryClient"] = $26a7abafe1ae99d6$export$d8bd0edf6c978788;
module.exports["logException"] = $26a7abafe1ae99d6$export$f86b2a1a2ce291b3;
module.exports["addSentryBreadcrumb"] = $26a7abafe1ae99d6$export$de29810e0b4aa46e;

});

parcelRegister("8Igpw", function(module, exports) {
const $43e5bdc11d95b8bf$export$9f229e40eb65abfc = (response)=>response?.headers?.get('x-trace-id') ?? response?.headers?.get('atl-traceid') ?? response?.headers?.get('x-b3-traceid') ?? undefined;
class $43e5bdc11d95b8bf$export$26e841bcf1aeb894 extends Error {
    constructor(message, errorAttributes){
        super(message), this.errorAttributes = errorAttributes;
        this.name = 'FetchError';
    }
}
class $43e5bdc11d95b8bf$var$HttpApiError extends Error {
    constructor(message, errorAttributes){
        super(message), this.message = message, this.errorAttributes = errorAttributes;
    }
}
const $43e5bdc11d95b8bf$export$a38d93aa782475f6 = async ({ path: path, options: options })=>{
    try {
        const response = await fetch(path, options);
        if (!response.ok || response.status >= 400) await $43e5bdc11d95b8bf$var$processHttpErrorResponse({
            response: response
        });
        return await response.json();
    } catch (err) {
        const originalErrorMessage = err instanceof Error ? 'Original error: ' + err.message : 'Unknown error';
        const statusCode = err instanceof $43e5bdc11d95b8bf$var$HttpApiError ? err?.errorAttributes?.statusCode : undefined;
        throw new $43e5bdc11d95b8bf$export$26e841bcf1aeb894(`performHttpFetch error while fetching ${path}. ${originalErrorMessage}`, {
            errorCode: 'performHttpFetchError',
            statusCode: statusCode
        });
    }
};
const $43e5bdc11d95b8bf$var$processHttpErrorResponse = async ({ response: response })=>{
    throw new $43e5bdc11d95b8bf$var$HttpApiError(`[Code ${response.status}] ${await response.text()}`, {
        statusCode: response.status,
        traceId: $43e5bdc11d95b8bf$export$9f229e40eb65abfc(response)
    });
};
module.exports["getTraceIdFromResponse"] = $43e5bdc11d95b8bf$export$9f229e40eb65abfc;
module.exports["FetchError"] = $43e5bdc11d95b8bf$export$26e841bcf1aeb894;
module.exports["performHttpFetch"] = $43e5bdc11d95b8bf$export$a38d93aa782475f6;

});

parcelRegister("35fh0", function(module, exports) {
const $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc = ()=>{
    let product = 'UNKNOWN';
    if (window && window.__ROVO_CHAT_CONFIG_PRODUCT__) product = window.__ROVO_CHAT_CONFIG_PRODUCT__;
    return product;
};
module.exports["getRovoChatProduct"] = $a3e3dc6fd5fb1937$export$d4fdfa93c283ffc;

});

parcelRegister("ldpU6", function(module, exports) {
const $62424571d4d73005$var$pathnamePrefixes = [
    '/jira/',
    '/wiki/',
    '/browse/'
];
const $62424571d4d73005$var$ATLAS_HOST = 'home.atlassian.com';
const $62424571d4d73005$var$ATLAS_TEAM_HOST = 'team.atlassian.com';
const $62424571d4d73005$var$UUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const $62424571d4d73005$export$d57ae76c6dc57a5 = (url)=>{
    try {
        let parsedUrl = new URL(url);
        let normalizedPath = '/any/';
        if (parsedUrl.host === $62424571d4d73005$var$ATLAS_HOST || parsedUrl.host === $62424571d4d73005$var$ATLAS_TEAM_HOST) // Replace org ID with "orgId" in the path
        normalizedPath = parsedUrl.pathname.replace(/\/o\/[^/]+/, '/o/orgId');
        const prefixRegex = new RegExp(`^(${$62424571d4d73005$var$pathnamePrefixes.join('|')})`);
        if (prefixRegex.test(parsedUrl.pathname)) normalizedPath = parsedUrl.pathname.match(prefixRegex)[0];
        const normalizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${normalizedPath}`;
        return normalizedUrl;
    } catch (error) {
        return 'https://could-not-parse.example.com';
    }
};
const $62424571d4d73005$export$5efaf8444170fe75 = (str)=>{
    if (!str) return {
        normalized: '',
        matchedUUIDs: []
    };
    const matchedUUIDs = str.match($62424571d4d73005$var$UUID_REGEX) || [];
    const normalized = str.replace($62424571d4d73005$var$UUID_REGEX, '{uuid}');
    return {
        normalized: normalized,
        matchedUUIDs: matchedUUIDs
    };
};
module.exports["normaliseUrl"] = $62424571d4d73005$export$d57ae76c6dc57a5;
module.exports["normalizeUUID"] = $62424571d4d73005$export$5efaf8444170fe75;

});

parcelRegister("6jYyB", function(module, exports) {

let $49a37dcba4f239e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $49a37dcba4f239e3$var$load("h3ABO"),
    $49a37dcba4f239e3$var$load("kC80R")
]).then(()=>parcelRequire('7hGsm'));

});

parcelRegister("kIvLT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6v6KC = parcelRequire("6v6KC");

var $inPa6 = parcelRequire("inPa6");


var $fYQcF = parcelRequire("fYQcF");


var $1yaYZ = parcelRequire("1yaYZ");


var $TwPkE = parcelRequire("TwPkE");


var $jA9SA = parcelRequire("jA9SA");


var $bQGO7 = parcelRequire("bQGO7");


var $lUZCl = parcelRequire("lUZCl");

const $6e0837af2bd4bfd5$var$isTownSquareEvent = ()=>[
        'home.atlassian.com',
        'team.atlassian.com'
    ].some((host)=>window.location?.host?.includes(host));
const $6e0837af2bd4bfd5$var$DEFAULT_TAGS = [
    'atlaskit',
    'aiMate'
];
const $6e0837af2bd4bfd5$export$e955abb82869dc84 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { propertiesRef: propertiesRef, mode: mode } = (0, $TwPkE.useAnalyticsPropertiesContext)();
    // TODO: Improve this functionality, potentially with a higher order provider for tags or similar
    // This is a temporary solution to add the 'townsquare' tag to operational events so Experience Tracker works in Atlas
    const maybeAtlasOperationalTags = (0, $42omo.useCallback)((inputPayload)=>{
        const payload = (0, $6v6KC.isUIAnalyticsEvent)(inputPayload) ? inputPayload.payload : inputPayload;
        if (payload.actionSubject === 'ui' && payload.eventType === 'operational' && $6e0837af2bd4bfd5$var$isTownSquareEvent()) return [
            'townsquare'
        ];
        return [];
    }, []);
    const tagsForAIAnalytics = [
        ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
    ];
    if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tagsForAIAnalytics.push('townsquare');
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIInteractionDismiss: trackAIInteractionDismiss, trackAIResultAction: trackAIResultAction, trackAIFeedbackSubmit: trackAIFeedbackSubmit } = (0, $fYQcF.useAIEventsInstrumentation)({
        // Required configruation
        product: propertiesRef.current.product,
        subproduct: propertiesRef.current.product,
        aiFeatureName: 'aiChat',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1,
        enablePlatformEvents: true,
        tags: tagsForAIAnalytics,
        customAnalyticsFire: (rawEvent, _createdEvent)=>{
            // Build event and apply context attributes
            const event = createAnalyticsEvent(rawEvent);
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            // Fire
            event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            }).fire((0, $bQGO7.ANALYTICS_CHANNEL));
        }
    });
    const getDefaultAttributes = (0, $42omo.useCallback)(()=>{
        const { agentCreatorType: agentCreatorType, agentId: agentId, agentVisibility: agentVisibility, agentExternalConfigReference: agentExternalConfigReference, agentActions: agentActions, agentIsDefault: agentIsDefault, agentIsVerified: agentIsVerified, conversationChannelId: conversationChannelId, experienceId: experienceId, fullScreen: fullScreen, product: product, productHeader: productHeader, mode: mode, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias } = propertiesRef.current;
        return {
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentCreatorType]: agentCreatorType,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentId]: agentId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentVisibility]: agentVisibility,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).conversationChannelId]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).experienceId]: experienceId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).fullScreen]: fullScreen,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).product]: product,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).productHeader]: productHeader,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).singleInstrumentationID]: conversationChannelId,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentExternalConfigReference]: agentExternalConfigReference,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentActions]: agentActions,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsDefault]: agentIsDefault,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).agentIsVerified]: agentIsVerified,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).mode]: mode,
            [(0, $jA9SA.AI_MATE_ATTRIBUTES).assistanceServiceConfigMinionAlias]: assistanceServiceConfigMinionAlias
        };
    }, [
        propertiesRef
    ]);
    const trackAIMAUEvent = (0, $42omo.useCallback)((payload)=>{
        // Handle tags
        const tags = [
            ...$6e0837af2bd4bfd5$var$DEFAULT_TAGS
        ];
        if ($6e0837af2bd4bfd5$var$isTownSquareEvent()) tags.push('townsquare');
        const { source: source, subjectId: subjectId, proactive: proactive, userGenerated: userGenerated, messageId: messageId, messageActions: messageActions, singleInstrumentationID: singleInstrumentationID, deepResearchEnabled: deepResearchEnabled, webSearchEnabled: webSearchEnabled, thinkDeeperEnabled: thinkDeeperEnabled, fastModeEnabled: fastModeEnabled, timestamp: timestamp, citedProductList: citedProductList, citedProduct: citedProduct, sourceProducts: sourceProducts, sourceProduct: sourceProduct, pluginsInvoked: pluginsInvoked, skillsInvoked: skillsInvoked, executedStratusSkill: executedStratusSkill, responseSources: responseSources, usesJsm: usesJsm, invokedFrom: invokedFrom, conversationChannelId: conversationChannelId, assistanceServiceConfigMinionAlias: assistanceServiceConfigMinionAlias, scenarioId: scenarioId, pageContext: pageContext, attributes: customAttributes } = payload;
        let attributes = {
            ...getDefaultAttributes(),
            isAIFeature: 1,
            proactiveAIGenerated: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0,
            aiFeatureName: 'aiChat',
            citedProductList: citedProductList,
            citedProduct: citedProduct,
            sourceProducts: sourceProducts,
            sourceProduct: sourceProduct,
            ...customAttributes
        };
        if (messageId) attributes.messageId = messageId;
        if (messageActions) attributes.messageActions = messageActions;
        if (invokedFrom) attributes.invokedFrom = invokedFrom;
        if (timestamp) attributes.timestamp = timestamp;
        if (singleInstrumentationID) attributes.singleInstrumentationID = singleInstrumentationID;
        if (pluginsInvoked) attributes.pluginsInvoked = pluginsInvoked;
        if (skillsInvoked) attributes.skillsInvoked = skillsInvoked;
        if (executedStratusSkill !== undefined) attributes.executedStratusSkill = executedStratusSkill;
        if (responseSources) attributes.responseSources = responseSources;
        if (usesJsm !== undefined) attributes.usesJsm = usesJsm;
        if (deepResearchEnabled) attributes.deepResearchEnabled = deepResearchEnabled;
        if (fastModeEnabled) attributes.fastModeEnabled = fastModeEnabled;
        if (thinkDeeperEnabled) attributes.thinkDeeperEnabled = thinkDeeperEnabled;
        if (webSearchEnabled) attributes.webSearchEnabled = webSearchEnabled;
        if (conversationChannelId) attributes.conversationChannelId = conversationChannelId;
        if (assistanceServiceConfigMinionAlias) attributes.assistanceServiceConfigMinionAlias = assistanceServiceConfigMinionAlias;
        if (pageContext) attributes.pageContext = pageContext;
        if (scenarioId) attributes.scenarioId = scenarioId;
        let libAttributes = {
            ...attributes,
            aiFeatureName: 'aiChat',
            proactiveGeneratedAI: proactive ? 1 : 0,
            userGeneratedAI: userGenerated ? 1 : 0
        };
        switch(payload.type){
            case 'initiated':
                trackAIInteractionInit({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'viewed':
                trackAIResultView({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'error':
                trackAIResultError({
                    aiErrorMessage: payload.errorMessage
                }, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'dismissed':
                trackAIInteractionDismiss({
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'actioned':
                trackAIResultAction(payload.actionResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
            case 'feedback':
                trackAIFeedbackSubmit(payload.feedbackResult, {
                    attributes: libAttributes,
                    tags: tags,
                    source: source,
                    actionSubjectId: subjectId
                });
                break;
        }
    // Handle specific AI MAU events
    }, [
        getDefaultAttributes,
        trackAIInteractionInit,
        trackAIResultView,
        trackAIResultError,
        trackAIInteractionDismiss,
        trackAIResultAction,
        trackAIFeedbackSubmit
    ]);
    const sendAnalyticsEvent = (0, $42omo.useCallback)((payload, options)=>{
        const extraTags = options?.removeDefaultTags ? [] : $6e0837af2bd4bfd5$var$DEFAULT_TAGS;
        const allTags = Array.from(new Set([
            ...extraTags,
            ...payload.tags || [],
            ...maybeAtlasOperationalTags(payload)
        ]));
        const defaultAttributes = getDefaultAttributes();
        let eventToBeLoggedWithSentry;
        if ((0, $6v6KC.isUIAnalyticsEvent)(payload)) {
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(payload.context);
            const updatedEvent = payload.update({
                ...payload.payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        } else {
            const event = createAnalyticsEvent({
                ...payload,
                tags: allTags,
                attributes: {
                    ...defaultAttributes,
                    ...payload.attributes
                }
            });
            const aiMateContextAttributes = (0, $lUZCl.getAttributesFromContexts)(event.context);
            const updatedEvent = event.update({
                attributes: {
                    ...event.payload.attributes,
                    ...aiMateContextAttributes
                }
            });
            updatedEvent.fire((0, $bQGO7.ANALYTICS_CHANNEL));
            eventToBeLoggedWithSentry = updatedEvent;
        }
        if (eventToBeLoggedWithSentry && eventToBeLoggedWithSentry.payload?.eventType !== 'operational') // choosing to log the event with Sentry if it is not an operational event to prevent noise in Sentry and not eat up the Sentry quota
        (0, $1yaYZ.addSentryBreadcrumb)(`sendAnalyticsEvent event: ${JSON.stringify(eventToBeLoggedWithSentry)}`);
    }, [
        createAnalyticsEvent,
        maybeAtlasOperationalTags,
        getDefaultAttributes
    ]);
    return {
        sendAnalyticsEvent: sendAnalyticsEvent,
        trackAIMAUEvent: trackAIMAUEvent,
        mode: mode
    };
};
module.exports["useAnalytics"] = $6e0837af2bd4bfd5$export$e955abb82869dc84;

});

parcelRegister("fYQcF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dWJ5i = parcelRequire("dWJ5i");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $ifW2H = parcelRequire("ifW2H");


var $8Y3mE = parcelRequire("8Y3mE");


var $1M9Av = parcelRequire("1M9Av");


var $ea2ui = parcelRequire("ea2ui");


var $j4EkW = parcelRequire("j4EkW");

const $a22fd04a8888d493$export$ddf49ad062368ad2 = (customConfig)=>{
    let context = (0, $42omo.useContext)((0, $ifW2H.AIEventsInstrumentationContext));
    const aiEventAttributesOverride = (0, $42omo.useRef)({});
    if (customConfig) context = {
        config: {
            ...(0, $8Y3mE.defaultAIEventsInstrumentationConfigValues),
            ...customConfig
        },
        // eslint-disable-next-line react-hooks/rules-of-hooks
        ...(0, $j4EkW.useAIInstrumentationSetup)(customConfig.singleInstrumentationID, customConfig.cookieSingleInstrumentationConfig)
    };
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    if (context === null) throw new Error('useAIEventsInstrumentation must be used within a AIEventsInstrumentationProvider');
    const { config: { source: source, aiExperienceName: aiExperienceName, aiFeatureName: aiFeatureName, proactiveGeneratedAI: proactiveGeneratedAI, userGeneratedAI: userGeneratedAI, isAIFeature: isAIFeature, channel: channel, subproduct: subproduct, actionSubjectId: actionSubjectId, tags: tags, product: product, eventDispatcherSource: eventDispatcherSource, skipAISessionValidation: skipAISessionValidation, customAnalyticsFire: customAnalyticsFire, additionalAttributes: additionalAttributes, useDefaultGASv3EventSchema: useDefaultGASv3EventSchema, enablePlatformEvents: enablePlatformEvents }, refreshSingleInstrumentationID: refreshSingleInstrumentationID, getSingleInstrumentationID: getSingleInstrumentationID, setAISessionState: setAISessionState, getAISessionState: getAISessionState } = context;
    const validateAndUpdateAISession = (0, $42omo.useCallback)((nextState)=>{
        const currentAISessionState = getAISessionState();
        return (0, $dWJ5i.match)({
            currentState: currentAISessionState,
            nextState: nextState,
            skipAISessionValidation: skipAISessionValidation
        }).with({
            skipAISessionValidation: true
        }, ()=>true).with({
            currentState: (0, $ea2ui.AISessionState).unset,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).viewed, (0, $ea2ui.AISessionState).error, (0, $ea2ui.AISessionState).dismissed)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIInteractionInit()`);
            return false;
        }).with({
            currentState: (0, $ea2ui.AISessionState).initiated,
            nextState: (0, $dWJ5i.P).union((0, $ea2ui.AISessionState).submitted, (0, $ea2ui.AISessionState).actioned, (0, $ea2ui.AISessionState).discarded)
        }, ()=>{
            // eslint-disable-next-line no-console
            console.error(`[@atlassian/ai-analytics]: ${nextState} event should be called only after trackAIResultView()`);
            return false;
        }).otherwise(()=>{
            setAISessionState(nextState);
            return true;
        });
    }, [
        setAISessionState,
        getAISessionState,
        skipAISessionValidation
    ]);
    const fireEventWithOptionalChannel = (0, $42omo.useCallback)((event)=>{
        if (typeof customAnalyticsFire === 'function') {
            customAnalyticsFire(event, createAnalyticsEvent({}));
            return;
        }
        if (enablePlatformEvents) {
            // it goes thru the aiMate analytics listener to avoid validation per prodcut listener
            // https://bitbucket.org/atlassian/atlassian-frontend-mirror/src/f904f690cf57ef84acad6c7bf1b5bd90ad9cada2/analytics/analytics-listeners/src/atlaskit/process-event.ts#lines-58
            createAnalyticsEvent(event).fire((0, $3pfAb.FabricChannel).aiMate);
            return;
        }
        if (channel) {
            createAnalyticsEvent(event).fire(channel);
            return;
        }
        createAnalyticsEvent(event).fire();
    }, [
        channel,
        customAnalyticsFire,
        createAnalyticsEvent,
        enablePlatformEvents
    ]);
    const createAndMergeEventPayload = (0, $42omo.useCallback)((payload, partialPayload)=>{
        const singleInstrumentationID = getSingleInstrumentationID();
        const eventPayload = {
            action: payload.action,
            actionSubject: payload.actionSubject,
            actionSubjectId: partialPayload?.actionSubjectId ?? actionSubjectId,
            attributes: {
                aiExperienceName: aiExperienceName,
                aiFeatureName: aiFeatureName,
                proactiveGeneratedAI: proactiveGeneratedAI,
                userGeneratedAI: userGeneratedAI,
                isAIFeature: isAIFeature,
                eventDispatcherSource: eventDispatcherSource,
                singleInstrumentationID: singleInstrumentationID,
                ...payload.attributes,
                ...partialPayload?.attributes,
                ...additionalAttributes,
                ...aiEventAttributesOverride.current
            }
        };
        return (0, $dWJ5i.match)({
            product: product,
            channel: channel,
            useDefaultGASv3EventSchema: useDefaultGASv3EventSchema,
            enablePlatformEvents: enablePlatformEvents
        }).with({
            enablePlatformEvents: true
        }, ()=>{
            return {
                eventType: 'track',
                ...eventPayload,
                tags: (0, $1M9Av.getTagsWithPlatformTag)(tags),
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        }).with({
            product: 'confluence',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // confluence event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/confluence/next/packages/analytics/src/analyticsListener.tsx#lines-53
            return {
                type: 'sendTrackEvent',
                data: {
                    ...eventPayload,
                    tags: partialPayload?.tags ?? tags,
                    source: partialPayload?.source ?? source,
                    subproduct: subproduct
                }
            };
        }).with({
            product: 'jira',
            channel: (0, $dWJ5i.P).nullish,
            useDefaultGASv3EventSchema: false
        }, ()=>{
            // jira event validation fronted logic
            // https://bitbucket.org/atlassian/atlassian-frontend-monorepo/src/f8bf8ba8c7b54c6e2764d85551b3f989b69d28d8/jira/src/packages/platform/observability/product-analytics-bridge/src/utils/extract-data-from-event.tsx#lines-164
            // it requires to use no more than 4 properties on the top level of event shape for custom event fire.
            return eventPayload;
        }).otherwise(()=>{
            // for any other product type we should use the default event shape
            // also if there is a custom event channel, we also should use the default event shape
            return {
                eventType: 'track',
                ...eventPayload,
                tags: partialPayload?.tags ?? tags,
                source: partialPayload?.source ?? source,
                subproduct: subproduct,
                product: product
            };
        });
    }, [
        subproduct,
        channel,
        product,
        getSingleInstrumentationID,
        useDefaultGASv3EventSchema,
        source,
        tags,
        eventDispatcherSource,
        actionSubjectId,
        additionalAttributes,
        enablePlatformEvents,
        aiExperienceName,
        aiFeatureName,
        proactiveGeneratedAI,
        userGeneratedAI,
        isAIFeature
    ]);
    const trackAIInteractionInit = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).initiated)) return;
        refreshSingleInstrumentationID(payload?.attributes?.singleInstrumentationID);
        const event = createAndMergeEventPayload({
            action: 'initiated',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        refreshSingleInstrumentationID,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel,
        validateAndUpdateAISession
    ]);
    const trackAIResultView = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).viewed)) return;
        const { doesNotMeetMAUCriteria: doesNotMeetMAUCriteria, attributes: attributes, ...payloadRest } = payload || {};
        const event = createAndMergeEventPayload({
            action: 'viewed',
            actionSubject: 'aiResult'
        }, {
            ...payloadRest,
            attributes: {
                ...attributes,
                doesNotMeetMAUCriteria: !!doesNotMeetMAUCriteria
            }
        });
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultError = (0, $42omo.useCallback)((error, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).error)) return;
        const event = createAndMergeEventPayload({
            action: 'error',
            actionSubject: 'aiResult',
            attributes: {
                ...error
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIInteractionDismiss = (0, $42omo.useCallback)((payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).dismissed)) return;
        const event = createAndMergeEventPayload({
            action: 'dismissed',
            actionSubject: 'aiInteraction'
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultAction = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).actioned)) return;
        const event = createAndMergeEventPayload({
            action: 'actioned',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIResultDiscarded = (0, $42omo.useCallback)((aiResultAction, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).discarded)) return;
        const event = createAndMergeEventPayload({
            action: 'discarded',
            actionSubject: 'aiResult',
            attributes: {
                aiResultAction: aiResultAction
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const trackAIFeedbackSubmit = (0, $42omo.useCallback)((aiFeedbackResult, payload)=>{
        if (!validateAndUpdateAISession((0, $ea2ui.AISessionState).submitted)) return;
        const event = createAndMergeEventPayload({
            action: 'submitted',
            actionSubject: 'aiFeedback',
            attributes: {
                aiFeedbackResult: aiFeedbackResult
            }
        }, payload);
        fireEventWithOptionalChannel(event);
    }, [
        validateAndUpdateAISession,
        createAndMergeEventPayload,
        fireEventWithOptionalChannel
    ]);
    const updateAIAttributes = (0, $42omo.useCallback)((newAttributes)=>{
        aiEventAttributesOverride.current = {
            ...aiEventAttributesOverride.current,
            ...newAttributes
        };
    }, []);
    return {
        updateAIAttributes: updateAIAttributes,
        trackAIInteractionInit: trackAIInteractionInit,
        trackAIResultView: trackAIResultView,
        trackAIResultError: trackAIResultError,
        trackAIResultDiscarded: trackAIResultDiscarded,
        trackAIInteractionDismiss: trackAIInteractionDismiss,
        trackAIResultAction: trackAIResultAction,
        trackAIFeedbackSubmit: trackAIFeedbackSubmit,
        refreshSingleInstrumentationID: refreshSingleInstrumentationID
    };
};
module.exports["useAIEventsInstrumentation"] = $a22fd04a8888d493$export$ddf49ad062368ad2;

});

parcelRegister("dWJ5i", function(module, exports) {
const $a273a9fd41301c8f$var$t = Symbol.for("@ts-pattern/matcher"), $a273a9fd41301c8f$var$e = Symbol.for("@ts-pattern/isVariadic"), $a273a9fd41301c8f$var$n = "@ts-pattern/anonymous-select-key", $a273a9fd41301c8f$var$r = (t)=>Boolean(t && "object" == typeof t), $a273a9fd41301c8f$var$i = (e)=>e && !!e[$a273a9fd41301c8f$var$t], $a273a9fd41301c8f$var$o = (n, s, c)=>{
    if ($a273a9fd41301c8f$var$i(n)) {
        const e = n[$a273a9fd41301c8f$var$t](), { matched: r, selections: i } = e.match(s);
        return r && i && Object.keys(i).forEach((t)=>c(t, i[t])), r;
    }
    if ($a273a9fd41301c8f$var$r(n)) {
        if (!$a273a9fd41301c8f$var$r(s)) return !1;
        if (Array.isArray(n)) {
            if (!Array.isArray(s)) return !1;
            let t = [], r = [], a = [];
            for (const o of n.keys()){
                const s = n[o];
                $a273a9fd41301c8f$var$i(s) && s[$a273a9fd41301c8f$var$e] ? a.push(s) : a.length ? r.push(s) : t.push(s);
            }
            if (a.length) {
                if (a.length > 1) throw new Error("Pattern error: Using `...P.array(...)` several times in a single pattern is not allowed.");
                if (s.length < t.length + r.length) return !1;
                const e = s.slice(0, t.length), n = 0 === r.length ? [] : s.slice(-r.length), i = s.slice(t.length, 0 === r.length ? Infinity : -r.length);
                return t.every((t, n)=>$a273a9fd41301c8f$var$o(t, e[n], c)) && r.every((t, e)=>$a273a9fd41301c8f$var$o(t, n[e], c)) && (0 === a.length || $a273a9fd41301c8f$var$o(a[0], i, c));
            }
            return n.length === s.length && n.every((t, e)=>$a273a9fd41301c8f$var$o(t, s[e], c));
        }
        return Reflect.ownKeys(n).every((e)=>{
            const r = n[e];
            var a;
            return (e in s || $a273a9fd41301c8f$var$i(a = r) && "optional" === a[$a273a9fd41301c8f$var$t]().matcherType) && $a273a9fd41301c8f$var$o(r, s[e], c);
        });
    }
    return Object.is(s, n);
}, $a273a9fd41301c8f$var$s = (e)=>{
    var n, o, a;
    return $a273a9fd41301c8f$var$r(e) ? $a273a9fd41301c8f$var$i(e) ? null != (n = null == (o = (a = e[$a273a9fd41301c8f$var$t]()).getSelectionKeys) ? void 0 : o.call(a)) ? n : [] : Array.isArray(e) ? $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s) : $a273a9fd41301c8f$var$c(Object.values(e), $a273a9fd41301c8f$var$s) : [];
}, $a273a9fd41301c8f$var$c = (t, e)=>t.reduce((t, n)=>t.concat(e(n)), []);
function $a273a9fd41301c8f$export$ce1e7a33533a73d9(...t) {
    if (1 === t.length) {
        const [e] = t;
        return (t)=>$a273a9fd41301c8f$var$o(e, t, ()=>{});
    }
    if (2 === t.length) {
        const [e, n] = t;
        return $a273a9fd41301c8f$var$o(e, n, ()=>{});
    }
    throw new Error(`isMatching wasn't given the right number of arguments: expected 1 or 2, received ${t.length}.`);
}
function $a273a9fd41301c8f$var$u(t) {
    return Object.assign(t, {
        optional: ()=>$a273a9fd41301c8f$var$l(t),
        and: (e)=>$a273a9fd41301c8f$var$m(t, e),
        or: (e)=>$a273a9fd41301c8f$var$d(t, e),
        select: (e)=>void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t)
    });
}
function $a273a9fd41301c8f$var$h(t) {
    return Object.assign(((t)=>Object.assign(t, {
            [Symbol.iterator] () {
                let n = 0;
                const r = [
                    {
                        value: Object.assign(t, {
                            [$a273a9fd41301c8f$var$e]: !0
                        }),
                        done: !1
                    },
                    {
                        done: !0,
                        value: void 0
                    }
                ];
                return {
                    next: ()=>{
                        var t;
                        return null != (t = r[n++]) ? t : r.at(-1);
                    }
                };
            }
        }))(t), {
        optional: ()=>$a273a9fd41301c8f$var$h($a273a9fd41301c8f$var$l(t)),
        select: (e)=>$a273a9fd41301c8f$var$h(void 0 === e ? $a273a9fd41301c8f$var$y(t) : $a273a9fd41301c8f$var$y(e, t))
    });
}
function $a273a9fd41301c8f$var$l(e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return void 0 === t ? ($a273a9fd41301c8f$var$s(e).forEach((t)=>r(t, void 0)), {
                        matched: !0,
                        selections: n
                    }) : {
                        matched: $a273a9fd41301c8f$var$o(e, t, r),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$s(e),
                matcherType: "optional"
            })
    });
}
const $a273a9fd41301c8f$var$f = (t, e)=>{
    for (const n of t)if (!e(n)) return !1;
    return !0;
}, $a273a9fd41301c8f$var$g = (t, e)=>{
    for (const [n, r] of t.entries())if (!e(r, n)) return !1;
    return !0;
};
function $a273a9fd41301c8f$var$m(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return {
                        matched: e.every((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "and"
            })
    });
}
function $a273a9fd41301c8f$var$d(...e) {
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let n = {};
                    const r = (t, e)=>{
                        n[t] = e;
                    };
                    return $a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s).forEach((t)=>r(t, void 0)), {
                        matched: e.some((e)=>$a273a9fd41301c8f$var$o(e, t, r)),
                        selections: n
                    };
                },
                getSelectionKeys: ()=>$a273a9fd41301c8f$var$c(e, $a273a9fd41301c8f$var$s),
                matcherType: "or"
            })
    });
}
function $a273a9fd41301c8f$var$p(e) {
    return {
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>({
                        matched: Boolean(e(t))
                    })
            })
    };
}
function $a273a9fd41301c8f$var$y(...e) {
    const r = "string" == typeof e[0] ? e[0] : void 0, i = 2 === e.length ? e[1] : "string" == typeof e[0] ? void 0 : e[0];
    return $a273a9fd41301c8f$var$u({
        [$a273a9fd41301c8f$var$t]: ()=>({
                match: (t)=>{
                    let e = {
                        [null != r ? r : $a273a9fd41301c8f$var$n]: t
                    };
                    return {
                        matched: void 0 === i || $a273a9fd41301c8f$var$o(i, t, (t, n)=>{
                            e[t] = n;
                        }),
                        selections: e
                    };
                },
                getSelectionKeys: ()=>[
                        null != r ? r : $a273a9fd41301c8f$var$n
                    ].concat(void 0 === i ? [] : $a273a9fd41301c8f$var$s(i))
            })
    });
}
function $a273a9fd41301c8f$var$v(t) {
    return "number" == typeof t;
}
function $a273a9fd41301c8f$var$b(t) {
    return "string" == typeof t;
}
function $a273a9fd41301c8f$var$w(t) {
    return "bigint" == typeof t;
}
const $a273a9fd41301c8f$var$S = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return !0;
})), $a273a9fd41301c8f$var$O = $a273a9fd41301c8f$var$S, $a273a9fd41301c8f$var$j = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        startsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.startsWith(n)))));
        },
        endsWith: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.endsWith(n)))));
        },
        minLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length >= t))(e))),
        length: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length === t))(e))),
        maxLength: (e)=>$a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$b(e) && e.length <= t))(e))),
        includes: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && t.includes(n)))));
        },
        regex: (e)=>{
            var n;
            return $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$m(t, (n = e, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$b(t) && Boolean(t.match(n))))));
        }
    }), $a273a9fd41301c8f$var$K = $a273a9fd41301c8f$var$j($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$b)), $a273a9fd41301c8f$var$x = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$v(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$v(e) && e >= t))(e))),
        int: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isInteger(t)))),
        finite: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && Number.isFinite(t)))),
        positive: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$v(t) && t < 0)))
    }), $a273a9fd41301c8f$var$E = $a273a9fd41301c8f$var$x($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$v)), $a273a9fd41301c8f$var$A = (t)=>Object.assign($a273a9fd41301c8f$var$u(t), {
        between: (e, n)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t, e)=>$a273a9fd41301c8f$var$p((n)=>$a273a9fd41301c8f$var$w(n) && t <= n && e >= n))(e, n))),
        lt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e < t))(e))),
        gt: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e > t))(e))),
        lte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e <= t))(e))),
        gte: (e)=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, ((t)=>$a273a9fd41301c8f$var$p((e)=>$a273a9fd41301c8f$var$w(e) && e >= t))(e))),
        positive: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t > 0))),
        negative: ()=>$a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$m(t, $a273a9fd41301c8f$var$p((t)=>$a273a9fd41301c8f$var$w(t) && t < 0)))
    }), $a273a9fd41301c8f$var$P = $a273a9fd41301c8f$var$A($a273a9fd41301c8f$var$p($a273a9fd41301c8f$var$w)), $a273a9fd41301c8f$var$T = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "boolean" == typeof t;
})), $a273a9fd41301c8f$var$B = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return "symbol" == typeof t;
})), $a273a9fd41301c8f$var$_ = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null == t;
})), $a273a9fd41301c8f$var$k = $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
    return null != t;
}));
var $a273a9fd41301c8f$export$56c0d5a1e737357d = {
    __proto__: null,
    matcher: $a273a9fd41301c8f$var$t,
    optional: $a273a9fd41301c8f$var$l,
    array: function(...e) {
        return $a273a9fd41301c8f$var$h({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!Array.isArray(t)) return {
                            matched: !1
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const n = e[0];
                        let r = {};
                        if (0 === t.length) return $a273a9fd41301c8f$var$s(n).forEach((t)=>{
                            r[t] = [];
                        }), {
                            matched: !0,
                            selections: r
                        };
                        const i = (t, e)=>{
                            r[t] = (r[t] || []).concat([
                                e
                            ]);
                        };
                        return {
                            matched: t.every((t)=>$a273a9fd41301c8f$var$o(n, t, i)),
                            selections: r
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    set: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Set)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        }, i = e[0];
                        return {
                            matched: $a273a9fd41301c8f$var$f(t, (t)=>$a273a9fd41301c8f$var$o(i, t, r)),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : $a273a9fd41301c8f$var$s(e[0])
                })
        });
    },
    map: function(...e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>{
                        if (!(t instanceof Map)) return {
                            matched: !1
                        };
                        let n = {};
                        if (0 === t.size) return {
                            matched: !0,
                            selections: n
                        };
                        const r = (t, e)=>{
                            n[t] = (n[t] || []).concat([
                                e
                            ]);
                        };
                        if (0 === e.length) return {
                            matched: !0
                        };
                        var i;
                        if (1 === e.length) throw new Error(`\`P.map\` wasn't given enough arguments. Expected (key, value), received ${null == (i = e[0]) ? void 0 : i.toString()}`);
                        const [s, c] = e;
                        return {
                            matched: $a273a9fd41301c8f$var$g(t, (t, e)=>{
                                const n = $a273a9fd41301c8f$var$o(s, e, r), i = $a273a9fd41301c8f$var$o(c, t, r);
                                return n && i;
                            }),
                            selections: n
                        };
                    },
                    getSelectionKeys: ()=>0 === e.length ? [] : [
                            ...$a273a9fd41301c8f$var$s(e[0]),
                            ...$a273a9fd41301c8f$var$s(e[1])
                        ]
                })
        });
    },
    intersection: $a273a9fd41301c8f$var$m,
    union: $a273a9fd41301c8f$var$d,
    not: function(e) {
        return $a273a9fd41301c8f$var$u({
            [$a273a9fd41301c8f$var$t]: ()=>({
                    match: (t)=>({
                            matched: !$a273a9fd41301c8f$var$o(e, t, ()=>{})
                        }),
                    getSelectionKeys: ()=>[],
                    matcherType: "not"
                })
        });
    },
    when: $a273a9fd41301c8f$var$p,
    select: $a273a9fd41301c8f$var$y,
    any: $a273a9fd41301c8f$var$S,
    _: $a273a9fd41301c8f$var$O,
    string: $a273a9fd41301c8f$var$K,
    number: $a273a9fd41301c8f$var$E,
    bigint: $a273a9fd41301c8f$var$P,
    boolean: $a273a9fd41301c8f$var$T,
    symbol: $a273a9fd41301c8f$var$B,
    nullish: $a273a9fd41301c8f$var$_,
    nonNullable: $a273a9fd41301c8f$var$k,
    instanceOf: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p(function(t) {
            return (e)=>e instanceof t;
        }(t)));
    },
    shape: function(t) {
        return $a273a9fd41301c8f$var$u($a273a9fd41301c8f$var$p($a273a9fd41301c8f$export$ce1e7a33533a73d9(t)));
    }
};
class $a273a9fd41301c8f$export$6c1467edb54d3773 extends Error {
    constructor(t){
        let e;
        try {
            e = JSON.stringify(t);
        } catch (n) {
            e = t;
        }
        super(`Pattern matching error: no pattern matches value ${e}`), this.input = void 0, this.input = t;
    }
}
const $a273a9fd41301c8f$var$$ = {
    matched: !1,
    value: void 0
};
function $a273a9fd41301c8f$export$4659b591c19bdf3d(t) {
    return new $a273a9fd41301c8f$var$I(t, $a273a9fd41301c8f$var$$);
}
class $a273a9fd41301c8f$var$I {
    with(...t) {
        if (this.state.matched) return this;
        const e = t[t.length - 1], r = [
            t[0]
        ];
        let i;
        3 === t.length && "function" == typeof t[1] ? i = t[1] : t.length > 2 && r.push(...t.slice(1, t.length - 1));
        let s = !1, c = {};
        const a = (t, e)=>{
            s = !0, c[t] = e;
        }, u = !r.some((t)=>$a273a9fd41301c8f$var$o(t, this.input, a)) || i && !Boolean(i(this.input)) ? $a273a9fd41301c8f$var$$ : {
            matched: !0,
            value: e(s ? $a273a9fd41301c8f$var$n in c ? c[$a273a9fd41301c8f$var$n] : c : this.input, this.input)
        };
        return new $a273a9fd41301c8f$var$I(this.input, u);
    }
    when(t, e) {
        if (this.state.matched) return this;
        const n = Boolean(t(this.input));
        return new $a273a9fd41301c8f$var$I(this.input, n ? {
            matched: !0,
            value: e(this.input, this.input)
        } : $a273a9fd41301c8f$var$$);
    }
    otherwise(t) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    exhaustive(t = $a273a9fd41301c8f$var$L) {
        return this.state.matched ? this.state.value : t(this.input);
    }
    run() {
        return this.exhaustive();
    }
    returnType() {
        return this;
    }
    narrow() {
        return this;
    }
    constructor(t, e){
        this.input = void 0, this.state = void 0, this.input = t, this.state = e;
    }
}
function $a273a9fd41301c8f$var$L(t) {
    throw new $a273a9fd41301c8f$export$6c1467edb54d3773(t);
}
module.exports["P"] = $a273a9fd41301c8f$export$56c0d5a1e737357d;
module.exports["match"] = $a273a9fd41301c8f$export$4659b591c19bdf3d;

});

parcelRegister("ifW2H", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $62e0541727c97e34$export$4f059feb37b5835e = (0, $42omo.createContext)(null);
module.exports["AIEventsInstrumentationContext"] = $62e0541727c97e34$export$4f059feb37b5835e;

});

parcelRegister("8Y3mE", function(module, exports) {

var $ea2ui = parcelRequire("ea2ui");

const $a544c5804dc19870$export$5013b36eeed4ec19 = {
    isAIFeature: 1,
    actionSubjectId: 'client',
    eventDispatcherSource: (0, $ea2ui.EventDispatcherSources).JSLib,
    skipAISessionValidation: false,
    useDefaultGASv3EventSchema: false,
    enablePlatformEvents: false
};
module.exports["defaultAIEventsInstrumentationConfigValues"] = $a544c5804dc19870$export$5013b36eeed4ec19;

});

parcelRegister("ea2ui", function(module, exports) {
var $5a6bb3bf0e14987c$export$af92e0e920a45719 = /*#__PURE__*/ function(AISessionState) {
    AISessionState["unset"] = "[AIInteraction]:UNSET";
    AISessionState["initiated"] = "[AIInteraction]:INITIATED";
    AISessionState["viewed"] = "[AIInteraction]:VIEWED";
    AISessionState["error"] = "[AIInteraction]:ERROR";
    AISessionState["dismissed"] = "[AIInteraction]:DISMISSED";
    AISessionState["actioned"] = "[AIInteraction]:ACTIONED";
    AISessionState["discarded"] = "[AIInteraction]:DISCARDED";
    AISessionState["submitted"] = "[AIInteraction]:SUBMITTED";
    return AISessionState;
}({});
var $5a6bb3bf0e14987c$export$7052d5b66e36f60f = /*#__PURE__*/ function(EventDispatcherSources) {
    EventDispatcherSources["JSLib"] = "name:@atlassian/ai-analytics|language:javascript";
    return EventDispatcherSources;
}({});
module.exports["AISessionState"] = $5a6bb3bf0e14987c$export$af92e0e920a45719;
module.exports["EventDispatcherSources"] = $5a6bb3bf0e14987c$export$7052d5b66e36f60f;

});

parcelRegister("1M9Av", function(module, exports) {
const $699df07a7cf548d4$export$e053e424fcbfebe9 = (tags)=>{
    const defaultTags = [
        'atlaskit'
    ];
    if (!tags) return defaultTags;
    return defaultTags.concat(tags);
};
module.exports["getTagsWithPlatformTag"] = $699df07a7cf548d4$export$e053e424fcbfebe9;

});

parcelRegister("j4EkW", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $kTkuM = parcelRequire("kTkuM");


var $a4NM6 = parcelRequire("a4NM6");


var $ea2ui = parcelRequire("ea2ui");

const $a4ec83494ea42b83$export$259576f4e7ac6488 = (customSingleInstrumentationIDFromUserConfig, cookieSingleInstrumentationConfig)=>{
    const singleInstrumentationIDRef = (0, $42omo.useRef)(undefined);
    const aiSessionStateRef = (0, $42omo.useRef)((0, $ea2ui.AISessionState).unset);
    const setAISessionState = (0, $42omo.useCallback)((nextState)=>{
        aiSessionStateRef.current = nextState;
    }, []);
    const getAISessionState = (0, $42omo.useCallback)(()=>{
        return aiSessionStateRef.current;
    }, []);
    const refreshSingleInstrumentationID = (0, $42omo.useCallback)((customSingleInstrumentationIDFromEvent)=>{
        const nextSingleInstrumentationID = (0, $kTkuM.getNewSingleInstrumentationID)(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig);
        singleInstrumentationIDRef.current = nextSingleInstrumentationID;
        if (cookieSingleInstrumentationConfig) (0, $a4NM6.setSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName, nextSingleInstrumentationID);
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig
    ]);
    const getSingleInstrumentationID = (0, $42omo.useCallback)(()=>{
        // this handles a race condition when we have a new singleInstrumentationID from the user config
        // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
        // singleInstrumentationID at first step and then return a new one.
        if (customSingleInstrumentationIDFromUserConfig && customSingleInstrumentationIDFromUserConfig !== singleInstrumentationIDRef.current) {
            refreshSingleInstrumentationID();
            return singleInstrumentationIDRef.current;
        }
        if (cookieSingleInstrumentationConfig) return (0, $a4NM6.readSingleInstrumentationIDCookie)(cookieSingleInstrumentationConfig.uniqueCookieFeatureName);
        return singleInstrumentationIDRef.current;
    }, [
        customSingleInstrumentationIDFromUserConfig,
        cookieSingleInstrumentationConfig,
        refreshSingleInstrumentationID
    ]);
    return {
        refreshSingleInstrumentationID: refreshSingleInstrumentationID,
        getSingleInstrumentationID: getSingleInstrumentationID,
        setAISessionState: setAISessionState,
        getAISessionState: getAISessionState
    };
};
module.exports["useAIInstrumentationSetup"] = $a4ec83494ea42b83$export$259576f4e7ac6488;

});

parcelRegister("kTkuM", function(module, exports) {

var $dWJ5i = parcelRequire("dWJ5i");


var $cUcZ5 = parcelRequire("cUcZ5");

function $9779584a42635fbf$export$cee2a1482be61648(customSingleInstrumentationIDFromEvent, customSingleInstrumentationIDFromUserConfig) {
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. from cookie lib
    // 4. default behaviour generates through the crypto API
    return (0, $dWJ5i.match)({
        customSingleInstrumentationIDFromEvent: customSingleInstrumentationIDFromEvent,
        customSingleInstrumentationIDFromUserConfig: customSingleInstrumentationIDFromUserConfig
    }).with({
        customSingleInstrumentationIDFromEvent: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromEvent).with({
        customSingleInstrumentationIDFromUserConfig: (0, $dWJ5i.P).string
    }, (result)=>result.customSingleInstrumentationIDFromUserConfig)// we can't use the crypto API in the browser due to SSR issues?
    // https://atlassian.slack.com/archives/C051ARA9QGH/p1749587419868869
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    .otherwise(()=>(0, (/*@__PURE__*/$parcel$interopDefault($cUcZ5)))());
}
module.exports["getNewSingleInstrumentationID"] = $9779584a42635fbf$export$cee2a1482be61648;

});

parcelRegister("a4NM6", function(module, exports) {

var $hEbxW = parcelRequire("hEbxW");

var $eGd7K = parcelRequire("eGd7K");

const $2674cc9dba61bfc1$export$72d8c154d3f75075 = 'SINGLE_INSTRUMENTATION_ID_IS_NOT_SET';
const $2674cc9dba61bfc1$export$35ae1861d13fb6c8 = (uniqueCookieFeatureName)=>`AI_INSTRUMENTATION_FEATURE_ID_${uniqueCookieFeatureName}`;
const $2674cc9dba61bfc1$export$9a4eaf99327c19fe = (uniqueCookieFeatureName, nextSingleInstrumentationID)=>(0, $eGd7K.setCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName), nextSingleInstrumentationID, {
        expires: 7,
        domain: location.hostname,
        sameSite: 'strict'
    });
const $2674cc9dba61bfc1$export$d6fb1caea334c7c7 = (uniqueCookieFeatureName)=>(0, $hEbxW.getCookie)($2674cc9dba61bfc1$export$35ae1861d13fb6c8(uniqueCookieFeatureName)) || $2674cc9dba61bfc1$export$72d8c154d3f75075;
module.exports["setSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$9a4eaf99327c19fe;
module.exports["readSingleInstrumentationIDCookie"] = $2674cc9dba61bfc1$export$d6fb1caea334c7c7;

});

parcelRegister("TwPkE", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");

const $19e5e9ef880dfbce$var$initialState = {
    conversationChannelId: '',
    experienceId: '',
    product: '',
    productHeader: '',
    agentId: null,
    agentExternalConfigReference: null,
    agentActions: [],
    agentIsDefault: null,
    agentIsVerified: null,
    fullScreen: false,
    agentCreatorType: '',
    agentVisibility: '',
    singleInstrumentationID: '',
    mode: undefined
};
const $19e5e9ef880dfbce$var$AnalyticsPropertiesContext = /*#__PURE__*/ (0, $42omo.createContext)({
    propertiesRef: {
        current: {
            ...$19e5e9ef880dfbce$var$initialState
        }
    },
    mode: undefined,
    setAnalyticsPropertiesWithoutRerender: ()=>{}
});
const $19e5e9ef880dfbce$export$5ae3634fdb64882c = /*#__PURE__*/ (0, $42omo.createContext)({
    sharedFeaturesInstrumentationId: undefined,
    isInSmartCreateFlow: undefined
});
const $19e5e9ef880dfbce$export$1aefd27d2ed3c1c9 = ({ children: children, mode: mode })=>{
    const propertiesRef = (0, $42omo.useRef)({
        ...$19e5e9ef880dfbce$var$initialState
    });
    const setAnalyticsPropertiesWithoutRerender = (0, $42omo.useCallback)((properties)=>{
        propertiesRef.current = {
            ...propertiesRef.current,
            ...properties
        };
    }, []);
    const value = (0, $42omo.useMemo)(()=>({
            propertiesRef: propertiesRef,
            mode: mode,
            setAnalyticsPropertiesWithoutRerender: setAnalyticsPropertiesWithoutRerender
        }), [
        setAnalyticsPropertiesWithoutRerender,
        mode
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext.Provider, {
        value: value,
        children: children
    });
};
const $19e5e9ef880dfbce$export$a00cd3c213413389 = ({ source: source, sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId, children: children, mode: mode, isAlwaysInSmartCreateFlow: isAlwaysInSmartCreateFlow })=>{
    const { sharedFeaturesInstrumentationId: parentSharedFeaturesInstrumentationId, isInSmartCreateFlow: parentIsInSmartCreateFlow } = (0, $42omo.useContext)($19e5e9ef880dfbce$export$5ae3634fdb64882c);
    const isInSmartCreateFlow = isAlwaysInSmartCreateFlow === undefined ? parentIsInSmartCreateFlow : isAlwaysInSmartCreateFlow;
    const data = (0, $42omo.useMemo)(()=>({
            source: source,
            attributes: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            }
        }), [
        source,
        sharedFeaturesInstrumentationId,
        parentSharedFeaturesInstrumentationId,
        isInSmartCreateFlow
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: data,
        children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$5ae3634fdb64882c.Provider, {
            value: {
                sharedFeaturesInstrumentationId: sharedFeaturesInstrumentationId ?? parentSharedFeaturesInstrumentationId,
                isInSmartCreateFlow: isInSmartCreateFlow
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)($19e5e9ef880dfbce$export$1aefd27d2ed3c1c9, {
                mode: mode,
                children: children
            })
        })
    });
};
const $19e5e9ef880dfbce$export$ab8aa3dfd687f012 = ()=>{
    return (0, $42omo.useContext)($19e5e9ef880dfbce$var$AnalyticsPropertiesContext);
};
module.exports["SharedFeaturesInstrumentationIdContext"] = $19e5e9ef880dfbce$export$5ae3634fdb64882c;
module.exports["AnalyticsContextWithSourceAndProperties"] = $19e5e9ef880dfbce$export$a00cd3c213413389;
module.exports["useAnalyticsPropertiesContext"] = $19e5e9ef880dfbce$export$ab8aa3dfd687f012;

});

parcelRegister("jA9SA", function(module, exports) {
/**
 * NOTE: Some of these fields are used to track AI MAU
 * See this page for more details: https://hello.atlassian.net/wiki/spaces/AAI/pages/3770721410/Unified+event+Instrumentation+for+AI
 */ const $eb66f40a0f078927$export$8cffc8b2c93affd4 = {
    agentCreatorType: 'agentCreatorType',
    agentId: 'agentId',
    agentVisibility: 'agentVisibility',
    agentExternalConfigReference: 'agentExternalConfigReference',
    agentActions: 'agentActions',
    agentIsDefault: 'agentIsDefault',
    agentIsVerified: 'agentIsVerified',
    conversationChannelId: 'conversationChannelId',
    experienceId: 'experienceId',
    fullScreen: 'fullScreen',
    mode: 'mode',
    product: 'product',
    productHeader: 'productHeader',
    singleInstrumentationID: 'singleInstrumentationID',
    sharedFeaturesInstrumentationId: 'sharedFeaturesInstrumentationId',
    assistanceServiceConfigMinionAlias: 'assistanceServiceConfigMinionAlias'
};
module.exports["AI_MATE_ATTRIBUTES"] = $eb66f40a0f078927$export$8cffc8b2c93affd4;

});

parcelRegister("bQGO7", function(module, exports) {

var $3pfAb = parcelRequire("3pfAb");

const $7940b633dc028a3e$export$85183a312807388d = (0, $3pfAb.FabricChannel).aiMate;
var $7940b633dc028a3e$export$406073150b1a408 = /*#__PURE__*/ function(AUTOSUGGEST_SOURCE) {
    AUTOSUGGEST_SOURCE["ROVO_CHAT"] = "rovo-chat";
    AUTOSUGGEST_SOURCE["CONFLUENCE_AIFC"] = "confluence-aifc";
    return AUTOSUGGEST_SOURCE;
}({});
module.exports["ANALYTICS_CHANNEL"] = $7940b633dc028a3e$export$85183a312807388d;
module.exports["AUTOSUGGEST_SOURCE"] = $7940b633dc028a3e$export$406073150b1a408;

});

parcelRegister("lUZCl", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $iN5LM = parcelRequire("iN5LM");

const $ee6ebd3561b1c806$var$isSourceAndAttributes = (x)=>{
    if (typeof x !== 'object' || x === null) return false;
    if (!('source' in x) || !('attributes' in x) || typeof x.attributes !== 'object' || x.attributes === null) return false;
    return (0, $iN5LM.ALLOWED_AI_MATE_SOURCES).includes(x.source);
};
const $ee6ebd3561b1c806$export$d97c97ed77ff09e8 = (context)=>{
    if (!context || !Array.isArray(context)) return {};
    let contextsThatHaveAttributes = context.filter((x)=>$ee6ebd3561b1c806$var$isSourceAndAttributes(x) || x[0, $ffCOo.AI_MATE_CONTEXT]);
    return contextsThatHaveAttributes.reduce((acc, x)=>{
        return {
            ...acc,
            ...x[0, $ffCOo.AI_MATE_CONTEXT]?.attributes ?? {},
            ...x.attributes ?? {}
        };
    }, {});
};
module.exports["getAttributesFromContexts"] = $ee6ebd3561b1c806$export$d97c97ed77ff09e8;

});

parcelRegister("iN5LM", function(module, exports) {
const $79e4722581e5fb43$export$e31e24b63b7085fd = [
    'AIMate',
    'smart-create',
    'CSMAI',
    'CSMAIEmbed',
    'rovoServiceAgent'
];
module.exports["ALLOWED_AI_MATE_SOURCES"] = $79e4722581e5fb43$export$e31e24b63b7085fd;

});

parcelRegister("dDAsV", function(module, exports) {

var $iS5Ay = parcelRequire("iS5Ay");


var $jaPWl = parcelRequire("jaPWl");

const $accffb80f429232b$export$bdbe5e70ac4420b8 = async ({ variables: variables, fetchPolicy: fetchPolicy })=>{
    const promotedSpacesLimit = variables && variables.promotedSpacesLimit || 10;
    const otherSpacesLimit = variables && variables.otherSpacesLimit || 10;
    const promotedSpaceKey = variables && variables.promotedSpaceKey || '';
    const result = await (0, $iS5Ay.experimentalQuery)({
        url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
        method: 'GET',
        headers: {
            'Content-Type': (0, $jaPWl.MediaType).JSON
        },
        variables: variables || {},
        fetchPolicy: fetchPolicy,
        parseResult: (json)=>{
            const matchedPromotedSpaces = json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces || [];
            const nodes = (json.promotedSpaces && json.promotedSpaces.spaces || []).concat(json.otherSpaces && json.otherSpaces.spaces || []);
            return {
                experimentalPromotedSpaces: {
                    nodes: nodes,
                    matchedPromotedSpaces: matchedPromotedSpaces,
                    __typename: 'ExperimentalPromotedSpaces'
                }
            };
        }
    });
    return {
        data: result.data
    };
};
module.exports["experimentalPromotedSpacesQuery"] = $accffb80f429232b$export$bdbe5e70ac4420b8;

});

parcelRegister("iS5Ay", function(module, exports) {

var $4HDYO = parcelRequire("4HDYO");


var $6fil2 = parcelRequire("6fil2");


var $1RY07 = parcelRequire("1RY07");


var $GLgaM = parcelRequire("GLgaM");


var $7ji4X = parcelRequire("7ji4X");


var $6l6jb = parcelRequire("6l6jb");


var $bjeS8 = parcelRequire("bjeS8");

async function $7002390fd45cd24e$export$ca7e5505c9b1be25({ url: url, method: method = 'GET', headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, fetchPolicy: fetchPolicy = 'cache-first', errorPolicy: errorPolicy = 'none', skip: skip = false, onError: onError, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, ignoreNoNetworkError: ignoreNoNetworkError, transformError: transformError }) {
    const key = (0, $6l6jb.generateCacheKey)({
        url: url,
        method: method,
        headers: headers,
        body: body,
        credentials: credentials,
        variables: variables
    });
    const fetchData = async ()=>{
        try {
            const json = await (0, $GLgaM.fetchResponse)({
                url: url,
                method: method,
                body: body,
                headers: headers,
                credentials: credentials,
                parseResponseOnSuccess: parseResponseOnSuccess,
                parseResponseOnError: parseResponseOnError
            }, variables);
            return await parseResult(json, variables);
        } catch (error) {
            if (ignoreNoNetworkError && (0, $6fil2.containsNetworkError)(error)) return undefined;
            throw error;
        }
    };
    const storeInstance = (0, $4HDYO.defaultRegistry).getStore((0, $7ji4X.queryStateStore));
    const getCachedData = ()=>{
        const queryState = storeInstance.storeState.getState();
        return queryState[key]?.data;
    };
    const setCachedData = (data)=>{
        storeInstance.actions.setQueryState(key, {
            data: data,
            loading: false,
            error: undefined,
            called: true
        });
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $1RY07.apolloCompatibleQuery)({
        fetchData: fetchData,
        fetchPolicy: fetchPolicy,
        errorPolicy: errorPolicy,
        skip: skip,
        getCachedData: getCachedData,
        setCachedData: setCachedData,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalQuery"] = $7002390fd45cd24e$export$ca7e5505c9b1be25;

});

parcelRegister("cSCao", function(module, exports) {
/* AISmartCreateSpotlight.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $inPa6 = parcelRequire("inPa6");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");


var $caX7N = parcelRequire("caX7N");


var $iXCQx = parcelRequire("iXCQx");


var $bqAtB = parcelRequire("bqAtB");

var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $8tIbq = parcelRequire("8tIbq");


var $lsxnT = parcelRequire("lsxnT");


var $9wGTI = parcelRequire("9wGTI");


var $bPDOf = parcelRequire("bPDOf");


var $ivb8S = parcelRequire("ivb8S");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $kkssp = parcelRequire("kkssp");


var $9zecR = parcelRequire("9zecR");


var $evORK = parcelRequire("evORK");

const $fc0094d2feaf8930$var$styles = {
    image: "_1bsbaq3k _4t3ihcro _bfhkdaj9"
};
const $fc0094d2feaf8930$var$i18n = (0, $cgtv4.defineMessages)({
    smartCreateTitle: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.title",
        defaultMessage: "Start work faster with Rovo"
    },
    smartCreateDescription: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.description",
        defaultMessage: "Let Rovo draft the doc or whiteboard you need to get started fast."
    },
    smartCreateCTA: {
        id: "onboarding-ai-first-create.nudge.smart-create-with-ai.cta",
        defaultMessage: "Try it now"
    }
});
const $fc0094d2feaf8930$export$21865c28a29cfa2f = ({ children: children, onClick: onClick, source: source, isLoading: isLoading, offset: offset = [
    0,
    2
], placement: placement = 'left-start' })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $42omo.useState)(false);
    const handleSpotlightStart = (0, $42omo.useCallback)(()=>{
        const statesToSet = [
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenAIFCSpotlight,
                value: 'true'
            },
            {
                key: (0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS).hasSeenDeeplinkReturnSpotlight,
                value: 'true'
            }
        ]; // Write to onboarding state (server-side persistence)
        setOnboardingState(statesToSet);
        setIsSpotlightActive(true);
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'AISmartCreateSpotlight',
                attributes: {
                    source: source
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        setOnboardingState,
        source
    ]);
    const handleSpotlightStop = ()=>{
        setIsSpotlightActive(false);
    };
    const choreographer = useChoreographer('AISmartCreateSpotlight', {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const { isAIFCOnbardingEligible: isChangboardingEligible, loading: isChangboardingEligibleLoading, error: isChangboardingEligibleError } = (0, $evORK.useIsAIFCOnbardingEligible)();
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)([
        ...Object.values((0, $bPDOf.AIFC_ONBOARDING_STATE_KEYS))
    ], !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled'));
    const { hasSeenAIFCSpotlight: hasSeenAIFCSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const handleSpotlightInteraction = (0, $42omo.useCallback)((e)=>{
        onClick?.(e);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightCTA',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        onClick,
        source
    ]);
    const handleOnClick = (0, $42omo.useCallback)((e)=>{
        handleSpotlightInteraction(e);
    }, [
        handleSpotlightInteraction
    ]);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>{
        setIsSpotlightActive(false);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'AISmartCreateSpotlightDismiss',
                source: source
            }
        }).fire();
        choreographer.stopMessage();
    }, [
        choreographer,
        createAnalyticsEvent,
        source
    ]);
    const getLocalOverrideValue = (0, $42omo.useCallback)(()=>{
        try {
            if ((0, $17wUi.confluenceSessionStorageInstance).getItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY)) return true;
        } catch  {
            return false;
        }
        return false;
    }, []);
    (0, $42omo.useEffect)(()=>{
        const localOverride = getLocalOverrideValue();
        const loadingComplete = !isLoading && !isChangboardingEligibleLoading && !isChangboardingEligibleError && !isOnboardingStateLoading && !isOnboardingStateError;
        if (loadingComplete && isChangboardingEligible && !hasSeenAIFCSpotlight) choreographer.startMessage();
        else if (localOverride) {
            handleSpotlightStart();
            (0, $17wUi.confluenceSessionStorageInstance).removeItem((0, $1UApO.keys).AIFC_CREATE_SPOTLIGHT_SESSION_KEY);
        }
    }, [
        choreographer,
        hasSeenAIFCSpotlight,
        isLoading,
        isChangboardingEligible,
        isChangboardingEligibleError,
        isChangboardingEligibleLoading,
        isOnboardingStateError,
        isOnboardingStateLoading,
        getLocalOverrideValue,
        handleSpotlightStart
    ]);
    const CreateWithRovoSpotlightMedia = (0, $42omo.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            className: (0, $gMc0m.default)([
                $fc0094d2feaf8930$var$styles.image
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($9zecR))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($kkssp))),
            width: 295,
            height: 135,
            alt: ""
        }));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8tIbq.UNSAFE_UpdateOnChange), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $caX7N.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqAtB.PopoverContent), {
        dismiss: handleOnDismiss,
        isVisible: isSpotlightActive,
        placement: placement,
        offset: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: placement === 'right-end' ? 'right' : 'left'
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: "ai-smart-create-spotlight"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, CreateWithRovoSpotlightMedia), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), {
            onClick: (e)=>handleOnClick(e)
        }, formatMessage($fc0094d2feaf8930$var$i18n.smartCreateCTA))))))))));
};
module.exports["AISmartCreateSpotlight"] = $fc0094d2feaf8930$export$21865c28a29cfa2f;

});

parcelRegister("8tIbq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hTKp4 = parcelRequire("hTKp4");


var $2MPqq = parcelRequire("2MPqq");

const $50e1434d8c6bc030$var$defaultOptions = {
    childList: true,
    subtree: true
};
const $50e1434d8c6bc030$export$6a6a5d23d75b0f62 = ({ selectors: selectors = [
    'body'
], options: options = $50e1434d8c6bc030$var$defaultOptions })=>{
    const { popoverContent: popoverContent } = (0, $42omo.useContext)((0, $2MPqq.SpotlightContext));
    const { update: update } = popoverContent;
    (0, $42omo.useEffect)(()=>{
        if (!update || selectors.length === 0) return;
        const doc = (0, $hTKp4.getDocument)();
        if (!doc) return;
        const elements = new Set();
        selectors.forEach((selector)=>{
            const element = doc.querySelector(selector);
            if (!element) return;
            elements.add(element);
        });
        if (elements.size === 0) return;
        const observers = [];
        elements.forEach((element)=>{
            const observer = new MutationObserver((mutations)=>{
                if (mutations.length === 0) return;
                update();
            });
            observer.observe(element, options);
            observers.push(observer);
        });
        return ()=>{
            observers.forEach((observer)=>observer.disconnect());
        };
    }, [
        selectors,
        options,
        update
    ]);
    return null;
};
module.exports["UNSAFE_UpdateOnChange"] = $50e1434d8c6bc030$export$6a6a5d23d75b0f62;

});

parcelRegister("kkssp", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationDark.886221cf.gif", import.meta.url).toString();

});

parcelRegister("9zecR", function(module, exports) {
module.exports = new URL("CreateWithRovoSpotlightAnimationLight.1a1df728.gif", import.meta.url).toString();

});

parcelRegister("evORK", function(module, exports) {

var $dlSEv = parcelRequire("dlSEv");


var $9wGTI = parcelRequire("9wGTI");


var $kAcNG = parcelRequire("kAcNG");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gqypm = parcelRequire("gqypm");

const $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT = 'confluence_first_active';
const $eeeb74b654b378be$export$c71507e40f69e111 = ()=>{
    const { isRovoLLMEnabled: isRovoLLMEnabled, cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { data: siteUserPersonalizationData, loading: siteUserPersonalizationLoading, error: siteUserPersonalizationError } = (0, $gqypm.useExperimentalSiteUserPersonalization)({
        variables: {
            cloudId: cloudId,
            userId: userId
        },
        skip: !userId || !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const siteUserPersonalizationAttributes = siteUserPersonalizationData?.experimentalSiteUserPersonalization?.attributes;
    const confluenceFirstActive = siteUserPersonalizationAttributes?.find(({ name: name })=>name === $eeeb74b654b378be$var$CONFLUENCE_FIRST_ACTIVE_TRAIT)?.value;
    const { attributes: sitePersonalizationAttributes, loading: sitePersonalizationLoading, error: sitePersonalizationError } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: !cloudId || !isLicensed || !isRovoLLMEnabled || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')
    });
    const AIFCBetaEnrolledDateTime = sitePersonalizationAttributes?.find(({ name: name })=>name === 'confluence_aifc_enabled_datetime')?.value;
    const isExistingUserBeforeAIFCBetaEnrolled = !!confluenceFirstActive && !!AIFCBetaEnrolledDateTime && (0, $dlSEv.default)(new Date(confluenceFirstActive), new Date(AIFCBetaEnrolledDateTime));
    if (sitePersonalizationError || sitePersonalizationLoading || siteUserPersonalizationError || siteUserPersonalizationLoading || !(0, $9wGTI.fg)('aifc_onboarding_killswitch') || !(0, $9wGTI.fg)('aifc_create_enabled')) return {
        isAIFCOnbardingEligible: false,
        error: sitePersonalizationError || siteUserPersonalizationError,
        loading: sitePersonalizationLoading || siteUserPersonalizationLoading
    };
    return {
        isAIFCOnbardingEligible: isExistingUserBeforeAIFCBetaEnrolled,
        loading: false
    };
};
module.exports["useIsAIFCOnbardingEligible"] = $eeeb74b654b378be$export$c71507e40f69e111;

});

parcelRegister("dlSEv", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b87a15bb5e36b12$export$2e2bcd8739ae039);

var $egXhZ = parcelRequire("egXhZ");


var $b5utg = parcelRequire("b5utg");

function $9b87a15bb5e36b12$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $b5utg.default)(2, arguments);
    var date = (0, $egXhZ.default)(dirtyDate);
    var dateToCompare = (0, $egXhZ.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("kAcNG", function(module, exports) {

var $8Lx5S = parcelRequire("8Lx5S");


var $1uFM6 = parcelRequire("1uFM6");


var $aMcHK = parcelRequire("aMcHK");


var $hcDKy = parcelRequire("hcDKy");

let $a3e54b7319a42934$export$98a405b08ebbac37 = false;
const $a3e54b7319a42934$export$3cfde1d6c626a865 = ({ cloudId: cloudId, skip: skip, fetchPolicy: fetchPolicy })=>{
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const skipOptions = skip || !isLicensed || $a3e54b7319a42934$export$98a405b08ebbac37 || // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    Boolean(undefined); // SitePersonalizationQuery isn't preloaded and can be skipped during SSR to avoid unnecessary requests
    const { data: data, loading: loading, error: error } = (0, $hcDKy.useExperimentalSitePersonalizationQuery)({
        variables: {
            cloudId: cloudId
        },
        fetchPolicy: fetchPolicy || 'cache-first',
        skip: skipOptions,
        onError (apolloError) {
            $a3e54b7319a42934$export$98a405b08ebbac37 = apolloError?.graphQLErrors?.some((graphQLError)=>(0, $aMcHK.isStatusCodeError)(graphQLError, '401') || (0, $1uFM6.isUnauthorizedError)(graphQLError));
        }
    });
    const attributes = data?.experimentalSitePersonalization?.attributes || [];
    return {
        loading: loading,
        error: error,
        attributes: attributes
    };
};
module.exports["useSitePersonalizationQuery"] = $a3e54b7319a42934$export$3cfde1d6c626a865;

});

parcelRegister("hcDKy", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $c7a26f042941282d$export$f9ec68434a742b9f = ({ skip: skip, onError: onError, variables: variables, fetchPolicy: fetchPolicy })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}`,
        method: 'GET',
        parseResult: (json)=>({
                experimentalSitePersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip,
        onError: onError,
        variables: variables,
        fetchPolicy: fetchPolicy
    });
};
module.exports["useExperimentalSitePersonalizationQuery"] = $c7a26f042941282d$export$f9ec68434a742b9f;

});

parcelRegister("gqypm", function(module, exports) {

var $dK51B = parcelRequire("dK51B");


var $CIjCq = parcelRequire("CIjCq");

const $a585c4c0c1029461$export$650aef70f4433205 = ({ variables: variables, skip: skip })=>{
    return (0, $dK51B.useExperimentalQuery)({
        url: ({ cloudId: cloudId, userId: userId })=>`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${userId}`,
        method: 'GET',
        variables: variables,
        parseResult: (json)=>({
                experimentalSiteUserPersonalization: {
                    attributes: (0, $CIjCq.stringifyPersonalizationAttributes)(json.attributes)
                }
            }),
        skip: skip
    });
};
module.exports["useExperimentalSiteUserPersonalization"] = $a585c4c0c1029461$export$650aef70f4433205;

});

parcelRegister("cbBHq", function(module, exports) {
/* eslint-disable @typescript-eslint/consistent-type-imports */ 
var $42omo = parcelRequire("42omo");


var $lvOsp = parcelRequire("lvOsp");


var $9wGTI = parcelRequire("9wGTI");


var $2PxwR = parcelRequire("2PxwR");


var $6gwjd = parcelRequire("6gwjd");

const $0b3da77a55c8d66c$export$47d6a944ca09299 = ()=>{
    const [preloadSmartCreationModalQuery] = (0, $lvOsp.useLazyQueryInterop)((0, $6gwjd.default));
    return (0, $42omo.useCallback)(()=>{
        if ((0, $9wGTI.fg)('aifc_create_enabled')) {
            preloadSmartCreationModalQuery();
            (0, $2PxwR.LazyConfluenceSmartCreationModal).preload();
        }
    }, [
        preloadSmartCreationModalQuery
    ]);
};
module.exports["usePreloadSmartCreationModal"] = $0b3da77a55c8d66c$export$47d6a944ca09299;

});

parcelRegister("2PxwR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c156286aa1d634b0$export$116ded32e65c3603 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4mwBk",
    name: "LazyConfluenceSmartCreationModal",
    loader: async ()=>(await (parcelRequire("17o9t"))).ConfluenceSmartCreationModal
});
module.exports["LazyConfluenceSmartCreationModal"] = $c156286aa1d634b0$export$116ded32e65c3603;

});

parcelRegister("17o9t", function(module, exports) {

let $0d092dea5e142c9b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0d092dea5e142c9b$var$load("h3ABO"),
    $0d092dea5e142c9b$var$load("2tQni"),
    $0d092dea5e142c9b$var$load("kknel"),
    $0d092dea5e142c9b$var$load("oTvoe"),
    $0d092dea5e142c9b$var$load("2vAWg"),
    $0d092dea5e142c9b$var$load("7cABH"),
    $0d092dea5e142c9b$var$load("4UuEP"),
    $0d092dea5e142c9b$var$load("cJcjb"),
    $0d092dea5e142c9b$var$load("9CYct"),
    $0d092dea5e142c9b$var$load("iqTGf"),
    $0d092dea5e142c9b$var$load("8hNVx"),
    $0d092dea5e142c9b$var$load("7do1E"),
    $0d092dea5e142c9b$var$load("77dkW"),
    $0d092dea5e142c9b$var$load("2YffH"),
    $0d092dea5e142c9b$var$load("a7nvi"),
    $0d092dea5e142c9b$var$load("aLflZ"),
    $0d092dea5e142c9b$var$load("9Sp67"),
    $0d092dea5e142c9b$var$load("1jbvx"),
    $0d092dea5e142c9b$var$load("5aIsS"),
    $0d092dea5e142c9b$var$load("iIoyG"),
    $0d092dea5e142c9b$var$load("2xn4F"),
    $0d092dea5e142c9b$var$load("1P7J4"),
    $0d092dea5e142c9b$var$load("i1up4"),
    $0d092dea5e142c9b$var$load("fJtJG"),
    $0d092dea5e142c9b$var$load("1GvGi"),
    $0d092dea5e142c9b$var$load("d4u0p"),
    $0d092dea5e142c9b$var$load("dAnq0"),
    $0d092dea5e142c9b$var$load("bogQM"),
    $0d092dea5e142c9b$var$load("jq3Ai"),
    $0d092dea5e142c9b$var$load("cD6Zr"),
    $0d092dea5e142c9b$var$load("kgDUw"),
    $0d092dea5e142c9b$var$load("eBY1U"),
    $0d092dea5e142c9b$var$load("dUz9k"),
    $0d092dea5e142c9b$var$load("cyGuT"),
    $0d092dea5e142c9b$var$load("dHMdi"),
    $0d092dea5e142c9b$var$load("lId0W"),
    $0d092dea5e142c9b$var$load("3EXzu"),
    $0d092dea5e142c9b$var$load("8pDNY"),
    $0d092dea5e142c9b$var$load("b2FtX"),
    $0d092dea5e142c9b$var$load("e4wOQ"),
    $0d092dea5e142c9b$var$load("3w411"),
    $0d092dea5e142c9b$var$load("fSobj"),
    $0d092dea5e142c9b$var$load("74u2y"),
    $0d092dea5e142c9b$var$load("7oiUM"),
    $0d092dea5e142c9b$var$load("8t3po"),
    $0d092dea5e142c9b$var$load("855o0"),
    $0d092dea5e142c9b$var$load("8MfZE"),
    $0d092dea5e142c9b$var$load("kjZZD"),
    $0d092dea5e142c9b$var$load("8iA2F"),
    $0d092dea5e142c9b$var$load("4RhJO"),
    $0d092dea5e142c9b$var$load("iif0M"),
    $0d092dea5e142c9b$var$load("2cMKQ"),
    $0d092dea5e142c9b$var$load("gusn7"),
    $0d092dea5e142c9b$var$load("6wr18"),
    $0d092dea5e142c9b$var$load("ffEVr"),
    $0d092dea5e142c9b$var$load("Wowvf"),
    $0d092dea5e142c9b$var$load("hhss7"),
    $0d092dea5e142c9b$var$load("dAdaw"),
    $0d092dea5e142c9b$var$load("c0JsV"),
    $0d092dea5e142c9b$var$load("j47Y5"),
    $0d092dea5e142c9b$var$load("ivqr8"),
    $0d092dea5e142c9b$var$load("bgHzk"),
    $0d092dea5e142c9b$var$load("7EorR"),
    $0d092dea5e142c9b$var$load("fQKYr")
]).then(()=>parcelRequire('6CLTo'));

});

parcelRegister("6gwjd", function(module, exports) {
/**
 * @generated SignedSource<<3713f9ef4d56463a35a603e84cf10cea>>
 * @relayHash e04a1fbd9772100897718d8eb52d327f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641
const $7b2c6142b984d24d$var$node = function() {
    var v0 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "ConfluenceSmartCreationModalQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "e04a1fbd9772100897718d8eb52d327f",
            "id": "29e075973424046eb1776b14978c687f77f381ef1355bfdb4ef0a4005920d641",
            "metadata": {},
            "name": "ConfluenceSmartCreationModalQuery",
            "operationKind": "query",
            "text": "query ConfluenceSmartCreationModalQuery{user:confluence_atlassianUser(current:true){id,title}}"
        }
    };
}();
$7b2c6142b984d24d$var$node.hash = "b82822dc05785ac3b5e50c2feec2f4f2";
var $7b2c6142b984d24d$export$2e2bcd8739ae039 = $7b2c6142b984d24d$var$node;
module.exports["default"] = $7b2c6142b984d24d$export$2e2bcd8739ae039;

});

parcelRegister("85eZj", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");


var $6mKj3 = parcelRequire("6mKj3");

const $6fbba8ca34a359ae$export$4c7f2883fc9f8d51 = '#FCA700';
const $6fbba8ca34a359ae$export$33063ab650a21729 = '#6A9A23';
const $6fbba8ca34a359ae$export$10e476bac9ec0ef5 = '#1868DB';
const $6fbba8ca34a359ae$export$df75671260772505 = '#AF59E0';
const $6fbba8ca34a359ae$export$e09051f7939a7d45 = '#FCA700';
const $6fbba8ca34a359ae$export$7754a3784fa3cc3f = '#82B536';
const $6fbba8ca34a359ae$export$9bbdafe829e411b8 = '#357DE8';
const $6fbba8ca34a359ae$export$6401c517c949fb36 = '#BF63F3';
const $6fbba8ca34a359ae$var$svgStrokeAnimation = null;
const $6fbba8ca34a359ae$var$styles = {
    svg: "_kqswstnw _lswu1j28 _mam9yfq0",
    container: "_kqswh2mm _p5tjidpf _3fei1j2e _10r8kb7n"
};
const $6fbba8ca34a359ae$var$rectProps = {
    line1: {
        dashMultiplier: 0,
        light: $6fbba8ca34a359ae$export$4c7f2883fc9f8d51,
        dark: $6fbba8ca34a359ae$export$e09051f7939a7d45
    },
    line2: {
        dashMultiplier: 0.66,
        light: $6fbba8ca34a359ae$export$33063ab650a21729,
        dark: $6fbba8ca34a359ae$export$7754a3784fa3cc3f
    },
    line3: {
        dashMultiplier: 0.46,
        light: $6fbba8ca34a359ae$export$10e476bac9ec0ef5,
        dark: $6fbba8ca34a359ae$export$9bbdafe829e411b8
    },
    line4: {
        dashMultiplier: 0.2,
        light: $6fbba8ca34a359ae$export$df75671260772505,
        dark: $6fbba8ca34a359ae$export$6401c517c949fb36
    }
};
const $6fbba8ca34a359ae$export$3bfefaa89ceb40fc = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { children: children, borderRadius: t1 } = t0;
    const borderRadius = t1 === undefined ? true : t1;
    const ref = (0, $42omo.useRef)(null);
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const theme = colorMode === "dark" ? "dark" : "light";
    const [perimeter, setPerimeter] = (0, $42omo.useState)(0);
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            const rect = ref?.current?.getBoundingClientRect();
            const height = rect?.height || 0;
            const width = rect?.width || 0;
            setPerimeter(height * 2 + width * 2);
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[2] !== perimeter) {
        t4 = (key)=>{
            const multiplier = $6fbba8ca34a359ae$var$rectProps[key].dashMultiplier;
            const dashArrayLength = Math.round(multiplier * perimeter);
            return multiplier === 0 ? 0 : `${dashArrayLength} ${perimeter - dashArrayLength}`;
        };
        $[2] = perimeter;
        $[3] = t4;
    } else t4 = $[3];
    const calculateDashArray = t4;
    if (!(0, $6mKj3.expValEquals)("cc_fd_aifc_copy_change_experiment", "isEnabled", true)) return children;
    let t5;
    if ($[4] !== perimeter) {
        t5 = {
            "--stroke-perimeter": perimeter
        };
        $[4] = perimeter;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $gMc0m.default)([
            $6fbba8ca34a359ae$var$styles.container
        ]);
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] !== borderRadius || $[8] !== calculateDashArray || $[9] !== theme) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, Object.keys($6fbba8ca34a359ae$var$rectProps).map((key_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), {
                key: key_0
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("svg", {
                height: "100%",
                width: "100%",
                xmlns: "http://www.w3.org/2000/svg",
                className: (0, $gMc0m.default)([
                    $6fbba8ca34a359ae$var$styles.svg
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("rect", {
                "data-testid": key_0,
                strokeDasharray: calculateDashArray(key_0),
                rx: borderRadius ? "4" : "0",
                ry: borderRadius ? "4" : "0",
                x: "1",
                y: "1",
                height: "94%",
                width: "99%",
                stroke: $6fbba8ca34a359ae$var$rectProps[key_0][theme],
                strokeWidth: "var(--ds-space-025, 2px)"
            })))));
        $[7] = borderRadius;
        $[8] = calculateDashArray;
        $[9] = theme;
        $[10] = t7;
    } else t7 = $[10];
    let t8;
    if ($[11] !== children) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, children);
        $[11] = children;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ref: ref,
            style: t5,
            className: t6
        }, t7, t8);
        $[13] = t5;
        $[14] = t7;
        $[15] = t8;
        $[16] = t9;
    } else t9 = $[16];
    return t9;
};
module.exports["AnimatedGradientBorder"] = $6fbba8ca34a359ae$export$3bfefaa89ceb40fc;

});

parcelRegister("kvDd7", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $isFEX = parcelRequire("isFEX");


var $6yCpa = parcelRequire("6yCpa");


var $8aF6s = parcelRequire("8aF6s");


var $cwGs1 = parcelRequire("cwGs1");

const $216c3ab682f21a76$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.start-from-template.title",
        defaultMessage: "Start from template"
    }
});
function $216c3ab682f21a76$export$d0556c61c98b4b88(t0) {
    const $ = (0, $frIzR.c)(11);
    const { onClick: onClick, spaceKey: spaceKey, parentId: parentId } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    let t1;
    if ($[0] !== onClick || $[1] !== parentId || $[2] !== showModal || $[3] !== spaceKey) {
        t1 = (_e)=>{
            onClick("startFromTemplatePopoverItem");
            showModal((0, $cwGs1.TemplateModal), {
                spaceKey: spaceKey,
                parentId: parentId,
                testId: "start-from-template-modal"
            });
        };
        $[0] = onClick;
        $[1] = parentId;
        $[2] = showModal;
        $[3] = spaceKey;
        $[4] = t1;
    } else t1 = $[4];
    const handleClick = t1;
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6yCpa.Ati).parse("ati:cloud:confluence:template");
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== formatMessage) {
        t3 = formatMessage($216c3ab682f21a76$export$defe85febe8b728c.title);
        $[6] = formatMessage;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== handleClick || $[9] !== t3) {
        t4 = {
            ati: t2,
            children: t3,
            onClick: handleClick,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($isFEX))),
            testId: "create-menu-start-from-template-item"
        };
        $[8] = handleClick;
        $[9] = t3;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
}
module.exports["messages"] = $216c3ab682f21a76$export$defe85febe8b728c;
module.exports["useStartFromTemplateItem"] = $216c3ab682f21a76$export$d0556c61c98b4b88;

});

parcelRegister("isFEX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0cdccba3d7742a12d1dd259bf333308d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d70b2843323b118c$var$_react = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("42omo")));

var $d70b2843323b118c$var$_baseNew = $d70b2843323b118c$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $d70b2843323b118c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d70b2843323b118c$var$TemplateIcon = (props)=>/*#__PURE__*/ $d70b2843323b118c$var$_react.default.createElement($d70b2843323b118c$var$_baseNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$d70b2843323b118c$var$TemplateIcon.displayName = 'TemplateIcon';
var $d70b2843323b118c$var$_default = module.exports.default = $d70b2843323b118c$var$TemplateIcon;

});

parcelRegister("cwGs1", function(module, exports) {
/* TemplateModal.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $1qfLF = parcelRequire("1qfLF");

var $7p4As = parcelRequire("7p4As");


var $hmuev = parcelRequire("hmuev");


var $cO1el = parcelRequire("cO1el");


var $gj7hi = parcelRequire("gj7hi");


var $5tOl1 = parcelRequire("5tOl1");


var $g5gZt = parcelRequire("g5gZt");


var $inPa6 = parcelRequire("inPa6");


var $lsxnT = parcelRequire("lsxnT");


var $kaoLF = parcelRequire("kaoLF");


var $jzeHS = parcelRequire("jzeHS");


var $9t4Ph = parcelRequire("9t4Ph");


var $eRRx0 = parcelRequire("eRRx0");


var $7bdcb = parcelRequire("7bdcb");


var $kLDhO = parcelRequire("kLDhO");

const $68e4be005f8b3a6f$var$stylesMap = {
    modalContainerStyles: "_19bvpxbi _u5f3pxbi _bfhkvuon",
    headerStyles: "_1e0c1txw _2lx21bp4 _1bsb1osq",
    footerStyles: "_1yt4pxbi _x3doia51 _1e0c1txw _4cvr1h6o _1bah1yb4",
    headerAndImageStyles: "_zulpidpf _1e0c1txw _2lx21bp4 _4cvr1h6o",
    scribbleStyles: "_1wpzesu3 _19pkxmi2",
    titleContainerStyles: "_zulpidpf _1e0c1txw _2lx21bp4 _4cvr1h6o",
    iconButtonStyles: "_zulpu2gc _1e0c1txw _4cvr1h6o"
};
const $68e4be005f8b3a6f$var$headerContainerStyles = null;
const $68e4be005f8b3a6f$var$gridStyles = null;
const $68e4be005f8b3a6f$var$closeButtonStyles = null;
const $68e4be005f8b3a6f$export$285e41bef8b1c77f = ({ onClose: onClose, onCloseComplete: onCloseComplete, spaceKey: spaceKey, parentId: parentId, teamTypeOverride: teamTypeOverride, testId: testId = 'template-modal' })=>{
    const { teamType: userTeamType } = (0, $jzeHS.useUserTeamType)({
        skip: !!teamTypeOverride
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const teamType = teamTypeOverride ?? userTeamType;
    const { blueprintModuleKeyToLocalizedName: blueprintModuleKeyToLocalizedName } = (0, $9t4Ph.useAllTemplatesQuery)();
    const { templates: templates, blankDocCreateLink: blankDocCreateLink = '' } = (0, $kaoLF.useTemplateDataTransform)(teamType, spaceKey, parentId, blueprintModuleKeyToLocalizedName);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const handleClose = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'cfind-5291-template-touchpoint',
                action: 'closed',
                actionSubject: 'modal',
                actionSubjectId: 'templateModal'
            }
        }).fire();
        onClose();
    };
    const hybridBlankDocClick = (0, $eRRx0.useHybridLinkClick)(blankDocCreateLink);
    const handleBlankDocClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'cfind-5291-template-touchpoint',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'startBlankDoc'
            }
        }).fire();
        onClose();
        hybridBlankDocClick(e);
    }, [
        onClose,
        hybridBlankDocClick,
        createAnalyticsEvent
    ]);
    const viewMoreTemplatesHref = '/wiki/templates';
    const hybridViewMoreClick = (0, $eRRx0.useHybridLinkClick)(viewMoreTemplatesHref);
    const handleViewMoreTemplatesClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'cfind-5291-template-touchpoint',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewMoreTemplates'
            }
        }).fire();
        onClose();
        hybridViewMoreClick(e);
    }, [
        onClose,
        hybridViewMoreClick,
        createAnalyticsEvent
    ]);
    const topSixTemplates = templates?.slice(0, 6); // Limit to 6 templates
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        testId: testId,
        width: "x-large",
        shouldScrollInViewport: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3 _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
        appearance: "subtle",
        label: formatMessage((0, $kLDhO.messages).closeModalLabel),
        onClick: handleClose,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        testId: `${testId}-close`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulpze3t _1e0c1txw _2lx21bp4 _y3gn1h6o _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d8eRd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.headerAndImageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.titleContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
        size: "large",
        as: "h1"
    }, formatMessage((0, $kLDhO.messages).modalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.scribbleStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/5ai2us5tokkn17261xufm2a4q1836188.svg",
        alt: ""
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "medium"
    }, formatMessage((0, $kLDhO.messages).modalSubtitle))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.modalContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_zulp1ejb _18s8xy5q _1e0c11p5 _yv0e13mt"
        ])
    }, topSixTemplates?.map((template, index)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7bdcb.TemplateCard), {
            key: `${template.name}-${index}`,
            name: template.name,
            contentTypeLabel: template.contentTypeLabel,
            contentTypeIcon: template.contentTypeIcon,
            imageSource: template.imageSource,
            imageSourceDark: template.imageSourceDark,
            createLink: template.createLink,
            templateId: template.templateId,
            contentType: template.contentType,
            onClose: onClose
        });
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.footerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        href: blankDocCreateLink,
        onClick: handleBlankDocClick,
        testId: `${testId}-start-blank-doc`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.iconButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
        label: formatMessage((0, $kLDhO.messages).startBlankDocLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, formatMessage((0, $kLDhO.messages).startBlankDoc))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
        appearance: "subtle",
        href: viewMoreTemplatesHref,
        onClick: handleViewMoreTemplatesClick,
        testId: `${testId}-view-more`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $68e4be005f8b3a6f$var$stylesMap.iconButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), null, formatMessage((0, $kLDhO.messages).viewMoreTemplates), " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5tOl1))), {
        label: formatMessage((0, $kLDhO.messages).viewMoreTemplatesLabel)
    }))))));
};
module.exports["TemplateModal"] = $68e4be005f8b3a6f$export$285e41bef8b1c77f;

});

parcelRegister("kaoLF", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $ZDq1z = parcelRequire("ZDq1z");


var $e0ycV = parcelRequire("e0ycV");


var $dignY = parcelRequire("dignY");


var $cgxgV = parcelRequire("cgxgV");


var $3ISyM = parcelRequire("3ISyM");


var $cf2U8 = parcelRequire("cf2U8");


var $94mMM = parcelRequire("94mMM");


var $60wYg = parcelRequire("60wYg");


var $kLDhO = parcelRequire("kLDhO");

// Create a Set for O(1) lookup performance
const $d7b0c57e8f8cafec$var$WHITEBOARD_TEMPLATE_IDS_SET = new Set(Object.values((0, $dignY.WHITEBOARD_TEMPLATE_IDS)));
const $d7b0c57e8f8cafec$export$5a36b99d39197c15 = (teamType, spaceKey, parentPageId, blueprintModuleKeyToLocalizedName)=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const blankDocCreateLink = (0, $cf2U8.buildCreationLink)({
        contentType: 'page',
        subType: (0, $cf2U8.ConfluencePageSubType).LIVE,
        withFallback: true,
        source: 'cfind-5291-template-touchpoint',
        spaceKey: spaceKey,
        parentPageId: parentPageId
    });
    const templates = (0, $42omo.useMemo)(()=>{
        // Get the template names for this team type
        let templateNames = teamType ? (0, $94mMM.teamToTemplatesMapping)[teamType] : undefined;
        if (!templateNames || templateNames.length === 0) templateNames = (0, $3ISyM.DEFAULT_POPULAR_TEMPLATES);
        // Transform each template name into a TemplateData object using reduce to avoid nested iteration
        const templates = [];
        for (const templateName of templateNames){
            if ($d7b0c57e8f8cafec$var$WHITEBOARD_TEMPLATE_IDS_SET.has(templateName)) {
                const titleDescriptor = (0, $dignY.WHITEBOARD_TEMPLATE_TITLE_MAPPING)[templateName];
                const imageSource = (0, $cgxgV.WHITEBOARD_TEMPLATE_TO_IMG_MAPPING)[templateName] || (0, $cgxgV.defaultImgSrc);
                const imageSourceDark = (0, $cgxgV.WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING)[templateName] || (0, $cgxgV.defaultDarkImgSrc);
                const createLink = (0, $cf2U8.buildCreationLink)({
                    contentType: 'whiteboard',
                    withFallback: true,
                    source: 'cfind-5291-template-touchpoint',
                    spaceKey: spaceKey,
                    parentPageId: parentPageId,
                    insertTemplateWithKey: templateName
                });
                templates.push({
                    name: titleDescriptor ? formatMessage(titleDescriptor) : templateName,
                    templateId: templateName,
                    contentType: 'whiteboard',
                    contentTypeLabel: formatMessage((0, $kLDhO.messages).whiteboardTemplateType),
                    contentTypeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ZDq1z))), {
                        label: formatMessage((0, $kLDhO.messages).whiteboardTemplateType)
                    }),
                    imageSource: imageSource,
                    imageSourceDark: imageSourceDark,
                    createLink: createLink
                });
                continue;
            }
            // Blueprint/Doc template - use extended mappings (includes all blueprints)
            const extendedBlueprintMapping = (0, $60wYg.BLUEPRINT_NAME_TO_IDS_MAPPING)[templateName];
            if (extendedBlueprintMapping) {
                const imageSource = (0, $cgxgV.BLUEPRINT_NAME_TO_IMG_MAPPING)[templateName] || (0, $cgxgV.defaultImgSrc);
                const imageSourceDark = (0, $cgxgV.BLUEPRINT_IMG_MAP_DARK)[templateName] || (0, $cgxgV.defaultDarkImgSrc);
                const createLink = (0, $cf2U8.buildCreationLink)({
                    contentType: 'page',
                    subType: (0, $cf2U8.ConfluencePageSubType).LIVE,
                    withFallback: true,
                    source: 'cfind-5291-template-touchpoint',
                    spaceKey: spaceKey,
                    parentPageId: parentPageId,
                    templateKey: extendedBlueprintMapping.blueprintModuleCompleteKey
                });
                // Use the server-localized name if available, falling back to the hardcoded enum value
                const localizedName = blueprintModuleKeyToLocalizedName?.[extendedBlueprintMapping.blueprintModuleCompleteKey] ?? templateName;
                templates.push({
                    name: localizedName,
                    templateId: extendedBlueprintMapping.blueprintModuleCompleteKey,
                    contentType: 'page',
                    contentSubtype: (0, $cf2U8.ConfluencePageSubType).LIVE,
                    contentTypeLabel: formatMessage((0, $kLDhO.messages).livePageTemplateType),
                    contentTypeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e0ycV))), {
                        label: ""
                    }),
                    imageSource: imageSource,
                    imageSourceDark: imageSourceDark,
                    createLink: createLink
                });
                continue;
            }
        }
        return templates;
    }, [
        teamType,
        formatMessage,
        spaceKey,
        parentPageId,
        blueprintModuleKeyToLocalizedName
    ]);
    return {
        templates: templates,
        blankDocCreateLink: blankDocCreateLink
    };
};
module.exports["useTemplateDataTransform"] = $d7b0c57e8f8cafec$export$5a36b99d39197c15;

});

parcelRegister("dignY", function(module, exports) {
// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/whiteboardMappings.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint

var $4mxrP = parcelRequire("4mxrP");

var $31df41c4412f615f$export$2f1a3cf395e54495 = /*#__PURE__*/ function(WHITEBOARD_TEMPLATE_IDS) {
    WHITEBOARD_TEMPLATE_IDS["ACTION_PLAN"] = "action-plan";
    WHITEBOARD_TEMPLATE_IDS["ANNUAL_CALENDAR"] = "annual-calendar-2025-2026";
    WHITEBOARD_TEMPLATE_IDS["BRAINWRITING"] = "brainwriting";
    WHITEBOARD_TEMPLATE_IDS["CONCEPT_MAP"] = "concept-map";
    WHITEBOARD_TEMPLATE_IDS["CRAZY_8S_BRAINSTORMING"] = "crazy-8s";
    WHITEBOARD_TEMPLATE_IDS["DISRUPTIVE_BRAINSTORM"] = "disruptive-brainstorm";
    WHITEBOARD_TEMPLATE_IDS["EXECUTIVE_SUMMARY"] = "executive-summary";
    WHITEBOARD_TEMPLATE_IDS["FISHBONE_DIAGRAM"] = "fishbone-diagram";
    WHITEBOARD_TEMPLATE_IDS["FLOWCHART"] = "flow-chart";
    WHITEBOARD_TEMPLATE_IDS["FOCUS_AREA_DIAGRAM"] = "focus-area-diagram";
    WHITEBOARD_TEMPLATE_IDS["FOURLS_RETRO"] = "4ls-retro";
    WHITEBOARD_TEMPLATE_IDS["GAP_ANALYSIS"] = "gap-analysis";
    WHITEBOARD_TEMPLATE_IDS["ICEBREAKERS"] = "ice-breakers";
    WHITEBOARD_TEMPLATE_IDS["INCIDENT_POSTMORTEM"] = "incident-postmortem";
    WHITEBOARD_TEMPLATE_IDS["NETWORK_OF_TEAMS"] = "network-of-teams";
    WHITEBOARD_TEMPLATE_IDS["ORG_CHART"] = "org-chart";
    WHITEBOARD_TEMPLATE_IDS["PRIORITIZATION_MATRIX"] = "prioritization";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_ROADMAP"] = "product-roadmap";
    WHITEBOARD_TEMPLATE_IDS["PRODUCT_VISION_BOARD"] = "product-vision-board";
    WHITEBOARD_TEMPLATE_IDS["ROOT_CAUSE_TEMPLATE"] = "root-cause-analysis";
    WHITEBOARD_TEMPLATE_IDS["SERVICE_BLUEPRINT"] = "service-blueprint";
    WHITEBOARD_TEMPLATE_IDS["SIMPLE_RETROSPECTIVE"] = "simple-retrospective";
    WHITEBOARD_TEMPLATE_IDS["STAKEHOLDER_MAPPING"] = "stakeholder-mapping";
    WHITEBOARD_TEMPLATE_IDS["SWIMLANES_PROCESS_MAP"] = "swimlanes";
    WHITEBOARD_TEMPLATE_IDS["SWOT_ANALYSIS"] = "swot-analysis";
    WHITEBOARD_TEMPLATE_IDS["TEAM_CHARTER_TEMPLATE"] = "team-formation-guide";
    WHITEBOARD_TEMPLATE_IDS["TEAM_HEALTH_MONITOR"] = "health-monitor";
    WHITEBOARD_TEMPLATE_IDS["TIMELINE_WORKFLOW"] = "timeline-workflow";
    WHITEBOARD_TEMPLATE_IDS["USER_STORY_MAP"] = "user-story-map";
    WHITEBOARD_TEMPLATE_IDS["WORKFLOW_TEMPLATE"] = "workflow";
    WHITEBOARD_TEMPLATE_IDS["ELEVATOR_PITCH"] = "elevator-pitch";
    return WHITEBOARD_TEMPLATE_IDS;
}({});
const $31df41c4412f615f$export$e6f6ad6a6a9f5ec0 = {
    ["simple-retrospective"]: (0, $4mxrP.i18n).simpleRetrospectiveTemplate,
    ["prioritization"]: (0, $4mxrP.i18n).prioritizationMatrixTemplate,
    ["brainwriting"]: (0, $4mxrP.i18n).brainwritingTemplate,
    ["incident-postmortem"]: (0, $4mxrP.i18n).incidentPostmortemTemplate,
    ["4ls-retro"]: (0, $4mxrP.i18n).fourLsTemplate,
    ["network-of-teams"]: (0, $4mxrP.i18n).networkOfTeamsTemplate,
    ["disruptive-brainstorm"]: (0, $4mxrP.i18n).disruptiveBrainstormTemplate,
    ["concept-map"]: (0, $4mxrP.i18n).conceptMapTemplate,
    ["swimlanes"]: (0, $4mxrP.i18n).swimlanesProcessMapTemplate,
    ["swot-analysis"]: (0, $4mxrP.i18n).swotAnalysisTemplate,
    ["focus-area-diagram"]: (0, $4mxrP.i18n).focusAreaDiagramTemplate,
    ["user-story-map"]: (0, $4mxrP.i18n).userStoryMapTemplate,
    ["timeline-workflow"]: (0, $4mxrP.i18n).timelineWorkflowTemplate,
    ["fishbone-diagram"]: (0, $4mxrP.i18n).fishboneDiagramTemplate,
    ["org-chart"]: (0, $4mxrP.i18n).orgChartTemplate,
    ["ice-breakers"]: (0, $4mxrP.i18n).icebreakersTemplate,
    ["service-blueprint"]: (0, $4mxrP.i18n).serviceBlueprintTemplate,
    ["product-vision-board"]: (0, $4mxrP.i18n).productVisionTemplate,
    ["workflow"]: (0, $4mxrP.i18n).workflowTemplate,
    ["health-monitor"]: (0, $4mxrP.i18n).teamHealthMonitorTemplate,
    ["flow-chart"]: (0, $4mxrP.i18n).flowchartTemplate,
    ["team-formation-guide"]: (0, $4mxrP.i18n).teamCharterTemplate,
    ["action-plan"]: (0, $4mxrP.i18n).actionPlanTemplate,
    ["executive-summary"]: (0, $4mxrP.i18n).executiveSummaryTemplate,
    ["root-cause-analysis"]: (0, $4mxrP.i18n).rootCauseTemplate,
    ["stakeholder-mapping"]: (0, $4mxrP.i18n).stakeholderMappingTemplate,
    ["gap-analysis"]: (0, $4mxrP.i18n).gapAnalysisTemplate,
    ["annual-calendar-2025-2026"]: (0, $4mxrP.i18n).annualCalendarTemplate,
    ["crazy-8s"]: (0, $4mxrP.i18n).crazy8sBrainstormingTemplate,
    ["product-roadmap"]: (0, $4mxrP.i18n).productRoadmapTemplate,
    ["elevator-pitch"]: (0, $4mxrP.i18n).elevatorPitchTemplate
};
const $31df41c4412f615f$export$e29ba58b8013030 = new Set(Object.values($31df41c4412f615f$export$2f1a3cf395e54495));
module.exports["WHITEBOARD_TEMPLATE_IDS"] = $31df41c4412f615f$export$2f1a3cf395e54495;
module.exports["WHITEBOARD_TEMPLATE_TITLE_MAPPING"] = $31df41c4412f615f$export$e6f6ad6a6a9f5ec0;

});

parcelRegister("4mxrP", function(module, exports) {
/* Eventually these strings should get moved to the components they're used in but creating generic file for now to kickoff translations */ 
var $cgtv4 = parcelRequire("cgtv4");

const $c3887a9c93c500a4$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    databaseTemplateType: {
        id: "experiment-cfind-5291-template-touchpoint.database.template",
        defaultMessage: "Database Template"
    },
    getStartedHeader: {
        id: "experiment-cfind-5291-template-touchpoint.getting.started.header",
        defaultMessage: "Get Started"
    },
    simpleRetrospectiveTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.simple.retrospective.template",
        defaultMessage: "Simple Retrospective"
    },
    flowchartTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.flowchart.template",
        defaultMessage: "Flowchart"
    },
    prioritizationMatrixTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.prioritization.matrix.template",
        defaultMessage: "Prioritization Matrix"
    },
    brainwritingTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.brainwriting.template",
        defaultMessage: "Brainwriting"
    },
    incidentPostmortemTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.incident.postmortem.template",
        defaultMessage: "Incident Postmortem"
    },
    fourLsTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.four.ls.template",
        defaultMessage: "4 Ls Retro"
    },
    networkOfTeamsTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.network.of.teams.template",
        defaultMessage: "Network of Teams"
    },
    disruptiveBrainstormTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.disruptive.brainstorm.template",
        defaultMessage: "Disruptive Brainstorm"
    },
    conceptMapTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.concept.map.template",
        defaultMessage: "Concept Map"
    },
    swimlanesProcessMapTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.swimlanes.process.map.template",
        defaultMessage: "Swimlanes Process Map"
    },
    swotAnalysisTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.swot.analysis.template",
        defaultMessage: "SWOT Analysis"
    },
    focusAreaDiagramTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.focus.area.diagram.template",
        defaultMessage: "Focus Area Diagram"
    },
    userStoryMapTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.user.story.map.template",
        defaultMessage: "User Story Map"
    },
    fishboneDiagramTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.fishbone.diagram.template",
        defaultMessage: "Fishbone Diagram"
    },
    orgChartTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.org.chart.template",
        defaultMessage: "Org Chart"
    },
    icebreakersTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.icebreakers.template",
        defaultMessage: "Icebreakers"
    },
    serviceBlueprintTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.service.blueprint.template",
        defaultMessage: "Service Blueprint"
    },
    productVisionTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.vision.board.template",
        defaultMessage: "Product Vision Board"
    },
    workflowTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.workflow.template",
        defaultMessage: "Workflow"
    },
    timelineWorkflowTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.timeline.workflow.template",
        defaultMessage: "Timeline Workflow"
    },
    teamHealthMonitorTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.team.health.monitor.template",
        defaultMessage: "Team Health Monitor"
    },
    teamCharterTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.team.charter.template",
        defaultMessage: "Team Charter Template"
    },
    actionPlanTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.action.plan.template",
        defaultMessage: "Action Plan"
    },
    gapAnalysisTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.gap.analysis.template",
        defaultMessage: "Gap Analysis"
    },
    productRoadmapTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.roadmap.template",
        defaultMessage: "Product Roadmap"
    },
    crazy8sBrainstormingTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.crazy-8s-brainstorming.template",
        defaultMessage: "Crazy 8s Brainstorming"
    },
    annualCalendarTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.annual-calendar.template",
        defaultMessage: "Annual Calendar"
    },
    stakeholderMappingTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.stakeholder-mapping.template",
        defaultMessage: "Stakeholder Mapping"
    },
    rootCauseTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.root-cause.template",
        defaultMessage: "Root Cause Analysis"
    },
    executiveSummaryTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.executive-summary.template",
        defaultMessage: "Executive Summary"
    },
    elevatorPitchTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.product.elevator-pitch.template",
        defaultMessage: "Elevator Pitch"
    }
});
module.exports["i18n"] = $c3887a9c93c500a4$export$a7357cdd1f0b0168;

});

parcelRegister("cgxgV", function(module, exports) {
// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/templateToImgMappings.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint

var $dignY = parcelRequire("dignY");


var $60wYg = parcelRequire("60wYg");

const $88c538ff10921c66$export$e272c57b679d644 = `https://wac-cdn.atlassian.com/misc-assets/webp-images/confluence/templates/taxonomy/`;
const $88c538ff10921c66$export$343b29b08adb8468 = 'https://dam-cdn.atl.orangelogic.com/AssetLink/24jio0s0f10wt00f100x8ka51g80147d.png';
const $88c538ff10921c66$export$e6bc61fd26441f1d = 'https://dam-cdn.atl.orangelogic.com/AssetLink/ka6xb0k673ogce3fr8663jhc11v815cv.svg';
const $88c538ff10921c66$export$ff18b1f7218e1365 = {
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v775766xlw833sa16cqlc03tuw1tflc2.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gt8mxd565jnlxpcla58q6fik18u0o5b2.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/286roqo0x24518bmu83f668tu5dvgms2.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/em34t20hd3k5d3y5lou7ac3pt8nwh53w.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hhhhhjyr0k0tkwqj64550117ytp50i1e.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/v4n83g7myc10be1f0uahh76jls455i8u.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/54i677d21ed42r1d7ws1bfd37nwf36s8.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/16065dh57ba4b022x51r0tkqbd28dl87.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26814iat2a7ndfjrs0uq5i2g0x72867y.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o7sw2x42srn06s00a0esiq788283341p.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/hu6yl738y22o50t0pr2vo4o05wan62n1.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0dn87kk6o66hvf420nfqjg45615k4m73.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3d765023oqb4btu13pj7wdw5343wx6vv.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8i66o10j7qu27884l2c3si1xh0335w14.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l5343a3n0485ax1nh434373xq8g5l6s7.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e1c2vi1r8376b5t834kd607uqt0ymyp.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/cm3igo2rky6iip0h1t3wy67pek85mla5.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/6a51tvn7g1o3tl3vqvg0nsb14p60w77d.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/76p747np1oon57pu221347ohfjvnm180.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/617mv306vsf7w6sp43b6w6pas8xt4djd.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5ks001pi5jng10bnv131n7nu0k40l3xo.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/370bf03j886cokvq31658l4l3w66wv6p.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/30u4108cdrbb83082p01f6810dtf1of4.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w814j2a58v56xuxoi444u5biqctwlhub.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kl7cn5h28ysoc3ti2gwyx6025v2b2nac.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1e56m4o21348hk5j226181v4elqwi0w1.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t520b6d576imhfl70je80l8x8d77bduo.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m3hvi182obpt68vrr0x32k7kpcn7j844.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/b4gx5wo7fsn6we642b242q7188gsq386.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/w2w6e854gvt71756v2q53318t6t3vei3.png',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/5u8b4i1104l3d762gb8023m1itq7l34x.svg'
};
const $88c538ff10921c66$export$72f354715b8d4636 = {
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8y8sc20314pf86r8887x1rh3j57t7v0m.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/a6x7e6e50ynr0m1117k686cu15f702xn.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g0o1ks846i88hr5a3b64682r5om4202q.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).CONCEPT_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/4ywpy0ek1o1o4rwao564k64v15ex4618.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/31t5j2o00j2s7t5ew0n6pr4kp4phvt04.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/o360h3o63u55epg1ai452ds5mms5i8x5.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).EXECUTIVE_SUMMARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ul7j8s4v6o2336il6a781m566t0rr6sc.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FISHBONE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/715fur87612t53h5m4bwg11k5j5w3771.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FLOWCHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/t3mfg1hxryf30du04apjsn3rf6i53ujn.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FOCUS_AREA_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nc8ogfbk5y7nugu56gy14cbk8564k4m1.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).FOURLS_RETRO]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/650c73qh4cx735v8v40530xf4l5gr263.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7a32ce1yafkbwyroef6b5ty6y7684560.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/mg40lr1ans63vk7t0rqwq53hx3mv3x0a.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ICEBREAKERS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8543ywanoenx7v0w2fo57874w081rs50.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).NETWORK_OF_TEAMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dp08ln0x64w03f6855vt5k25xttu8y1y.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ORG_CHART]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/kpq78wcv70g231k70x6083uw1oj35x15.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/qi6q25nj7657c511n5t06gu6a6cf7nk4.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dd47fnm3l1ngnqcie3ad4oj747251s37.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRODUCT_VISION_BOARD]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eu16r33866w646j52x351lpsceof0057.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ROOT_CAUSE_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g1um66bc1q5ia7x04gsdl0rgx87j6jvm.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/fe1f2sv15s3q667sqp4w2l3271qp431y.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/yxsr7cv8cc4ox20f6am0788u13tx8731.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).STAKEHOLDER_MAPPING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dptnm3xu130487m1a3eo1y780g274c38.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SWIMLANES_PROCESS_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3ao2nw5gfffwms6j4w0fd07126007215.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i88nc0mpr1j8m2v045a7s6ik0x827ero.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TEAM_CHARTER_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/i622u0u2h5d2o0b23abf1qx57h36p8a8.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TEAM_HEALTH_MONITOR]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x1687g5ye71fs1qfym3a653nls22g460.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/17uws3bph888pu42v71k12nbq27i4k5a.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1l6gk820v5e7h17h0y4b27sb4l5whvy3.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).WORKFLOW_TEMPLATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1hquucr1ec0b4l1ht06l68sh80r0rs4q.svg',
    [(0, $dignY.WHITEBOARD_TEMPLATE_IDS).ELEVATOR_PITCH]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ltv22274128075mvb5h842f082vd35ik.svg'
};
const $88c538ff10921c66$export$c88a6d0afe4f1305 = {
    [(0, $60wYg.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: '90-day-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'all-hands-meeting',
    [(0, $60wYg.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'annual-plan-one-pager',
    [(0, $60wYg.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'executive-business-review',
    [(0, $60wYg.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'business-status-update',
    [(0, $60wYg.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'business-plan-one-pager',
    [(0, $60wYg.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'career-development-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'competitive-analysis',
    [(0, $60wYg.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'content-design-glossary',
    [(0, $60wYg.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'content-strategy',
    [(0, $60wYg.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'customer-impact-assessment',
    [(0, $60wYg.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'customer-interview-report',
    [(0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'decision',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_DECISION]: 'design-decision',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'design-review',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'design-sprint',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'design-system',
    [(0, $60wYg.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'devops-runbook',
    [(0, $60wYg.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'employee-handbook',
    [(0, $60wYg.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'hr-knowledge-base',
    [(0, $60wYg.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'how-to-article',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'itsm-known-errors',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'itsm-change-management',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'itsm-post-incident-review',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'itsm-runbook',
    [(0, $60wYg.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'incident-communication',
    [(0, $60wYg.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'incident-postmortem',
    [(0, $60wYg.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'job-description',
    [(0, $60wYg.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW]: 'lennys-performance-review',
    [(0, $60wYg.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS]: 'lennys-product-requirements',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_PLAN]: 'marketing-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES]: 'meeting-notes',
    [(0, $60wYg.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'message-house',
    [(0, $60wYg.BLUEPRINT_NAMES).OKRS]: 'okrs',
    [(0, $60wYg.BLUEPRINT_NAMES).PERSONA]: 'persona',
    [(0, $60wYg.BLUEPRINT_NAMES).PRESENTER_MODE]: 'presenter-mode',
    [(0, $60wYg.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'product-requirements',
    [(0, $60wYg.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'product-roadmap',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'project-kickoff',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN]: 'project-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_STATUS]: 'project-status',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE]: 'project-timeline',
    [(0, $60wYg.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'qtc-acquisition',
    [(0, $60wYg.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'remote-team-meeting',
    [(0, $60wYg.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'risk-assessment',
    [(0, $60wYg.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'roles-and-responsibilities',
    [(0, $60wYg.BLUEPRINT_NAMES).SMART_GOALS]: 'smart-goals',
    [(0, $60wYg.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'swot-analysis',
    [(0, $60wYg.BLUEPRINT_NAMES).SALES_PORTAL]: 'sales-portal',
    [(0, $60wYg.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'sales-account-planning',
    [(0, $60wYg.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW]: 'software-architecture-review',
    [(0, $60wYg.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'sprint-planning-meeting',
    [(0, $60wYg.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'stakeholder-communications',
    [(0, $60wYg.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE]: 'sop',
    [(0, $60wYg.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'strategic-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'team-homepage',
    [(0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER]: 'team-poster',
    [(0, $60wYg.BLUEPRINT_NAMES).TO_DO_LIST]: 'to-do-list',
    [(0, $60wYg.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'troubleshooting-article',
    [(0, $60wYg.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'vendor-agreement',
    [(0, $60wYg.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'virtual-event',
    [(0, $60wYg.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'vision-to-values',
    [(0, $60wYg.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'end-of-week-status-report',
    [(0, $60wYg.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'weekly-meeting-notes',
    [(0, $60wYg.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'work-trip-planner',
    [(0, $60wYg.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'workshop-planner',
    [(0, $60wYg.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'writing-guidelines',
    [(0, $60wYg.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'quarterly-check-in',
    [(0, $60wYg.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'aws-architecture-diagram',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'marketing-blog-post',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'marketing-campaign',
    [(0, $60wYg.BLUEPRINT_NAMES).HIRING_PROCESS]: 'hiring-process',
    [(0, $60wYg.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'mutual-action-plan',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'itsm-weekly-major-incident-report',
    [(0, $60wYg.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'disruptive-brainstorming'
};
const $88c538ff10921c66$var$blueprintsWithoutImages = new Set([
    (0, $60wYg.BLUEPRINT_NAMES).STANDARD_OPERATING_PROCEDURE_TEMPLATE,
    (0, $60wYg.BLUEPRINT_NAMES).PROJECT_TIMELINE_TEMPLATE,
    (0, $60wYg.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
    (0, $60wYg.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
    (0, $60wYg.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS,
    (0, $60wYg.BLUEPRINT_NAMES).NON_DISCLOSURE_AGREEMENT
]);
const $88c538ff10921c66$export$3e4521316af54a8c = Object.keys($88c538ff10921c66$export$c88a6d0afe4f1305).reduce((mappings, key)=>{
    mappings[key] = $88c538ff10921c66$var$blueprintsWithoutImages.has(key) ? $88c538ff10921c66$export$343b29b08adb8468 : `${$88c538ff10921c66$export$e272c57b679d644}${$88c538ff10921c66$export$c88a6d0afe4f1305[key]}.svg`;
    return mappings;
}, {});
const $88c538ff10921c66$export$5afae992b84a32d5 = {
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/h4k3b710fj7203m0hj43j3cc425cuy76.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_SPRINT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/olpn6123xee0naxqm57sf3bpnr3mvglw.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_DECISION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1x53580r2xjt08816apkqrwq6g7ga107.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/juc54l2t2c16lx8k1g3e3q1076ckmfng.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).CUSTOMER_INTERVIEW_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0e473ir7jdwlcoyls06uc04iim077741.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).CONTENT_STRATEGY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/m06ipqhy7no6d5ab6qrd7kqfhlggy2ni.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).CONTENT_DESIGN_GLOSSARY]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ayg5h2aq885e62ysr47865rg461uw2we.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ms2f3506w5a41lv6jk38ucy8882yky4e.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).COMPETITIVE_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1s4ovxh8tpsk74g33lmd4ujw0np3o731.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s8644uajks6cw0fj2o0q1e7tf645pjdq.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q7243b5o3jvm6vo3504p7rc8o667pmy6.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/g5y6q6oqf15txlpv1q2m53648sh1888w.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/843prjia43re78n53vh4f1nkvm5lbb43.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/waj1m80wt58g346m3bx1l82cq5fn785e.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2sb43g4320785m6k44k8djm3d7487s01.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).HOW_TO_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/871dux30tosjc8ipe18fr346rmqe4juf.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2atvs27hd5w232sg773008l3q2fssr4o.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).NINETY_DAY_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/eub8wfax8n446u54req1vvq0i5y4ai51.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ALL_HANDS_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/l8c1g33u3a37qc73v4v0ple4bt7582u8.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_KICKOFF]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/q23316jb58686pa5na5l23hp4tmlym5q.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PERSONA]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3288qdj186qk418dt7p3fp5m1ngy1204.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DESIGN_SYSTEMS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3r6x6daq4gj0a8w55gv4l0mi0l2jq676.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DEVOPS_RUNBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/55p8fe88y7345bq5o8ld1wo4b3s6x7fk.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/322w834s7iv5cv55sawmnvnj214165l8.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d154e06qu2wc6f4rvf24qn5q352ni5y5.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x80i888ygwk623tn3b1i1ol70p7v7sa1.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8wx1f2120m7qo2osbgh3m26o0h13b460.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3p11p1kfnqf1xtj2i6282pup7500v5v7.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/07h8i0ldabdfh18e0f3406xfw32fk787.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/un7420lmym06873pxv6i7us28442i30e.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).JOB_DESCRIPTION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3lwqq2rfxv426g7op1js2b8470g26sfu.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/626r1r03m1i01w37o72r6y7n57t0plmq.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PRESENTER_MODE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x763b1j8e1y71f0lh286048tn6q30035.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36p554e65x6ub45035dacj50l08mjpo0.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/p204067765c1yfd83im6hpt7cv4mfkc7.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3sj6n68sjtf332lau0l627qr3ot3qe2v.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/x2n21bdg03i16s3t16tprkv6537446s5.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).QUARTERLY_CHECK_IN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/26a3wch8758m13o012m762xxv25ch8vg.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).SMART_GOALS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/2bf67v33y7f2ln226xipfru2n7kns60b.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).VIRTUAL_EVENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/c0i6b28xct78230ggb358m1047081ww5.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/k4r783xvvwvviw60i728w66g3nl8a1sn.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ok5ycecnech333n2m582ix021r2jy65k.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).TEAM_HOMEPAGE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0rnr6dq077l1x5wx53q036arpk780f2p.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).SWOT_ANALYSIS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wmlg4wd6587651183as8031t301d4o85.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).TO_DO_LIST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1asf3cijux7ga204cbc7qg6ra367nhc7.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).WORK_TRIP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ogmwu64w8pwoxp2ho80nd87kp2x2pa3g.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).WRITING_GUIDELINES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/64524bi14mrls3rem07y1p25hkumv16u.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).WORKSHOP_PLANNER]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/u0nub00c433fl778atn5yhgjoh782l13.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).WEEKLY_MEETING_NOTES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/y0i7w3ks85280ehvpr28lpu5yg3ja0a7.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).VISION_TO_VALUES]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7mx000d02pi8r2ueg3rw7v01lgbj55dp.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PRODUCT_ROADMAP]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0wtr2h661307rsnsoolf1k4502semf22.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).OKRS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/363722lk1ks8ut57cxor25f1d0864170.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/tt73e3c4016001x617mxxitl5g3u1n65.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MESSAGE_HOUSE]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/0b2egux177m04b0dxo628v4m3s103460.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).SALES_PORTAL]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/j233apow7he8t03o2dn0o51g52mnw15j.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).REMOTE_TEAM_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/7cknim011u00041rmw2yw1vr3w65xan1.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).QTC_ACQUISITION]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ek48h0gx82ks3j46480m6c6cu2h1e7wq.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).PROJECT_STATUS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vwpc40ldd857guo662l34831851l8h1x.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).VENDOR_AGREEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/vkq707lue205jypgy6kiy30u650u566x.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).STAKEHOLDER_COMMUNICATIONS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wldn3c51e68086nl43q8wpk1x8yrcg17.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).STRATEGIC_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/d25x120oi2118101kxfmt10aqm2g8cvv.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j1bvq02m82l623fy575sd7of2djd7my.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).AWS_ARCHITECTURE_DIAGRAM]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/3575i1013te6m8sp1xr08f54e8053egq.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_BLOG_POST]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/xfw4001fj343b5k7fteg177lb3175blr.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MARKETING_CAMPAIGN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/70u14cws7507hm18ak4lp7eq5k0a8582.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).HIRING_PROCESS]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/dc3418xr3v7522y6dv4gg636nmvf8y41.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).MUTUAL_ACTION_PLAN]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/gm7gxjca3f0i7eon74md67f57c0r3qq1.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).ITSM_WEEKLY_MAJOR_INCIDENT_REPORT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/57ib28g38e3c0h5tj3ak5fxn3g2ppq7o.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).DISRUPTIVE_BRAINSTORMING]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/38dc3au247c7a030ya5c7f3ajp7131lq.svg',
    [(0, $60wYg.BLUEPRINT_NAMES).NON_DISCLOSURE_AGREEMENT]: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ed8e6w12k8ar4d1523lr3rpx3ys68dhh.svg'
};
module.exports["defaultImgSrc"] = $88c538ff10921c66$export$343b29b08adb8468;
module.exports["defaultDarkImgSrc"] = $88c538ff10921c66$export$e6bc61fd26441f1d;
module.exports["WHITEBOARD_TEMPLATE_TO_IMG_MAPPING"] = $88c538ff10921c66$export$ff18b1f7218e1365;
module.exports["WHITEBOARD_TEMPLATE_TO_DARK_IMG_MAPPING"] = $88c538ff10921c66$export$72f354715b8d4636;
module.exports["BLUEPRINT_NAME_TO_IMG_MAPPING"] = $88c538ff10921c66$export$3e4521316af54a8c;
module.exports["BLUEPRINT_IMG_MAP_DARK"] = $88c538ff10921c66$export$5afae992b84a32d5;

});

parcelRegister("60wYg", function(module, exports) {
// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/blueprintNameMapping.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint
var $853a581dfb6e7381$export$82e276cacb9013c9 = /*#__PURE__*/ function(BLUEPRINT_NAMES) {
    BLUEPRINT_NAMES["NINETY_DAY_PLAN"] = "90-Day Plan";
    BLUEPRINT_NAMES["ALL_HANDS_MEETING"] = "All Hands Meeting";
    BLUEPRINT_NAMES["ANNUAL_PLAN_ONE_PAGER"] = "Annual Plan One-Pager";
    BLUEPRINT_NAMES["EXECUTIVE_BUSINESS_REVIEW"] = "Executive Business Review";
    BLUEPRINT_NAMES["BUSINESS_STATUS_UPDATE"] = "Business Status Update";
    BLUEPRINT_NAMES["BUSINESS_PLAN_ONE_PAGER"] = "Business Plan One-Pager";
    BLUEPRINT_NAMES["CAREER_DEVELOPMENT_PLAN"] = "Career Development Plan";
    BLUEPRINT_NAMES["COMPETITIVE_ANALYSIS"] = "Competitive Analysis";
    BLUEPRINT_NAMES["CONTENT_DESIGN_GLOSSARY"] = "Content Design Glossary";
    BLUEPRINT_NAMES["CONTENT_STRATEGY"] = "Content Strategy";
    BLUEPRINT_NAMES["CUSTOMER_IMPACT_ASSESSMENT"] = "Customer Impact Assessment";
    BLUEPRINT_NAMES["CUSTOMER_INTERVIEW_REPORT"] = "Customer Interview Report";
    BLUEPRINT_NAMES["DACI_DECISION_DOCUMENTATION"] = "DACI: Decision Documentation";
    BLUEPRINT_NAMES["DESIGN_DECISION"] = "Design Decision";
    BLUEPRINT_NAMES["DESIGN_REVIEW"] = "Design Review";
    BLUEPRINT_NAMES["DESIGN_SPRINT"] = "Design Sprint";
    BLUEPRINT_NAMES["DESIGN_SYSTEMS"] = "Design Systems";
    BLUEPRINT_NAMES["DEVOPS_RUNBOOK"] = "DevOps Runbook";
    BLUEPRINT_NAMES["EMPLOYEE_HANDBOOK"] = "Employee Handbook";
    BLUEPRINT_NAMES["HR_KNOWLEDGE_BASE_MANAGEMENT"] = "HR Knowledge Base Management";
    BLUEPRINT_NAMES["HOW_TO_ARTICLE"] = "How-To Article";
    BLUEPRINT_NAMES["ITSM_KNOWN_ERRORS"] = "ITSM Known Errors";
    BLUEPRINT_NAMES["ITSM_CHANGE_MANAGEMENT"] = "ITSM Change Management";
    BLUEPRINT_NAMES["ITSM_POST_INCIDENT_REVIEWS"] = "ITSM Post Incident Reviews";
    BLUEPRINT_NAMES["ITSM_RUNBOOK"] = "ITSM Runbook";
    BLUEPRINT_NAMES["INCIDENT_COMMUNICATION"] = "Incident Communication";
    BLUEPRINT_NAMES["INCIDENT_POSTMORTEM"] = "Incident Postmortem";
    BLUEPRINT_NAMES["JOB_DESCRIPTION"] = "Job Description";
    BLUEPRINT_NAMES["LENNYS_PERFORMANCE_REVIEW"] = "Lenny's Performance Review";
    BLUEPRINT_NAMES["LENNYS_PRODUCT_REQUIREMENTS"] = "Lenny's Product Requirements";
    BLUEPRINT_NAMES["MARKETING_PLAN"] = "Marketing Plan";
    BLUEPRINT_NAMES["MEETING_NOTES"] = "Meeting Notes";
    BLUEPRINT_NAMES["MESSAGE_HOUSE"] = "Message House";
    BLUEPRINT_NAMES["OKRS"] = "OKRs";
    BLUEPRINT_NAMES["PERSONA"] = "Persona";
    BLUEPRINT_NAMES["PRESENTER_MODE"] = "Presenter Mode";
    BLUEPRINT_NAMES["PRODUCT_REQUIREMENTS"] = "Product Requirements";
    BLUEPRINT_NAMES["PRODUCT_ROADMAP"] = "Product Roadmap";
    BLUEPRINT_NAMES["PROJECT_KICKOFF"] = "Project Kickoff";
    BLUEPRINT_NAMES["PROJECT_PLAN"] = "Project Plan";
    BLUEPRINT_NAMES["PROJECT_STATUS"] = "Project Status";
    BLUEPRINT_NAMES["PROJECT_TIMELINE_TEMPLATE"] = "Project Timeline Template";
    BLUEPRINT_NAMES["QTC_ACQUISITION"] = "QTC Acquisition";
    BLUEPRINT_NAMES["QUARTERLY_CHECK_IN"] = "Quarterly Check In";
    BLUEPRINT_NAMES["REMOTE_TEAM_MEETING"] = "Remote Team Meeting";
    BLUEPRINT_NAMES["RISK_ASSESSMENT_MATRIX"] = "Risk Assessment Matrix";
    BLUEPRINT_NAMES["ROLES_AND_RESPONSIBILITIES"] = "Roles and Responsibilities Play";
    BLUEPRINT_NAMES["SMART_GOALS"] = "SMART Goals";
    BLUEPRINT_NAMES["SWOT_ANALYSIS"] = "SWOT Analysis";
    BLUEPRINT_NAMES["SALES_PORTAL"] = "Sales Portal";
    BLUEPRINT_NAMES["SALES_ACCOUNT_PLANNING"] = "Sales Account Planning";
    BLUEPRINT_NAMES["SERVICE_TEAM_HEALTH_MONITOR"] = "Service Team Health Monitor";
    BLUEPRINT_NAMES["SOFTWARE_ARCHITECTURE_REVIEW"] = "Software Architecture Review";
    BLUEPRINT_NAMES["SPRINT_PLANNING_MEETING"] = "Sprint Planning Meeting";
    BLUEPRINT_NAMES["STAKEHOLDER_COMMUNICATIONS"] = "Stakeholder Communications";
    BLUEPRINT_NAMES["STANDARD_OPERATING_PROCEDURE_TEMPLATE"] = "Standard Operating Procedure (SOP) Template";
    BLUEPRINT_NAMES["STRATEGIC_PLAN"] = "Strategic Plan";
    BLUEPRINT_NAMES["TEAM_HOMEPAGE"] = "Team Homepage";
    BLUEPRINT_NAMES["TEAM_POSTER"] = "Team Poster";
    BLUEPRINT_NAMES["TO_DO_LIST"] = "To-Do List";
    BLUEPRINT_NAMES["TROUBLESHOOTING_ARTICLE"] = "Troubleshooting Article";
    BLUEPRINT_NAMES["VENDOR_AGREEMENT"] = "Vendor Agreement";
    BLUEPRINT_NAMES["VIRTUAL_EVENT"] = "Virtual Event";
    BLUEPRINT_NAMES["VISION_TO_VALUES"] = "Vision to Values";
    BLUEPRINT_NAMES["END_OF_WEEK_STATUS_REPORT"] = "End of Week Status Report";
    BLUEPRINT_NAMES["WEEKLY_MEETING_NOTES"] = "Weekly Meeting Notes";
    BLUEPRINT_NAMES["WORK_TRIP_PLANNER"] = "Work Trip Planner";
    BLUEPRINT_NAMES["WORKSHOP_PLANNER"] = "Workshop Planner";
    BLUEPRINT_NAMES["WRITING_GUIDELINES"] = "Writing Guidelines";
    BLUEPRINT_NAMES["AWS_ARCHITECTURE_DIAGRAM"] = "AWS Architecture Diagram";
    BLUEPRINT_NAMES["MARKETING_BLOG_POST"] = "Marketing Blog Post";
    BLUEPRINT_NAMES["MARKETING_CAMPAIGN"] = "Marketing Campaign";
    BLUEPRINT_NAMES["HIRING_PROCESS"] = "Hiring Process";
    BLUEPRINT_NAMES["MUTUAL_ACTION_PLAN"] = "Mutual Action Plan";
    BLUEPRINT_NAMES["ITSM_WEEKLY_MAJOR_INCIDENT_REPORT"] = "ITSM Weekly Major Incident Report";
    BLUEPRINT_NAMES["DISRUPTIVE_BRAINSTORMING"] = "Disruptive Brainstorming";
    BLUEPRINT_NAMES["NON_DISCLOSURE_AGREEMENT"] = "Non-Disclosure Agreement";
    return BLUEPRINT_NAMES;
}({});
const $853a581dfb6e7381$export$c42db12dd3d44bb8 = new Set(Object.values($853a581dfb6e7381$export$82e276cacb9013c9));
const $853a581dfb6e7381$export$d7a793aff6267afc = {
    ["90-Day Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:90-day-plan-item',
        contentBlueprintId: 'b18bd4b0-cb12-4c8a-be83-bb5769b25481'
    },
    ["All Hands Meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:all-hands-meeting-item',
        contentBlueprintId: '67dddaa6-f038-45bf-b21f-8259dcf441db'
    },
    ["Annual Plan One-Pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:annual-plan-one-pager-item',
        contentBlueprintId: '2823fda6-dfb4-4b81-8394-2e19e96b99fb'
    },
    ["Executive Business Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:executive-business-review-item',
        contentBlueprintId: '9433bfd2-c7b2-41cf-b493-d4a1feb39210'
    },
    ["Business Status Update"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-item',
        contentBlueprintId: 'f877653e-87e1-4654-a915-3591b3dd0db3'
    },
    ["Business Plan One-Pager"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-plan-one-pager-item',
        contentBlueprintId: '6db15ae0-081f-4a9b-9936-15dec72492ee'
    },
    ["Career Development Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:career-development-plan-item',
        contentBlueprintId: '2b75697e-04cd-4e68-8eec-c3828a0d8c36'
    },
    ["Competitive Analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:competitive-analysis-item',
        contentBlueprintId: '1f0e6e6e-766b-4e98-9022-90ab4ef6194f'
    },
    ["Content Design Glossary"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-design-glossary-item',
        contentBlueprintId: 'bc251e1b-c784-4593-a360-d5a5bbccd56b'
    },
    ["Content Strategy"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:content-strategy-item',
        contentBlueprintId: '30735803-4a23-40df-9848-1ab97067e66c'
    },
    ["Customer Impact Assessment"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-impact-assessment-item',
        contentBlueprintId: '71a66b1f-49c9-4f9e-87fa-895850e1d2db'
    },
    ["Customer Interview Report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:customer-interview-report-item',
        contentBlueprintId: '5322e0f4-2f85-45f3-8ffe-94fba1d571d8'
    },
    ["DACI: Decision Documentation"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint-item',
        contentBlueprintId: '7edaef4a-329f-47c9-abfe-7e241c9e17ba'
    },
    ["Design Decision"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-item',
        contentBlueprintId: 'fb9933f8-841d-43ea-a872-ef06abd7f725'
    },
    ["Design Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-review-item',
        contentBlueprintId: '22f59064-c993-4fa9-bfd7-6a9e1be0ba4c'
    },
    ["Design Sprint"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-item',
        contentBlueprintId: '3acf77bc-919c-4bd5-a8ee-cf1f045d01d5'
    },
    ["Design Systems"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-systems-item',
        contentBlueprintId: '337e0487-2a9c-4ce9-95b0-4212c228379a'
    },
    ["DevOps Runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:devops-runbook-item',
        contentBlueprintId: 'eb916d7d-a90d-4d18-955b-445e28ce08a5'
    },
    ["Employee Handbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-item',
        contentBlueprintId: '705c6810-8621-4c26-8d4e-ec51c92fd395'
    },
    ["HR Knowledge Base Management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hr-knowledge-base-management-item',
        contentBlueprintId: '62eb020a-ab61-4a64-8f96-788745e1761c'
    },
    ["How-To Article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-how-to-item',
        contentBlueprintId: '74323bcf-829b-4d71-a765-facc886accdd'
    },
    ["ITSM Known Errors"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-known-errors-item',
        contentBlueprintId: '55c00b7d-e8e9-4644-ae6c-08bc4a480b70'
    },
    ["ITSM Change Management"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-change-management-item',
        contentBlueprintId: '0ad3bc27-3852-4166-af6b-d5ffe48060e9'
    },
    ["ITSM Post Incident Reviews"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-pir-item',
        contentBlueprintId: '0d50396d-ca50-4c57-90aa-91dea817d4db'
    },
    ["ITSM Runbook"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-item',
        contentBlueprintId: '9866346f-4709-4ae3-ba43-05bd2c30f689'
    },
    ["Incident Communication"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-communication-item',
        contentBlueprintId: '45175536-78b0-4f59-a44c-47b0994037d0'
    },
    ["Incident Postmortem"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:incident-management-post-mortem-item',
        contentBlueprintId: '08117408-2841-483d-a2f6-7fe1c8985b8d'
    },
    ["Job Description"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:job-description-item',
        contentBlueprintId: '2571ed8f-b86b-4f30-aadd-997bbb259906'
    },
    ["Lenny's Performance Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-performance-review-item',
        contentBlueprintId: '8c187053-1bc6-4fef-a9f1-3d22e02b94b4'
    },
    ["Lenny's Product Requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:lennys-product-requirements-item',
        contentBlueprintId: '245dd102-5d0f-41a2-b26c-048d43b60005'
    },
    ["Marketing Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-item',
        contentBlueprintId: '857e112e-50f1-4a24-b4f5-d6a717e4e279'
    },
    ["Meeting Notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-item',
        contentBlueprintId: 'ec8ecc7e-7e4b-4f8a-aa3f-a6a7f2df4ac9'
    },
    ["Message House"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:message-house-template-item',
        contentBlueprintId: '43864f05-5531-44c1-b54b-66b97993fc9f'
    },
    ["OKRs"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:okr-item',
        contentBlueprintId: '1e2fb2f7-e6d6-4825-8f1e-47033a15bd52'
    },
    ["Persona"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:persona-item',
        contentBlueprintId: '181f2ea7-5fd6-4cbc-aa8f-d314f62c2483'
    },
    ["Presenter Mode"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:presenter-mode-item',
        contentBlueprintId: 'b414482f-1bd4-460e-bf14-8607879a93cb'
    },
    ["Product Requirements"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-item',
        contentBlueprintId: '4443a61a-9a9a-4712-b81e-a84e3ae51554'
    },
    ["Product Roadmap"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:product-roadmap-item',
        contentBlueprintId: '72f7004a-2f37-4ea4-a95f-2daade784d58'
    },
    ["Project Kickoff"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-kickoff-item',
        contentBlueprintId: '4342057b-f7b0-4385-9317-2b8de25ee952'
    },
    ["Project Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-item',
        contentBlueprintId: 'f7a9afa1-19c0-4558-abd4-f8060829f9fc'
    },
    ["Project Status"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-item',
        contentBlueprintId: 'a2484be7-df58-4f17-a347-2fecb7b22bb9'
    },
    ["Project Timeline Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-timeline-item',
        contentBlueprintId: 'ecd39da6-2163-4ea4-b6c7-280b7662681b'
    },
    ["QTC Acquisition"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:qtc-acquisition-item',
        contentBlueprintId: 'feafa3b9-bf33-46af-9452-1fbcbe36e0a2'
    },
    ["Remote Team Meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:remote-team-meeting-item',
        contentBlueprintId: '5a273376-0251-49ca-9ee8-197e643bdfd3'
    },
    ["Risk Assessment Matrix"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:risk-assessment-item',
        contentBlueprintId: '7f67b5e5-fd5e-4517-9006-0775f3f2f8ec'
    },
    ["Roles and Responsibilities Play"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:roles-responsibilities-item',
        contentBlueprintId: 'be29e5eb-fbe7-4213-b16f-5fb25b13f2d8'
    },
    ["SMART Goals"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:smart-goals-item',
        contentBlueprintId: 'e97d646a-8b86-4561-9daf-ae7ee2de4a19'
    },
    ["SWOT Analysis"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:swot-analysis-item',
        contentBlueprintId: '2f7a20e6-4b0d-478f-96cf-1f093470f571'
    },
    ["Sales Portal"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-item',
        contentBlueprintId: '985c2d47-6f30-4a58-915a-3103786a9f8f'
    },
    ["Sales Account Planning"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-item',
        contentBlueprintId: 'cd9f6877-6926-4f48-b178-0d897b70b99c'
    },
    ["Software Architecture Review"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-item',
        contentBlueprintId: 'd1e47ac0-cc06-4699-a939-b012a4ead2f8'
    },
    ["Sprint Planning Meeting"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sprint-planning-meeting-item',
        contentBlueprintId: '611f84bb-1b6e-4a35-ba13-b67fdbeebfb6'
    },
    ["Stakeholder Communications"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:stakeholder-communications-item',
        contentBlueprintId: 'b6c3445f-bbc5-4de3-8b06-919619d9a82f'
    },
    ["Standard Operating Procedure (SOP) Template"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-item',
        contentBlueprintId: '14d6eb8f-cac0-494c-a22d-0e41bd76e9f9'
    },
    ["Strategic Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-strategy-item',
        contentBlueprintId: '43da1e9b-652d-4a0c-9570-cfdcbfc38c10'
    },
    ["Team Homepage"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-homepage-item',
        contentBlueprintId: 'c9160e85-fb5c-4502-a6b9-c39c3f8f9d2a'
    },
    ["Team Poster"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:team-poster-item',
        contentBlueprintId: '2e0ddf37-d490-4bc8-9476-0597d928fe06'
    },
    ["To-Do List"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:to-do-list-item',
        contentBlueprintId: 'c5ad620d-c78d-4d72-84aa-adf07798dc81'
    },
    ["Troubleshooting Article"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-item',
        contentBlueprintId: 'e864ea83-270e-47de-b573-b21d1cc537cd'
    },
    ["Vendor Agreement"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vendor-agreement-item',
        contentBlueprintId: '9f11fe97-3ee7-43d7-8ad0-05253c80c12e'
    },
    ["Virtual Event"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:virtual-event-item',
        contentBlueprintId: '65012d82-c253-41de-8875-552cb92baa1d'
    },
    ["Vision to Values"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:vision-to-values-item',
        contentBlueprintId: '00361a2d-c2c9-4670-9cfc-49d8c4126122'
    },
    ["End of Week Status Report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:eow-status-report-item',
        contentBlueprintId: '6873d89c-765f-4677-b370-048005c7470b'
    },
    ["Weekly Meeting Notes"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:recurring-meeting-minutes-item',
        contentBlueprintId: '7c19a101-d13e-4d67-870b-279e6342c6bc'
    },
    ["Work Trip Planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:work-trip-planner-item',
        contentBlueprintId: 'b3c70113-a13a-4419-b906-7cac93bcd092'
    },
    ["Workshop Planner"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:workshop-planner-item',
        contentBlueprintId: 'e9889133-019b-4283-a4d2-9f916081cc76'
    },
    ["Writing Guidelines"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:writing-guideline-item',
        contentBlueprintId: '0193f684-d07b-4af1-af11-7dc20d7d7bc4'
    },
    ["Quarterly Check In"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:quarterly-check-in-item',
        contentBlueprintId: 'e2a1cea6-c5e7-4de1-b397-862efddc17d8'
    },
    ["AWS Architecture Diagram"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:aws-architecture-diagram-item',
        contentBlueprintId: '777e5e10-8151-411b-9d3a-e18c32e1ccf9'
    },
    ["Marketing Blog Post"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blog-post-item',
        contentBlueprintId: '77b5e06c-c8a6-4fa5-b104-69b4b2c3006d'
    },
    ["Marketing Campaign"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-item',
        contentBlueprintId: '4254b414-5ba3-4178-85fd-03c93166d92b'
    },
    ["Hiring Process"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-item',
        contentBlueprintId: '29e1a62b-919d-4a1d-9325-ab26e1539bba'
    },
    ["Mutual Action Plan"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:mutual-action-plan-item',
        contentBlueprintId: 'cd7d12fc-79c5-45fc-97e0-275b5fe09063'
    },
    ["ITSM Weekly Major Incident Report"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-weekly-major-incident-report-item',
        contentBlueprintId: '00917469-8d47-4375-8148-8f6e42db13a6'
    },
    ["Disruptive Brainstorming"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:disrupt-brainstorming-item',
        contentBlueprintId: '01e2cb00-2daf-41d8-aec2-e409c985bcbb'
    },
    ["Non-Disclosure Agreement"]: {
        blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:non-disclosure-agreement-blueprint',
        itemModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:non-disclosure-agreement-item',
        contentBlueprintId: 'd4f5e6a7-8b9c-4d0e-9f1a-2b3c4d5e6f7g'
    }
};
module.exports["BLUEPRINT_NAMES"] = $853a581dfb6e7381$export$82e276cacb9013c9;
module.exports["BLUEPRINT_NAME_TO_IDS_MAPPING"] = $853a581dfb6e7381$export$d7a793aff6267afc;

});

parcelRegister("3ISyM", function(module, exports) {
// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/defaultPopularTemplates.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint

var $60wYg = parcelRequire("60wYg");


var $dignY = parcelRequire("dignY");

const $746f8d64df21bb40$export$2c95017061b2237f = [
    (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
    (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
    (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
    (0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER,
    (0, $60wYg.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
    (0, $60wYg.BLUEPRINT_NAMES).PRESENTER_MODE,
    (0, $60wYg.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
    (0, $60wYg.BLUEPRINT_NAMES).TO_DO_LIST
];
module.exports["DEFAULT_POPULAR_TEMPLATES"] = $746f8d64df21bb40$export$2c95017061b2237f;

});

parcelRegister("cf2U8", function(module, exports) {
/*
 * Duplicated from @confluence/create-blank-fabric-page to avoid a circular dependency —
 * this experiment package must be a dependency of create-blank-fabric-page, so we can't
 * import from it. If this experiment wins, we should revisit the package structure.
 */ 
var $c3Qwv = parcelRequire("c3Qwv");


var $1NBp8 = parcelRequire("1NBp8");


var $hQnHK = parcelRequire("hQnHK");

var $12a81c98c7b02b40$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["LIVE"] = "LIVE";
    return ConfluencePageSubType;
}({});
const $12a81c98c7b02b40$var$queryParamKeys = {
    subType: 'subType',
    spaceKey: 'spaceKey',
    parentPageId: 'parentPageId',
    source: 'source',
    withFallback: 'withFallback',
    insertTemplateWithKey: (0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM),
    templateKey: 'templateKey',
    /* Created By Flow Analytic contributes to Core Actions/FO and should sometimes be disabled
	(ex: user going through onboarding may be firing this event during onboarding screens and should not contribute to KR metric)*/ disableCreatedByFlowAnalytic: 'dcbfa'
};
const $12a81c98c7b02b40$var$SUPPORTED_CONTENT_TYPES = [
    'page',
    'whiteboard'
];
const $12a81c98c7b02b40$export$b3086acbf0304043 = (options)=>{
    const queryParams = {};
    if ('subType' in options && options.subType) queryParams[$12a81c98c7b02b40$var$queryParamKeys.subType] = options.subType;
    if ('spaceKey' in options && options.spaceKey) queryParams[$12a81c98c7b02b40$var$queryParamKeys.spaceKey] = options.spaceKey;
    if ('parentPageId' in options && options.parentPageId) queryParams[$12a81c98c7b02b40$var$queryParamKeys.parentPageId] = options.parentPageId;
    if ('withFallback' in options && options.withFallback) queryParams[$12a81c98c7b02b40$var$queryParamKeys.withFallback] = options.withFallback;
    if ('source' in options && options.source) queryParams[$12a81c98c7b02b40$var$queryParamKeys.source] = options.source;
    if ((0, $hQnHK.INSERT_TEMPLATE_WITH_KEY_QUERY_PARAM) in options && options.insertTemplateWithKey) queryParams[$12a81c98c7b02b40$var$queryParamKeys.insertTemplateWithKey] = options.insertTemplateWithKey;
    if ('templateKey' in options && options.templateKey) queryParams[$12a81c98c7b02b40$var$queryParamKeys.templateKey] = options.templateKey;
    if ('disableCreatedByFlowAnalytic' in options && options.disableCreatedByFlowAnalytic) queryParams[$12a81c98c7b02b40$var$queryParamKeys.disableCreatedByFlowAnalytic] = options.disableCreatedByFlowAnalytic;
    return (0, $1NBp8.CREATE_CONTENT).toUrl({
        contentType: options.contentType
    }, {
        query: queryParams
    });
};
const $12a81c98c7b02b40$export$67c4cee80a3410cd = (queryParams)=>{
    const subType = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.subType);
    const spaceKey = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.spaceKey);
    const parentPageId = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.parentPageId);
    const withFallback = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.withFallback) ? true : undefined;
    const source = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.source);
    const insertTemplateWithKey = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.insertTemplateWithKey) ?? undefined;
    const templateKey = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.templateKey);
    const disableCreatedByFlowAnalytic = (0, $c3Qwv.getSingleParam)(queryParams, $12a81c98c7b02b40$var$queryParamKeys.disableCreatedByFlowAnalytic) === 'true';
    return {
        subType: subType,
        spaceKey: spaceKey,
        parentPageId: parentPageId,
        withFallback: withFallback,
        source: source,
        insertTemplateWithKey: insertTemplateWithKey,
        templateKey: templateKey,
        disableCreatedByFlowAnalytic: disableCreatedByFlowAnalytic
    };
};
module.exports["ConfluencePageSubType"] = $12a81c98c7b02b40$export$c5ec0cc4d455d1c8;
module.exports["buildCreationLink"] = $12a81c98c7b02b40$export$b3086acbf0304043;

});

parcelRegister("94mMM", function(module, exports) {
// Copied from @confluence/experiment-personalized-templates-v2/src/mappings/teamToTemplatesMapping.ts
// to avoid circular dependency with @confluence/experiment-cfind-5291-template-touchpoint

var $60wYg = parcelRequire("60wYg");


var $dignY = parcelRequire("dignY");

const $94d6ea964f1701e4$export$eaa4084616ac3256 = {
    'SOFTWARE DEVELOPMENT': [
        (0, $60wYg.BLUEPRINT_NAMES).PRODUCT_REQUIREMENTS,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $60wYg.BLUEPRINT_NAMES).SOFTWARE_ARCHITECTURE_REVIEW,
        (0, $60wYg.BLUEPRINT_NAMES).DEVOPS_RUNBOOK,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).FLOWCHART,
        (0, $60wYg.BLUEPRINT_NAMES).SPRINT_PLANNING_MEETING,
        (0, $60wYg.BLUEPRINT_NAMES).INCIDENT_POSTMORTEM
    ],
    'CUSTOMER SERVICE': [
        (0, $60wYg.BLUEPRINT_NAMES).CUSTOMER_IMPACT_ASSESSMENT,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).SERVICE_BLUEPRINT,
        (0, $60wYg.BLUEPRINT_NAMES).INCIDENT_COMMUNICATION,
        (0, $60wYg.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $60wYg.BLUEPRINT_NAMES).SMART_GOALS,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES
    ],
    'IT SUPPORT': [
        (0, $60wYg.BLUEPRINT_NAMES).HOW_TO_ARTICLE,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).ITSM_KNOWN_ERRORS,
        (0, $60wYg.BLUEPRINT_NAMES).TROUBLESHOOTING_ARTICLE,
        (0, $60wYg.BLUEPRINT_NAMES).ITSM_POST_INCIDENT_REVIEWS,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $60wYg.BLUEPRINT_NAMES).ITSM_RUNBOOK,
        (0, $60wYg.BLUEPRINT_NAMES).ITSM_CHANGE_MANAGEMENT
    ],
    'PRODUCT MANAGEMENT': [
        (0, $60wYg.BLUEPRINT_NAMES).LENNYS_PRODUCT_REQUIREMENTS,
        (0, $60wYg.BLUEPRINT_NAMES).PRODUCT_ROADMAP,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).PRIORITIZATION_MATRIX,
        (0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $60wYg.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    'PROJECT MANAGEMENT': [
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).STRATEGIC_PLAN,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).SIMPLE_RETROSPECTIVE,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $60wYg.BLUEPRINT_NAMES).ROLES_AND_RESPONSIBILITIES,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_KICKOFF
    ],
    DESIGN: [
        (0, $60wYg.BLUEPRINT_NAMES).DESIGN_SYSTEMS,
        (0, $60wYg.BLUEPRINT_NAMES).DESIGN_SPRINT,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).DISRUPTIVE_BRAINSTORM,
        (0, $60wYg.BLUEPRINT_NAMES).CONTENT_STRATEGY,
        (0, $60wYg.BLUEPRINT_NAMES).DESIGN_DECISION,
        (0, $60wYg.BLUEPRINT_NAMES).PERSONA,
        (0, $60wYg.BLUEPRINT_NAMES).DESIGN_REVIEW,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).CRAZY_8S_BRAINSTORMING,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP
    ],
    MARKETING: [
        (0, $60wYg.BLUEPRINT_NAMES).MARKETING_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $60wYg.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $60wYg.BLUEPRINT_NAMES).PERSONA,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).TIMELINE_WORKFLOW
    ],
    SALES: [
        (0, $60wYg.BLUEPRINT_NAMES).SALES_PORTAL,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $60wYg.BLUEPRINT_NAMES).SALES_ACCOUNT_PLANNING,
        (0, $60wYg.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW
    ],
    OPERATIONS: [
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).GAP_ANALYSIS,
        (0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $60wYg.BLUEPRINT_NAMES).ANNUAL_PLAN_ONE_PAGER,
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).ANNUAL_CALENDAR,
        (0, $60wYg.BLUEPRINT_NAMES).SWOT_ANALYSIS,
        (0, $60wYg.BLUEPRINT_NAMES).ALL_HANDS_MEETING,
        (0, $60wYg.BLUEPRINT_NAMES).STRATEGIC_PLAN
    ],
    RESEARCH: [
        (0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).USER_STORY_MAP,
        (0, $60wYg.BLUEPRINT_NAMES).PERSONA,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $60wYg.BLUEPRINT_NAMES).PRESENTER_MODE
    ],
    FINANCE: [
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_STATUS_UPDATE,
        (0, $60wYg.BLUEPRINT_NAMES).BUSINESS_PLAN_ONE_PAGER,
        (0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_STATUS,
        (0, $60wYg.BLUEPRINT_NAMES).VENDOR_AGREEMENT,
        (0, $60wYg.BLUEPRINT_NAMES).QTC_ACQUISITION,
        (0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $60wYg.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX
    ],
    'HUMAN RESOURCES': [
        (0, $60wYg.BLUEPRINT_NAMES).HR_KNOWLEDGE_BASE_MANAGEMENT,
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).ORG_CHART,
        (0, $60wYg.BLUEPRINT_NAMES).EMPLOYEE_HANDBOOK,
        (0, $60wYg.BLUEPRINT_NAMES).CAREER_DEVELOPMENT_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).JOB_DESCRIPTION,
        (0, $60wYg.BLUEPRINT_NAMES).TEAM_POSTER,
        (0, $60wYg.BLUEPRINT_NAMES).NINETY_DAY_PLAN,
        (0, $60wYg.BLUEPRINT_NAMES).LENNYS_PERFORMANCE_REVIEW,
        (0, $60wYg.BLUEPRINT_NAMES).VISION_TO_VALUES
    ],
    LEGAL: [
        (0, $60wYg.BLUEPRINT_NAMES).DACI_DECISION_DOCUMENTATION,
        (0, $60wYg.BLUEPRINT_NAMES).RISK_ASSESSMENT_MATRIX,
        (0, $60wYg.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $60wYg.BLUEPRINT_NAMES).EXECUTIVE_BUSINESS_REVIEW,
        (0, $60wYg.BLUEPRINT_NAMES).NON_DISCLOSURE_AGREEMENT
    ],
    OTHER: [
        (0, $60wYg.BLUEPRINT_NAMES).PROJECT_PLAN,
        (0, $dignY.WHITEBOARD_TEMPLATE_IDS).BRAINWRITING,
        (0, $60wYg.BLUEPRINT_NAMES).MEETING_NOTES,
        (0, $60wYg.BLUEPRINT_NAMES).TO_DO_LIST,
        (0, $60wYg.BLUEPRINT_NAMES).END_OF_WEEK_STATUS_REPORT,
        (0, $60wYg.BLUEPRINT_NAMES).PRESENTER_MODE
    ]
};
module.exports["teamToTemplatesMapping"] = $94d6ea964f1701e4$export$eaa4084616ac3256;

});

parcelRegister("kLDhO", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $5e58f79b8f1ae92b$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    modalTitle: {
        id: "experiment-cfind-5291-template-touchpoint.modal.title",
        defaultMessage: "We recommend these for you"
    },
    modalSubtitle: {
        id: "experiment-cfind-5291-template-touchpoint.modal.subtitle",
        defaultMessage: "Skip the setup and jump into a template to get started."
    },
    startBlankDoc: {
        id: "experiment-cfind-5291-template-touchpoint.modal.start-blank-doc",
        defaultMessage: "Start blank doc"
    },
    viewMoreTemplates: {
        id: "experiment-cfind-5291-template-touchpoint.modal.view-more-templates",
        defaultMessage: "View more templates"
    },
    closeModal: {
        id: "experiment-cfind-5291-template-touchpoint.modal.close",
        defaultMessage: "Close"
    },
    buttonUseTemplate: {
        id: "experiment-cfind-5291-template-touchpoint.modal.use-template",
        defaultMessage: "Use template"
    },
    closeModalLabel: {
        id: "experiment-cfind-5291-template-touchpoint.modal.close-label",
        defaultMessage: "Close modal"
    },
    startBlankDocLabel: {
        id: "experiment-cfind-5291-template-touchpoint.modal.start-blank-doc-label",
        defaultMessage: "Start blank document"
    },
    viewMoreTemplatesLabel: {
        id: "experiment-cfind-5291-template-touchpoint.modal.view-more-templates-label",
        defaultMessage: "View more templates"
    },
    whiteboardTemplateType: {
        id: "experiment-cfind-5291-template-touchpoint.whiteboard.template",
        defaultMessage: "Whiteboard"
    },
    pageTemplateType: {
        id: "experiment-cfind-5291-template-touchpoint.page.template",
        defaultMessage: "Page"
    },
    livePageTemplateType: {
        id: "experiment-cfind-5291-template-touchpoint.livepage.template",
        defaultMessage: "Doc"
    },
    templateCardAriaLabel: {
        id: "experiment-cfind-5291-template-touchpoint.modal.template-card-aria-label",
        defaultMessage: "Use {templateName} {contentType} template"
    }
});
module.exports["messages"] = $5e58f79b8f1ae92b$export$defe85febe8b728c;

});

parcelRegister("jzeHS", function(module, exports) {

var $b5q5u = parcelRequire("b5q5u");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $jMyy4 = parcelRequire("jMyy4");


var $8Lx5S = parcelRequire("8Lx5S");


var $bQm3c = parcelRequire("bQm3c");


var $gKr8t = parcelRequire("gKr8t");


var $94mMM = parcelRequire("94mMM");

const $1b91c98d6851bc21$var$VALID_TEAM_TYPES = Object.keys((0, $94mMM.teamToTemplatesMapping));
const $1b91c98d6851bc21$var$userTeamTypeQuery = (0, $b5q5u.default);
const $1b91c98d6851bc21$var$sanitizeTeamType = (teamType)=>{
    if (teamType && $1b91c98d6851bc21$var$VALID_TEAM_TYPES.includes(teamType)) return teamType;
    return undefined;
};
const $1b91c98d6851bc21$export$a9464bd05a64f2ad = ({ skip: skip } = {})=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const isLicensed = (0, $8Lx5S.useIsLicensed)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($1b91c98d6851bc21$var$userTeamTypeQuery, {
        variables: {
            userId: userId ?? ''
        },
        skip: skip || !isLicensed || !userId,
        client: (0, $gKr8t.getAGGClient)()
    });
    (0, $42omo.useEffect)(()=>{
        if (error) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'useUserTeamTypeQuery',
                source: 'useUserTeamType',
                attributes: {
                    message: error.message
                }
            }
        }).fire();
    }, [
        error,
        createAnalyticsEvent
    ]);
    if (loading) return {
        teamType: undefined,
        loading: true
    };
    if (error) return {
        teamType: undefined,
        loading: false,
        error: error
    };
    if (data?.user?.__typename === 'AtlassianAccountUser') return {
        teamType: $1b91c98d6851bc21$var$sanitizeTeamType(data.user.extendedProfile?.teamType?.toLocaleUpperCase()),
        loading: false
    };
    return {
        teamType: undefined,
        loading: false
    };
};
module.exports["useUserTeamType"] = $1b91c98d6851bc21$export$a9464bd05a64f2ad;

});

parcelRegister("b5q5u", function(module, exports) {
/**
 * @generated SignedSource<<4011eeb67d0c619c2887bad7d89d2ab4>>
 * @relayHash cc0f905acfe076b52018f89b1c5fa989
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c5aac52eff11674d800fb04341e8f918b3a93a31f28e55cdcf500aa760dc3395
const $7605f7af3cedc26c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "userId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "accountId",
            "variableName": "userId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v3 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "teamType"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useUserTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useUserTeamTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "cc0f905acfe076b52018f89b1c5fa989",
            "id": "c5aac52eff11674d800fb04341e8f918b3a93a31f28e55cdcf500aa760dc3395",
            "metadata": {},
            "name": "useUserTeamTypeQuery",
            "operationKind": "query",
            "text": "query useUserTeamTypeQuery($userId:ID!){user(accountId:$userId){__typename,...on AtlassianAccountUser{extendedProfile{teamType}},id}}"
        }
    };
}();
$7605f7af3cedc26c$var$node.hash = "90d6d6a7b806d870aeb5c8bcfdbe2e97";
var $7605f7af3cedc26c$export$2e2bcd8739ae039 = $7605f7af3cedc26c$var$node;
module.exports["default"] = $7605f7af3cedc26c$export$2e2bcd8739ae039;

});

parcelRegister("9t4Ph", function(module, exports) {

var $imN4Q = parcelRequire("imN4Q");


var $jMyy4 = parcelRequire("jMyy4");

const $21298dd9a3e27546$var$allTemplatesQuery = (0, $imN4Q.default);
const $21298dd9a3e27546$export$ffe95a820e18b9ac = (data)=>{
    const map = {};
    data?.allTemplates?.nodes?.forEach((template)=>{
        if (template?.blueprintModuleCompleteKey && template?.name) map[template.blueprintModuleCompleteKey] = template.name;
    });
    return map;
};
const $21298dd9a3e27546$export$5505005d84848396 = ({ skip: skip } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($21298dd9a3e27546$var$allTemplatesQuery, {
        skip: skip
    });
    const blueprintModuleKeyToLocalizedName = $21298dd9a3e27546$export$ffe95a820e18b9ac(data);
    return {
        blueprintModuleKeyToLocalizedName: blueprintModuleKeyToLocalizedName,
        loading: loading,
        error: error
    };
};
module.exports["useAllTemplatesQuery"] = $21298dd9a3e27546$export$5505005d84848396;

});

parcelRegister("imN4Q", function(module, exports) {
/**
 * @generated SignedSource<<49ae61db93536fc3923a21da797ce8c3>>
 * @relayHash db7a79ee3194134302fd2cc2da01380f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 05d1a25330f3cd8aee55c6402834ce3342dfe15073f4a3d92ba25bb04b50c727
const $fd26ba0f16c04d64$var$node = function() {
    var v0 = [
        {
            "args": [
                {
                    "kind": "Literal",
                    "name": "usePersonalSpace",
                    "value": true
                }
            ],
            "concreteType": "PaginatedTemplateInfoList",
            "kind": "LinkedField",
            "name": "allTemplates",
            "plural": false,
            "selections": [
                {
                    "concreteType": "TemplateInfo",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "blueprintModuleCompleteKey"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "name"
                        }
                    ]
                }
            ],
            "storageKey": "allTemplates(usePersonalSpace:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useAllTemplatesQuery",
            "selections": v0 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useAllTemplatesQuery",
            "selections": v0 /*: any*/ 
        },
        "params": {
            "cacheID": "db7a79ee3194134302fd2cc2da01380f",
            "id": "05d1a25330f3cd8aee55c6402834ce3342dfe15073f4a3d92ba25bb04b50c727",
            "metadata": {},
            "name": "useAllTemplatesQuery",
            "operationKind": "query",
            "text": "query useAllTemplatesQuery{allTemplates(usePersonalSpace:true){nodes{blueprintModuleCompleteKey,name}}}"
        }
    };
}();
$fd26ba0f16c04d64$var$node.hash = "e18a58b29526e42df25c1b26a711b68f";
var $fd26ba0f16c04d64$export$2e2bcd8739ae039 = $fd26ba0f16c04d64$var$node;
module.exports["default"] = $fd26ba0f16c04d64$export$2e2bcd8739ae039;

});

parcelRegister("eRRx0", function(module, exports) {
/*
 * Duplicated from @confluence/create-blank-fabric-page to avoid a circular dependency —
 * this experiment package must be a dependency of create-blank-fabric-page, so we can't
 * import from it. If this experiment wins, we should revisit the package structure.
 */ 
var $42omo = parcelRequire("42omo");


var $dHSeC = parcelRequire("dHSeC");


var $dPJCf = parcelRequire("dPJCf");

const $bed7f317b17c16a3$export$7947243b7b7e6ed9 = (href)=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const matchRoute = (0, $dPJCf.useMatchRoute)();
    return (0, $42omo.useCallback)((event)=>{
        const isSpaTransition = !!(0, $dHSeC.getSpaTransitionDetails)(event, {
            matchRoute: matchRoute
        });
        if (isSpaTransition && href) {
            event.preventDefault();
            push(href);
        }
    }, [
        matchRoute,
        push,
        href
    ]);
};
module.exports["useHybridLinkClick"] = $bed7f317b17c16a3$export$7947243b7b7e6ed9;

});

parcelRegister("7bdcb", function(module, exports) {
/* TemplateCard.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $gj7hi = parcelRequire("gj7hi");


var $ccHMk = parcelRequire("ccHMk");


var $inPa6 = parcelRequire("inPa6");


var $cgxgV = parcelRequire("cgxgV");


var $eRRx0 = parcelRequire("eRRx0");


var $kLDhO = parcelRequire("kLDhO");

const $20ec452621de9e06$var$previewContainerStyles = null;
const $20ec452621de9e06$var$previewImageStyles = null;
const $20ec452621de9e06$var$blurredImageStyles = null;
const $20ec452621de9e06$var$overlayStyles = null;
const $20ec452621de9e06$var$overlayVisibleStyles = null;
const $20ec452621de9e06$var$headingOverrideStyles = null;
const $20ec452621de9e06$var$cardStyles = {
    mainContainer: "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itia51 _2rko12b0 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c1txw _2lx21bp4 _1bsb1osq _4t3imgvx _bfhkhp5a _9oik1r31 _1bnxglyw _jf4cnqa1 _1dbzt7xp",
    textContainer: "_1yt4utpp _zulp1b66 _1e0c1txw _2lx21bp4 _bfhkhfxm _mrkb12b0 _1o0z12b0",
    subTextContainer: "_zulpu2gc _1e0c1txw"
};
const $20ec452621de9e06$export$ba340e850b866867 = ({ name: name, contentType: contentType, contentTypeLabel: contentTypeLabel, contentTypeIcon: contentTypeIcon, imageSource: imageSource, imageSourceDark: imageSourceDark, createLink: createLink, templateId: templateId, onClose: onClose })=>{
    const [isHovered, setIsHovered] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState(false);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hybridLinkClick = (0, $eRRx0.useHybridLinkClick)(createLink);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useCallback((e)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'cfind-5291-template-touchpoint',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'templateCard',
                attributes: {
                    templateId: templateId,
                    contentType: contentType
                }
            }
        }).fire();
        onClose?.();
        hybridLinkClick(e);
    }, [
        onClose,
        hybridLinkClick,
        templateId,
        contentType,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
        href: createLink ?? '#',
        onMouseEnter: ()=>setIsHovered(true),
        onMouseLeave: ()=>setIsHovered(false),
        onClick: handleClick,
        xcss: $20ec452621de9e06$var$cardStyles.mainContainer,
        "aria-label": formatMessage((0, $kLDhO.messages).templateCardAriaLabel, {
            templateName: name,
            contentType: contentTypeLabel
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _kqswh2mm _4t3i68cl _1bsb1osq _13li12b0 _qrwq12b0"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
        src: imageSource ?? (0, $cgxgV.defaultImgSrc),
        srcDark: imageSourceDark ?? (0, $cgxgV.defaultDarkImgSrc),
        alt: "",
        className: (0, $gMc0m.default)([
            "_v5646juh _189eidpf _4t3i1osq _1bsb1osq",
            isHovered && "_kdam1p0y"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_v5641hrg _kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1e0c1txw _4cvr1h6o _1bah1h6o _tzy4idpf _lcxvglyw",
            isHovered && "_tzy4kb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        appearance: "primary",
        tabIndex: -1,
        "aria-hidden": true
    }, formatMessage((0, $kLDhO.messages).buttonUseTemplate)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $20ec452621de9e06$var$cardStyles.textContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        title: name,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _1bsb1osq _p12f1osq _y3gn1e5h"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        size: "large",
        weight: "bold"
    }, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
        xcss: $20ec452621de9e06$var$cardStyles.subTextContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, contentTypeIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", null, contentTypeLabel)))));
};
module.exports["TemplateCard"] = $20ec452621de9e06$export$ba340e850b866867;

});

parcelRegister("jqe2L", function(module, exports) {
/* eslint-disable check-file/filename-blocklist */ 
var $jiJCD = parcelRequire("jiJCD");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $9wGTI = parcelRequire("9wGTI");

const $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled = ()=>{
    return (0, $9wGTI.fg)('confluence_frontend_fabric_editor_blank_page') || (0, $9wGTI.fg)('confluence_frontend_fabric_editor_all_pages');
};
const $350735cb5bb3c1ba$export$9d03777b293b05ce = ()=>{
    return $350735cb5bb3c1ba$var$isCreateBlankPageInFabricEnabled();
};
const $350735cb5bb3c1ba$export$c8780cd30055dcb8 = (parentPageResponse, creationSpaceKey)=>{
    // parent page is in the selected space
    const spaceKey = parentPageResponse?.content?.nodes?.[0]?.space?.key;
    if (spaceKey !== creationSpaceKey) return false;
    // ancestors must be of the same content Type
    const contentType = parentPageResponse?.content?.nodes?.[0]?.type;
    if (contentType !== 'page') return false;
    // parent page must not be archived
    const status = parentPageResponse?.content?.nodes?.[0]?.status;
    if (status === 'archived') return false;
    // must have create access under the parent page
    const operations = parentPageResponse?.content?.nodes?.[0]?.operations;
    const hasCreateOperation = operations && operations.find((op)=>op?.targetType === 'page' && op.operation === 'create');
    return !!hasCreateOperation;
};
const $350735cb5bb3c1ba$export$4c6171230e6eef02 = (overrideValue, defaultValue)=>{
    return {
        value: overrideValue || defaultValue,
        usedOverride: !!overrideValue
    };
};
const $350735cb5bb3c1ba$export$a0b32aef6b0d7373 = (urlToChange, params, updateEditorMode)=>{
    updateEditorMode?.('create-page');
    const urlComponents = (0, $jiJCD.parse)(urlToChange, true);
    return (0, $jiJCD.format)({
        ...urlComponents,
        // remove `search`, otherwise
        // `query` will be ignored
        search: undefined,
        query: {
            ...urlComponents.query,
            ...params
        }
    });
};
const $350735cb5bb3c1ba$export$f59f47d22cf7d84d = (url)=>{
    if (!url) throw new Error('No url for new content');
    if (url.startsWith((0, $jlIaF.CONTEXT_PATH))) return url;
    return `${0, $jlIaF.CONTEXT_PATH}${url}`;
};
const $350735cb5bb3c1ba$export$cca9db3da8f2e4f8 = ({ spaceKey: spaceKey, contentId: contentId, url: url, type: type = 'page' })=>{
    const legacyDraftRouteMatch = (0, $1NBp8.RESUME_DRAFT_LEGACY).match(url);
    const draftShareId = legacyDraftRouteMatch?.query?.draftShareId || '';
    const editV2Url = type === 'blogpost' ? (0, $1NBp8.EDIT_BLOG_V2).toUrl({
        contentType: 'blog',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    }) : (0, $1NBp8.EDIT_PAGE_V2).toUrl({
        contentType: 'pages',
        spaceKey: spaceKey,
        contentId: contentId
    }, {
        query: {
            draftShareId: draftShareId
        }
    });
    return $350735cb5bb3c1ba$export$f59f47d22cf7d84d(editV2Url);
};
const $350735cb5bb3c1ba$export$b47a1345d675bf12 = (error, messageMatches)=>{
    if (error && 'graphQLErrors' in error) return error.graphQLErrors?.some(({ message: message })=>messageMatches.some((messageMatch)=>message.includes(messageMatch)));
    return false;
};
module.exports["isCreateBlankFabricPageEnabled"] = $350735cb5bb3c1ba$export$9d03777b293b05ce;
module.exports["appendQueryParams"] = $350735cb5bb3c1ba$export$a0b32aef6b0d7373;
module.exports["processDraftUrl"] = $350735cb5bb3c1ba$export$f59f47d22cf7d84d;
module.exports["getEditPageUrl"] = $350735cb5bb3c1ba$export$cca9db3da8f2e4f8;
module.exports["graphqlErrorHasMessage"] = $350735cb5bb3c1ba$export$b47a1345d675bf12;

});

parcelRegister("fywGr", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $6mKj3 = parcelRequire("6mKj3");


var $5cryL = parcelRequire("5cryL");


var $8Z78B = parcelRequire("8Z78B");


var $1k2r8 = parcelRequire("1k2r8");

const $7aae32df106d9977$export$864cb1c5b7b9b39 = ()=>{
    // When the centralized onboarding state experiment is enabled, use the centralized preloader
    // to ensure all onboarding state queries hit the cache.
    if ((0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return (0, $1k2r8.preloadAllOnboardingState)();
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: Object.values((0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS))
        }
    });
};
module.exports["preloadEditorOnboardingState"] = $7aae32df106d9977$export$864cb1c5b7b9b39;

});

parcelRegister("1k2r8", function(module, exports) {

var $dYU3e = parcelRequire("dYU3e");


var $9xoMO = parcelRequire("9xoMO");


var $8Z78B = parcelRequire("8Z78B");

const $2daa64592339f2ce$export$ce5c629ae8376218 = ()=>{
    return (0, $dYU3e.query)({
        query: (0, $8Z78B.default),
        variables: {
            key: (0, $9xoMO.OnboardingKeysCombined)
        }
    });
};
module.exports["preloadAllOnboardingState"] = $2daa64592339f2ce$export$ce5c629ae8376218;

});

parcelRegister("7yn0t", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $4ri4I = parcelRequire("4ri4I");


var $58PBI = parcelRequire("58PBI");

const $41894bf31b7b5c77$export$c6419170331da813 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { children: children, editSource: t1 } = t0;
    const editSource = t1 === undefined ? "" : t1;
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext));
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [t2, t3] = (0, $4ri4I.useEditSource)();
    const { editSource: contextEditSource } = t2;
    const { setEditSource: setEditSource } = t3;
    let t4;
    if ($[0] !== editSource || $[1] !== setEditSource) {
        t4 = ()=>{
            setEditSource(editSource);
            setDoPreload(true);
        };
        $[0] = editSource;
        $[1] = setEditSource;
        $[2] = t4;
    } else t4 = $[2];
    const onHover = t4;
    let t5;
    if ($[3] !== children || $[4] !== onHover) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            onMouseEnter: onHover,
            onFocus: onHover
        }, children);
        $[3] = children;
        $[4] = onHover;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== contextEditSource || $[7] !== doPreload || $[8] !== editSource || $[9] !== preloader) {
        t6 = editSource === contextEditSource && doPreload && preloader ? preloader({}) : null;
        $[6] = contextEditSource;
        $[7] = doPreload;
        $[8] = editSource;
        $[9] = preloader;
        $[10] = t6;
    } else t6 = $[10];
    let t7;
    if ($[11] !== t5 || $[12] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, t5, t6);
        $[11] = t5;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
};
module.exports["CreateContentButtonPreloader"] = $41894bf31b7b5c77$export$c6419170331da813;

});

parcelRegister("58PBI", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $037500d910957a1c$var$noop = ()=>null;
const $037500d910957a1c$export$2dc50c54ef05578f = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext($037500d910957a1c$var$noop);
$037500d910957a1c$export$2dc50c54ef05578f.displayName = 'EditContentButtonPreloaderContext';
module.exports["EditContentButtonPreloaderContext"] = $037500d910957a1c$export$2dc50c54ef05578f;

});

parcelRegister("7DERG", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $b0c65948d0a153f5$export$92e41deae5b713d0 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "c07Cp",
    name: 'ConfluenceSmartCreationModalLoader',
    loader: async ()=>(await (parcelRequire("gXz7g"))).ConfluenceSmartCreationModalManager
});
module.exports["ConfluenceSmartCreationModalLoader"] = $b0c65948d0a153f5$export$92e41deae5b713d0;

});

parcelRegister("gXz7g", function(module, exports) {

let $c58d65637ab6e9ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c58d65637ab6e9ee$var$load("gs8si").then(()=>parcelRequire('iaA9H'));

});

parcelRegister("6g41Q", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $14f8b7ba4c44a126$export$5389b57fe2014013 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "grVUL",
    name: "EngagementInlineDialogLoaderNav3",
    loader: async ()=>(await (parcelRequire("g8JXt"))).EngagementInlineDialogWrapper
});

const $14f8b7ba4c44a126$export$96098f07afe80f94 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xXIQx",
    name: "EngagementInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("g8JXt"))).EngagementInlineDialogWrapper
});
module.exports["EngagementInlineDialogLoaderNav3"] = $14f8b7ba4c44a126$export$5389b57fe2014013;
module.exports["EngagementInlineDialogLoader"] = $14f8b7ba4c44a126$export$96098f07afe80f94;

});

parcelRegister("g8JXt", function(module, exports) {

let $0308465f38a4ffa1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0308465f38a4ffa1$var$load("b8oHe").then(()=>parcelRequire('1Q21q'));

});

parcelRegister("gWntw", function(module, exports) {

let $c55445ca5243fd9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c55445ca5243fd9a$var$load("iYF63"),
    $c55445ca5243fd9a$var$load("6wr18"),
    $c55445ca5243fd9a$var$load("kFEyO"),
    $c55445ca5243fd9a$var$load("iBQD9"),
    $c55445ca5243fd9a$var$load("hLjS5"),
    $c55445ca5243fd9a$var$load("48rvp"),
    $c55445ca5243fd9a$var$load("iMSgb"),
    $c55445ca5243fd9a$var$load("ffEVr"),
    $c55445ca5243fd9a$var$load("7EorR"),
    $c55445ca5243fd9a$var$load("hhss7"),
    $c55445ca5243fd9a$var$load("dnVDi")
]).then(()=>parcelRequire('ePUmE'));

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<3919502493e84e68af871b81db7a95f6>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("yuV6Z", function(module, exports) {
const $378a693b2c26358e$export$ca6dda5263526f75 = '/gateway/api/emoji';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $378a693b2c26358e$var$isServerEnvironment = ()=>false; // "1" true || "" false || undefined false
const $378a693b2c26358e$var$isClientEnvironment = ()=>!!window.__SSR_RENDERED__;
const $378a693b2c26358e$export$756c07819e5ddb69 = (cloudId, emojiId, scale)=>`${$378a693b2c26358e$export$ca6dda5263526f75}/${cloudId}/${emojiId}/path?scale=${scale ?? 'MDPI'}`;
const $378a693b2c26358e$export$761bef4dd134445c = (params)=>{
    const { isSSR: isSSR, hasCloudId: hasCloudId, isGuestUser: isGuestUser } = params;
    const ssrEnabled = !!(isSSR && hasCloudId);
    // SSR Not Supported
    if (!ssrEnabled || isGuestUser) return false;
    // SSR For Logged in Users
    return true;
};
const $378a693b2c26358e$export$fc7d38d59502d4a6 = ({ onEmojiLoadSuccess: onEmojiLoadSuccess, onEmojiLoadFail: onEmojiLoadFail })=>{
    if (!onEmojiLoadSuccess && !onEmojiLoadFail) return undefined;
    return {
        onEmojiLoadSuccess: onEmojiLoadSuccess,
        onEmojiLoadFail: onEmojiLoadFail
    };
};
const $378a693b2c26358e$export$91e66df277b39831 = (emojiId)=>{
    const { id: id, shortName: shortName } = emojiId;
    const regexp = new RegExp(/:([^:]+):/g); // tests and takes the value between two colons
    if (id) return id;
    if (regexp.test(shortName)) return shortName.replaceAll(':', '');
    return shortName;
};
const $378a693b2c26358e$export$1dcae2834e6255a2 = (params)=>{
    // Feature enabled flags
    const isSSR = $378a693b2c26358e$var$isServerEnvironment() || $378a693b2c26358e$var$isClientEnvironment();
    const isGuestUser = !params.isLicensed || !params.isLoggedIn;
    // Transform parameters
    const cloudId = params?.cloudId ?? '';
    const userId = params?.userId ?? undefined;
    const disableUpload = params?.disableUpload;
    const emojiSSRConfig = params?.emojiSSRConfig ?? {};
    // Enable emoji ssr
    const useEmojiSSR = $378a693b2c26358e$export$761bef4dd134445c({
        isSSR: isSSR,
        hasCloudId: !!cloudId,
        isGuestUser: isGuestUser
    });
    // Default emoji SSR interface
    const emojiSSRConfigOverride = useEmojiSSR ? {
        optimisticImageApi: {
            getUrl: (emojiId)=>$378a693b2c26358e$export$756c07819e5ddb69(cloudId, $378a693b2c26358e$export$91e66df277b39831(emojiId))
        },
        ...emojiSSRConfig
    } : undefined;
    // Enable emoji load callbacks
    const emojiLoadCallbacks = $378a693b2c26358e$export$fc7d38d59502d4a6({
        onEmojiLoadSuccess: params?.onEmojiLoadSuccess,
        onEmojiLoadFail: params?.onEmojiLoadFail
    });
    return {
        cloudId: cloudId,
        userId: userId,
        disableUpload: disableUpload,
        ...useEmojiSSR && {
            emojiSSRConfig: emojiSSRConfigOverride
        },
        emojiLoadCallbacks: emojiLoadCallbacks
    };
};
module.exports["getOptimisticImageURL"] = $378a693b2c26358e$export$756c07819e5ddb69;
module.exports["getEmojiSSRSupport"] = $378a693b2c26358e$export$761bef4dd134445c;
module.exports["createEmojiProviderParameters"] = $378a693b2c26358e$export$1dcae2834e6255a2;

});

parcelRegister("bS81H", function(module, exports) {
/**
 * @generated SignedSource<<38cc20dc6cd248133b23f322b59216e7>>
 * @relayHash 611f36fd3ab140915814f503f8503110
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8
const $5a2ebb253ede159a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "action"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentStatus"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentVersion"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "Confluence_dataSecurityPolicy",
            "kind": "LinkedField",
            "name": "dataSecurityPolicy",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "action",
                            "variableName": "action"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentId",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentStatus",
                            "variableName": "contentStatus"
                        },
                        {
                            "kind": "Variable",
                            "name": "contentVersion",
                            "variableName": "contentVersion"
                        },
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "concreteType": "DataSecurityPolicyDecision",
                    "kind": "LinkedField",
                    "name": "isActionEnabledForContent",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "action"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "allowed"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "611f36fd3ab140915814f503f8503110",
            "id": "97be9875eda07a3755479859d908d73b01a8526a1d7d39ebe7c437e3317987f8",
            "metadata": {},
            "name": "graphqlHelpersDSPIsActionEnabledForContentQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersDSPIsActionEnabledForContentQuery($action:DataSecurityPolicyAction!,$contentId:ID!,$contentStatus:DataSecurityPolicyDecidableContentStatus!,$contentVersion:Int!,$spaceKey:String){dataSecurityPolicy{isActionEnabledForContent(action:$action,contentId:$contentId,contentStatus:$contentStatus,contentVersion:$contentVersion,spaceKey:$spaceKey){action,allowed}}}"
        }
    };
}();
$5a2ebb253ede159a$var$node.hash = "c488c053b9896d7e6d5b6c4474dd396b";
var $5a2ebb253ede159a$export$2e2bcd8739ae039 = $5a2ebb253ede159a$var$node;
module.exports["default"] = $5a2ebb253ede159a$export$2e2bcd8739ae039;

});

parcelRegister("loiTn", function(module, exports) {
$parcel$export(module.exports, "default", () => $48d42f44838c1016$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $48d42f44838c1016$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $42omo.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $42omo.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("52EPl", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ccHMk = parcelRequire("ccHMk");


var $4JWgN = parcelRequire("4JWgN");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $loiTn = parcelRequire("loiTn");


var $ghftu = parcelRequire("ghftu");


var $16xFS = parcelRequire("16xFS");


var $dh538 = parcelRequire("dh538");


var $lGgRw = parcelRequire("lGgRw");


var $dTk3A = parcelRequire("dTk3A");


var $4hF42 = parcelRequire("4hF42");


var $rTIrg = parcelRequire("rTIrg");


var $nVQ0B = parcelRequire("nVQ0B");


var $dhBFe = parcelRequire("dhBFe");


var $6XsRH = parcelRequire("6XsRH");

const $58fceacc21a186da$var$MAX_HEIGHT = `calc(100vh - 16px)`;
const $58fceacc21a186da$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $58fceacc21a186da$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${crossAxis}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}`,
            `${$58fceacc21a186da$var$opposites[mainAxis]}-${$58fceacc21a186da$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-start`,
        `${$58fceacc21a186da$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
function $58fceacc21a186da$var$isKeyboardEvent(event) {
    return event !== null && (event instanceof KeyboardEvent || 'nativeEvent' in event && event.nativeEvent instanceof KeyboardEvent);
}
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $58fceacc21a186da$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $ee7An.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, returnFocusRef: returnFocusRef, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $dTk3A.layers).modal(), label: label, interactionName: interactionName, strategy: strategy, menuLabel: menuLabel, shouldPreventEscapePropagation: shouldPreventEscapePropagation = false })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $6mkwk.default)(isOpen, ()=>defaultOpen);
    const triggerRef = (0, $42omo.useRef)(null);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $42omo.useState)(false);
    const id = (0, $6XsRH.default)();
    const itemRef = (0, $dhBFe.default)();
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    const fallbackPlacements = (0, $42omo.useMemo)(()=>$58fceacc21a186da$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $42omo.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onOpenChange,
        itemRef
    ]);
    const handleOnClose = (0, $42omo.useCallback)((event, currentLevel)=>{
        const isTabLeftOrEscapeKey = $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT));
        // Stop propagation on ESCAPE or Left arrow if shouldPreventEscapePropagation is true
        if (shouldPreventEscapePropagation && $58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) event.stopPropagation();
        if (event !== null && !isTabLeftOrEscapeKey && event.target instanceof HTMLElement && event.target.closest?.(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`)) {
            // Check if it is within dropdown and it is a trigger button
            // if it is a nested dropdown, clicking trigger won't close the dropdown
            // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
            if (!currentLevel) return;
            // if currentLevel is provided, we will compare with the given item's level
            // when it is available and larger than currentLevel, we will proceed the close behavior
            const toCloseLevel = itemRef.current?.dataset['ds-Level'];
            if (toCloseLevel && Number(toCloseLevel) < currentLevel) return;
        }
        // transfer focus to the element specified by ref
        // if ref is not provided, use old behavior:
        // focus on trigger when <Esc> or <Shift+Tab> is pressed
        if (returnFocusRef) requestAnimationFrame(()=>{
            returnFocusRef.current?.focus();
        });
        else if ($58fceacc21a186da$var$isKeyboardEvent(event) && (event.key === 'Tab' && event.shiftKey || event.key === 'Escape' || event.key === (0, $4JWgN.KEY_LEFT))) requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        else if (triggerRef.current) {
            // Don't focus the trigger if the click was outside of the menu
            const isClickOutsideMenu = event?.target instanceof HTMLElement && event.target.closest?.('[role="menu"]') === null;
            const shouldPreventFocus = isClickOutsideMenu && document.activeElement !== document.body; // except if clicking on the body
            if (!shouldPreventFocus) requestAnimationFrame(()=>{
                triggerRef.current?.focus();
            });
        }
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        returnFocusRef,
        setLocalIsOpen,
        shouldPreventEscapePropagation
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $loiTn.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $42omo.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $ee7An.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $ee7An.default;
        return (0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $6XsRH.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $4JWgN.KEY_DOWN) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $4JWgN.KEY_SPACE) || e.key === (0, $4JWgN.KEY_ENTER)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $4JWgN.KEY_TAB) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer,
        // When shouldFitContainer is true, `fixed` positions are not allowed
        strategy: strategy !== 'fixed' ? strategy : undefined
    } : {
        shouldRenderToParent: shouldRenderToParent,
        strategy: strategy
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $nVQ0B.default), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $lGgRw.default), {
            id: isLocalOpen ? id : undefined,
            shouldFlip: shouldFlip,
            isOpen: isLocalOpen,
            shouldReturnFocus: // If returnFocusRef is provided, we **don't** want to return focus to the trigger.
            // Otherwise, Popup will focus on the dropdown trigger after the `returnFocusRef` element is focused.
            returnFocusRef === undefined,
            onClose: handleOnClose,
            zIndex: zIndex,
            placement: placement,
            role: shouldRenderToParent && currentLevel > 0 && (0, $dh538.fg)('platform-dst-nested-dropdown-menu-role') ? 'group' : undefined,
            fallbackPlacements: fallbackPlacements,
            testId: testId && `${testId}--content`,
            shouldUseCaptureOnOutsideClick: true,
            ...conditionalProps,
            shouldDisableFocusLock: true,
            trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
            ...rest })=>{
                if (typeof trigger === 'function') return trigger({
                    'aria-controls': ariaControls,
                    'aria-expanded': ariaExpanded,
                    'aria-haspopup': ariaHasPopup,
                    ...rest,
                    ...bindFocus,
                    triggerRef: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    isSelected: isLocalOpen,
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`
                });
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                    ...bindFocus,
                    ref: (0, $3654r.default)([
                        ref,
                        triggerRef,
                        itemRef
                    ]),
                    "aria-controls": ariaControls,
                    "aria-expanded": ariaExpanded,
                    "aria-haspopup": ariaHasPopup,
                    isSelected: isLocalOpen,
                    iconAfter: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
                            ...iconProps,
                            size: "small"
                        }),
                    onClick: handleTriggerClicked,
                    testId: testId && `${testId}--trigger`,
                    "aria-label": label,
                    interactionName: interactionName,
                    children: trigger
                });
            },
            content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $4hF42.default), {
                    onClose: handleOnClose,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $rTIrg.default), {
                        spacing: spacing,
                        maxHeight: $58fceacc21a186da$var$MAX_HEIGHT,
                        maxWidth: shouldFitContainer ? undefined : 800,
                        onClose: handleOnClose,
                        onUpdate: update,
                        isLoading: isLoading,
                        statusLabel: statusLabel,
                        setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                        shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                        isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                        autoFocus: autoFocus,
                        testId: testId && `${testId}--menu-wrapper`,
                        menuLabel: menuLabel,
                        children: children
                    })
                })
        })
    });
};
var $58fceacc21a186da$export$2e2bcd8739ae039 = $58fceacc21a186da$var$DropdownMenu;
module.exports["default"] = $58fceacc21a186da$export$2e2bcd8739ae039;

});

parcelRegister("4hF42", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $ee7An = parcelRequire("ee7An");


var $16xFS = parcelRequire("16xFS");


var $ijhQY = parcelRequire("ijhQY");

const $72bf3d2a48c5b2ec$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $42omo.createContext)({
    menuItemRefs: [],
    registerRef: (0, $ee7An.default)
});
/**
 * Focus manager logic.
 */ const $72bf3d2a48c5b2ec$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $42omo.useRef)([]);
    // Used to force a re-render only
    const [refresh, setRefresh] = (0, $42omo.useState)(0);
    const registerMode = (0, $42omo.useRef)('ordered');
    registerMode.current = 'ordered';
    const registerRef = (0, $42omo.useCallback)((ref)=>{
        if (menuItemRefs.current.includes(ref)) return;
        switch(registerMode.current){
            case 'ordered':
                menuItemRefs.current.push(ref);
                break;
            case 'unordered':
                // Reset and force a rerender
                registerMode.current = 'regenerate';
                menuItemRefs.current = [];
                setRefresh(refresh + 1);
                break;
            case 'regenerate':
                break;
            default:
                throw new Error(`Unexpected case of ${registerMode.current}`);
        }
    }, // Updating register ref on force reload will cause `useRegisterItemWithFocusManager` to re-register
    [
        refresh
    ]);
    const { isLayerDisabled: isLayerDisabled, currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    // Root menu (from a button) is at level 1; first submenu is at level 2. ARIA: Left only closes submenus.
    const isNestedMenu = currentLevel > 1;
    // Intentionally rebinding on each render
    (0, $42omo.useEffect)(()=>{
        if (registerMode.current === 'ordered') // Use effect is called after rendering is complete and useEffects of the children a called first
        registerMode.current = 'unordered';
    });
    (0, $42omo.useEffect)(()=>(0, $fFa3V.bind)(window, {
            type: 'keydown',
            listener: (0, $ijhQY.default)(menuItemRefs, isLayerDisabled, onClose, isNestedMenu)
        }), [
        isLayerDisabled,
        onClose,
        isNestedMenu
    ]);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($72bf3d2a48c5b2ec$export$f18c1d4fc7326096.Provider, {
        value: contextValue,
        children: children
    });
};
var $72bf3d2a48c5b2ec$export$2e2bcd8739ae039 = $72bf3d2a48c5b2ec$var$FocusManager;
module.exports["FocusManagerContext"] = $72bf3d2a48c5b2ec$export$f18c1d4fc7326096;
module.exports["default"] = $72bf3d2a48c5b2ec$export$2e2bcd8739ae039;

});

parcelRegister("ijhQY", function(module, exports) {
$parcel$export(module.exports, "default", () => $8cb43cdb6098a100$export$2e2bcd8739ae039);

var $4JWgN = parcelRequire("4JWgN");


var $dh538 = parcelRequire("dh538");


var $6XsRH = parcelRequire("6XsRH");

const $8cb43cdb6098a100$var$actionMap = {
    [(0, $4JWgN.KEY_DOWN)]: 'next',
    [(0, $4JWgN.KEY_UP)]: 'prev',
    [(0, $4JWgN.KEY_HOME)]: 'first',
    [(0, $4JWgN.KEY_END)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx + 1 === refs.length) currentFocusedIdx = 0;
        else currentFocusedIdx++;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $8cb43cdb6098a100$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    for(let i = 0; i < refs.length - 1; i++){
        if (currentFocusedIdx === 0) currentFocusedIdx = refs.length - 1;
        else currentFocusedIdx--;
        const { current: element } = refs[currentFocusedIdx];
        const isValid = !!element && !element.hasAttribute('disabled');
        if (isValid) return element;
    }
    return;
};
function $8cb43cdb6098a100$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose, isNestedMenu = false) {
    return (e)=>{
        const currentRefs = refs.current ?? [];
        const currentFocusedIdx = currentRefs.findIndex(({ current: el })=>el && document.activeElement?.isSameNode(el));
        if ((0, $dh538.fg)('platform_dst_popup-disable-focuslock')) {
            // if we use a popup as a nested dropdown, we must prevent the dropdown from closing.
            const isNestedDropdown = !!document.activeElement?.closest(`[id^=${(0, $6XsRH.PREFIX)}]`);
            if (isLayerDisabled() && isNestedDropdown) {
                if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
                // if it is a nested dropdown and the level of the given dropdown is not the current level,
                // we don't need to have focus on it
                return;
            }
        } else if (isLayerDisabled()) {
            if (e.key === (0, $4JWgN.KEY_TAB) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        // Left arrow: only in a submenu — close and return focus to parent. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_LEFT)) {
            e.preventDefault();
            if (isNestedMenu) onClose(e);
            return;
        }
        // Right arrow: only when item has submenu — open it. No navigation within menu.
        if (e.key === (0, $4JWgN.KEY_RIGHT)) {
            const activeElement = document.activeElement;
            if (activeElement instanceof HTMLElement && (activeElement.getAttribute('aria-haspopup') === 'true' || activeElement.getAttribute('aria-haspopup') === 'menu')) {
                e.preventDefault();
                activeElement.click();
            }
            return;
        }
        const action = $8cb43cdb6098a100$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const nextFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, currentFocusedIdx);
                nextFocusableElement?.focus();
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                const prevFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentFocusedIdx);
                prevFocusableElement?.focus();
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const firstFocusableElement = $8cb43cdb6098a100$var$getNextFocusableElement(currentRefs, -1);
                firstFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const lastFocusableElement = $8cb43cdb6098a100$var$getPrevFocusableElement(currentRefs, currentRefs.length);
                lastFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});

parcelRegister("6XsRH", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec4c4b23458ff7f$export$2e2bcd8739ae039);

var $c0qxy = parcelRequire("c0qxy");

const $6ec4c4b23458ff7f$export$8a682ae47622dbb9 = 'ds--dropdown--';
function $6ec4c4b23458ff7f$export$2e2bcd8739ae039() {
    const id = (0, $c0qxy.useId)();
    return `${$6ec4c4b23458ff7f$export$8a682ae47622dbb9}${id}`;
}
module.exports["PREFIX"] = $6ec4c4b23458ff7f$export$8a682ae47622dbb9;

});

parcelRegister("rTIrg", function(module, exports) {
/* menu-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $2SlZp = parcelRequire("2SlZp");


var $dh538 = parcelRequire("dh538");


var $gdv5Z = parcelRequire("gdv5Z");


var $9hlns = parcelRequire("9hlns");


var $51SOF = parcelRequire("51SOF");


var $4AsMp = parcelRequire("4AsMp");


var $4hF42 = parcelRequire("4hF42");

const $b799d0b248957a2a$var$styles = {
    spinnerContainer: "_1e0c1txw _1ul91lit _1bah1h6o _1q51v47k _y4tiv47k _85i5v47k _bozgv47k"
};
const $b799d0b248957a2a$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b799d0b248957a2a$var$styles.spinnerContainer,
        role: "menuitem",
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
            size: "small",
            label: statusLabel,
            testId: testId
        })
    });
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $b799d0b248957a2a$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus, menuLabel: menuLabel })=>{
    const { menuItemRefs: menuItemRefs } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDescendant = menuItemRefs.some((menuItemRef)=>{
            const { current: menuItem } = menuItemRef;
            if (!menuItem) return false;
            const isCheckboxOrRadio = (0, $51SOF.default)(menuItem) || (0, $4AsMp.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDescendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $42omo.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $42omo.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.map(({ current: current })=>current).find((el)=>!!el && !el.hasAttribute('disabled')) ?? null;
        if (((0, $dh538.fg)('platform_dst_menu_item_focus') || shouldRenderToParent) && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2SlZp.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`,
        menuLabel: menuLabel,
        children: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)($b799d0b248957a2a$var$LoadingIndicator, {
            statusLabel: statusLabel,
            testId: testId && `${testId}--loading-indicator`
        }) : children
    });
};
var $b799d0b248957a2a$export$2e2bcd8739ae039 = $b799d0b248957a2a$var$MenuWrapper;
module.exports["default"] = $b799d0b248957a2a$export$2e2bcd8739ae039;

});

parcelRegister("51SOF", function(module, exports) {
$parcel$export(module.exports, "default", () => $e12d4b588eba9c45$export$2e2bcd8739ae039);
function $e12d4b588eba9c45$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("4AsMp", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b1db4379970383b$export$2e2bcd8739ae039);
function $9b1db4379970383b$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});

parcelRegister("nVQ0B", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $02b3fc6de2f24ae9$export$756f795847463ebd = /*#__PURE__*/ (0, $42omo.createContext)({
    setItemState: (0, $ee7An.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $ee7An.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $02b3fc6de2f24ae9$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $42omo.useRef)({});
    const context = (0, $42omo.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsx)($02b3fc6de2f24ae9$export$756f795847463ebd.Provider, {
        value: context,
        children: children
    });
};
var $02b3fc6de2f24ae9$export$2e2bcd8739ae039 = $02b3fc6de2f24ae9$var$SelectionStore;
module.exports["SelectionStoreContext"] = $02b3fc6de2f24ae9$export$756f795847463ebd;
module.exports["default"] = $02b3fc6de2f24ae9$export$2e2bcd8739ae039;

});

parcelRegister("dhBFe", function(module, exports) {
// eslint-disable-next-line sort-imports

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4hF42 = parcelRequire("4hF42");

// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programmatically
// control focus on a user navigates using the keyboard.
function $167560b2a39794c6$var$useRegisterItemWithFocusManager(hasPopup = false) {
    const { registerRef: registerRef } = (0, $42omo.useContext)((0, $4hF42.FocusManagerContext));
    const itemRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        if (hasPopup && (0, $dh538.fg)('select-avoid-duplicated-registered-ref')) return;
        registerRef(itemRef);
    }, [
        registerRef,
        hasPopup
    ]);
    return itemRef;
}
var $167560b2a39794c6$export$2e2bcd8739ae039 = $167560b2a39794c6$var$useRegisterItemWithFocusManager;
module.exports["default"] = $167560b2a39794c6$export$2e2bcd8739ae039;

});

parcelRegister("dAYOx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $56M4r = parcelRequire("56M4r");


var $d77M1 = parcelRequire("d77M1");


var $cGtPE = parcelRequire("cGtPE");


var $dhBFe = parcelRequire("dhBFe");

/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item/usage)
 */ const $cdf608dda9733d23$var$DropdownMenuItem = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, role: role, ...rest }, ref)=>{
    // if the dropdown item has aria-haspopup, we won't register with focus manager
    // since it is a nested trigger, we have registered inside dropdown-menu
    const itemRef = (0, $dhBFe.default)(!!rest['aria-haspopup']);
    const handleItemClick = (0, $42omo.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, $l998X.jsx)((0, $d77M1.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else if (href) return /*#__PURE__*/ (0, $l998X.jsx)((0, $cGtPE.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        interactionName: interactionName,
        ...rest,
        children: children
    });
    else return /*#__PURE__*/ (0, $l998X.jsx)((0, $56M4r.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $3654r.default)([
            ref,
            itemRef
        ]),
        role: role || 'menuitem',
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        interactionName: interactionName,
        ...rest,
        children: children
    });
});
var $cdf608dda9733d23$export$2e2bcd8739ae039 = $cdf608dda9733d23$var$DropdownMenuItem;
module.exports["default"] = $cdf608dda9733d23$export$2e2bcd8739ae039;

});

parcelRegister("ahaN7", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $7rvPL = parcelRequire("7rvPL");


var $2UQGL = parcelRequire("2UQGL");

/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $88990be4c91574c4$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, ...rest }, ref)=>{
    const uid = (0, $c0qxy.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $7rvPL.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        ...rest,
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $2UQGL.default), {
                id: titleId,
                title: title
            }),
            children
        ]
    });
});
var $88990be4c91574c4$export$2e2bcd8739ae039 = $88990be4c91574c4$var$DropdownMenuItemGroup;
module.exports["default"] = $88990be4c91574c4$export$2e2bcd8739ae039;

});

parcelRegister("2UQGL", function(module, exports) {
/* group-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

const $19018ee1ec1e6aca$var$styles = {
    heading: "_11c8i4vh _1rjcze3t _18zrpxbi _syazazsu"
};
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $19018ee1ec1e6aca$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        xcss: $19018ee1ec1e6aca$var$styles.heading,
        children: title
    });
var $19018ee1ec1e6aca$export$2e2bcd8739ae039 = $19018ee1ec1e6aca$var$GroupTitle;
module.exports["default"] = $19018ee1ec1e6aca$export$2e2bcd8739ae039;

});

parcelRegister("bRPo1", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $e569016d63746a22$var$baseStyles = null;
const $e569016d63746a22$var$justifyStartStyles = null;
const $e569016d63746a22$var$justifyEndStyles = null; /**
                                * __Tag group__
                                *
                                * A tag group controls the layout and alignment for a collection of tags.
                                *
                                * - [Examples](https://atlassian.design/components/tag-group/examples)
                                * - [Code](https://atlassian.design/components/tag-group/code)
                                * - [Usage](https://atlassian.design/components/tag-group/usage)
                                */ 
const $e569016d63746a22$var$TagGroup = /*#__PURE__*/ (0, $42omo.forwardRef)(({ alignment: alignment = 'start', titleId: titleId, label: label, children: children }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "group",
        ref: ref,
        "aria-label": label,
        "aria-labelledby": titleId,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _1n261g80",
            alignment === 'start' && "_1bah1y6m",
            alignment === 'end' && "_1bahesu3"
        ]),
        children: children
    });
});
var $e569016d63746a22$export$2e2bcd8739ae039 = $e569016d63746a22$var$TagGroup;
module.exports["default"] = $e569016d63746a22$export$2e2bcd8739ae039;

});

parcelRegister("4IoVL", function(module, exports) {
/* eslint-disable import-extensions/file-extension-required */ 
var $eGqQQ = parcelRequire("eGqQQ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $2TuWI = parcelRequire("2TuWI");


var $kzNtP = parcelRequire("kzNtP");


var $c4QoG = parcelRequire("c4QoG");


var $I0A3i = parcelRequire("I0A3i");


var $kQiXs = parcelRequire("kQiXs");

const $17b0f8a5b73de479$var$DEFAULT_CONFIG = {
    clientId: '',
    fileStoreUrl: ''
};
const $17b0f8a5b73de479$var$cachedGetDownloadData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, isExternalShare: isExternalShare, shareToken: shareToken })=>{
    if (isExternalShare && shareToken && (0, $6mKj3.expValEquals)('add_anonid_in_media_token', 'cohort', 'test')) {
        const tokenResponse = await (0, $I0A3i.fetchExternalContentMediaSessionToken)(shareToken);
        const tokenData = tokenResponse?.data;
        return {
            token: tokenData?.externalContentMediaSession?.accessTokens?.readOnlyToken?.value || '',
            config: tokenData?.externalContentMediaSession?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
        };
    }
    // Fallback to existing logic for backward compatibility
    const response = await (isExternalShare ? (0, $I0A3i.fetchExternalShareMediaToken) : (0, $I0A3i.fetchMediaToken))(contentId);
    const data = response?.data;
    const externalData = data?.['singleContent'];
    const content = isExternalShare ? externalData : data?.['content']?.nodes?.[0];
    return {
        token: content?.body?.atlas_doc_format?.mediaToken?.token || '',
        config: data?.mediaConfiguration || $17b0f8a5b73de479$var$DEFAULT_CONFIG
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$export$6176af039388fdbf = (dataGetter)=>async ()=>{
        const data = await dataGetter();
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$da46cefd33160c4d = (viewDataGetter, uploadDataGetter)=>async (params)=>{
        // Currently, supplying upload token only for file and collection update action.
        // If no params are provided, the view token is returned.
        const isUpdateAction = !!params?.access?.find(({ type: type, actions: actions })=>(type === 'file' || type == 'collection') && actions.includes('update'));
        const data = await (isUpdateAction ? uploadDataGetter() : viewDataGetter());
        return {
            token: data?.token || '',
            clientId: data?.config?.clientId || '',
            baseUrl: data?.config?.fileStoreUrl || ''
        };
    };
const $17b0f8a5b73de479$export$6cb774192b5cd093 = (contextId)=>{
    try {
        const { snippetId: snippetId } = JSON.parse(contextId);
        return snippetId ? {
            snippetId: snippetId
        } : undefined;
    } catch  {} // not JSON or not a SnippetContextId.
};
const $17b0f8a5b73de479$export$724cb324eb7535cd = async (contextId)=>{
    if ((0, $6mKj3.expVal)('cc_snippets', 'isEnabled', false)) {
        const snippetContext = $17b0f8a5b73de479$export$6cb774192b5cd093(contextId);
        if (snippetContext) {
            const auth = await (0, $2TuWI.fetchSnippetMediaToken)(snippetContext.snippetId);
            return {
                clientId: auth.clientId,
                token: auth.token,
                baseUrl: auth.baseUrl
            };
        }
    }
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = (0, $c4QoG.getTemplateMediaContextValues)(contextId);
    // template media informtion is stored slightly different in the context
    // to be able to discern which call to make
    if (collectionId || templateId) return (0, $c4QoG.getTemplateMediaAuth)({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
    const response = await (0, $I0A3i.fetchMediaToken)(contextId);
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.mediaConfiguration || {};
    return {
        clientId: clientId,
        token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
        baseUrl: fileStoreUrl || ''
    };
};
const $17b0f8a5b73de479$var$cachedGetUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = options.contentType === 'comment' && options.cloudId && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint') ? await (0, $I0A3i.getCommentUploadToken)(options.contentId, options.cloudId) : await (0, $I0A3i.getUploadToken)(options.contentId);
    const session = response?.data?.contentMediaSession;
    return {
        token: session?.token?.value || '',
        config: session?.configuration || $17b0f8a5b73de479$var$DEFAULT_CONFIG,
        collectionId: session?.collection || ''
    };
}, (json)=>json.token);
const $17b0f8a5b73de479$var$getUploadCollectionId = async (options)=>{
    const uploadData = await $17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
    return uploadData.collectionId;
};
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter = (options)=>()=>$17b0f8a5b73de479$var$cachedGetUploadData.getValue(options);
const $17b0f8a5b73de479$var$getUploadMediaClientConfig = async (options)=>({
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd,
        useSha256ForUploads: true
    });
const $17b0f8a5b73de479$var$cachedGetExportDspData = (0, $kzNtP.cacheWithExp)(async ({ contentId: contentId, spaceKey: spaceKey })=>{
    const response = await (0, $I0A3i.getIsExportEnabledForContent)(contentId, spaceKey);
    const isExportAllowed = response?.data?.dataSecurityPolicy?.isActionEnabledForContent?.allowed;
    return {
        isExportAllowed: isExportAllowed,
        exp: Date.now() + 60000
    };
}, (json)=>json.exp);
const $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy = async (options)=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const { contentId: contentId, spaceKey: spaceKey, mediaDspContentId: mediaDspContentId } = options;
    if (!(0, $9wGTI.fg)('dlp_allow_content_dsp_check_without_space_details')) {
        // Note: If you can't provide spaceKey, you can't enable downloads in media viewer
        if (!spaceKey) return true;
    }
    try {
        const relevantContentId = mediaDspContentId || contentId;
        const response = await $17b0f8a5b73de479$var$cachedGetExportDspData.getValue({
            contentId: relevantContentId,
            spaceKey: spaceKey
        });
        const isExportAllowed = response?.isExportAllowed;
        return !isExportAllowed;
    } catch  {
        // Fails CLOSED
        return true;
    }
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetter = (options)=>async ()=>{
        // Only pass contentId, isExternalShare, and shareToken to the cacheWithExp function
        // to avoid unnecessary re-fetching of the token if other options differ
        const authQueryOptions = {
            contentId: options.contentId,
            isExternalShare: options.isExternalShare,
            shareToken: options.shareToken
        };
        let data = await $17b0f8a5b73de479$var$cachedGetDownloadData.getValue(authQueryOptions);
        if (options.mediaToken) data = {
            ...data,
            token: options.mediaToken
        };
        // For drafts mediaToken by default is null and created once any media added to them
        // So, once publishing draft that just got media but token was cached before as `null`
        // we need to re-fetch the token without the cache
        if (!data.token) data = await $17b0f8a5b73de479$var$cachedGetDownloadData.forceGetValue(authQueryOptions);
        return data;
    };
const $17b0f8a5b73de479$export$9891be2d4fea1436 = async (options)=>{
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$e43b4f8676d4deae = async (options)=>({
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    });
const $17b0f8a5b73de479$export$39c5d94533971b79 = async (options)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$9891be2d4fea1436(options)
    });
const $17b0f8a5b73de479$export$4887a1cde0f552dc = async (options)=>{
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(options);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$9891be2d4fea1436(options),
        $17b0f8a5b73de479$var$getUploadMediaClientConfig(options),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$e43b4f8676d4deae(options) : undefined,
        $17b0f8a5b73de479$var$getUploadCollectionId(options)
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
};
const $17b0f8a5b73de479$export$c64cc28e06e9eda = (pathname)=>{
    return !!(0, $1NBp8.PDF_EXPORT_PAGE).match(pathname);
};
let $17b0f8a5b73de479$var$previousAttachUploadedMediaListener;
const $17b0f8a5b73de479$var$registerGlobalFileAddedListener = (options)=>{
    if ($17b0f8a5b73de479$var$previousAttachUploadedMediaListener) (0, $eGqQQ.globalMediaEventEmitter).off('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
    $17b0f8a5b73de479$var$previousAttachUploadedMediaListener = (0, $kQiXs.attachUploadedMedia)(options);
    (0, $eGqQQ.globalMediaEventEmitter).on('file-added', $17b0f8a5b73de479$var$previousAttachUploadedMediaListener);
};
const $17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createViewAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic = (getOptions)=>async ()=>{
        const options = getOptions();
        return $17b0f8a5b73de479$var$createUploadAuthProviderDataGetter(options)();
    };
const $17b0f8a5b73de479$export$af68076132bb2083 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$6176af039388fdbf($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$de798661504725b9 = async (getOptions)=>{
    const options = getOptions();
    return {
        enforceDataSecurityPolicy: await $17b0f8a5b73de479$var$getEnforceDataSecurityPolicy(options),
        authProvider: $17b0f8a5b73de479$export$da46cefd33160c4d($17b0f8a5b73de479$var$createViewAuthProviderDataGetterDynamic(getOptions), $17b0f8a5b73de479$var$createUploadAuthProviderDataGetterDynamic(getOptions)),
        getAuthFromContext: $17b0f8a5b73de479$export$724cb324eb7535cd
    };
};
const $17b0f8a5b73de479$export$221251ab27f63f41 = async (getOptions)=>({
        viewMediaClientConfig: await $17b0f8a5b73de479$export$af68076132bb2083(getOptions)
    });
const $17b0f8a5b73de479$export$e6a9b44aa174a3d4 = async (getOptions)=>{
    // We deliberately do NOT register the global listener dynamically each token fetch.
    // Instead we register once per provider creation with the then-current options snapshot.
    // If you need the listener to react to changed options, recreate the provider instead.
    const initialOptions = getOptions();
    $17b0f8a5b73de479$var$registerGlobalFileAddedListener(initialOptions);
    const [viewMediaClientConfig, uploadMediaClientConfig, viewAndUploadMediaClientConfig, collection] = await Promise.all([
        $17b0f8a5b73de479$export$af68076132bb2083(()=>getOptions()),
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadMediaClientConfig(opts);
        })(),
        (0, $9wGTI.fg)('platform_media_video_captions') ? $17b0f8a5b73de479$export$de798661504725b9(()=>getOptions()) : undefined,
        (async ()=>{
            const opts = getOptions();
            return $17b0f8a5b73de479$var$getUploadCollectionId(opts);
        })()
    ]);
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: initialOptions.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig,
        viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
    };
}; /**
 * Usage sketch (React):
 * const liveOptionsRef = useRef(currentOptions);
 * liveOptionsRef.current = currentOptions; // update on changes
 * const providerPromise = useMemo(() => createEditorMediaProviderDynamic(() => liveOptionsRef.current), []);
 * editorApi.media.actions.setProvider(providerPromise);
 */ 
module.exports["createAuthProvider"] = $17b0f8a5b73de479$export$6176af039388fdbf;
module.exports["getAuthFromContext"] = $17b0f8a5b73de479$export$724cb324eb7535cd;
module.exports["getViewMediaClientConfig"] = $17b0f8a5b73de479$export$9891be2d4fea1436;
module.exports["createRendererMediaProvider"] = $17b0f8a5b73de479$export$39c5d94533971b79;
module.exports["createEditorMediaProvider"] = $17b0f8a5b73de479$export$4887a1cde0f552dc;
module.exports["controlDataExportOnCertainFeatures"] = $17b0f8a5b73de479$export$c64cc28e06e9eda;
module.exports["createRendererMediaProviderDynamic"] = $17b0f8a5b73de479$export$221251ab27f63f41;
module.exports["createEditorMediaProviderDynamic"] = $17b0f8a5b73de479$export$e6a9b44aa174a3d4;

});

parcelRegister("2TuWI", function(module, exports) {

var $f7B1p = parcelRequire("f7B1p");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");

const $15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL = '/gateway/api/blocks/v1/snippets';
const $15f98e0699368f56$export$73c71f9590626082 = async (snippetId)=>{
    try {
        const response = await (0, $f7B1p.cfetch)(`${$15f98e0699368f56$var$BLOCK_SERVICE_SNIPPETS_MEDIA_TOKEN_URL}/${snippetId}/media-token`, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = await response.json();
        const collectionId = data.collectionNames?.[snippetId];
        return {
            clientId: data.config.clientId,
            token: data.token,
            baseUrl: data.config.fileStoreUrl,
            ...collectionId !== undefined && {
                collectionId: collectionId
            }
        };
    } catch (error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        throw error;
    }
};
module.exports["fetchSnippetMediaToken"] = $15f98e0699368f56$export$73c71f9590626082;

});

parcelRegister("kzNtP", function(module, exports) {

var $9ILXP = parcelRequire("9ILXP");


var $a4TK8 = parcelRequire("a4TK8");

const $852f3734fd3706d8$var$BUFFER_MS = 60000; // refresh token 60 seconds before it expires
const $852f3734fd3706d8$var$EMPTY = [
    -Infinity,
    null,
    null
];
function $852f3734fd3706d8$export$d18015d30d3c28a4(asyncFunction, tokenOrExpInMsAccessor, tokenExpBufferInMs = $852f3734fd3706d8$var$BUFFER_MS) {
    const cache = {};
    async function getValue(arg, force) {
        // It is ok to have clashing hash because we are going to check args anyway
        // Worse case is calling fn() more often than it should
        let hash = '';
        try {
            hash = JSON.stringify(arg);
        } catch  {}
        const [exp, lastArg, lastValue] = cache[hash] || $852f3734fd3706d8$var$EMPTY;
        if (force || exp <= Date.now() || !(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(lastArg, arg)) {
            const value = await asyncFunction(arg);
            let tokenOrExp = null;
            try {
                tokenOrExp = tokenOrExpInMsAccessor(value);
            } catch (e) {}
            let exp = null;
            if (tokenOrExp) {
                if (!isNaN(tokenOrExp)) exp = Number(tokenOrExp);
                else if (typeof tokenOrExp === 'string') try {
                    exp = (0, $9ILXP.default)(tokenOrExp).exp * 1000 - tokenExpBufferInMs;
                } catch (e) {}
            }
            cache[hash] = exp === null ? $852f3734fd3706d8$var$EMPTY : [
                exp,
                arg,
                value
            ];
            return value;
        }
        return lastValue;
    }
    return {
        forceGetValue: (arg)=>{
            return getValue(arg, true);
        },
        getValue: (arg)=>{
            return getValue(arg, false);
        }
    };
}
module.exports["cacheWithExp"] = $852f3734fd3706d8$export$d18015d30d3c28a4;

});

parcelRegister("c4QoG", function(module, exports) {

var $kzNtP = parcelRequire("kzNtP");


var $4IoVL = parcelRequire("4IoVL");


var $7EQEd = parcelRequire("7EQEd");

// blueprints/templates in uuid form are technically a new template
const $30f3da79b755ac50$var$isBlueprint = (templateId)=>!/^[0-9]+$/.test(templateId);
const $30f3da79b755ac50$var$isNewTemplate = (templateId)=>!templateId || templateId === '';
const $30f3da79b755ac50$var$shouldUseTemplateId = (templateIds)=>templateIds.length;
const $30f3da79b755ac50$var$formatTemplateId = (templateId, isFirstLoad, isUpload)=>{
    if ($30f3da79b755ac50$var$isNewTemplate(templateId) || $30f3da79b755ac50$var$isBlueprint(templateId) && isUpload || !isFirstLoad) return [];
    else return [
        templateId
    ];
};
const $30f3da79b755ac50$var$cachedGetTemplateUploadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateUploadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    const session = response?.data?.templateMediaSession;
    const collectionId = session?.collections?.[0]?.value || '';
    return {
        token: session?.uploadToken?.value || '',
        config: session?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        },
        collectionId: collectionId
    };
}, (json)=>json.token);
const $30f3da79b755ac50$var$cachedGetTemplateDownloadData = (0, $kzNtP.cacheWithExp)(async (options)=>{
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        spaceKey: options.spaceKey,
        templateIds: options.templateIds,
        collectionId: options.collectionId
    });
    return {
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        config: response?.data?.templateMediaSession?.configuration || {
            fileStoreUrl: '',
            clientId: ''
        }
    };
}, (json)=>json.token);
const $30f3da79b755ac50$export$ea5d75839efa2930 = async (editorOptions)=>{
    const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !editorOptions.collectionId, true);
    const uploadData = await $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
        ...editorOptions,
        templateIds: templateIds,
        collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : editorOptions.collectionId
    });
    return uploadData.collectionId;
};
const $30f3da79b755ac50$export$8867d7a854cea94a = (contextId)=>{
    let collectionId, templateId, spaceKey = null;
    try {
        ({ collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = JSON.parse(contextId));
    } catch (_) {}
    return {
        collectionId: collectionId,
        templateId: templateId,
        spaceKey: spaceKey
    };
};
const $30f3da79b755ac50$export$c52d46b5239d3052 = async ({ templateId: templateId, collectionId: collectionId, spaceKey: spaceKey })=>{
    // if given a templateId the source is the renderer, otherwise it's the editor
    const response = await (0, $7EQEd.getTemplateDownloadToken)({
        templateIds: templateId ? [
            templateId
        ] : [],
        collectionId: templateId ? null : collectionId,
        spaceKey: spaceKey
    });
    const { clientId: clientId = '', fileStoreUrl: fileStoreUrl = '' } = response?.data?.templateMediaSession?.configuration || {};
    return {
        clientId: clientId,
        token: response?.data?.templateMediaSession?.downloadToken?.value || '',
        baseUrl: fileStoreUrl
    };
};
const $30f3da79b755ac50$var$getAuthFromContext = async (contextId)=>{
    const { collectionId: collectionId, templateId: templateId, spaceKey: spaceKey } = $30f3da79b755ac50$export$8867d7a854cea94a(contextId);
    // templateID = null/undefined -> not template type
    // templateId = "" -> new template
    // templateId = "2394234324" -> user modified template
    // templateId = "23j4h-23jk4h-kj2h34-kj23h4" -> new template
    if (typeof collectionId !== 'string' && typeof templateId !== 'string') // copy source is page contentType
    return (0, $4IoVL.getAuthFromContext)(contextId);
    return $30f3da79b755ac50$export$c52d46b5239d3052({
        collectionId: collectionId,
        spaceKey: spaceKey,
        templateId: templateId
    });
};
const $30f3da79b755ac50$export$e7a68a11bc740f17 = (options)=>{
    return {
        authProvider: (0, $4IoVL.createAuthProvider)(async ()=>$30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue(options)),
        getAuthFromContext: $30f3da79b755ac50$var$getAuthFromContext
    };
};
const $30f3da79b755ac50$export$4f3a63958bc8e871 = (options)=>{
    return Promise.resolve({
        viewMediaClientConfig: $30f3da79b755ac50$export$e7a68a11bc740f17(options)
    });
};
const $30f3da79b755ac50$export$582e7673a587f23a = async (options)=>{
    let isFirstDownload = true;
    let collectionId = options.collectionId;
    const getEditorViewTemplateMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(async ()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, isFirstDownload, false);
                isFirstDownload = false;
                return $30f3da79b755ac50$var$cachedGetTemplateDownloadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                isFirstDownload = false;
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const getTemplateMediaUploadMediaClientConfig = (editorOptions)=>{
        return {
            authProvider: (0, $4IoVL.createAuthProvider)(()=>{
                const templateIds = $30f3da79b755ac50$var$formatTemplateId(editorOptions.templateId, !collectionId, true);
                return $30f3da79b755ac50$var$cachedGetTemplateUploadData.getValue({
                    ...editorOptions,
                    templateIds: templateIds,
                    collectionId: $30f3da79b755ac50$var$shouldUseTemplateId(templateIds) ? null : collectionId
                });
            }),
            getAuthFromContext: (context)=>{
                return $30f3da79b755ac50$var$getAuthFromContext(context);
            }
        };
    };
    const viewMediaClientConfig = getEditorViewTemplateMediaClientConfig(options);
    const uploadMediaClientConfig = getTemplateMediaUploadMediaClientConfig(options);
    const collection = await $30f3da79b755ac50$export$ea5d75839efa2930(options);
    collectionId = collection || null;
    return {
        viewMediaClientConfig: viewMediaClientConfig,
        uploadParams: {
            collection: collection,
            onUploadRejection: options.onUploadRejection
        },
        uploadMediaClientConfig: uploadMediaClientConfig
    };
};
module.exports["getTemplateUploadCollectionId"] = $30f3da79b755ac50$export$ea5d75839efa2930;
module.exports["getTemplateMediaContextValues"] = $30f3da79b755ac50$export$8867d7a854cea94a;
module.exports["getTemplateMediaAuth"] = $30f3da79b755ac50$export$c52d46b5239d3052;
module.exports["createRendererTemplateMediaProvider"] = $30f3da79b755ac50$export$4f3a63958bc8e871;
module.exports["createTemplateEditorMediaProvider"] = $30f3da79b755ac50$export$582e7673a587f23a;

});

parcelRegister("7EQEd", function(module, exports) {

var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $6UhpO = parcelRequire("6UhpO");


var $23pnW = parcelRequire("23pnW");


var $c0rhi = parcelRequire("c0rhi");

const $bced78bb0973f66e$export$852d9acd488f2352 = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $6UhpO.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'network-only'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
const $bced78bb0973f66e$export$779a7b38112a4dbb = async ({ spaceKey: spaceKey, templateIds: templateIds, collectionId: collectionId = null })=>{
    return (0, $c0rhi.queryInterop)({
        query: (0, $23pnW.default),
        variables: {
            spaceKey: spaceKey || null,
            templateIds: templateIds,
            collectionId: collectionId
        },
        fetchPolicy: 'no-cache'
    }).catch((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        return undefined;
    });
};
module.exports["getTemplateDownloadToken"] = $bced78bb0973f66e$export$852d9acd488f2352;
module.exports["getTemplateUploadToken"] = $bced78bb0973f66e$export$779a7b38112a4dbb;

});

parcelRegister("6UhpO", function(module, exports) {
/**
 * @generated SignedSource<<273886fda73b45eae565a459bc35c481>>
 * @relayHash 7da80c4186ab379cb41cda405bebee65
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1
const $ba0dcc1d393f4102$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "downloadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionDownloadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "7da80c4186ab379cb41cda405bebee65",
            "id": "b087f1d76c63fdcc9767cdf0710dfa4efaf3f7db7a96f39d1b7b4eef575b40c1",
            "metadata": {},
            "name": "TemplateMediaSessionDownloadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionDownloadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},downloadToken{value,duration}}}"
        }
    };
}();
$ba0dcc1d393f4102$var$node.hash = "cb69ec0c674b12c3415c2289771f970f";
var $ba0dcc1d393f4102$export$2e2bcd8739ae039 = $ba0dcc1d393f4102$var$node;
module.exports["default"] = $ba0dcc1d393f4102$export$2e2bcd8739ae039;

});

parcelRegister("23pnW", function(module, exports) {
/**
 * @generated SignedSource<<0933b98efee62f87a502c2fb09d64af2>>
 * @relayHash f5528f55bdab5a02587ef6cd5262334d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059
const $d22835c5674bcb0e$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "collectionId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "templateIds"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "collectionId",
                    "variableName": "collectionId"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "templateIds",
                    "variableName": "templateIds"
                }
            ],
            "concreteType": "TemplateMediaSession",
            "kind": "LinkedField",
            "name": "templateMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MapOfStringToString",
                    "kind": "LinkedField",
                    "name": "collections",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        v3 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                },
                {
                    "concreteType": "TemplateMediaToken",
                    "kind": "LinkedField",
                    "name": "uploadToken",
                    "plural": false,
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "duration"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "TemplateMediaSessionUploadQuery",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "cacheID": "f5528f55bdab5a02587ef6cd5262334d",
            "id": "7ce5237137eaa73015ff248d0a763c44e037f18ed58c1bb4ff3b73e41cc13059",
            "metadata": {},
            "name": "TemplateMediaSessionUploadQuery",
            "operationKind": "query",
            "text": "query TemplateMediaSessionUploadQuery($spaceKey:String,$templateIds:[String]!,$collectionId:String){templateMediaSession(spaceKey:$spaceKey,templateIds:$templateIds,collectionId:$collectionId){collections{key,value},configuration{fileStoreUrl,clientId},uploadToken{value,duration}}}"
        }
    };
}();
$d22835c5674bcb0e$var$node.hash = "1d0108dcbf48addfcc8b1c4145c7178d";
var $d22835c5674bcb0e$export$2e2bcd8739ae039 = $d22835c5674bcb0e$var$node;
module.exports["default"] = $d22835c5674bcb0e$export$2e2bcd8739ae039;

});

parcelRegister("I0A3i", function(module, exports) {

var $iTcHJ = parcelRequire("iTcHJ");


var $bS81H = parcelRequire("bS81H");


var $5d9b4 = parcelRequire("5d9b4");


var $9ILXP = parcelRequire("9ILXP");


var $7Sm4c = parcelRequire("7Sm4c");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $c0rhi = parcelRequire("c0rhi");


var $lUobS = parcelRequire("lUobS");


var $62FVQ = parcelRequire("62FVQ");


var $6mmMU = parcelRequire("6mmMU");


var $egLSs = parcelRequire("egLSs");


var $dqLCu = parcelRequire("dqLCu");

const $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery = (0, $bS81H.default);
const $1fd47ba2b01e31e6$var$FetchMediaTokenQuery = (0, $iTcHJ.default);
let $1fd47ba2b01e31e6$var$isFirstLoad = true;
const $1fd47ba2b01e31e6$export$f3bf3f7b03608218 = (requestBody)=>{
    if (requestBody.contentType === 'comment' && (0, $9wGTI.fg)('confluence_comment_use_comment_media_endpoint')) // Hard disable drag-and-drop upload functionality for comments
    return;
    // Use regular mutation for normal uploads (file browser, copy-paste, etc.)
    return (0, $egLSs.experimentalFileUploadMutate)({
        variables: requestBody
    });
};
const $1fd47ba2b01e31e6$export$2b7fb70f168591f8 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$FetchMediaTokenQuery,
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ],
            missingContentId: !contentId
        },
        context: {
            allowOnExternalPage: true
        },
        // If SSR has populated the cache then we want to use the cache when rendering SPA-over-SSR
        fetchPolicy: $1fd47ba2b01e31e6$var$isFirstLoad ? 'cache-first' : 'network-only'
    }).then(/* onFulfilled */ (value)=>{
        $1fd47ba2b01e31e6$var$isFirstLoad = false;
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(value?.errors);
        } catch  {}
        return value;
    }, /* onRejected */ (reason)=>{
        try {
            $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors(contentId)(reason?.graphQLErrors, reason?.networkError);
        } catch  {}
        throw reason;
    });
/**
 * `fetchMediaToken` is called repetitively to renew the token before it
 * expires. If an error condition arises (because of frontend or backend), the
 * same error(s) may be reported as unhandled to our analytics and monitoring at
 * a very high rate/volume. Such repetitive reporting fron one user in one tab
 * is noisy. `throttleFetchMediaTokenErrors` attempts to reduce the noise.
 */ const $1fd47ba2b01e31e6$var$throttleFetchMediaTokenErrors = (0, (/*@__PURE__*/$parcel$interopDefault($5d9b4)))((_cacheKey)=>{
    /**
   * The errors that happened last time. The `GraphQLError` instances are big
   * and are not trivial to compare so `prevErrors` caches partial info.
   */ let prevErrors = undefined;
    return (graphQLErrors, networkError)=>{
        // Each of `graphQLErrors` and `networkError` are reported to analytics and
        // monitoring so type of `Error` does not matter to what follows and
        // `GraphQLError` is the most convenient TypeScript type to deal with.
        if (networkError) graphQLErrors = (graphQLErrors || []).concat(networkError);
        if (graphQLErrors) {
            /**
       * The new/current errors which will become `prevErrors` at the end of
       * this iteration.
       */ const nextErrors = {};
            for (const graphQLError of graphQLErrors){
                // Extract the partial, easy-to-compare, cachable info from the big
                // `GraphQLError` instance:
                const message = graphQLError.message || String(graphQLError) || graphQLError.originalError?.message || String(graphQLError.originalError);
                const { path: path } = graphQLError;
                const key = Array.isArray(path) && path.join('.') || message;
                if (key) {
                    const value = (0, $aMcHK.getStatusCode)(graphQLError) || message;
                    if (value) {
                        nextErrors[key] = value;
                        // If a similar error happened in the previous iteration, do not
                        // report it to analytics and monitoring again:
                        if (prevErrors?.[key] === value) (0, $7Sm4c.markErrorAsHandled)(graphQLError);
                    }
                }
            }
            prevErrors = nextErrors;
        } else // If `MediaDownloadTokenQuery` succeeds, report subsequent/future errors
        // even if similar ones occurred and were reported before the current
        // success - there is a meaningful change in state and it may be useful in
        // debugging.
        prevErrors = undefined;
    };
});
const $1fd47ba2b01e31e6$export$e5e77dc812ab6e52 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $lUobS.default),
        variables: {
            contentId: contentId
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $1fd47ba2b01e31e6$export$db4c125247d46dd = (shareToken)=>(0, $c0rhi.queryInterop)({
        query: (0, $dqLCu.default),
        variables: {
            shareToken: shareToken
        },
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'network-only'
    });
const $1fd47ba2b01e31e6$export$2b96f2ad626f63d2 = (contentId)=>(0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'no-cache'
    });
const $1fd47ba2b01e31e6$export$de87322aceb1e609 = async (contentId)=>{
    if (!(0, $9wGTI.fg)('confluence-media-upload-token-cache')) return $1fd47ba2b01e31e6$export$2b96f2ad626f63d2(contentId);
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $62FVQ.default),
            variables: {
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $62FVQ.default),
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $1fd47ba2b01e31e6$export$4205291ac54c446e = async (contentId, cloudId)=>{
    try {
        const { data: data } = await (0, $c0rhi.queryInterop)({
            query: (0, $6mmMU.default),
            variables: {
                cloudId: cloudId,
                contentId: contentId
            },
            fetchPolicy: 'cache-first'
        });
        const token = data?.contentMediaSession?.token?.value;
        if (token) {
            const { exp: exp } = (0, $9ILXP.default)(token);
            const currentTime = Math.floor(Date.now() / 1000);
            // Check if the token has not expired
            if (exp > currentTime) return {
                data: data
            };
        }
    } catch  {
    // Fall through to refetch on decode failure
    }
    // Refetch with network-only policy if token is expired, or invalid
    return (0, $c0rhi.queryInterop)({
        query: (0, $6mmMU.default),
        variables: {
            cloudId: cloudId,
            contentId: contentId
        },
        fetchPolicy: 'network-only'
    });
};
const $1fd47ba2b01e31e6$export$4777fc7c5d601381 = (contentId, spaceKey)=>{
    const action = (0, $9wGTI.fg)('cc-dlp_split-attachment-dl-from-export-dsp') ? 'ATTACHMENT_DOWNLOAD' : 'PAGE_EXPORT';
    const variables = {
        action: action,
        contentId: contentId,
        contentStatus: 'CURRENT',
        contentVersion: 1,
        ...spaceKey && {
            spaceKey: spaceKey
        }
    };
    /* Note -> relay compatible query replacement available, in @confluence/data-security package.
   * Using queryInterop for compatibility with Relay migration
   */ return (0, $c0rhi.queryInterop)({
        query: $1fd47ba2b01e31e6$var$DSPIsActionEnabledForContentQuery,
        variables: variables,
        context: {
            allowOnExternalPage: true
        },
        fetchPolicy: 'cache-first'
    });
};
module.exports["setAttachment"] = $1fd47ba2b01e31e6$export$f3bf3f7b03608218;
module.exports["fetchMediaToken"] = $1fd47ba2b01e31e6$export$2b7fb70f168591f8;
module.exports["fetchExternalShareMediaToken"] = $1fd47ba2b01e31e6$export$e5e77dc812ab6e52;
module.exports["fetchExternalContentMediaSessionToken"] = $1fd47ba2b01e31e6$export$db4c125247d46dd;
module.exports["getUploadToken"] = $1fd47ba2b01e31e6$export$de87322aceb1e609;
module.exports["getCommentUploadToken"] = $1fd47ba2b01e31e6$export$4205291ac54c446e;
module.exports["getIsExportEnabledForContent"] = $1fd47ba2b01e31e6$export$4777fc7c5d601381;

});

parcelRegister("lUobS", function(module, exports) {
/**
 * @generated SignedSource<<cfa4445e6bb02210910af08c520e0543>>
 * @relayHash ea7172d4f00c5846ec23ab207abff057
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e
const $2624e38a54eebf0f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "concreteType": "ContentBodyPerRepresentation",
                    "kind": "LinkedField",
                    "name": "body",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ContentBody",
                            "kind": "LinkedField",
                            "name": "atlas_doc_format",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "EmbeddedMediaToken",
                                    "kind": "LinkedField",
                                    "name": "mediaToken",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "token"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalShareMediaDownloadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "ea7172d4f00c5846ec23ab207abff057",
            "id": "def5df9707285fd6e6ce8403c4b6e14be14ec1bc83092c3a8315bd1cae3d8b6e",
            "metadata": {},
            "name": "ExternalShareMediaDownloadTokenQuery",
            "operationKind": "query",
            "text": "query ExternalShareMediaDownloadTokenQuery($contentId:ID!){singleContent(id:$contentId){id,body{atlas_doc_format{mediaToken{token}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$2624e38a54eebf0f$var$node.hash = "3592e1b2dcd3aa2c38a177d9b363dafe";
var $2624e38a54eebf0f$export$2e2bcd8739ae039 = $2624e38a54eebf0f$var$node;
module.exports["default"] = $2624e38a54eebf0f$export$2e2bcd8739ae039;

});

parcelRegister("62FVQ", function(module, exports) {
/**
 * @generated SignedSource<<31b5d532b516ee1d749ea0abc13f0451>>
 * @relayHash 20688ce23e5e858cfc82d72bb57f43b8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c
const $15e95f80a91466f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "contentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "20688ce23e5e858cfc82d72bb57f43b8",
            "id": "6675bb1797e9ac9206231ded11f5893e0128fe48eaeb5c3ee4b3024ed69be54c",
            "metadata": {},
            "name": "MediaUploadTokenQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQuery($contentId:ID!){contentMediaSession(contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$15e95f80a91466f9$var$node.hash = "1f89a4aaada59e040e6317ae1cdc704c";
var $15e95f80a91466f9$export$2e2bcd8739ae039 = $15e95f80a91466f9$var$node;
module.exports["default"] = $15e95f80a91466f9$export$2e2bcd8739ae039;

});

parcelRegister("6mmMU", function(module, exports) {
/**
 * @generated SignedSource<<60dea3de9a9635f6732328087d92dedd>>
 * @relayHash c06482aa2ab100620d21019ae889668d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37
const $39c17bb60e74ced3$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "alias": "contentMediaSession",
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "confluence_commentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaToken",
                    "kind": "LinkedField",
                    "name": "token",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "value"
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        }
                    ]
                },
                {
                    "kind": "ScalarField",
                    "name": "collection"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "MediaUploadTokenQueryCommentQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c06482aa2ab100620d21019ae889668d",
            "id": "6f18fbd3655dc7d982b17a901a58731161062354f5b6b10a2c133f035fcb7e37",
            "metadata": {},
            "name": "MediaUploadTokenQueryCommentQuery",
            "operationKind": "query",
            "text": "query MediaUploadTokenQueryCommentQuery($cloudId:ID!,$contentId:ID!){contentMediaSession:confluence_commentMediaSession(cloudId:$cloudId,contentId:$contentId){token{value},configuration{clientId,fileStoreUrl},collection}}"
        }
    };
}();
$39c17bb60e74ced3$var$node.hash = "ecbc3538cd4e4434bac2e03ab7969cd8";
var $39c17bb60e74ced3$export$2e2bcd8739ae039 = $39c17bb60e74ced3$var$node;
module.exports["default"] = $39c17bb60e74ced3$export$2e2bcd8739ae039;

});

parcelRegister("egLSs", function(module, exports) {

var $4GGNn = parcelRequire("4GGNn");


var $aBfpe = parcelRequire("aBfpe");

const $7fce44bdcdfe3fe8$export$1b01a64a392afa44 = ({ variables: variables })=>{
    return (0, $4GGNn.experimentalMutate)({
        url: `/wiki/rest/drag-and-drop/1/filestore/upload`,
        method: 'POST',
        body: JSON.stringify(variables),
        headers: {
            'Content-Type': (0, $aBfpe.MediaType).JSON
        },
        variables: variables,
        parseResult: ()=>({
                experimentalFileUpload: true
            })
    });
};
module.exports["experimentalFileUploadMutate"] = $7fce44bdcdfe3fe8$export$1b01a64a392afa44;

});

parcelRegister("dqLCu", function(module, exports) {
/**
 * @generated SignedSource<<a0d7a3f519928728f106243b7743fa1a>>
 * @relayHash c64eff3bdc2352e89d29fc9d40e39f79
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255
const $b85e553ccc70de04$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "shareToken"
        }
    ], v1 = [
        {
            "kind": "ScalarField",
            "name": "value"
        }
    ], v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "shareToken",
                    "variableName": "shareToken"
                }
            ],
            "concreteType": "ContentMediaSession",
            "kind": "LinkedField",
            "name": "externalContentMediaSession",
            "plural": false,
            "selections": [
                {
                    "concreteType": "MediaAccessTokens",
                    "kind": "LinkedField",
                    "name": "accessTokens",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readOnlyToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        },
                        {
                            "concreteType": "MediaToken",
                            "kind": "LinkedField",
                            "name": "readWriteToken",
                            "plural": false,
                            "selections": v1 /*: any*/ 
                        }
                    ]
                },
                {
                    "concreteType": "MediaConfiguration",
                    "kind": "LinkedField",
                    "name": "configuration",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "fileStoreUrl"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "clientId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalContentMediaSessionQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c64eff3bdc2352e89d29fc9d40e39f79",
            "id": "0383b95992e0b08fce6e9726b252b827c2a925f54a0ef8d6bdc7d88c65deb255",
            "metadata": {},
            "name": "ExternalContentMediaSessionQuery",
            "operationKind": "query",
            "text": "query ExternalContentMediaSessionQuery($shareToken:String!){externalContentMediaSession(shareToken:$shareToken){accessTokens{readOnlyToken{value},readWriteToken{value}},configuration{fileStoreUrl,clientId}}}"
        }
    };
}();
$b85e553ccc70de04$var$node.hash = "73d645a33a55cbb7625d57b6d5cf2a1a";
var $b85e553ccc70de04$export$2e2bcd8739ae039 = $b85e553ccc70de04$var$node;
module.exports["default"] = $b85e553ccc70de04$export$2e2bcd8739ae039;

});

parcelRegister("kQiXs", function(module, exports) {

var $I0A3i = parcelRequire("I0A3i");

const $c59debd6932d7898$var$noop = ()=>{};
const $c59debd6932d7898$export$ad897c91dfb246e9 = (options)=>{
    if (options.contentId && options.contentType) return (file)=>{
        const { id: id, name: name, size: size, mimeType: mimeType } = file;
        const { contentId: contentId, contentType: contentType } = options;
        const requestBody = {
            size: size,
            contentType: contentType,
            mimeType: mimeType,
            fileName: name,
            pageId: contentId,
            fileStoreId: id,
            minorEdit: true,
            renderEditorHTML: false,
            collectionName: `contentId-${contentId}`,
            uploadSource: 'fabric-editor'
        };
        (0, $I0A3i.setAttachment)(requestBody);
    };
    else return $c59debd6932d7898$var$noop;
};
module.exports["attachUploadedMedia"] = $c59debd6932d7898$export$ad897c91dfb246e9;

});

parcelRegister("1RqgI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $iZTFQ = parcelRequire("iZTFQ");


var $gEpEw = parcelRequire("gEpEw");

class $f76d2aa2a1b6bce3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $gEpEw.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        };
        this.onSetPageHandler = (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        };
        this.onSortHandler = ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        };
        this.onRankEndIfExistsHandler = (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        };
        this.onRankEndHandler = (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iZTFQ.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        };
    }
}
$f76d2aa2a1b6bce3$export$2e2bcd8739ae039.defaultProps = {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $ee7An.default),
    onSort: (0, $ee7An.default),
    rowsPerPage: Infinity
};
module.exports["default"] = $f76d2aa2a1b6bce3$export$2e2bcd8739ae039;

});

parcelRegister("iZTFQ", function(module, exports) {
const $7136cb869e4237cd$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $7136cb869e4237cd$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $7136cb869e4237cd$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $7136cb869e4237cd$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $7136cb869e4237cd$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $7136cb869e4237cd$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $7136cb869e4237cd$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};
module.exports["getPageRows"] = $7136cb869e4237cd$export$3987dc24b734dcab;
module.exports["assertIsSortable"] = $7136cb869e4237cd$export$5eb35a4771ec4090;
module.exports["validateSortKey"] = $7136cb869e4237cd$export$9133f5a8bfe8a200;
module.exports["inlineStylesIfRanking"] = $7136cb869e4237cd$export$a601f1775e10043f;
module.exports["reorderRows"] = $7136cb869e4237cd$export$c476bbe5da59992d;

});

parcelRegister("gEpEw", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");


var $a1aS7 = parcelRequire("a1aS7");


var $1QeRM = parcelRequire("1QeRM");


var $4S6q0 = parcelRequire("4S6q0");


var $ariie = parcelRequire("ariie");


var $fsOrO = parcelRequire("fsOrO");


var $gR32R = parcelRequire("gR32R");


var $3l42I = parcelRequire("3l42I");


var $lF3zd = parcelRequire("lF3zd");

function $5c24977a9a721875$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $acwm0.DESC:
            return 0, $acwm0.ASC;
        case 0, $acwm0.ASC:
            return 0, $acwm0.DESC;
        default:
            return currentSortOrder;
    }
}
const $5c24977a9a721875$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $ee7An.default), onSort: providedOnSort = (0, $ee7An.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $ee7An.default), onRankEnd: providedOnRankEnd = (0, $ee7An.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $42omo.useState)(false);
    const tableBodyRef = (0, $42omo.useRef)(null);
    const onSort = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $42omo.useEffect)(()=>{
        (0, $iZTFQ.validateSortKey)(sortKey, head);
        (0, $iZTFQ.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $acwm0.DESC)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $acwm0.ASC) : $5c24977a9a721875$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $iZTFQ.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $acwm0.LARGE) : (0, $acwm0.SMALL);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $l998X.jsx)((0, $1QeRM.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gR32R.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $a1aS7.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $l998X.jsx)((0, $lF3zd.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $l998X.jsx)((0, $a1aS7.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3l42I.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $l998X.jsx)((0, $fsOrO.default), {
                isLoading: isLoading,
                spinnerSize: (0, $acwm0.LARGE),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $5c24977a9a721875$var$RankableTableBody = /*#__PURE__*/ (0, $42omo.lazy)(()=>(parcelRequire("jQuNB")));
const $5c24977a9a721875$var$TableBody = /*#__PURE__*/ (0, $42omo.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $l998X.jsx)((0, $4S6q0.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $ariie.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $l998X.jsx)($5c24977a9a721875$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c24977a9a721875$export$2e2bcd8739ae039 = $5c24977a9a721875$var$DynamicTable;
module.exports["default"] = $5c24977a9a721875$export$2e2bcd8739ae039;

});

parcelRegister("acwm0", function(module, exports) {
const $0675324f6a750b1a$export$1dee026a19752d6b = 'ASC';
const $0675324f6a750b1a$export$b6abcf7fa1d94f65 = 'DESC';
const $0675324f6a750b1a$export$71dd4c8ecd45e95f = 'small';
const $0675324f6a750b1a$export$7b93a10c0fefe3e3 = 'large';
const $0675324f6a750b1a$export$3843c586a90b9cbf = 0.22;
module.exports["ASC"] = $0675324f6a750b1a$export$1dee026a19752d6b;
module.exports["DESC"] = $0675324f6a750b1a$export$b6abcf7fa1d94f65;
module.exports["SMALL"] = $0675324f6a750b1a$export$71dd4c8ecd45e95f;
module.exports["LARGE"] = $0675324f6a750b1a$export$7b93a10c0fefe3e3;
module.exports["LOADING_CONTENTS_OPACITY"] = $0675324f6a750b1a$export$3843c586a90b9cbf;

});

parcelRegister("a1aS7", function(module, exports) {
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $cd45f3a97f0c2709$var$fixedSizeTableStyles = null;
const $cd45f3a97f0c2709$var$tableStyles = null;
const $cd45f3a97f0c2709$var$bodyBorder = null;
const $cd45f3a97f0c2709$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("table" // React and Typescript do not yet support the inert attribute https://github.com/facebook/react/pull/24730
    , {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $gMc0m.default)([
            "_1bsb1osq _yq5hus1c _btyzidpf _ect4ttxp",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $cd45f3a97f0c2709$var$captionStyles = null;
const $cd45f3a97f0c2709$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("caption", {
        className: (0, $gMc0m.default)([
            "_11c81af2 _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $cd45f3a97f0c2709$var$paginationWrapperStyles = null;
const $cd45f3a97f0c2709$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });
module.exports["Table"] = $cd45f3a97f0c2709$export$54ec01a60f47d33d;
module.exports["Caption"] = $cd45f3a97f0c2709$export$32fbfacc5d962e0c;
module.exports["PaginationWrapper"] = $cd45f3a97f0c2709$export$3e5e12dc01f20a43;

});

parcelRegister("1QeRM", function(module, exports) {
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c201fa6e50809e47$var$fixedHeightStyles = null;
const $c201fa6e50809e47$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $gMc0m.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $c201fa6e50809e47$var$emptyViewContainerStyles = null;
const $c201fa6e50809e47$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $gMc0m.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};
module.exports["EmptyViewWithFixedHeight"] = $c201fa6e50809e47$export$8f45b9407d4090d7;
module.exports["EmptyViewContainer"] = $c201fa6e50809e47$export$381ea436de119582;

});

parcelRegister("4S6q0", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6ZeF0 = parcelRequire("6ZeF0");


var $cBjhI = parcelRequire("cBjhI");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $07b7d6d69c936337$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $cBjhI.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $07b7d6d69c936337$var$Body = (0, $6ZeF0.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($07b7d6d69c936337$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$07b7d6d69c936337$export$2e2bcd8739ae039 = $07b7d6d69c936337$var$Body;
module.exports["default"] = $07b7d6d69c936337$export$2e2bcd8739ae039;

});

parcelRegister("6ZeF0", function(module, exports) {
$parcel$export(module.exports, "default", () => $9b3dd488c65554a3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $acwm0 = parcelRequire("acwm0");


var $iZTFQ = parcelRequire("iZTFQ");

const $9b3dd488c65554a3$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $9b3dd488c65554a3$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $acwm0.ASC) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $9b3dd488c65554a3$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $9b3dd488c65554a3$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $9b3dd488c65554a3$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iZTFQ.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $9b3dd488c65554a3$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $iZTFQ.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args);
            this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $l998X.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("cBjhI", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lLKv4 = parcelRequire("lLKv4");


var $iu1PC = parcelRequire("iu1PC");

const $979466b421ef3326$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iu1PC.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $lLKv4.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$979466b421ef3326$export$2e2bcd8739ae039 = $979466b421ef3326$var$Row;
module.exports["default"] = $979466b421ef3326$export$2e2bcd8739ae039;

});

parcelRegister("lLKv4", function(module, exports) {
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $lo5NK = parcelRequire("lo5NK");

const $14854dc930c609a4$var$fixedSizeTruncateStyles = null;
const $14854dc930c609a4$var$overflowTruncateStyles = null;
const $14854dc930c609a4$var$truncationWidthStyles = null;
const $14854dc930c609a4$var$cellStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $14854dc930c609a4$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $l998X.jsx)("td" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        style: (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        // @ts-ignore
        ref: innerRef,
        className: (0, $gMc0m.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });
module.exports["TableBodyCell"] = $14854dc930c609a4$export$948e91fcef170792;

});

parcelRegister("lo5NK", function(module, exports) {
const $2d66c0434ecf2ef8$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $2d66c0434ecf2ef8$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$2d66c0434ecf2ef8$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
module.exports["getTruncationStyleVars"] = $2d66c0434ecf2ef8$export$5e6497a652ae30b5;

});

parcelRegister("iu1PC", function(module, exports) {
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $8163b397157d0c91$var$rowStyles = null;
const $8163b397157d0c91$var$rowBackgroundStyles = null;
const $8163b397157d0c91$var$rowHighlightedBackgroundStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $8163b397157d0c91$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("tr", {
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $gMc0m.default)([
            "_bfhksm61 _1ygbdfik _1ah312gs",
            isHighlighted ? "_bfhk15s3 _irr3ufnl" : "_irr31dpa",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});
module.exports["TableBodyRow"] = $8163b397157d0c91$export$45f39d9c38b886d5;

});

parcelRegister("ariie", function(module, exports) {

var $42omo = parcelRequire("42omo");

class $e87925282ef46156$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
module.exports["ErrorBoundary"] = $e87925282ef46156$export$e926676385687eaf;

});

parcelRegister("fsOrO", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $2qpLu = parcelRequire("2qpLu");

class $d7f23e5c1016680b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $2qpLu.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $2qpLu.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}
$d7f23e5c1016680b$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: (0, $acwm0.LOADING_CONTENTS_OPACITY),
    loadingLabel: 'Loading table'
};
module.exports["default"] = $d7f23e5c1016680b$export$2e2bcd8739ae039;

});

parcelRegister("2qpLu", function(module, exports) {
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0273760afafdefb6$export$c335a80381ec61f5 = '--contents-opacity';
const $0273760afafdefb6$var$containerStyles = null;
const $0273760afafdefb6$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $gMc0m.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $0273760afafdefb6$var$contentsContainerStyles = null;
const $0273760afafdefb6$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            [$0273760afafdefb6$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $gMc0m.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $0273760afafdefb6$var$spinnerContainerStyles = null;
const $0273760afafdefb6$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });
module.exports["Container"] = $0273760afafdefb6$export$42a852a2b6b56249;
module.exports["ContentsContainer"] = $0273760afafdefb6$export$67c29eae8ae2137a;
module.exports["SpinnerContainer"] = $0273760afafdefb6$export$a5e06607a5ac6158;

});

parcelRegister("gR32R", function(module, exports) {
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");


var $acwm0 = parcelRequire("acwm0");


var $eQFTY = parcelRequire("eQFTY");

class $23b1b51bd1ae612c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eQFTY.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eQFTY.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createRef();
        this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        };
        this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        };
        this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        };
        this.componentWillUnmount = ()=>{
            this.detachListeners();
        };
        this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        };
        this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps);
        this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        };
        this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        };
        this.handleResize = ()=>{
            this.updateSpinnerPosition();
        };
        this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        };
        this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        };
        this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}
$23b1b51bd1ae612c$export$2e2bcd8739ae039.defaultProps = {
    isLoading: true,
    spinnerSize: (0, $acwm0.LARGE),
    contentsOpacity: `var(--ds-opacity-loading, ${`${0, $acwm0.LOADING_CONTENTS_OPACITY}`})`,
    loadingLabel: 'Loading table'
};
module.exports["default"] = $23b1b51bd1ae612c$export$2e2bcd8739ae039;

});

parcelRegister("eQFTY", function(module, exports) {
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $6d5e1b6cb99753a2$var$containerStyles = null;
const $6d5e1b6cb99753a2$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $6d5e1b6cb99753a2$var$spinnerBackdropStyles = null;
const $6d5e1b6cb99753a2$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $gMc0m.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $6d5e1b6cb99753a2$var$spinnerContainerStyles = null;
const $6d5e1b6cb99753a2$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: ref,
        className: (0, $gMc0m.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));
module.exports["Container"] = $6d5e1b6cb99753a2$export$42a852a2b6b56249;
module.exports["SpinnerBackdrop"] = $6d5e1b6cb99753a2$export$aa207050321b0c53;
module.exports["SpinnerContainer"] = $6d5e1b6cb99753a2$export$a5e06607a5ac6158;

});

parcelRegister("3l42I", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dsM1s = parcelRequire("dsM1s");

class $5ca997743c0935b2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $dsM1s.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args);
        this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}
module.exports["default"] = $5ca997743c0935b2$export$2e2bcd8739ae039;

});

parcelRegister("dsM1s", function(module, exports) {
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $6mkwk = parcelRequire("6mkwk");


var $laHi9 = parcelRequire("laHi9");


var $6R5uz = parcelRequire("6R5uz");


var $gdv5Z = parcelRequire("gdv5Z");

var $u9agA = parcelRequire("u9agA");


var $aNNTx = parcelRequire("aNNTx");


var $hBGRU = parcelRequire("hBGRU");


var $kLrz5 = parcelRequire("kLrz5");


var $dSfjw = parcelRequire("dSfjw");


var $l7NbM = parcelRequire("l7NbM");

const $6fe03321c7228100$var$styles = {
    paginationMenu: "_1q51ze3t _y4tize3t _85i5ze3t _bozgze3t _1pfhze3t _12l2ze3t _6rthze3t _ahbqze3t",
    paginationMenuItem: "_1pfhze3t _ect4ttxp",
    navigatorIconWrapper: "_18zr12x7"
};
const $6fe03321c7228100$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $6fe03321c7228100$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($laHi9))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "span",
        xcss: $6fe03321c7228100$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $l998X.jsx)(Chevron, {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}
function $6fe03321c7228100$var$InnerPagination({ components: components = (0, $dSfjw.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $dSfjw.emptyObject), max: max = 7, onChange: onChange = (0, $ee7An.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $kLrz5.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $6mkwk.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$6fe03321c7228100$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
            as: "li",
            xcss: $6fe03321c7228100$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hBGRU.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $6fe03321c7228100$var$styles.paginationMenu,
                    children: (0, $l7NbM.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $aNNTx.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $l998X.jsx)($6fe03321c7228100$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $6fe03321c7228100$var$Pagination = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)($6fe03321c7228100$var$InnerPagination));
var $6fe03321c7228100$export$2e2bcd8739ae039 = $6fe03321c7228100$var$Pagination;
module.exports["default"] = $6fe03321c7228100$export$2e2bcd8739ae039;

});

parcelRegister("aNNTx", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e29809e32dcc0c3$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $4e29809e32dcc0c3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("hBGRU", function(module, exports) {
$parcel$export(module.exports, "default", () => $2cc2659209e25aa4$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");

function $2cc2659209e25aa4$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("kLrz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $327224ec3ee62dd2$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");

const $327224ec3ee62dd2$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $327224ec3ee62dd2$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        as: "li",
        testId: testId,
        xcss: $327224ec3ee62dd2$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $6F6hl.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("dSfjw", function(module, exports) {
const $ccc55450a2ce3996$export$3f860eba1218f8d3 = {};
module.exports["emptyObject"] = $ccc55450a2ce3996$export$3f860eba1218f8d3;

});

parcelRegister("l7NbM", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");

// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $e6d8d358662d744b$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $2XqLN.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $e6d8d358662d744b$export$2e2bcd8739ae039 = $e6d8d358662d744b$var$collapseRange;
module.exports["default"] = $e6d8d358662d744b$export$2e2bcd8739ae039;

});

parcelRegister("lF3zd", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iZTFQ = parcelRequire("iZTFQ");


var $65EM3 = parcelRequire("65EM3");


var $l8KsL = parcelRequire("l8KsL");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $28a7f7501af435d6$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    UNSAFE_componentWillMount() {
        (0, $iZTFQ.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iZTFQ.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $l8KsL.default) : (0, $73K2i.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $l998X.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $l998X.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$28a7f7501af435d6$export$2e2bcd8739ae039 = $28a7f7501af435d6$var$TableHead;
module.exports["default"] = $28a7f7501af435d6$export$2e2bcd8739ae039;

});

parcelRegister("65EM3", function(module, exports) {
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $acwm0 = parcelRequire("acwm0");


var $lo5NK = parcelRequire("lo5NK");

const $207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $207a1abf337d81f4$var$rankingStyles = null;
const $207a1abf337d81f4$var$headStyles = null;
const $207a1abf337d81f4$var$overflowTruncateStyles = null;
const $207a1abf337d81f4$var$truncationWidthStyles = null;
const $207a1abf337d81f4$var$fixedSizeTruncateStyles = null;
const $207a1abf337d81f4$var$cellStyles = null;
const $207a1abf337d81f4$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $gMc0m.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $207a1abf337d81f4$var$headCellBaseStyles = null;
const $207a1abf337d81f4$export$4e8024263ace498b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $lo5NK.getTruncationStyleVars)({
            width: width
        }),
        [$207a1abf337d81f4$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $acwm0.ASC);
    const isDESC = sortOrder === (0, $acwm0.DESC);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    }; // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $gMc0m.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8wadc _179r1uh4 _mqm2glyw _kqswh2mm _syazazsu _k48pwu06 _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});
module.exports["Head"] = $207a1abf337d81f4$export$e93312b7773dfcac;
module.exports["HeadCell"] = $207a1abf337d81f4$export$4e8024263ace498b;

});

parcelRegister("l8KsL", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iwGL6 = parcelRequire("iwGL6");


var $iZTFQ = parcelRequire("iZTFQ");


var $73K2i = parcelRequire("73K2i");

// eslint-disable-next-line @repo/internal/react/no-class-components
class $3c91b6293fefaa96$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $iZTFQ.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $73K2i.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $3c91b6293fefaa96$var$RankableTableHeadCell = (0, $iwGL6.default)($3c91b6293fefaa96$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$3c91b6293fefaa96$export$2e2bcd8739ae039 = $3c91b6293fefaa96$var$RankableTableHeadCell;
module.exports["default"] = $3c91b6293fefaa96$export$2e2bcd8739ae039;

});

parcelRegister("iwGL6", function(module, exports) {
$parcel$export(module.exports, "default", () => $12473f443f38c444$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $12473f443f38c444$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $l998X.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.ref = void 0;
            this.state = {
                refWidth: 0,
                refHeight: 0
            };
            this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            };
            this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("73K2i", function(module, exports) {
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $22Iw9 = parcelRequire("22Iw9");


var $euUgw = parcelRequire("euUgw");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");


var $3gadb = parcelRequire("3gadb");


var $acwm0 = parcelRequire("acwm0");


var $65EM3 = parcelRequire("65EM3");

const $b62786d16abca385$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk1j28 _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk1j28 _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $b62786d16abca385$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c8wadc _syazazsu _k48pwu06"
};
const $b62786d16abca385$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $42omo.useState)(false);
    const [isFocused, setIsFocused] = (0, $42omo.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $42omo.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $42omo.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $42omo.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $b62786d16abca385$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: sortOrder === (0, $acwm0.ASC) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
                onClick: onClick,
                xcss: $b62786d16abca385$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isVisibleIconOnlyHeader ? $b62786d16abca385$var$styles.hideIconHeaderWrapper : $b62786d16abca385$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $l998X.jsx)("span", {
                            className: (0, $gMc0m.default)([
                                $b62786d16abca385$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                        xcss: isSortIconVisible ? $b62786d16abca385$var$styles.sortIconVisibleWrapper : $b62786d16abca385$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $acwm0.ASC) ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($22Iw9))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $65EM3.HeadCell // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b62786d16abca385$export$2e2bcd8739ae039 = $b62786d16abca385$var$TableHeadCell;
module.exports["default"] = $b62786d16abca385$export$2e2bcd8739ae039;

});

parcelRegister("jQuNB", function(module, exports) {

let $e72ac3b3a9bdc9c9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e72ac3b3a9bdc9c9$var$load("iNa18"),
    $e72ac3b3a9bdc9c9$var$load("8makw"),
    $e72ac3b3a9bdc9c9$var$load("heWL2")
]).then(()=>parcelRequire('dHxkf'));

});

parcelRegister("lBvGi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $56c2dc0faf44f7eb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $kZ5GD = parcelRequire("kZ5GD");

const $56c2dc0faf44f7eb$var$noOptions = [];
function $56c2dc0faf44f7eb$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $56c2dc0faf44f7eb$var$noOptions, value: propValue, defaultValue: defaultValue, id: id, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, labelId: labelId, onInvalid: onInvalid = (0, $ee7An.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const uid = (0, $c0qxy.useId)();
    const [selectedValue, setSelectedValue] = (0, $42omo.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "radiogroup",
        // TODO: Make `aria-labelledby` a `never` in TS. See https://product-fabric.atlassian.net/browse/DSP-23009
        "aria-labelledby": labelId || ariaLabelledBy,
        "data-testid": testId,
        "aria-describedby": isInvalid ? `${id || uid}-error` : undefined,
        id: id || uid,
        children: options.map(({ ...optionProps }, index)=>{
            if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
            const isChecked = value !== null && optionProps.value === value;
            return /*#__PURE__*/ (0, $42omo.createElement)((0, $kZ5GD.default), {
                ...optionProps,
                name: name || optionProps.name,
                key: index,
                onChange: onRadioChange,
                onInvalid: onInvalid,
                isInvalid: isChecked && isInvalid,
                isChecked: isChecked,
                testId: optionProps.testId || testId,
                isRequired: isRequired,
                analyticsContext: analyticsContext
            });
        })
    });
}

});

parcelRegister("h17uI", function(module, exports) {
/*!
 * is-number <https://github.com/jonschlinkert/is-number>
 *
 * Copyright (c) 2014-present, Jon Schlinkert.
 * Released under the MIT License.
 */ 'use strict';
module.exports = function(num) {
    if (typeof num === 'number') return num - num === 0;
    if (typeof num === 'string' && num.trim() !== '') return Number.isFinite ? Number.isFinite(+num) : isFinite(+num);
    return false;
};

});

parcelRegister("bIBXx", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dWCFT = parcelRequire("dWCFT");

var $cFEpk = parcelRequire("cFEpk");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $5TGLQ = parcelRequire("5TGLQ");


var $99qsA = parcelRequire("99qsA");

var $6T8v4 = parcelRequire("6T8v4");

var $eKXGE = parcelRequire("eKXGE");


var $2oOe7 = parcelRequire("2oOe7");


var $jgNUL = parcelRequire("jgNUL");


var $6BP5H = parcelRequire("6BP5H");


var $7lMCw = parcelRequire("7lMCw");


var $cda8t = parcelRequire("cda8t");

const $6a13142a7a4ddecd$var$packageName = "platform-pkg";
const $6a13142a7a4ddecd$var$packageVersion = "0.0.0-use.local";
const $6a13142a7a4ddecd$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $6a13142a7a4ddecd$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $6a13142a7a4ddecd$var$packageName,
    packageVersion: $6a13142a7a4ddecd$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $6a13142a7a4ddecd$var$TimePicker = /*#__PURE__*/ (0, $42omo.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $ee7An.default), onChange: providedOnChange = (0, $ee7An.default), onFocus: providedOnFocus = (0, $ee7An.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $6BP5H.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $2oOe7.defaultTimes), value: providedValue }, _ref)=>{
    const [containerRef, setContainerRef] = (0, $42omo.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $42omo.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $42omo.useState)(false);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(defaultIsOpen);
    const [value, setValue] = (0, $42omo.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $42omo.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$6a13142a7a4ddecd$var$analyticsAttributes
    });
    (0, $42omo.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $42omo.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $42omo.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $2oOe7.defaultTimeFormat));
            } catch  {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $dWCFT.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $5TGLQ.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $99qsA.default) : (0, $6T8v4.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $2oOe7.defaultTimeFormat));
        const date = (0, $6BP5H.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $cFEpk.default)(date)) return time;
        if (timeFormat) return (0, $dWCFT.default)(date, (0, $7lMCw.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $cda8t.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $2oOe7.EmptyComponent),
        Menu: (0, $jgNUL.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $2oOe7.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $eKXGE.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$6a13142a7a4ddecd$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $l998X.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                // @ts-ignore - Type mismatch with components - workaround for help-center local consumption
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                // @ts-ignore - Type mismatch with onChange handler - workaround for help-center local consumption
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $2oOe7.placeholderDatetime)),
                // @ts-ignore - Type mismatch with styles config - workaround for help-center local consumption
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $6a13142a7a4ddecd$export$2e2bcd8739ae039 = $6a13142a7a4ddecd$var$TimePicker;
module.exports["default"] = $6a13142a7a4ddecd$export$2e2bcd8739ae039;

});

parcelRegister("jgNUL", function(module, exports) {
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $3hOY6 = parcelRequire("3hOY6");


var $hq1yX = parcelRequire("hq1yX");

const $234f598d19f6cd6a$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $hq1yX.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $l998X.jsx)((0, $3hOY6.components).Menu // We have to have this because `getClassNames` is missing. Can't define
        , {
            ...rest,
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });
module.exports["FixedLayerMenu"] = $234f598d19f6cd6a$export$982ad994195b4356;

});

parcelRegister("6BP5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $8831c39f93c6811b$export$2e2bcd8739ae039);
const $8831c39f93c6811b$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $8831c39f93c6811b$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $8831c39f93c6811b$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $8831c39f93c6811b$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $8831c39f93c6811b$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $8831c39f93c6811b$var$map24[hour];
    return hour;
}
function $8831c39f93c6811b$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $8831c39f93c6811b$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $8831c39f93c6811b$var$formatSemi24(timeArray[0].trim());
    const hour = $8831c39f93c6811b$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $8831c39f93c6811b$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $8831c39f93c6811b$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $8831c39f93c6811b$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$8831c39f93c6811b$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $8831c39f93c6811b$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $8831c39f93c6811b$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $8831c39f93c6811b$var$assignToDate(time2);
}

});

parcelRegister("2pBiX", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");

const $e5ba90f4b97bd7c1$var$i18n = (0, $cgtv4.defineMessages)({
    errorTitleCannotStart: {
        id: "loom-utils.error-flag.title.cannot-start",
        defaultMessage: "We couldn\u2019t start your recording"
    },
    errorSDKFailedToInitialize: {
        id: "loom-utils.error-flag.description.sdk-failed-to-initialize",
        defaultMessage: "Give it a moment and then refresh to try again."
    }
});
const $e5ba90f4b97bd7c1$export$b8f10a3122c10d73 = (0, $3u0dr.isReactCompilerActiveV2)() ? (t0)=>{
    const $ = (0, $frIzR.c)(3);
    const { flags: flags } = t0;
    const intl = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== flags || $[1] !== intl) {
        t1 = ()=>{
            flags.showInfoFlag({
                title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
                description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
            });
        };
        $[0] = flags;
        $[1] = intl;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ flags: flags })=>{
    const intl = (0, $8C5kA.default)();
    return (0, $42omo.useCallback)(()=>{
        flags.showInfoFlag({
            title: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorTitleCannotStart),
            description: intl.formatMessage($e5ba90f4b97bd7c1$var$i18n.errorSDKFailedToInitialize)
        });
    }, [
        flags,
        intl
    ]);
};
module.exports["useLoomEntryPointErrorCallback"] = $e5ba90f4b97bd7c1$export$b8f10a3122c10d73;

});

parcelRegister("5kjCz", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $irVI7 = parcelRequire("irVI7");


var $glCMv = parcelRequire("glCMv");


var $fGzMp = parcelRequire("fGzMp");


var $kmyYx = parcelRequire("kmyYx");


var $aJPUt = parcelRequire("aJPUt");


var $04e9M = parcelRequire("04e9M");


var $78QFu = parcelRequire("78QFu");


var $9Cbhx = parcelRequire("9Cbhx");

const $44f37a86f8c1409e$export$c3c3c3f81a03570c = 'renderer';
const $44f37a86f8c1409e$export$e70b8cd540123fd4 = 'editor';
const $44f37a86f8c1409e$export$f783453b83c906eb = 'pdf';
const $44f37a86f8c1409e$var$ACTION = {
    SUCCESS: 'taskSuccess',
    FAIL: 'taskFail',
    ABORT: 'taskAbort',
    START: 'taskStart'
};
const $44f37a86f8c1409e$export$84a4de0ef6621278 = (name)=>name.split('.').slice(1).join('.');
const $44f37a86f8c1409e$export$b94fa6ed199caed2 = (macroEventRegister = new Map())=>{
    const macros = [];
    // @ts-ignore
    for (const v of macroEventRegister.values()){
        const { name: name } = v;
        if (name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) {
            const macro = {
                uniqueHash: $44f37a86f8c1409e$export$84a4de0ef6621278(name),
                ...$44f37a86f8c1409e$export$ae13022b12e7d19a(v)
            };
            macros.push(macro);
        }
    }
    return macros;
};
const $44f37a86f8c1409e$export$c1196ba2be68e8d3 = (macro)=>{
    return {
        type: macro?.type || '',
        macroId: (0, $9Cbhx.getMacroId)(macro?.parameters),
        extensionKey: (0, $9Cbhx.getExtensionKey)(macro),
        extensionType: macro?.extensionType || ''
    };
};
const $44f37a86f8c1409e$export$ae13022b12e7d19a = (macroEvent)=>{
    return {
        extensionKey: (0, $9Cbhx.getExtensionKey)(macroEvent?.experienceAttributes),
        extensionType: macroEvent?.experienceAttributes?.extensionType || '',
        type: macroEvent?.experienceAttributes?.type || '',
        macroId: macroEvent?.experienceAttributes?.macroId || '',
        duration: macroEvent?.duration || '',
        status: macroEvent?.status || '',
        pageId: macroEvent?.pageId || ''
    };
};
const $44f37a86f8c1409e$export$b16b3cab64ff0bd4 = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) return;
    $44f37a86f8c1409e$export$f7c63e38d5d9fd0b(mode, contentId).start({
        attributes: {
            mode: mode
        },
        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
        id: contentId
    });
};
const $44f37a86f8c1409e$export$f9ebd83e8406755f = (mode, contentId)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    if (macroEventRegister.has(contentId)) {
        if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister)) {
            const macroAttributes = {
                mode: mode,
                macros: null
            };
            if ($44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) macroAttributes.macros = $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister);
            (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    ...macroAttributes
                }
            });
        } else (0, $fGzMp.getExperienceTracker)().abort({
            name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
            reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
            attributes: {
                macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                mode: mode
            }
        });
        const jiraMacro = $44f37a86f8c1409e$export$32db3a6a0c8b81ea(macroEventRegister);
        jiraMacro.forEach((macro)=>{
            const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
            const status = macro.status;
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: status,
                    attributes: {
                        ...macro.experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`
                    }
                });
            });
        });
        // clean up after aborting all event
        macroEventRegister.clear();
        $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
    }
};
const $44f37a86f8c1409e$export$d693932e457c5586 = (eventRegister = new Map())=>{
    if (eventRegister.size === 0) return true;
    // only check whether all sub-experience has finished
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) return false;
    }
    return true;
};
const $44f37a86f8c1409e$export$375cf77d729480fb = (eventRegister = new Map())=>{
    // @ts-ignore
    for (const v of eventRegister.values()){
        if (v.name !== (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) return true;
    }
    return false;
};
const $44f37a86f8c1409e$export$faf154bb66b40b64 = (name)=>name.includes((0, $9Cbhx.JIRA_EXTENSION_KEY));
const $44f37a86f8c1409e$export$f2ada44de4a33ea1 = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name) && v.status !== $44f37a86f8c1409e$var$ACTION.SUCCESS) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$32db3a6a0c8b81ea = (eventRegister)=>{
    const macros = [];
    // Type 'IterableIterator<[string, MacroExperienceAttribute]>' is not an array type
    // or a string type. Use compiler option '--downlevelIteration'
    // to allow iterating of iterators
    // @ts-ignore
    for (const v of eventRegister.values())if ($44f37a86f8c1409e$export$faf154bb66b40b64(v.name)) macros.push(v);
    return macros;
};
const $44f37a86f8c1409e$export$98d7b4463a1de442 = (contentId, mode)=>{
    (function macroTimeout() {
        setTimeout(()=>{
            const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
            if (!macroEventRegister.has(contentId)) return;
            const pageEvent = macroEventRegister.get(contentId);
            const isTimedOut = Math.round(window.performance.now() - pageEvent.startTime) > (0, $aJPUt.ExperienceTimeout).MACRO_LOAD;
            // 1. all macro loaded or main-experience timeout and have sub-experience
            //    succeed the main experience and report to experience tracker and done
            if ($44f37a86f8c1409e$export$d693932e457c5586(macroEventRegister) && $44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            else if (isTimedOut) {
                // 2a. timeout does not has sub-experience, succeed the main experience
                if (!$44f37a86f8c1409e$export$375cf77d729480fb(macroEventRegister)) (0, $fGzMp.getExperienceTracker)().succeed({
                    name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                    attributes: {
                        mode: mode
                    }
                });
                else {
                    (0, $fGzMp.getExperienceTracker)().abort({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        reason: `Some macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`,
                        attributes: {
                            macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                            mode: mode
                        }
                    });
                    const unsuceededJIRAMacro = $44f37a86f8c1409e$export$f2ada44de4a33ea1(macroEventRegister);
                    unsuceededJIRAMacro.forEach((macro)=>{
                        const extensionKey = (0, $9Cbhx.getExtensionKey)(macro.experienceAttributes);
                        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                            analyticsWebClient.sendOperationalEvent({
                                source: 'ui',
                                actionSubject: 'macroTracker',
                                action: 'taskAbort',
                                attributes: {
                                    ...macro.experienceAttributes,
                                    extensionKey: extensionKey,
                                    mode: mode,
                                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                                    reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                                }
                            });
                        });
                    });
                }
                // clean up after aborting all event
                macroEventRegister.clear();
                $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            } else macroTimeout();
        }, 2000);
    })();
};
const $44f37a86f8c1409e$var$macroEventRegisterHash = new Map();
const $44f37a86f8c1409e$export$adf8cb42c7fe1834 = (mode, contentId)=>{
    if ($44f37a86f8c1409e$var$macroEventRegisterHash.has(`${mode}.${contentId}`)) return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, new Map());
    return $44f37a86f8c1409e$var$macroEventRegisterHash.get(`${mode}.${contentId}`);
};
const $44f37a86f8c1409e$export$d7fca4196d2b6b6c = (mode, contentId, name, experienceAttributes)=>{
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
            analyticsWebClient.sendOperationalEvent({
                source: 'ui',
                actionSubject: 'macroTracker',
                action: 'taskStart',
                attributes: {
                    ...experienceAttributes,
                    extensionKey: extensionKey,
                    mode: mode,
                    pageId: contentId,
                    task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                    pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                }
            });
        });
    }
};
const $44f37a86f8c1409e$export$d10b6dded8392899 = (mode, contentId, name, experienceAttributes)=>{
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    const macroId = experienceAttributes?.macroId;
    if (!macroEventRegister.has(macroId)) return;
    if ($44f37a86f8c1409e$export$faf154bb66b40b64(name)) {
        const extensionKey = (0, $9Cbhx.getExtensionKey)(experienceAttributes);
        const { status: status } = macroEventRegister.get(macroId);
        if (status === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskSuccess',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        pageLoadInfo: (0, $78QFu.getUniquePageLoadId)()
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.ABORT) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskAbort',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        reason: `JIRA macro aborted before completion in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`
                    }
                });
            });
        } else if (status === $44f37a86f8c1409e$var$ACTION.FAIL) {
            const { duration: duration } = macroEventRegister.get(macroId);
            (0, $04e9M.getAnalyticsWebClient)().then((analyticsWebClient)=>{
                analyticsWebClient.sendOperationalEvent({
                    source: 'ui',
                    actionSubject: 'macroTracker',
                    action: 'taskFail',
                    attributes: {
                        ...experienceAttributes,
                        extensionKey: extensionKey,
                        mode: mode,
                        duration: duration,
                        task: `${(0, $irVI7.VIEW_JIRA_MACRO_EXPERIENCE)}`,
                        error: new (0, $glCMv.ExperienceTimeoutError)(`JIRA macro failed to complete in ${(0, $aJPUt.ExperienceTimeout).MACRO_LOAD}ms`)
                    }
                });
            });
        }
    }
};
const $44f37a86f8c1409e$export$f7c63e38d5d9fd0b = (0, $2XqLN.default)((mode, contentId)=>{
    const macroTracker = new (0, $kmyYx.ExperienceTracker)();
    const macroEventRegister = $44f37a86f8c1409e$export$adf8cb42c7fe1834(mode, contentId);
    macroTracker.subscribe((event)=>{
        const { action: action, name: name, attributes: experienceAttributes, ...rest } = event;
        const macroId = experienceAttributes?.macroId;
        if (action === $44f37a86f8c1409e$var$ACTION.START) {
            // prevent triggering of event
            const current = macroEventRegister.get(macroId);
            if (current && current.id === macroId) return;
            if (name === (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE)) // prevent firing the same view-all-macro more than once
            {
                if (!macroEventRegister.has(contentId)) {
                    // clear the event register, prevent event being re-tracked between SPA transition
                    macroEventRegister.clear();
                    (0, $fGzMp.getExperienceTracker)().start({
                        name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                        timeout: (0, $aJPUt.ExperienceTimeout).MACRO_LOAD,
                        id: contentId,
                        attributes: {
                            mode: mode
                        }
                    });
                    macroEventRegister.set(contentId, {
                        status: $44f37a86f8c1409e$var$ACTION.START,
                        name: name,
                        mode: mode,
                        ...rest
                    });
                    $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
                }
            } else {
                // tracking each macro, report to MacroTracker
                macroEventRegister.set(macroId, {
                    status: $44f37a86f8c1409e$var$ACTION.START,
                    name: name,
                    experienceAttributes: {
                        ...experienceAttributes,
                        extensionKey: (0, $9Cbhx.getExtensionKey)(experienceAttributes)
                    },
                    pageId: contentId,
                    mode: mode,
                    ...rest
                });
                $44f37a86f8c1409e$export$d7fca4196d2b6b6c(mode, contentId, name, experienceAttributes);
            }
        } else if (action === $44f37a86f8c1409e$var$ACTION.SUCCESS) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, name: name } = event;
            // tracking each macro when it successfully loads
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.SUCCESS,
                duration: duration,
                pageId: contentId
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action === $44f37a86f8c1409e$var$ACTION.ABORT) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, reason: reason, name: name } = event;
            // tracking each macro when it aborts loading
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.ABORT,
                duration: duration,
                pageId: contentId,
                reason: reason
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro aborts to load, aborts the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().abort({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                reason: 'Macro abort loading',
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        } else if (action == $44f37a86f8c1409e$var$ACTION.FAIL) {
            // if event is not yet track
            if (!macroEventRegister.has(macroId)) return;
            const { duration: duration, error: error, name: name } = event;
            // tracking each macro when it fails to load
            macroEventRegister.set(macroId, {
                ...macroEventRegister.get(macroId),
                id: macroId,
                name: name,
                mode: mode,
                status: $44f37a86f8c1409e$var$ACTION.FAIL,
                duration: duration,
                pageId: contentId,
                error: error
            });
            $44f37a86f8c1409e$var$macroEventRegisterHash.set(`${mode}.${contentId}`, macroEventRegister);
            // one macro fails to load, fails the entire experience and report to ExperienceTracker
            (0, $fGzMp.getExperienceTracker)().fail({
                name: (0, $irVI7.VIEW_ALL_MACRO_EXPERIENCE),
                error: error,
                attributes: {
                    macros: $44f37a86f8c1409e$export$b94fa6ed199caed2(macroEventRegister),
                    mode: mode,
                    ...experienceAttributes
                }
            });
            $44f37a86f8c1409e$export$d10b6dded8392899(mode, contentId, name, experienceAttributes);
        }
        $44f37a86f8c1409e$export$98d7b4463a1de442(contentId, mode);
    });
    return macroTracker;
});
const $44f37a86f8c1409e$export$4ce0bedef4e84bb7 = (mode, extension)=>{
    const attributes = $44f37a86f8c1409e$export$c1196ba2be68e8d3(extension);
    return `${mode}.${(0, $9Cbhx.getExtensionKey)(attributes)}.${attributes.macroId}`;
};
module.exports["RENDERER"] = $44f37a86f8c1409e$export$c3c3c3f81a03570c;
module.exports["EDITOR"] = $44f37a86f8c1409e$export$e70b8cd540123fd4;
module.exports["PDF"] = $44f37a86f8c1409e$export$f783453b83c906eb;
module.exports["getMacroAttributesFromADFNode"] = $44f37a86f8c1409e$export$c1196ba2be68e8d3;
module.exports["startMacroExperience"] = $44f37a86f8c1409e$export$b16b3cab64ff0bd4;
module.exports["getMacroExperienceTracker"] = $44f37a86f8c1409e$export$f7c63e38d5d9fd0b;
module.exports["stopMacroExperience"] = $44f37a86f8c1409e$export$f9ebd83e8406755f;
module.exports["stopJIRAMacro"] = $44f37a86f8c1409e$export$d10b6dded8392899;
module.exports["getExperienceName"] = $44f37a86f8c1409e$export$4ce0bedef4e84bb7;

});

parcelRegister("9Cbhx", function(module, exports) {

var $kyKWe = parcelRequire("kyKWe");


var $hukUK = parcelRequire("hukUK");

const $9293ebd9645c82d6$export$7486394da5136452 = 'jira';
const $9293ebd9645c82d6$export$8d178e7efa3ed0e7 = 'issue-count';
const $9293ebd9645c82d6$export$c3f023baaa9b214b = 'table-view';
const $9293ebd9645c82d6$export$7d601f5ae4a82040 = 'single-issue';
const $9293ebd9645c82d6$export$47eae2202f029f6b = (parameters)=>{
    if (!parameters) return (0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))();
    const idFromNode = parameters?.macroMetadata?.macroId?.value;
    if (idFromNode) return idFromNode;
    // for macro that does not have unique macro id, we want to generate some unique id
    return (0, $hukUK.objectHash)(parameters);
};
const $9293ebd9645c82d6$export$218d96312e385949 = (attributes)=>{
    if (!attributes) return '';
    const { extensionKey: extensionKey } = attributes;
    const macroParams = attributes?.parameters?.macroParams;
    if (extensionKey === $9293ebd9645c82d6$export$7486394da5136452) return `${extensionKey}${$9293ebd9645c82d6$export$cc2f094f034c7f8f(macroParams)}`;
    return extensionKey;
};
const $9293ebd9645c82d6$export$cc2f094f034c7f8f = (macroParams)=>{
    const prefix = '-';
    if (macroParams?.count?.value === 'true') return prefix + $9293ebd9645c82d6$export$8d178e7efa3ed0e7;
    else if (macroParams?.columns && macroParams?.maximumIssues) return prefix + $9293ebd9645c82d6$export$c3f023baaa9b214b;
    else if (macroParams?.key?.value) return prefix + $9293ebd9645c82d6$export$7d601f5ae4a82040;
    return '';
};
module.exports["JIRA_EXTENSION_KEY"] = $9293ebd9645c82d6$export$7486394da5136452;
module.exports["getMacroId"] = $9293ebd9645c82d6$export$47eae2202f029f6b;
module.exports["getExtensionKey"] = $9293ebd9645c82d6$export$218d96312e385949;

});

parcelRegister("2bAZx", function(module, exports) {
// inspired by https://github.com/kentcdodds/use-deep-compare-effect/blob/master/src/index.js
/* eslint react-hooks/exhaustive-deps: 0 */ //Todo: this is flawed because callback is not included in the dependency array generated by useDeepCompareMemoize
// if the callback function (all use cases I found were inline functions and therfore not passed as a ref, were passes to the dep array they would trigger a re-evaluation every render defeating the purpose
// in order to properly work and handle the callback function being changed, the callback argument must be a useCallback or other function passed by ref and have it be included in the memoized depenedency array

var $42omo = parcelRequire("42omo");


var $a4TK8 = parcelRequire("a4TK8");

function $a4fa77695d2683a4$export$db77f469fe79526e(callback, dependencies) {
    (0, $42omo.useEffect)(callback, $a4fa77695d2683a4$var$useDeepCompareMemoize(dependencies));
}
//eslint-ignore react-hooks/exhaustive-deps
function $a4fa77695d2683a4$var$useDeepCompareMemoize(value) {
    const ref = (0, $42omo.useRef)();
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(value, ref.current)) ref.current = value;
    return ref.current;
}
module.exports["useDeepCompareEffect"] = $a4fa77695d2683a4$export$db77f469fe79526e;

});

parcelRegister("bX5uj", function(module, exports) {

var $5kjCz = parcelRequire("5kjCz");


var $2bAZx = parcelRequire("2bAZx");

function $b23c2b4e39153eb4$export$3462df5a881e125d({ attributes: attributes, children: children = null, contentId: contentId, extensionKey: extensionKey, mode: mode, name: name }) {
    (0, $2bAZx.useDeepCompareEffect)(()=>{
        (0, $5kjCz.getMacroExperienceTracker)(mode, contentId).succeed({
            name: name,
            attributes: attributes
        });
    }, [
        attributes,
        contentId,
        extensionKey,
        mode,
        name
    ]);
    // https://stackoverflow.com/questions/54905376
    return children;
}
module.exports["MacroExperienceSuccess"] = $b23c2b4e39153eb4$export$3462df5a881e125d;

});

parcelRegister("iP9x4", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $5yfLD = parcelRequire("5yfLD");


var $4h1jl = parcelRequire("4h1jl");


var $9wGTI = parcelRequire("9wGTI");


var $4IoVL = parcelRequire("4IoVL");

const $2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR = 'mediaProvider unavailable, must use initialAuth';
// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
const $2c59df77bd212c3d$var$isServerEnvironment = ()=>undefined;
const $2c59df77bd212c3d$var$isClientEnvironment = ()=>window.__SSR_RENDERED__;
const $2c59df77bd212c3d$var$getInitialAuth = (config)=>{
    const recordedAuth = (0, $4h1jl.mediaConfigRecorder)?.get();
    if (!recordedAuth) return undefined;
    return {
        ...recordedAuth,
        // If the mediaToken is provided in the config, use it.
        // This ensures the correct token is used in cases where the token differs from
        // the initial page, such as media included through an `include` macro.
        token: config?.mediaToken || recordedAuth.token
    };
};
const $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy = ()=>{
    if (!(0, $9wGTI.fg)('dlp_attachment_download_respects_data_export_dsp')) return false;
    const shouldEnforceDataSecurityPolicy = (0, $4h1jl.mediaConfigEnforceDSPRecorder)?.get();
    return !!shouldEnforceDataSecurityPolicy;
};
const $2c59df77bd212c3d$var$getServerModeConfig = (config)=>({
        mode: 'server',
        config: {
            authProvider: ()=>Promise.reject(new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR)),
            initialAuth: $2c59df77bd212c3d$var$getInitialAuth(config),
            enforceDataSecurityPolicy: $2c59df77bd212c3d$var$getInitialEnforceDataSecurityPolicy()
        }
    });
const $2c59df77bd212c3d$var$createClientAuthProvider = ({ contentId: contentId, spaceKey: spaceKey, isExternalShare: isExternalShare, mediaToken: mediaToken })=>async (authContext)=>{
        if (!!contentId && !!spaceKey) {
            const { viewMediaClientConfig: viewMediaClientConfig } = await (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                spaceKey: spaceKey,
                isExternalShare: isExternalShare,
                mediaToken: mediaToken
            });
            return viewMediaClientConfig.authProvider(authContext);
        } else throw new Error($2c59df77bd212c3d$var$MEDIA_PROVIDER_UNAVAILABLE_ERROR);
    };
const $2c59df77bd212c3d$var$getClientModeConfig = (config)=>({
        mode: 'client',
        config: {
            authProvider: $2c59df77bd212c3d$var$createClientAuthProvider(config),
            initialAuth: window.__MEDIA_CONFIG__,
            enforceDataSecurityPolicy: window.__MEDIA_CONFIG_ENFORCE_DSP__
        }
    });
const $2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig = (config)=>{
    if ($2c59df77bd212c3d$var$isServerEnvironment()) return $2c59df77bd212c3d$var$getServerModeConfig(config);
    else if ($2c59df77bd212c3d$var$isClientEnvironment()) return $2c59df77bd212c3d$var$getClientModeConfig(config);
};
const $2c59df77bd212c3d$export$85decadf1b9d641b = (0, $2XqLN.default)($2c59df77bd212c3d$var$getMediaSSRModeAndAuthConfig, (0, (/*@__PURE__*/$parcel$interopDefault($5yfLD))));
const $2c59df77bd212c3d$export$45c8e19bd67cadee = (config)=>{
    return $2c59df77bd212c3d$export$85decadf1b9d641b(config);
};
module.exports["getMediaSSRModeAndAuthConfigMemoized"] = $2c59df77bd212c3d$export$85decadf1b9d641b;
module.exports["useMediaSSRModeAndAuthConfig"] = $2c59df77bd212c3d$export$45c8e19bd67cadee;

});

parcelRegister("4h1jl", function(module, exports) {

var $2BiLx = parcelRequire("2BiLx");

const $c75b7ce9b9db2aec$export$279f2f878f49d0df = new (0, $2BiLx.ObjectRecorder)();
const $c75b7ce9b9db2aec$export$e125b144e38aa5db = new (0, $2BiLx.ObjectRecorder)();
module.exports["mediaConfigRecorder"] = $c75b7ce9b9db2aec$export$279f2f878f49d0df;
module.exports["mediaConfigEnforceDSPRecorder"] = $c75b7ce9b9db2aec$export$e125b144e38aa5db;

});

parcelRegister("2BiLx", function(module, exports) {
class $53dcea44a491523c$export$e411414ea02dd271 {
    set(object) {
        this.object = object;
    }
    get() {
        return this.object;
    }
    constructor(){
        this.object = null;
    }
}
module.exports["ObjectRecorder"] = $53dcea44a491523c$export$e411414ea02dd271;

});

parcelRegister("6otn0", function(module, exports) {
// DEFLATE is a complex format; to read this code, you should probably check the RFC first:
// https://tools.ietf.org/html/rfc1951
// You may also wish to take a look at the guide I made about this program:
// https://gist.github.com/101arrowz/253f31eb5abc3d9275ab943003ffecad
// Some of the following code is similar to that of UZIP.js:
// https://github.com/photopea/UZIP.js
// However, the vast majority of the codebase has diverged from UZIP.js to increase performance and reduce bundle size.
// Sometimes 0 will appear where -1 would be more appropriate. This is because using a uint
// is better for memory in most engines (I *think*).
var $4a7bc43a0955ef89$var$ch2 = {};
var $4a7bc43a0955ef89$var$wk = function(c, id, msg, transfer, cb) {
    var w = new Worker($4a7bc43a0955ef89$var$ch2[id] || ($4a7bc43a0955ef89$var$ch2[id] = URL.createObjectURL(new Blob([
        c + ';addEventListener("error",function(e){e=e.error;postMessage({$e$:[e.message,e.code,e.stack]})})'
    ], {
        type: 'text/javascript'
    }))));
    w.onmessage = function(e) {
        var d = e.data, ed = d.$e$;
        if (ed) {
            var err = new Error(ed[0]);
            err['code'] = ed[1];
            err.stack = ed[2];
            cb(err, null);
        } else cb(null, d);
    };
    w.postMessage(msg, transfer);
    return w;
};
// aliases for shorter compressed code (most minifers don't do this)
var $4a7bc43a0955ef89$var$u8 = Uint8Array, $4a7bc43a0955ef89$var$u16 = Uint16Array, $4a7bc43a0955ef89$var$i32 = Int32Array;
// fixed length extra bits
var $4a7bc43a0955ef89$var$fleb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0,
    /* unused */ 0,
    0,
    /* impossible */ 0
]);
// fixed distance extra bits
var $4a7bc43a0955ef89$var$fdeb = new $4a7bc43a0955ef89$var$u8([
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    /* unused */ 0,
    0
]);
// code length index map
var $4a7bc43a0955ef89$var$clim = new $4a7bc43a0955ef89$var$u8([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// get base, reverse index map from extra bits
var $4a7bc43a0955ef89$var$freb = function(eb, start) {
    var b = new $4a7bc43a0955ef89$var$u16(31);
    for(var i = 0; i < 31; ++i)b[i] = start += 1 << eb[i - 1];
    // numbers here are at max 18 bits
    var r = new $4a7bc43a0955ef89$var$i32(b[30]);
    for(var i = 1; i < 30; ++i)for(var j = b[i]; j < b[i + 1]; ++j)r[j] = j - b[i] << 5 | i;
    return {
        b: b,
        r: r
    };
};
var $4a7bc43a0955ef89$var$_a = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fleb, 2), $4a7bc43a0955ef89$var$fl = $4a7bc43a0955ef89$var$_a.b, $4a7bc43a0955ef89$var$revfl = $4a7bc43a0955ef89$var$_a.r;
// we can ignore the fact that the other numbers are wrong; they never happen anyway
$4a7bc43a0955ef89$var$fl[28] = 258, $4a7bc43a0955ef89$var$revfl[258] = 28;
var $4a7bc43a0955ef89$var$_b = $4a7bc43a0955ef89$var$freb($4a7bc43a0955ef89$var$fdeb, 0), $4a7bc43a0955ef89$var$fd = $4a7bc43a0955ef89$var$_b.b, $4a7bc43a0955ef89$var$revfd = $4a7bc43a0955ef89$var$_b.r;
// map of value to reverse (assuming 16 bits)
var $4a7bc43a0955ef89$var$rev = new $4a7bc43a0955ef89$var$u16(32768);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32768; ++$4a7bc43a0955ef89$var$i){
    // reverse table algorithm from SO
    var $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$i & 0xAAAA) >> 1 | ($4a7bc43a0955ef89$var$i & 0x5555) << 1;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xCCCC) >> 2 | ($4a7bc43a0955ef89$var$x & 0x3333) << 2;
    $4a7bc43a0955ef89$var$x = ($4a7bc43a0955ef89$var$x & 0xF0F0) >> 4 | ($4a7bc43a0955ef89$var$x & 0x0F0F) << 4;
    $4a7bc43a0955ef89$var$rev[$4a7bc43a0955ef89$var$i] = (($4a7bc43a0955ef89$var$x & 0xFF00) >> 8 | ($4a7bc43a0955ef89$var$x & 0x00FF) << 8) >> 1;
}
// create huffman tree from u8 "map": index -> code length for code index
// mb (max bits) must be at most 15
// TODO: optimize/split up?
var $4a7bc43a0955ef89$var$hMap = function(cd, mb, r) {
    var s = cd.length;
    // index
    var i = 0;
    // u16 "map": index -> # of codes with bit length = index
    var l = new $4a7bc43a0955ef89$var$u16(mb);
    // length of cd must be 288 (total # of codes)
    for(; i < s; ++i)if (cd[i]) ++l[cd[i] - 1];
    // u16 "map": index -> minimum code for bit length = index
    var le = new $4a7bc43a0955ef89$var$u16(mb);
    for(i = 1; i < mb; ++i)le[i] = le[i - 1] + l[i - 1] << 1;
    var co;
    if (r) {
        // u16 "map": index -> number of actual bits, symbol for code
        co = new $4a7bc43a0955ef89$var$u16(1 << mb);
        // bits to remove for reverser
        var rvb = 15 - mb;
        for(i = 0; i < s; ++i)// ignore 0 lengths
        if (cd[i]) {
            // num encoding both symbol and bits read
            var sv = i << 4 | cd[i];
            // free bits
            var r_1 = mb - cd[i];
            // start value
            var v = le[cd[i] - 1]++ << r_1;
            // m is end value
            for(var m = v | (1 << r_1) - 1; v <= m; ++v)// every 16 bit value starting with the code yields the same result
            co[$4a7bc43a0955ef89$var$rev[v] >> rvb] = sv;
        }
    } else {
        co = new $4a7bc43a0955ef89$var$u16(s);
        for(i = 0; i < s; ++i)if (cd[i]) co[i] = $4a7bc43a0955ef89$var$rev[le[cd[i] - 1]++] >> 15 - cd[i];
    }
    return co;
};
// fixed length tree
var $4a7bc43a0955ef89$var$flt = new $4a7bc43a0955ef89$var$u8(288);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 144; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
for(var $4a7bc43a0955ef89$var$i = 144; $4a7bc43a0955ef89$var$i < 256; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 9;
for(var $4a7bc43a0955ef89$var$i = 256; $4a7bc43a0955ef89$var$i < 280; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 7;
for(var $4a7bc43a0955ef89$var$i = 280; $4a7bc43a0955ef89$var$i < 288; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$flt[$4a7bc43a0955ef89$var$i] = 8;
// fixed distance tree
var $4a7bc43a0955ef89$var$fdt = new $4a7bc43a0955ef89$var$u8(32);
for(var $4a7bc43a0955ef89$var$i = 0; $4a7bc43a0955ef89$var$i < 32; ++$4a7bc43a0955ef89$var$i)$4a7bc43a0955ef89$var$fdt[$4a7bc43a0955ef89$var$i] = 5;
// fixed length map
var $4a7bc43a0955ef89$var$flm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 0), $4a7bc43a0955ef89$var$flrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$flt, 9, 1);
// fixed distance map
var $4a7bc43a0955ef89$var$fdm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 0), $4a7bc43a0955ef89$var$fdrm = /*#__PURE__*/ $4a7bc43a0955ef89$var$hMap($4a7bc43a0955ef89$var$fdt, 5, 1);
// find max of array
var $4a7bc43a0955ef89$var$max = function(a) {
    var m = a[0];
    for(var i = 1; i < a.length; ++i)if (a[i] > m) m = a[i];
    return m;
};
// read d, starting at bit p and mask with m
var $4a7bc43a0955ef89$var$bits = function(d, p, m) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8) >> (p & 7) & m;
};
// read d, starting at bit p continuing for at least 16 bits
var $4a7bc43a0955ef89$var$bits16 = function(d, p) {
    var o = p / 8 | 0;
    return (d[o] | d[o + 1] << 8 | d[o + 2] << 16) >> (p & 7);
};
// get end of byte
var $4a7bc43a0955ef89$var$shft = function(p) {
    return (p + 7) / 8 | 0;
};
// typed array slice - allows garbage collector to free original reference,
// while being more compatible than .slice
var $4a7bc43a0955ef89$var$slc = function(v, s, e) {
    if (s == null || s < 0) s = 0;
    if (e == null || e > v.length) e = v.length;
    // can't use .constructor in case user-supplied
    return new $4a7bc43a0955ef89$var$u8(v.subarray(s, e));
};
var $4a7bc43a0955ef89$export$ae5516a5a74c19a8 = {
    UnexpectedEOF: 0,
    InvalidBlockType: 1,
    InvalidLengthLiteral: 2,
    InvalidDistance: 3,
    StreamFinished: 4,
    NoStreamHandler: 5,
    InvalidHeader: 6,
    NoCallback: 7,
    InvalidUTF8: 8,
    ExtraFieldTooLong: 9,
    InvalidDate: 10,
    FilenameTooLong: 11,
    StreamFinishing: 12,
    InvalidZipData: 13,
    UnknownCompressionMethod: 14
};
// error codes
var $4a7bc43a0955ef89$var$ec = [
    'unexpected EOF',
    'invalid block type',
    'invalid length/literal',
    'invalid distance',
    'stream finished',
    'no stream handler',
    ,
    'no callback',
    'invalid UTF-8 data',
    'extra field too long',
    'date not in range 1980-2099',
    'filename too long',
    'stream finishing',
    'invalid zip data'
];
var $4a7bc43a0955ef89$var$err = function(ind, msg, nt) {
    var e = new Error(msg || $4a7bc43a0955ef89$var$ec[ind]);
    e.code = ind;
    if (Error.captureStackTrace) Error.captureStackTrace(e, $4a7bc43a0955ef89$var$err);
    if (!nt) throw e;
    return e;
};
// expands raw DEFLATE data
var $4a7bc43a0955ef89$var$inflt = function(dat, st, buf, dict) {
    // source length       dict length
    var sl = dat.length, dl = dict ? dict.length : 0;
    if (!sl || st.f && !st.l) return buf || new $4a7bc43a0955ef89$var$u8(0);
    var noBuf = !buf;
    // have to estimate size
    var resize = noBuf || st.i != 2;
    // no state
    var noSt = st.i;
    // Assumes roughly 33% compression ratio average
    if (noBuf) buf = new $4a7bc43a0955ef89$var$u8(sl * 3);
    // ensure buffer can fit at least l elements
    var cbuf = function(l) {
        var bl = buf.length;
        // need to increase size to fit
        if (l > bl) {
            // Double or set to necessary, whichever is greater
            var nbuf = new $4a7bc43a0955ef89$var$u8(Math.max(bl * 2, l));
            nbuf.set(buf);
            buf = nbuf;
        }
    };
    //  last chunk         bitpos           bytes
    var final = st.f || 0, pos = st.p || 0, bt = st.b || 0, lm = st.l, dm = st.d, lbt = st.m, dbt = st.n;
    // total bits
    var tbts = sl * 8;
    do {
        if (!lm) {
            // BFINAL - this is only 1 when last chunk is next
            final = $4a7bc43a0955ef89$var$bits(dat, pos, 1);
            // type: 0 = no compression, 1 = fixed huffman, 2 = dynamic huffman
            var type = $4a7bc43a0955ef89$var$bits(dat, pos + 1, 3);
            pos += 3;
            if (!type) {
                // go to end of byte boundary
                var s = $4a7bc43a0955ef89$var$shft(pos) + 4, l = dat[s - 4] | dat[s - 3] << 8, t = s + l;
                if (t > sl) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                // ensure size
                if (resize) cbuf(bt + l);
                // Copy over uncompressed data
                buf.set(dat.subarray(s, t), bt);
                // Get new bitpos, update byte count
                st.b = bt += l, st.p = pos = t * 8, st.f = final;
                continue;
            } else if (type == 1) lm = $4a7bc43a0955ef89$var$flrm, dm = $4a7bc43a0955ef89$var$fdrm, lbt = 9, dbt = 5;
            else if (type == 2) {
                //  literal                            lengths
                var hLit = $4a7bc43a0955ef89$var$bits(dat, pos, 31) + 257, hcLen = $4a7bc43a0955ef89$var$bits(dat, pos + 10, 15) + 4;
                var tl = hLit + $4a7bc43a0955ef89$var$bits(dat, pos + 5, 31) + 1;
                pos += 14;
                // length+distance tree
                var ldt = new $4a7bc43a0955ef89$var$u8(tl);
                // code length tree
                var clt = new $4a7bc43a0955ef89$var$u8(19);
                for(var i = 0; i < hcLen; ++i)// use index map to get real code
                clt[$4a7bc43a0955ef89$var$clim[i]] = $4a7bc43a0955ef89$var$bits(dat, pos + i * 3, 7);
                pos += hcLen * 3;
                // code lengths bits
                var clb = $4a7bc43a0955ef89$var$max(clt), clbmsk = (1 << clb) - 1;
                // code lengths map
                var clm = $4a7bc43a0955ef89$var$hMap(clt, clb, 1);
                for(var i = 0; i < tl;){
                    var r = clm[$4a7bc43a0955ef89$var$bits(dat, pos, clbmsk)];
                    // bits read
                    pos += r & 15;
                    // symbol
                    var s = r >> 4;
                    // code length to copy
                    if (s < 16) ldt[i++] = s;
                    else {
                        //  copy   count
                        var c = 0, n = 0;
                        if (s == 16) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 3), pos += 2, c = ldt[i - 1];
                        else if (s == 17) n = 3 + $4a7bc43a0955ef89$var$bits(dat, pos, 7), pos += 3;
                        else if (s == 18) n = 11 + $4a7bc43a0955ef89$var$bits(dat, pos, 127), pos += 7;
                        while(n--)ldt[i++] = c;
                    }
                }
                //    length tree                 distance tree
                var lt = ldt.subarray(0, hLit), dt = ldt.subarray(hLit);
                // max length bits
                lbt = $4a7bc43a0955ef89$var$max(lt);
                // max dist bits
                dbt = $4a7bc43a0955ef89$var$max(dt);
                lm = $4a7bc43a0955ef89$var$hMap(lt, lbt, 1);
                dm = $4a7bc43a0955ef89$var$hMap(dt, dbt, 1);
            } else $4a7bc43a0955ef89$var$err(1);
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
        }
        // Make sure the buffer can hold this + the largest possible addition
        // Maximum chunk size (practically, theoretically infinite) is 2^17
        if (resize) cbuf(bt + 131072);
        var lms = (1 << lbt) - 1, dms = (1 << dbt) - 1;
        var lpos = pos;
        for(;; lpos = pos){
            // bits read, code
            var c = lm[$4a7bc43a0955ef89$var$bits16(dat, pos) & lms], sym = c >> 4;
            pos += c & 15;
            if (pos > tbts) {
                if (noSt) $4a7bc43a0955ef89$var$err(0);
                break;
            }
            if (!c) $4a7bc43a0955ef89$var$err(2);
            if (sym < 256) buf[bt++] = sym;
            else if (sym == 256) {
                lpos = pos, lm = null;
                break;
            } else {
                var add = sym - 254;
                // no extra bits needed if less
                if (sym > 264) {
                    // index
                    var i = sym - 257, b = $4a7bc43a0955ef89$var$fleb[i];
                    add = $4a7bc43a0955ef89$var$bits(dat, pos, (1 << b) - 1) + $4a7bc43a0955ef89$var$fl[i];
                    pos += b;
                }
                // dist
                var d = dm[$4a7bc43a0955ef89$var$bits16(dat, pos) & dms], dsym = d >> 4;
                if (!d) $4a7bc43a0955ef89$var$err(3);
                pos += d & 15;
                var dt = $4a7bc43a0955ef89$var$fd[dsym];
                if (dsym > 3) {
                    var b = $4a7bc43a0955ef89$var$fdeb[dsym];
                    dt += $4a7bc43a0955ef89$var$bits16(dat, pos) & (1 << b) - 1, pos += b;
                }
                if (pos > tbts) {
                    if (noSt) $4a7bc43a0955ef89$var$err(0);
                    break;
                }
                if (resize) cbuf(bt + 131072);
                var end = bt + add;
                if (bt < dt) {
                    var shift = dl - dt, dend = Math.min(dt, end);
                    if (shift + bt < 0) $4a7bc43a0955ef89$var$err(3);
                    for(; bt < dend; ++bt)buf[bt] = dict[shift + bt];
                }
                for(; bt < end; ++bt)buf[bt] = buf[bt - dt];
            }
        }
        st.l = lm, st.p = lpos, st.b = bt, st.f = final;
        if (lm) final = 1, st.m = lbt, st.d = dm, st.n = dbt;
    }while (!final);
    // don't reallocate for streams or user buffers
    return bt != buf.length && noBuf ? $4a7bc43a0955ef89$var$slc(buf, 0, bt) : buf.subarray(0, bt);
};
// starting at p, write the minimum number of bits that can hold v to d
var $4a7bc43a0955ef89$var$wbits = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
};
// starting at p, write the minimum number of bits (>8) that can hold v to d
var $4a7bc43a0955ef89$var$wbits16 = function(d, p, v) {
    v <<= p & 7;
    var o = p / 8 | 0;
    d[o] |= v;
    d[o + 1] |= v >> 8;
    d[o + 2] |= v >> 16;
};
// creates code lengths from a frequency table
var $4a7bc43a0955ef89$var$hTree = function(d, mb) {
    // Need extra info to make a tree
    var t = [];
    for(var i = 0; i < d.length; ++i)if (d[i]) t.push({
        s: i,
        f: d[i]
    });
    var s = t.length;
    var t2 = t.slice();
    if (!s) return {
        t: $4a7bc43a0955ef89$var$et,
        l: 0
    };
    if (s == 1) {
        var v = new $4a7bc43a0955ef89$var$u8(t[0].s + 1);
        v[t[0].s] = 1;
        return {
            t: v,
            l: 1
        };
    }
    t.sort(function(a, b) {
        return a.f - b.f;
    });
    // after i2 reaches last ind, will be stopped
    // freq must be greater than largest possible number of symbols
    t.push({
        s: -1,
        f: 25001
    });
    var l = t[0], r = t[1], i0 = 0, i1 = 1, i2 = 2;
    t[0] = {
        s: -1,
        f: l.f + r.f,
        l: l,
        r: r
    };
    // efficient algorithm from UZIP.js
    // i0 is lookbehind, i2 is lookahead - after processing two low-freq
    // symbols that combined have high freq, will start processing i2 (high-freq,
    // non-composite) symbols instead
    // see https://reddit.com/r/photopea/comments/ikekht/uzipjs_questions/
    while(i1 != s - 1){
        l = t[t[i0].f < t[i2].f ? i0++ : i2++];
        r = t[i0 != i1 && t[i0].f < t[i2].f ? i0++ : i2++];
        t[i1++] = {
            s: -1,
            f: l.f + r.f,
            l: l,
            r: r
        };
    }
    var maxSym = t2[0].s;
    for(var i = 1; i < s; ++i)if (t2[i].s > maxSym) maxSym = t2[i].s;
    // code lengths
    var tr = new $4a7bc43a0955ef89$var$u16(maxSym + 1);
    // max bits in tree
    var mbt = $4a7bc43a0955ef89$var$ln(t[i1 - 1], tr, 0);
    if (mbt > mb) {
        // more algorithms from UZIP.js
        // TODO: find out how this code works (debt)
        //  ind    debt
        var i = 0, dt = 0;
        //    left            cost
        var lft = mbt - mb, cst = 1 << lft;
        t2.sort(function(a, b) {
            return tr[b.s] - tr[a.s] || a.f - b.f;
        });
        for(; i < s; ++i){
            var i2_1 = t2[i].s;
            if (tr[i2_1] > mb) {
                dt += cst - (1 << mbt - tr[i2_1]);
                tr[i2_1] = mb;
            } else break;
        }
        dt >>= lft;
        while(dt > 0){
            var i2_2 = t2[i].s;
            if (tr[i2_2] < mb) dt -= 1 << mb - tr[i2_2]++ - 1;
            else ++i;
        }
        for(; i >= 0 && dt; --i){
            var i2_3 = t2[i].s;
            if (tr[i2_3] == mb) {
                --tr[i2_3];
                ++dt;
            }
        }
        mbt = mb;
    }
    return {
        t: new $4a7bc43a0955ef89$var$u8(tr),
        l: mbt
    };
};
// get the max length and assign length codes
var $4a7bc43a0955ef89$var$ln = function(n, l, d) {
    return n.s == -1 ? Math.max($4a7bc43a0955ef89$var$ln(n.l, l, d + 1), $4a7bc43a0955ef89$var$ln(n.r, l, d + 1)) : l[n.s] = d;
};
// length codes generation
var $4a7bc43a0955ef89$var$lc = function(c) {
    var s = c.length;
    // Note that the semicolon was intentional
    while(s && !c[--s]);
    var cl = new $4a7bc43a0955ef89$var$u16(++s);
    //  ind      num         streak
    var cli = 0, cln = c[0], cls = 1;
    var w = function(v) {
        cl[cli++] = v;
    };
    for(var i = 1; i <= s; ++i)if (c[i] == cln && i != s) ++cls;
    else {
        if (!cln && cls > 2) {
            for(; cls > 138; cls -= 138)w(32754);
            if (cls > 2) {
                w(cls > 10 ? cls - 11 << 5 | 28690 : cls - 3 << 5 | 12305);
                cls = 0;
            }
        } else if (cls > 3) {
            w(cln), --cls;
            for(; cls > 6; cls -= 6)w(8304);
            if (cls > 2) w(cls - 3 << 5 | 8208), cls = 0;
        }
        while(cls--)w(cln);
        cls = 1;
        cln = c[i];
    }
    return {
        c: cl.subarray(0, cli),
        n: s
    };
};
// calculate the length of output from tree, code lengths
var $4a7bc43a0955ef89$var$clen = function(cf, cl) {
    var l = 0;
    for(var i = 0; i < cl.length; ++i)l += cf[i] * cl[i];
    return l;
};
// writes a fixed block
// returns the new bit pos
var $4a7bc43a0955ef89$var$wfblk = function(out, pos, dat) {
    // no need to write 00 as type: TypedArray defaults to 0
    var s = dat.length;
    var o = $4a7bc43a0955ef89$var$shft(pos + 2);
    out[o] = s & 255;
    out[o + 1] = s >> 8;
    out[o + 2] = out[o] ^ 255;
    out[o + 3] = out[o + 1] ^ 255;
    for(var i = 0; i < s; ++i)out[o + i + 4] = dat[i];
    return (o + 4 + s) * 8;
};
// writes a block
var $4a7bc43a0955ef89$var$wblk = function(dat, out, final, syms, lf, df, eb, li, bs, bl, p) {
    $4a7bc43a0955ef89$var$wbits(out, p++, final);
    ++lf[256];
    var _a = $4a7bc43a0955ef89$var$hTree(lf, 15), dlt = _a.t, mlb = _a.l;
    var _b = $4a7bc43a0955ef89$var$hTree(df, 15), ddt = _b.t, mdb = _b.l;
    var _c = $4a7bc43a0955ef89$var$lc(dlt), lclt = _c.c, nlc = _c.n;
    var _d = $4a7bc43a0955ef89$var$lc(ddt), lcdt = _d.c, ndc = _d.n;
    var lcfreq = new $4a7bc43a0955ef89$var$u16(19);
    for(var i = 0; i < lclt.length; ++i)++lcfreq[lclt[i] & 31];
    for(var i = 0; i < lcdt.length; ++i)++lcfreq[lcdt[i] & 31];
    var _e = $4a7bc43a0955ef89$var$hTree(lcfreq, 7), lct = _e.t, mlcb = _e.l;
    var nlcc = 19;
    for(; nlcc > 4 && !lct[$4a7bc43a0955ef89$var$clim[nlcc - 1]]; --nlcc);
    var flen = bl + 5 << 3;
    var ftlen = $4a7bc43a0955ef89$var$clen(lf, $4a7bc43a0955ef89$var$flt) + $4a7bc43a0955ef89$var$clen(df, $4a7bc43a0955ef89$var$fdt) + eb;
    var dtlen = $4a7bc43a0955ef89$var$clen(lf, dlt) + $4a7bc43a0955ef89$var$clen(df, ddt) + eb + 14 + 3 * nlcc + $4a7bc43a0955ef89$var$clen(lcfreq, lct) + 2 * lcfreq[16] + 3 * lcfreq[17] + 7 * lcfreq[18];
    if (bs >= 0 && flen <= ftlen && flen <= dtlen) return $4a7bc43a0955ef89$var$wfblk(out, p, dat.subarray(bs, bs + bl));
    var lm, ll, dm, dl;
    $4a7bc43a0955ef89$var$wbits(out, p, 1 + (dtlen < ftlen)), p += 2;
    if (dtlen < ftlen) {
        lm = $4a7bc43a0955ef89$var$hMap(dlt, mlb, 0), ll = dlt, dm = $4a7bc43a0955ef89$var$hMap(ddt, mdb, 0), dl = ddt;
        var llm = $4a7bc43a0955ef89$var$hMap(lct, mlcb, 0);
        $4a7bc43a0955ef89$var$wbits(out, p, nlc - 257);
        $4a7bc43a0955ef89$var$wbits(out, p + 5, ndc - 1);
        $4a7bc43a0955ef89$var$wbits(out, p + 10, nlcc - 4);
        p += 14;
        for(var i = 0; i < nlcc; ++i)$4a7bc43a0955ef89$var$wbits(out, p + 3 * i, lct[$4a7bc43a0955ef89$var$clim[i]]);
        p += 3 * nlcc;
        var lcts = [
            lclt,
            lcdt
        ];
        for(var it = 0; it < 2; ++it){
            var clct = lcts[it];
            for(var i = 0; i < clct.length; ++i){
                var len = clct[i] & 31;
                $4a7bc43a0955ef89$var$wbits(out, p, llm[len]), p += lct[len];
                if (len > 15) $4a7bc43a0955ef89$var$wbits(out, p, clct[i] >> 5 & 127), p += clct[i] >> 12;
            }
        }
    } else lm = $4a7bc43a0955ef89$var$flm, ll = $4a7bc43a0955ef89$var$flt, dm = $4a7bc43a0955ef89$var$fdm, dl = $4a7bc43a0955ef89$var$fdt;
    for(var i = 0; i < li; ++i){
        var sym = syms[i];
        if (sym > 255) {
            var len = sym >> 18 & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, lm[len + 257]), p += ll[len + 257];
            if (len > 7) $4a7bc43a0955ef89$var$wbits(out, p, sym >> 23 & 31), p += $4a7bc43a0955ef89$var$fleb[len];
            var dst = sym & 31;
            $4a7bc43a0955ef89$var$wbits16(out, p, dm[dst]), p += dl[dst];
            if (dst > 3) $4a7bc43a0955ef89$var$wbits16(out, p, sym >> 5 & 8191), p += $4a7bc43a0955ef89$var$fdeb[dst];
        } else $4a7bc43a0955ef89$var$wbits16(out, p, lm[sym]), p += ll[sym];
    }
    $4a7bc43a0955ef89$var$wbits16(out, p, lm[256]);
    return p + ll[256];
};
// deflate options (nice << 13) | chain
var $4a7bc43a0955ef89$var$deo = /*#__PURE__*/ new $4a7bc43a0955ef89$var$i32([
    65540,
    131080,
    131088,
    131104,
    262176,
    1048704,
    1048832,
    2114560,
    2117632
]);
// empty
var $4a7bc43a0955ef89$var$et = /*#__PURE__*/ new $4a7bc43a0955ef89$var$u8(0);
// compresses data into a raw DEFLATE buffer
var $4a7bc43a0955ef89$var$dflt = function(dat, lvl, plvl, pre, post, st) {
    var s = st.z || dat.length;
    var o = new $4a7bc43a0955ef89$var$u8(pre + s + 5 * (1 + Math.ceil(s / 7000)) + post);
    // writing to this writes to the output buffer
    var w = o.subarray(pre, o.length - post);
    var lst = st.l;
    var pos = (st.r || 0) & 7;
    if (lvl) {
        if (pos) w[0] = st.r >> 3;
        var opt = $4a7bc43a0955ef89$var$deo[lvl - 1];
        var n = opt >> 13, c = opt & 8191;
        var msk_1 = (1 << plvl) - 1;
        //    prev 2-byte val map    curr 2-byte val map
        var prev = st.p || new $4a7bc43a0955ef89$var$u16(32768), head = st.h || new $4a7bc43a0955ef89$var$u16(msk_1 + 1);
        var bs1_1 = Math.ceil(plvl / 3), bs2_1 = 2 * bs1_1;
        var hsh = function(i) {
            return (dat[i] ^ dat[i + 1] << bs1_1 ^ dat[i + 2] << bs2_1) & msk_1;
        };
        // 24576 is an arbitrary number of maximum symbols per block
        // 424 buffer for last block
        var syms = new $4a7bc43a0955ef89$var$i32(25000);
        // length/literal freq   distance freq
        var lf = new $4a7bc43a0955ef89$var$u16(288), df = new $4a7bc43a0955ef89$var$u16(32);
        //  l/lcnt  exbits  index          l/lind  waitdx          blkpos
        var lc_1 = 0, eb = 0, i = st.i || 0, li = 0, wi = st.w || 0, bs = 0;
        for(; i + 2 < s; ++i){
            // hash value
            var hv = hsh(i);
            // index mod 32768    previous index mod
            var imod = i & 32767, pimod = head[hv];
            prev[imod] = pimod;
            head[hv] = imod;
            // We always should modify head and prev, but only add symbols if
            // this data is not yet processed ("wait" for wait index)
            if (wi <= i) {
                // bytes remaining
                var rem = s - i;
                if ((lc_1 > 7000 || li > 24576) && (rem > 423 || !lst)) {
                    pos = $4a7bc43a0955ef89$var$wblk(dat, w, 0, syms, lf, df, eb, li, bs, i - bs, pos);
                    li = lc_1 = eb = 0, bs = i;
                    for(var j = 0; j < 286; ++j)lf[j] = 0;
                    for(var j = 0; j < 30; ++j)df[j] = 0;
                }
                //  len    dist   chain
                var l = 2, d = 0, ch_1 = c, dif = imod - pimod & 32767;
                if (rem > 2 && hv == hsh(i - dif)) {
                    var maxn = Math.min(n, rem) - 1;
                    var maxd = Math.min(32767, i);
                    // max possible length
                    // not capped at dif because decompressors implement "rolling" index population
                    var ml = Math.min(258, rem);
                    while(dif <= maxd && --ch_1 && imod != pimod){
                        if (dat[i + l] == dat[i + l - dif]) {
                            var nl = 0;
                            for(; nl < ml && dat[i + nl] == dat[i + nl - dif]; ++nl);
                            if (nl > l) {
                                l = nl, d = dif;
                                // break out early when we reach "nice" (we are satisfied enough)
                                if (nl > maxn) break;
                                // now, find the rarest 2-byte sequence within this
                                // length of literals and search for that instead.
                                // Much faster than just using the start
                                var mmd = Math.min(dif, nl - 2);
                                var md = 0;
                                for(var j = 0; j < mmd; ++j){
                                    var ti = i - dif + j & 32767;
                                    var pti = prev[ti];
                                    var cd = ti - pti & 32767;
                                    if (cd > md) md = cd, pimod = ti;
                                }
                            }
                        }
                        // check the previous match
                        imod = pimod, pimod = prev[imod];
                        dif += imod - pimod & 32767;
                    }
                }
                // d will be nonzero only when a match was found
                if (d) {
                    // store both dist and len data in one int32
                    // Make sure this is recognized as a len/dist with 28th bit (2^28)
                    syms[li++] = 268435456 | $4a7bc43a0955ef89$var$revfl[l] << 18 | $4a7bc43a0955ef89$var$revfd[d];
                    var lin = $4a7bc43a0955ef89$var$revfl[l] & 31, din = $4a7bc43a0955ef89$var$revfd[d] & 31;
                    eb += $4a7bc43a0955ef89$var$fleb[lin] + $4a7bc43a0955ef89$var$fdeb[din];
                    ++lf[257 + lin];
                    ++df[din];
                    wi = i + l;
                    ++lc_1;
                } else {
                    syms[li++] = dat[i];
                    ++lf[dat[i]];
                }
            }
        }
        for(i = Math.max(i, wi); i < s; ++i){
            syms[li++] = dat[i];
            ++lf[dat[i]];
        }
        pos = $4a7bc43a0955ef89$var$wblk(dat, w, lst, syms, lf, df, eb, li, bs, i - bs, pos);
        if (!lst) {
            st.r = pos & 7 | w[pos / 8 | 0] << 3;
            // shft(pos) now 1 less if pos & 7 != 0
            pos -= 7;
            st.h = head, st.p = prev, st.i = i, st.w = wi;
        }
    } else {
        for(var i = st.w || 0; i < s + lst; i += 65535){
            // end
            var e = i + 65535;
            if (e >= s) {
                // write final block
                w[pos / 8 | 0] = lst;
                e = s;
            }
            pos = $4a7bc43a0955ef89$var$wfblk(w, pos + 1, dat.subarray(i, e));
        }
        st.i = s;
    }
    return $4a7bc43a0955ef89$var$slc(o, 0, pre + $4a7bc43a0955ef89$var$shft(pos) + post);
};
// CRC32 table
var $4a7bc43a0955ef89$var$crct = /*#__PURE__*/ function() {
    var t = new Int32Array(256);
    for(var i = 0; i < 256; ++i){
        var c = i, k = 9;
        while(--k)c = (c & 1 && -306674912) ^ c >>> 1;
        t[i] = c;
    }
    return t;
}();
// CRC32
var $4a7bc43a0955ef89$var$crc = function() {
    var c = -1;
    return {
        p: function(d) {
            // closures have awful performance
            var cr = c;
            for(var i = 0; i < d.length; ++i)cr = $4a7bc43a0955ef89$var$crct[cr & 255 ^ d[i]] ^ cr >>> 8;
            c = cr;
        },
        d: function() {
            return ~c;
        }
    };
};
// Adler32
var $4a7bc43a0955ef89$var$adler = function() {
    var a = 1, b = 0;
    return {
        p: function(d) {
            // closures have awful performance
            var n = a, m = b;
            var l = d.length | 0;
            for(var i = 0; i != l;){
                var e = Math.min(i + 2655, l);
                for(; i < e; ++i)m += n += d[i];
                n = (n & 65535) + 15 * (n >> 16), m = (m & 65535) + 15 * (m >> 16);
            }
            a = n, b = m;
        },
        d: function() {
            a %= 65521, b %= 65521;
            return (a & 255) << 24 | (a & 0xFF00) << 8 | (b & 255) << 8 | b >> 8;
        }
    };
};
// deflate with opts
var $4a7bc43a0955ef89$var$dopt = function(dat, opt, pre, post, st) {
    if (!st) {
        st = {
            l: 1
        };
        if (opt.dictionary) {
            var dict = opt.dictionary.subarray(-32768);
            var newDat = new $4a7bc43a0955ef89$var$u8(dict.length + dat.length);
            newDat.set(dict);
            newDat.set(dat, dict.length);
            dat = newDat;
            st.w = dict.length;
        }
    }
    return $4a7bc43a0955ef89$var$dflt(dat, opt.level == null ? 6 : opt.level, opt.mem == null ? st.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(dat.length))) * 1.5) : 20 : 12 + opt.mem, pre, post, st);
};
// Walmart object spread
var $4a7bc43a0955ef89$var$mrg = function(a, b) {
    var o = {};
    for(var k in a)o[k] = a[k];
    for(var k in b)o[k] = b[k];
    return o;
};
// worker clone
// This is possibly the craziest part of the entire codebase, despite how simple it may seem.
// The only parameter to this function is a closure that returns an array of variables outside of the function scope.
// We're going to try to figure out the variable names used in the closure as strings because that is crucial for workerization.
// We will return an object mapping of true variable name to value (basically, the current scope as a JS object).
// The reason we can't just use the original variable names is minifiers mangling the toplevel scope.
// This took me three weeks to figure out how to do.
var $4a7bc43a0955ef89$var$wcln = function(fn, fnStr, td) {
    var dt = fn();
    var st = fn.toString();
    var ks = st.slice(st.indexOf('[') + 1, st.lastIndexOf(']')).replace(/\s+/g, '').split(',');
    for(var i = 0; i < dt.length; ++i){
        var v = dt[i], k = ks[i];
        if (typeof v == 'function') {
            fnStr += ';' + k + '=';
            var st_1 = v.toString();
            if (v.prototype) {
                // for global objects
                if (st_1.indexOf('[native code]') != -1) {
                    var spInd = st_1.indexOf(' ', 8) + 1;
                    fnStr += st_1.slice(spInd, st_1.indexOf('(', spInd));
                } else {
                    fnStr += st_1;
                    for(var t in v.prototype)fnStr += ';' + k + '.prototype.' + t + '=' + v.prototype[t].toString();
                }
            } else fnStr += st_1;
        } else td[k] = v;
    }
    return fnStr;
};
var $4a7bc43a0955ef89$var$ch = [];
// clone bufs
var $4a7bc43a0955ef89$var$cbfs = function(v) {
    var tl = [];
    for(var k in v)if (v[k].buffer) tl.push((v[k] = new v[k].constructor(v[k])).buffer);
    return tl;
};
// use a worker to execute code
var $4a7bc43a0955ef89$var$wrkr = function(fns, init, id, cb) {
    if (!$4a7bc43a0955ef89$var$ch[id]) {
        var fnStr = '', td_1 = {}, m = fns.length - 1;
        for(var i = 0; i < m; ++i)fnStr = $4a7bc43a0955ef89$var$wcln(fns[i], fnStr, td_1);
        $4a7bc43a0955ef89$var$ch[id] = {
            c: $4a7bc43a0955ef89$var$wcln(fns[m], fnStr, td_1),
            e: td_1
        };
    }
    var td = $4a7bc43a0955ef89$var$mrg({}, $4a7bc43a0955ef89$var$ch[id].e);
    return $4a7bc43a0955ef89$var$wk($4a7bc43a0955ef89$var$ch[id].c + ';onmessage=function(e){for(var k in e.data)self[k]=e.data[k];onmessage=' + init.toString() + '}', id, td, $4a7bc43a0955ef89$var$cbfs(td), cb);
};
// base async inflate fn
var $4a7bc43a0955ef89$var$bInflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$fl,
        $4a7bc43a0955ef89$var$fd,
        $4a7bc43a0955ef89$var$flrm,
        $4a7bc43a0955ef89$var$fdrm,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$ec,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$max,
        $4a7bc43a0955ef89$var$bits,
        $4a7bc43a0955ef89$var$bits16,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$err,
        $4a7bc43a0955ef89$var$inflt,
        $4a7bc43a0955ef89$export$90366d8b308ba94a,
        $4a7bc43a0955ef89$var$pbf,
        $4a7bc43a0955ef89$var$gopt
    ];
};
var $4a7bc43a0955ef89$var$bDflt = function() {
    return [
        $4a7bc43a0955ef89$var$u8,
        $4a7bc43a0955ef89$var$u16,
        $4a7bc43a0955ef89$var$i32,
        $4a7bc43a0955ef89$var$fleb,
        $4a7bc43a0955ef89$var$fdeb,
        $4a7bc43a0955ef89$var$clim,
        $4a7bc43a0955ef89$var$revfl,
        $4a7bc43a0955ef89$var$revfd,
        $4a7bc43a0955ef89$var$flm,
        $4a7bc43a0955ef89$var$flt,
        $4a7bc43a0955ef89$var$fdm,
        $4a7bc43a0955ef89$var$fdt,
        $4a7bc43a0955ef89$var$rev,
        $4a7bc43a0955ef89$var$deo,
        $4a7bc43a0955ef89$var$et,
        $4a7bc43a0955ef89$var$hMap,
        $4a7bc43a0955ef89$var$wbits,
        $4a7bc43a0955ef89$var$wbits16,
        $4a7bc43a0955ef89$var$hTree,
        $4a7bc43a0955ef89$var$ln,
        $4a7bc43a0955ef89$var$lc,
        $4a7bc43a0955ef89$var$clen,
        $4a7bc43a0955ef89$var$wfblk,
        $4a7bc43a0955ef89$var$wblk,
        $4a7bc43a0955ef89$var$shft,
        $4a7bc43a0955ef89$var$slc,
        $4a7bc43a0955ef89$var$dflt,
        $4a7bc43a0955ef89$var$dopt,
        $4a7bc43a0955ef89$export$21533ff51b8a0b4a,
        $4a7bc43a0955ef89$var$pbf
    ];
};
// gzip extra
var $4a7bc43a0955ef89$var$gze = function() {
    return [
        $4a7bc43a0955ef89$var$gzh,
        $4a7bc43a0955ef89$var$gzhl,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$crc,
        $4a7bc43a0955ef89$var$crct
    ];
};
// gunzip extra
var $4a7bc43a0955ef89$var$guze = function() {
    return [
        $4a7bc43a0955ef89$var$gzs,
        $4a7bc43a0955ef89$var$gzl
    ];
};
// zlib extra
var $4a7bc43a0955ef89$var$zle = function() {
    return [
        $4a7bc43a0955ef89$var$zlh,
        $4a7bc43a0955ef89$var$wbytes,
        $4a7bc43a0955ef89$var$adler
    ];
};
// unzlib extra
var $4a7bc43a0955ef89$var$zule = function() {
    return [
        $4a7bc43a0955ef89$var$zls
    ];
};
// post buf
var $4a7bc43a0955ef89$var$pbf = function(msg) {
    return postMessage(msg, [
        msg.buffer
    ]);
};
// get opts
var $4a7bc43a0955ef89$var$gopt = function(o) {
    return o && {
        out: o.size && new $4a7bc43a0955ef89$var$u8(o.size),
        dictionary: o.dictionary
    };
};
// async helper
var $4a7bc43a0955ef89$var$cbify = function(dat, opts, fns, init, id, cb) {
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        w.terminate();
        cb(err, dat);
    });
    w.postMessage([
        dat,
        opts
    ], opts.consume ? [
        dat.buffer
    ] : []);
    return function() {
        w.terminate();
    };
};
// auto stream
var $4a7bc43a0955ef89$var$astrm = function(strm) {
    strm.ondata = function(dat, final) {
        return postMessage([
            dat,
            final
        ], [
            dat.buffer
        ]);
    };
    return function(ev) {
        if (ev.data.length) {
            strm.push(ev.data[0], ev.data[1]);
            postMessage([
                ev.data[0].length
            ]);
        } else strm.flush();
    };
};
// async stream attach
var $4a7bc43a0955ef89$var$astrmify = function(fns, strm, opts, init, id, flush, ext) {
    var t;
    var w = $4a7bc43a0955ef89$var$wrkr(fns, init, id, function(err, dat) {
        if (err) w.terminate(), strm.ondata.call(strm, err);
        else if (!Array.isArray(dat)) ext(dat);
        else if (dat.length == 1) {
            strm.queuedSize -= dat[0];
            if (strm.ondrain) strm.ondrain(dat[0]);
        } else {
            if (dat[1]) w.terminate();
            strm.ondata.call(strm, err, dat[0], dat[1]);
        }
    });
    w.postMessage(opts);
    strm.queuedSize = 0;
    strm.push = function(d, f) {
        if (!strm.ondata) $4a7bc43a0955ef89$var$err(5);
        if (t) strm.ondata($4a7bc43a0955ef89$var$err(4, 0, 1), null, !!f);
        strm.queuedSize += d.length;
        w.postMessage([
            d,
            t = f
        ], [
            d.buffer
        ]);
    };
    strm.terminate = function() {
        w.terminate();
    };
    if (flush) strm.flush = function() {
        w.postMessage([]);
    };
};
// read 2 bytes
var $4a7bc43a0955ef89$var$b2 = function(d, b) {
    return d[b] | d[b + 1] << 8;
};
// read 4 bytes
var $4a7bc43a0955ef89$var$b4 = function(d, b) {
    return (d[b] | d[b + 1] << 8 | d[b + 2] << 16 | d[b + 3] << 24) >>> 0;
};
var $4a7bc43a0955ef89$var$b8 = function(d, b) {
    return $4a7bc43a0955ef89$var$b4(d, b) + $4a7bc43a0955ef89$var$b4(d, b + 4) * 4294967296;
};
// write bytes
var $4a7bc43a0955ef89$var$wbytes = function(d, b, v) {
    for(; v; ++b)d[b] = v, v >>>= 8;
};
// gzip header
var $4a7bc43a0955ef89$var$gzh = function(c, o) {
    var fn = o.filename;
    c[0] = 31, c[1] = 139, c[2] = 8, c[8] = o.level < 2 ? 4 : o.level == 9 ? 2 : 0, c[9] = 3; // assume Unix
    if (o.mtime != 0) $4a7bc43a0955ef89$var$wbytes(c, 4, Math.floor(new Date(o.mtime || Date.now()) / 1000));
    if (fn) {
        c[3] = 8;
        for(var i = 0; i <= fn.length; ++i)c[i + 10] = fn.charCodeAt(i);
    }
};
// gzip footer: -8 to -4 = CRC, -4 to -0 is length
// gzip start
var $4a7bc43a0955ef89$var$gzs = function(d) {
    if (d[0] != 31 || d[1] != 139 || d[2] != 8) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    var flg = d[3];
    var st = 10;
    if (flg & 4) st += (d[10] | d[11] << 8) + 2;
    for(var zs = (flg >> 3 & 1) + (flg >> 4 & 1); zs > 0; zs -= !d[st++]);
    return st + (flg & 2);
};
// gzip length
var $4a7bc43a0955ef89$var$gzl = function(d) {
    var l = d.length;
    return (d[l - 4] | d[l - 3] << 8 | d[l - 2] << 16 | d[l - 1] << 24) >>> 0;
};
// gzip header length
var $4a7bc43a0955ef89$var$gzhl = function(o) {
    return 10 + (o.filename ? o.filename.length + 1 : 0);
};
// zlib header
var $4a7bc43a0955ef89$var$zlh = function(c, o) {
    var lv = o.level, fl = lv == 0 ? 0 : lv < 6 ? 1 : lv == 9 ? 3 : 2;
    c[0] = 120, c[1] = fl << 6 | (o.dictionary && 32);
    c[1] |= 31 - (c[0] << 8 | c[1]) % 31;
    if (o.dictionary) {
        var h = $4a7bc43a0955ef89$var$adler();
        h.p(o.dictionary);
        $4a7bc43a0955ef89$var$wbytes(c, 2, h.d());
    }
};
// zlib start
var $4a7bc43a0955ef89$var$zls = function(d, dict) {
    if ((d[0] & 15) != 8 || d[0] >> 4 > 7 || (d[0] << 8 | d[1]) % 31) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
    if ((d[1] >> 5 & 1) == +!dict) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data: ' + (d[1] & 32 ? 'need' : 'unexpected') + ' dictionary');
    return (d[1] >> 3 & 4) + 2;
};
function $4a7bc43a0955ef89$var$StrmOpt(opts, cb) {
    if (typeof opts == 'function') cb = opts, opts = {};
    this.ondata = cb;
    return opts;
}
/**
 * Streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$ae157b6234afe138 = /*#__PURE__*/ function() {
    function Deflate(opts, cb) {
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        this.o = opts || {};
        this.s = {
            l: 0,
            i: 32768,
            w: 32768,
            z: 32768
        };
        // Buffer length must always be 0 mod 32768 for index calculations to be correct when modifying head and prev
        // 98304 = 32768 (lookback) + 65536 (common chunk size)
        this.b = new $4a7bc43a0955ef89$var$u8(98304);
        if (this.o.dictionary) {
            var dict = this.o.dictionary.subarray(-32768);
            this.b.set(dict, 32768 - dict.length);
            this.s.i = 32768 - dict.length;
        }
    }
    Deflate.prototype.p = function(c, f) {
        this.ondata($4a7bc43a0955ef89$var$dopt(c, this.o, 0, 0, this.s), f);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Deflate.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        var endLen = chunk.length + this.s.z;
        if (endLen > this.b.length) {
            if (endLen > 2 * this.b.length - 32768) {
                var newBuf = new $4a7bc43a0955ef89$var$u8(endLen & -32768);
                newBuf.set(this.b.subarray(0, this.s.z));
                this.b = newBuf;
            }
            var split = this.b.length - this.s.z;
            this.b.set(chunk.subarray(0, split), this.s.z);
            this.s.z = this.b.length;
            this.p(this.b, false);
            this.b.set(this.b.subarray(-32768));
            this.b.set(chunk.subarray(split), 32768);
            this.s.z = chunk.length - split + 32768;
            this.s.i = 32766, this.s.w = 32768;
        } else {
            this.b.set(chunk, this.s.z);
            this.s.z += chunk.length;
        }
        this.s.l = final & 1;
        if (this.s.z > this.s.w + 8191 || final) {
            this.p(this.b, final || false);
            this.s.w = this.s.i, this.s.i -= 2;
        }
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * deflated output for small inputs.
     */ Deflate.prototype.flush = function() {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.s.l) $4a7bc43a0955ef89$var$err(4);
        this.p(this.b, false);
        this.s.w = this.s.i, this.s.i -= 2;
    };
    return Deflate;
}();
/**
 * Asynchronous streaming DEFLATE compression
 */ var $4a7bc43a0955ef89$export$84e526fabcba03e3 = /*#__PURE__*/ function() {
    function AsyncDeflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$ae157b6234afe138(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 6, 1);
    }
    return AsyncDeflate;
}();
function $4a7bc43a0955ef89$export$2316623ecd1285ab(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$21533ff51b8a0b4a(ev.data[0], ev.data[1]));
    }, 0, cb);
}
function $4a7bc43a0955ef89$export$21533ff51b8a0b4a(data, opts) {
    return $4a7bc43a0955ef89$var$dopt(data, opts || {}, 0, 0);
}
/**
 * Streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$d1de70a877d6e43c = /*#__PURE__*/ function() {
    function Inflate(opts, cb) {
        // no StrmOpt here to avoid adding to workerizer
        if (typeof opts == 'function') cb = opts, opts = {};
        this.ondata = cb;
        var dict = opts && opts.dictionary && opts.dictionary.subarray(-32768);
        this.s = {
            i: 0,
            b: dict ? dict.length : 0
        };
        this.o = new $4a7bc43a0955ef89$var$u8(32768);
        this.p = new $4a7bc43a0955ef89$var$u8(0);
        if (dict) this.o.set(dict);
    }
    Inflate.prototype.e = function(c) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        if (!this.p.length) this.p = c;
        else if (c.length) {
            var n = new $4a7bc43a0955ef89$var$u8(this.p.length + c.length);
            n.set(this.p), n.set(c, this.p.length), this.p = n;
        }
    };
    Inflate.prototype.c = function(final) {
        this.s.i = +(this.d = final || false);
        var bts = this.s.b;
        var dt = $4a7bc43a0955ef89$var$inflt(this.p, this.s, this.o);
        this.ondata($4a7bc43a0955ef89$var$slc(dt, bts, this.s.b), this.d);
        this.o = $4a7bc43a0955ef89$var$slc(dt, this.s.b - 32768), this.s.b = this.o.length;
        this.p = $4a7bc43a0955ef89$var$slc(this.p, this.s.p / 8 | 0), this.s.p &= 7;
    };
    /**
     * Pushes a chunk to be inflated
     * @param chunk The chunk to push
     * @param final Whether this is the final chunk
     */ Inflate.prototype.push = function(chunk, final) {
        this.e(chunk), this.c(final);
    };
    return Inflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$fff8358d6dbaa9cc = /*#__PURE__*/ function() {
    function AsyncInflate(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 7, 0);
    }
    return AsyncInflate;
}();
function $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$90366d8b308ba94a(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 1, cb);
}
function $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data, {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
// before you yell at me for not just using extends, my reason is that TS inheritance is hard to workerize.
/**
 * Streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$8e4b66d280bf8342 = /*#__PURE__*/ function() {
    function Gzip(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$crc();
        this.l = 0;
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gzip.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        this.l += chunk.length;
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Gzip.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && $4a7bc43a0955ef89$var$gzhl(this.o), f && 8, this.s);
        if (this.v) $4a7bc43a0955ef89$var$gzh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 8, this.c.d()), $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.l);
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * GZIPped output for small inputs.
     */ Gzip.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Gzip;
}();
/**
 * Asynchronous streaming GZIP compression
 */ var $4a7bc43a0955ef89$export$b4c75ae96cdf708b = /*#__PURE__*/ function() {
    function AsyncGzip(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$gze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$8e4b66d280bf8342
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$8e4b66d280bf8342(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 8, 1);
    }
    return AsyncGzip;
}();
function $4a7bc43a0955ef89$export$69f0ea7cf3a331a8(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$gze,
        function() {
            return [
                $4a7bc43a0955ef89$export$3d616c3fb3e15483
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$3d616c3fb3e15483(ev.data[0], ev.data[1]));
    }, 2, cb);
}
function $4a7bc43a0955ef89$export$3d616c3fb3e15483(data, opts) {
    if (!opts) opts = {};
    var c = $4a7bc43a0955ef89$var$crc(), l = data.length;
    c.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, $4a7bc43a0955ef89$var$gzhl(opts), 8), s = d.length;
    return $4a7bc43a0955ef89$var$gzh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, s - 8, c.d()), $4a7bc43a0955ef89$var$wbytes(d, s - 4, l), d;
}
/**
 * Streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$4cb607de6db70415 = /*#__PURE__*/ function() {
    function Gunzip(opts, cb) {
        this.v = 1;
        this.r = 0;
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be GUNZIPped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Gunzip.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        this.r += chunk.length;
        if (this.v) {
            var p = this.p.subarray(this.v - 1);
            var s = p.length > 3 ? $4a7bc43a0955ef89$var$gzs(p) : 4;
            if (s > p.length) {
                if (!final) return;
            } else if (this.v > 1 && this.onmember) this.onmember(this.r - p.length);
            this.p = p.subarray(s), this.v = 0;
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
        // process concatenated GZIP
        if (this.s.f && !this.s.l && !final) {
            this.v = $4a7bc43a0955ef89$var$shft(this.s.p) + 9;
            this.s = {
                i: 0
            };
            this.o = new $4a7bc43a0955ef89$var$u8(0);
            this.push(new $4a7bc43a0955ef89$var$u8(0), final);
        }
    };
    return Gunzip;
}();
/**
 * Asynchronous streaming single or multi-member GZIP decompression
 */ var $4a7bc43a0955ef89$export$d5adcdd968132151 = /*#__PURE__*/ function() {
    function AsyncGunzip(opts, cb) {
        var _this = this;
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$guze,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$4cb607de6db70415
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4cb607de6db70415(ev.data);
            strm.onmember = function(offset) {
                return postMessage(offset);
            };
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 9, 0, function(offset) {
            return _this.onmember && _this.onmember(offset);
        });
    }
    return AsyncGunzip;
}();
function $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$guze,
        function() {
            return [
                $4a7bc43a0955ef89$export$c80456f7aaba691c
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$c80456f7aaba691c(ev.data[0], ev.data[1]));
    }, 3, cb);
}
function $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) {
    var st = $4a7bc43a0955ef89$var$gzs(data);
    if (st + 8 > data.length) $4a7bc43a0955ef89$var$err(6, 'invalid gzip data');
    return $4a7bc43a0955ef89$var$inflt(data.subarray(st, -8), {
        i: 2
    }, opts && opts.out || new $4a7bc43a0955ef89$var$u8($4a7bc43a0955ef89$var$gzl(data)), opts && opts.dictionary);
}
/**
 * Streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$4187ccf2467013b9 = /*#__PURE__*/ function() {
    function Zlib(opts, cb) {
        this.c = $4a7bc43a0955ef89$var$adler();
        this.v = 1;
        $4a7bc43a0955ef89$export$ae157b6234afe138.call(this, opts, cb);
    }
    /**
     * Pushes a chunk to be zlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Zlib.prototype.push = function(chunk, final) {
        this.c.p(chunk);
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.push.call(this, chunk, final);
    };
    Zlib.prototype.p = function(c, f) {
        var raw = $4a7bc43a0955ef89$var$dopt(c, this.o, this.v && (this.o.dictionary ? 6 : 2), f && 4, this.s);
        if (this.v) $4a7bc43a0955ef89$var$zlh(raw, this.o), this.v = 0;
        if (f) $4a7bc43a0955ef89$var$wbytes(raw, raw.length - 4, this.c.d());
        this.ondata(raw, f);
    };
    /**
     * Flushes buffered uncompressed data. Useful to immediately retrieve the
     * zlibbed output for small inputs.
     */ Zlib.prototype.flush = function() {
        $4a7bc43a0955ef89$export$ae157b6234afe138.prototype.flush.call(this);
    };
    return Zlib;
}();
/**
 * Asynchronous streaming Zlib compression
 */ var $4a7bc43a0955ef89$export$bedbe3a2c2136490 = /*#__PURE__*/ function() {
    function AsyncZlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bDflt,
            $4a7bc43a0955ef89$var$zle,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$ae157b6234afe138,
                    $4a7bc43a0955ef89$export$4187ccf2467013b9
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$4187ccf2467013b9(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 10, 1);
    }
    return AsyncZlib;
}();
function $4a7bc43a0955ef89$export$925212de7058410b(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bDflt,
        $4a7bc43a0955ef89$var$zle,
        function() {
            return [
                $4a7bc43a0955ef89$export$f87121a6d50aff25
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$f87121a6d50aff25(ev.data[0], ev.data[1]));
    }, 4, cb);
}
function $4a7bc43a0955ef89$export$f87121a6d50aff25(data, opts) {
    if (!opts) opts = {};
    var a = $4a7bc43a0955ef89$var$adler();
    a.p(data);
    var d = $4a7bc43a0955ef89$var$dopt(data, opts, opts.dictionary ? 6 : 2, 4);
    return $4a7bc43a0955ef89$var$zlh(d, opts), $4a7bc43a0955ef89$var$wbytes(d, d.length - 4, a.d()), d;
}
/**
 * Streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$af2424f875ff1b17 = /*#__PURE__*/ function() {
    function Unzlib(opts, cb) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.call(this, opts, cb);
        this.v = opts && opts.dictionary ? 2 : 1;
    }
    /**
     * Pushes a chunk to be unzlibbed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzlib.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.e.call(this, chunk);
        if (this.v) {
            if (this.p.length < 6 && !final) return;
            this.p = this.p.subarray($4a7bc43a0955ef89$var$zls(this.p, this.v - 1)), this.v = 0;
        }
        if (final) {
            if (this.p.length < 4) $4a7bc43a0955ef89$var$err(6, 'invalid zlib data');
            this.p = this.p.subarray(0, -4);
        }
        // necessary to prevent TS from using the closure value
        // This allows for workerization to function correctly
        $4a7bc43a0955ef89$export$d1de70a877d6e43c.prototype.c.call(this, final);
    };
    return Unzlib;
}();
/**
 * Asynchronous streaming Zlib decompression
 */ var $4a7bc43a0955ef89$export$cf6668790220dcad = /*#__PURE__*/ function() {
    function AsyncUnzlib(opts, cb) {
        $4a7bc43a0955ef89$var$astrmify([
            $4a7bc43a0955ef89$var$bInflt,
            $4a7bc43a0955ef89$var$zule,
            function() {
                return [
                    $4a7bc43a0955ef89$var$astrm,
                    $4a7bc43a0955ef89$export$d1de70a877d6e43c,
                    $4a7bc43a0955ef89$export$af2424f875ff1b17
                ];
            }
        ], this, $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb), function(ev) {
            var strm = new $4a7bc43a0955ef89$export$af2424f875ff1b17(ev.data);
            onmessage = $4a7bc43a0955ef89$var$astrm(strm);
        }, 11, 0);
    }
    return AsyncUnzlib;
}();
function $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return $4a7bc43a0955ef89$var$cbify(data, opts, [
        $4a7bc43a0955ef89$var$bInflt,
        $4a7bc43a0955ef89$var$zule,
        function() {
            return [
                $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6
            ];
        }
    ], function(ev) {
        return $4a7bc43a0955ef89$var$pbf($4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(ev.data[0], $4a7bc43a0955ef89$var$gopt(ev.data[1])));
    }, 5, cb);
}
function $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts) {
    return $4a7bc43a0955ef89$var$inflt(data.subarray($4a7bc43a0955ef89$var$zls(data, opts && opts.dictionary), -4), {
        i: 2
    }, opts && opts.out, opts && opts.dictionary);
}
/**
 * Streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$578fe199ef655b76 = /*#__PURE__*/ function() {
    function Decompress(opts, cb) {
        this.o = $4a7bc43a0955ef89$var$StrmOpt.call(this, opts, cb) || {};
        this.G = $4a7bc43a0955ef89$export$4cb607de6db70415;
        this.I = $4a7bc43a0955ef89$export$d1de70a877d6e43c;
        this.Z = $4a7bc43a0955ef89$export$af2424f875ff1b17;
    }
    // init substream
    // overriden by AsyncDecompress
    Decompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(dat, final) {
            _this.ondata(dat, final);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Decompress.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (!this.s) {
            if (this.p && this.p.length) {
                var n = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                n.set(this.p), n.set(chunk, this.p.length);
            } else this.p = chunk;
            if (this.p.length > 2) {
                this.s = this.p[0] == 31 && this.p[1] == 139 && this.p[2] == 8 ? new this.G(this.o) : (this.p[0] & 15) != 8 || this.p[0] >> 4 > 7 || (this.p[0] << 8 | this.p[1]) % 31 ? new this.I(this.o) : new this.Z(this.o);
                this.i();
                this.s.push(this.p, final);
                this.p = null;
            }
        } else this.s.push(chunk, final);
    };
    return Decompress;
}();
/**
 * Asynchronous streaming GZIP, Zlib, or raw DEFLATE decompression
 */ var $4a7bc43a0955ef89$export$ae2c1d81988d4b43 = /*#__PURE__*/ function() {
    function AsyncDecompress(opts, cb) {
        $4a7bc43a0955ef89$export$578fe199ef655b76.call(this, opts, cb);
        this.queuedSize = 0;
        this.G = $4a7bc43a0955ef89$export$d5adcdd968132151;
        this.I = $4a7bc43a0955ef89$export$fff8358d6dbaa9cc;
        this.Z = $4a7bc43a0955ef89$export$cf6668790220dcad;
    }
    AsyncDecompress.prototype.i = function() {
        var _this = this;
        this.s.ondata = function(err, dat, final) {
            _this.ondata(err, dat, final);
        };
        this.s.ondrain = function(size) {
            _this.queuedSize -= size;
            if (_this.ondrain) _this.ondrain(size);
        };
    };
    /**
     * Pushes a chunk to be decompressed
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncDecompress.prototype.push = function(chunk, final) {
        this.queuedSize += chunk.length;
        $4a7bc43a0955ef89$export$578fe199ef655b76.prototype.push.call(this, chunk, final);
    };
    return AsyncDecompress;
}();
function $4a7bc43a0955ef89$export$678d868aab8fb3c7(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$b6df3e950734d697(data, opts, cb) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$cae1ce83fe4a1782(data, opts, cb) : $4a7bc43a0955ef89$export$ca7cbb494e731274(data, opts, cb);
}
function $4a7bc43a0955ef89$export$c4bdbbbc9a4faabe(data, opts) {
    return data[0] == 31 && data[1] == 139 && data[2] == 8 ? $4a7bc43a0955ef89$export$c80456f7aaba691c(data, opts) : (data[0] & 15) != 8 || data[0] >> 4 > 7 || (data[0] << 8 | data[1]) % 31 ? $4a7bc43a0955ef89$export$90366d8b308ba94a(data, opts) : $4a7bc43a0955ef89$export$9ec8134f0f1b9fc6(data, opts);
}
// flatten a directory structure
var $4a7bc43a0955ef89$var$fltn = function(d, p, t, o) {
    for(var k in d){
        var val = d[k], n = p + k, op = o;
        if (Array.isArray(val)) op = $4a7bc43a0955ef89$var$mrg(o, val[1]), val = val[0];
        if (val instanceof $4a7bc43a0955ef89$var$u8) t[n] = [
            val,
            op
        ];
        else {
            t[n += '/'] = [
                new $4a7bc43a0955ef89$var$u8(0),
                op
            ];
            $4a7bc43a0955ef89$var$fltn(val, n, t, o);
        }
    }
};
// text encoder
var $4a7bc43a0955ef89$var$te = typeof TextEncoder != 'undefined' && /*#__PURE__*/ new TextEncoder();
// text decoder
var $4a7bc43a0955ef89$var$td = typeof TextDecoder != 'undefined' && /*#__PURE__*/ new TextDecoder();
// text decoder stream
var $4a7bc43a0955ef89$var$tds = 0;
try {
    $4a7bc43a0955ef89$var$td.decode($4a7bc43a0955ef89$var$et, {
        stream: true
    });
    $4a7bc43a0955ef89$var$tds = 1;
} catch (e) {}
// decode UTF8
var $4a7bc43a0955ef89$var$dutf8 = function(d) {
    for(var r = '', i = 0;;){
        var c = d[i++];
        var eb = (c > 127) + (c > 223) + (c > 239);
        if (i + eb > d.length) return {
            s: r,
            r: $4a7bc43a0955ef89$var$slc(d, i - 1)
        };
        if (!eb) r += String.fromCharCode(c);
        else if (eb == 3) c = ((c & 15) << 18 | (d[i++] & 63) << 12 | (d[i++] & 63) << 6 | d[i++] & 63) - 65536, r += String.fromCharCode(55296 | c >> 10, 56320 | c & 1023);
        else if (eb & 1) r += String.fromCharCode((c & 31) << 6 | d[i++] & 63);
        else r += String.fromCharCode((c & 15) << 12 | (d[i++] & 63) << 6 | d[i++] & 63);
    }
};
/**
 * Streaming UTF-8 decoding
 */ var $4a7bc43a0955ef89$export$ba46860a31c72e94 = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is decoded
     */ function DecodeUTF8(cb) {
        this.ondata = cb;
        if ($4a7bc43a0955ef89$var$tds) this.t = new TextDecoder();
        else this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be decoded from UTF-8 binary
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ DecodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        final = !!final;
        if (this.t) {
            this.ondata(this.t.decode(chunk, {
                stream: true
            }), final);
            if (final) {
                if (this.t.decode().length) $4a7bc43a0955ef89$var$err(8);
                this.t = null;
            }
            return;
        }
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        var dat = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
        dat.set(this.p);
        dat.set(chunk, this.p.length);
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (final) {
            if (r.length) $4a7bc43a0955ef89$var$err(8);
            this.p = null;
        } else this.p = r;
        this.ondata(s, final);
    };
    return DecodeUTF8;
}();
/**
 * Streaming UTF-8 encoding
 */ var $4a7bc43a0955ef89$export$283f13d12b1b210e = /*#__PURE__*/ function() {
    /**
     * Creates a UTF-8 decoding stream
     * @param cb The callback to call whenever data is encoded
     */ function EncodeUTF8(cb) {
        this.ondata = cb;
    }
    /**
     * Pushes a chunk to be encoded to UTF-8
     * @param chunk The string data to push
     * @param final Whether this is the last chunk
     */ EncodeUTF8.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        if (this.d) $4a7bc43a0955ef89$var$err(4);
        this.ondata($4a7bc43a0955ef89$export$366b39a6daa8ed7a(chunk), this.d = final || false);
    };
    return EncodeUTF8;
}();
function $4a7bc43a0955ef89$export$366b39a6daa8ed7a(str, latin1) {
    if (latin1) {
        var ar_1 = new $4a7bc43a0955ef89$var$u8(str.length);
        for(var i = 0; i < str.length; ++i)ar_1[i] = str.charCodeAt(i);
        return ar_1;
    }
    if ($4a7bc43a0955ef89$var$te) return $4a7bc43a0955ef89$var$te.encode(str);
    var l = str.length;
    var ar = new $4a7bc43a0955ef89$var$u8(str.length + (str.length >> 1));
    var ai = 0;
    var w = function(v) {
        ar[ai++] = v;
    };
    for(var i = 0; i < l; ++i){
        if (ai + 5 > ar.length) {
            var n = new $4a7bc43a0955ef89$var$u8(ai + 8 + (l - i << 1));
            n.set(ar);
            ar = n;
        }
        var c = str.charCodeAt(i);
        if (c < 128 || latin1) w(c);
        else if (c < 2048) w(192 | c >> 6), w(128 | c & 63);
        else if (c > 55295 && c < 57344) c = 65536 + (c & 1047552) | str.charCodeAt(++i) & 1023, w(240 | c >> 18), w(128 | c >> 12 & 63), w(128 | c >> 6 & 63), w(128 | c & 63);
        else w(224 | c >> 12), w(128 | c >> 6 & 63), w(128 | c & 63);
    }
    return $4a7bc43a0955ef89$var$slc(ar, 0, ai);
}
function $4a7bc43a0955ef89$export$adb211f8cb999894(dat, latin1) {
    if (latin1) {
        var r = '';
        for(var i = 0; i < dat.length; i += 16384)r += String.fromCharCode.apply(null, dat.subarray(i, i + 16384));
        return r;
    } else if ($4a7bc43a0955ef89$var$td) return $4a7bc43a0955ef89$var$td.decode(dat);
    else {
        var _a = $4a7bc43a0955ef89$var$dutf8(dat), s = _a.s, r = _a.r;
        if (r.length) $4a7bc43a0955ef89$var$err(8);
        return s;
    }
}
// deflate bit flag
var $4a7bc43a0955ef89$var$dbf = function(l) {
    return l == 1 ? 3 : l < 6 ? 2 : l == 9 ? 1 : 0;
};
// skip local zip header
var $4a7bc43a0955ef89$var$slzh = function(d, b) {
    return b + 30 + $4a7bc43a0955ef89$var$b2(d, b + 26) + $4a7bc43a0955ef89$var$b2(d, b + 28);
};
// read zip header
var $4a7bc43a0955ef89$var$zh = function(d, b, z) {
    var fnl = $4a7bc43a0955ef89$var$b2(d, b + 28), fn = $4a7bc43a0955ef89$export$adb211f8cb999894(d.subarray(b + 46, b + 46 + fnl), !($4a7bc43a0955ef89$var$b2(d, b + 8) & 2048)), es = b + 46 + fnl, bs = $4a7bc43a0955ef89$var$b4(d, b + 20);
    var _a = z && bs == 4294967295 ? $4a7bc43a0955ef89$var$z64e(d, es) : [
        bs,
        $4a7bc43a0955ef89$var$b4(d, b + 24),
        $4a7bc43a0955ef89$var$b4(d, b + 42)
    ], sc = _a[0], su = _a[1], off = _a[2];
    return [
        $4a7bc43a0955ef89$var$b2(d, b + 10),
        sc,
        su,
        fn,
        es + $4a7bc43a0955ef89$var$b2(d, b + 30) + $4a7bc43a0955ef89$var$b2(d, b + 32),
        off
    ];
};
// read zip64 extra field
var $4a7bc43a0955ef89$var$z64e = function(d, b) {
    for(; $4a7bc43a0955ef89$var$b2(d, b) != 1; b += 4 + $4a7bc43a0955ef89$var$b2(d, b + 2));
    return [
        $4a7bc43a0955ef89$var$b8(d, b + 12),
        $4a7bc43a0955ef89$var$b8(d, b + 4),
        $4a7bc43a0955ef89$var$b8(d, b + 20)
    ];
};
// extra field length
var $4a7bc43a0955ef89$var$exfl = function(ex) {
    var le = 0;
    if (ex) for(var k in ex){
        var l = ex[k].length;
        if (l > 65535) $4a7bc43a0955ef89$var$err(9);
        le += l + 4;
    }
    return le;
};
// write zip header
var $4a7bc43a0955ef89$var$wzh = function(d, b, f, fn, u, c, ce, co) {
    var fl = fn.length, ex = f.extra, col = co && co.length;
    var exl = $4a7bc43a0955ef89$var$exfl(ex);
    $4a7bc43a0955ef89$var$wbytes(d, b, ce != null ? 0x2014B50 : 0x4034B50), b += 4;
    if (ce != null) d[b++] = 20, d[b++] = f.os;
    d[b] = 20, b += 2; // spec compliance? what's that?
    d[b++] = f.flag << 1 | (c < 0 && 8), d[b++] = u && 8;
    d[b++] = f.compression & 255, d[b++] = f.compression >> 8;
    var dt = new Date(f.mtime == null ? Date.now() : f.mtime), y = dt.getFullYear() - 1980;
    if (y < 0 || y > 119) $4a7bc43a0955ef89$var$err(10);
    $4a7bc43a0955ef89$var$wbytes(d, b, y << 25 | dt.getMonth() + 1 << 21 | dt.getDate() << 16 | dt.getHours() << 11 | dt.getMinutes() << 5 | dt.getSeconds() >> 1), b += 4;
    if (c != -1) {
        $4a7bc43a0955ef89$var$wbytes(d, b, f.crc);
        $4a7bc43a0955ef89$var$wbytes(d, b + 4, c < 0 ? -c - 2 : c);
        $4a7bc43a0955ef89$var$wbytes(d, b + 8, f.size);
    }
    $4a7bc43a0955ef89$var$wbytes(d, b + 12, fl);
    $4a7bc43a0955ef89$var$wbytes(d, b + 14, exl), b += 16;
    if (ce != null) {
        $4a7bc43a0955ef89$var$wbytes(d, b, col);
        $4a7bc43a0955ef89$var$wbytes(d, b + 6, f.attrs);
        $4a7bc43a0955ef89$var$wbytes(d, b + 10, ce), b += 14;
    }
    d.set(fn, b);
    b += fl;
    if (exl) for(var k in ex){
        var exf = ex[k], l = exf.length;
        $4a7bc43a0955ef89$var$wbytes(d, b, +k);
        $4a7bc43a0955ef89$var$wbytes(d, b + 2, l);
        d.set(exf, b + 4), b += 4 + l;
    }
    if (col) d.set(co, b), b += col;
    return b;
};
// write zip footer (end of central directory)
var $4a7bc43a0955ef89$var$wzf = function(o, b, c, d, e) {
    $4a7bc43a0955ef89$var$wbytes(o, b, 0x6054B50); // skip disk
    $4a7bc43a0955ef89$var$wbytes(o, b + 8, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 10, c);
    $4a7bc43a0955ef89$var$wbytes(o, b + 12, d);
    $4a7bc43a0955ef89$var$wbytes(o, b + 16, e);
};
/**
 * A pass-through stream to keep data uncompressed in a ZIP archive.
 */ var $4a7bc43a0955ef89$export$2b25194e1767ea06 = /*#__PURE__*/ function() {
    /**
     * Creates a pass-through stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     */ function ZipPassThrough(filename) {
        this.filename = filename;
        this.c = $4a7bc43a0955ef89$var$crc();
        this.size = 0;
        this.compression = 0;
    }
    /**
     * Processes a chunk and pushes to the output stream. You can override this
     * method in a subclass for custom behavior, but by default this passes
     * the data through. You must call this.ondata(err, chunk, final) at some
     * point in this method.
     * @param chunk The chunk to process
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.process = function(chunk, final) {
        this.ondata(null, chunk, final);
    };
    /**
     * Pushes a chunk to be added. If you are subclassing this with a custom
     * compression algorithm, note that you must push data from the source
     * file only, pre-compression.
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipPassThrough.prototype.push = function(chunk, final) {
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        this.c.p(chunk);
        this.size += chunk.length;
        if (final) this.crc = this.c.d();
        this.process(chunk, final || false);
    };
    return ZipPassThrough;
}();
// I don't extend because TypeScript extension adds 1kB of runtime bloat
/**
 * Streaming DEFLATE compression for ZIP archives. Prefer using AsyncZipDeflate
 * for better performance
 */ var $4a7bc43a0955ef89$export$f7e481ca646388b6 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function ZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$ae157b6234afe138(opts, function(dat, final) {
            _this.ondata(null, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
    }
    ZipDeflate.prototype.process = function(chunk, final) {
        try {
            this.d.push(chunk, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ ZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return ZipDeflate;
}();
/**
 * Asynchronous streaming DEFLATE compression for ZIP archives
 */ var $4a7bc43a0955ef89$export$ffb5e59e179924b2 = /*#__PURE__*/ function() {
    /**
     * Creates an asynchronous DEFLATE stream that can be added to ZIP archives
     * @param filename The filename to associate with this data stream
     * @param opts The compression options
     */ function AsyncZipDeflate(filename, opts) {
        var _this = this;
        if (!opts) opts = {};
        $4a7bc43a0955ef89$export$2b25194e1767ea06.call(this, filename);
        this.d = new $4a7bc43a0955ef89$export$84e526fabcba03e3(opts, function(err, dat, final) {
            _this.ondata(err, dat, final);
        });
        this.compression = 8;
        this.flag = $4a7bc43a0955ef89$var$dbf(opts.level);
        this.terminate = this.d.terminate;
    }
    AsyncZipDeflate.prototype.process = function(chunk, final) {
        this.d.push(chunk, final);
    };
    /**
     * Pushes a chunk to be deflated
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ AsyncZipDeflate.prototype.push = function(chunk, final) {
        $4a7bc43a0955ef89$export$2b25194e1767ea06.prototype.push.call(this, chunk, final);
    };
    return AsyncZipDeflate;
}();
// TODO: Better tree shaking
/**
 * A zippable archive to which files can incrementally be added
 */ var $4a7bc43a0955ef89$export$9a4d4a7c32a75d2f = /*#__PURE__*/ function() {
    /**
     * Creates an empty ZIP archive to which files can be added
     * @param cb The callback to call whenever data for the generated ZIP archive
     *           is available
     */ function Zip(cb) {
        this.ondata = cb;
        this.u = [];
        this.d = 1;
    }
    /**
     * Adds a file to the ZIP archive
     * @param file The file stream to add
     */ Zip.prototype.add = function(file) {
        var _this = this;
        if (!this.ondata) $4a7bc43a0955ef89$var$err(5);
        // finishing or finished
        if (this.d & 2) this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, false);
        else {
            var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(file.filename), fl_1 = f.length;
            var com = file.comment, o = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com);
            var u = fl_1 != file.filename.length || o && com.length != o.length;
            var hl_1 = fl_1 + $4a7bc43a0955ef89$var$exfl(file.extra) + 30;
            if (fl_1 > 65535) this.ondata($4a7bc43a0955ef89$var$err(11, 0, 1), null, false);
            var header = new $4a7bc43a0955ef89$var$u8(hl_1);
            $4a7bc43a0955ef89$var$wzh(header, 0, file, f, u, -1);
            var chks_1 = [
                header
            ];
            var pAll_1 = function() {
                for(var _i = 0, chks_2 = chks_1; _i < chks_2.length; _i++){
                    var chk = chks_2[_i];
                    _this.ondata(null, chk, false);
                }
                chks_1 = [];
            };
            var tr_1 = this.d;
            this.d = 0;
            var ind_1 = this.u.length;
            var uf_1 = $4a7bc43a0955ef89$var$mrg(file, {
                f: f,
                u: u,
                o: o,
                t: function() {
                    if (file.terminate) file.terminate();
                },
                r: function() {
                    pAll_1();
                    if (tr_1) {
                        var nxt = _this.u[ind_1 + 1];
                        if (nxt) nxt.r();
                        else _this.d = 1;
                    }
                    tr_1 = 1;
                }
            });
            var cl_1 = 0;
            file.ondata = function(err, dat, final) {
                if (err) {
                    _this.ondata(err, dat, final);
                    _this.terminate();
                } else {
                    cl_1 += dat.length;
                    chks_1.push(dat);
                    if (final) {
                        var dd = new $4a7bc43a0955ef89$var$u8(16);
                        $4a7bc43a0955ef89$var$wbytes(dd, 0, 0x8074B50);
                        $4a7bc43a0955ef89$var$wbytes(dd, 4, file.crc);
                        $4a7bc43a0955ef89$var$wbytes(dd, 8, cl_1);
                        $4a7bc43a0955ef89$var$wbytes(dd, 12, file.size);
                        chks_1.push(dd);
                        uf_1.c = cl_1, uf_1.b = hl_1 + cl_1 + 16, uf_1.crc = file.crc, uf_1.size = file.size;
                        if (tr_1) uf_1.r();
                        tr_1 = 1;
                    } else if (tr_1) pAll_1();
                }
            };
            this.u.push(uf_1);
        }
    };
    /**
     * Ends the process of adding files and prepares to emit the final chunks.
     * This *must* be called after adding all desired files for the resulting
     * ZIP file to work properly.
     */ Zip.prototype.end = function() {
        var _this = this;
        if (this.d & 2) {
            this.ondata($4a7bc43a0955ef89$var$err(4 + (this.d & 1) * 8, 0, 1), null, true);
            return;
        }
        if (this.d) this.e();
        else this.u.push({
            r: function() {
                if (!(_this.d & 1)) return;
                _this.u.splice(-1, 1);
                _this.e();
            },
            t: function() {}
        });
        this.d = 3;
    };
    Zip.prototype.e = function() {
        var bt = 0, l = 0, tl = 0;
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            tl += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0);
        }
        var out = new $4a7bc43a0955ef89$var$u8(tl + 22);
        for(var _b = 0, _c = this.u; _b < _c.length; _b++){
            var f = _c[_b];
            $4a7bc43a0955ef89$var$wzh(out, bt, f, f.f, f.u, -f.c - 2, l, f.o);
            bt += 46 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra) + (f.o ? f.o.length : 0), l += f.b;
        }
        $4a7bc43a0955ef89$var$wzf(out, bt, this.u.length, tl, l);
        this.ondata(null, out, true);
        this.d = 2;
    };
    /**
     * A method to terminate any internal workers used by the stream. Subsequent
     * calls to add() will fail.
     */ Zip.prototype.terminate = function() {
        for(var _i = 0, _a = this.u; _i < _a.length; _i++){
            var f = _a[_i];
            f.t();
        }
        this.d = 2;
    };
    return Zip;
}();
function $4a7bc43a0955ef89$export$8901015135f2fb22(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var r = {};
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var k = Object.keys(r);
    var lft = k.length, o = 0, tot = 0;
    var slft = lft, files = new Array(lft);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var cbf = function() {
        var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
        tot = 0;
        for(var i = 0; i < slft; ++i){
            var f = files[i];
            try {
                var l = f.c.length;
                $4a7bc43a0955ef89$var$wzh(out, tot, f, f.f, f.u, l);
                var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
                var loc = tot + badd;
                out.set(f.c, loc);
                $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, l, tot, f.m), o += 16 + badd + (f.m ? f.m.length : 0), tot = loc + l;
            } catch (e) {
                return cbd(e, null);
            }
        }
        $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
        cbd(null, out);
    };
    if (!lft) cbf();
    var _loop_1 = function(i) {
        var fn = k[i];
        var _a = r[fn], file = _a[0], p = _a[1];
        var c = $4a7bc43a0955ef89$var$crc(), size = file.length;
        c.p(file);
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        var compression = p.level == 0 ? 0 : 8;
        var cbl = function(e, d) {
            if (e) {
                tAll();
                cbd(e, null);
            } else {
                var l = d.length;
                files[i] = $4a7bc43a0955ef89$var$mrg(p, {
                    size: size,
                    crc: c.d(),
                    c: d,
                    f: f,
                    m: m,
                    u: s != fn.length || m && com.length != ms,
                    compression: compression
                });
                o += 30 + s + exl + l;
                tot += 76 + 2 * (s + exl) + (ms || 0) + l;
                if (!--lft) cbf();
            }
        };
        if (s > 65535) cbl($4a7bc43a0955ef89$var$err(11, 0, 1), null);
        if (!compression) cbl(null, file);
        else if (size < 160000) try {
            cbl(null, $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p));
        } catch (e) {
            cbl(e, null);
        }
        else term.push($4a7bc43a0955ef89$export$2316623ecd1285ab(file, p, cbl));
    };
    // Cannot use lft because it can decrease
    for(var i = 0; i < slft; ++i)_loop_1(i);
    return tAll;
}
function $4a7bc43a0955ef89$export$eb1654f146d54eb3(data, opts) {
    if (!opts) opts = {};
    var r = {};
    var files = [];
    $4a7bc43a0955ef89$var$fltn(data, '', r, opts);
    var o = 0;
    var tot = 0;
    for(var fn in r){
        var _a = r[fn], file = _a[0], p = _a[1];
        var compression = p.level == 0 ? 0 : 8;
        var f = $4a7bc43a0955ef89$export$366b39a6daa8ed7a(fn), s = f.length;
        var com = p.comment, m = com && $4a7bc43a0955ef89$export$366b39a6daa8ed7a(com), ms = m && m.length;
        var exl = $4a7bc43a0955ef89$var$exfl(p.extra);
        if (s > 65535) $4a7bc43a0955ef89$var$err(11);
        var d = compression ? $4a7bc43a0955ef89$export$21533ff51b8a0b4a(file, p) : file, l = d.length;
        var c = $4a7bc43a0955ef89$var$crc();
        c.p(file);
        files.push($4a7bc43a0955ef89$var$mrg(p, {
            size: file.length,
            crc: c.d(),
            c: d,
            f: f,
            m: m,
            u: s != fn.length || m && com.length != ms,
            o: o,
            compression: compression
        }));
        o += 30 + s + exl + l;
        tot += 76 + 2 * (s + exl) + (ms || 0) + l;
    }
    var out = new $4a7bc43a0955ef89$var$u8(tot + 22), oe = o, cdl = tot - o;
    for(var i = 0; i < files.length; ++i){
        var f = files[i];
        $4a7bc43a0955ef89$var$wzh(out, f.o, f, f.f, f.u, f.c.length);
        var badd = 30 + f.f.length + $4a7bc43a0955ef89$var$exfl(f.extra);
        out.set(f.c, f.o + badd);
        $4a7bc43a0955ef89$var$wzh(out, o, f, f.f, f.u, f.c.length, f.o, f.m), o += 16 + badd + (f.m ? f.m.length : 0);
    }
    $4a7bc43a0955ef89$var$wzf(out, o, files.length, cdl, oe);
    return out;
}
/**
 * Streaming pass-through decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf = /*#__PURE__*/ function() {
    function UnzipPassThrough() {}
    UnzipPassThrough.prototype.push = function(data, final) {
        this.ondata(null, data, final);
    };
    UnzipPassThrough.compression = 0;
    return UnzipPassThrough;
}();
/**
 * Streaming DEFLATE decompression for ZIP archives. Prefer AsyncZipInflate for
 * better performance.
 */ var $4a7bc43a0955ef89$export$eb188945cc39e642 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function UnzipInflate() {
        var _this = this;
        this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
    }
    UnzipInflate.prototype.push = function(data, final) {
        try {
            this.i.push(data, final);
        } catch (e) {
            this.ondata(e, null, final);
        }
    };
    UnzipInflate.compression = 8;
    return UnzipInflate;
}();
/**
 * Asynchronous streaming DEFLATE decompression for ZIP archives
 */ var $4a7bc43a0955ef89$export$6235d84645dad4f9 = /*#__PURE__*/ function() {
    /**
     * Creates a DEFLATE decompression that can be used in ZIP archives
     */ function AsyncUnzipInflate(_, sz) {
        var _this = this;
        if (sz < 320000) this.i = new $4a7bc43a0955ef89$export$d1de70a877d6e43c(function(dat, final) {
            _this.ondata(null, dat, final);
        });
        else {
            this.i = new $4a7bc43a0955ef89$export$fff8358d6dbaa9cc(function(err, dat, final) {
                _this.ondata(err, dat, final);
            });
            this.terminate = this.i.terminate;
        }
    }
    AsyncUnzipInflate.prototype.push = function(data, final) {
        if (this.i.terminate) data = $4a7bc43a0955ef89$var$slc(data, 0);
        this.i.push(data, final);
    };
    AsyncUnzipInflate.compression = 8;
    return AsyncUnzipInflate;
}();
/**
 * A ZIP archive decompression stream that emits files as they are discovered
 */ var $4a7bc43a0955ef89$export$9b7485f84cbaaa56 = /*#__PURE__*/ function() {
    /**
     * Creates a ZIP decompression stream
     * @param cb The callback to call whenever a file in the ZIP archive is found
     */ function Unzip(cb) {
        this.onfile = cb;
        this.k = [];
        this.o = {
            0: $4a7bc43a0955ef89$export$93f81d5bbbb7c6bf
        };
        this.p = $4a7bc43a0955ef89$var$et;
    }
    /**
     * Pushes a chunk to be unzipped
     * @param chunk The chunk to push
     * @param final Whether this is the last chunk
     */ Unzip.prototype.push = function(chunk, final) {
        var _this = this;
        if (!this.onfile) $4a7bc43a0955ef89$var$err(5);
        if (!this.p) $4a7bc43a0955ef89$var$err(4);
        if (this.c > 0) {
            var len = Math.min(this.c, chunk.length);
            var toAdd = chunk.subarray(0, len);
            this.c -= len;
            if (this.d) this.d.push(toAdd, !this.c);
            else this.k[0].push(toAdd);
            chunk = chunk.subarray(len);
            if (chunk.length) return this.push(chunk, final);
        } else {
            var f = 0, i = 0, is = void 0, buf = void 0;
            if (!this.p.length) buf = chunk;
            else if (!chunk.length) buf = this.p;
            else {
                buf = new $4a7bc43a0955ef89$var$u8(this.p.length + chunk.length);
                buf.set(this.p), buf.set(chunk, this.p.length);
            }
            var l = buf.length, oc = this.c, add = oc && this.d;
            var _loop_2 = function() {
                var _a;
                var sig = $4a7bc43a0955ef89$var$b4(buf, i);
                if (sig == 0x4034B50) {
                    f = 1, is = i;
                    this_1.d = null;
                    this_1.c = 0;
                    var bf = $4a7bc43a0955ef89$var$b2(buf, i + 6), cmp_1 = $4a7bc43a0955ef89$var$b2(buf, i + 8), u = bf & 2048, dd = bf & 8, fnl = $4a7bc43a0955ef89$var$b2(buf, i + 26), es = $4a7bc43a0955ef89$var$b2(buf, i + 28);
                    if (l > i + 30 + fnl + es) {
                        var chks_3 = [];
                        this_1.k.unshift(chks_3);
                        f = 2;
                        var sc_1 = $4a7bc43a0955ef89$var$b4(buf, i + 18), su_1 = $4a7bc43a0955ef89$var$b4(buf, i + 22);
                        var fn_1 = $4a7bc43a0955ef89$export$adb211f8cb999894(buf.subarray(i + 30, i += 30 + fnl), !u);
                        if (sc_1 == 4294967295) _a = dd ? [
                            -2
                        ] : $4a7bc43a0955ef89$var$z64e(buf, i), sc_1 = _a[0], su_1 = _a[1];
                        else if (dd) sc_1 = -1;
                        i += es;
                        this_1.c = sc_1;
                        var d_1;
                        var file_1 = {
                            name: fn_1,
                            compression: cmp_1,
                            start: function() {
                                if (!file_1.ondata) $4a7bc43a0955ef89$var$err(5);
                                if (!sc_1) file_1.ondata(null, $4a7bc43a0955ef89$var$et, true);
                                else {
                                    var ctr = _this.o[cmp_1];
                                    if (!ctr) file_1.ondata($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + cmp_1, 1), null, false);
                                    d_1 = sc_1 < 0 ? new ctr(fn_1) : new ctr(fn_1, sc_1, su_1);
                                    d_1.ondata = function(err, dat, final) {
                                        file_1.ondata(err, dat, final);
                                    };
                                    for(var _i = 0, chks_4 = chks_3; _i < chks_4.length; _i++){
                                        var dat = chks_4[_i];
                                        d_1.push(dat, false);
                                    }
                                    if (_this.k[0] == chks_3 && _this.c) _this.d = d_1;
                                    else d_1.push($4a7bc43a0955ef89$var$et, true);
                                }
                            },
                            terminate: function() {
                                if (d_1 && d_1.terminate) d_1.terminate();
                            }
                        };
                        if (sc_1 >= 0) file_1.size = sc_1, file_1.originalSize = su_1;
                        this_1.onfile(file_1);
                    }
                    return "break";
                } else if (oc) {
                    if (sig == 0x8074B50) {
                        is = i += 12 + (oc == -2 && 8), f = 3, this_1.c = 0;
                        return "break";
                    } else if (sig == 0x2014B50) {
                        is = i -= 4, f = 3, this_1.c = 0;
                        return "break";
                    }
                }
            };
            var this_1 = this;
            for(; i < l - 4; ++i){
                var state_1 = _loop_2();
                if (state_1 === "break") break;
            }
            this.p = $4a7bc43a0955ef89$var$et;
            if (oc < 0) {
                var dat = f ? buf.subarray(0, is - 12 - (oc == -2 && 8) - ($4a7bc43a0955ef89$var$b4(buf, is - 16) == 0x8074B50 && 4)) : buf.subarray(0, i);
                if (add) add.push(dat, !!f);
                else this.k[+(f == 2)].push(dat);
            }
            if (f & 2) return this.push(buf.subarray(i), final);
            this.p = buf.subarray(i);
        }
        if (final) {
            if (this.c) $4a7bc43a0955ef89$var$err(13);
            this.p = null;
        }
    };
    /**
     * Registers a decoder with the stream, allowing for files compressed with
     * the compression type provided to be expanded correctly
     * @param decoder The decoder constructor
     */ Unzip.prototype.register = function(decoder) {
        this.o[decoder.compression] = decoder;
    };
    return Unzip;
}();
var $4a7bc43a0955ef89$var$mt = typeof queueMicrotask == 'function' ? queueMicrotask : typeof setTimeout == 'function' ? setTimeout : function(fn) {
    fn();
};
function $4a7bc43a0955ef89$export$23c8d3f8757cab88(data, opts, cb) {
    if (!cb) cb = opts, opts = {};
    if (typeof cb != 'function') $4a7bc43a0955ef89$var$err(7);
    var term = [];
    var tAll = function() {
        for(var i = 0; i < term.length; ++i)term[i]();
    };
    var files = {};
    var cbd = function(a, b) {
        $4a7bc43a0955ef89$var$mt(function() {
            cb(a, b);
        });
    };
    $4a7bc43a0955ef89$var$mt(function() {
        cbd = cb;
    });
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) {
        cbd($4a7bc43a0955ef89$var$err(13, 0, 1), null);
        return tAll;
    }
    var lft = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (lft) {
        var c = lft;
        var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
        var z = o == 4294967295 || c == 65535;
        if (z) {
            var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
            z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
            if (z) {
                c = lft = $4a7bc43a0955ef89$var$b4(data, ze + 32);
                o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
            }
        }
        var fltr = opts && opts.filter;
        var _loop_3 = function(i) {
            var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_1 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
            o = no;
            var cbl = function(e, d) {
                if (e) {
                    tAll();
                    cbd(e, null);
                } else {
                    if (d) files[fn] = d;
                    if (!--lft) cbd(null, files);
                }
            };
            if (!fltr || fltr({
                name: fn,
                size: sc,
                originalSize: su,
                compression: c_1
            })) {
                if (!c_1) cbl(null, $4a7bc43a0955ef89$var$slc(data, b, b + sc));
                else if (c_1 == 8) {
                    var infl = data.subarray(b, b + sc);
                    // Synchronously decompress under 512KB, or barely-compressed data
                    if (su < 524288 || sc > 0.8 * su) try {
                        cbl(null, $4a7bc43a0955ef89$export$90366d8b308ba94a(infl, {
                            out: new $4a7bc43a0955ef89$var$u8(su)
                        }));
                    } catch (e) {
                        cbl(e, null);
                    }
                    else term.push($4a7bc43a0955ef89$export$cae1ce83fe4a1782(infl, {
                        size: su
                    }, cbl));
                } else cbl($4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_1, 1), null);
            } else cbl(null, null);
        };
        for(var i = 0; i < c; ++i)_loop_3(i);
    } else cbd(null, {});
    return tAll;
}
function $4a7bc43a0955ef89$export$c757709326bb5901(data, opts) {
    var files = {};
    var e = data.length - 22;
    for(; $4a7bc43a0955ef89$var$b4(data, e) != 0x6054B50; --e)if (!e || data.length - e > 65558) $4a7bc43a0955ef89$var$err(13);
    var c = $4a7bc43a0955ef89$var$b2(data, e + 8);
    if (!c) return {};
    var o = $4a7bc43a0955ef89$var$b4(data, e + 16);
    var z = o == 4294967295 || c == 65535;
    if (z) {
        var ze = $4a7bc43a0955ef89$var$b4(data, e - 12);
        z = $4a7bc43a0955ef89$var$b4(data, ze) == 0x6064B50;
        if (z) {
            c = $4a7bc43a0955ef89$var$b4(data, ze + 32);
            o = $4a7bc43a0955ef89$var$b4(data, ze + 48);
        }
    }
    var fltr = opts && opts.filter;
    for(var i = 0; i < c; ++i){
        var _a = $4a7bc43a0955ef89$var$zh(data, o, z), c_2 = _a[0], sc = _a[1], su = _a[2], fn = _a[3], no = _a[4], off = _a[5], b = $4a7bc43a0955ef89$var$slzh(data, off);
        o = no;
        if (!fltr || fltr({
            name: fn,
            size: sc,
            originalSize: su,
            compression: c_2
        })) {
            if (!c_2) files[fn] = $4a7bc43a0955ef89$var$slc(data, b, b + sc);
            else if (c_2 == 8) files[fn] = $4a7bc43a0955ef89$export$90366d8b308ba94a(data.subarray(b, b + sc), {
                out: new $4a7bc43a0955ef89$var$u8(su)
            });
            else $4a7bc43a0955ef89$var$err(14, 'unknown compression type ' + c_2);
        }
    }
    return files;
}
module.exports["gzipSync"] = $4a7bc43a0955ef89$export$3d616c3fb3e15483;
module.exports["gunzipSync"] = $4a7bc43a0955ef89$export$c80456f7aaba691c;

});

parcelRegister("cwXs1", function(module, exports) {

var $6V5uh = parcelRequire("6V5uh");


var $7sea9 = parcelRequire("7sea9");


var $dmgN7 = parcelRequire("dmgN7");

function $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized) {
    if (cache.inserted[serialized.name] === undefined) return cache.insert('', serialized, cache.sheet, true);
}
function $91f696e693fdbefb$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $dmgN7.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $91f696e693fdbefb$var$createEmotion = function createEmotion(options) {
    var cache = (0, $6V5uh.default)(options); // $FlowFixMe
    cache.sheet.speedy = function(value) {
        this.isSpeedy = value;
    };
    cache.compat = true;
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered, undefined);
        (0, $dmgN7.insertStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var keyframes = function keyframes() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        var animation = "animation-" + serialized.name;
        $91f696e693fdbefb$var$insertWithoutScoping(cache, {
            name: serialized.name,
            styles: "@keyframes " + animation + "{" + serialized.styles + "}"
        });
        return animation;
    };
    var injectGlobal = function injectGlobal() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        var serialized = (0, $7sea9.serializeStyles)(args, cache.registered);
        $91f696e693fdbefb$var$insertWithoutScoping(cache, serialized);
    };
    var cx = function cx() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return $91f696e693fdbefb$var$merge(cache.registered, css, $91f696e693fdbefb$var$classnames(args));
    };
    return {
        css: css,
        cx: cx,
        injectGlobal: injectGlobal,
        keyframes: keyframes,
        hydrate: function hydrate(ids) {
            ids.forEach(function(key) {
                cache.inserted[key] = true;
            });
        },
        flush: function flush() {
            cache.registered = {};
            cache.inserted = {};
            cache.sheet.flush();
        },
        // $FlowFixMe
        sheet: cache.sheet,
        cache: cache,
        getRegisteredStyles: (0, $dmgN7.getRegisteredStyles).bind(null, cache.registered),
        merge: $91f696e693fdbefb$var$merge.bind(null, cache.registered, css)
    };
};
var $91f696e693fdbefb$var$classnames = function classnames(args) {
    var cls = '';
    for(var i = 0; i < args.length; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
var $91f696e693fdbefb$export$2e2bcd8739ae039 = $91f696e693fdbefb$var$createEmotion;
module.exports["default"] = $91f696e693fdbefb$export$2e2bcd8739ae039;

});

parcelRegister("6V5uh", function(module, exports) {

var $17TcT = parcelRequire("17TcT");


var $iJwkl = parcelRequire("iJwkl");

parcelRequire("bDkqZ");

// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $509c529e1de59914$var$delimiter = '/*|*/';
var $509c529e1de59914$var$needle = $509c529e1de59914$var$delimiter + '}';
function $509c529e1de59914$var$toSheet(block) {
    if (block) $509c529e1de59914$var$Sheet.current.insert(block + '}');
}
var $509c529e1de59914$var$Sheet = {
    current: null
};
var $509c529e1de59914$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $509c529e1de59914$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $509c529e1de59914$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $509c529e1de59914$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $509c529e1de59914$var$delimiter : '');
            }
        case -2:
            content.split($509c529e1de59914$var$needle).forEach($509c529e1de59914$var$toSheet);
    }
};
var $509c529e1de59914$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $iJwkl.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($509c529e1de59914$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $509c529e1de59914$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $17TcT.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $509c529e1de59914$export$2e2bcd8739ae039 = $509c529e1de59914$var$createCache;
module.exports["default"] = $509c529e1de59914$export$2e2bcd8739ae039;

});

parcelRegister("17TcT", function(module, exports) {
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $0d2144d6479b12ec$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $0d2144d6479b12ec$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    return tag;
}
var $0d2144d6479b12ec$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $0d2144d6479b12ec$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $0d2144d6479b12ec$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();
module.exports["StyleSheet"] = $0d2144d6479b12ec$export$9d753cd7ae895cce;

});

parcelRegister("iJwkl", function(module, exports) {
function $da358174ef16096d$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $da358174ef16096d$export$2e2bcd8739ae039 = $da358174ef16096d$var$stylis_min;
module.exports["default"] = $da358174ef16096d$export$2e2bcd8739ae039;

});

parcelRegister("bDkqZ", function(module, exports) {
var $87833012dd311f8f$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $87833012dd311f8f$export$2e2bcd8739ae039 = $87833012dd311f8f$var$weakMemoize;

});

parcelRegister("7sea9", function(module, exports) {

var $f2VtL = parcelRequire("f2VtL");


var $5LEcS = parcelRequire("5LEcS");


var $1scxZ = parcelRequire("1scxZ");

var $56d622567ec5b15a$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $56d622567ec5b15a$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $56d622567ec5b15a$var$hyphenateRegex = /[A-Z]|^ms/g;
var $56d622567ec5b15a$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $56d622567ec5b15a$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $56d622567ec5b15a$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $56d622567ec5b15a$var$processStyleName = (0, $1scxZ.default)(function(styleName) {
    return $56d622567ec5b15a$var$isCustomProperty(styleName) ? styleName : styleName.replace($56d622567ec5b15a$var$hyphenateRegex, '-$&').toLowerCase();
});
var $56d622567ec5b15a$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($56d622567ec5b15a$var$animationRegex, function(match, p1, p2) {
                $56d622567ec5b15a$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $56d622567ec5b15a$var$cursor
                };
                return p1;
            });
    }
    if ((0, $5LEcS.default)[key] !== 1 && !$56d622567ec5b15a$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $56d622567ec5b15a$var$contentValuePattern, $56d622567ec5b15a$var$contentValues, $56d622567ec5b15a$var$oldProcessStyleValue, $56d622567ec5b15a$var$msPattern, $56d622567ec5b15a$var$hyphenPattern, $56d622567ec5b15a$var$hyphenatedCache;
var $56d622567ec5b15a$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $56d622567ec5b15a$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $56d622567ec5b15a$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $56d622567ec5b15a$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $56d622567ec5b15a$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $56d622567ec5b15a$var$cursor;
                var result = interpolation(mergedProps);
                $56d622567ec5b15a$var$cursor = previousCursor;
                return $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $56d622567ec5b15a$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($56d622567ec5b15a$var$isProcessableValue(value)) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($56d622567ec5b15a$var$isProcessableValue(value[_i])) string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + $56d622567ec5b15a$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $56d622567ec5b15a$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $56d622567ec5b15a$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $56d622567ec5b15a$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $56d622567ec5b15a$var$cursor;
var $56d622567ec5b15a$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $56d622567ec5b15a$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $56d622567ec5b15a$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $56d622567ec5b15a$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $56d622567ec5b15a$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $f2VtL.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $56d622567ec5b15a$var$cursor
    };
};
module.exports["serializeStyles"] = $56d622567ec5b15a$export$6321afa313b251b5;

});

parcelRegister("f2VtL", function(module, exports) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $af43a1132694bb05$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $af43a1132694bb05$export$2e2bcd8739ae039 = $af43a1132694bb05$var$murmur2;
module.exports["default"] = $af43a1132694bb05$export$2e2bcd8739ae039;

});

parcelRegister("5LEcS", function(module, exports) {
var $433087baeb224055$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $433087baeb224055$export$2e2bcd8739ae039 = $433087baeb224055$var$unitlessKeys;
module.exports["default"] = $433087baeb224055$export$2e2bcd8739ae039;

});

parcelRegister("1scxZ", function(module, exports) {
function $10f223981f04db65$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $10f223981f04db65$export$2e2bcd8739ae039 = $10f223981f04db65$var$memoize;
module.exports["default"] = $10f223981f04db65$export$2e2bcd8739ae039;

});

parcelRegister("jq9iL", function(module, exports) {
$parcel$export(module.exports, "getFiles", () => (parcelRequire("3E6Lz")).getFiles);
$parcel$export(module.exports, "containsFiles", () => (parcelRequire("3E6Lz")).containsFiles);

var $3E6Lz = parcelRequire("3E6Lz");


});

parcelRegister("3E6Lz", function(module, exports) {
function $709b2838a61f0f18$export$ed3e218cf6ca2bc6({ source: source }) {
    return source.types.includes('Files');
}
function $709b2838a61f0f18$export$d964e69f1fd5fd4c({ source: source }) {
    return source.items// unlike other media types, for files:
    // item.kind is 'file'
    // item.type is the type of file eg 'image/jpg'
    // for other media types, item.type is the mime format
    .filter((item)=>item.kind === 'file').map((item)=>item.getAsFile()).filter((file)=>file != null);
}
module.exports["containsFiles"] = $709b2838a61f0f18$export$ed3e218cf6ca2bc6;
module.exports["getFiles"] = $709b2838a61f0f18$export$d964e69f1fd5fd4c;

});

parcelRegister("jwcwi", function(module, exports) {
/* progress-tracker.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cWhfY = parcelRequire("cWhfY");


var $f7TWP = parcelRequire("f7TWP");

const $1a8d06d25fc8b317$var$containerStyles = null;
const $1a8d06d25fc8b317$var$spacingOptions = {
    comfortable: "var(--ds-space-500, 40px)",
    cozy: "var(--ds-space-200, 16px)",
    // @deprecated left for backwards compatibility
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
/**
 * __Progress tracker__
 *
 * A progress tracker displays the steps and progress through a journey.
 *
 * - [Examples](https://atlassian.design/components/progress-tracker/examples)
 * - [Code](https://atlassian.design/components/progress-tracker/code)
 * - [Usage](https://atlassian.design/components/progress-tracker/usage)
 */ const $1a8d06d25fc8b317$var$ProgressTracker = ({ items: items = [], spacing: spacing = 'cozy', render: render = {
    link: ({ item: item })=>// Anchor content is coming from another location
        // eslint-disable-next-line @atlassian/a11y/anchor-has-content
        /*#__PURE__*/ (0, $l998X.jsx)((0, $cWhfY.default), {
            ...item
        })
}, animated: animated = true, testId: testId, label: label = 'Progress' })=>{
    const prevItems = (0, $42omo.useRef)(items.map((stage)=>({
            ...stage,
            percentageComplete: 0
        })));
    const previousStages = items.map((stage)=>{
        const oldStage = prevItems.current?.find((st)=>st.id === stage.id);
        return !!oldStage ? oldStage : stage;
    });
    (0, $42omo.useEffect)(()=>{
        prevItems.current = items;
    }, [
        items
    ]);
    const progressChanges = items.filter((stage, index)=>stage.percentageComplete !== previousStages[index].percentageComplete).length;
    const totalStepsForward = items.filter((stage, index)=>stage.percentageComplete > previousStages[index].percentageComplete).length;
    const totalStepsBack = items.filter((stage, index)=>stage.percentageComplete < previousStages[index].percentageComplete).length;
    let stepsForward = totalStepsForward;
    let stepsBack = totalStepsBack;
    const progressItems = items.map((stage, index)=>{
        let transitionSpeed = 0;
        let transitionDelay = 0;
        const transitionEasing = progressChanges > 1 ? 'linear' : 'cubic-bezier(0.15,1,0.3,1)';
        if (animated) {
            transitionSpeed = progressChanges > 1 ? 50 : 300;
            if (stage.percentageComplete < previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially in reverse.
         */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                stepsBack -= 1;
            } else if (stage.percentageComplete > previousStages[index].percentageComplete) {
                /**
         * Load each transition sequentially.
         */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                stepsForward -= 1;
            }
        }
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $f7TWP.default), {
            transitionSpeed: transitionSpeed,
            transitionDelay: transitionDelay,
            transitionEasing: transitionEasing,
            item: stage,
            render: render
        }, stage.id);
    });
    const listInlineStyles = {
        gridTemplateColumns: `repeat(${items.length}, 1fr)`,
        ['--ds--pt--sp']: $1a8d06d25fc8b317$var$spacingOptions[spacing],
        maxWidth: 80 * items.length * 2
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("ol", {
        "data-testid": testId,
        style: listInlineStyles,
        "aria-label": label,
        className: (0, $gMc0m.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _zulp6odm _1e0c11p5 _1bsb1osq _2mzuglyw _85i5ze3t _1q51ze3t _y4tize3t _bozgze3t _rxvc1jfw"
        ]),
        children: progressItems
    });
};
var $1a8d06d25fc8b317$export$2e2bcd8739ae039 = $1a8d06d25fc8b317$var$ProgressTracker;
module.exports["default"] = $1a8d06d25fc8b317$export$2e2bcd8739ae039;

});

parcelRegister("cWhfY", function(module, exports) {
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $auNCB = parcelRequire("auNCB");

const $e073ee697483df67$var$styles = {
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _11c81kw7 _2rko12b0 _syazi7uo _1e0c1ule _9oik1r31 _1bnx8stv _jf4cnqa1 _30l313af _9h8h12zz"
};
/**
 * __Progress tracker link__
 */ const $e073ee697483df67$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        xcss: $e073ee697483df67$var$styles.anchor,
        // TODO: We should not be rendering empty hrefs on anchors. This should be plain text or a button/pressable if `onClick` is provided.
        href: href || '',
        onClick: onClick,
        testId: testId,
        children: label
    });
};
var $e073ee697483df67$export$2e2bcd8739ae039 = $e073ee697483df67$var$Link;
module.exports["default"] = $e073ee697483df67$export$2e2bcd8739ae039;

});

parcelRegister("f7TWP", function(module, exports) {
/* stage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $gdv5Z = parcelRequire("gdv5Z");


var $3rSKm = parcelRequire("3rSKm");


var $kEBXJ = parcelRequire("kEBXJ");

function $711efba874fede10$var$_defineProperty(e, r, t) {
    return (r = $711efba874fede10$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $711efba874fede10$var$_toPropertyKey(t) {
    var i = $711efba874fede10$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $711efba874fede10$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $711efba874fede10$var$styles = {
    listItemContent: "_1bsb1osq _kqswh2mm"
};
const $711efba874fede10$var$textColor = {
    unvisited: "_syaz1rpy",
    current: "_syaz1oa5",
    visited: "_syazi7uo",
    disabled: "_syaz1gmx"
};
const $711efba874fede10$var$fontWeight = {
    unvisited: "_k48pi7a9",
    current: "_k48pwu06",
    visited: "_k48pwu06",
    disabled: "_k48pwu06"
};
const $711efba874fede10$var$listItemStyles = null;
const $711efba874fede10$var$fadeAnimationBase = null;
const $711efba874fede10$var$fadeIn = null;
const $711efba874fede10$var$fadeAnimationActive = null;
const $711efba874fede10$var$titleStyles = null; // eslint-disable-next-line @repo/internal/react/no-class-components
class $711efba874fede10$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentDidUpdate(prevProps) {
        if (prevProps.item.status !== this.props.item.status || prevProps.item.percentageComplete !== this.props.item.percentageComplete) this.startTransition();
    }
    componentWillUnmount() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
    }
    startTransition() {
        if (this.animationTimeoutId) clearTimeout(this.animationTimeoutId);
        this.setState({
            ...this.state,
            transitioning: true
        });
        const timeout = this.props.transitionDelay + this.props.transitionSpeed;
        this.animationTimeoutId = setTimeout(()=>{
            this.onEntered();
        }, timeout);
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && // TODO: `noLink` is unnecessary as we should just be detecting if the `href` is set...
        !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            ['--ds--pt--ts']: `${transitionSpeed}ms`,
            ['--ds--pt--td']: `${transitionDelay}ms`,
            ['--ds--pt--te']: transitionEasing
        };
        return /*#__PURE__*/ (0, $l998X.jsx)("li", {
            "data-testid": testId,
            style: listInlineStyles,
            "aria-current": ariaCurrent,
            className: (0, $gMc0m.default)([
                "_2mzuglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1i4q1hna"
            ]),
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $gdv5Z.default), {
                xcss: $711efba874fede10$var$styles.listItemContent,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $kEBXJ.default), {
                        testId: testId && `${testId}-marker`,
                        status: item.percentageComplete > 0 ? 'visited' : item.status
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        style: {
                            animationPlayState: this.state.transitioning ? 'running' : 'paused',
                            animationDuration: [
                                'visited',
                                'disabled'
                            ].includes(this.props.item.status) ? '0ms' : undefined
                        },
                        className: (0, $gMc0m.default)([
                            "_tzy4kb7n",
                            "_y44v18do _ju251oqq _1y0ctrqk"
                        ]),
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3rSKm.default), {
                            testId: testId && `${testId}-bar`,
                            percentageComplete: item.percentageComplete
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)("div", {
                        "data-testid": testId && `${testId}-title`,
                        className: (0, $gMc0m.default)([
                            "_tzy4kb7n",
                            "_11c8fhey _1pfhv47k _y3gn1h6o",
                            $711efba874fede10$var$textColor[item.status],
                            $711efba874fede10$var$fontWeight[item.status]
                        ]),
                        children: this.shouldShowLink() ? render.link({
                            item: item
                        }) : item.label
                    })
                ]
            })
        });
    }
    constructor(props){
        super(props);
        $711efba874fede10$var$_defineProperty(this, "animationTimeoutId", void 0);
        $711efba874fede10$var$_defineProperty(this, "onEntered", ()=>{
            this.setState({
                transitioning: false,
                oldPercentageComplete: this.props.item.percentageComplete
            });
        });
        this.state = {
            transitioning: false,
            oldPercentageComplete: 0
        };
    }
}
module.exports["default"] = $711efba874fede10$export$2e2bcd8739ae039;

});

parcelRegister("3rSKm", function(module, exports) {
/* bar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $99e33e8128326caf$var$spacing = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};
const $99e33e8128326caf$var$progressBarStyles = null; /**
                                 * __Progress bar__
                                 *
                                 * A progress bar describes the horizontal tracking bar that traverses each individual step.
                                 *
                                 */ 
const $99e33e8128326caf$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(--ds--pt--sp, ${$99e33e8128326caf$var$spacing.cosy}) + ${"var(--ds-space-050, 4px)"}))`
        },
        className: (0, $gMc0m.default)([
            "_v564d86a _4t3iu2gc _kqswstnw _bfhk1856 _1ein1cuf _5fbc1cuf _1e021ssb _t9ecymk3 _1lww1oqq"
        ])
    });
var $99e33e8128326caf$export$2e2bcd8739ae039 = $99e33e8128326caf$var$ProgressBar;
module.exports["default"] = $99e33e8128326caf$export$2e2bcd8739ae039;

});

parcelRegister("kEBXJ", function(module, exports) {
/* marker.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $abb2296c785e715e$var$progressMarkerStyles = null;
const $abb2296c785e715e$var$markerColor = {
    unvisited: "_bfhk1aqn",
    current: "_bfhk1856",
    visited: "_bfhk1856",
    disabled: "_bfhkby5v"
}; /**
    * __Progress marker__
    *
    * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
    */ 
const $abb2296c785e715e$var$ProgressMarker = ({ testId: testId, status: status = 'unvisited' })=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rkou2gc _v564vc7x _1bsbu2gc _4t3iu2gc _kqswstnw _1e021ssb _t9ec157a",
            $abb2296c785e715e$var$markerColor[status]
        ])
    });
var $abb2296c785e715e$export$2e2bcd8739ae039 = $abb2296c785e715e$var$ProgressMarker;
module.exports["default"] = $abb2296c785e715e$export$2e2bcd8739ae039;

});

parcelRegister("bl4QJ", function(module, exports) {
/* WatchButtonPlaceholder.js generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $8cjip = parcelRequire("8cjip");


var $eEA8O = parcelRequire("eEA8O");

const $84156adddab51810$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_701w1ul9 _1yxxv77o _w8sqv77o",
            __cmplp.className
        ])
    });
});
const $84156adddab51810$export$2d7669ced06071f = ({ compact: compact })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($84156adddab51810$export$2d5d2ba3c7c8c40b, {
        testId: "watch-button-placeholder",
        "data-test-id": "watch-button-placeholder",
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: "WatchIcon",
            spacing: "spacious"
        }),
        isDisabled: true,
        spacing: compact ? 'compact' : 'default'
    });
$84156adddab51810$export$2d7669ced06071f.propTypes = {
    compact: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
};
module.exports["WatchButtonPlaceholder"] = $84156adddab51810$export$2d7669ced06071f;

});

parcelRegister("5EoFB", function(module, exports) {
const $41d3d3266b0b22cf$export$6b0a1934b74e691a = {
    PAGE: 0,
    SPACE: 1
};
const $41d3d3266b0b22cf$export$1841061cdd9b445a = 20;
module.exports["MANAGE_WATCHER_TAB_TYPES"] = $41d3d3266b0b22cf$export$6b0a1934b74e691a;

});

parcelRegister("sD2Tz", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Gu3g = parcelRequire("1Gu3g");


var $4ri4I = parcelRequire("4ri4I");


var $6mKj3 = parcelRequire("6mKj3");


var $58PBI = parcelRequire("58PBI");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Styling div for hover area only
const $f75716c2560aeeb6$var$HoverAreaWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm _1tes1bs0 _1kt9b3bt _1cs8stnw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f75716c2560aeeb6$export$93fd4db39a89045f = ({ contentId: contentId, spaceKey: spaceKey, children: children, editSource: editSource, isEmbeddedEditor: isEmbeddedEditor })=>{
    const preloader = (0, $42omo.useContext)((0, $58PBI.EditContentButtonPreloaderContext)); // See packages/confluence-fabric-editor/src/editorPreloader.tsx
    const [doPreload, setDoPreload] = (0, $42omo.useState)(false);
    const [{ editSource: contextEditSource }, { setEditSource: setEditSource }] = (0, $4ri4I.useEditSource)();
    // Cleanup editorPreloadManager on contentId change and unmount.
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            if (doPreload) (0, $1Gu3g.EditorPreloadManager).removePreloadedId(contentId);
        };
    }, [
        doPreload,
        contentId
    ]);
    const onHover = (0, $42omo.useCallback)(async ()=>{
        if ((0, $1Gu3g.EditorPreloadManager).shouldPreload(contentId)) {
            setDoPreload(true);
            setEditSource(editSource);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        contentId,
        editSource
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, (0, $6mKj3.expValEquals)('platform_editor_collabdraft_query_improvements', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f75716c2560aeeb6$var$HoverAreaWrapper, {
        onMouseEnter: onHover
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        onMouseEnter: onHover,
        onFocus: onHover
    }, children), editSource === contextEditSource && doPreload && preloader ? preloader({
        contentId: contentId,
        spaceKey: spaceKey,
        isEmbeddedEditor: isEmbeddedEditor
    }) : null);
};
module.exports["EditContentButtonPreloader"] = $f75716c2560aeeb6$export$93fd4db39a89045f;

});

parcelRegister("1Gu3g", function(module, exports) {
/**
 * Editor Preload Manager
 *
 * A static cache for preloaded contentId's designed to prevent
 * the duplication of preload triggers on any one page during
 * a user's session
 */ class $4fc0e3bf51597bc1$export$369fde9923d909f1 {
    /**
   * Should Preload
   *
   * A mutative lookup to the cache that'll insert the contentId provided
   * if it's not already present. Returns true if the cache did not already
   * contain the provided contentId
   */ static shouldPreload(contentId) {
        if (this.cache.has(contentId)) return false;
        this.cache.add(contentId);
        return true;
    }
    /**
   * Remove Preloaded ID
   *
   * Removes a contentId from the cache, allowing it to be re-preloaded
   */ static removePreloadedId(contentId) {
        this.cache.delete(contentId);
        this.intentCache.delete(contentId);
    }
    /**
   * Clear
   *
   * Removes all cached contentId's from the cache
   */ static clear() {
        this.cache.clear();
        this.intentCache.clear();
    }
}
$4fc0e3bf51597bc1$export$369fde9923d909f1.cache = new Set();
$4fc0e3bf51597bc1$export$369fde9923d909f1.intentCache = new Set();
module.exports["EditorPreloadManager"] = $4fc0e3bf51597bc1$export$369fde9923d909f1;

});

parcelRegister("2cKGu", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $1ggpj = parcelRequire("1ggpj");

const $c721ee7829bb57f5$export$f2c6bba4d41ef211 = (contentType, contentMode)=>{
    if ((0, $9wGTI.fg)('confluence_frontend_content_wrapper')) {
        // Starring currently doesn't support unpublished drafts (which could be of contentType page or blogpost)
        if (contentMode === 'draft') return false;
        return contentType === 'page' || contentType === 'blogpost' || (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
    } else return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database' || contentType === 'embed' || contentType === 'folder';
};
module.exports["useIsStarringEnabled"] = $c721ee7829bb57f5$export$f2c6bba4d41ef211;

});

parcelRegister("4c4ke", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


var $bl4QJ = parcelRequire("bl4QJ");


const $6572a38c2b754de3$export$7a3e91558b835213 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "G6aNu",
    name: "WatchDialog",
    loader: async ()=>(await (parcelRequire("b0LO4"))).WatchDialog,
    loading: (0, $bl4QJ.WatchButtonPlaceholder)
});
module.exports["WatchDialog"] = $6572a38c2b754de3$export$7a3e91558b835213;

});

parcelRegister("b0LO4", function(module, exports) {

let $8044c72ece42a6fd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8044c72ece42a6fd$var$load("eOZfH"),
    $8044c72ece42a6fd$var$load("fZt2F"),
    $8044c72ece42a6fd$var$load("6wr18"),
    $8044c72ece42a6fd$var$load("ffEVr"),
    $8044c72ece42a6fd$var$load("7EorR"),
    $8044c72ece42a6fd$var$load("cUtrS")
]).then(()=>parcelRequire('bzo9I'));

});

parcelRegister("3dPSK", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $660080b0a61a732e$export$75ba55e1c62d2f65 = (contentType)=>{
    return (0, $1ggpj.isCanvasContentType)(contentType) || contentType === 'database';
};
module.exports["useIsWatchDialogEnabled"] = $660080b0a61a732e$export$75ba55e1c62d2f65;

});

parcelRegister("cei05", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $132077623536365b$export$c037b66df971b916 = /*#__PURE__*/ (0, $42omo.createContext)({
    inFlightRequests: new Map(),
    setInFlightRequests: ()=>{}
});
function $132077623536365b$export$1bb2b4064846aef2() {
    return (0, $42omo.useContext)($132077623536365b$export$c037b66df971b916);
}
function $132077623536365b$export$afffe3cb36bf5e6e({ children: children }) {
    const inFlightRequestsRef = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useRef(new Map());
    const setInFlightRequests = (0, $42omo.useCallback)((requestKey, value)=>{
        inFlightRequestsRef.current.set(requestKey, value);
    }, []);
    const contextValue = (0, $42omo.useMemo)(()=>({
            inFlightRequests: inFlightRequestsRef.current,
            setInFlightRequests: setInFlightRequests
        }), [
        setInFlightRequests
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($132077623536365b$export$c037b66df971b916.Provider, {
        value: contextValue,
        children: children
    });
}
module.exports["useUniversalCreateBFFContext"] = $132077623536365b$export$1bb2b4064846aef2;
module.exports["UniversalCreateBFFProvider"] = $132077623536365b$export$afffe3cb36bf5e6e;

});

parcelRegister("dG1kO", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $caUKj = parcelRequire("caUKj");

/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $67bf03c55a136376$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $67bf03c55a136376$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $caUKj.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $42omo.useMemo)(()=>{
        const sortedJsonString = $67bf03c55a136376$var$createSortedCacheKey(props);
        return `gc-${consumer}-${sortedJsonString}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $42omo.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $42omo.useCallback)(()=>{
        setValue((prev)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev.cache;
            return {
                ...prev,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey)=>cache[targetCacheKey] !== undefined;
    return {
        setCachedObject: setCachedObject,
        removeCachedObject: removeCachedObject,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        cacheKey: cacheKey,
        cachedObject: cachedObject
    };
}
module.exports["useGenericCache"] = $67bf03c55a136376$export$53a1e737d45016e2;

});


//# sourceMappingURL=CreateComponent.f16d30a6.js.map
